webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(1488)
var isDate = __webpack_require__(413)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(129)(module)))

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getYearFromUtc = exports.formatEntryDateTime = exports.formatEntryTime = exports.formatEntryDate = exports.sortByRecentMonth = exports.sortByDate = undefined;
exports.isToday = isToday;
exports.isTomorrow = isTomorrow;
exports.formatDate = formatDate;

var _momentTimezone = __webpack_require__(828);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tzLondon = 'Europe/London';

function isToday(dateStr) {
    var today = (0, _momentTimezone2.default)().tz(tzLondon);
    var date = _momentTimezone2.default.tz(dateStr, tzLondon);
    return date.isSame(today, 'day');
}

function isTomorrow(dateStr) {
    var tomorrow = (0, _momentTimezone2.default)().tz(tzLondon).add(1, 'days');
    var date = _momentTimezone2.default.tz(dateStr, tzLondon);
    return date.isSame(tomorrow, 'day');
}

var sortByDate = exports.sortByDate = function sortByDate(key) {
    var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (a, b) {
        var date1 = new Date((0, _lodash.get)(a, key));
        var date2 = new Date((0, _lodash.get)(b, key));
        var reverseCoef = reverse ? -1 : 1;
        if (date1 > date2) {
            return -1 * reverseCoef;
        }
        if (date1 < date2) {
            return 1 * reverseCoef;
        }

        return 0;
    };
};

var sortByRecentMonth = exports.sortByRecentMonth = function sortByRecentMonth(key) {
    var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (a, b) {
        var date1 = (0, _momentTimezone2.default)(a[key], 'MMMM YYYY');
        var date2 = (0, _momentTimezone2.default)(b[key], 'MMMM YYYY');
        var reverseCoef = reverse ? -1 : 1;

        if (date1 > date2) {
            return -1 * reverseCoef;
        }
        if (date1 < date2) {
            return 1 * reverseCoef;
        }

        return 0;
    };
};

function formatDate(dateStr, format) {
    return dateStr ? _momentTimezone2.default.tz(dateStr, tzLondon).format(format) : '';
}

var formatEntryDate = exports.formatEntryDate = function formatEntryDate(dateStr, format) {
    if (!dateStr) {
        return null;
    }

    if (isToday(dateStr)) {
        return 'Today';
    }

    if (isTomorrow(dateStr)) {
        return 'Tomorrow';
    }

    return formatDate(dateStr, format || 'dddd, DD MMMM YYYY');
};

var formatEntryTime = exports.formatEntryTime = function formatEntryTime(dateStr) {
    return formatDate(dateStr, 'h:mm');
};

var formatEntryDateTime = exports.formatEntryDateTime = function formatEntryDateTime(dateStr) {
    return formatEntryDate(dateStr) + ' - ' + formatEntryTime(dateStr);
};

var getYearFromUtc = exports.getYearFromUtc = function getYearFromUtc() {
    var utcStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return new Date(utcStr).getUTCFullYear();
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RpSimpleTable = exports.addIds = exports.EMPTINESS_SIGN = exports.compareFns = exports.addSortFns = exports.sortData = exports.Row = exports.Body = exports.Header = exports.ShowMore = exports.NoData = exports.Loading = undefined;

var _RpTable = __webpack_require__(2278);

var _RpTable2 = _interopRequireDefault(_RpTable);

var _RpSimpleTable = __webpack_require__(2277);

var _RpSimpleTable2 = _interopRequireDefault(_RpSimpleTable);

var _Loading = __webpack_require__(928);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoData = __webpack_require__(929);

var _NoData2 = _interopRequireDefault(_NoData);

var _ShowMore = __webpack_require__(930);

var _ShowMore2 = _interopRequireDefault(_ShowMore);

var _Header = __webpack_require__(529);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(528);

var _Body2 = _interopRequireDefault(_Body);

var _Row = __webpack_require__(530);

var _Row2 = _interopRequireDefault(_Row);

var _sortData = __webpack_require__(935);

var _sortData2 = _interopRequireDefault(_sortData);

var _compareFns = __webpack_require__(934);

var _compareFns2 = _interopRequireDefault(_compareFns);

var _addSortFns = __webpack_require__(933);

var _addSortFns2 = _interopRequireDefault(_addSortFns);

var _handleEmpty = __webpack_require__(932);

var _addIds = __webpack_require__(931);

var _addIds2 = _interopRequireDefault(_addIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Loading = _Loading2.default;
exports.NoData = _NoData2.default;
exports.ShowMore = _ShowMore2.default;
exports.Header = _Header2.default;
exports.Body = _Body2.default;
exports.Row = _Row2.default;
exports.sortData = _sortData2.default;
exports.addSortFns = _addSortFns2.default;
exports.compareFns = _compareFns2.default;
exports.EMPTINESS_SIGN = _handleEmpty.EMPTINESS_SIGN;
exports.addIds = _addIds2.default;
exports.RpSimpleTable = _RpSimpleTable2.default;
exports.default = _RpTable2.default;

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TrainerLink = exports.OwnerLink = exports.JockeyLink = exports.HorseLink = exports.CourseLink = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpReactTable = __webpack_require__(22);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _url = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon chevronIcon',
    size: 'XSmall'
});

var Link = function Link(_ref) {
    var profileType = _ref.profileType,
        name = _ref.name,
        title = _ref.title,
        shortName = _ref.shortName,
        uid = _ref.uid,
        className = _ref.className,
        children = _ref.children,
        _ref$whenEmpty = _ref.whenEmpty,
        whenEmpty = _ref$whenEmpty === undefined ? _rpReactTable.EMPTINESS_SIGN : _ref$whenEmpty;
    return uid && name ? _jsx('a', {
        className: (0, _classnames2.default)('ui-link ui-link_table js-popupLink', className),
        href: (0, _url.buildProfileUrl)(uid, name, profileType),
        title: title
    }, void 0, children || shortName || name, _ref2) : _jsx('span', {}, void 0, whenEmpty);
};

var profileTypes = ['trainer', 'owner', 'jockey', 'horse', 'course'];

/* eslint react/prop-types: 0 */
var ProfileLink = profileTypes.reduce(function (res, type) {
    return Object.assign(res, _defineProperty({}, type, function (props) {
        return _jsx(Link, {
            profileType: type,
            uid: props[type + 'Uid'],
            name: props[type + 'StyleName'],
            shortName: props[type + 'ShortName'],
            className: props.className,
            whenEmpty: props.whenEmpty,
            title: props.title
        }, void 0, props.children);
    }));
}, {});

var CourseLink = exports.CourseLink = ProfileLink.course;
var HorseLink = exports.HorseLink = ProfileLink.horse;
var JockeyLink = exports.JockeyLink = ProfileLink.jockey;
var OwnerLink = exports.OwnerLink = ProfileLink.owner;
var TrainerLink = exports.TrainerLink = ProfileLink.trainer;

exports.default = ProfileLink;

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatStake = exports.formatPrize = exports.formatMoney = exports.formatSalePrice = exports.formatPrice = undefined;

var _numeral = __webpack_require__(1962);

var _numeral2 = _interopRequireDefault(_numeral);

var _lodash = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencySymbols = {
    GBP: '£',
    EUR: '€',
    USD: '$'
};

var formatPrice = exports.formatPrice = function formatPrice(value) {
    return (0, _numeral2.default)(value).format('0,0');
};

var formatSalePrice = exports.formatSalePrice = function formatSalePrice(price, curCode) {
    if (!+price) {
        return '—';
    }

    var currency = (0, _lodash.toUpper)(curCode);
    var currencySymbol = currencySymbols[currency];
    var formattedPrice = formatPrice(price);

    return currencySymbol ? '' + currencySymbol + formattedPrice : formattedPrice + ' ' + currency;
};

var formatMoney = exports.formatMoney = function formatMoney(number) {
    return formatSalePrice(number, 'GBP');
};

var formatPrize = exports.formatPrize = function formatPrize(prize) {
    if (prize < 100) {
        return '';
    }

    var res = prize < 500 ? Math.round(prize / 100) / 10 : Math.round(prize / 1000);
    return res + 'K';
};

var formatStake = exports.formatStake = function formatStake(stake) {
    if (!(0, _lodash.isNumber)(stake)) {
        return stake;
    }
    if (stake === 0) {
        return '0.00';
    }

    return (0, _numeral2.default)(stake).format('+0.00');
};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Abbr = function Abbr(_ref) {
    var title = _ref.title,
        children = _ref.children,
        _ref$breakpoint = _ref.breakpoint,
        breakpoint = _ref$breakpoint === undefined ? 'fromNarrow' : _ref$breakpoint;
    return _jsx('abbr', {
        className: 'pp-abbr pp-abbr__' + breakpoint,
        title: title
    }, void 0, _jsx('span', {
        className: 'pp-abbr__inner'
    }, void 0, children || title.charAt(0)));
};

exports.default = Abbr;

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1246), __esModule: true };

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1209);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(104);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(585);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(585);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(1859);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAP = exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = exports.MARKER = "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var RECTANGLE = exports.RECTANGLE = "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var POLYLINE = exports.POLYLINE = "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var POLYGON = exports.POLYGON = "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var CIRCLE = exports.CIRCLE = "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var KML_LAYER = exports.KML_LAYER = "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var DIRECTIONS_RENDERER = exports.DIRECTIONS_RENDERER = "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var HEATMAP_LAYER = exports.HEATMAP_LAYER = "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var FUSION_TABLES_LAYER = exports.FUSION_TABLES_LAYER = "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var ANCHOR = exports.ANCHOR = "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var INFO_WINDOW = exports.INFO_WINDOW = "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var OVERLAY_VIEW = exports.OVERLAY_VIEW = "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var DRAWING_MANAGER = exports.DRAWING_MANAGER = "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var SEARCH_BOX = exports.SEARCH_BOX = "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var MARKER_CLUSTERER = exports.MARKER_CLUSTERER = "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var INFO_BOX = exports.INFO_BOX = "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var TRAFFIC_LAYER = exports.TRAFFIC_LAYER = "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var STREET_VIEW_PANORAMA = exports.STREET_VIEW_PANORAMA = "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selection = exports.timePeriods = exports.raceTypes = undefined;

var _raceTypes = __webpack_require__(1199);

var _raceTypes2 = _interopRequireDefault(_raceTypes);

var _timePeriods = __webpack_require__(356);

var timePeriods = _interopRequireWildcard(_timePeriods);

var _selection = __webpack_require__(131);

var selection = _interopRequireWildcard(_selection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.raceTypes = _raceTypes2.default;
exports.timePeriods = timePeriods;
exports.selection = selection;

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */



var shallowEqual = __webpack_require__(225);

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _curry2 = __webpack_require__(814);

var _curry3 = _interopRequireDefault(_curry2);

var _noop2 = __webpack_require__(822);

var _noop3 = _interopRequireDefault(_noop2);

var _forEach2 = __webpack_require__(816);

var _forEach3 = _interopRequireDefault(_forEach2);

var _bind2 = __webpack_require__(1915);

var _bind3 = _interopRequireDefault(_bind2);

var _has2 = __webpack_require__(1927);

var _has3 = _interopRequireDefault(_has2);

var _reduce2 = __webpack_require__(1946);

var _reduce3 = _interopRequireDefault(_reduce2);

var _identity2 = __webpack_require__(179);

var _identity3 = _interopRequireDefault(_identity2);

var _mapKeys2 = __webpack_require__(1939);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

exports.addDefaultPrefixToPropTypes = addDefaultPrefixToPropTypes;
exports.collectUncontrolledAndControlledProps = collectUncontrolledAndControlledProps;
exports.default = enhanceElement;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
function addDefaultPrefixToPropTypes(propTypes /*: Object*/) {
  return (0, _mapKeys3.default)(propTypes, function (value, key) {
    return "default" + key.substr(0, 1).toUpperCase() + key.substr(1);
  });
}

function removeDefaultPrefix(defaultKey) {
  // default = 7
  var key = defaultKey.substr(7);
  return "" + key.substr(0, 1).toLowerCase() + key.substr(1);
}

function collectProps(propTypes /*: Object*/, props /*: Object*/) {
  var keyTransform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity3.default;

  return (0, _reduce3.default)(propTypes, function (acc, value, key) {
    if ((0, _has3.default)(props, key)) {
      var nextKey = keyTransform(key);
      // eslint-disable-next-line no-param-reassign
      acc[nextKey] = props[key];
    }
    return acc;
  }, {});
}

function collectUncontrolledAndControlledProps(defaultUncontrolledPropTypes /*: Object*/, controlledPropTypes /*: Object*/, props /*: Object*/) {
  return (0, _extends3.default)({}, collectProps(defaultUncontrolledPropTypes, props, removeDefaultPrefix), collectProps(controlledPropTypes, props));
}

function registerGoogleEventsFromReactProps(instance /*: Object*/, props /*: Object*/, eventMap /*: Object*/) {
  var registered = (0, _reduce3.default)(eventMap, function (acc, googleEventName, onEventName) {
    if ((0, _has3.default)(props, onEventName)) {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }
    return acc;
  }, []);

  return (0, _bind3.default)(_forEach3.default, null, registered, function (event) {
    return google.maps.event.removeListener(event);
  });
}

function registerEventsFromComponent(component, getInstanceFromComponent, eventMap) {
  var instance = getInstanceFromComponent(component);
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents = registerGoogleEventsFromReactProps(instance, component.props, eventMap);
}

function unregisterEventsFromComponent(component, getInstanceFromComponent) {
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents();
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents = _noop3.default;
}

var enhanceWithPropTypes = (0, _curry3.default)(function (getInstanceFromComponent, controlledPropUpdaterMap, componentSpec) {
  var _componentSpec$compon = componentSpec.componentDidUpdate,
      _componentDidUpdate = _componentSpec$compon === undefined ? _noop3.default : _componentSpec$compon;

  return (0, _extends3.default)({}, componentSpec, {
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      var _this = this;

      (0, _forEach3.default)(controlledPropUpdaterMap, function (fn, key) {
        var nextValue = _this.props[key];
        if (nextValue !== prevProps[key]) {
          fn(getInstanceFromComponent(_this), nextValue, _this);
        }
      });
      _componentDidUpdate.call(this, prevProps, prevState);
    }
  });
});

var enhanceWithEventMap = (0, _curry3.default)(function (getInstanceFromComponent, eventMap, componentSpec) {
  var _componentSpec$compon2 = componentSpec.componentDidMount,
      _componentDidMount = _componentSpec$compon2 === undefined ? _noop3.default : _componentSpec$compon2,
      _componentSpec$compon3 = componentSpec.componentDidUpdate,
      _componentDidUpdate2 = _componentSpec$compon3 === undefined ? _noop3.default : _componentSpec$compon3,
      _componentSpec$compon4 = componentSpec.componentWillUnmount,
      _componentWillUnmount = _componentSpec$compon4 === undefined ? _noop3.default : _componentSpec$compon4;

  return (0, _extends3.default)({}, componentSpec, {

    _unregisterEvents: _noop3.default,

    componentDidMount: function componentDidMount() {
      _componentDidMount.call(this);
      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
    },
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      unregisterEventsFromComponent(this, getInstanceFromComponent);
      _componentDidUpdate2.call(this, prevProps, prevState);
      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
    },
    componentWillUnmount: function componentWillUnmount() {
      unregisterEventsFromComponent(this, getInstanceFromComponent);
      _componentWillUnmount.call(this);
    }
  });
});

var enhanceWithPublicMethod = (0, _curry3.default)(function (getInstanceFromComponent, publicMethodMap, componentSpec) {
  return (0, _reduce3.default)(publicMethodMap, function (acc, fn, publicMethodName) {
    // eslint-disable-next-line no-param-reassign
    acc[publicMethodName] = function publicMethod() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return fn(getInstanceFromComponent(this), args, /* Use with caution */this);
    };
    return acc;
  }, (0, _extends3.default)({}, componentSpec));
});

function enhanceElement(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap) {
  return (0, _flowRight3.default)(enhanceWithPublicMethod(getInstanceFromComponent, publicMethodMap), enhanceWithEventMap(getInstanceFromComponent, eventMap), enhanceWithPropTypes(getInstanceFromComponent, controlledPropUpdaterMap));
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(542);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _url = __webpack_require__(162);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var ResultLink = function ResultLink(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceDate = _ref.raceDate,
        raceInstanceUid = _ref.raceInstanceUid,
        raceInstanceTitle = _ref.raceInstanceTitle,
        children = _ref.children,
        className = _ref.className,
        urlHash = _ref.urlHash;

    var date = raceDatetime || raceDate;
    if (!courseUid || !courseName || !date || !raceInstanceUid) {
        return _jsx('span', {
            className: className
        }, void 0, '\u2014');
    }

    var urlDate = (0, _date.formatDate)(date, 'Y-MM-DD');
    var name = (0, _url.nameToUrl)(courseName);
    var hash = urlHash ? '#' + urlHash : '';
    var url = '/results/' + courseUid + '/' + name + '/' + urlDate + '/' + raceInstanceUid + hash;

    return _jsx('a', {
        className: (0, _classnames2.default)('ui-link ui-link_table js-popupLink', className),
        href: url,
        title: raceInstanceTitle
    }, void 0, children || raceInstanceTitle, _ref2);
};

ResultLink.defaultProps = {
    urlHash: ''
};

exports.default = ResultLink;

/***/ }),
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(958);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatWinDist = exports.yardsToFurlongs = undefined;
exports.distanceMap = distanceMap;
exports.mapYardGroups = mapYardGroups;

var _lodash = __webpack_require__(6);

var yardsInFurlong = 220;
var furlongsInMile = 8;
var forthPartOfYard = yardsInFurlong / 4;
var roundToLowerValue = forthPartOfYard;
var roundToGreaterValue = forthPartOfYard * 3;
var halfSymbol = '½';
var yardsLabel = 'yds';
var furlongsLabel = 'f';
var milesLabel = 'm';

var getShortForm = function getShortForm(yardsValue, furlongsValue, milesValue) {
    var result = [];
    var resultYards = null;
    var resultFurlongs = furlongsValue;
    var resultMiles = milesValue;

    if (yardsValue > roundToLowerValue && yardsValue < roundToGreaterValue) {
        resultYards = halfSymbol;
    }
    // If yards value is rounded to greater, lets add 1 unit to furlongs value
    if (yardsValue >= roundToGreaterValue) {
        resultFurlongs += 1;
    }

    // If yards value is rounded to greater, lets add 1 unit to furlongs value
    if (resultFurlongs >= furlongsInMile) {
        resultFurlongs = 0;
        resultMiles += 1;
    }

    // Don't show 0 number
    if (!resultFurlongs) {
        resultFurlongs = '';
    }

    if (resultMiles) {
        result.push(resultMiles + milesLabel);
    }
    if (resultFurlongs || resultYards) {
        result.push(resultFurlongs + resultYards + furlongsLabel);
    }

    return result;
};

var getLongForm = function getLongForm(yardsValue, furlongsValue, milesValue) {
    var result = [];
    if (milesValue) {
        result.push(milesValue + milesLabel);
    }
    if (furlongsValue) {
        result.push(furlongsValue + furlongsLabel);
    }
    if (yardsValue) {
        result.push(yardsValue + yardsLabel);
    }

    return result;
};

var yardsToFurlongs = exports.yardsToFurlongs = function yardsToFurlongs(yards, isShowInLongForm) {
    if (!isFinite(yards)) {
        return '';
    }

    var yardsValue = yards % yardsInFurlong;

    // Calculate furlongs value (with no dependant on yards rounding)
    var furlongsValue = Math.floor(yards / yardsInFurlong % furlongsInMile);

    // Calculate miles value
    var milesValue = Math.floor(yards / yardsInFurlong / furlongsInMile);

    var result = isShowInLongForm ? getLongForm(yardsValue, furlongsValue, milesValue) : getShortForm(yardsValue, furlongsValue, milesValue);

    return result.join('');
};

var furlongMap = {
    flat: [{ from: 0, to: 1211, value: '5f' }, { from: 1211, to: 1431, value: '6f' }, { from: 1431, to: 1651, value: '7f' }, { from: 1651, to: 2091, value: '1m-1m1f' }, { from: 2091, to: 2531, value: '1m2f-1m3f' }, { from: 2531, to: 2971, value: '1m4f-1m5f' }, { from: 2971, to: 3411, value: '1m6f-1m7f' }, { from: 3411, to: Infinity, value: '2m-plus' }],
    jumps: [{ from: 0, to: 3851, value: '2m-2m1f' }, { from: 3851, to: 4291, value: '2m1½f-2m3f' }, { from: 4291, to: 4951, value: '2m3½f-2m6f' }, { from: 4951, to: 5831, value: '2m7f-3m2½f' }, { from: 5831, to: Infinity, value: '3m3f-plus' }]
};

function distanceMap(yard, raceType) {
    var matchedRange = furlongMap[raceType].find(function (range) {
        return (0, _lodash.isNaN)(yard) ? null : (0, _lodash.inRange)(yard, range.from, range.to);
    });

    return matchedRange && matchedRange.value;
}

function mapYardGroups(yardsRange, raceType) {
    return (0, _lodash.uniq)(yardsRange.split('-').map(function (yardStr) {
        return parseInt(yardStr, 10);
    }).map(function (yard) {
        return distanceMap(yard, raceType);
    }).filter(function (distance) {
        return distance;
    })).join('-');
}

var formatWinDist = exports.formatWinDist = function formatWinDist(raceOutcomeCode, winningDistance, distanceToWinner) {
    if (!winningDistance && !distanceToWinner) {
        return null;
    }

    return +raceOutcomeCode === 1 ? 'by ' + winningDistance + ', ' : 'btn ' + distanceToWinner + ', ';
};

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selection = undefined;

var _Filter = __webpack_require__(985);

var _Filter2 = _interopRequireDefault(_Filter);

var _selection = __webpack_require__(547);

var _selection2 = _interopRequireDefault(_selection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.selection = _selection2.default;
exports.default = _Filter2.default;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Definition = function Definition(_ref) {
    var term = _ref.term,
        description = _ref.description,
        children = _ref.children,
        className = _ref.className;
    return description || children ? _jsx('div', {
        className: (0, _classnames2.default)('pp-definition', className)
    }, void 0, term && _jsx('dt', {
        className: 'pp-definition__term'
    }, void 0, term, ':'), _jsx('dd', {
        className: 'pp-definition__description'
    }, void 0, children || description)) : null;
};

exports.default = Definition;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FilteringComponent = __webpack_require__(1179);

var _FilteringComponent2 = _interopRequireDefault(_FilteringComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FilteringComponent2.default;

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasValue = exports.getValues = exports.getValue = exports.getValueWithSuffix = exports.getCaptions = exports.getCaption = exports.getOptions = exports.getOption = exports.setSelected = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(6);

var _timePeriods = __webpack_require__(356);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setFirstAsSelected = function setFirstAsSelected(arr) {
    return arr.map(function (item, index) {
        return index ? item : _extends({}, item, { selected: true });
    });
};

var setSelected = exports.setSelected = function setSelected(arr, value) {
    var mappedArray = arr.map(function (item) {
        return item.value === value ? _extends({}, item, { selected: true }) : item;
    });

    return mappedArray.find(function (option) {
        return option.selected;
    }) ? mappedArray : setFirstAsSelected(mappedArray);
};

var getOption = exports.getOption = function getOption(categories, categoryName) {
    return categories[categoryName].options.find(function (item) {
        return item.selected;
    });
};

var getOptions = exports.getOptions = function getOptions(categories) {
    return (0, _lodash.keys)(categories).reduce(function (result, key) {
        return _extends({}, result, _defineProperty({}, key, getOption(categories, key)));
    }, {});
};

var getCaption = exports.getCaption = function getCaption() {
    return getOption.apply(undefined, arguments).label;
};

var getCaptions = exports.getCaptions = function getCaptions(categories) {
    var selectedOptions = getOptions(categories);
    return (0, _lodash.keys)(categories).reduce(function (result, key) {
        return _extends({}, result, _defineProperty({}, key, selectedOptions[key].label));
    }, {});
};

var getValueWithSuffix = exports.getValueWithSuffix = function getValueWithSuffix() {
    return getOption.apply(undefined, arguments).value;
};

var getValue = exports.getValue = function getValue() {
    return (0, _timePeriods.removeExtra)(getOption.apply(undefined, arguments).value);
};

var getValues = exports.getValues = function getValues(categories) {
    var selectedOptions = getOptions(categories);
    return (0, _lodash.keys)(categories).reduce(function (result, key) {
        return _extends({}, result, _defineProperty({}, key, (0, _timePeriods.removeExtra)(selectedOptions[key].value)));
    }, {});
};

var hasValue = exports.hasValue = function hasValue(categories, value) {
    return categories.options.some(function (option) {
        return value === option.value;
    });
};

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfISOWeek = __webpack_require__(147)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(284)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var fixMobileSafariWhiteScreenBug = function fixMobileSafariWhiteScreenBug() {
    if (!document || !document.getElementsByTagName) return;

    var body = document.getElementsByTagName('body');
    if (body && body[0]) {
        body[0].style.display = 'none';
        /* eslint-disable no-unused-expressions */
        body[0].offsetHeight; // no need to store this anywhere, the reference is enough
        /* eslint-enable no-unused-expressions */
        body[0].style.display = '';
    }
};

exports.default = fixMobileSafariWhiteScreenBug;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildProfileUrl = exports.nameToBannerUrl = exports.nameToUrl = undefined;

var _lodash = __webpack_require__(6);

var nameToUrl = exports.nameToUrl = function nameToUrl(name) {
    return (0, _lodash.toLower)(name).replace(/[^\w\d\s-]/g, '').replace(/\s+/g, '-');
};

var nameToBannerUrl = exports.nameToBannerUrl = function nameToBannerUrl(name) {
    return (0, _lodash.toLower)(name).replace(/\.|\s|'/g, '');
};

var buildProfileUrl = exports.buildProfileUrl = function buildProfileUrl(id, name, type) {
    return '/profile/' + type + '/' + id + '/' + nameToUrl(name);
};

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getRaceInfoKey = function getRaceInfoKey(_ref) {
    var bookmaker = _ref.bookmaker,
        raceTime = _ref.raceTime,
        raceDate = _ref.raceDate,
        courseName = _ref.courseName;

    if (!(raceTime && raceDate && courseName && bookmaker)) {
        // eslint-disable-next-line no-console
        console.error('no required info data in: getRaceInfoKey');
    }
    return (raceDate + '/' + raceTime + '/' + courseName + '/' + bookmaker).toUpperCase();
};

var PricesStateStore = function () {
    function PricesStateStore() {
        _classCallCheck(this, PricesStateStore);

        this.showDecimalPrices = false;
        this.raceInfo = {};
        this.currentBookmakerName = null;
    }

    _createClass(PricesStateStore, [{
        key: 'setPriceViewType',
        value: function setPriceViewType(_ref2) {
            var showDecimal = _ref2.showDecimal;

            this.showDecimalPrices = showDecimal;
        }
    }, {
        key: 'isDecimalPrice',
        value: function isDecimalPrice() {
            return this.showDecimalPrices;
        }
    }, {
        key: 'setCurrentBookmaker',
        value: function setCurrentBookmaker(bookmakerName) {
            this.currentBookmakerName = bookmakerName;
        }
    }, {
        key: 'getCurrentBookmaker',
        value: function getCurrentBookmaker() {
            return this.currentBookmakerName;
        }
    }, {
        key: 'updateRaceInfo',
        value: function updateRaceInfo(_ref3) {
            var bookmaker = _ref3.bookmaker,
                raceTime = _ref3.raceTime,
                raceDate = _ref3.raceDate,
                courseName = _ref3.courseName,
                suspendState = _ref3.suspendState,
                winOdds = _ref3.winOdds,
                placeWinner = _ref3.placeWinner,
                isBog = _ref3.isBog;

            var statusKey = getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName });

            this.raceInfo[statusKey] = { suspendState: suspendState, winOdds: winOdds, placeWinner: placeWinner, isBog: isBog };
        }
    }, {
        key: 'getRaceInfo',
        value: function getRaceInfo(_ref4) {
            var bookmaker = _ref4.bookmaker,
                raceTime = _ref4.raceTime,
                raceDate = _ref4.raceDate,
                courseName = _ref4.courseName;

            return this.raceInfo[getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName })];
        }
    }]);

    return PricesStateStore;
}();
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */


var pricesStateStore = exports.pricesStateStore = new PricesStateStore();

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.diffusionServiceUtils = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _PricesStateStore = __webpack_require__(190);

var _DIFFUSION = __webpack_require__(330);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _DiffusionFeedHelper = __webpack_require__(2265);

var _DiffusionFeedHelper2 = _interopRequireDefault(_DiffusionFeedHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTopicRaceType() {
    return 'HORSES';
}

function getTopicInfoType() {
    return '#INFO';
}

function getTopicMarketType(type) {
    return type || 'WIN';
}

function getElementDataAttribute(attribute, element) {
    return (0, _jquery2.default)(element).closest('[' + attribute + ']').attr(attribute);
}

function getTopicRaceDate(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, element);
}

function getTopicCourseName(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, element);
}

function getTopicRaceTime(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, element);
}

function getTopicHorseName(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, element);
}

function getTopicBookmaker(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER, element);
}

function getElementDiffusionData(element) {
    return {
        horseName: getTopicHorseName(element),
        courseName: getTopicCourseName(element),
        raceTime: getTopicRaceTime(element),
        raceDate: getTopicRaceDate(element)
    };
}

function createInfoTopic(_ref) {
    var raceDate = _ref.raceDate,
        courseName = _ref.courseName,
        raceTime = _ref.raceTime,
        bookmaker = _ref.bookmaker;

    if (!raceDate || !courseName || !raceTime || !bookmaker) {
        // eslint-disable-next-line no-console
        console.error('info topic not created', raceDate, courseName, raceTime, bookmaker);
        return null;
    }

    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), getTopicInfoType(), _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];

    return topicArray.join('/');
}

function createPriceTopic(_ref2) {
    var raceDate = _ref2.raceDate,
        courseName = _ref2.courseName,
        raceTime = _ref2.raceTime,
        horseName = _ref2.horseName,
        bookmaker = _ref2.bookmaker;

    if (!raceDate || !courseName || !raceTime || !horseName || !bookmaker) {
        // eslint-disable-next-line no-console
        console.error('price topic not created', raceDate, courseName, raceTime, horseName, bookmaker);
        return null;
    }

    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), horseName, _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];

    return topicArray.join('/');
}

function parseDiffusionTopic(topic) {
    var topicArray = topic.split('/');
    return {
        raceType: topicArray[0],
        raceDate: topicArray[1],
        courseName: topicArray[2],
        raceTime: topicArray[3],
        marketType: topicArray[4],
        infoType: topicArray[5],
        bookmaker: topicArray[6]
    };
}

function parseInfoTopicData(WebClientMessage) {
    var _WebClientMessage$get = WebClientMessage.getFields(0),
        _WebClientMessage$get2 = _slicedToArray(_WebClientMessage$get, 4),
        eachwayTerms = _WebClientMessage$get2[0],
        isBog = _WebClientMessage$get2[1],
        suspendState = _WebClientMessage$get2[2],
        orderBy = _WebClientMessage$get2[3];

    var isWinOnly = eachwayTerms === '1/1|1-1';

    var _eachwayTerms$split = eachwayTerms.split('|'),
        _eachwayTerms$split2 = _slicedToArray(_eachwayTerms$split, 2),
        winOdds = _eachwayTerms$split2[0],
        placeWinner = _eachwayTerms$split2[1];

    var topic = WebClientMessage.getTopic();

    var _parseDiffusionTopic = parseDiffusionTopic(topic),
        bookmaker = _parseDiffusionTopic.bookmaker,
        courseName = _parseDiffusionTopic.courseName,
        raceDate = _parseDiffusionTopic.raceDate,
        raceTime = _parseDiffusionTopic.raceTime;

    return {
        raceDate: raceDate,
        courseName: courseName,
        raceTime: raceTime,
        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
        winOdds: winOdds,
        placeWinner: placeWinner,
        isWinOnly: isWinOnly,
        isBog: isBog,
        suspendState: suspendState,
        orderBy: orderBy
    };
}

function parsePriceTopicData(WebClientMessage) {
    var dataFields = WebClientMessage.getFields(0);
    var topic = WebClientMessage.getTopic();

    var _parseDiffusionTopic2 = parseDiffusionTopic(topic),
        horseName = _parseDiffusionTopic2.infoType,
        bookmaker = _parseDiffusionTopic2.bookmaker,
        courseName = _parseDiffusionTopic2.courseName,
        raceDate = _parseDiffusionTopic2.raceDate,
        raceTime = _parseDiffusionTopic2.raceTime;

    var historyPrices = {
        fractional: dataFields.slice(9, 14),
        decimal: dataFields.slice(14, 19)
    };

    return {
        horseName: horseName,
        raceDate: raceDate,
        courseName: courseName,
        raceTime: raceTime,
        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
        historyPrices: historyPrices,
        outcomersId: dataFields[1],
        eventId: dataFields[4],
        meetingId: dataFields[5],
        status: dataFields[6],
        fractionalPrice: dataFields[7],
        decimalPrice: dataFields[8],
        historyPrice: dataFields[14]
    };
}

function getDisplayedPriceValue(renderConfig) {
    var result = void 0;
    var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
    var raceSuspendState = raceInfo && raceInfo.suspendState;
    var isHorseSuspended = [renderConfig.status, raceSuspendState].includes('H');

    if (isHorseSuspended) {
        return '-';
    }
    if (!renderConfig.decimalPrice && !renderConfig.fractionalPrice) {
        return '';
    }
    if (!renderConfig.decimalPrice) {
        return 'SP';
    }
    if (_PricesStateStore.pricesStateStore.isDecimalPrice()) {
        result = Math.floor(parseFloat(renderConfig.decimalPrice) * 100) / 100;
    } else {
        result = renderConfig.fractionalPrice;
    }
    if (renderConfig.bookmaker === 'TOTE') {
        result = parseFloat(result).toFixed(2);
    }
    return result;
}

function getPriceContainer(horseData) {
    return (0, _jquery2.default)('[' + _DIFFUSION2.default.DATA.INPUT.HORSE_NAME + ']').toArray().filter(function (element) {
        var _getElementDiffusionD = getElementDiffusionData(element),
            courseName = _getElementDiffusionD.courseName,
            raceTime = _getElementDiffusionD.raceTime,
            raceDate = _getElementDiffusionD.raceDate,
            horseName = _getElementDiffusionD.horseName;

        return horseName.toUpperCase() === horseData.horseName.toUpperCase() && raceDate === horseData.raceDate && raceTime === horseData.raceTime && courseName === horseData.courseName;
    });
}
// TODO: export by default or export all methods separately (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */
var diffusionServiceUtils = exports.diffusionServiceUtils = {
    getTopicRaceType: getTopicRaceType,
    getTopicInfoType: getTopicInfoType,
    getTopicMarketType: getTopicMarketType,
    getTopicRaceDate: getTopicRaceDate,
    getTopicCourseName: getTopicCourseName,
    getTopicRaceTime: getTopicRaceTime,
    getTopicHorseName: getTopicHorseName,
    getTopicBookmaker: getTopicBookmaker,
    getElementDataAttribute: getElementDataAttribute,
    getElementDiffusionData: getElementDiffusionData,
    createInfoTopic: createInfoTopic,
    createPriceTopic: createPriceTopic,
    parseDiffusionTopic: parseDiffusionTopic,
    parseInfoTopicData: parseInfoTopicData,
    parsePriceTopicData: parsePriceTopicData,
    getDisplayedPriceValue: getDisplayedPriceValue,
    getPriceContainer: getPriceContainer
};

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortByRaceName = exports.formatRaceName = undefined;

var _lodash = __webpack_require__(6);

var formatRaceName = exports.formatRaceName = function formatRaceName(name) {
    if ((0, _lodash.toLower)(name) === 'total') {
        return 'TOTAL';
    }

    return (0, _lodash.capitalize)(name).replace('aw', 'AW').replace('Nhf', 'NHF');
};

var raceNameIndexes = {
    Hurdle: 1,
    Chase: 2,
    NHF: 3
};

var sortByRaceName = exports.sortByRaceName = function sortByRaceName(key) {
    return function (a, b) {
        var name1 = a[key];
        var name2 = b[key];
        if (name1 === name2) {
            return 0;
        }

        var index1 = raceNameIndexes[name1];
        var index2 = raceNameIndexes[name2];
        if (index1 && index2) {
            return index1 - index2;
        }

        return name1 > name2 ? 1 : -1;
    };
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.zeroToDash = exports.placesSort = undefined;

var _rpReactTable = __webpack_require__(22);

var placesSort = exports.placesSort = function placesSort(key) {
    return function (a, b) {
        if (a[key] === 0) {
            return 1;
        }
        if (b[key] === 0) {
            return -1;
        }
        return a[key] - b[key];
    };
};

var zeroToDash = exports.zeroToDash = function zeroToDash(key) {
    return function (rowData) {
        return rowData[key] || _rpReactTable.EMPTINESS_SIGN;
    };
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(145)
var startOfISOWeek = __webpack_require__(147)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var nonRunnerKeys = ['NR', 'WD'];

var isRunnerCode = exports.isRunnerCode = function isRunnerCode(raceOutcomeCode) {
    return !nonRunnerKeys.includes(raceOutcomeCode);
};

var isRunner = exports.isRunner = function isRunner(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode;
    return isRunnerCode(raceOutcomeCode);
};

var duplicateArrayVals = exports.duplicateArrayVals = function duplicateArrayVals(sourceArr) {
    return sourceArr.reduce(function (acc, el) {
        return [].concat(_toConsumableArray(acc), [el, el]);
    }, []);
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseDefinition = function HorseDefinition(_ref) {
    var horseName = _ref.horseName,
        horseUid = _ref.horseUid,
        countryOriginCode = _ref.countryOriginCode,
        avgFlatWinDist = _ref.avgFlatWinDist,
        term = _ref.term;
    return horseUid ? _jsx(_Definition2.default, {
        term: term
    }, void 0, _jsx(_ProfileLink.HorseLink, {
        horseStyleName: horseName,
        horseUid: horseUid,
        className: 'hp-horseDefinition__link'
    }), '\xA0', _jsx('span', {
        className: 'hp-horseDefinition__country'
    }, void 0, '(', countryOriginCode, ')'), !!avgFlatWinDist && ' (' + avgFlatWinDist + 'f)') : null;
};

exports.default = HorseDefinition;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switcher = function Switcher(_ref) {
    var items = _ref.items,
        selected = _ref.selected,
        setSelected = _ref.setSelected;
    return items.length <= 1 ? null : _jsx('div', {
        className: 'ui-switcher'
    }, void 0, items.map(function (item, index) {
        return _jsx('button', {
            className: (0, _classnames2.default)('ui-btn', 'ui-switcher__btn', index === selected && 'ui-btn_primary', index !== selected && 'ui-btn_secondary'),
            onClick: function onClick() {
                return setSelected(index);
            }
        }, item, item);
    }));
};

exports.default = Switcher;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _money = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StakeCell = function StakeCell(_ref) {
    var stake = _ref.stake;
    return stake <= 0 ? (0, _money.formatStake)(stake) : _jsx('strong', {}, void 0, (0, _money.formatStake)(stake));
};

exports.default = StakeCell;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _date = __webpack_require__(19);

var _url = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var RaceCardLink = function RaceCardLink(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceUid = _ref.raceInstanceUid,
        children = _ref.children;

    if (!courseName || !courseUid || !raceDatetime || !raceUid) {
        return null;
    }

    var date = (0, _date.formatDate)(raceDatetime, 'Y-MM-DD');
    var url = '/racecards/' + courseUid + '/' + (0, _url.nameToUrl)(courseName) + '/' + date + '/' + raceUid;
    return _jsx('a', {
        className: 'ui-link ui-link_table js-popupLink js-navigate-url',
        href: url
    }, void 0, children, _ref2);
};

exports.default = RaceCardLink;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sireSubTabs = exports.horseSubStubs = undefined;

var _lodash = __webpack_require__(6);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var human = ['form', 'entries', 'horses', 'stats'];

var jockey = [human[0], 'booked-rides', human[2], human[3]];

var course = ['stats', 'course-map', 'course-records', 'favourites', 'signposts', 'course-info', 'results'];

var horseSubStubs = exports.horseSubStubs = {
    form: ['my-ratings'],
    entries: [],
    stats: [],
    quotes: [],
    pedigree: [],
    sales: [],
    notes: []
};

var horse = Object.keys(horseSubStubs);

var dam = (0, _lodash.uniq)(['progeny', 'progeny-entries', 'progeny-sales', 'pedigree'].concat(_toConsumableArray(horse)));

var sireSubTabs = exports.sireSubTabs = {
    stallionDetails: ['weatherbys-overview', 'sire-reference'],
    studRecord: ['progeny', 'progeny-statistics', 'progeny-dams-sire', 'progeny-results', 'progeny-entries', 'nicks'],
    salesRecord: ['fee-history', 'sales-statistics', 'sales-results', 'sales-entries']
};

var sire = (0, _lodash.uniq)([].concat(_toConsumableArray(Object.keys(sireSubTabs)), [
// no sub-tabs:
'pedigree'], _toConsumableArray(horse)));

var TabNames = {
    owner: human,
    trainer: human,
    jockey: jockey,
    course: course,
    horse: horse,
    sire: sire,
    dam: dam
};

exports.default = TabNames;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _FetchError = __webpack_require__(1175);

var _FetchError2 = _interopRequireDefault(_FetchError);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(161);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref4 = _jsx(_rpReactTable.Loading, {});

var TabFetchProvider = function (_PureComponent) {
    _inherits(TabFetchProvider, _PureComponent);

    function TabFetchProvider(props) {
        _classCallCheck(this, TabFetchProvider);

        var _this = _possibleConstructorReturn(this, (TabFetchProvider.__proto__ || Object.getPrototypeOf(TabFetchProvider)).call(this, props));

        _this.cancelRequest = function () {
            return null;
        };

        _this.refresh = function () {
            clearTimeout(_this.state.errorTimeout);
            _this.setState({
                errorTimeout: null
            });
            _this.fetchData(_this.props.params);
        };

        _this.state = {
            shouldFetch: true,
            errorTimeout: null
        };
        return _this;
    }

    _createClass(TabFetchProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData(this.props.params);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var params = _ref.params;
            var _props$params = this.props.params,
                id = _props$params.id,
                tab = _props$params.tab;

            if (id === params.id && tab === params.tab) {
                return;
            }

            this.cancelRequest();
            this.setState({ shouldFetch: true, data: {} });

            this.fetchData(params);
        }
    }, {
        key: 'fetchData',
        value: function fetchData(_ref2) {
            var _this2 = this;

            var id = _ref2.id,
                name = _ref2.name,
                tab = _ref2.tab,
                type = _ref2.type;

            var indexTab = this.props.route.fetchPath || '';

            var tabOrIndex = tab || indexTab;

            _axios2.default.get('tab/' + type + '/' + id + '/' + name + '/' + tabOrIndex, {
                cancelToken: new _axios.CancelToken(function (cancel) {
                    _this2.cancelRequest = cancel;
                })
            }).then(function (_ref3) {
                var data = _ref3.data;

                _this2.setState({ shouldFetch: false, data: data }, function () {
                    (0, _fixMobileSafariWhiteScreenBug2.default)();
                });
            }).catch(function (error) {
                if ((0, _axios.isCancel)(error)) {
                    return;
                }

                console.warn(error);
                _this2.setState({
                    errorTimeout: setTimeout(_this2.refresh, 20000)
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                shouldFetch = _state.shouldFetch,
                fetchedData = _state.data,
                errorTimeout = _state.errorTimeout;
            var _props = this.props,
                Tab = _props.route.Tab,
                params = _props.params,
                data = _props.data;


            return shouldFetch ? _jsx('section', {}, void 0, _ref4, errorTimeout && _jsx(_FetchError2.default, {
                refresh: this.refresh
            })) : _jsx(Tab, {
                data: Object.assign({}, data, fetchedData),
                params: params
            });
        }
    }]);

    return TabFetchProvider;
}(_react.PureComponent);

exports.default = TabFetchProvider;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatWeight = function formatWeight(weightInLbs) {
    return weightInLbs ? Math.floor(weightInLbs / 14) + "-" + weightInLbs % 14 : null;
};

exports.default = formatWeight;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getHorseType = exports.getHorseType = function getHorseType(_ref) {
    var damStatus = _ref.damStatus,
        sireStatus = _ref.sireStatus;

    if (damStatus) {
        return 'dam';
    }
    if (sireStatus) {
        return 'sire';
    }
    return 'horse';
};

var hasProgeny = exports.hasProgeny = function hasProgeny(profile) {
    return getHorseType(profile) !== 'horse';
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areAllFieldsEmpty = exports.fromObjToArray = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(6);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Convert object to array
 * @param dataObj object
 * @param keyField string
 * @returns {array}
 */
var fromObjToArray = exports.fromObjToArray = function fromObjToArray(dataObj) {
    var keyField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
    return (0, _lodash.keys)(dataObj).map(function (key) {
        return _extends(_defineProperty({}, keyField, key), dataObj[key]);
    });
};

/**
 * Check if all obj/array values are empty
 * @param obj array
 * @returns {boolean}
 */
var areAllFieldsEmpty = exports.areAllFieldsEmpty = function areAllFieldsEmpty(obj) {
    return (0, _lodash.values)(obj).every(function (val) {
        return (0, _lodash.isPlainObject)(val) ? areAllFieldsEmpty(val) : !val;
    });
};

/***/ }),
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var getDaysInMonth = __webpack_require__(411)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(146)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellRangeRenderer__ = __webpack_require__(892);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellRangeRenderer__["a"]; });







/***/ }),
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DATA: {
        INPUT: {
            HORSE_NAME: 'data-diffusion-horsename',
            COURSE_NAME: 'data-diffusion-coursename',
            RACE_TIME: 'data-diffusion-racetime',
            RACE_DATE: 'data-diffusion-racedate',
            BOOKMAKER: 'data-diffusion-bookmaker'
        },
        OUTPUT: {
            OUTCOMERS_ID: 'data-diffusion-outcomers-id',
            FRACTIONAL: 'data-diffusion-fractional',
            DECIMAL: 'data-diffusion-decimal',
            HISTORY: 'data-diffusion-history',
            STATUS: 'data-diffusion-status',
            EVENT_ID: 'data-diffusion-event-id',
            MEETING_ID: 'data-diffusion-meeting-id',
            NEXT_PRICE: 'data-diffusion-next-price'
        }
    }
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(2292);


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(2295);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHorseName = undefined;
exports.default = analyticsPage;

var _rpAnalytics = __webpack_require__(130);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var section1 = {
    horse: 'Horses',
    jockey: 'Jockeys',
    owner: 'Owners',
    trainer: 'Trainers',
    course: 'Courses'
};

var stateName = {
    horse: 'raceHorseName',
    jockey: 'jokeyName',
    owner: 'ownerName',
    trainer: 'trainerName',
    course: 'courseName'
};

var state = {
    raceHorseName: '',
    jokeyName: '',
    ownerName: '',
    trainerName: '',
    courseName: ''
};

var getHorseName = exports.getHorseName = function getHorseName() {
    return state.raceHorseName;
};

function analyticsPage() {
    var _segmentio$setCommonT;

    var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var pathnameSplit = global.location.pathname.split('/');
    var type = pathnameSplit[2];

    if (preloadedState) {
        state.raceHorseName = type === 'horse' && preloadedState.profile && preloadedState.profile.horseName;

        state.jokeyName = type === 'jockey' && preloadedState.profile && preloadedState.profile.styleName;

        state.ownerName = type === 'owner' && preloadedState.profile && preloadedState.profile.styleName;

        state.trainerName = type === 'trainer' && preloadedState.profile && preloadedState.profile.styleName;

        state.courseName = type === 'course' && preloadedState.profile && preloadedState.profile.courseStyleName;
    }

    var newSection2 = (0, _jquery2.default)('a.ui-tabs__tab_selected').text();
    // jQuery('a.pp-subTabs__tab_selected').text(); // on Sire's Stud Record; not used

    var commonTraits = segmentio.getCommonTraits();
    var oldSection2 = commonTraits && commonTraits[segmentio.TRAIT_SITE_SUB_SECTION_2];
    if (!newSection2 || newSection2 === oldSection2) return;

    segmentio.setCommonTraits((_segmentio$setCommonT = {}, _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SECTION, 'Profiles'), _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_1, section1[type]), _defineProperty(_segmentio$setCommonT, segmentio.TRAIT_SITE_SUB_SECTION_2, newSection2), _segmentio$setCommonT));

    var pageTraits = {};

    if (state.raceHorseName) {
        pageTraits['Race Horse Name'] = state.raceHorseName;
    }

    if (state.jokeyName) {
        pageTraits['Jockey Name'] = state.jokeyName;
    }

    if (state.ownerName) {
        pageTraits['Owner Name'] = state.ownerName;
    }

    if (state.trainerName) {
        pageTraits['Trainer Name'] = state.trainerName;
    }

    if (state.courseName) {
        pageTraits['Course Name'] = state.courseName;
    }

    var permutiveProps = {
        profile: {
            type: section1[type],
            name: state[stateName[type]]
        }
    };

    var pageName = null; // not used for now
    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS, permutiveProps);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(73);
var normalizeHeaderName = __webpack_require__(972);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(538);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(538);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(6);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatBirthDate = function formatBirthDate(utc) {
    return (0, _moment2.default)(utc).format('DDMMMYY');
};

var Age = function Age(_ref) {
    var age = _ref.age,
        horseDateOfBirth = _ref.horseDateOfBirth,
        horseColourCode = _ref.horseColourCode,
        horseSexCode = _ref.horseSexCode,
        avgFlatWinDist = _ref.avgFlatWinDist;

    var data = (0, _lodash.compact)([horseDateOfBirth && formatBirthDate(horseDateOfBirth), (0, _lodash.toLower)(horseColourCode), (0, _lodash.toLower)(horseSexCode)]).join(' ');
    return _jsx(_Definition2.default, {
        term: age.replace(/-/g, '')
    }, void 0, data && _jsx('span', {
        className: 'hp-details__info'
    }, void 0, '(', data, ')'), avgFlatWinDist && _jsx('span', {
        className: 'hp-details__info'
    }, void 0, '\xA0(', avgFlatWinDist, 'f)'));
};

exports.default = Age;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breeder = function Breeder(_ref) {
    var breederName = _ref.breederName,
        className = _ref.className;
    return breederName ? _jsx(_Definition2.default, {
        term: 'Breeder',
        className: className,
        description: breederName
    }) : null;
};

exports.default = Breeder;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(252);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dam = function Dam(_ref) {
    var damHorseName = _ref.damHorseName,
        damUid = _ref.damUid,
        damCountryOriginCode = _ref.damCountryOriginCode;
    return _jsx(_HorseDefinition2.default, {
        countryOriginCode: damCountryOriginCode,
        horseName: damHorseName,
        horseUid: damUid,
        term: 'Dam'
    });
};

exports.default = Dam;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(252);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DamSire = function DamSire(_ref) {
    var damSireHorseName = _ref.damSireHorseName,
        damSireUid = _ref.damSireUid,
        damSireCountryOriginCode = _ref.damSireCountryOriginCode,
        damSireAvgFlatWinDist = _ref.damSireAvgFlatWinDist;
    return _jsx(_HorseDefinition2.default, {
        avgFlatWinDist: damSireAvgFlatWinDist,
        countryOriginCode: damSireCountryOriginCode,
        horseName: damSireHorseName,
        horseUid: damSireUid,
        term: 'Dam\'s Sire'
    });
};

exports.default = DamSire;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shortid = __webpack_require__(331);

var _shortid2 = _interopRequireDefault(_shortid);

var _lodash = __webpack_require__(6);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

var _ProfileLink = __webpack_require__(24);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previousOwner = function previousOwner(owner) {
    return _jsx('li', {}, _shortid2.default.generate(), owner.ownerStyleName, ' until ', (0, _date.formatDate)(owner.ownerChangeDate, 'D MMM YYYY'));
};

var Owner = function Owner(_ref) {
    var ownerName = _ref.ownerName,
        ownerUid = _ref.ownerUid,
        hasPedigree = _ref.hasPedigree,
        previousOwners = _ref.previousOwners;
    return ownerUid ? _jsx(_Definition2.default, {
        term: (hasPedigree ? 'Racing ' : '') + 'Owner'
    }, void 0, _jsx(_ProfileLink.OwnerLink, {
        ownerStyleName: ownerName,
        ownerUid: ownerUid
    }), !(0, _lodash.isEmpty)(previousOwners) && _jsx('ul', {
        className: 'hp-details__owners-list'
    }, void 0, previousOwners.map(previousOwner))) : null;
};

exports.default = Owner;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(252);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sire = function Sire(_ref) {
    var sireHorseName = _ref.sireHorseName,
        sireUid = _ref.sireUid,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        sireAvgFlatWinDist = _ref.sireAvgFlatWinDist;
    return _jsx(_HorseDefinition2.default, {
        avgFlatWinDist: sireAvgFlatWinDist,
        countryOriginCode: sireCountryOriginCode,
        horseName: sireHorseName,
        horseUid: sireUid,
        term: 'Sire'
    });
};

exports.default = Sire;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trainer = function Trainer(_ref) {
    var hasPedigree = _ref.hasPedigree,
        trainerName = _ref.trainerName,
        trainerUid = _ref.trainerUid,
        _ref$trainerLast14Day = _ref.trainerLast14Days,
        wins = _ref$trainerLast14Day.wins,
        runs = _ref$trainerLast14Day.runs,
        percent = _ref$trainerLast14Day.percent;
    return trainerUid ? _jsx(_Definition2.default, {
        term: 'Trainer'
    }, void 0, _jsx(_ProfileLink.TrainerLink, {
        trainerStyleName: trainerName,
        trainerUid: trainerUid
    }), !hasPedigree && !!runs && _jsx('span', {
        className: 'hp-details__info'
    }, void 0, '\xA0(Last 14 days: ', wins, '-', runs, ', ', percent, '%)')) : null;
};

exports.default = Trainer;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.myRatingsType = exports.raceRecordsType = exports.figuresType = exports.formType = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formType = exports.formType = _propTypes2.default.shape({
    raceDatetime: _propTypes2.default.string,
    courseName: _propTypes2.default.string,
    distanceYard: _propTypes2.default.number,
    goingTypeServicesDesc: _propTypes2.default.string,
    goingTypeCode: _propTypes2.default.string,
    weightCarriedLbs: _propTypes2.default.number,
    otherHorse: _propTypes2.default.shape({
        styleName: _propTypes2.default.string,
        weightCarriedLbs: _propTypes2.default.number
    }),
    oddsDesc: _propTypes2.default.string,
    jockeyShortName: _propTypes2.default.string,
    officialRatingRanOff: _propTypes2.default.number,
    rpTopspeed: _propTypes2.default.number,
    rpPostmark: _propTypes2.default.number,
    rukReplayAvailable: _propTypes2.default.bool
});

var figuresType = exports.figuresType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    raceTypeCode: _propTypes2.default.string,
    formFigure: _propTypes2.default.string
}));

var raceRecordsType = exports.raceRecordsType = _propTypes2.default.shape({
    jumpsFiguresCalculated: figuresType,
    flatFiguresCalculated: figuresType,
    lifetimeRecords: _propTypes2.default.objectOf(_propTypes2.default.shape({
        starts: _propTypes2.default.number.isRequired,
        wins: _propTypes2.default.number.isRequired,
        '2nds': _propTypes2.default.number.isRequired,
        '3rds': _propTypes2.default.number.isRequired,
        winnigs: _propTypes2.default.number,
        earnings: _propTypes2.default.number,
        'or+': _propTypes2.default.number,
        bestTs: _propTypes2.default.number,
        bestRpr: _propTypes2.default.number
    }))
});

var myRatingsType = exports.myRatingsType = _propTypes2.default.objectOf(_propTypes2.default.number);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(91);

var _reactRouter = __webpack_require__(160);

var _history = __webpack_require__(956);

__webpack_require__(955);

var _humanRoutes = __webpack_require__(952);

var _humanRoutes2 = _interopRequireDefault(_humanRoutes);

var _courseRoutes = __webpack_require__(950);

var _courseRoutes2 = _interopRequireDefault(_courseRoutes);

var _horseRoutes = __webpack_require__(951);

var _horseRoutes2 = _interopRequireDefault(_horseRoutes);

var _rpLibs = __webpack_require__(953);

var _rpLibs2 = _interopRequireDefault(_rpLibs);

var _analyticsPage = __webpack_require__(336);

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_rpLibs2.default.beforeRender();

var routes = [].concat(_toConsumableArray(_humanRoutes2.default), [_courseRoutes2.default, _horseRoutes2.default]);

var browserHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
    basename: '/profile/'
});

(0, _reactDom.render)(_jsx(_reactRouter.Router, {
    routes: routes,
    history: browserHistory,
    onUpdate: function onUpdate() {
        (0, _analyticsPage2.default)();
    }
}), document.querySelector('main'));

_rpLibs2.default.afterRender();

exports.default = browserHistory;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpGuiGuide = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// on desktop iOS arrow is always down (you cannot see it when Select is opened)
var isDesktopIos = !_rpGuiGuide.mobileDetect.isPhone() && !_rpGuiGuide.mobileDetect.tablet() && window.navigator.userAgent.indexOf('Mac') > -1;

var Select = function (_PureComponent) {
    _inherits(Select, _PureComponent);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.onSelect = function (e) {
            _this.props.onSelect(e.target.value);
        };

        _this.toggleArrow = function () {
            _this.setState(function (_ref) {
                var arrowUp = _ref.arrowUp;
                return { arrowUp: !arrowUp };
            });
        };

        _this.downArrow = function () {
            _this.setState({ arrowUp: false });
        };

        _this.state = { arrowUp: false };
        return _this;
    }

    _createClass(Select, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                value = _props.value,
                options = _props.options,
                wrapperClass = _props.wrapperClass;

            var title = children || options[value];

            var arrowClass = (0, _classnames2.default)('pp-select__arrow', !isDesktopIos && this.state.arrowUp && 'pp-select__arrow_up');

            var selectBoxState = (0, _classnames2.default)(this.state.arrowUp && 'ui-btn_primary pp-select__selected');

            // "slt" and "sld" classes are used for automation tests
            return options.length > 1 ? _jsx('div', {
                className: 'pp-select ui-btn ' + wrapperClass + ' ' + selectBoxState
            }, void 0, title, _jsx(_rpReactSvgIcon2.default, {
                iconName: 'down',
                size: 'Medium',
                className: arrowClass
            }), _jsx('select', {
                className: 'slt pp-select__input',
                value: value,
                onChange: this.onSelect,
                onBlur: this.downArrow,
                onClick: this.toggleArrow
            }, void 0, options.map(function (optionText, index) {
                return _jsx('option', {
                    value: index,
                    className: value === index ? 'sld' : null
                }, optionText, optionText);
            }))) : _jsx('div', {
                className: 'pp-select'
            }, void 0, title);
        }
    }]);

    return Select;
}(_react.PureComponent);

exports.default = Select;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _rpReactTable = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-danger: 0 */


var _ref2 = _jsx(_rpReactTable.Loading, {});

var Weatherbys = function (_PureComponent) {
    _inherits(Weatherbys, _PureComponent);

    function Weatherbys(props) {
        _classCallCheck(this, Weatherbys);

        var _this = _possibleConstructorReturn(this, (Weatherbys.__proto__ || Object.getPrototypeOf(Weatherbys)).call(this, props));

        var weatherbysUid = _this.props.weatherbysUid;

        _this.state = {
            weatherbysInfo: '',
            loading: weatherbysUid
        };
        return _this;
    }

    _createClass(Weatherbys, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                type = _props.type,
                weatherbysUid = _props.weatherbysUid;

            if (this.state.loading) {
                _axios2.default.get('horse/weatherbys/' + weatherbysUid + '/' + type).then(function (_ref) {
                    var data = _ref.data;
                    return _this2.setState(_extends({}, data, {
                        loading: false
                    }));
                }).catch(function () {
                    return _this2.setState({ loading: false });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                weatherbysInfo = _state.weatherbysInfo,
                loading = _state.loading;
            var _props2 = this.props,
                className = _props2.className,
                title = _props2.title,
                weatherbysUid = _props2.weatherbysUid;

            return weatherbysUid ? _jsx('div', {}, void 0, loading && _ref2, weatherbysInfo && _jsx('div', {
                className: 'hp-weatherbys'
            }, void 0, title && _jsx('h2', {
                className: 'hp-weatherbys__title'
            }, void 0, title), _jsx('div', {
                className: className,
                dangerouslySetInnerHTML: { __html: weatherbysInfo }
            }))) : null;
        }
    }]);

    return Weatherbys;
}(_react.PureComponent);

exports.default = Weatherbys;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__(2073);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _getHumanMetaData = __webpack_require__(1188);

var _getHumanMetaData2 = _interopRequireDefault(_getHumanMetaData);

var _getHorseMetaData = __webpack_require__(1187);

var _getHorseMetaData2 = _interopRequireDefault(_getHorseMetaData);

var _getCourseMetaData = __webpack_require__(1186);

var _getCourseMetaData2 = _interopRequireDefault(_getCourseMetaData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMetaData = function getMetaData(type, page, name, profile) {
    switch (type) {
        case 'course':
            return (0, _getCourseMetaData2.default)(page, name);
        case 'horse':
            return (0, _getHorseMetaData2.default)(page, profile);
        default:
            return (0, _getHumanMetaData2.default)(type, page, name);
    }
};

var MetaData = function MetaData(_ref) {
    var type = _ref.type,
        page = _ref.page,
        name = _ref.name,
        profile = _ref.profile;

    var _getMetaData = getMetaData(type, page, name, profile),
        title = _getMetaData.title,
        description = _getMetaData.description;

    return _jsx(_reactHelmet2.default, {
        title: title,
        meta: [{
            name: 'description',
            content: description.replace(/\s\s+/g, ' ')
        }]
    });
};

exports.default = MetaData;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _NavLink = __webpack_require__(1191);

var _NavLink2 = _interopRequireDefault(_NavLink);

var _HelpLink = __webpack_require__(1189);

var _HelpLink2 = _interopRequireDefault(_HelpLink);

var _MoreBtn = __webpack_require__(1190);

var _MoreBtn2 = _interopRequireDefault(_MoreBtn);

var _SubNav = __webpack_require__(1193);

var _SubNav2 = _interopRequireDefault(_SubNav);

var _tabNames = __webpack_require__(256);

var _tabNames2 = _interopRequireDefault(_tabNames);

var _isShown = __webpack_require__(1197);

var _isShown2 = _interopRequireDefault(_isShown);

var _calculateTabUrl = __webpack_require__(578);

var _calculateTabUrl2 = _interopRequireDefault(_calculateTabUrl);

var _checkSubTabSelected = __webpack_require__(1196);

var _checkSubTabSelected2 = _interopRequireDefault(_checkSubTabSelected);

var _calculateActiveClass = __webpack_require__(1195);

var _calculateActiveClass2 = _interopRequireDefault(_calculateActiveClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Nav = function Nav(_ref) {
    var _ref$params = _ref.params,
        type = _ref$params.type,
        id = _ref$params.id,
        name = _ref$params.name,
        currentTab = _ref$params.tab,
        _ref$params$hash = _ref$params.hash,
        hash = _ref$params$hash === undefined ? '' : _ref$params$hash,
        _ref$params$mr = _ref$params.mr,
        mr = _ref$params$mr === undefined ? {} : _ref$params$mr,
        helpUrl = _ref.helpUrl,
        tabsToExclude = _ref.tabsToExclude,
        horseType = _ref.horseType;

    var url = type + '/' + id + '/' + name;
    // removing tabs that shouldn't be rendered
    var tabs = _lodash.without.apply(undefined, [_tabNames2.default[horseType || type]].concat(_toConsumableArray(tabsToExclude)));

    // calculating on what sreen size we need a "More" button
    var MoreBtnIsShown = tabs.length > _isShown2.default.XN + 1;
    var MoreBtnIsShownOnNarrow = tabs.length > _isShown2.default.N + 1;

    // sire tabs has sub-tabs so we need to handle this case
    var isSire = horseType === 'sire';
    var hasWeatherbys = isSire && !tabsToExclude.includes('stallionDetails');

    var isSubTabSelected = isSire && (0, _checkSubTabSelected2.default)(currentTab);
    var activeClassName = (0, _calculateActiveClass2.default)(isSire, hasWeatherbys, isSubTabSelected, currentTab);

    return _jsx('nav', {
        className: (0, _classnames2.default)('ui-tabs__wrapper', isSubTabSelected && 'pp-tabs__subNavWrapper')
    }, void 0, _jsx('div', {
        className: 'ui-tabs pp-tabs dark'
    }, void 0, tabs.map(function (tabName, index) {
        return _jsx(_NavLink2.default, {
            url: url,
            hash: hash,
            tabName: tabName,
            tabUrl: (0, _calculateTabUrl2.default)(currentTab, tabName, index, isSire, mr.isShown),
            activeClassName: activeClassName,
            cssClasses: [MoreBtnIsShown && index >= _isShown2.default.XN && 'hidden-xs-down', MoreBtnIsShownOnNarrow && index >= _isShown2.default.N && 'hidden-sm-down']
        }, tabName);
    }), MoreBtnIsShown && _jsx(_MoreBtn2.default, {
        url: url,
        hash: hash,
        tabNames: tabs.slice(_isShown2.default.XN),
        currentTab: currentTab,
        is5Tabs: tabs.length === 5
    }), _jsx(_HelpLink2.default, {
        url: helpUrl
    })), isSubTabSelected && _jsx(_SubNav2.default, {
        currentTab: currentTab,
        hasWeatherbys: hasWeatherbys,
        url: url
    }));
};

Nav.defaultProps = {
    tabsToExclude: []
};

exports.default = Nav;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _timePeriods = __webpack_require__(356);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(161);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _analyticsPage = __webpack_require__(336);

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageProvider = function (_PureComponent) {
    _inherits(PageProvider, _PureComponent);

    function PageProvider(props) {
        _classCallCheck(this, PageProvider);

        var _this = _possibleConstructorReturn(this, (PageProvider.__proto__ || Object.getPrototypeOf(PageProvider)).call(this, props));

        var data = window.PRELOADED_STATE;
        delete window.PRELOADED_STATE;

        _this.state = { data: data };

        (0, _timePeriods.setActiveSeasons)(data.seasons);

        (0, _analyticsPage2.default)(data);
        return _this;
    }

    _createClass(PageProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _fixMobileSafariWhiteScreenBug2.default)();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            (0, _fixMobileSafariWhiteScreenBug2.default)();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                Page = _props.route.Page,
                location = _props.location,
                children = _props.children;

            var _location$pathname$sp = location.pathname.split('/'),
                _location$pathname$sp2 = _slicedToArray(_location$pathname$sp, 5),
                type = _location$pathname$sp2[0],
                id = _location$pathname$sp2[1],
                name = _location$pathname$sp2[2],
                tab = _location$pathname$sp2[3],
                subTab = _location$pathname$sp2[4];

            var hash = location.hash;


            return _jsx(Page, {
                data: this.state.data,
                params: { type: type, id: id, name: name, tab: tab, hash: hash, subTab: subTab }
            }, void 0, children);
        }
    }]);

    return PageProvider;
}(_react.PureComponent);

exports.default = PageProvider;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reason of creating: goo.gl/YMZBM6

var TabProvider = function TabProvider(_ref) {
    var Tab = _ref.route.Tab,
        params = _ref.params,
        data = _ref.data;
    return Tab && _jsx(Tab, {
        data: data,
        params: params
    });
};

exports.default = TabProvider;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeEndYear = exports.removeExtra = exports.getAvailable = exports.getLast5 = exports.getCurrent = exports.getAll = exports.setActiveSeasons = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getRaceTypeStartYear = getRaceTypeStartYear;
exports.getCurrentSeasonEndYear = getCurrentSeasonEndYear;
exports.getPeriods = getPeriods;

var _lodash = __webpack_require__(6);

var _date = __webpack_require__(19);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var activeSeasons = [];

var setActiveSeasons = exports.setActiveSeasons = function setActiveSeasons(seasons) {
    activeSeasons.splice(0);
    activeSeasons.push.apply(activeSeasons, _toConsumableArray(seasons));
};

var getCurrentSeasonYear = function getCurrentSeasonYear(racingType) {
    var currentYear = new Date().getUTCFullYear();
    return racingType === 'jumps' ? currentYear - 1 : currentYear;
};

function getRaceTypeStartYear(racingType, country, seasons) {
    var startYearUTC = (0, _lodash.get)(seasons, [racingType, country], undefined);
    return startYearUTC ? (0, _date.getYearFromUtc)(startYearUTC) : getCurrentSeasonYear(racingType);
}

function getCurrentSeasonEndYear(racingType, country) {
    var currentYear = new Date().getUTCFullYear();
    var currentSeasonCode = 'F';
    if (racingType === 'jumps') {
        currentSeasonCode = country === 'IRE' ? 'I' : 'J';
    }
    var activeSeason = activeSeasons.find(function (_ref) {
        var seasonTypeCode = _ref.seasonTypeCode;
        return seasonTypeCode === currentSeasonCode;
    });

    return activeSeason ? (0, _date.getYearFromUtc)(activeSeason.seasonEndDate) : currentYear;
}

function getPeriods(startYear, endYear, raceType) {
    var periods = [];

    var labelTemplate = function labelTemplate(year) {
        return '' + year;
    };
    var valueTemplate = function valueTemplate(year) {
        return year + '/' + year;
    };

    if (raceType === 'jumps') {
        labelTemplate = function labelTemplate(year) {
            return year - 1 + '-' + year.toString().slice(2);
        };
        valueTemplate = function valueTemplate(year) {
            return year - 1 + '/' + year;
        };
    }

    for (var year = startYear; year > endYear; year -= 1) {
        periods.push({
            label: labelTemplate(year),
            value: valueTemplate(year)
        });
    }

    return periods;
}

var getAll = exports.getAll = function getAll(lastYear, currentYear) {
    return {
        label: 'All',
        value: lastYear + '/' + currentYear + '/all'
    };
};

var getCurrent = exports.getCurrent = function getCurrent(currentYear, type) {
    return {
        label: 'Current ' + (type === 'jumps' ? 'season' : 'year'),
        value: (type === 'jumps' ? currentYear - 1 : currentYear) + '/' + currentYear + '/current'
    };
};

var getLast5 = exports.getLast5 = function getLast5(currentSeasonEndYear, type) {
    var isJumps = type === 'jumps';
    var periodStartYear = currentSeasonEndYear - (isJumps ? 5 : 4);
    return {
        label: 'Last 5 ' + (isJumps ? 'season' : 'year') + 's',
        value: periodStartYear + '/' + currentSeasonEndYear + '/last5'
    };
};

var getAvailable = exports.getAvailable = function getAvailable() {
    var seasonsAvailable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments[1];
    var useSingleYearFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return seasonsAvailable[type] ? seasonsAvailable[type].map(function (_ref2) {
        var seasonStartDate = _ref2.seasonStartDate,
            seasonEndDate = _ref2.seasonEndDate;

        var startYear = (0, _date.formatDate)(seasonStartDate, 'Y');
        return {
            value: useSingleYearFormat ? startYear : (0, _date.getYearFromUtc)(seasonStartDate) + '/' + (0, _date.getYearFromUtc)(seasonEndDate),
            label: type === 'FLAT' ? startYear : startYear + '-' + (0, _date.formatDate)(seasonEndDate, 'YY')
        };
    }) : [];
};

// removing helper suffixes from option value
var removeExtra = exports.removeExtra = function removeExtra(val) {
    return val.replace('/last5', '').replace('/current', '').replace('/all', '');
};

// remove end year from option value
// '2015-2016' => '2015'
var removeEndYear = exports.removeEndYear = function removeEndYear(option) {
    return _extends({}, option, {
        value: option.value.split('/')[0]
    });
};

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpNavigation = __webpack_require__(248);

var _index = __webpack_require__(349);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showBarrier = function showBarrier(event, url) {
    event.preventDefault();

    var urlToRedirect = window.location.origin + '/profile/' + url.split('#')[0];
    var lightBoxText = "Subscribe to Members' Club and get access to this content and much more";

    (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, {
        text: lightBoxText,
        r: urlToRedirect,
        service: 'both'
    }).then(function (hasAccess) {
        if (hasAccess) {
            _index2.default.push(url);
        }
    });
};

exports.default = showBarrier;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCategories = exports.getCategories = undefined;

var _selection = __webpack_require__(131);

var _updateCategories = __webpack_require__(1180);

var _updateCategories2 = _interopRequireDefault(_updateCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCategories = exports.getCategories = function getCategories(tab, type, reducer, categories) {
    var key = 'filter_' + tab + '_' + type;
    var storedActions = JSON.parse(localStorage.getItem(key));

    if (!Array.isArray(storedActions)) {
        return null;
    }

    return storedActions.reduce(function (acc, action) {
        return (0, _updateCategories2.default)(acc, reducer, action);
    }, categories);
};

var setCategories = exports.setCategories = function setCategories(tab, type, categories) {
    var key = 'filter_' + tab + '_' + type;
    var actions = Object.keys(categories).map(function (categoryName) {
        return {
            type: categoryName,
            value: (0, _selection.getOption)(categories, categoryName).value
        };
    });
    localStorage.setItem(key, JSON.stringify(actions));
};

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(201);
var createDesc = __webpack_require__(202);
var toIObject = __webpack_require__(120);
var toPrimitive = __webpack_require__(376);
var has = __webpack_require__(132);
var IE8_DOM_DEFINE = __webpack_require__(595);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(118) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(67);
var core = __webpack_require__(33);
var fails = __webpack_require__(164);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(59);
var core = __webpack_require__(33);
var LIBRARY = __webpack_require__(200);
var wksExt = __webpack_require__(378);
var defineProperty = __webpack_require__(105).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(60);


/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(212)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var differenceInCalendarMonths = __webpack_require__(664)
var compareAsc = __webpack_require__(214)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(283)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfISOWeek = __webpack_require__(147)
var startOfISOYear = __webpack_require__(215)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 413 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(284)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(1563)
var buildFormatLocale = __webpack_require__(1564)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Default CellMeasurer `cellSizeCache` implementation.
 * Permanently caches all cell sizes (identified by column and row index) unless explicitly cleared.
 * Can be configured to handle uniform cell widths and/or heights as a way of optimizing certain use cases.
 */
var DefaultCellSizeCache = function () {
  function DefaultCellSizeCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref$uniformRowHeight = _ref.uniformRowHeight;
    var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
    var _ref$uniformColumnWid = _ref.uniformColumnWidth;
    var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DefaultCellSizeCache);

    this._uniformRowHeight = uniformRowHeight;
    this._uniformColumnWidth = uniformColumnWidth;

    this._cachedColumnWidth = undefined;
    this._cachedRowHeight = undefined;

    this._cachedColumnWidths = {};
    this._cachedRowHeights = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DefaultCellSizeCache, [{
    key: "clearAllColumnWidths",
    value: function clearAllColumnWidths() {
      this._cachedColumnWidth = undefined;
      this._cachedColumnWidths = {};
    }
  }, {
    key: "clearAllRowHeights",
    value: function clearAllRowHeights() {
      this._cachedRowHeight = undefined;
      this._cachedRowHeights = {};
    }
  }, {
    key: "clearColumnWidth",
    value: function clearColumnWidth(index) {
      this._cachedColumnWidth = undefined;

      delete this._cachedColumnWidths[index];
    }
  }, {
    key: "clearRowHeight",
    value: function clearRowHeight(index) {
      this._cachedRowHeight = undefined;

      delete this._cachedRowHeights[index];
    }
  }, {
    key: "getColumnWidth",
    value: function getColumnWidth(index) {
      return this._uniformColumnWidth ? this._cachedColumnWidth : this._cachedColumnWidths[index];
    }
  }, {
    key: "getRowHeight",
    value: function getRowHeight(index) {
      return this._uniformRowHeight ? this._cachedRowHeight : this._cachedRowHeights[index];
    }
  }, {
    key: "setColumnWidth",
    value: function setColumnWidth(index, width) {
      this._cachedColumnWidth = width;
      this._cachedColumnWidths[index] = width;
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight(index, height) {
      this._cachedRowHeight = height;
      this._cachedRowHeights[index] = height;
    }
  }]);

  return DefaultCellSizeCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (DefaultCellSizeCache);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback;
    var indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(530);

var _Row2 = _interopRequireDefault(_Row);

var _Loading = __webpack_require__(928);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoData = __webpack_require__(929);

var _NoData2 = _interopRequireDefault(_NoData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function Body(_ref) {
  var loading = _ref.loading,
      noDataText = _ref.noDataText,
      data = _ref.data,
      columns = _ref.columns,
      setRowClass = _ref.setRowClass,
      specialRow = _ref.specialRow;
  return _react2.default.createElement(
    'tbody',
    { className: 'ui-table__body' },
    loading || !data.length ? _react2.default.createElement(
      'tr',
      { className: 'ui-table__row' },
      _react2.default.createElement(
        'td',
        {
          className: 'ui-table__cell',
          colSpan: columns.length
        },
        loading ? _react2.default.createElement(_Loading2.default, null) : _react2.default.createElement(_NoData2.default, { text: noDataText })
      )
    ) : data.map(function (rowData, index) {
      return _react2.default.createElement(_Row2.default, {
        rowData: rowData,
        columns: columns,
        key: rowData.__id || index,
        setRowClass: setRowClass,
        specialRow: specialRow
      });
    })
  );
};

Body.propTypes = {
  loading: _propTypes2.default.bool,
  noDataText: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({}).isRequired).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func
};

exports.default = Body;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createHeaderText = function createHeaderText() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return name.split(/(?=[A-Z])/).join(' ').toLowerCase();
};

/* eslint jsx-a11y/no-static-element-interactions: 0 */

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          sortIdx = _props.sortIdx,
          sortable = _props.sortable,
          onHeaderCellClick = _props.onHeaderCellClick,
          headerRow = _props.headerRow;


      return _react2.default.createElement(
        'thead',
        { className: 'ui-table__header' },
        headerRow && headerRow(),
        _react2.default.createElement(
          'tr',
          { className: 'ui-table__row' },
          columns.map(function (_ref, i) {
            var header = _ref.header,
                className = _ref.className,
                key = _ref.key;
            return _react2.default.createElement(
              'th',
              {
                className: (0, _classnames2.default)('ui-table__cell', 'ui-table__cell_header', className, sortable && sortIdx === i && 'ui-table__cell_sorted'),
                key: key,
                onClick: sortable && sortIdx !== i && function () {
                  return onHeaderCellClick(i, key);
                } || function () {
                  return null;
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'ui-table__cellContent' },
                (0, _lodash.isFunction)(header) ? header() : header || createHeaderText(key)
              )
            );
          })
        )
      );
    }
  }]);

  return Header;
}(_react.PureComponent);

Header.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
  })).isRequired,
  sortable: _propTypes2.default.bool,
  sortIdx: _propTypes2.default.number,
  onHeaderCellClick: _propTypes2.default.func,
  headerRow: _propTypes2.default.func
};

exports.default = Header;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _handleEmpty = __webpack_require__(932);

var _handleEmpty2 = _interopRequireDefault(_handleEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_PureComponent) {
  _inherits(Row, _PureComponent);

  function Row() {
    _classCallCheck(this, Row);

    return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rowData = _props.rowData,
          columns = _props.columns,
          setRowClass = _props.setRowClass,
          specialRow = _props.specialRow;


      return specialRow(rowData) || _react2.default.createElement(
        'tr',
        {
          className: (0, _classnames2.default)('ui-table__row', setRowClass && setRowClass(rowData))
        },
        columns.map(function (_ref) {
          var className = _ref.className,
              key = _ref.key,
              cell = _ref.cell;
          return _react2.default.createElement(
            'td',
            {
              className: (0, _classnames2.default)('ui-table__cell', className),
              key: key
            },
            cell ? cell(rowData) : (0, _handleEmpty2.default)(rowData[key])
          );
        })
      );
    }
  }]);

  return Row;
}(_react.PureComponent);

Row.defaultProps = {
  specialRow: function specialRow() {
    return false;
  }
};

Row.propTypes = {
  rowData: _propTypes2.default.shape({}).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    cell: _propTypes2.default.func,
    className: _propTypes2.default.string
  })).isRequired,
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func
};

exports.default = Row;

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var settle = __webpack_require__(964);
var buildURL = __webpack_require__(967);
var parseHeaders = __webpack_require__(973);
var isURLSameOrigin = __webpack_require__(971);
var createError = __webpack_require__(541);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(966);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(969);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(963);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getValues = exports.getValue = exports.getStatusLabels = exports.getStatusLabel = exports.getLabels = exports.getLabel = exports.getOptions = exports.getOption = exports.setSelected = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _entries = __webpack_require__(815);

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setSelected = exports.setSelected = function setSelected(arr, value) {
    return arr.map(function (item) {
        return item.value === value ? _extends({}, item, { selected: true }) : item;
    });
};

var getOption = exports.getOption = function getOption(category) {
    return (category.options || []).find(function (item) {
        return item.selected;
    }) || {};
};

var getOptions = exports.getOptions = function getOptions(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            category = _ref2[1];

        res[key] = getOption(category);
    });
    return res;
};

var getLabel = exports.getLabel = function getLabel(category) {
    return getOption(category).label;
};

var getLabels = exports.getLabels = function getLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            category = _ref4[1];

        res[key] = getLabel(category);
    });
    return res;
};

var getStatusLabel = exports.getStatusLabel = function getStatusLabel(category) {
    var _getOption = getOption(category),
        statusLabel = _getOption.statusLabel,
        label = _getOption.label;

    return statusLabel || label;
};

var getStatusLabels = exports.getStatusLabels = function getStatusLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            category = _ref6[1];

        res[key] = !category.isHidden ? getStatusLabel(category) : null;
    });
    return res;
};

var getValue = exports.getValue = function getValue(category) {
    return getOption(category).value;
};

var getValues = exports.getValues = function getValues(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            category = _ref8[1];

        res[key] = getValue(category);
    });
    return res;
};

exports.default = {
    setSelected: setSelected,
    getOption: getOption,
    getOptions: getOptions,
    getLabel: getLabel,
    getLabels: getLabels,
    getStatusLabel: getStatusLabel,
    getStatusLabels: getStatusLabels,
    getValue: getValue,
    getValues: getValues
};

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverComponent = __webpack_require__(995);

var _PopoverComponent2 = _interopRequireDefault(_PopoverComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PopoverComponent2.default;

/***/ }),
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodFactory = undefined;

var _filter = __webpack_require__(66);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getRTOptions = function getRTOptions(typeCode) {
    var _raceTypes$course = _filter.raceTypes.course,
        jumps = _raceTypes$course.jumps,
        flat = _raceTypes$course.flat;

    switch (typeCode) {
        case 'J':
        case 'P':
            return [jumps];
        case 'B':
            return [flat, jumps];
        default:
            return [flat];
    }
};

var raceTypeFactory = function raceTypeFactory(code, currentRaceType) {
    return {
        options: _filter.selection.setSelected(getRTOptions(code), currentRaceType),
        title: 'race type'
    };
};

var timePeriodFactory = exports.timePeriodFactory = function timePeriodFactory(raceType, countryCode) {
    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(raceType, countryCode);

    var options = [_filter.timePeriods.getLast5(currentYear, raceType), _filter.timePeriods.getCurrent(currentYear, raceType)].concat(_toConsumableArray(_filter.timePeriods.getPeriods(currentYear - 1, currentYear - 5, raceType)));

    options[0].selected = true;

    return {
        title: 'time period',
        options: options,
        createdBy: { raceType: raceType, countryCode: countryCode }
    };
};

var categories = function categories(currentRaceType, countryCode, typeCode) {
    return {
        raceType: raceTypeFactory(typeCode, currentRaceType),
        timePeriod: timePeriodFactory(currentRaceType, countryCode)
    };
};

exports.default = categories;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodFactory = undefined;

var _lodash = __webpack_require__(6);

var _filter = __webpack_require__(66);

var raceCategoryOptions = {
    big: {
        label: 'Big races',
        value: 'big-race'
    },
    all: {
        label: 'All races',
        value: 'all-races'
    }
};

var raceCategoryFactory = function raceCategoryFactory(statusType) {
    var all = raceCategoryOptions.all,
        big = raceCategoryOptions.big;

    var options = statusType === 'big-race' ? [big, all] : [all];

    return {
        options: _filter.selection.setSelected(options, statusType),
        title: 'race category'
    };
};

var raceTypeFactory = function raceTypeFactory(typeCode, raceType) {
    return {
        title: 'race type',
        options: _filter.selection.setSelected(_filter.raceTypes.getForCourse(typeCode), raceType)
    };
};

var timePeriodFactory = exports.timePeriodFactory = function timePeriodFactory(raceType, principalSeason, seasonsAvailable) {
    return {
        options: _filter.selection.setSelected(_filter.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.toUpper)(raceType), true), principalSeason.toString()),
        title: 'time period',
        createdBy: {
            seasonsAvailable: seasonsAvailable,
            principalSeason: principalSeason,
            raceType: raceType
        }
    };
};

var categoriesFactory = function categoriesFactory(raceStatusType, courseTypeCode, raceType) {
    var coursePrincipalSeason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var seasonsAvailable = arguments[4];
    return seasonsAvailable ? {
        raceCategory: raceCategoryFactory(raceStatusType),
        raceType: raceTypeFactory(courseTypeCode, raceType),
        timePeriod: timePeriodFactory(raceType, coursePrincipalSeason, seasonsAvailable)
    } : null;
};

exports.default = categoriesFactory;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoriesFactory = exports.timePeriodsFactory = undefined;
exports.raceTypesFactory = raceTypesFactory;

var _lodash = __webpack_require__(6);

var _filter = __webpack_require__(66);

var _date = __webpack_require__(19);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getExtraTimeOptions = function getExtraTimeOptions(hasCurrentYear, currentYear, seasons, type) {
    var firstSeasonStart = +(0, _date.formatDate)(seasons[seasons.length - 1].seasonStartDate, 'YYYY');
    var lastSeasonEnd = +(0, _date.formatDate)(seasons[0].seasonEndDate, 'YYYY');

    var allOption = _filter.timePeriods.getAll(firstSeasonStart, currentYear);
    var currentYearOption = _filter.timePeriods.getCurrent(currentYear, type);
    currentYearOption.selected = true;
    var last5Option = _filter.timePeriods.getLast5(currentYear, type);

    var hasFewSeasons = seasons.length > 1;
    var hasLast5Seasons = currentYear - lastSeasonEnd < 5;

    return (0, _lodash.compact)([hasFewSeasons && allOption, hasCurrentYear && currentYearOption, hasLast5Seasons && last5Option]);
};

var getAvailableTimeOptions = function getAvailableTimeOptions(seasonsAvailable, raceType) {
    var options = _filter.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.toUpper)(raceType));
    options[0].selected = true;
    return options;
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(country, raceType, seasonsAvailable) {
    var seasons = seasonsAvailable[(0, _lodash.toUpper)(raceType)];

    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(raceType, country);

    var hasCurrentYear = seasons[0].seasonDesc.includes(currentYear);

    var availableSeasonsOptions = getAvailableTimeOptions(seasonsAvailable, raceType);
    var extraOptions = getExtraTimeOptions(hasCurrentYear, currentYear, seasons, raceType);

    var options = [].concat(_toConsumableArray(extraOptions), _toConsumableArray(hasCurrentYear ? availableSeasonsOptions.slice(1) : availableSeasonsOptions));

    var timePeriod = {
        title: 'time period',
        options: options,
        createdBy: {
            raceType: raceType,
            seasonsAvailable: seasonsAvailable,
            country: country
        }
    };

    return timePeriod;
};

function raceTypesFactory(typeCode, raceType, seasonsAvailable) {
    var options = _filter.raceTypes.getForCourse(typeCode, seasonsAvailable, true);

    return {
        title: 'race type',
        options: _filter.selection.setSelected(options, raceType)
    };
}

var categoriesFactory = exports.categoriesFactory = function categoriesFactory(typeCode, country, raceType, seasonsAvailable) {
    return seasonsAvailable ? {
        raceType: raceTypesFactory(typeCode, raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(country, raceType, seasonsAvailable)
    } : null;
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(238);

var _qs2 = _interopRequireDefault(_qs);

var _FormTable = __webpack_require__(1074);

var _FormTable2 = _interopRequireDefault(_FormTable);

var _RaceRecords = __webpack_require__(1085);

var _RaceRecords2 = _interopRequireDefault(_RaceRecords);

var _transformData = __webpack_require__(1088);

var _transformData2 = _interopRequireDefault(_transformData);

var _Weatherbys = __webpack_require__(351);

var _Weatherbys2 = _interopRequireDefault(_Weatherbys);

var _dataPropTypes = __webpack_require__(348);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, _jsx('span', {}, void 0, 'Details of horses trained outside GB and Ireland or born prior to 1986 may be incomplete.'), _jsx('span', {}, void 0, '\xA0OR Rating is the latest published.', _jsx('br', {})), _jsx('span', {}, void 0, 'GB PTP results are displayed when a horse is declared to run under rules.'));

var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form(props) {
        _classCallCheck(this, Form);

        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        _this.fetchMyRating = _this.fetchMyRating.bind(_this);
        _this.onFilterClick = _this.onFilterClick.bind(_this);

        _this.state = _extends({
            loading: false,
            myRatingFetched: false,
            myRatingData: null,
            selectedFilter: null
        }, (0, _transformData2.default)(props.data));
        return _this;
    }

    _createClass(Form, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mr = this.props.params.mr;

            if (mr.isShown) {
                this.fetchMyRating();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var mr = this.props.params.mr;

            if (mr.isShown && !this.state.loading && !this.state.myRatingFetched) {
                this.fetchMyRating();
            }
        }
    }, {
        key: 'onFilterClick',
        value: function onFilterClick(_ref) {
            var nextFilter = _ref.currentTarget.value;

            this.setState(function (prevState) {
                return {
                    selectedFilter: prevState.selectedFilter === nextFilter ? null : nextFilter
                };
            });
        }
    }, {
        key: 'fetchMyRating',
        value: function fetchMyRating() {
            var _this2 = this;

            this.setState({ loading: true });
            var formData = this.state.form;
            var horseUid = this.props.params.id;

            var racesIds = formData.map(function (entry) {
                return entry.raceInstanceUid;
            });

            _axios2.default.post('horse/form/ugc/' + horseUid, _qs2.default.stringify({ params: racesIds })).then(function (_ref2) {
                var ratings = _ref2.data.ratings;
                return _this2.setState({
                    loading: false,
                    myRatingFetched: true,
                    myRatingData: ratings || []
                });
            }).catch(function () {
                return _this2.setState({ loading: false, myRatingFetched: true });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                selectedFilter = _state.selectedFilter,
                records = _state.records,
                figures = _state.figures,
                form = _state.form,
                hasSpecial = _state.hasSpecial,
                myRatingData = _state.myRatingData,
                loading = _state.loading;
            var _props = this.props,
                weatherbysUid = _props.data.profile.weatherbysUid,
                params = _props.params;


            var data = {
                loading: loading,
                form: form,
                myRatings: myRatingData,
                raceRecords: records
            };

            return _jsx('section', {}, void 0, _jsx(_RaceRecords2.default, {
                data: data,
                figures: figures,
                onFilterClick: this.onFilterClick,
                selectedFilter: selectedFilter,
                params: params
            }), _jsx(_FormTable2.default, {
                data: data,
                hasSpecial: hasSpecial,
                selectedFilter: selectedFilter,
                params: params
            }), _jsx(_Weatherbys2.default, {
                title: 'Weatherbys Race Record',
                type: 'race-record',
                weatherbysUid: weatherbysUid
            }), _ref3);
        }
    }]);

    return Form;
}(_react.Component);

exports.default = Form;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var filterArrays = {
    'Flat Turf': ['F'],
    'All-weather': ['X'],
    NHF: ['B', 'W'],
    Hurdle: ['H', 'Y'],
    Chase: ['C', 'U', 'Z'],
    PTP: ['P']
};

var findTypeByCode = function findTypeByCode(code) {
    return Object.keys(filterArrays).filter(function (type) {
        return filterArrays[type].includes(code);
    })[0];
};

exports.default = filterArrays;
exports.findTypeByCode = findTypeByCode;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameContainer = function NameContainer(_ref) {
    var horseName = _ref.horseName,
        countryCode = _ref.countryCode,
        number = _ref.number;
    return _jsx('div', {
        className: 'hp-nameRow__leftContainer'
    }, void 0, _jsx('h1', {
        className: 'hp-nameRow__name'
    }, void 0, number && _jsx('span', {
        className: 'hp-nameRow__number'
    }, void 0, number, '.'), horseName), _jsx('span', {
        className: 'hp-nameRow__code'
    }, void 0, '(', countryCode, ')'));
};

exports.default = NameContainer;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _RelativesTable = __webpack_require__(1107);

var _RelativesTable2 = _interopRequireDefault(_RelativesTable);

var _RelativesTableDisclaimer = __webpack_require__(1108);

var _RelativesTableDisclaimer2 = _interopRequireDefault(_RelativesTableDisclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlatJumpsTables = function FlatJumpsTables(_ref) {
    var _ref$data = _ref.data,
        FLAT = _ref$data.FLAT,
        JUMPS = _ref$data.JUMPS,
        disclaimerName = _ref.disclaimerName,
        flatTitle = _ref.flatTitle,
        jumpsTitle = _ref.jumpsTitle,
        flatNoData = _ref.flatNoData,
        jumpsNoData = _ref.jumpsNoData;

    var flatJumps = [{ type: 'Flat', data: FLAT, noDataText: flatNoData, title: flatTitle }, { type: 'jumps', data: JUMPS, noDataText: jumpsNoData, title: jumpsTitle }];
    var maxFlat = (0, _lodash.maxBy)(FLAT, 'bestRpPostmark');
    var maxJumps = (0, _lodash.maxBy)(JUMPS, 'bestRpPostmark');

    if (maxJumps && (!maxFlat || maxFlat.bestRpPostmark < maxJumps.bestRpPostmark)) {
        flatJumps.reverse();
    }

    return _jsx('div', {}, void 0, flatJumps.map(function (_ref2) {
        var type = _ref2.type,
            data = _ref2.data,
            noDataText = _ref2.noDataText,
            title = _ref2.title;
        return _jsx(_RelativesTable2.default, {
            data: data,
            noDataText: noDataText,
            title: title
        }, type);
    }), _jsx(_RelativesTableDisclaimer2.default, {
        type: disclaimerName
    }));
};

exports.default = FlatJumpsTables;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DamProgeny = __webpack_require__(1112);

var _DamProgeny2 = _interopRequireDefault(_DamProgeny);

var _ProgenyCommon = __webpack_require__(1110);

var _ProgenyCommon2 = _interopRequireDefault(_ProgenyCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progeny = function Progeny(_ref) {
    var _ref$data = _ref.data,
        progenyResults = _ref$data.progenyResults,
        availableSeasonsData = _ref$data.availableSeasonsData,
        progenyHorsesData = _ref$data.progenyHorsesData,
        _ref$data$profile = _ref$data.profile,
        damStatus = _ref$data$profile.damStatus,
        weatherbysUid = _ref$data$profile.weatherbysUid,
        _ref$params = _ref.params,
        id = _ref$params.id,
        tab = _ref$params.tab;
    return (!tab || tab === 'progeny') && damStatus ? _jsx(_DamProgeny2.default, {
        data: progenyResults
    }) : _jsx(_ProgenyCommon2.default, {
        id: id,
        weatherbysUid: weatherbysUid,
        availableSeasonsData: availableSeasonsData,
        data: progenyHorsesData.data,
        tab: tab
    });
};

exports.default = Progeny;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseCell = function HorseCell(_ref) {
    var horseName = _ref.horseName,
        horseUid = _ref.horseUid,
        horseSexCode = _ref.horseSexCode,
        countryOriginCode = _ref.countryOriginCode,
        damSireStyleName = _ref.damSireStyleName,
        damSireUid = _ref.damSireUid,
        damSireCountryOriginCode = _ref.damSireCountryOriginCode;
    return _jsx('div', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        className: horseSexCode === 'M' || horseSexCode === 'F' ? 'hp-sire-progeny__female' : '',
        horseStyleName: horseName,
        horseUid: horseUid
    }), _jsx('span', {
        className: 'hp-sire-progeny__country'
    }, void 0, ' (', countryOriginCode, ')'), _jsx('div', {
        className: 'hidden-md-up'
    }, void 0, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: damSireStyleName,
        horseUid: damSireUid
    }), _jsx('span', {}, void 0, ' (', damSireCountryOriginCode, ')')));
};

exports.default = HorseCell;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodsFactory = undefined;

var _lodash = __webpack_require__(6);

var _selection = __webpack_require__(131);

var _index = __webpack_require__(66);

var _date = __webpack_require__(19);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getRaceTypesOptions = function getRaceTypesOptions(seasonsAvailable) {
    return (0, _lodash.keys)(seasonsAvailable).reduce(function (result, key) {
        return seasonsAvailable[key] ? [].concat(_toConsumableArray(result), [{ label: (0, _lodash.capitalize)(key), value: (0, _lodash.toLower)(key) }]) : result;
    }, []);
};

var getOnwardsOption = function getOnwardsOption(raceType, seasonsForType) {
    var _seasonsForType = seasonsForType[seasonsForType.length - 1],
        seasonStartDate = _seasonsForType.seasonStartDate,
        seasonEndDate = _seasonsForType.seasonEndDate;

    var lastSeasonEndDate = seasonsForType[0].seasonEndDate;
    var jumpsSuffix = raceType === 'jumps' ? '-' + (0, _date.formatDate)(seasonEndDate, 'YY') : '';

    return {
        value: (0, _date.getYearFromUtc)(seasonStartDate) + '/' + (0, _date.getYearFromUtc)(lastSeasonEndDate),
        label: '' + (0, _date.formatDate)(seasonStartDate, 'Y') + jumpsSuffix + ' onwards'
    };
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(raceType, seasonsAvailable) {
    var options = _index.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.upperCase)(raceType));
    var seasonsForType = seasonsAvailable[(0, _lodash.upperCase)(raceType)];
    if (seasonsForType.length > 1) {
        options.unshift(getOnwardsOption(raceType, seasonsForType));
    }
    options[0].selected = true;

    return {
        title: 'time period',
        options: options,
        createdBy: {
            raceType: raceType,
            seasonsAvailable: seasonsAvailable
        }
    };
};

var raceTypeFactory = function raceTypeFactory(raceType, seasonsAvailable) {
    return {
        title: 'race type',
        options: (0, _selection.setSelected)(getRaceTypesOptions(seasonsAvailable), raceType)
    };
};

var categoriesFactory = function categoriesFactory(seasonsAvailable, _ref) {
    var raceType = _ref.raceType;
    return {
        raceType: raceTypeFactory(raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(raceType, seasonsAvailable)
    };
};

exports.default = categoriesFactory;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monthFactory = exports.timePeriodsFactory = undefined;

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(6);

var _selection = __webpack_require__(131);

var _filter = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var last3MonthOption = {
    label: 'Last 3 months',
    value: 'lastThree'
};

var getRaceTypesOptions = function getRaceTypesOptions(_ref) {
    var FLAT = _ref.FLAT,
        JUMPS = _ref.JUMPS;

    var result = [];
    var _raceTypes$horse = _filter.raceTypes.horse,
        flat = _raceTypes$horse.flat,
        jumps = _raceTypes$horse.jumps;

    if (FLAT) {
        result.push.apply(result, _toConsumableArray(flat));
    }
    if (JUMPS) {
        result.push.apply(result, _toConsumableArray(jumps));
    }
    return result;
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(raceType, seasonsAvailable) {
    var flatOrJumps = raceType.split('/')[1];
    var options = _filter.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.upperCase)(flatOrJumps));
    options[0].selected = true;

    var timePeriod = {
        title: 'time period',
        options: options,
        createdBy: {
            flatOrJumps: flatOrJumps,
            seasonsAvailable: seasonsAvailable
        }
    };
    return timePeriod;
};

var raceTypeFactory = function raceTypeFactory(raceType, seasonsAvailable) {
    return {
        title: 'race type',
        options: (0, _selection.setSelected)(getRaceTypesOptions(seasonsAvailable), raceType)
    };
};

var getMonthOptions = function getMonthOptions() {
    return [{
        label: 'No filter',
        value: ''
    }].concat(_toConsumableArray(_moment2.default.months().map(function (m, i) {
        return {
            label: m,
            value: '' + (i + 1)
        };
    })));
};

var monthFactory = exports.monthFactory = function monthFactory(raceType, timePeriod, seasonsAvailable) {
    var flatOrJumps = raceType.split('/')[1] || raceType;
    var typeSeasons = seasonsAvailable[(0, _lodash.upperCase)(flatOrJumps)] || [];
    var selectedSeasonEndYear = timePeriod.substr(5);
    var selectedSeason = typeSeasons.find(function (_ref2) {
        var seasonEndDate = _ref2.seasonEndDate;
        return seasonEndDate.substr(0, 4) === selectedSeasonEndYear;
    }) || {};
    var isCurrentSeason = (0, _moment2.default)(selectedSeason.seasonEndDate) > (0, _moment2.default)();

    var options = isCurrentSeason ? [last3MonthOption].concat(_toConsumableArray(getMonthOptions())) : getMonthOptions();
    options[0].selected = true;

    return {
        title: 'month',
        options: options,
        createdBy: {
            timePeriod: timePeriod,
            flatOrJumps: flatOrJumps,
            seasonsAvailable: seasonsAvailable
        }
    };
};

var categoriesFactory = function categoriesFactory(seasonsAvailable, _ref3) {
    var raceType = _ref3.raceType,
        timePeriod = _ref3.timePeriod;
    return {
        raceType: raceTypeFactory(raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(raceType, seasonsAvailable),
        month: monthFactory(raceType, timePeriod, seasonsAvailable)
    };
};

exports.default = categoriesFactory;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _RatioCell = __webpack_require__(573);

var _RatioCell2 = _interopRequireDefault(_RatioCell);

var _money = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_rpReactSvgIcon2.default, {
    className: 'hp-progeny-statistics__arrow tableShowIcon',
    iconName: 'down',
    size: 'Medium'
});

var _ref2 = _jsx(_Abbr2.default, {
    title: 'winners / runners',
    breakpoint: 'fromMedium'
}, void 0, 'wnrs\xA0/ rnrs');

var _ref4 = _jsx(_Abbr2.default, {
    title: 'wins',
    breakpoint: 'fromMedium'
}, void 0, 'wins\xA0/ runs');

var _ref6 = _jsx('wbr', {});

var columns = [{
    key: 'arrow',
    header: ' ',
    cell: function cell() {
        return _ref;
    }

}, {
    key: 'category',
    header: 'race type'
}, {
    key: 'winners',
    header: function header() {
        return _ref2;
    },
    cell: function cell(_ref3) {
        var a = _ref3.winners,
            b = _ref3.runners;
        return _jsx(_RatioCell2.default, {
            a: a,
            b: b
        });
    }
}, {
    key: 'percentWinnersRunners',
    header: '%'
}, {
    key: 'wins',
    header: function header() {
        return _ref4;
    },
    cell: function cell(_ref5) {
        var wins = _ref5.wins,
            runs = _ref5.runs;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, wins), _jsx('span', {
            className: 'hidden-md-up'
        }, void 0, '/', _ref6, runs));
    }
}, {
    key: 'runs'
}, {
    key: 'percentWinsRuns',
    header: '%'
}, {
    key: 'place2ndNumber',
    header: '2nd'
}, {
    key: 'place3rdNumber',
    header: '3rd'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref7) {
        var totalPrizeMoney = _ref7.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}];

exports.default = columns;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _url = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeatherbysOverview = function WeatherbysOverview(_ref) {
    var _ref$data = _ref.data,
        _ref$data$externalLin = _ref$data.externalLinks,
        weatherbysDomain = _ref$data$externalLin.weatherbysDomain,
        assetsUrl = _ref$data$externalLin.assetsUrl,
        _ref$data$profile = _ref$data.profile,
        weatherbysUid = _ref$data$profile.weatherbysUid,
        horseName = _ref$data$profile.horseName;

    var mainFrameUrl = weatherbysDomain + '/pages/' + weatherbysUid + 'rpdynover.html';
    var bannerFrameUrl = weatherbysDomain + '/pages/images/' + (0, _url.nameToBannerUrl)(horseName) + 'con.jpg';
    var logoUrl = assetsUrl + '/img/png/weatherbys_logo.png';

    return _jsx('section', {
        className: 'hp-weatherbysOverview__container'
    }, void 0, _jsx('iframe', {
        className: 'hp-weatherbysOverview__mainFrame',
        src: mainFrameUrl,
        scrolling: 'no'
    }), _jsx('div', {
        className: 'hp-weatherbysOverview__bannerContainer'
    }, void 0, _jsx('img', {
        src: logoUrl,
        alt: 'weatherbys'
    }), _jsx('img', {
        className: 'hp-weatherbysOverview__banner',
        src: bannerFrameUrl,
        alt: 'weatherbys fee banner for ' + horseName
    })));
};

exports.default = WeatherbysOverview;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodsFactory = undefined;

var _filter = __webpack_require__(66);

var raceTypeFactory = function raceTypeFactory(country, type) {
    return {
        title: 'race type',
        options: _filter.selection.setSelected(_filter.raceTypes.human, country + '/' + type)
    };
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(country, raceType) {
    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(raceType, country);
    var options = _filter.timePeriods.getPeriods(currentYear, 1987, raceType).map(_filter.timePeriods.removeEndYear);

    return {
        title: 'time period',
        options: _filter.selection.setSelected(options, options[0].value),
        createdBy: { raceType: raceType }
    };
};

var categoriesFactory = function categoriesFactory(country, type) {
    return country && type ? {
        raceType: raceTypeFactory(country, type),
        timePeriod: timePeriodsFactory(country, type)
    } : null;
};

exports.default = categoriesFactory;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.statusFactory = exports.categoriesFactory = exports.raceTypeFactory = undefined;
exports.displayByFactory = displayByFactory;
exports.timePeriodFactory = timePeriodFactory;
exports.advancedFactory = advancedFactory;

var _lodash = __webpack_require__(6);

var _filter = __webpack_require__(66);

var _date = __webpack_require__(19);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var trainerOption = {
    label: 'Trainer',
    value: 'trainer'
};

var jockeyOption = {
    label: 'Jockey',
    value: 'jockey'
};

var getGenericDisplayBy = function getGenericDisplayBy(humanType) {
    return (0, _lodash.compact)([{
        label: 'Course',
        value: 'course'
    }, {
        label: 'Distance',
        value: 'distance'
    }, humanType === 'jockey' ? trainerOption : jockeyOption, {
        label: 'Month',
        value: 'month'
    }, {
        label: 'Race Class (Handicap, Selling..)',
        value: 'race-type'
    }, humanType === 'owner' && trainerOption]);
};

function displayByFactory(country, type, humanType) {
    var selectedValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var options = [];
    var genericDisplayByOptions = getGenericDisplayBy(humanType);

    if (type === 'flat') {
        var year = {
            label: 'Year',
            value: 'year'
        };
        var age = {
            label: 'Age of horse',
            value: 'age-of-horse'
        };
        options = [age].concat(_toConsumableArray(genericDisplayByOptions), [year]);
    } else {
        var raceTypeOption = {
            label: 'Race Type (NHF, Hurdle, Chase)',
            value: 'race-category'
        };
        var season = {
            label: 'Season (' + (country === 'GB' ? 'April' : 'May') + ' - April)',
            value: 'season'
        };

        options = [].concat(_toConsumableArray(genericDisplayByOptions), [raceTypeOption, season]);
    }

    options.find(function (_ref) {
        var value = _ref.value;
        return value === selectedValue || value === 'year' || value === 'season';
    }).selected = true;

    return {
        options: options,
        title: 'display by',
        createdBy: {
            raceType: type,
            humanType: humanType
        }
    };
}

function timePeriodFactory(country, type, seasonsAvailable) {
    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(type, country);
    var beginYear = seasonsAvailable[type] ? (0, _date.getYearFromUtc)(seasonsAvailable[type][country]) : currentYear;

    var options = [_filter.timePeriods.getAll(beginYear, currentYear), _filter.timePeriods.getCurrent(currentYear, type), _filter.timePeriods.getLast5(currentYear, type)].concat(_toConsumableArray(_filter.timePeriods.getPeriods(currentYear - 1, currentYear - 6, type)));

    options[0].selected = true;

    return {
        options: options,
        title: 'time period',
        createdBy: {
            raceType: type
        },
        seasonsAvailable: seasonsAvailable
    };
}

function getAdvancedOptions(type) {
    if (type === 'flat') {
        return [{
            label: '2yo',
            value: '2yo'
        }, {
            label: '3yo',
            value: '3yo'
        }, {
            label: '4yo+',
            value: '4yo+'
        }];
    }

    return [{
        label: 'Hurdles',
        value: 'hurdle'
    }, {
        label: 'Chases',
        value: 'chase'
    }, {
        label: 'National Hunt Flat',
        value: 'nhf'
    }];
}

function advancedFactory(country, type) {
    var displayBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var humanType = arguments[3];

    var noFilter = {
        value: 'overall',
        label: 'No filter',
        selected: true
    };
    var options = [noFilter];

    if (getGenericDisplayBy(humanType).some(function (o) {
        return o.value === displayBy;
    })) {
        options = [noFilter].concat(_toConsumableArray(getAdvancedOptions(type)));
    }

    return {
        options: options,
        title: 'advanced filter (' + (type === 'jumps' ? 'by code' : 'by age') + ')',
        createdBy: {
            raceType: type
        }
    };
}

var raceTypeFactory = exports.raceTypeFactory = function raceTypeFactory(country, type) {
    return {
        title: 'race type',
        options: _filter.selection.setSelected(_filter.raceTypes.human, country + '/' + type)
    };
};

var categoriesFactory = exports.categoriesFactory = function categoriesFactory(country, type, humanType, seasonsAvailable) {
    var raceType = raceTypeFactory(country, type);
    var displayBy = displayByFactory(country, type, humanType);
    var timePeriod = timePeriodFactory(country, type, seasonsAvailable);
    var advanced = advancedFactory(country, type);
    return { raceType: raceType, displayBy: displayBy, timePeriod: timePeriod, advanced: advanced };
};

function getAdvancedStatus(categories) {
    var selectedValue = _filter.selection.getValue(categories, 'advanced');
    if (selectedValue !== 'overall') {
        return _filter.selection.getCaption(categories, 'advanced');
    }

    return null;
}

function getTimePeriodStatus(categories) {
    var option = _filter.selection.getOption(categories, 'timePeriod');
    var years = (0, _lodash.uniq)(option.value.split('/').slice(0, 2));

    if (option.value.match(/last5/)) {
        return (0, _lodash.toLower)(option.label);
    }
    if (option.value.match(/all/)) {
        return years.join(' - ');
    }
    if (years.length > 1) {
        years[1] = years[1].slice(2);
    }
    return years.join('-');
}

var statusFactory = exports.statusFactory = function statusFactory(categories) {
    return {
        raceType: _filter.selection.getCaption(categories, 'raceType'),
        displayBy: _filter.selection.getCaption(categories, 'displayBy'),
        timePeriod: getTimePeriodStatus(categories),
        advanced: getAdvancedStatus(categories)
    };
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cross',
    size: 'Medium'
});

var ErrorModal = function ErrorModal(_ref) {
    var children = _ref.children,
        text = _ref.text,
        onClose = _ref.onClose;
    return _jsx('div', {
        className: 'pp-errorModal__overlay'
    }, void 0, _jsx('div', {
        className: 'pp-errorModal__container'
    }, void 0, _jsx('div', {
        className: 'pp-errorModal__header'
    }, void 0, _jsx('button', {
        className: 'ui-btn',
        onClick: onClose
    }, void 0, _ref2)), _jsx('div', {
        className: 'pp-errorModal__content'
    }, void 0, children || text), _jsx('button', {
        className: 'pp-errorModal__button ui-btn ui-btn_major',
        onClick: onClose
    }, void 0, 'Ok')));
};

exports.default = ErrorModal;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultSilkImg = '/pdfs/missing-silk-40x29.133.0.png';

var Image = function (_PureComponent) {
    _inherits(Image, _PureComponent);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

        _this.onError = function () {
            _this.setState({ src: '' + _this.props.imgHost + defaultSilkImg });
        };

        _this.state = { src: props.src };
        return _this;
    }

    _createClass(Image, [{
        key: 'render',
        value: function render() {
            return _jsx('img', {
                className: this.props.imgClass,
                src: this.state.src,
                alt: this.props.alt,
                onError: this.onError
            });
        }
    }]);

    return Image;
}(_react.PureComponent);

exports.default = Image;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Formats a ratio cell, e.g.: a/b
 * @param {number} a - Divident.
 * @param {number} b - Divisor.
 */
var _ref2 = _jsx('span', {}, void 0, _rpReactTable.EMPTINESS_SIGN);

var _ref3 = _jsx('wbr', {});

var RatioCell = function RatioCell(_ref) {
    var a = _ref.a,
        b = _ref.b;
    return a === 0 && b === 0 ? _ref2 : _jsx('span', {}, void 0, _jsx('strong', {}, void 0, a), '/', _ref3, b);
};

exports.default = RatioCell;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntriesList = __webpack_require__(575);

var _EntriesList2 = _interopRequireDefault(_EntriesList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Entries = function Entries(props) {
    var type = props.params.type,
        data = props.data;

    var isJockey = type === 'jockey';
    var isHorseShown = type !== 'horse';
    var entries = (isJockey ? data.bookedRides : data.entries) || [];
    var title = isJockey ? 'booked rides' : 'entries';
    var horseName = isHorseShown ? null : data.profile.horseName;

    return _jsx('section', {}, void 0, _jsx(_EntriesList2.default, {
        entries: entries,
        horseName: horseName,
        noDataText: 'No ' + title + ' for this ' + type,
        isHorseShown: isHorseShown,
        isPriceShown: true,
        isDamShown: false
    }));
};

var entriesTypes = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    courseStyleName: _propTypes2.default.string,
    courseUid: _propTypes2.default.number,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    raceDatetime: _propTypes2.default.string,
    raceInstanceTitle: _propTypes2.default.string,
    raceInstanceUid: _propTypes2.default.number,
    raceStatusCode: _propTypes2.default.string,
    raceUid: _propTypes2.default.number
}));

exports.default = Entries;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpReactTable = __webpack_require__(22);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _EntriesRow = __webpack_require__(1178);

var _EntriesRow2 = _interopRequireDefault(_EntriesRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var itemsPerPage = 20;

var EntriesList = function (_PureComponent) {
    _inherits(EntriesList, _PureComponent);

    function EntriesList(props) {
        _classCallCheck(this, EntriesList);

        var _this = _possibleConstructorReturn(this, (EntriesList.__proto__ || Object.getPrototypeOf(EntriesList)).call(this, props));

        _this.updatePrices = function () {
            (0, _jquery2.default)(document).trigger('dynamicPricesUpdated.PRICES');
        };

        _this.showMore = function () {
            _this.setState(function (state) {
                return { shownItems: state.shownItems + itemsPerPage };
            });
        };

        _this.state = { shownItems: itemsPerPage };
        return _this;
    }

    _createClass(EntriesList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updatePrices();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var entries = _ref.entries;

            if (entries !== this.props.entries) {
                this.setState({ shownItems: itemsPerPage });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.updatePrices();
        }
    }, {
        key: 'render',
        value: function render() {
            var shownItems = this.state.shownItems;
            var _props = this.props,
                entries = _props.entries,
                isDamShown = _props.isDamShown,
                isHorseShown = _props.isHorseShown,
                noDataText = _props.noDataText,
                horseName = _props.horseName,
                isPriceShown = _props.isPriceShown;


            return _jsx('section', {
                className: 'pp-entries'
            }, void 0, _jsx('h2', {
                className: 'pp-entries__header'
            }, void 0, 'Date / ', isHorseShown && 'Horse / ', isDamShown && 'Dam / ', 'Race'), entries.length ? _jsx('ul', {
                className: (0, _classnames2.default)({ 'js-diffusionTopicSettingsRace': isPriceShown })
            }, void 0, entries.slice(0, shownItems).map(function (row) {
                return _jsx(_EntriesRow2.default, {
                    data: _extends({ horseName: horseName }, row),
                    isDamShown: isDamShown,
                    isHorseShown: isHorseShown,
                    isPriceShown: isPriceShown
                }, '' + row.horseUid + row.raceInstanceUid);
            })) : _jsx(_rpReactTable.NoData, {
                text: noDataText
            }), shownItems < entries.length && _jsx(_rpReactTable.ShowMore, {
                onClick: this.showMore
            }));
        }
    }]);

    return EntriesList;
}(_react.PureComponent);

exports.default = EntriesList;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'videoHollow',
    className: 'ui-icon tableShowIcon',
    size: 'Medium'
});

var ReplayLink = function ReplayLink(props) {
    return _react2.default.createElement(
        _ResultLink2.default,
        _extends({}, props, {
            urlHash: 'fullReplay-profiles',
            className: 'hp-formTable__videoIcon'
        }),
        _ref
    );
};

exports.default = ReplayLink;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var SalesHorseLink = function SalesHorseLink(_ref) {
    var children = _ref.children,
        venueUid = _ref.venueUid,
        saleDate = _ref.saleDate,
        lotNo = _ref.lotNo,
        lotLetter = _ref.lotLetter;

    if (!venueUid || !saleDate || !lotNo) {
        return null;
    }

    var date = (0, _date.formatDate)(saleDate, 'Y-MM-DD');
    var url = '/bloodstock/sales/catalogues/' + venueUid + '/' + date + '?lot=' + lotNo + '&letter=' + (lotLetter || ' ');

    return _jsx('a', {
        className: 'ui-link ui-link_table js-popupLink js-navigate-url',
        href: url
    }, void 0, children || (0, _date.formatDate)(saleDate, 'DDMMMYY'), _ref2);
};

exports.default = SalesHorseLink;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabNames = __webpack_require__(256);

var calculateTabUrl = function calculateTabUrl(currentTab, tabName, index, isSire, isMyRatingShown) {
    // when current tab is missing (we are on the index tab)
    // tab with index = 0 would be active
    if (!currentTab && !index) {
        return '';
    }
    if (tabName === 'form' && isMyRatingShown) {
        return tabName + '/my-ratings';
    }
    if (!isSire) {
        return tabName;
    }

    // if we are on sire profiles there are subtabs
    // and sometimes title of tab is different from url
    var subTabs = _tabNames.sireSubTabs[tabName];
    if (subTabs) {
        return subTabs.includes(currentTab) ? currentTab : subTabs[0];
    }
    return tabName;
};

exports.default = calculateTabUrl;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */

var _ref = _jsx("div", {
    className: "js-PC-runnerBestOddsContainer"
}, void 0, _jsx("div", {
    className: "PC-bestOddsContainer js-bestOddsContainer"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__shadow js-PC-bestOdds__shadow"
}), _jsx("div", {
    className: "PC-bestOdds js-PC-bestOdds"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__arrow js-PC-bestOdds__arrow"
}), _jsx("div", {
    className: "PC-bestOdds__horseName js-bestOddsHorseName"
}), _jsx("div", {
    className: "PC-bestOdds__headers"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__headers__field\n                        PC-bestOdds__headers__field_bookmaker"
}, void 0, "Bookmaker"), _jsx("div", {
    className: "PC-bestOdds__headers__field\n                        PC-bestOdds__headers__field_price"
}, void 0, "Price"), _jsx("div", {
    className: "PC-bestOdds__headers__field\n                        PC-bestOdds__headers__field_terms"
}, void 0, "E.W. Terms")), _jsx("div", {
    className: "PC-bestOdds__bookiesList PC-bestOdds__bookiesList_betslip"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "BET365",
    "data-diffusion-bookieName": "bet365"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, _jsx("div", {}, void 0, "bet365"), _jsx("a", {
    href: "https://members.bet365.com/Members/OpenAccount/?affiliate=365_386841&prdid=1&ibpid=2200&lng=1&rUrl=www%2Eracingpost%2Ecom&oty=1&ver=2",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "PC-bestOdds__bookieRow__name_account"
}, void 0, "Open Account")), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_bet365 js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "LADB",
    "data-diffusion-bookieName": "ladbrokes"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, _jsx("div", {}, void 0, "Ladbrokes"), _jsx("a", {
    href: "http://online.ladbrokes.com/promoRedirect?key=ej0xMzc3MTI2OSZsPS0xJnA9NjgwNDk4",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "PC-bestOdds__bookieRow__name_account"
}, void 0, "Open Account")), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_ladbrokes js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "PPWR",
    "data-diffusion-bookieName": "paddypower"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, "Paddy Power"), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_paddypower js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "BETFAIR",
    "data-diffusion-bookieName": "betfair"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, "Betfair"), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_betfair js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "WH_OXI",
    "data-diffusion-bookieName": "williamHill"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, _jsx("div", {}, void 0, "William Hill"), _jsx("a", {
    href: "http://ads2.williamhill.com/redirect.aspx?pid=185759757&lpid=1487411833&bid=1487411716",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "PC-bestOdds__bookieRow__name_account"
}, void 0, "Open Account")), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_williamHill js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "CORAL",
    "data-diffusion-bookieName": "coral"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, _jsx("div", {}, void 0, "Coral"), _jsx("a", {
    href: "http://affiliate.coral.co.uk/processing/clickthrgh.asp?btag=a_2757b_6528",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "PC-bestOdds__bookieRow__name_account"
}, void 0, "Open Account")), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_coral js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "SURREY",
    "data-diffusion-bookieName": "skybet"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, _jsx("div", {}, void 0, "Sky Bet"), _jsx("a", {
    href: "https://m.skybet.com/",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "PC-bestOdds__bookieRow__name_account"
}, void 0, "Open Account")), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_skybet js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog"
}))), _jsx("div", {
    className: "PC-bestOdds__bookiesList"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "SPORTING INDEX",
    "data-diffusion-bookieName": "sportingBet"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, "Sporting"), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_sportingBet js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "VC",
    "data-diffusion-bookieName": "betVictor"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, "BetVictor"), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_betVictor js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "BOLEYSPORTS",
    "data-diffusion-bookieName": "boylesport"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, "Boylesport"), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_boylesport js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow js-diffusionBestOdds",
    "data-diffusion-horsename": "",
    "data-diffusion-bookmaker": "888",
    "data-diffusion-bookieName": "888sport"
}, void 0, _jsx("div", {
    className: "PC-bestOdds__bookieRow__name"
}, void 0, "888sport"), _jsx("div", {
    className: "PC-bestOdds__bookieRow__price"
}, void 0, _jsx("div", {
    className: "ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_888sport js-betHandler\n                                js-PC-bestOdds__priceBtn"
})), _jsx("div", {
    className: "PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
}), _jsx("div", {
    className: "PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
}))))));

var BestOdds = function BestOdds() {
    return _ref;
};

/* eslint-enable */

exports.default = BestOdds;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceButton = function PriceButton(_ref) {
    var diffusionCourseName = _ref.diffusionCourseName,
        horseName = _ref.horseName,
        raceDatetime = _ref.raceDatetime,
        raceInstanceUid = _ref.raceInstanceUid;
    return _jsx('div', {
        className: 'js-PC-runnerRow hp-price-button__wrapper'
    }, void 0, _jsx('div', {
        className: 'js-diffusionHorsesList js-bestOddsPriceContainer js-horsesList',
        'data-card-race-date-time': raceDatetime,
        'data-diffusion-horsename': horseName,
        'data-diffusion-race-id': raceInstanceUid,
        'data-diffusion-racedate': (0, _date.formatDate)(raceDatetime, 'YYYY-MM-DD'),
        'data-diffusion-coursename': diffusionCourseName,
        'data-diffusion-racetime': (0, _date.formatDate)(raceDatetime, 'HH:mm')
    }, void 0, _jsx('div', {
        className: 'ui-priceBtn_noPrice ui-btn js-diffusionPriceValue\n                    js-betHandler js-runnerPrice js-runnerPriceBestOdds'
    })), _jsx('div', {
        className: 'js-bestOddsRunnerHorseName hide'
    }, void 0, horseName));
};

exports.default = PriceButton;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var gngSequence = ['Frozen', 'Hard', 'Firm', 'Fast', 'Good To Firm', 'Standard To Fast', 'Good', 'Standard', 'Good To Yielding', 'Good To Soft', 'Standard To Slow', 'Yielding', 'Yielding To Soft', 'Muddy', 'Soft', 'Slow', 'Sloppy', 'Very Soft', 'Soft To Heavy', 'Heavy'];

var gngCodeSequence = ['FZ', 'HD', 'F', 'FT', 'GF', 'SF', 'G', 'SD', 'GY', 'GS', 'SS', 'Y', 'YS', 'MY', 'S', 'SW', 'SY', 'VS', 'SH', 'HY'];

var goingSortFn = exports.goingSortFn = function goingSortFn(a, b) {
    return gngSequence.indexOf(a.going) - gngSequence.indexOf(b.going);
};

var goingCodeSortFn = exports.goingCodeSortFn = function goingCodeSortFn(a, b) {
    return gngCodeSequence.indexOf(a.goingTypeCode) - gngCodeSequence.indexOf(b.goingTypeCode);
};

/***/ }),
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1247), __esModule: true };

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1212);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1211);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(603);
var hiddenKeys = __webpack_require__(366).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(213)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(145)
var setISOYear = __webpack_require__(684)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(213)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(281)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(213)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(281)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(145)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var differenceInCalendarDays = __webpack_require__(282)
var compareAsc = __webpack_require__(214)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(407)
var parse = __webpack_require__(3)
var differenceInSeconds = __webpack_require__(409)
var differenceInMonths = __webpack_require__(408)
var enLocale = __webpack_require__(415)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfYear = __webpack_require__(690)
var differenceInCalendarDays = __webpack_require__(282)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(686)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(414)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(215)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(687)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(688)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(689)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(413)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var startOfISOYear = __webpack_require__(215)
var differenceInCalendarDays = __webpack_require__(282)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var getDaysInMonth = __webpack_require__(411)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(658)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(536);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(1739));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1950);


/***/ }),
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var isIE = isBrowser ? !!document.documentElement.currentStyle : false;
var hiddenTextarea = isBrowser && document.createElement('textarea');
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null || maxRows !== null) {
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      height = Math.min(maxHeight, height);
    }
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths

  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  return delete computedStyleCache[uid];
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

/**
 * <TextareaAutosize />
 */
var noop = function noop() {}; // IE11 has a problem with eval source maps, can be reproduced with:
// eval('"use strict"; var onNextFrame = window.cancelAnimationFrame; onNextFrame(4);')
// so we bind window as context in dev modes


var _ref = isBrowser && window.requestAnimationFrame ?  true ? [window.requestAnimationFrame, window.cancelAnimationFrame] : [window.requestAnimationFrame.bind(window), window.cancelAnimationFrame.bind(window)] : [setTimeout, clearTimeout];
var onNextFrame = _ref[0];
var clearNextFrameAction = _ref[1];

var TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._resizeLock = false;

    _this._onRootDOMNode = function (node) {
      _this._rootDOMNode = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      }
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event);
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      if (typeof _this._rootDOMNode === 'undefined') {
        callback();
        return;
      }

      var nodeHeight = calculateNodeHeight(_this._rootDOMNode, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount;
      _this.rowCount = rowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid();
    _this._controlled = typeof props.value === 'string';
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _props = this.props,
        _minRows = _props.minRows,
        _maxRows = _props.maxRows,
        _onHeightChange = _props.onHeightChange,
        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
        _inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ["minRows", "maxRows", "onHeightChange", "useCacheForDOMMeasurements", "inputRef"]);
    props.style = _extends({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", _extends({}, props, {
      onChange: this._onChange,
      ref: this._onRootDOMNode
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        return _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    var _this3 = this;

    this._clearNextFrame();

    this._onNextFrameActionId = onNextFrame(function () {
      return _this3._resizeComponent();
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearNextFrame();

    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  _proto._clearNextFrame = function _clearNextFrame() {
    clearNextFrameAction(this._onNextFrameActionId);
  };

  return TextareaAutosize;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextareaAutosize.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHeightChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useCacheForDOMMeasurements: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  minRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maxRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
TextareaAutosize.defaultProps = {
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};

/* harmony default export */ __webpack_exports__["default"] = (TextareaAutosize);


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _Component);

  function ArrowKeyStepper(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call(this, props, context));

    _this.state = {
      scrollToColumn: props.scrollToColumn,
      scrollToRow: props.scrollToRow
    };

    _this._columnStartIndex = 0;
    _this._columnStopIndex = 0;
    _this._rowStartIndex = 0;
    _this._rowStopIndex = 0;

    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var scrollToColumn = nextProps.scrollToColumn;
      var scrollToRow = nextProps.scrollToRow;


      if (this.props.scrollToColumn !== scrollToColumn) {
        this.setState({ scrollToColumn: scrollToColumn });
      }

      if (this.props.scrollToRow !== scrollToRow) {
        this.setState({ scrollToRow: scrollToRow });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var className = _props.className;
      var children = _props.children;
      var _state = this.state;
      var scrollToColumn = _state.scrollToColumn;
      var scrollToRow = _state.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: className,
          onKeyDown: this._onKeyDown
        },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(event) {
      var _props2 = this.props;
      var columnCount = _props2.columnCount;
      var disabled = _props2.disabled;
      var mode = _props2.mode;
      var rowCount = _props2.rowCount;


      if (disabled) {
        return;
      }

      var _state2 = this.state;
      var scrollToColumnPrevious = _state2.scrollToColumn;
      var scrollToRowPrevious = _state2.scrollToRow;
      var _state3 = this.state;
      var scrollToColumn = _state3.scrollToColumn;
      var scrollToRow = _state3.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.

      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref) {
      var columnStartIndex = _ref.columnStartIndex;
      var columnStopIndex = _ref.columnStopIndex;
      var rowStartIndex = _ref.rowStartIndex;
      var rowStopIndex = _ref.rowStopIndex;

      this._columnStartIndex = columnStartIndex;
      this._columnStopIndex = columnStopIndex;
      this._rowStartIndex = rowStartIndex;
      this._rowStopIndex = rowStopIndex;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
/* harmony default export */ __webpack_exports__["a"] = (ArrowKeyStepper);
 false ? ArrowKeyStepper.propTypes = {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']),
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(2118);









/**
 * Decorator component that automatically adjusts the width and height of a single child.
 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
 * All other properties will be passed through to the child component.
 */

var AutoSizer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AutoSizer, _Component);

  function AutoSizer(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call(this, props));

    _this.state = {
      height: 0,
      width: 0
    };

    _this._onResize = _this._onResize.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Delay access of parentNode until mount.
      // This handles edge-cases where the component has already been unmounted before its ref has been set,
      // As well as libraries like react-lite which have a slightly different lifecycle.
      this._parentNode = this._autoSizer.parentNode;

      // Defer requiring resize handler in order to support server-side rendering.
      // See issue #41
      this._detectElementResize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])();
      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

      this._onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var disableHeight = _props.disableHeight;
      var disableWidth = _props.disableWidth;
      var _state = this.state;
      var height = _state.height;
      var width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };

      if (!disableHeight) {
        outerStyle.height = 0;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          ref: this._setRef,
          style: outerStyle
        },
        children({ height: height, width: width })
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var onResize = this.props.onResize;

      // Gaurd against AutoSizer component being removed from the DOM immediately after being added.
      // This can result in invalid style values which can result in NaN values if we don't handle them.
      // See issue #150 for more context.

      var boundingRect = this._parentNode.getBoundingClientRect();
      var height = boundingRect.height || 0;
      var width = boundingRect.width || 0;

      var style = window.getComputedStyle(this._parentNode) || {};
      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
      var paddingRight = parseInt(style.paddingRight, 10) || 0;
      var paddingTop = parseInt(style.paddingTop, 10) || 0;
      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;

      this.setState({
        height: height - paddingTop - paddingBottom,
        width: width - paddingLeft - paddingRight
      });

      onResize({ height: height, width: width });
    }
  }, {
    key: '_setRef',
    value: function _setRef(autoSizer) {
      this._autoSizer = autoSizer;
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {}
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);
 false ? AutoSizer.propTypes = {
  /**
  * Function responsible for rendering children.
  * This function should implement the following signature:
  * ({ height, width }) => PropTypes.element
  */
  children: PropTypes.func.isRequired,

  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool,

  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool,

  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellSizeCache__ = __webpack_require__(512);










/**
 * Measures a Grid cell's contents by rendering them in a way that is not visible to the user.
 * Either a fixed width or height may be provided if it is desirable to measure only in one direction.
 */

var CellMeasurer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _Component);

  function CellMeasurer(props, state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call(this, props, state));

    _this._cellSizeCache = props.cellSizeCache || new __WEBPACK_IMPORTED_MODULE_8__defaultCellSizeCache__["a" /* default */]();

    _this.getColumnWidth = _this.getColumnWidth.bind(_this);
    _this.getRowHeight = _this.getRowHeight.bind(_this);
    _this.resetMeasurements = _this.resetMeasurements.bind(_this);
    _this.resetMeasurementForColumn = _this.resetMeasurementForColumn.bind(_this);
    _this.resetMeasurementForRow = _this.resetMeasurementForRow.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'getColumnWidth',
    value: function getColumnWidth(_ref) {
      var index = _ref.index;

      var columnWidth = this._cellSizeCache.getColumnWidth(index);
      if (columnWidth != null) {
        return columnWidth;
      }

      var rowCount = this.props.rowCount;


      var maxWidth = 0;

      for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        var _measureCell2 = this._measureCell({
          clientWidth: true,
          columnIndex: index,
          rowIndex: rowIndex
        });

        var width = _measureCell2.width;


        maxWidth = Math.max(maxWidth, width);
      }

      this._cellSizeCache.setColumnWidth(index, maxWidth);

      return maxWidth;
    }
  }, {
    key: 'getRowHeight',
    value: function getRowHeight(_ref2) {
      var index = _ref2.index;

      var rowHeight = this._cellSizeCache.getRowHeight(index);
      if (rowHeight != null) {
        return rowHeight;
      }

      var columnCount = this.props.columnCount;


      var maxHeight = 0;

      for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
        var _measureCell3 = this._measureCell({
          clientHeight: true,
          columnIndex: columnIndex,
          rowIndex: index
        });

        var height = _measureCell3.height;


        maxHeight = Math.max(maxHeight, height);
      }

      this._cellSizeCache.setRowHeight(index, maxHeight);

      return maxHeight;
    }
  }, {
    key: 'resetMeasurementForColumn',
    value: function resetMeasurementForColumn(columnIndex) {
      this._cellSizeCache.clearColumnWidth(columnIndex);
    }
  }, {
    key: 'resetMeasurementForRow',
    value: function resetMeasurementForRow(rowIndex) {
      this._cellSizeCache.clearRowHeight(rowIndex);
    }
  }, {
    key: 'resetMeasurements',
    value: function resetMeasurements() {
      this._cellSizeCache.clearAllColumnWidths();
      this._cellSizeCache.clearAllRowHeights();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._renderAndMount();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cellSizeCache = this.props.cellSizeCache;


      if (cellSizeCache !== nextProps.cellSizeCache) {
        this._cellSizeCache = nextProps.cellSizeCache;
      }

      this._updateDivDimensions(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unmountContainer();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        getColumnWidth: this.getColumnWidth,
        getRowHeight: this.getRowHeight,
        resetMeasurements: this.resetMeasurements,
        resetMeasurementForColumn: this.resetMeasurementForColumn,
        resetMeasurementForRow: this.resetMeasurementForRow
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_getContainerNode',
    value: function _getContainerNode(props) {
      var container = props.container;


      if (container) {
        return __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(typeof container === 'function' ? container() : container);
      } else {
        return document.body;
      }
    }
  }, {
    key: '_measureCell',
    value: function _measureCell(_ref3) {
      var _ref3$clientHeight = _ref3.clientHeight;
      var clientHeight = _ref3$clientHeight === undefined ? false : _ref3$clientHeight;
      var _ref3$clientWidth = _ref3.clientWidth;
      var clientWidth = _ref3$clientWidth === undefined ? true : _ref3$clientWidth;
      var columnIndex = _ref3.columnIndex;
      var rowIndex = _ref3.rowIndex;
      var cellRenderer = this.props.cellRenderer;


      var rendered = cellRenderer({
        columnIndex: columnIndex,
        index: rowIndex, // Simplify List :rowRenderer use case
        rowIndex: rowIndex
      });

      // Handle edge case where this method is called before the CellMeasurer has completed its initial render (and mounted).
      this._renderAndMount();

      // @TODO Keep an eye on this for future React updates as the interface may change:
      // https://twitter.com/soprano/status/737316379712331776
      __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, rendered, this._div);

      var measurements = {
        height: clientHeight && this._div.clientHeight,
        width: clientWidth && this._div.clientWidth
      };

      __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.unmountComponentAtNode(this._div);

      return measurements;
    }
  }, {
    key: '_renderAndMount',
    value: function _renderAndMount() {
      if (!this._div) {
        this._div = document.createElement('div');
        this._div.style.display = 'inline-block';
        this._div.style.position = 'absolute';
        this._div.style.visibility = 'hidden';
        this._div.style.zIndex = -1;

        this._updateDivDimensions(this.props);

        this._containerNode = this._getContainerNode(this.props);
        this._containerNode.appendChild(this._div);
      }
    }
  }, {
    key: '_unmountContainer',
    value: function _unmountContainer() {
      if (this._div) {
        this._containerNode.removeChild(this._div);

        this._div = null;
      }

      this._containerNode = null;
    }
  }, {
    key: '_updateDivDimensions',
    value: function _updateDivDimensions(props) {
      var height = props.height;
      var width = props.width;


      if (height && height !== this._divHeight) {
        this._divHeight = height;
        this._div.style.height = height + 'px';
      }

      if (width && width !== this._divWidth) {
        this._divWidth = width;
        this._div.style.width = width + 'px';
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
 false ? CellMeasurer.propTypes = {
  /**
   * Renders a cell given its indices.
   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Optional, custom caching strategy for cell sizes.
   */
  cellSizeCache: PropTypes.object,

  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ getColumnWidth, getRowHeight, resetMeasurements }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,

  /**
   * Number of columns in grid.
   */
  columnCount: PropTypes.number.isRequired,

  /**
   * A Node, Component instance, or function that returns either.
   * If this property is not specified the document body will be used.
   */
  container: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.node]),

  /**
   * Assign a fixed :height in order to measure dynamic text :width only.
   */
  height: PropTypes.number,

  /**
   * Number of rows in grid.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Assign a fixed :width in order to measure dynamic text :height only.
   */
  width: PropTypes.number
} : void 0;

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CollectionView__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionData__ = __webpack_require__(2102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getUpdatedOffsetForIndex__ = __webpack_require__(2117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _Component);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    return _this;
  }

  /** See Collection#recomputeCellSizesAndPositions */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: function ref(_ref) {
          _this2._collectionView = _ref;
        }
      }, props));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props;
      var cellCount = _props.cellCount;
      var cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter;
      var sectionSize = _props.sectionSize;


      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref2) {
      var align = _ref2.align;
      var cellIndex = _ref2.cellIndex;
      var height = _ref2.height;
      var scrollLeft = _ref2.scrollLeft;
      var scrollTop = _ref2.scrollTop;
      var width = _ref2.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref3) {
      var _this3 = this;

      var height = _ref3.height;
      var isScrolling = _ref3.isScrolling;
      var width = _ref3.width;
      var x = _ref3.x;
      var y = _ref3.y;
      var _props2 = this.props;
      var cellGroupRenderer = _props2.cellGroupRenderer;
      var cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref4) {
          var index = _ref4.index;
          return _this3._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
 false ? Collection.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : void 0;


function defaultCellGroupRenderer(_ref5) {
  var cellCache = _ref5.cellCache;
  var cellRenderer = _ref5.cellRenderer;
  var cellSizeAndPositionGetter = _ref5.cellSizeAndPositionGetter;
  var indices = _ref5.indices;
  var isScrolling = _ref5.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _Component);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props;
      var columnMaxWidth = _props.columnMaxWidth;
      var columnMinWidth = _props.columnMinWidth;
      var columnCount = _props.columnCount;
      var width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var children = _props2.children;
      var columnMaxWidth = _props2.columnMaxWidth;
      var columnMinWidth = _props2.columnMinWidth;
      var columnCount = _props2.columnCount;
      var width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
 false ? ColumnSizer.propTypes = {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(2105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__ = __webpack_require__(2107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__ = __webpack_require__(2108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultCellRangeRenderer__ = __webpack_require__(892);

















/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */

var Grid = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Grid, _Component);

  function Grid(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props, context));

    _this.state = {
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0
    };

    // Invokes onSectionRendered callback only when start/stop row or column indices change
    _this._onGridRenderedMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    // Bind functions to instance so they don't lose context when passed around
    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._updateScrollLeftForScrollToColumn = _this._updateScrollLeftForScrollToColumn.bind(_this);
    _this._updateScrollTopForScrollToRow = _this._updateScrollTopForScrollToRow.bind(_this);

    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);

    _this._columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._columnWidthGetter(params);
      },
      estimatedCellSize: _this._getEstimatedColumnSize(props)
    });
    _this._rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._rowHeightGetter(params);
      },
      estimatedCellSize: _this._getEstimatedRowSize(props)
    });

    // See defaultCellRangeRenderer() for more information on the usage of these caches
    _this._cellCache = {};
    _this._styleCache = {};
    return _this;
  }

  /**
   * Pre-measure all columns and rows in a Grid.
   * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
   * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props = this.props;
      var columnCount = _props.columnCount;
      var rowCount = _props.rowCount;


      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref$columnIndex = _ref.columnIndex;
      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
      var _ref$rowIndex = _ref.rowIndex;
      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._columnSizeAndPositionManager.resetCell(columnIndex);
      this._rowSizeAndPositionManager.resetCell(rowIndex);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._cellCache = {};
      this._styleCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref2) {
      var columnIndex = _ref2.columnIndex;
      var rowIndex = _ref2.rowIndex;

      var props = this.props;
      this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        scrollToColumn: columnIndex
      }));
      this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        scrollToRow: rowIndex
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props;
      var scrollLeft = _props2.scrollLeft;
      var scrollToColumn = _props2.scrollToColumn;
      var scrollTop = _props2.scrollTop;
      var scrollToRow = _props2.scrollToRow;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      if (scrollToColumn >= 0 || scrollToRow >= 0) {
        this._updateScrollLeftForScrollToColumn();
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
      });
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props3 = this.props;
      var autoHeight = _props3.autoHeight;
      var columnCount = _props3.columnCount;
      var height = _props3.height;
      var rowCount = _props3.rowCount;
      var scrollToAlignment = _props3.scrollToAlignment;
      var scrollToColumn = _props3.scrollToColumn;
      var scrollToRow = _props3.scrollToRow;
      var width = _props3.width;
      var _state = this.state;
      var scrollLeft = _state.scrollLeft;
      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
      var scrollTop = _state.scrollTop;

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218

      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        // @TRICKY :autoHeight property instructs Grid to leave :scrollTop management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop since it forces layout/flow.
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__["a" /* default */])({
        cellSizeAndPositionManager: this._columnSizeAndPositionManager,
        previousCellsCount: prevProps.columnCount,
        previousCellSize: prevProps.columnWidth,
        previousScrollToAlignment: prevProps.scrollToAlignment,
        previousScrollToIndex: prevProps.scrollToColumn,
        previousSize: prevProps.width,
        scrollOffset: scrollLeft,
        scrollToAlignment: scrollToAlignment,
        scrollToIndex: scrollToColumn,
        size: width,
        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
          return _this2._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { scrollToColumn: scrollToColumn }));
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__["a" /* default */])({
        cellSizeAndPositionManager: this._rowSizeAndPositionManager,
        previousCellsCount: prevProps.rowCount,
        previousCellSize: prevProps.rowHeight,
        previousScrollToAlignment: prevProps.scrollToAlignment,
        previousScrollToIndex: prevProps.scrollToRow,
        previousSize: prevProps.height,
        scrollOffset: scrollTop,
        scrollToAlignment: scrollToAlignment,
        scrollToIndex: scrollToRow,
        size: height,
        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
          return _this2._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { scrollToRow: scrollToRow }));
        }
      });

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()
      this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize___default()();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }

      this._calculateChildrenToRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var _this3 = this;

      if (nextProps.columnCount === 0 && nextState.scrollLeft !== 0 || nextProps.rowCount === 0 && nextState.scrollTop !== 0) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null) {
          newState.scrollLeft = nextProps.scrollLeft;
        }
        if (nextProps.scrollTop != null) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this._setScrollPosition(newState);
      }

      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
        this._styleCache = {};
      }

      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);

      this._columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
      });
      this._rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: this._getEstimatedRowSize(nextProps)
      });

      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: this.props.columnCount,
        cellSize: this.props.columnWidth,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: nextProps.columnWidth,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: this.props.scrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollLeftForScrollToColumn(nextProps, nextState);
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: this.props.rowCount,
        cellSize: this.props.rowHeight,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: nextProps.rowHeight,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: this.props.scrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollTopForScrollToRow(nextProps, nextState);
        }
      });

      this._calculateChildrenToRender(nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props;
      var autoContainerWidth = _props4.autoContainerWidth;
      var autoHeight = _props4.autoHeight;
      var className = _props4.className;
      var containerStyle = _props4.containerStyle;
      var height = _props4.height;
      var id = _props4.id;
      var noContentRenderer = _props4.noContentRenderer;
      var style = _props4.style;
      var tabIndex = _props4.tabIndex;
      var width = _props4.width;
      var isScrolling = this.state.isScrolling;


      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          ref: function ref(_ref3) {
            _this4._scrollingContainer = _ref3;
          },
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex
        },
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : ''
            }, containerStyle)
          },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer;
      var cellRangeRenderer = props.cellRangeRenderer;
      var columnCount = props.columnCount;
      var height = props.height;
      var overscanColumnCount = props.overscanColumnCount;
      var overscanRowCount = props.overscanRowCount;
      var rowCount = props.rowCount;
      var width = props.width;
      var isScrolling = state.isScrolling;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal;
      var scrollDirectionVertical = state.scrollDirectionVertical;
      var scrollLeft = state.scrollLeft;
      var scrollTop = state.scrollTop;


      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["b" /* default */])({
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: this._renderedColumnStartIndex,
          stopIndex: this._renderedColumnStopIndex
        });

        var overscanRowIndices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["b" /* default */])({
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: this._renderedRowStartIndex,
          stopIndex: this._renderedRowStopIndex
        });

        // Store for _invokeOnGridRenderedHelper()
        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
        this._rowStopIndex = overscanRowIndices.overscanStopIndex;

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
          columnStartIndex: this._columnStartIndex,
          columnStopIndex: this._columnStopIndex,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
          rowStartIndex: this._rowStartIndex,
          rowStopIndex: this._rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_debounceScrollEndedCallback',
    value: function _debounceScrollEndedCallback() {
      this._disablePointerEventsTimeoutId = null;

      var styleCache = this._styleCache;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];
        }
      }

      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_invokeOnGridRenderedHelper',
    value: function _invokeOnGridRenderedHelper() {
      var onSectionRendered = this.props.onSectionRendered;


      this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: this._columnStartIndex,
          columnOverscanStopIndex: this._columnStopIndex,
          columnStartIndex: this._renderedColumnStartIndex,
          columnStopIndex: this._renderedColumnStopIndex,
          rowOverscanStartIndex: this._rowStartIndex,
          rowOverscanStopIndex: this._rowStopIndex,
          rowStartIndex: this._renderedRowStartIndex,
          rowStopIndex: this._renderedRowStopIndex
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref4) {
      var _this5 = this;

      var scrollLeft = _ref4.scrollLeft;
      var scrollTop = _ref4.scrollTop;
      var totalColumnsWidth = _ref4.totalColumnsWidth;
      var totalRowsHeight = _ref4.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref5) {
          var scrollLeft = _ref5.scrollLeft;
          var scrollTop = _ref5.scrollTop;
          var _props5 = _this5.props;
          var height = _props5.height;
          var onScroll = _props5.onScroll;
          var width = _props5.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref6) {
      var scrollLeft = _ref6.scrollLeft;
      var scrollTop = _ref6.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_wrapPropertyGetter',
    value: function _wrapPropertyGetter(value) {
      return value instanceof Function ? value : function () {
        return value;
      };
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(size) {
      return this._wrapPropertyGetter(size);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var columnCount = props.columnCount;
      var scrollToAlignment = props.scrollToAlignment;
      var scrollToColumn = props.scrollToColumn;
      var width = props.width;
      var scrollLeft = state.scrollLeft;


      if (scrollToColumn >= 0 && columnCount > 0) {
        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));

        var calculatedScrollLeft = this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });

        if (scrollLeft !== calculatedScrollLeft) {
          this._setScrollPosition({
            scrollLeft: calculatedScrollLeft
          });
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var height = props.height;
      var rowCount = props.rowCount;
      var scrollToAlignment = props.scrollToAlignment;
      var scrollToRow = props.scrollToRow;
      var scrollTop = state.scrollTop;


      if (scrollToRow >= 0 && rowCount > 0) {
        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));

        var calculatedScrollTop = this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });

        if (scrollTop !== calculatedScrollTop) {
          this._setScrollPosition({
            scrollTop: calculatedScrollTop
          });
        }
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _props6 = this.props;
      var autoHeight = _props6.autoHeight;
      var height = _props6.height;
      var width = _props6.width;

      var scrollbarSize = this._scrollbarSize;
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), event.target.scrollLeft);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), event.target.scrollTop);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        var scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];
        var scrollDirectionVertical = scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_15__defaultCellRangeRenderer__["a" /* default */],
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  overscanColumnCount: 0,
  overscanRowCount: 10,
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  style: {},
  tabIndex: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);
 false ? Grid.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a group of cells given their index ranges.
   * Should implement the following interface: ({
   *   cellCache: Map,
   *   cellRenderer: Function,
   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
   *   columnStartIndex: number,
   *   columnStopIndex: number,
   *   isScrolling: boolean,
   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
   *   rowStartIndex: number,
   *   rowStopIndex: number,
   *   scrollLeft: number,
   *   scrollTop: number
   * }): Array<PropTypes.node>
   */
  cellRangeRenderer: PropTypes.func.isRequired,

  /**
   * Optional custom CSS class name to attach to root Grid element.
   */
  className: PropTypes.string,

  /**
   * Number of columns in grid.
   */
  columnCount: PropTypes.number.isRequired,

  /**
   * Either a fixed column width (number) or a function that returns the width of a column given its index.
   * Should implement the following interface: (index: number): number
   */
  columnWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /**
   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Grid element.
   */
  id: PropTypes.string,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Grid that was just rendered.
   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /**
   * Number of rows in grid.
   */
  rowCount: PropTypes.number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number,

  /** Horizontal offset. */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Column index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToColumn: PropTypes.number,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Row index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToRow: PropTypes.number,

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /**
   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache;
  var cellRenderer = _ref.cellRenderer;
  var columnSizeAndPositionManager = _ref.columnSizeAndPositionManager;
  var columnStartIndex = _ref.columnStartIndex;
  var columnStopIndex = _ref.columnStopIndex;
  var horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment;
  var isScrolling = _ref.isScrolling;
  var rowSizeAndPositionManager = _ref.rowSizeAndPositionManager;
  var rowStartIndex = _ref.rowStartIndex;
  var rowStopIndex = _ref.rowStopIndex;
  var scrollLeft = _ref.scrollLeft;
  var scrollTop = _ref.scrollTop;
  var styleCache = _ref.styleCache;
  var verticalOffsetAdjustment = _ref.verticalOffsetAdjustment;
  var visibleColumnIndices = _ref.visibleColumnIndices;
  var visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];
  var offsetAdjusted = verticalOffsetAdjustment || horizontalOffsetAdjustment;
  var canCacheStyle = !isScrolling || !offsetAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        style = {
          height: rowDatum.size,
          left: columnDatum.offset + horizontalOffsetAdjustment,
          position: 'absolute',
          top: rowDatum.offset + verticalOffsetAdjustment,
          width: columnDatum.size
        };

        styleCache[key] = style;
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__ = __webpack_require__(514);









/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfiniteLoader, _Component);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var _this3 = this;

      var startIndex = _ref.startIndex;
      var stopIndex = _ref.stopIndex;
      var _props = this.props;
      var isRowLoaded = _props.isRowLoaded;
      var minimumBatchSize = _props.minimumBatchSize;
      var rowCount = _props.rowCount;
      var threshold = _props.threshold;


      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
      }, []);

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
 false ? InfiniteLoader.propTypes = {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : void 0;
function isRangeVisible(_ref2) {
  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex;
  var lastRenderedStopIndex = _ref2.lastRenderedStopIndex;
  var startIndex = _ref2.startIndex;
  var stopIndex = _ref2.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref3) {
  var isRowLoaded = _ref3.isRowLoaded;
  var minimumBatchSize = _ref3.minimumBatchSize;
  var rowCount = _ref3.rowCount;
  var startIndex = _ref3.startIndex;
  var stopIndex = _ref3.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Grid__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__);













/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(List, _Component);

  function List(props, context) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, List);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (List.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(List)).call(this, props, context));

    _this._cellRenderer = _this._cellRenderer.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      this.Grid.forceUpdate();
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      this.Grid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.recomputeGridSize({
        rowIndex: index
      });
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var className = _props.className;
      var noRowsRenderer = _props.noRowsRenderer;
      var scrollToIndex = _props.scrollToIndex;
      var width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: function ref(_ref) {
          _this2.Grid = _ref;
        },
        scrollToRow: scrollToIndex
      }));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_cellRenderer',
    value: function _cellRenderer(_ref2) {
      var rowIndex = _ref2.rowIndex;
      var style = _ref2.style;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['rowIndex', 'style']);

      var rowRenderer = this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width');

      var writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        index: rowIndex,
        style: style
      }, rest));
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref3) {
      var clientHeight = _ref3.clientHeight;
      var scrollHeight = _ref3.scrollHeight;
      var scrollTop = _ref3.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex;
      var rowOverscanStopIndex = _ref4.rowOverscanStopIndex;
      var rowStartIndex = _ref4.rowStartIndex;
      var rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

List.defaultProps = {
  estimatedRowSize: 30,
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (List);
 false ? List.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** Optional CSS class name */
  className: PropTypes.string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: PropTypes.func.isRequired,

  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(325);











/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _Component);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _this.state = {
      scrollLeft: 0,
      scrollTop: 0
    };

    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
    return _this;
  }

  /** See Grid#measureAllCells */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See issue #546 */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      console.warn('MultiGrid measureAllRows() is deprecated; use measureAllCells() instead.');

      this.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref$columnIndex = _ref.columnIndex;
      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
      var _ref$rowIndex = _ref.rowIndex;
      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
      var _props = this.props;
      var fixedColumnCount = _props.fixedColumnCount;
      var fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(null, this.props);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._maybeCalculateCachedStyles(null, this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props;
      var columnWidth = _props2.columnWidth;
      var fixedColumnCount = _props2.fixedColumnCount;
      var fixedRowCount = _props2.fixedRowCount;
      var rowHeight = _props2.rowHeight;


      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles(this.props, nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var onScroll = _props3.onScroll;
      var onSectionRendered = _props3.onSectionRendered;
      var scrollLeftProp = _props3.scrollLeft;
      var scrollToColumn = _props3.scrollToColumn;
      var scrollTopProp = _props3.scrollTop;
      var scrollToRow = _props3.scrollToRow;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      // scrollTop and scrollToRow props are explicitly filtered out and ignored

      var _state = this.state;
      var scrollLeft = _state.scrollLeft;
      var scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_bottomLeftGridRef',
    value: function _bottomLeftGridRef(ref) {
      this._bottomLeftGrid = ref;
    }
  }, {
    key: '_bottomRightGridRef',
    value: function _bottomRightGridRef(ref) {
      this._bottomRightGrid = ref;
    }
  }, {
    key: '_cellRendererBottomLeftGrid',
    value: function _cellRendererBottomLeftGrid(_ref2) {
      var rowIndex = _ref2.rowIndex;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['rowIndex']);

      var _props4 = this.props;
      var cellRenderer = _props4.cellRenderer;
      var fixedRowCount = _props4.fixedRowCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  }, {
    key: '_cellRendererBottomRightGrid',
    value: function _cellRendererBottomRightGrid(_ref3) {
      var columnIndex = _ref3.columnIndex;
      var rowIndex = _ref3.rowIndex;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['columnIndex', 'rowIndex']);

      var _props5 = this.props;
      var cellRenderer = _props5.cellRenderer;
      var fixedColumnCount = _props5.fixedColumnCount;
      var fixedRowCount = _props5.fixedRowCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  }, {
    key: '_cellRendererTopRightGrid',
    value: function _cellRendererTopRightGrid(_ref4) {
      var columnIndex = _ref4.columnIndex;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex']);

      var _props6 = this.props;
      var cellRenderer = _props6.cellRenderer;
      var fixedColumnCount = _props6.fixedColumnCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount
      }));
    }
  }, {
    key: '_columnWidthRightGrid',
    value: function _columnWidthRightGrid(_ref5) {
      var index = _ref5.index;
      var _props7 = this.props;
      var fixedColumnCount = _props7.fixedColumnCount;
      var columnWidth = _props7.columnWidth;


      return columnWidth instanceof Function ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount;
      var columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (columnWidth instanceof Function) {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount;
      var rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (rowHeight instanceof Function) {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(prevProps, props) {
      var columnWidth = props.columnWidth;
      var height = props.height;
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var rowHeight = props.rowHeight;
      var style = props.style;
      var styleBottomLeftGrid = props.styleBottomLeftGrid;
      var styleBottomRightGrid = props.styleBottomRightGrid;
      var styleTopLeftGrid = props.styleTopLeftGrid;
      var styleTopRightGrid = props.styleTopRightGrid;
      var width = props.width;


      var firstRender = !prevProps;
      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;

      if (firstRender || sizeChange || style !== prevProps.style) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          width: width
        }, style);
      }

      if (firstRender || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(props),
          overflow: 'hidden',
          position: 'relative',
          width: width
        };
      }

      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          outline: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(props),
          outline: 0,
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          outline: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(props),
          outline: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;
      var scrollTop = scrollInfo.scrollTop;

      this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });
      var onScroll = this.props.onScroll;
      if (onScroll) {
        onScroll(scrollInfo);
      }
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var rowCount = props.rowCount;
      var scrollTop = props.scrollTop;


      if (!fixedColumnCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getBottomGridHeight(props),
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollTop: scrollTop,
        style: this._bottomLeftGridStyle,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount;
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var rowCount = props.rowCount;
      var scrollToColumn = props.scrollToColumn;
      var scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount;
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var scrollLeft = props.scrollLeft;


      if (!fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        height: this._getTopGridHeight(props),
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: this._topRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_rowHeightBottomGrid',
    value: function _rowHeightBottomGrid(_ref6) {
      var index = _ref6.index;
      var _props8 = this.props;
      var fixedRowCount = _props8.fixedRowCount;
      var rowHeight = _props8.rowHeight;


      return rowHeight instanceof Function ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
    }
  }, {
    key: '_topLeftGridRef',
    value: function _topLeftGridRef(ref) {
      this._topLeftGrid = ref;
    }
  }, {
    key: '_topRightGridRef',
    value: function _topRightGridRef(ref) {
      this._topRightGrid = ref;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

MultiGrid.defaultProps = {
  fixedColumnCount: 0,
  fixedRowCount: 0,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {}
};
/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);
 false ? MultiGrid.propTypes = {
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired
} : void 0;

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _Component);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state;
      var clientHeight = _state.clientHeight;
      var clientWidth = _state.clientWidth;
      var scrollHeight = _state.scrollHeight;
      var scrollLeft = _state.scrollLeft;
      var scrollTop = _state.scrollTop;
      var scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight;
      var clientWidth = _ref.clientWidth;
      var scrollHeight = _ref.scrollHeight;
      var scrollLeft = _ref.scrollLeft;
      var scrollTop = _ref.scrollTop;
      var scrollWidth = _ref.scrollWidth;

      this.setState({ clientHeight: clientHeight, clientWidth: clientWidth, scrollHeight: scrollHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
 false ? ScrollSync.propTypes = {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultHeaderRenderer__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultCellRenderer__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellDataGetter__ = __webpack_require__(900);









/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_7__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultCellRenderer__["a" /* default */],
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_5__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
 false ? Column.propTypes = {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute correspnding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: string, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Header label for this column */
  label: PropTypes.string,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortDirection__ = __webpack_require__(513);




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_2__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_2__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      className: classNames,
      width: 18,
      height: 18,
      viewBox: '0 0 24 24'
    },
    sortDirection === __WEBPACK_IMPORTED_MODULE_2__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

 false ? SortIndicator.propTypes = {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : void 0;

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SortDirection__ = __webpack_require__(513);















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _Component);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      this.Grid.forceUpdate();
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      this.Grid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.recomputeGridSize({
        rowIndex: index
      });
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: index
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;
      var disableHeader = _props.disableHeader;
      var gridClassName = _props.gridClassName;
      var gridStyle = _props.gridStyle;
      var headerHeight = _props.headerHeight;
      var height = _props.height;
      var id = _props.id;
      var noRowsRenderer = _props.noRowsRenderer;
      var rowClassName = _props.rowClassName;
      var rowStyle = _props.rowStyle;
      var scrollToIndex = _props.scrollToIndex;
      var style = _props.style;
      var width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = rowClassName instanceof Function ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flexStyles, {
          overflow: 'hidden'
        });
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table', className),
          id: id,
          style: style
        },
        !disableHeader && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerRow', rowClass),
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rowStyleObject, {
              height: headerHeight,
              overflow: 'hidden',
              paddingRight: scrollbarWidth,
              width: width
            })
          },
          this._getRenderedHeaderRow()
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          autoContainerWidth: true,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: function ref(_ref) {
            _this2.Grid = _ref;
          },
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref2) {
      var column = _ref2.column;
      var columnIndex = _ref2.columnIndex;
      var isScrolling = _ref2.isScrolling;
      var rowData = _ref2.rowData;
      var rowIndex = _ref2.rowIndex;
      var _column$props = column.props;
      var cellDataGetter = _column$props.cellDataGetter;
      var cellRenderer = _column$props.cellRenderer;
      var className = _column$props.className;
      var columnData = _column$props.columnData;
      var dataKey = _column$props.dataKey;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({ cellData: cellData, columnData: columnData, dataKey: dataKey, isScrolling: isScrolling, rowData: rowData, rowIndex: rowIndex });

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        {
          key: 'Row' + rowIndex + '-Col' + columnIndex,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__rowColumn', className),
          style: style,
          title: title
        },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref3) {
      var column = _ref3.column;
      var index = _ref3.index;
      var _props2 = this.props;
      var headerClassName = _props2.headerClassName;
      var headerStyle = _props2.headerStyle;
      var onHeaderClick = _props2.onHeaderClick;
      var sort = _props2.sort;
      var sortBy = _props2.sortBy;
      var sortDirection = _props2.sortDirection;
      var _column$props2 = column.props;
      var dataKey = _column$props2.dataKey;
      var disableSort = _column$props2.disableSort;
      var headerRenderer = _column$props2.headerRenderer;
      var label = _column$props2.label;
      var columnData = _column$props2.columnData;

      var sortEnabled = !disableSort && sort;

      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        'ReactVirtualized__Table__sortableHeaderColumn': sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, headerStyle);

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var a11yProps = {};

      if (sortEnabled || onHeaderClick) {
        (function () {
          // If this is a sortable header, clicking it should update the table data's sorting.
          var newSortDirection = sortBy !== dataKey || sortDirection === __WEBPACK_IMPORTED_MODULE_13__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_13__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_13__SortDirection__["a" /* default */].DESC;

          var onClick = function onClick() {
            sortEnabled && sort({
              sortBy: dataKey,
              sortDirection: newSortDirection
            });
            onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey });
          };

          var onKeyDown = function onKeyDown(event) {
            if (event.key === 'Enter' || event.key === ' ') {
              onClick();
            }
          };

          a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
          a11yProps.role = 'rowheader';
          a11yProps.tabIndex = 0;
          a11yProps.onClick = onClick;
          a11yProps.onKeyDown = onKeyDown;
        })();
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
          key: 'Header-Col' + index,
          className: classNames,
          style: style
        }),
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref4) {
      var _this3 = this;

      var index = _ref4.rowIndex;
      var isScrolling = _ref4.isScrolling;
      var key = _ref4.key;
      var style = _ref4.style;
      var _props3 = this.props;
      var children = _props3.children;
      var onRowClick = _props3.onRowClick;
      var onRowDoubleClick = _props3.onRowDoubleClick;
      var onRowMouseOver = _props3.onRowMouseOver;
      var onRowMouseOut = _props3.onRowMouseOut;
      var rowClassName = _props3.rowClassName;
      var rowGetter = _props3.rowGetter;
      var rowRenderer = _props3.rowRenderer;
      var rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = rowClassName instanceof Function ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, rowStyleObject, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      });

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getRenderedHeaderRow',
    value: function _getRenderedHeaderRow() {
      var _this4 = this;

      var _props4 = this.props;
      var children = _props4.children;
      var disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return rowHeight instanceof Function ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref5) {
      var clientHeight = _ref5.clientHeight;
      var scrollHeight = _ref5.scrollHeight;
      var scrollTop = _ref5.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref6) {
      var rowOverscanStartIndex = _ref6.rowOverscanStartIndex;
      var rowOverscanStopIndex = _ref6.rowOverscanStopIndex;
      var rowStartIndex = _ref6.rowStartIndex;
      var rowStopIndex = _ref6.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      var Grid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"])(this.Grid);
      var clientWidth = Grid.clientWidth || 0;
      var offsetWidth = Grid.offsetWidth || 0;
      var scrollbarWidth = offsetWidth - clientWidth;

      this.setState({ scrollbarWidth: scrollbarWidth });
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
 false ? Table.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props, propName, componentName) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      if (children[i].type !== Column) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
  * Optional callback when a column's header is clicked.
  * ({ columnData: any, dataKey: string }): void
  */
  onHeaderClick: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * ({ sortBy: string, sortDirection: SortDirection }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var columnData = _ref.columnData;
  var dataKey = _ref.dataKey;
  var rowData = _ref.rowData;

  if (rowData.get instanceof Function) {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;
  var cellDataKey = _ref.cellDataKey;
  var columnData = _ref.columnData;
  var rowData = _ref.rowData;
  var rowIndex = _ref.rowIndex;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(898);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var columnData = _ref.columnData;
  var dataKey = _ref.dataKey;
  var disableSort = _ref.disableSort;
  var label = _ref.label;
  var sortBy = _ref.sortBy;
  var sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: label
    },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], {
      key: 'SortIndicator',
      sortDirection: sortDirection
    }));
  }

  return children;
}

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className;
  var columns = _ref.columns;
  var index = _ref.index;
  var isScrolling = _ref.isScrolling;
  var key = _ref.key;
  var onRowClick = _ref.onRowClick;
  var onRowDoubleClick = _ref.onRowDoubleClick;
  var onRowMouseOver = _ref.onRowMouseOver;
  var onRowMouseOut = _ref.onRowMouseOut;
  var rowData = _ref.rowData;
  var style = _ref.style;

  var a11yProps = {};

  if (onRowClick || onRowDoubleClick || onRowMouseOver || onRowMouseOut) {
    a11yProps['aria-label'] = 'row';
    a11yProps.role = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function () {
        return onRowClick({ index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function () {
        return onRowDoubleClick({ index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function () {
        return onRowMouseOut({ index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function () {
        return onRowMouseOver({ index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      style: style
    }),
    columns
  );
}

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(2115);











var WindowScroller = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WindowScroller, _Component);

  function WindowScroller(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    // Handle server-side rendering case
    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call(this, props));

    var height = typeof window !== 'undefined' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getHeight */])(props.scrollElement || window) : 0;

    _this.state = {
      height: height,
      isScrolling: false,
      scrollTop: 0
    };

    _this._onResize = _this._onResize.bind(_this);
    _this.__handleWindowScrollEvent = _this.__handleWindowScrollEvent.bind(_this);
    _this.__resetIsScrolling = _this.__resetIsScrolling.bind(_this);
    return _this;
  }

  // Can’t use defaultProps for scrollElement without breaking server-side rendering


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition(scrollElement) {
      var onResize = this.props.onResize;
      var height = this.state.height;


      scrollElement = scrollElement || this.props.scrollElement || window;
      this._positionFromTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionFromTop */])(__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this), scrollElement);

      var newHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getHeight */])(scrollElement);
      if (height !== newHeight) {
        this.setState({
          height: newHeight
        });
        onResize({
          height: newHeight
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement || window;

      this.updatePosition(scrollElement);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

      window.addEventListener('resize', this._onResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var scrollElement = this.props.scrollElement || window;
      var nextScrollElement = nextProps.scrollElement || window;

      if (scrollElement !== nextScrollElement) {
        this.updatePosition(nextScrollElement);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, nextScrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, this.props.scrollElement || window);

      window.removeEventListener('resize', this._onResize, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state;
      var isScrolling = _state.isScrolling;
      var scrollTop = _state.scrollTop;
      var height = _state.height;


      return children({
        height: height,
        isScrolling: isScrolling,
        scrollTop: scrollTop
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onResize',
    value: function _onResize(event) {
      this.updatePosition();
    }

    // Referenced by utils/onScroll

  }, {
    key: '__handleWindowScrollEvent',
    value: function __handleWindowScrollEvent(event) {
      var onScroll = this.props.onScroll;


      var scrollElement = this.props.scrollElement || window;
      var scrollTop = Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollTop */])(scrollElement) - this._positionFromTop);

      this.setState({
        isScrolling: true,
        scrollTop: scrollTop
      });

      onScroll({
        scrollTop: scrollTop
      });
    }

    // Referenced by utils/onScroll

  }, {
    key: '__resetIsScrolling',
    value: function __resetIsScrolling() {
      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: 'scrollElement',
    get: function get() {
      return this.props.scrollElement || window;
    }
  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {}
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);
 false ? WindowScroller.propTypes = {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,

  /** Callback to be invoked on-resize: ({ height }) */
  onResize: PropTypes.func.isRequired,

  /** Callback to be invoked on-scroll: ({ scrollTop }) */
  onScroll: PropTypes.func.isRequired,

  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.any
} : void 0;

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    document.body.style.pointerEvents = originalBodyPointerEvents;

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    clearTimeout(disablePointerEventsTimeoutId);
  }

  disablePointerEventsTimeoutId = setTimeout(enablePointerEventsAfterDelayCallback, IS_SCROLLING_TIMEOUT);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent(event);
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      clearTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

/***/ }),
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(0), __webpack_require__(14), __webpack_require__(13), __webpack_require__(65), __webpack_require__(238), __webpack_require__(91), __webpack_require__(1805), __webpack_require__(2276), __webpack_require__(1591), __webpack_require__(18), __webpack_require__(1527), __webpack_require__(248), __webpack_require__(885));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "rp-react-svg-icon", "classnames", "rp-mq-breakpoints", "qs", "react-dom", "isomorphic-fetch", "rp-react-select", "datepicker", "jquery", "date-fns", "rp-navigation", "react-textarea-autosize"], factory);
	else if(typeof exports === 'object')
		exports["rpBloodstockSearch"] = factory(require("react"), require("prop-types"), require("rp-react-svg-icon"), require("classnames"), require("rp-mq-breakpoints"), require("qs"), require("react-dom"), require("isomorphic-fetch"), require("rp-react-select"), require("datepicker"), require("jquery"), require("date-fns"), require("rp-navigation"), require("react-textarea-autosize"));
	else
		root["rpBloodstockSearch"] = factory(root["react"], root["prop-types"], root["rp-react-svg-icon"], root["classnames"], root["rp-mq-breakpoints"], root["qs"], root["react-dom"], root["isomorphic-fetch"], root["rp-react-select"], root["datepicker"], root["jquery"], root["date-fns"], root["rp-navigation"], root["react-textarea-autosize"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_23__, __WEBPACK_EXTERNAL_MODULE_26__, __WEBPACK_EXTERNAL_MODULE_67__, __WEBPACK_EXTERNAL_MODULE_193__, __WEBPACK_EXTERNAL_MODULE_215__, __WEBPACK_EXTERNAL_MODULE_224__, __WEBPACK_EXTERNAL_MODULE_225__, __WEBPACK_EXTERNAL_MODULE_226__, __WEBPACK_EXTERNAL_MODULE_277__, __WEBPACK_EXTERNAL_MODULE_320__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 89);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(182);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(153)
var isDate = __webpack_require__(58)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATUS_UNAUTHORIZED = exports.CONTENT_TYPE_TEXT = exports.CONTENT_TYPE_JSON = exports.HEADER_CONTENT_TYPE = exports.HEADER_DISABLE_REDIRECT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isUnauthorized = isUnauthorized;
exports.callApi = callApi;

var _isomorphicFetch = __webpack_require__(193);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _isPlainObject2 = __webpack_require__(41);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _qs = __webpack_require__(26);

var _qs2 = _interopRequireDefault(_qs);

var _rpAuth = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HEADER_DISABLE_REDIRECT = exports.HEADER_DISABLE_REDIRECT = 'X-Disable-Redirect';
var HEADER_CONTENT_TYPE = exports.HEADER_CONTENT_TYPE = 'Content-Type';

var CONTENT_TYPE_JSON = exports.CONTENT_TYPE_JSON = 'application/json';
var CONTENT_TYPE_TEXT = exports.CONTENT_TYPE_TEXT = 'text/plain';

var STATUS_UNAUTHORIZED = exports.STATUS_UNAUTHORIZED = 401;

function isUnauthorized(resp) {
    return resp && resp.status === STATUS_UNAUTHORIZED;
}

function callApi(endpoint) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var query = _ref.query,
        body = _ref.body,
        otherInit = _objectWithoutProperties(_ref, ['query', 'body']);

    var init = _extends({}, otherInit, {
        credentials: 'include',
        headers: _extends({}, otherInit.headers, _defineProperty({}, HEADER_DISABLE_REDIRECT, true))
    });
    if (body) {
        init = _extends({
            method: 'POST' }, init, {
            body: (0, _isPlainObject3.default)(body) ? JSON.stringify(body) : body,
            headers: _extends({}, init.headers, _defineProperty({}, HEADER_CONTENT_TYPE, CONTENT_TYPE_JSON))
        });
    }
    var url = (0, _isPlainObject3.default)(query) ? endpoint + '?' + _qs2.default.stringify(query, { skipNulls: true }) : endpoint;
    return (0, _isomorphicFetch2.default)(url, init).then(function (resp) {
        if (resp.status === STATUS_UNAUTHORIZED) {
            if (resp.url.indexOf('shortlist') > -1) {
                (0, _rpAuth.checkForAccess)('SignIn', true, true, {
                    text: 'Please sign in to edit your shortlist'
                });
            } else {
                (0, _rpAuth.checkForAccess)('Subscriptions', true, true);
            }
        }
        if (!resp.ok) {
            return Promise.reject(resp);
        }

        var contentType = resp.headers.get(HEADER_CONTENT_TYPE);

        if (contentType.indexOf(CONTENT_TYPE_JSON) !== -1) return resp.json();
        if (contentType.indexOf(CONTENT_TYPE_TEXT) !== -1) return resp.text();

        return Promise.resolve(null);
    });
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(46);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindCode = exports.bind = exports.codes = undefined;

var _rpMqBreakpoints = __webpack_require__(23);

var _Breakpoints = __webpack_require__(170);

exports.codes = _rpMqBreakpoints.breakpointCodes;
exports.bind = _Breakpoints.bind;
exports.bindCode = _Breakpoints.bindCode;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(20),
    getRawTag = __webpack_require__(105),
    objectToString = __webpack_require__(106);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CellRace = exports.CellDateSale = exports.CellHorseSireUGC = exports.CellHorseUGC = exports.CellPrice = exports.CellDamDamsSire = exports.CellDamsSire = exports.CellDam = exports.CellSire = exports.CellHorse = exports.CellLot = undefined;

var _CellLot = __webpack_require__(262);

var _CellLot2 = _interopRequireDefault(_CellLot);

var _CellHorse = __webpack_require__(76);

var _CellHorse2 = _interopRequireDefault(_CellHorse);

var _CellSire = __webpack_require__(77);

var _CellSire2 = _interopRequireDefault(_CellSire);

var _CellDam = __webpack_require__(78);

var _CellDam2 = _interopRequireDefault(_CellDam);

var _CellDamsSire = __webpack_require__(79);

var _CellDamsSire2 = _interopRequireDefault(_CellDamsSire);

var _CellDamDamsSire = __webpack_require__(272);

var _CellDamDamsSire2 = _interopRequireDefault(_CellDamDamsSire);

var _CellPrice = __webpack_require__(273);

var _CellPrice2 = _interopRequireDefault(_CellPrice);

var _CellHorseUGC = __webpack_require__(80);

var _CellHorseUGC2 = _interopRequireDefault(_CellHorseUGC);

var _CellHorseSireUGC = __webpack_require__(284);

var _CellHorseSireUGC2 = _interopRequireDefault(_CellHorseSireUGC);

var _CellDateSale = __webpack_require__(285);

var _CellDateSale2 = _interopRequireDefault(_CellDateSale);

var _CellRace = __webpack_require__(286);

var _CellRace2 = _interopRequireDefault(_CellRace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CellLot = _CellLot2.default;
exports.CellHorse = _CellHorse2.default;
exports.CellSire = _CellSire2.default;
exports.CellDam = _CellDam2.default;
exports.CellDamsSire = _CellDamsSire2.default;
exports.CellDamDamsSire = _CellDamDamsSire2.default;
exports.CellPrice = _CellPrice2.default;
exports.CellHorseUGC = _CellHorseUGC2.default;
exports.CellHorseSireUGC = _CellHorseSireUGC2.default;
exports.CellDateSale = _CellDateSale2.default;
exports.CellRace = _CellRace2.default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(104),
    getValue = __webpack_require__(109);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObject = __webpack_require__(16);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableToggle = exports.TableCell = exports.TableRowConstructor = exports.TableRow = exports.TableBody = exports.TableHeadCell = exports.TableHead = exports.default = undefined;

var _Table = __webpack_require__(239);

var _Table2 = _interopRequireDefault(_Table);

var _TableHead = __webpack_require__(71);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableHeadCell = __webpack_require__(72);

var _TableHeadCell2 = _interopRequireDefault(_TableHeadCell);

var _TableBody = __webpack_require__(74);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableRowConstructor = __webpack_require__(75);

var _TableRowConstructor2 = _interopRequireDefault(_TableRowConstructor);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableToggle = __webpack_require__(259);

var _TableToggle2 = _interopRequireDefault(_TableToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Table2.default;
exports.TableHead = _TableHead2.default;
exports.TableHeadCell = _TableHeadCell2.default;
exports.TableBody = _TableBody2.default;
exports.TableRow = _TableRow2.default;
exports.TableRowConstructor = _TableRowConstructor2.default;
exports.TableCell = _TableCell2.default;
exports.TableToggle = _TableToggle2.default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(94),
    listCacheDelete = __webpack_require__(95),
    listCacheGet = __webpack_require__(96),
    listCacheHas = __webpack_require__(97),
    listCacheSet = __webpack_require__(98);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(33);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(118);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_23__;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(62);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_26__;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableRow;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableRow(_ref) {
    var className = _ref.className,
        otherProps = _objectWithoutProperties(_ref, ['className']);

    return _react2.default.createElement('tr', _extends({
        className: (0, _classnames2.default)('ui-table__row', className)
    }, otherProps));
}

TableRow.propTypes = {
    className: _propTypes2.default.string
};

TableRow.defaultProps = {
    className: ''
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableCell;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableCell(_ref) {
    var className = _ref.className,
        otherProps = _objectWithoutProperties(_ref, ['className']);

    return _react2.default.createElement('td', _extends({
        className: (0, _classnames2.default)('ui-table__cell', className)
    }, otherProps));
}

TableCell.propTypes = {
    className: _propTypes2.default.string
};

TableCell.defaultProps = {
    className: ''
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfileLink = __webpack_require__(263);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProfileLink2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.catalogueUrl = catalogueUrl;
exports.statisticsUrl = statisticsUrl;
exports.lotUrl = lotUrl;
exports.profileUrl = profileUrl;
exports.raceUrl = raceUrl;
exports.queryUrl = queryUrl;

var _qs = __webpack_require__(26);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(264);

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build URL for catalogue page
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @param {object} [queryParams]
 * @returns {string} URL
 */
function catalogueUrl(uid, date) {
    var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var catUrl = 'catalogues/' + uid + '/' + date;
    if (queryParams) {
        catUrl += '?' + _qs2.default.stringify(queryParams);
    }

    return catUrl;
}

/**
 * Build URL for statistics page
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @returns {string} URL
 */
function statisticsUrl(uid, date) {
    return 'statistics/' + uid + '/' + date;
}

/**
 * Build URL to concrete lot
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @param {number} lot Lot number
 * @param {string} letter Lot letter
 * @returns {string} URL
 */
function lotUrl(uid, date, lot, letter) {
    return 'catalogues/' + uid + '/' + date + '?lot=' + lot + '&letter=' + encodeURIComponent(letter);
}

/**
 * Build URL to horses/humans profiles
 *
 * @param {string} type Profile type
 * @param {number} id Profile ID
 * @param {string} name Profile style name
 * @returns {string}
 */
function profileUrl(type, id, name) {
    if (!type || !id || !name) {
        return '';
    }

    var urlName = name.toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-');

    return '/profile/' + type + '/' + id + '/' + urlName;
}

/**
 * Build URL to race card
 *
 * @param {number} courseId courseId
 * @param {string} courseName courseName
  * @param {string} raceDate raceDate
 * @param {number} raceId raceId
 * @returns {string}
 */
function raceUrl(courseId, courseName, raceDate, raceId) {
    if (!courseId || !courseName || !raceDate || !raceId) {
        return '';
    }

    var urlName = courseName.toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-');

    return '/racecards/' + courseId + '/' + urlName + '/' + raceDate + '/' + raceId;
}

/**
 * Build URL with given query params
 *
 * @param {string} baseUrl
 * @param {{}} params Query parameters
 * @returns {string}
 */
function queryUrl(baseUrl, params) {
    var parsedUrl = _url2.default.parse(baseUrl);
    var query = _qs2.default.parse(parsedUrl.query || parsedUrl.search);

    return _url2.default.format(Object.assign(parsedUrl, {
        search: _qs2.default.stringify(Object.assign(query, params))
    }));
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesTab = __webpack_require__(291);

var _RelativesTab2 = _interopRequireDefault(_RelativesTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesTab2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(44);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(110),
    mapCacheDelete = __webpack_require__(117),
    mapCacheGet = __webpack_require__(119),
    mapCacheHas = __webpack_require__(120),
    mapCacheSet = __webpack_require__(121);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(137),
    baseKeys = __webpack_require__(145),
    isArrayLike = __webpack_require__(56);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(158)
var getISOWeek = __webpack_require__(162)
var getISOYear = __webpack_require__(60)
var parse = __webpack_require__(6)
var isValid = __webpack_require__(165)
var enLocale = __webpack_require__(166)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(163)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16),
    isSymbol = __webpack_require__(24);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    getPrototype = __webpack_require__(194),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCatalogueItemSafe = exports.getDefaultCatalogueItem = exports.findCatalogueItem = exports.submitNote = exports.fetchNote = exports.toggleNote = exports.toggleShortlist = exports.bindCatalogue = undefined;

var _UGC = __webpack_require__(276);

var _ugc = __webpack_require__(81);

exports.bindCatalogue = _UGC.bindCatalogue;
exports.toggleShortlist = _UGC.toggleShortlist;
exports.toggleNote = _UGC.toggleNote;
exports.fetchNote = _UGC.fetchNote;
exports.submitNote = _UGC.submitNote;
exports.findCatalogueItem = _ugc.findCatalogueItem;
exports.getDefaultCatalogueItem = _ugc.getDefaultCatalogueItem;
exports.getCatalogueItemSafe = _ugc.getCatalogueItemSafe;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Dialog = exports.Backdrop = exports.default = undefined;

var _Lightbox = __webpack_require__(327);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _LightboxBackdrop = __webpack_require__(85);

var _LightboxBackdrop2 = _interopRequireDefault(_LightboxBackdrop);

var _LightboxDialog = __webpack_require__(86);

var _LightboxDialog2 = _interopRequireDefault(_LightboxDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Lightbox2.default;
exports.Backdrop = _LightboxBackdrop2.default;
exports.Dialog = _LightboxDialog2.default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(93),
    isObjectLike = __webpack_require__(12);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(18),
    stackClear = __webpack_require__(99),
    stackDelete = __webpack_require__(100),
    stackGet = __webpack_require__(101),
    stackHas = __webpack_require__(102),
    stackSet = __webpack_require__(103);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 47 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(122),
    arraySome = __webpack_require__(125),
    cacheHas = __webpack_require__(126);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(8),
    stubFalse = __webpack_require__(141);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(142),
    baseUnary = __webpack_require__(143),
    nodeUtil = __webpack_require__(144);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(15),
    isLength = __webpack_require__(54);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(148),
    Map = __webpack_require__(34),
    Promise = __webpack_require__(149),
    Set = __webpack_require__(150),
    WeakMap = __webpack_require__(151),
    baseGetTag = __webpack_require__(11),
    toSource = __webpack_require__(48);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var getDaysInMonth = __webpack_require__(157)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var startOfISOWeek = __webpack_require__(39)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = __webpack_require__(171);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pagination2.default;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(20),
    arrayMap = __webpack_require__(63),
    isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(24);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(190);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(191),
    hasUnicode = __webpack_require__(65),
    unicodeToArray = __webpack_require__(192);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_67__;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FiltersToggle = exports.FiltersSelect = exports.FiltersReset = exports.FiltersNav = exports.FiltersInput = undefined;

var _Input = __webpack_require__(196);

var _Input2 = _interopRequireDefault(_Input);

var _Nav = __webpack_require__(203);

var _Nav2 = _interopRequireDefault(_Nav);

var _Reset = __webpack_require__(211);

var _Reset2 = _interopRequireDefault(_Reset);

var _Select = __webpack_require__(213);

var _Select2 = _interopRequireDefault(_Select);

var _Toggle = __webpack_require__(218);

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FiltersInput = _Input2.default;
exports.FiltersNav = _Nav2.default;
exports.FiltersReset = _Reset2.default;
exports.FiltersSelect = _Select2.default;
exports.FiltersToggle = _Toggle2.default;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(198);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Input2.default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(229);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableHead;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableHead(props) {
    return _react2.default.createElement('thead', props);
}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableHeadCell;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableHeadSortIcon = __webpack_require__(251);

var _TableHeadSortIcon2 = _interopRequireDefault(_TableHeadSortIcon);

var _TableHead = __webpack_require__(73);

var _TableHead2 = _interopRequireDefault(_TableHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableHeadCell(_ref) {
    var className = _ref.className,
        children = _ref.children,
        type = _ref.type,
        sorting = _ref.sorting,
        sortable = _ref.sortable,
        otherProps = _objectWithoutProperties(_ref, ['className', 'children', 'type', 'sorting', 'sortable']);

    return _react2.default.createElement(
        'th',
        _extends({
            className: (0, _classnames3.default)('ui-table__cell', _defineProperty({}, _TableHead2.default.cell_unsortable, !sortable),
            // ui-table__cell_sorted describes styles only for table type 1
            { 'ui-table__cell_sorted': type === 1 && sorting }, className)
        }, otherProps),
        children,
        type === 5 && _react2.default.createElement(_TableHeadSortIcon2.default, {
            className: _TableHead2.default.cell__sortIcon,
            direction: sorting
        })
    );
}

TableHeadCell.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    type: _propTypes2.default.number.isRequired,
    sorting: _propTypes2.default.string,
    sortable: _propTypes2.default.bool.isRequired
};

TableHeadCell.defaultProps = {
    className: '',
    children: null,
    sorting: null
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(252);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableHead.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableHead.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableBody;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableBody(_ref) {
    var rootRef = _ref.rootRef,
        otherProps = _objectWithoutProperties(_ref, ['rootRef']);

    return _react2.default.createElement('tbody', _extends({
        ref: rootRef
    }, otherProps));
}

TableBody.propTypes = {
    rootRef: _propTypes2.default.func
};

TableBody.defaultProps = {
    rootRef: null
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableRowConstructor;

var _isFunction = __webpack_require__(15);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isPlainObject = __webpack_require__(41);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableRowConstructor = __webpack_require__(257);

var _TableRowConstructor2 = _interopRequireDefault(_TableRowConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableRowConstructor(_ref) {
    var children = _ref.children,
        type = _ref.type,
        columns = _ref.columns,
        data = _ref.data,
        identity = _ref.identity,
        expanded = _ref.expanded,
        onToggle = _ref.onToggle;

    var row = _react2.default.createElement(
        _TableRow2.default,
        null,
        columns.map(function (column) {
            if (!column.cell) {
                return _react2.default.createElement(
                    _TableCell2.default,
                    {
                        key: column.name,
                        className: column.className
                    },
                    data[column.name]
                );
            }

            if ((0, _isPlainObject2.default)(column.cell)) {
                return _react2.default.createElement(
                    _TableCell2.default,
                    _extends({
                        key: column.name,
                        className: column.className
                    }, column.cell),
                    function () {
                        if ((0, _isFunction2.default)(column.cell.children)) {
                            var Children = column.cell.children;
                            return _react2.default.createElement(Children, {
                                column: column,
                                data: data,
                                identity: identity,
                                expanded: expanded,
                                onToggle: onToggle
                            });
                        }
                        return data[column.name];
                    }()
                );
            }

            var Cell = column.cell;
            if ((0, _isFunction2.default)(Cell)) {
                return _react2.default.createElement(Cell, {
                    key: column.name,
                    className: column.className,
                    column: column,
                    data: data,
                    identity: identity,
                    expanded: expanded,
                    onToggle: onToggle
                });
            }

            throw new Error('Column ' + column.name + ' has invalid cell ' + column.cell);
        })
    );

    if (!expanded) {
        return row;
    }

    return _react2.default.createElement(
        'tr',
        { className: 'ui-table__row' },
        _react2.default.createElement(
            'td',
            { className: _TableRowConstructor2.default.expansion__cell, colSpan: columns.length },
            _react2.default.createElement(
                'table',
                {
                    className: _TableRowConstructor2.default.expansion__table + ' ui-table ui-table_type' + type
                },
                _react2.default.createElement(
                    'tbody',
                    null,
                    row
                )
            ),
            function () {
                if (_react2.default.isValidElement(children)) {
                    return children;
                }

                if ((0, _isFunction2.default)(children)) {
                    var Children = children;
                    return _react2.default.createElement(Children, {
                        data: data,
                        identity: identity,
                        onToggle: onToggle
                    });
                }

                throw new Error('Row has invalid children ' + children);
            }()
        )
    );
}

TableRowConstructor.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
    type: _propTypes2.default.number.isRequired,
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        className: _propTypes2.default.string,
        name: _propTypes2.default.string.isRequired,
        cell: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.func])
    })).isRequired,
    data: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    identity: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    expanded: _propTypes2.default.bool,
    onToggle: _propTypes2.default.func
};

TableRowConstructor.defaultProps = {
    children: null,
    expanded: false,
    onToggle: function onToggle() {
        return null;
    }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = CellHorse;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function CellHorse(_ref) {
    var data = _ref.data,
        otherProps = _objectWithoutProperties(_ref, ['data']);

    return _react2.default.createElement(
        _ProfileLink2.default,
        _extends({
            type: _ProfileLink2.default.TYPE_HORSE,
            uid: data.horse_uid,
            name: data.horse_style_name
        }, otherProps),
        data.horse_name || data.horse_style_name
    );
}

CellHorse.propTypes = {
    data: _propTypes2.default.shape({
        horse_uid: _propTypes2.default.number,
        horse_name: _propTypes2.default.string,
        horse_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = CellSire;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function CellSire(_ref) {
    var data = _ref.data,
        otherProps = _objectWithoutProperties(_ref, ['data']);

    return _react2.default.createElement(
        _ProfileLink2.default,
        _extends({
            type: _ProfileLink2.default.TYPE_HORSE,
            uid: data.sire_uid,
            name: data.sire_style_name
        }, otherProps),
        data.sire_name || data.sire_style_name
    );
}

CellSire.propTypes = {
    data: _propTypes2.default.shape({
        sire_uid: _propTypes2.default.number,
        sire_name: _propTypes2.default.string,
        sire_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDam;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDam(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        _ProfileLink2.default,
        {
            type: _ProfileLink2.default.TYPE_HORSE,
            uid: data.dam_uid,
            name: data.dam_style_name
        },
        data.dam_style_name
    );
}

CellDam.propTypes = {
    data: _propTypes2.default.shape({
        dam_uid: _propTypes2.default.number,
        dam_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDamsSire;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDamsSire(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        _ProfileLink2.default,
        {
            type: 'horse',
            uid: data.sire_of_dam_uid,
            name: data.sire_of_dam_style_name || data.sire_of_dam_name
        },
        data.sire_of_dam_name || data.sire_of_dam_style_name
    );
}

CellDamsSire.propTypes = {
    data: _propTypes2.default.shape({
        sire_of_dam_uid: _propTypes2.default.number,
        sire_of_dam_name: _propTypes2.default.string,
        sire_of_dam_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CellHorseUGCComponent = CellHorseUGCComponent;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _UGC = __webpack_require__(42);

var _CellHorse = __webpack_require__(76);

var _CellHorse2 = _interopRequireDefault(_CellHorse);

var _CellHorseUGC = __webpack_require__(282);

var _CellHorseUGC2 = _interopRequireDefault(_CellHorseUGC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellHorseUGCComponent(_ref) {
    var children = _ref.children,
        data = _ref.data,
        shortlist = _ref.shortlist,
        note = _ref.note,
        expanded = _ref.expanded;

    return _react2.default.createElement(
        'div',
        { className: _CellHorseUGC2.default.root },
        _react2.default.createElement(
            'div',
            { className: _CellHorseUGC2.default.horse },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_CellHorse2.default, {
                    data: data,
                    bold: true
                })
            ),
            children && _react2.default.createElement(
                'div',
                null,
                children
            )
        ),
        !expanded && _react2.default.createElement(
            'div',
            { className: _CellHorseUGC2.default.ugc },
            shortlist && _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _CellHorseUGC2.default.icon,
                iconName: 'starFilled',
                size: 'Medium'
            }),
            note && _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _CellHorseUGC2.default.icon,
                iconName: 'note-dark',
                size: 'Medium'
            })
        )
    );
}

CellHorseUGCComponent.propTypes = {
    children: _propTypes2.default.node,
    data: _propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired
    }).isRequired,
    shortlist: _propTypes2.default.bool,
    note: _propTypes2.default.bool,
    expanded: _propTypes2.default.bool
};

CellHorseUGCComponent.defaultProps = {
    children: null,
    shortlist: false,
    note: false,
    expanded: false
};

exports.default = (0, _UGC.bindCatalogue)(CellHorseUGCComponent, function (catalogue, ownProps) {
    var _ownProps$data = ownProps.data,
        venue_uid = _ownProps$data.venue_uid,
        sale_date_raw = _ownProps$data.sale_date_raw,
        lot_no = _ownProps$data.lot_no,
        lot_letter = _ownProps$data.lot_letter;

    var _getCatalogueItemSafe = (0, _UGC.getCatalogueItemSafe)(catalogue, venue_uid, sale_date_raw, lot_no, lot_letter),
        shortlist = _getCatalogueItemSafe.shortlist,
        note = _getCatalogueItemSafe.note;

    return { shortlist: shortlist, note: note };
});

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findCatalogueItem = findCatalogueItem;
exports.getDefaultCatalogueItem = getDefaultCatalogueItem;
exports.getCatalogueItemSafe = getCatalogueItemSafe;

var _isMatch2 = __webpack_require__(278);

var _isMatch3 = _interopRequireDefault(_isMatch2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findCatalogueItem(catalogue, venueId, saleDate, lotNo, lotLetter) {
    return catalogue.find(function (item) {
        return (0, _isMatch3.default)(item, { venueId: venueId, saleDate: saleDate, lotNo: lotNo, lotLetter: lotLetter });
    });
}

function getDefaultCatalogueItem(venueId, saleDate, lotNo, lotLetter) {
    return {
        venueId: venueId,
        saleDate: saleDate,
        lotNo: lotNo,
        lotLetter: lotLetter,
        shortlist: false,
        note: false
    };
}

function getCatalogueItemSafe(catalogue, venueId, saleDate, lotNo, lotLetter) {
    return findCatalogueItem(catalogue, venueId, saleDate, lotNo, lotLetter) || getDefaultCatalogueItem(venueId, saleDate, lotNo, lotLetter);
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesRow = __webpack_require__(289);

var _RelativesRow2 = _interopRequireDefault(_RelativesRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesRow2.default;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Relatives = __webpack_require__(290);

var _Relatives2 = _interopRequireDefault(_Relatives);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Relatives2.default;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(316),
    baseIsNaN = __webpack_require__(317),
    strictIndexOf = __webpack_require__(318);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(67);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Backdrop = function (_PureComponent) {
    _inherits(Backdrop, _PureComponent);

    function Backdrop() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Backdrop);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Backdrop.__proto__ || Object.getPrototypeOf(Backdrop)).call.apply(_ref, [this].concat(args))), _this), _this.container = document.getElementById('lightbox'), _this.handleOverlayClick = function (ev) {
            if (ev.target === _this.rootRef || ev.target === _this.containerRef) {
                _this.props.onClose();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Backdrop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.open) {
                this.manipulate(true);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var open = _ref2.open;

            if (this.props.open !== open) {
                this.manipulate(open);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.manipulate(false);
        }
    }, {
        key: 'manipulate',
        value: function manipulate(open) {
            var _this2 = this;

            if (open) {
                /* eslint-disable jsx-a11y/no-static-element-interactions */
                _reactDom2.default.render(_react2.default.createElement(
                    'div',
                    {
                        ref: function ref(_ref4) {
                            _this2.rootRef = _ref4;
                        },
                        className: 'ui-overlay',
                        onClick: this.handleOverlayClick
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: function ref(_ref3) {
                                _this2.containerRef = _ref3;
                            },
                            className: 'ui-overlay__container'
                        },
                        this.props.children
                    )
                ), this.container);
                /* eslint-enable jsx-a11y/no-static-element-interactions */
            } else {
                _reactDom2.default.unmountComponentAtNode(this.container);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return Backdrop;
}(_react.PureComponent);

Backdrop.propTypes = {
    children: _propTypes2.default.node.isRequired,
    open: _propTypes2.default.bool,
    onClose: _propTypes2.default.func
};
Backdrop.defaultProps = {
    open: false,
    onClose: null
};
exports.default = Backdrop;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Dialog;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _LightboxDialog = __webpack_require__(328);

var _LightboxDialog2 = _interopRequireDefault(_LightboxDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dialog(_ref) {
    var children = _ref.children,
        closeButton = _ref.closeButton,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        'div',
        { className: 'ui-modal' },
        closeButton && _react2.default.createElement(
            'button',
            {
                className: _LightboxDialog2.default.closeButton,
                onClick: onClose
            },
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _LightboxDialog2.default.closeButtonIcon,
                iconName: 'cross',
                size: 'Medium'
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'ui-modal__canvas' },
            children
        )
    );
}

Dialog.propTypes = {
    children: _propTypes2.default.node,
    closeButton: _propTypes2.default.bool,
    onClose: _propTypes2.default.func
};

Dialog.defaultProps = {
    children: null,
    closeButton: true,
    onClose: null
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(351);


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getValues = exports.getValue = exports.getStatusLabels = exports.getStatusLabel = exports.getLabels = exports.getLabel = exports.getOptions = exports.getOption = exports.setSelected = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setSelected = exports.setSelected = function setSelected(arr, value) {
    return arr.map(function (item) {
        return item.value === value ? _extends({}, item, { selected: true }) : item;
    });
};

var getOption = exports.getOption = function getOption(category) {
    return (category.options || []).find(function (item) {
        return item.selected;
    }) || {};
};

var getOptions = exports.getOptions = function getOptions(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            category = _ref2[1];

        res[key] = getOption(category);
    });
    return res;
};

var getLabel = exports.getLabel = function getLabel(category) {
    return getOption(category).label;
};

var getLabels = exports.getLabels = function getLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            category = _ref4[1];

        res[key] = getLabel(category);
    });
    return res;
};

var getStatusLabel = exports.getStatusLabel = function getStatusLabel(category) {
    var _getOption = getOption(category),
        statusLabel = _getOption.statusLabel,
        label = _getOption.label;

    return statusLabel || label;
};

var getStatusLabels = exports.getStatusLabels = function getStatusLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            category = _ref6[1];

        res[key] = !category.isHidden ? getStatusLabel(category) : null;
    });
    return res;
};

var getValue = exports.getValue = function getValue(category) {
    return getOption(category).value;
};

var getValues = exports.getValues = function getValues(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            category = _ref8[1];

        res[key] = getValue(category);
    });
    return res;
};

exports.default = {
    setSelected: setSelected,
    getOption: getOption,
    getOptions: getOptions,
    getLabel: getLabel,
    getLabels: getLabels,
    getStatusLabel: getStatusLabel,
    getStatusLabels: getStatusLabels,
    getValue: getValue,
    getValues: getValues
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callApi = exports.bindBreakpointCode = exports.bindBreakpoints = exports.getUGCCatalogueItemSafe = exports.bindUGCCatalogue = exports.Lightbox = exports.Relatives = exports.SearchResults = exports.SearchEntries = undefined;

var _Search = __webpack_require__(90);

var _Relatives = __webpack_require__(83);

var _Relatives2 = _interopRequireDefault(_Relatives);

var _Lightbox = __webpack_require__(43);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _UGC = __webpack_require__(42);

var _Breakpoints = __webpack_require__(10);

var _api = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SearchEntries = _Search.SearchEntries;
exports.SearchResults = _Search.SearchResults;
exports.Relatives = _Relatives2.default;
exports.Lightbox = _Lightbox2.default;
exports.bindUGCCatalogue = _UGC.bindCatalogue;
exports.getUGCCatalogueItemSafe = _UGC.getCatalogueItemSafe;
exports.bindBreakpoints = _Breakpoints.bind;
exports.bindBreakpointCode = _Breakpoints.bindCode;
exports.callApi = _api.callApi;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchEntries = exports.SearchResults = undefined;

var _Results = __webpack_require__(91);

var _Results2 = _interopRequireDefault(_Results);

var _Entries = __webpack_require__(383);

var _Entries2 = _interopRequireDefault(_Entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SearchResults = _Results2.default;
exports.SearchEntries = _Entries2.default;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResults = __webpack_require__(92);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResults2.default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual2 = __webpack_require__(32);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _difference_in_months = __webpack_require__(152);

var _difference_in_months2 = _interopRequireDefault(_difference_in_months);

var _add_days = __webpack_require__(156);

var _add_days2 = _interopRequireDefault(_add_days);

var _add_months = __webpack_require__(59);

var _add_months2 = _interopRequireDefault(_add_months);

var _format = __webpack_require__(38);

var _format2 = _interopRequireDefault(_format);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _Pagination = __webpack_require__(61);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _SearchResultsFilters = __webpack_require__(186);

var _SearchResultsFilters2 = _interopRequireDefault(_SearchResultsFilters);

var _SearchResultsTable = __webpack_require__(238);

var _SearchResultsTable2 = _interopRequireDefault(_SearchResultsTable);

var _Lightbox = __webpack_require__(377);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _api = __webpack_require__(7);

var _SearchResults = __webpack_require__(381);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ERROR_MESSAGE_REFINE = 'No lots found matching your search. ' + 'Use the reset button to clear your search and start again';
var ERROR_MESSAGE_RANGE = 'No lots found for the selected date range';

var DATE_FORMAT = 'YYYY-MM-DD';

function isRefinementBroad(_ref) {
    var from = _ref.from,
        to = _ref.to,
        otherRefinement = _objectWithoutProperties(_ref, ['from', 'to']);

    // Date range is longer than a month
    // and filters Sale, Vendor, Horse, Sire, Dam, Dam Sire are empty
    return (0, _difference_in_months2.default)(to, (0, _add_days2.default)(from, 1)) > 0 && ['sale', 'vendor', 'buyer', 'name', 'sire', 'dam', 'damSire'].every(function (prop) {
        return !otherRefinement[prop];
    });
}

var SearchResults = function (_PureComponent) {
    _inherits(SearchResults, _PureComponent);

    function SearchResults() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResults);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            lightbox: false,
            fetching: false,
            fetchFailed: false,
            filtersUsed: false,
            totalLotsNum: SearchResults.getInitialTotalLotsNum(),
            totalPagesNum: SearchResults.getInitialTotalPagesNum(),
            filters: _this.getInitialFilters(),
            page: SearchResults.getInitialPage(),
            data: SearchResults.getInitialData(),
            header: [],
            expansion: null,
            sort: 'lot_no'
        }, _this.isFiltersUsed = function () {
            return (0, _isEqual3.default)(_this.getInitialFilters(), _this.state.filters);
        }, _this.isSortable = function (sort) {
            return _this.state.header.find(function (headerCellData) {
                return headerCellData.name === sort && headerCellData.sortLink;
            });
        }, _this.isDateRangeInitial = function () {
            var _this$state$filters = _this.state.filters,
                from = _this$state$filters.from,
                to = _this$state$filters.to;

            var _this$getInitialFilte = _this.getInitialFilters(),
                initialRangeFrom = _this$getInitialFilte.from,
                initialRangeTo = _this$getInitialFilte.to;

            return initialRangeFrom === from && initialRangeTo === to;
        }, _this.handleFiltersChange = function (filters, next) {
            _this.setState({ filters: filters }, function () {
                if (next) {
                    next();
                }
            });
        }, _this.handleFiltersReset = function () {
            _this.setState({
                filters: _this.getInitialFilters(),
                filtersUsed: false,
                data: SearchResults.getInitialData(),
                page: SearchResults.getInitialPage(),
                totalLotsNum: SearchResults.getInitialTotalLotsNum(),
                totalPagesNum: SearchResults.getInitialTotalPagesNum()
            });
        }, _this.handleFiltersSearch = function () {
            if (isRefinementBroad(_this.state.filters)) {
                _this.setState({ lightbox: true });
                return Promise.reject();
            }

            return _this.fetchData({
                filters: _this.state.filters,
                page: SearchResults.getInitialPage()
            }).then(function () {
                _this.setState({
                    filtersUsed: true
                });
            });
        }, _this.handleTableToggle = function (expansion) {
            return _this.setState({
                expansion: expansion === _this.state.expansion ? null : expansion
            });
        }, _this.handleTableSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _this.handlePageChange = function (page) {
            return _this.fetchData({ page: page });
        }, _this.handleLightboxClose = function () {
            return _this.setState({ lightbox: false });
        }, _this.createErrorMessage = function () {
            if (!_this.isDateRangeInitial()) {
                return ERROR_MESSAGE_RANGE;
            } else if (!_this.isFiltersUsed()) {
                return ERROR_MESSAGE_REFINE;
            }
            return ERROR_MESSAGE_RANGE;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResults, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // fetching the data after page being loaded on profiles
            var _props = this.props,
                sireName = _props.sireName,
                from = _props.from,
                to = _props.to;

            if (sireName && from && to) {
                this.fetchData().then(function () {
                    return _this2.setState({ filtersUsed: true });
                });
            }
        }
    }, {
        key: 'getInitialFilters',
        value: function getInitialFilters() {
            var _props2 = this.props,
                from = _props2.from,
                to = _props2.to,
                sireName = _props2.sireName;

            return {
                from: from || (0, _format2.default)((0, _add_months2.default)(new Date(), -1), DATE_FORMAT),
                to: to || (0, _format2.default)(new Date(), DATE_FORMAT),
                sale: '',
                saleCompany: null,
                sex: null,
                age: null,
                name: '',
                sire: sireName,
                dam: '',
                damSire: '',
                vendor: '',
                buyer: '',
                resultsWithSold: false,
                minPrice: null,
                maxPrice: null
            };
        }
    }, {
        key: 'fetchData',
        value: function fetchData(params) {
            var _this3 = this;

            var _state$params = _extends({}, this.state, params),
                filters = _state$params.filters,
                sort = _state$params.sort,
                page = _state$params.page;

            this.setState({ sort: sort, page: page, fetching: true });
            var sireName = this.props.sireName;

            var query = {
                sort: sort,
                page: page,
                q: Object.keys(filters).reduce(function (result, key) {
                    var value = key === _SearchResultsFilters.FILTERS_PROP_SIRE && sireName ? sireName : filters[key];
                    return value ? _extends({}, result, _defineProperty({}, key, value)) : result;
                }, {})
            };
            return (0, _api.callApi)('/bloodstock/sales/search/results/data.json', { query: query }).then(function (data) {
                return _this3.setState({
                    fetching: false,
                    fetchFailed: false,
                    totalLotsNum: data.pagination.totalItems,
                    totalPagesNum: data.pagination.totalPages,
                    page: data.pagination.currentPage,
                    data: data.rows,
                    header: data.header
                });
            }).catch(function () {
                return _this3.setState({
                    fetching: false,
                    fetchFailed: true,
                    totalLotsNum: 0,
                    totalPagesNum: 0,
                    data: [],
                    header: []
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var breakpointCode = this.props.breakpointCode;
            var _state = this.state,
                lightbox = _state.lightbox,
                fetching = _state.fetching,
                filtersUsed = _state.filtersUsed,
                totalPagesNum = _state.totalPagesNum,
                totalLotsNum = _state.totalLotsNum,
                filters = _state.filters,
                page = _state.page,
                data = _state.data,
                expansion = _state.expansion,
                sort = _state.sort;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _SearchResults2.default.filters },
                    _react2.default.createElement(_SearchResultsFilters2.default, {
                        lotsNum: totalLotsNum,
                        resetDisabled: this.isFiltersUsed(),
                        value: filters,
                        breakpointCode: breakpointCode,
                        onChange: this.handleFiltersChange,
                        onReset: this.handleFiltersReset,
                        onSearch: this.handleFiltersSearch,
                        filtersUsed: filtersUsed,
                        filters: filters
                    })
                ),
                _react2.default.createElement(_Lightbox2.default, {
                    open: lightbox,
                    onClose: this.handleLightboxClose
                }),
                (fetching || filtersUsed) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResults2.default.table },
                        _react2.default.createElement(_SearchResultsTable2.default, {
                            breakpointCode: breakpointCode,
                            data: data,
                            canSortByColumn: this.isSortable,
                            loading: fetching,
                            expansion: expansion,
                            sorting: _defineProperty({}, sort, 'asc'),
                            onToggle: this.handleTableToggle,
                            onSort: this.handleTableSort,
                            errorMessage: this.createErrorMessage()
                        })
                    ),
                    _react2.default.createElement(_Pagination2.default, {
                        displayedPagesNum: 5,
                        totalPagesNum: totalPagesNum,
                        page: page,
                        onPageChange: this.handlePageChange
                    })
                )
            );
        }
    }], [{
        key: 'getInitialPage',
        value: function getInitialPage() {
            return 1;
        }
    }, {
        key: 'getInitialData',
        value: function getInitialData() {
            return [];
        }
    }, {
        key: 'getInitialTotalLotsNum',
        value: function getInitialTotalLotsNum() {
            return 0;
        }
    }, {
        key: 'getInitialTotalPagesNum',
        value: function getInitialTotalPagesNum() {
            return 0;
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                sireName: '',
                from: null,
                to: null
            };
        }
    }]);

    return SearchResults;
}(_react.PureComponent);

SearchResults.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    sireName: _propTypes2.default.string,
    from: _propTypes2.default.string,
    to: _propTypes2.default.string
};
exports.default = (0, _Breakpoints.bindCode)(SearchResults);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(45),
    equalArrays = __webpack_require__(49),
    equalByTag = __webpack_require__(127),
    equalObjects = __webpack_require__(130),
    getTag = __webpack_require__(57),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(51),
    isTypedArray = __webpack_require__(53);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(19);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(19);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(19);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(19);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(18);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(18),
    Map = __webpack_require__(34),
    MapCache = __webpack_require__(35);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(15),
    isMasked = __webpack_require__(107),
    isObject = __webpack_require__(16),
    toSource = __webpack_require__(48);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(20);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(108);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(111),
    ListCache = __webpack_require__(18),
    Map = __webpack_require__(34);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(112),
    hashDelete = __webpack_require__(113),
    hashGet = __webpack_require__(114),
    hashHas = __webpack_require__(115),
    hashSet = __webpack_require__(116);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(21);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(21);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(21);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(22);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(22);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(22);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(22);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(35),
    setCacheAdd = __webpack_require__(123),
    setCacheHas = __webpack_require__(124);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(20),
    Uint8Array = __webpack_require__(128),
    eq = __webpack_require__(33),
    equalArrays = __webpack_require__(49),
    mapToArray = __webpack_require__(50),
    setToArray = __webpack_require__(129);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(131);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(132),
    getSymbols = __webpack_require__(134),
    keys = __webpack_require__(36);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(133),
    isArray = __webpack_require__(9);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(135),
    stubArray = __webpack_require__(136);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(138),
    isArguments = __webpack_require__(139),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(51),
    isIndex = __webpack_require__(52),
    isTypedArray = __webpack_require__(53);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(140),
    isObjectLike = __webpack_require__(12);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isLength = __webpack_require__(54),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(46);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(146),
    nativeKeys = __webpack_require__(147);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(55);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var differenceInCalendarMonths = __webpack_require__(154)
var compareAsc = __webpack_require__(155)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 153 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var startOfYear = __webpack_require__(159)
var differenceInCalendarDays = __webpack_require__(160)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(161)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var startOfISOWeek = __webpack_require__(39)
var startOfISOYear = __webpack_require__(164)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(60)
var startOfISOWeek = __webpack_require__(39)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(58)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(167)
var buildFormatLocale = __webpack_require__(168)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 167 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(169)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 169 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.bind = bind;
exports.bindCode = bindCode;

var _rpMqBreakpoints = __webpack_require__(23);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProcessor = function defaultProcessor(breakpoint) {
    return { breakpoint: breakpoint };
};

function bind(Component) {
    var processor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProcessor;

    return function (_PureComponent) {
        _inherits(Breakpoints, _PureComponent);

        function Breakpoints() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Breakpoints);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Breakpoints.__proto__ || Object.getPrototypeOf(Breakpoints)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, processor(_rpMqBreakpoints2.default.current())), _this.handleSwitch = function (ev) {
                _this.setState(processor(ev.detail.breakpoint));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Breakpoints, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                window.addEventListener('rpBreakpointsSwitch', this.handleSwitch);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                window.removeEventListener('rpBreakpointsSwitch', this.handleSwitch);
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, _extends({}, this.props, this.state));
            }
        }]);

        return Breakpoints;
    }(_react.PureComponent);
}

function bindCode(Component) {
    return bind(Component, function (breakpoint) {
        return { breakpointCode: breakpoint.code };
    });
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _range = __webpack_require__(172);

var _range2 = _interopRequireDefault(_range);

var _clamp = __webpack_require__(177);

var _clamp2 = _interopRequireDefault(_clamp);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PaginationNav = __webpack_require__(179);

var _PaginationNav2 = _interopRequireDefault(_PaginationNav);

var _PaginationPage = __webpack_require__(183);

var _PaginationPage2 = _interopRequireDefault(_PaginationPage);

var _Pagination = __webpack_require__(184);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = function (_PureComponent) {
    _inherits(Pagination, _PureComponent);

    function Pagination() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Pagination);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            offset: Pagination.clampOffset(Pagination.calcPageOffset(_this.props), _this.props)
        }, _this.handlePageClick = function (page) {
            return _this.changePage(page);
        }, _this.handlePrevPageClick = function () {
            _this.changePage(_this.props.page - 1);
        }, _this.handleNextPageClick = function () {
            _this.changePage(_this.props.page + 1);
        }, _this.handleLeftOffsetClick = function () {
            _this.setOffset(_this.state.offset - _this.props.displayedPagesNum);
        }, _this.handleRightOffsetClick = function () {
            _this.setOffset(_this.state.offset + _this.props.displayedPagesNum);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Pagination, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            this.setOffset(Pagination.calcPageOffset(props));
        }
    }, {
        key: 'setOffset',
        value: function setOffset(offset) {
            this.setState({
                offset: Pagination.clampOffset(offset, this.props)
            });
        }
    }, {
        key: 'changePage',
        value: function changePage(page) {
            return this.props.onPageChange(page);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                totalPagesNum = _props.totalPagesNum,
                displayedPagesNum = _props.displayedPagesNum,
                page = _props.page;

            if (!totalPagesNum) {
                return null;
            }
            var offset = this.state.offset;

            return _react2.default.createElement(
                'div',
                {
                    className: 'ui-btnGroup ui-btnGroup_pagination rn-pagination'
                },
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: offset <= 0,
                        onClick: this.handleLeftOffsetClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: _Pagination2.default.icon + ' ' + _Pagination2.default.iconLeft,
                        size: 'Medium',
                        iconName: 'expand-all'
                    })
                ),
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: page <= 1,
                        onClick: this.handlePrevPageClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { className: _Pagination2.default.icon, size: 'Medium', iconName: 'left' })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'ui-btn_paginationRange ui-btn' },
                    'Page ',
                    page,
                    ' of ',
                    totalPagesNum
                ),
                (0, _range2.default)(offset, Math.min(offset + displayedPagesNum, totalPagesNum)).map(function (i) {
                    return _react2.default.createElement(_PaginationPage2.default, {
                        key: i,
                        current: i + 1 === page,
                        value: i + 1,
                        onClick: _this2.handlePageClick
                    });
                }),
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: page >= totalPagesNum,
                        onClick: this.handleNextPageClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { className: _Pagination2.default.icon, size: 'Medium', iconName: 'right' })
                ),
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: offset >= totalPagesNum - displayedPagesNum,
                        onClick: this.handleRightOffsetClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: _Pagination2.default.icon + ' ' + _Pagination2.default.iconRight,
                        size: 'Medium',
                        iconName: 'expand-all'
                    })
                )
            );
        }
    }], [{
        key: 'clampOffset',
        value: function clampOffset(offset, _ref2) {
            var totalPagesNum = _ref2.totalPagesNum,
                displayedPagesNum = _ref2.displayedPagesNum;

            return (0, _clamp2.default)(offset, 0, totalPagesNum - displayedPagesNum);
        }
    }, {
        key: 'calcPageOffset',
        value: function calcPageOffset(_ref3) {
            var page = _ref3.page,
                displayedPagesNum = _ref3.displayedPagesNum;

            return Math.floor(page - displayedPagesNum / 2);
        }
    }]);

    return Pagination;
}(_react.PureComponent);

Pagination.propTypes = {
    totalPagesNum: _propTypes2.default.number.isRequired,
    displayedPagesNum: _propTypes2.default.number,
    page: _propTypes2.default.number.isRequired,
    onPageChange: _propTypes2.default.func.isRequired
};
Pagination.defaultProps = {
    displayedPagesNum: 10
};
exports.default = Pagination;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(173);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(174),
    isIterateeCall = __webpack_require__(175),
    toFinite = __webpack_require__(176);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(33),
    isArrayLike = __webpack_require__(56),
    isIndex = __webpack_require__(52),
    isObject = __webpack_require__(16);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(40);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(178),
    toNumber = __webpack_require__(40);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PaginationNav;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PaginationNav = __webpack_require__(180);

var _PaginationNav2 = _interopRequireDefault(_PaginationNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaginationNav(_ref) {
    var children = _ref.children,
        disabled = _ref.disabled,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'button',
        {
            className: (0, _classnames2.default)(_PaginationNav2.default.root, 'ui-btn', { 'ui-btn--disabled': disabled }),
            disabled: disabled,
            onClick: onClick
        },
        children
    );
}

PaginationNav.propTypes = {
    children: _propTypes2.default.node,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

PaginationNav.defaultProps = {
    children: null,
    disabled: false,
    onClick: null
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(181);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./PaginationNav.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./PaginationNav.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".PaginationNav__root___2pSil {\n  width: 32px;\n  text-align: center; }\n", ""]);

// exports
exports.locals = {
	"root": "PaginationNav__root___2pSil"
};

/***/ }),
/* 182 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationPage = function (_PureComponent) {
    _inherits(PaginationPage, _PureComponent);

    function PaginationPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PaginationPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationPage.__proto__ || Object.getPrototypeOf(PaginationPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            var _this$props = _this.props,
                value = _this$props.value,
                onClick = _this$props.onClick;

            onClick(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PaginationPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                current = _props.current,
                value = _props.value;

            return _react2.default.createElement(
                'button',
                {
                    className: (0, _classnames2.default)('ui-btn ui-btn_paginationItem', { 'ui-btn_primary': current }),
                    disabled: current,
                    onClick: this.handleClick
                },
                value
            );
        }
    }]);

    return PaginationPage;
}(_react.PureComponent);

exports.default = PaginationPage;


PaginationPage.propTypes = {
    current: _propTypes2.default.bool,
    value: _propTypes2.default.number.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

PaginationPage.defaultProps = {
    current: false
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(185);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Pagination.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Pagination.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".Pagination__icon___2Jufl {\n  margin: auto !important; }\n  .Pagination__iconLeft___2s-E7 {\n    transform: rotate(90deg); }\n  .Pagination__iconRight___1S0t7 {\n    transform: rotate(-90deg); }\n", ""]);

// exports
exports.locals = {
	"icon": "Pagination__icon___2Jufl",
	"iconLeft": "Pagination__iconLeft___2s-E7",
	"iconRight": "Pagination__iconRight___1S0t7"
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FILTERS_PROP_ONLY_SOLD = exports.FILTERS_PROP_MAX_PRICE = exports.FILTERS_PROP_MIN_PRICE = exports.FILTERS_PROP_BUYER = exports.FILTERS_PROP_VENDOR = exports.FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM = exports.FILTERS_PROP_SIRE = exports.FILTERS_PROP_NAME = exports.FILTERS_PROP_AGE = exports.FILTERS_PROP_SEX = exports.FILTERS_PROP_SALE_COMPANY = exports.FILTERS_PROP_SALE = exports.FITLERS_PROP_TO = exports.FITLERS_PROP_FROM = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filtersLabels, _propTypes$shape;

var _capitalize2 = __webpack_require__(187);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _format = __webpack_require__(38);

var _format2 = _interopRequireDefault(_format);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _api = __webpack_require__(7);

var _Filters = __webpack_require__(68);

var _DatePicker = __webpack_require__(222);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Checkbox = __webpack_require__(70);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Sale = __webpack_require__(232);

var _Sale2 = _interopRequireDefault(_Sale);

var _SearchResultsFilters = __webpack_require__(236);

var _SearchResultsFilters2 = _interopRequireDefault(_SearchResultsFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TAB_SALE = 'TAB_SALE';
var TAB_HORSE = 'TAB_HORSE';
var TAB_PEDIGREE = 'TAB_PEDIGREE';
var TAB_VENDOR_BUYER = 'TAB_VENDOR_BUYER';
var TAB_PRICE_RANGE = 'TAB_PRICE_RANGE';

var ONLY_SOLD_LABEL = 'Show only sold lots';

var DATE_MIN_THRESHOLD = '1991-01-01';

var EXTRA_NARROW = _Breakpoints.codes.EXTRA_NARROW,
    NARROW = _Breakpoints.codes.NARROW,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;


var SEX_OPTIONS = [{ label: 'Colt', value: 'C' }, { label: 'Filly', value: 'F' }, { label: 'Gelding', value: 'G' }, { label: 'Horse', value: 'H' }, { label: 'Mare', value: 'M' }, { label: 'Rig', value: 'R' }];

var AGE_OPTIONS = [{ label: 'Foal', value: '0' }, { label: 'Yearling', value: '1' }, { label: '2-y-o', value: '2' }, { label: 'Older horses', value: '3+' }];

var PRICE_OPTIONS = [{ label: '£10,000', value: 10000 }, { label: '£20,000', value: 20000 }, { label: '£30,000', value: 30000 }, { label: '£40,000', value: 40000 }, { label: '£50,000', value: 50000 }, { label: '£100,000', value: 100000 }, { label: '£200,000', value: 200000 }, { label: '£300,000', value: 300000 }, { label: '£400,000', value: 400000 }, { label: '£500,000 +', value: '' }];

var FITLERS_PROP_FROM = exports.FITLERS_PROP_FROM = 'from';
var FITLERS_PROP_TO = exports.FITLERS_PROP_TO = 'to';
var FILTERS_PROP_SALE = exports.FILTERS_PROP_SALE = 'sale';
var FILTERS_PROP_SALE_COMPANY = exports.FILTERS_PROP_SALE_COMPANY = 'saleCompany';
var FILTERS_PROP_SEX = exports.FILTERS_PROP_SEX = 'sex';
var FILTERS_PROP_AGE = exports.FILTERS_PROP_AGE = 'age';
var FILTERS_PROP_NAME = exports.FILTERS_PROP_NAME = 'name';
var FILTERS_PROP_SIRE = exports.FILTERS_PROP_SIRE = 'sire';
var FILTERS_PROP_DAM = exports.FILTERS_PROP_DAM = 'dam';
var FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM_SIRE = 'damSire';
var FILTERS_PROP_VENDOR = exports.FILTERS_PROP_VENDOR = 'vendor';
var FILTERS_PROP_BUYER = exports.FILTERS_PROP_BUYER = 'buyer';
var FILTERS_PROP_MIN_PRICE = exports.FILTERS_PROP_MIN_PRICE = 'minPrice';
var FILTERS_PROP_MAX_PRICE = exports.FILTERS_PROP_MAX_PRICE = 'maxPrice';
var FILTERS_PROP_ONLY_SOLD = exports.FILTERS_PROP_ONLY_SOLD = 'resultsWithSold';

var filtersLabels = (_filtersLabels = {}, _defineProperty(_filtersLabels, FILTERS_PROP_SALE, 'Sale'), _defineProperty(_filtersLabels, FILTERS_PROP_SALE_COMPANY, 'Sale Company'), _defineProperty(_filtersLabels, FILTERS_PROP_SEX, 'Sex'), _defineProperty(_filtersLabels, FILTERS_PROP_AGE, 'Age'), _defineProperty(_filtersLabels, FILTERS_PROP_NAME, 'Name'), _defineProperty(_filtersLabels, FILTERS_PROP_SIRE, 'Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM, 'Dam'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM_SIRE, 'Dam\'s Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_VENDOR, 'Vendor'), _defineProperty(_filtersLabels, FILTERS_PROP_BUYER, 'Buyer'), _filtersLabels);

var SearchResultsFilters = function (_PureComponent) {
    _inherits(SearchResultsFilters, _PureComponent);

    function SearchResultsFilters() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResultsFilters);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsFilters.__proto__ || Object.getPrototypeOf(SearchResultsFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            tab: TAB_SALE,
            open: true,
            saleCompanyOptions: { data: [], fetched: false },
            history: [],
            appliedFilters: []
        }, _this.getNavAlign = function () {
            var breakpointCode = _this.props.breakpointCode;


            switch (breakpointCode) {
                case EXTRA_NARROW:
                    return _Filters.FiltersNav.ALIGN_HORIZONTAL;
                default:
                    return _Filters.FiltersNav.ALIGN_VERTICAL;
            }
        }, _this.getNavOptions = function () {
            var breakpointCode = _this.props.breakpointCode;


            var getVendorLabel = function getVendorLabel() {
                switch (breakpointCode) {
                    case EXTRA_NARROW:
                        return 'V / B';
                    case NARROW:
                        return 'Ven / Buy';
                    default:
                        return 'Vendor / Buyer';
                }
            };

            return [{ label: 'Sale', value: TAB_SALE }, { label: 'Horse', value: TAB_HORSE }, { label: 'Pedigree', value: TAB_PEDIGREE }, { label: getVendorLabel(), value: TAB_VENDOR_BUYER }, { label: 'Price Range', value: TAB_PRICE_RANGE }];
        }, _this.getPriceMinOptions = function () {
            var filters = _this.props.filters;

            var maxPrice = filters[FILTERS_PROP_MAX_PRICE];

            return PRICE_OPTIONS.filter(function (option) {
                return option.value !== '' && (maxPrice ? option.value < maxPrice : true);
            });
        }, _this.getPriceMaxOptions = function () {
            var filters = _this.props.filters;

            var minPrice = filters[FILTERS_PROP_MIN_PRICE];

            return PRICE_OPTIONS.filter(function (option) {
                return option.value === '' || option.value > minPrice;
            });
        }, _this.handleTabChange = function (tab) {
            return _this.setState({ tab: tab });
        }, _this.handleFiltersVisibilityChange = function () {
            _this.setState({
                open: !_this.state.open
            });
        }, _this.handleResetClick = function () {
            _this.setState({ history: [] });
            return _this.props.onReset();
        }, _this.handleSearchClick = function () {
            _this.props.onSearch().then(function () {
                _this.setState({
                    appliedFilters: [].concat(_toConsumableArray(_this.state.history))
                });
            });
        }, _this.createFilterChangeHandler = function (prop) {
            return function (value, option) {
                var filters = _this.props.filters;

                if (filters[prop] === value) {
                    return;
                }

                var shouldUpdateHistory = ![FITLERS_PROP_FROM, FITLERS_PROP_TO, FILTERS_PROP_MIN_PRICE, FILTERS_PROP_MAX_PRICE].includes(prop);
                if (shouldUpdateHistory) {
                    _this.setState({
                        history: _this.state.history.filter(function (item) {
                            return item.prop !== prop;
                        }).concat(value ? {
                            prop: prop,
                            value: function () {
                                switch (prop) {
                                    case FILTERS_PROP_ONLY_SOLD:
                                        return ONLY_SOLD_LABEL;
                                    case FILTERS_PROP_SALE_COMPANY:
                                        return option.name;
                                    case FILTERS_PROP_SEX:
                                    case FILTERS_PROP_AGE:
                                        return option.label;
                                    default:
                                        return value;
                                }
                            }()
                        } : [])
                    });
                }

                var shouldTriggerSearchAutomatically = [FITLERS_PROP_FROM, FITLERS_PROP_TO, FILTERS_PROP_MIN_PRICE, FILTERS_PROP_MAX_PRICE, FILTERS_PROP_SALE_COMPANY, FILTERS_PROP_SEX, FILTERS_PROP_AGE, FILTERS_PROP_ONLY_SOLD].includes(prop);

                _this.props.onChange(_extends({}, filters, _defineProperty({}, prop, value)), shouldTriggerSearchAutomatically && _this.handleSearchClick);
            };
        }, _this.filterChangeHandlers = [FITLERS_PROP_FROM, FITLERS_PROP_TO, FILTERS_PROP_SALE, FILTERS_PROP_SALE_COMPANY, FILTERS_PROP_SEX, FILTERS_PROP_AGE, FILTERS_PROP_NAME, FILTERS_PROP_SIRE, FILTERS_PROP_DAM, FILTERS_PROP_DAM_SIRE, FILTERS_PROP_VENDOR, FILTERS_PROP_BUYER, FILTERS_PROP_ONLY_SOLD, FILTERS_PROP_MIN_PRICE, FILTERS_PROP_MAX_PRICE].reduce(function (result, prop) {
            return _extends({}, result, _defineProperty({}, prop, _this.createFilterChangeHandler(prop)));
        }, {}), _this.handleSaleCompanyOpen = function () {
            if (_this.state.saleCompanyOptions.fetched) {
                return null;
            }
            return (0, _api.callApi)('/bloodstock/sales/search/company/data.json').then(function (options) {
                _this.setState({
                    saleCompanyOptions: { data: [].concat(_toConsumableArray(options)), fetched: true }
                });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResultsFilters, [{
        key: 'getFilterProps',
        value: function getFilterProps() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                prop = _ref2.prop,
                _ref2$label = _ref2.label,
                label = _ref2$label === undefined ? (0, _capitalize3.default)(prop) : _ref2$label,
                _ref2$className = _ref2.className,
                className = _ref2$className === undefined ? _SearchResultsFilters2.default.filter : _ref2$className;

            return {
                className: className,
                label: label,
                value: this.props.filters[prop],
                onChange: this.filterChangeHandlers[prop]
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                filters = _props.filters,
                filtersUsed = _props.filtersUsed,
                lotsNum = _props.lotsNum,
                resetDisabled = _props.resetDisabled,
                breakpointCode = _props.breakpointCode;
            var _state = this.state,
                saleCompanyOptions = _state.saleCompanyOptions,
                tab = _state.tab,
                appliedFilters = _state.appliedFilters,
                open = _state.open;

            var toNarrow = [NARROW, EXTRA_NARROW].includes(breakpointCode);
            var toWide = [WIDE, EXTRA_WIDE].includes(breakpointCode);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFilters2.default.top },
                    toNarrow && _react2.default.createElement(_Filters.FiltersToggle, {
                        className: _SearchResultsFilters2.default.toggle,
                        open: open,
                        onClick: this.handleFiltersVisibilityChange
                    }),
                    _react2.default.createElement(
                        'h2',
                        { className: _SearchResultsFilters2.default.heading },
                        'Refine Search Results'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _SearchResultsFilters2.default.description },
                        'For Sales Results searches on a date range larger than 30 days you will need to apply two filters below on the Sale Name, Horse name, pedigree, vendor or price range'
                    )
                ),
                (open || !toNarrow) && _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFilters2.default.center },
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResultsFilters2.default.nav },
                        _react2.default.createElement(_Filters.FiltersNav, {
                            name: 'tab',
                            align: this.getNavAlign(),
                            options: this.getNavOptions(),
                            value: tab,
                            onChange: this.handleTabChange
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.datepicker },
                            _react2.default.createElement(_DatePicker2.default, _extends({
                                displayFormat: 'DD MMM YYYY',
                                min: DATE_MIN_THRESHOLD,
                                max: filters[FITLERS_PROP_TO]
                            }, this.getFilterProps({
                                prop: FITLERS_PROP_FROM,
                                label: 'From',
                                className: _SearchResultsFilters2.default.date
                            }))),
                            _react2.default.createElement(_DatePicker2.default, _extends({
                                displayFormat: 'DD MMM YYYY',
                                min: filters[FITLERS_PROP_FROM],
                                max: (0, _format2.default)(new Date(), 'YYYY-MM-DD')
                            }, this.getFilterProps({
                                prop: FITLERS_PROP_TO,
                                label: 'To',
                                className: _SearchResultsFilters2.default.date
                            })))
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.lotsFilter },
                            _react2.default.createElement(_Checkbox2.default, this.getFilterProps({
                                prop: FILTERS_PROP_ONLY_SOLD,
                                label: ONLY_SOLD_LABEL
                            }))
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResultsFilters2.default.center + ' ' + _SearchResultsFilters2.default.content },
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.form },
                            function () {
                                switch (tab) {
                                    case TAB_SALE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Sale2.default, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SALE
                                            })),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SALE_COMPANY,
                                                label: 'Sale Company'
                                            }), {
                                                labelGetter: 'name',
                                                options: saleCompanyOptions.data,
                                                onOpen: _this2.handleSaleCompanyOpen
                                            }))
                                        );
                                    case TAB_HORSE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SEX
                                            }), {
                                                options: SEX_OPTIONS
                                            })),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_AGE
                                            }), {
                                                options: AGE_OPTIONS
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_NAME
                                            }))
                                        );
                                    case TAB_PEDIGREE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SIRE
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_DAM
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_DAM_SIRE,
                                                label: 'Dam\'s Sire'
                                            }))
                                        );
                                    case TAB_VENDOR_BUYER:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_VENDOR,
                                                label: 'Vendor Name'
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_BUYER,
                                                label: 'Buyer Name'
                                            }))
                                        );
                                    case TAB_PRICE_RANGE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_MIN_PRICE,
                                                label: 'Price Range Min'
                                            }), {
                                                options: _this2.getPriceMinOptions(),
                                                optionsSorter: null
                                            })),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_MAX_PRICE,
                                                label: 'Price Range Max'
                                            }), {
                                                options: _this2.getPriceMaxOptions(),
                                                optionsSorter: null
                                            }))
                                        );
                                    default:
                                        return null;
                                }
                            }()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.lots },
                            _react2.default.createElement(
                                'div',
                                { className: _SearchResultsFilters2.default.lotsInfo },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    'Lots found'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _SearchResultsFilters2.default.lotsNum,
                                        'data-test-selector': 'lots_found_right_block'
                                    },
                                    lotsNum
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResultsFilters2.default.buttons },
                        _react2.default.createElement(_Filters.FiltersReset, {
                            className: _SearchResultsFilters2.default.reset,
                            disabled: resetDisabled,
                            onClick: this.handleResetClick
                        }),
                        _react2.default.createElement(
                            'button',
                            {
                                className: _SearchResultsFilters2.default.search + ' ui-btn ui-btn_primary',
                                onClick: this.handleSearchClick
                            },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Search'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFilters2.default.history },
                    filtersUsed && appliedFilters.length > 0 && toWide && _react2.default.createElement(
                        'span',
                        { 'data-test-selector': 'filters_applied' },
                        'Filters Applied: ',
                        appliedFilters.map(function (item) {
                            if (item.prop === FILTERS_PROP_ONLY_SOLD) {
                                return item.value;
                            }
                            return filtersLabels[item.prop] + ' -\n                                        ' + item.value.charAt(0).toUpperCase().concat(item.value.slice(1));
                        }).join(', ')
                    )
                )
            );
        }
    }], [{
        key: 'defaultProps',
        get: function get() {
            return {
                resetDisabled: false
            };
        }
    }]);

    return SearchResultsFilters;
}(_react.PureComponent);

SearchResultsFilters.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    filters: _propTypes2.default.shape((_propTypes$shape = {}, _defineProperty(_propTypes$shape, FITLERS_PROP_FROM, _propTypes2.default.string), _defineProperty(_propTypes$shape, FITLERS_PROP_TO, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SALE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SALE_COMPANY, _propTypes2.default.number), _defineProperty(_propTypes$shape, FILTERS_PROP_SEX, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_AGE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_NAME, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_VENDOR, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_BUYER, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_MIN_PRICE, _propTypes2.default.number), _defineProperty(_propTypes$shape, FILTERS_PROP_MAX_PRICE, _propTypes2.default.number), _propTypes$shape)).isRequired,
    filtersUsed: _propTypes2.default.bool.isRequired,
    lotsNum: _propTypes2.default.number.isRequired,
    resetDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onReset: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired
};
exports.default = SearchResultsFilters;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(25),
    upperFirst = __webpack_require__(188);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(189);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(64),
    hasUnicode = __webpack_require__(65),
    stringToArray = __webpack_require__(66),
    toString = __webpack_require__(25);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_193__;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(55);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(0), __webpack_require__(4), __webpack_require__(5), __webpack_require__(26), __webpack_require__(67));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "rp-react-svg-icon", "classnames", "qs", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["rpAuth"] = factory(require("prop-types"), require("react"), require("rp-react-svg-icon"), require("classnames"), require("qs"), require("react-dom"));
	else
		root["rpAuth"] = factory(root["prop-types"], root["react"], root["rp-react-svg-icon"], root["classnames"], root["qs"], root["react-dom"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_70__, __WEBPACK_EXTERNAL_MODULE_83__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 98);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRAIT_ORDER_ID = exports.TRAIT_ORDER_ID = 'Order ID';
var TRAIT_COUPON_ID = exports.TRAIT_COUPON_ID = 'Coupon ID';
var TRAIT_DISCOUNT = exports.TRAIT_DISCOUNT = 'Discount';
var TRAIT_PRODUCT_ID = exports.TRAIT_PRODUCT_ID = 'Product ID';
var TRAIT_TOTAL = exports.TRAIT_TOTAL = 'Total';
var TRAIT_NAME = exports.TRAIT_NAME = 'Name';
var TRAIT_PRICE = exports.TRAIT_PRICE = 'Price';
var TRAIT_AFFILIATION = exports.TRAIT_AFFILIATION = 'Affiliation';
var TRAIT_CATEGORY = exports.TRAIT_CATEGORY = 'Category';
var TRAIT_QUANTITY = exports.TRAIT_QUANTITY = 'Quantity';
var TRAIT_CHECKOUT_ID = exports.TRAIT_CHECKOUT_ID = 'Checkout ID';
var TRAIT_PRODUCTS = exports.TRAIT_PRODUCTS = 'Products';
var TRAIT_STEP = exports.TRAIT_STEP = 'Step';
var TRAIT_LOCATION = exports.TRAIT_LOCATION = 'Location';
var TRAIT_POSITION = exports.TRAIT_POSITION = 'Position';
var TRAIT_BOOKMAKER = exports.TRAIT_BOOKMAKER = 'Bookmaker';
var TRAIT_BOOKMAKER_OFFER = exports.TRAIT_BOOKMAKER_OFFER = 'Bookmaker Offer';
var TRAIT_PRODUCT = exports.TRAIT_PRODUCT = 'Product';
var TRAIT_CURRENCY = exports.TRAIT_CURRENCY = 'Currency';

var TRAIT_ODDS = exports.TRAIT_ODDS = 'Odds';
var TRAIT_RACE_ID = exports.TRAIT_RACE_ID = 'Race ID';
var TRAIT_RACE_DATE = exports.TRAIT_RACE_DATE = 'Race date';
var TRAIT_RACE_TIME = exports.TRAIT_RACE_TIME = 'Race time';
var TRAIT_RACE_OFFERS_AVAILABLE = exports.TRAIT_RACE_OFFERS_AVAILABLE = 'Offer Available';
var TRAIT_TIME_OF_EVENT = exports.TRAIT_TIME_OF_EVENT = 'Time of event';
var TRAIT_RACECOURSE = exports.TRAIT_RACECOURSE = 'Racecourse';
var TRAIT_HORSE_NAME = exports.TRAIT_HORSE_NAME = 'Horse Name';
var TRAIT_BET_DATE = exports.TRAIT_BET_DATE = 'Bet Date';
var TRAIT_BETSLIP_ID = exports.TRAIT_BETSLIP_ID = 'Betslip ID';
var TRAIT_RECEIPT_ID = exports.TRAIT_RECEIPT_ID = 'Bet receipt ID';
var TRAIT_RECEIPT_TYPE = exports.TRAIT_RECEIPT_TYPE = 'Bet Receipt Type';
var TRAIT_BET_COUNT = exports.TRAIT_BET_COUNT = 'Bet Count';
var TRAIT_BET_TYPE = exports.TRAIT_BET_TYPE = 'Bet Type';
var TRAIT_STAKE = exports.TRAIT_STAKE = 'Stake';
var TRAIT_WIN_EW = exports.TRAIT_WIN_EW = 'Win / EW';
var TRAIT_API_OUTCOME = exports.TRAIT_API_OUTCOME = 'API Outcome';
var TRAIT_COUPON = exports.TRAIT_COUPON = 'Coupon';
var TRAIT_REVENUE = exports.TRAIT_REVENUE = 'Revenue';
var TRAIT_PACKAGE = exports.TRAIT_PACKAGE = 'Package';
var TRAIT_STATUS = exports.TRAIT_STATUS = 'Status';

var TRAIT_REWARDS_FOR_RACING = exports.TRAIT_REWARDS_FOR_RACING = 'Rewards For Racing';
var TRAIT_DAILY_CONTACT = exports.TRAIT_DAILY_CONTACT = 'Daily Contact';
var TRAIT_FIRST_NAME = exports.TRAIT_FIRST_NAME = 'First Name';
var TRAIT_LAST_NAME = exports.TRAIT_LAST_NAME = 'Last Name';
var TRAIT_PHONE_NUMBER = exports.TRAIT_PHONE_NUMBER = 'Phone Number';

var TRAIT_EMAIL = exports.TRAIT_EMAIL = 'Email';
var TRAIT_CREATED_AT = exports.TRAIT_CREATED_AT = 'Created At';
var TRAIT_OUTCOME = exports.TRAIT_OUTCOME = 'Outcome';
var TRAIT_ERROR = exports.TRAIT_ERROR = 'Error';

var TRAIT_RACINGPOST_CONTACT = exports.TRAIT_RACINGPOST_CONTACT = 'Racing Post Contact';
var TRAIT_THIRDPARTY_CONTACT = exports.TRAIT_THIRDPARTY_CONTACT = 'Third Party Contact';

var TRAIT_DEVICE_TYPE = exports.TRAIT_DEVICE_TYPE = 'Device Type';
var TRAIT_USER_NAME = exports.TRAIT_USER_NAME = 'Username';
var TRAIT_USER_ID = exports.TRAIT_USER_ID = 'User Id';
var TRAIT_LOGGED_IN_STATUS = exports.TRAIT_LOGGED_IN_STATUS = 'Logged In Status';
var TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = exports.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = 'Betting Account Logged In Status';

var TRAIT_PACKAGE_ORIGIN = exports.TRAIT_PACKAGE_ORIGIN = 'Package Origin';
var TRAIT_PACKAGE_DESTINATION = exports.TRAIT_PACKAGE_DESTINATION = 'Package Destination';

var TRAIT_LAST_CHANGED_OPTION = exports.TRAIT_LAST_CHANGED_OPTION = 'Last Changed Option';

var TRAIT_RACE_CONDITIONS = exports.TRAIT_RACE_CONDITIONS = 'Race Conditions';
var TRAIT_FORM = exports.TRAIT_FORM = 'Form';
var TRAIT_MY_NOTES = exports.TRAIT_MY_NOTES = 'My Notes';
var TRAIT_SPOTLIGHTS = exports.TRAIT_SPOTLIGHTS = 'Spotlights';
var TRAIT_COMMENTS = exports.TRAIT_COMMENTS = 'Comments';
var TRAIT_OWNER = exports.TRAIT_OWNER = 'Owner';
var TRAIT_QUOTES = exports.TRAIT_QUOTES = 'Quotes';
var TRAIT_PEDIGREES = exports.TRAIT_PEDIGREES = 'Pedigrees';
var TRAIT_RTF = exports.TRAIT_RTF = 'RTF%';
var TRAIT_DECIMAL_ODDS = exports.TRAIT_DECIMAL_ODDS = 'Decimal Odds';
var TRAIT_PRICE_HISTORY = exports.TRAIT_PRICE_HISTORY = 'Price History';
var TRAIT_ORDER_BY_PRICE = exports.TRAIT_ORDER_BY_PRICE = 'Order by Price';
var TRAIT_BETTING_FORCAST = exports.TRAIT_BETTING_FORCAST = 'Betting Forecast';
var TRAIT_MY_RATINGS = exports.TRAIT_MY_RATINGS = 'My Ratings';
var TRAIT_SHOW_PRICES = exports.TRAIT_SHOW_PRICES = 'Show Prices';

var TRAIT_HORSE_ENTERED = exports.TRAIT_HORSE_ENTERED = 'Horse Entered';
var TRAIT_HORSE_DECLARED = exports.TRAIT_HORSE_DECLARED = 'Horse Declared';
var TRAIT_SHOW_PEDIGREE = exports.TRAIT_SHOW_PEDIGREE = 'Show Pedigree';

var TRAIT_SELECTION = exports.TRAIT_SELECTION = 'Selection';

var TRAIT_SITE_SECTION = exports.TRAIT_SITE_SECTION = 'Site Section';
var TRAIT_SITE_SUB_SECTION_1 = exports.TRAIT_SITE_SUB_SECTION_1 = 'Site Sub Section 1';
var TRAIT_SITE_SUB_SECTION_2 = exports.TRAIT_SITE_SUB_SECTION_2 = 'Site Sub Section 2';

var TRAIT_HORSE_BETTING = exports.TRAIT_HORSE_BETTING = 'Communication Horse Betting';
var TRAIT_HORSE_NEWS = exports.TRAIT_HORSE_NEWS = 'Communication Horse News';
var TRAIT_COMPETITIONS = exports.TRAIT_COMPETITIONS = 'Communication Competitions';
var TRAIT_BLOODSTOCK = exports.TRAIT_BLOODSTOCK = 'Communication Bloodstock';
var TRAIT_SPORT_BETTING = exports.TRAIT_SPORT_BETTING = 'Communication Sport Betting';
var TRAIT_OVER_EIGHTEEN = exports.TRAIT_OVER_EIGHTEEN = 'Communication Eighteen';
var TRAIT_DAYLY_UPDATES = exports.TRAIT_DAYLY_UPDATES = 'Daily Contact';
var TRAIT_R4R = exports.TRAIT_R4R = 'Rewards For Racing';
var TRAIT_THIRD_PARTY = exports.TRAIT_THIRD_PARTY = 'Third Party Contact';

var TRAIT_ACCORDION_NAME = exports.TRAIT_ACCORDION_NAME = 'Accordion Name';

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(126);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Event's name for tracking
 * @type {string}
 */
var EVENT_LOG_IN = exports.EVENT_LOG_IN = 'Login';
var EVENT_EMAIL_VERIFICATION = exports.EVENT_EMAIL_VERIFICATION = 'Email Verified';
var EVENT_REGISTRATION = exports.EVENT_REGISTRATION = 'Registration Complete';
var EVENT_SUBSCRIPTION_SALE_ATTEMPT = exports.EVENT_SUBSCRIPTION_SALE_ATTEMPT = 'Subscription Sale Attempt';
var EVENT_SUBSCRIPTION_SALE = exports.EVENT_SUBSCRIPTION_SALE = 'Subscription Sale';

var EVENT_BOOKMAKER_OPEN_ACCOUNT = exports.EVENT_BOOKMAKER_OPEN_ACCOUNT = 'Bookmaker Open Account';
var EVENT_BOOKMAKER_LOGIN = exports.EVENT_BOOKMAKER_LOGIN = 'Bookmaker Login';
var EVENT_BOOKMAKER_LOGIN_SUCCESS = exports.EVENT_BOOKMAKER_LOGIN_SUCCESS = 'Bookmaker Login Success';
var EVENT_BOOKMAKER_LOGIN_FAILURE = exports.EVENT_BOOKMAKER_LOGIN_FAILURE = 'Bookmaker Login Failure';
var EVENT_BOOKMAKER_LOGIN_ATTEMPT = exports.EVENT_BOOKMAKER_LOGIN_ATTEMPT = 'Bookmaker Login Attempt';
var EVENT_BOOKMAKER_REGISTER_BUTTON = exports.EVENT_BOOKMAKER_REGISTER_BUTTON = 'Bookmaker Register Button';
var EVENT_BOOKMAKER_PLACE_BET = exports.EVENT_BOOKMAKER_PLACE_BET = 'Place Bet';
var EVENT_BOOKMAKER_BET_RECEIPT = exports.EVENT_BOOKMAKER_BET_RECEIPT = 'Bet Receipt';
var EVENT_BOOKMAKER_OFFER_CLAIM_CLICK = exports.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK = 'Bookmaker Offer Claim Button';

var EVENT_BETSLIP_ERROR_MESSAGE = exports.EVENT_BETSLIP_ERROR_MESSAGE = 'Betslip Error Message';

var EVENT_BET_BUTTON_CLICK = exports.EVENT_BET_BUTTON_CLICK = 'Odds Button';
var EVENT_REMOVE_SELECTION_BUTTON_CLICK = exports.EVENT_REMOVE_SELECTION_BUTTON_CLICK = 'Remove Selection';
var EVENT_QUICK_STAKE_BUTTONS_CLICK = exports.EVENT_QUICK_STAKE_BUTTONS_CLICK = 'Quick Stake Buttons';
var EVENT_CANCEL_BET_BUTTON_CLICK = exports.EVENT_CANCEL_BET_BUTTON_CLICK = 'Cancel Bet';
var EVENT_DISCARD_SLIP_CLICK = exports.EVENT_DISCARD_SLIP_CLICK = 'Discard Slip';

var EVENT_CARD_CUSTOMISATION = exports.EVENT_CARD_CUSTOMISATION = 'Card Customisation';
var EVENT_HORSE_TRACKING_SETTINGS = exports.EVENT_HORSE_TRACKING_SETTINGS = 'Horse Tracker Settings';

var EVENT_NAVIGATION_CLICK = exports.EVENT_NAVIGATION_CLICK = 'Navigation Click';
var EVENT_FOOTER_CLICK = exports.EVENT_FOOTER_CLICK = 'Footer Click';

var EVENT_BARRIER_SHOW = exports.EVENT_BARRIER_SHOW = 'Barrier';
var EVENT_BARRIER_SUBSCRIBE = exports.EVENT_BARRIER_SUBSCRIBE = 'Barrier Subscribe';
var EVENT_BARRIER_SIGN_IN = exports.EVENT_BARRIER_SIGN_IN = 'Barrier Sign In';

var EVENT_BARRIER_ESSENTIAL_SHOW = exports.EVENT_BARRIER_ESSENTIAL_SHOW = 'Essential subscribe barrier';
var EVENT_BARRIER_ESSENTIAL_SUBSCRIBE = exports.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE = 'Subscribe essential barrier';

var EVENT_BARRIER_ULTIMATE_SHOW = exports.EVENT_BARRIER_ULTIMATE_SHOW = 'Ultimate subscribe barrier';
var EVENT_BARRIER_ULTIMATE_SUBSCRIBE = exports.EVENT_BARRIER_ULTIMATE_SUBSCRIBE = 'Subscribe ultimate barrier';

var EVENT_BARRIER_ULTIMATE_ONLY_SHOW = exports.EVENT_BARRIER_ULTIMATE_ONLY_SHOW = 'Ultimate upgrade barrier';
var EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE = exports.EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE = 'Upgrade ultimate barrier';

var EVENT_BARRIER_SIGNIN_SHOW = exports.EVENT_BARRIER_SIGNIN_SHOW = 'Sign in';
var EVENT_BARRIER_SIGNIN_PASSWORD = exports.EVENT_BARRIER_SIGNIN_PASSWORD = 'Forgotten password';

var EVENT_BETTING_OFFER_CLICK = exports.EVENT_BETTING_OFFER_CLICK = 'Betting Offer Click';

var EVENT_CHECKOUT_STARTED = exports.EVENT_CHECKOUT_STARTED = 'Checkout Started';
var EVENT_CHECKOUT_STEP_VIEWED = exports.EVENT_CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed';
var EVENT_CHECKOUT_STEP_COMPLETED = exports.EVENT_CHECKOUT_STEP_COMPLETED = 'Checkout Step Completed';

var EVENT_COUPON_ENTERED = exports.EVENT_COUPON_ENTERED = 'Coupon Entered';
var EVENT_COUPON_DENIED = exports.EVENT_COUPON_DENIED = 'Coupon Denied';
var EVENT_COUPON_REMOVED = exports.EVENT_COUPON_REMOVED = 'Coupon Removed';
var EVENT_COUPON_APPLIED = exports.EVENT_COUPON_APPLIED = 'Coupon Applied';

var EVENT_OFFER_ACCORDION_CLOSED = exports.EVENT_OFFER_ACCORDION_CLOSED = 'Offer Accordion Closed';
var EVENT_OFFER_ACCORDION_OPENED = exports.EVENT_OFFER_ACCORDION_OPENED = 'Offer Accordion Opened';
var EVENT_ORDER_COMPLETED = exports.EVENT_ORDER_COMPLETED = 'Order Completed';

var EVENT_PACKAGE_UPGRADE = exports.EVENT_PACKAGE_UPGRADE = 'Package Upgrade';
var EVENT_PREFERENCE_UPDATE = exports.EVENT_PREFERENCE_UPDATE = 'Preference Update';

var EVENT_BLUKAI_ODDS_BUTTON_CLICK = exports.EVENT_BLUKAI_ODDS_BUTTON_CLICK = 'Odds_Button_Click';
var EVENT_BLUKAI_BOOKMAKER_LOGIN = exports.EVENT_BLUKAI_BOOKMAKER_LOGIN = 'Bookmaker_Login';
var EVENT_BLUKAI_OPEN_ACCOUNT = exports.EVENT_BLUKAI_OPEN_ACCOUNT = 'Open_Account';

var EVENT_RACE_MATRIX_CLICK = exports.EVENT_RACE_MATRIX_CLICK = 'Todays Race Matrix Click';

var EVENT_RACECARD_OFFER_ACCORDION_OPENED = exports.EVENT_RACECARD_OFFER_ACCORDION_OPENED = 'Racecard Offer Accordion Opened';
var EVENT_RACECARD_OFFER_ACCORDION_CLOSED = exports.EVENT_RACECARD_OFFER_ACCORDION_CLOSED = 'Racecard Offer Accordion Closed';
var EVENT_RACECARD_OFFER_BUTTON_CLICKED = exports.EVENT_RACECARD_OFFER_BUTTON_CLICKED = 'Racecard Offer Button Clicked';
var EVENT_CARD_INDEX_CLICKED = exports.EVENT_CARD_INDEX_CLICKED = 'Card Index Clicked';

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _propTypes = __webpack_require__(0);

var _constants = __webpack_require__(18);

var _nonCanonical = __webpack_require__(41);

var _getDeviceType = __webpack_require__(42);

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = __webpack_require__(43);

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = __webpack_require__(44);

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = __webpack_require__(26);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = __webpack_require__(29);

var _getUTMParams = __webpack_require__(45);

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _traits = __webpack_require__(1);

var _configProvider = __webpack_require__(69);

var _configProvider2 = _interopRequireDefault(_configProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

function track(event) {
    var _extends2;

    var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;

    var _configProvider$getEv = _configProvider2.default.getEvent(event),
        getPropTypes = _configProvider$getEv.getPropTypes,
        buildProps = _configProvider$getEv.buildProps;

    var props = (0, _extends4.default)({}, traits);

    if (getPropTypes) {
        (0, _propTypes.checkPropTypes)(getPropTypes(), traits, 'trait', event + ' event');
    }

    if (buildProps) {
        props = buildProps(traits);
    }

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
    }

    properties = (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, (0, _getBettingAccountLoggedInStatus2.default)() ? 'Logged In' : 'Logged Out'), _extends2), properties, (0, _getUTMParams2.default)(), props);

    return new Promise(function (resolve) {
        if (!global.analytics || !global.analytics.initialize) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.track(event, properties, options, resolve);
    });
}

exports.default = track;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(100);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
// EXTERNAL MODULE: external "react"
var external__react_ = __webpack_require__(5);
var external__react__default = /*#__PURE__*/__webpack_require__.n(external__react_);

// EXTERNAL MODULE: external "prop-types"
var external__prop_types_ = __webpack_require__(0);
var external__prop_types__default = /*#__PURE__*/__webpack_require__.n(external__prop_types_);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/PropTypes.js

var subscriptionShape = external__prop_types__default.a.shape({
  trySubscribe: external__prop_types__default.a.func.isRequired,
  tryUnsubscribe: external__prop_types__default.a.func.isRequired,
  notifyNestedSubs: external__prop_types__default.a.func.isRequired,
  isSubscribed: external__prop_types__default.a.func.isRequired
});
var storeShape = external__prop_types__default.a.shape({
  subscribe: external__prop_types__default.a.func.isRequired,
  dispatch: external__prop_types__default.a.func.isRequired,
  getState: external__prop_types__default.a.func.isRequired
});
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}
// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





var prefixUnsafeLifecycleMethods = typeof external__react__default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return external__react_["Children"].only(this.props.children);
    };

    return Provider;
  }(external__react_["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: storeShape.isRequired,
    children: external__prop_types__default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);
  return Provider;
}
/* harmony default export */ var components_Provider = (createProvider());
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(237);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(239);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(84);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js










var connectAdvanced_prefixUnsafeLifecycleMethods = typeof external__react__default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    browser_default()(Object(react_is["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        browser_default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        browser_default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = _extends({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(external__react_["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(external__react_["Component"]);

    if (connectAdvanced_prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = connectAdvanced_prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var es = __webpack_require__(47);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/isPlainObject.js
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/verifyPlainObject.js


function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(es["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var connect_mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var connect_mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var connect_mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/verifySubselectors.js


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? connect_mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? connect_mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect_connect = (createConnect());
// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Provider", function() { return components_Provider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createProvider", function() { return createProvider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return connectAdvanced; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connect", function() { return connect_connect; });





/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(250);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(85);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideMandatoryLogin = exports.showMandatoryLogin = exports.hideErrorDialog = exports.showErrorDialog = exports.hideForgottenPassword = exports.showForgottenPassword = exports.hideResetPassword = exports.showResetPassword = exports.setEmailVerificationData = exports.hideEmailVerification = exports.showEmailVerification = exports.hideBarriers = exports.showBarriers = exports.signOut = exports.signIn = exports.HIDE_MANDATORY_LOGIN = exports.SHOW_MANDATORY_LOGIN = exports.HIDE_ERROR_DIALOG = exports.SHOW_ERROR_DIALOG = exports.HIDE_FORGOTTEN_PASSWORD = exports.SHOW_FORGOTTEN_PASSWORD = exports.HIDE_CREATE_PASSWORD = exports.SHOW_CREATE_PASSWORD = exports.HIDE_RESET_PASSWORD = exports.SHOW_RESET_PASSWORD = exports.SET_EMAIL_VERIFICATION_MESSAGE = exports.HIDE_EMAIL_VERIFICATION = exports.SHOW_EMAIL_VERIFICATION = exports.HIDE_BARRIER = exports.SHOW_BARRIER = exports.SIGN_OUT = exports.SIGN_IN = undefined;

var _rpAnalytics = __webpack_require__(23);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SIGN_IN = exports.SIGN_IN = 'SIGN_IN';
var SIGN_OUT = exports.SIGN_OUT = 'SIGN_OUT';
var SHOW_BARRIER = exports.SHOW_BARRIER = 'SHOW_BARRIER';
var HIDE_BARRIER = exports.HIDE_BARRIER = 'HIDE_BARRIER';
var SHOW_EMAIL_VERIFICATION = exports.SHOW_EMAIL_VERIFICATION = 'SHOW_EMAIL_VERIFICATION';
var HIDE_EMAIL_VERIFICATION = exports.HIDE_EMAIL_VERIFICATION = 'HIDE_EMAIL_VERIFICATION';
var SET_EMAIL_VERIFICATION_MESSAGE = exports.SET_EMAIL_VERIFICATION_MESSAGE = 'SET_EMAIL_VERIFICATION_MESSAGE';
var SHOW_RESET_PASSWORD = exports.SHOW_RESET_PASSWORD = 'SHOW_RESET_PASSWORD';
var HIDE_RESET_PASSWORD = exports.HIDE_RESET_PASSWORD = 'HIDE_RESET_PASSWORD';
var SHOW_CREATE_PASSWORD = exports.SHOW_CREATE_PASSWORD = 'SHOW_CREATE_PASSWORD';
var HIDE_CREATE_PASSWORD = exports.HIDE_CREATE_PASSWORD = 'HIDE_CREATE_PASSWORD';
var SHOW_FORGOTTEN_PASSWORD = exports.SHOW_FORGOTTEN_PASSWORD = 'SHOW_FORGOTTEN_PASSWORD';
var HIDE_FORGOTTEN_PASSWORD = exports.HIDE_FORGOTTEN_PASSWORD = 'HIDE_FORGOTTEN_PASSWORD';
var SHOW_ERROR_DIALOG = exports.SHOW_ERROR_DIALOG = 'SHOW_ERROR_DIALOG';
var HIDE_ERROR_DIALOG = exports.HIDE_ERROR_DIALOG = 'HIDE_ERROR_DIALOG';
var SHOW_MANDATORY_LOGIN = exports.SHOW_MANDATORY_LOGIN = 'SHOW_MANDATORY_LOGIN';
var HIDE_MANDATORY_LOGIN = exports.HIDE_MANDATORY_LOGIN = 'HIDE_MANDATORY_LOGIN';

var signIn = exports.signIn = function signIn() {
    return { type: SIGN_IN };
};
var signOut = exports.signOut = function signOut() {
    return { type: SIGN_OUT };
};

var showBarriers = exports.showBarriers = function showBarriers(step, backUrl, text, service, showTitle) {
    (0, _rpAnalytics.identify)().then(function () {
        (0, _rpAnalytics.trackBarrierShow)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, backUrl));
    });
    return {
        type: SHOW_BARRIER, step: step, backUrl: backUrl, text: text, service: service, showTitle: showTitle
    };
};
var hideBarriers = exports.hideBarriers = function hideBarriers() {
    return { type: HIDE_BARRIER };
};
var showEmailVerification = exports.showEmailVerification = function showEmailVerification(message, accountId, session) {
    return {
        type: SHOW_EMAIL_VERIFICATION,
        message: message,
        accountId: accountId,
        session: session
    };
};
var hideEmailVerification = exports.hideEmailVerification = function hideEmailVerification() {
    return { type: HIDE_EMAIL_VERIFICATION };
};
var setEmailVerificationData = exports.setEmailVerificationData = function setEmailVerificationData(message, accountId, session) {
    return {
        type: SET_EMAIL_VERIFICATION_MESSAGE,
        message: message,
        accountId: accountId,
        session: session
    };
};
var showResetPassword = exports.showResetPassword = function showResetPassword(email) {
    return { type: SHOW_RESET_PASSWORD, email: email };
};
var hideResetPassword = exports.hideResetPassword = function hideResetPassword() {
    return { type: HIDE_RESET_PASSWORD };
};
var showForgottenPassword = exports.showForgottenPassword = function showForgottenPassword() {
    (0, _rpAnalytics.identify)().then(function () {
        (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, global.location.href));
    });
    return { type: SHOW_FORGOTTEN_PASSWORD };
};
var hideForgottenPassword = exports.hideForgottenPassword = function hideForgottenPassword() {
    return { type: HIDE_FORGOTTEN_PASSWORD };
};
var showErrorDialog = exports.showErrorDialog = function showErrorDialog() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];
    return {
        type: SHOW_ERROR_DIALOG,
        message: message,
        action: action
    };
};
var hideErrorDialog = exports.hideErrorDialog = function hideErrorDialog() {
    return { type: HIDE_ERROR_DIALOG };
};
var showMandatoryLogin = exports.showMandatoryLogin = function showMandatoryLogin(step, target) {
    return { type: SHOW_MANDATORY_LOGIN, step: step, target: target };
};
var hideMandatoryLogin = exports.hideMandatoryLogin = function hideMandatoryLogin() {
    return { type: HIDE_MANDATORY_LOGIN };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(77);
var isBuffer = __webpack_require__(216);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.upgradeSubscription = exports.renewSubscription = exports.confirmSubscription = exports.createUserPassword = exports.requestPasswordChange = exports.resetUserPassword = exports.getUserPackage = exports.getUserServices = exports.getUserAmend = exports.getSessionStatus = exports.getSubscriptions = exports.deleteSession = exports.getAccess = exports.getSession = exports.AuthSignUp = exports.AuthSignIn = exports.getApplicableToMove = exports.confirmVerificationEmail = exports.sendVerificationEmail = exports.getUserCardInfo = exports.getUserInfo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(214);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(70);

var _qs2 = _interopRequireDefault(_qs);

var _getMPPAttributes2 = __webpack_require__(233);

var _getMPPAttributes3 = _interopRequireDefault(_getMPPAttributes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _getMPPAttributes = (0, _getMPPAttributes3.default)(),
    esuitejsToken = _getMPPAttributes.esuitejsToken,
    esuitejsRestEndpoint = _getMPPAttributes.esuitejsRestEndpoint,
    esuitejsRestVersion = _getMPPAttributes.esuitejsRestVersion;

var sessionUrl = '/members-club/session';
var accessUrl = '/members-club/access';
var BASE_URL = esuitejsRestEndpoint + '/api';
var ACCOUNTS_URL = BASE_URL + '/accounts';
var AUTHENTICATION_URL = ACCOUNTS_URL + '/authenticate';
var FORGOTTEN_PASSWORD_URL = ACCOUNTS_URL + '/forgotten-password';
var RESET_PASSWORD_URL = ACCOUNTS_URL + '/update-password';
var SESSIONS_URL = BASE_URL + '/sessions';
var EMAIL_VERIFICATION_URL = '/verify';
var SUBSCRIPTIONS_URL = '/subscriptions';

var getSubscriptionMoveUrl = function getSubscriptionMoveUrl(accountReference, subscriptionReference) {
    return ACCOUNTS_URL + '/' + accountReference + '/subscriptions/' + subscriptionReference + '/move';
};
var getAccountReferenceUrl = function getAccountReferenceUrl(accountReference) {
    return ACCOUNTS_URL + '/' + accountReference;
};

var parametersNames = ['RP_horseBetting', 'RP_horseNews', 'RP_bloodstock', 'RP_sportBetting', 'RP_competitions', 'RP_newsletterThirdParty', 'RP_18yo', 'RP_isTermsAgreed', 'RP_opt_in_daily_updates', 'RP_rewardsForRacing'];

var getMPPHeaders = function getMPPHeaders(session, version) {
    return _extends({
        'Content-Type': 'application/json; charset=UTF-8',
        'X-TokenId': esuitejsToken,
        'X-Version': version || esuitejsRestVersion
    }, session ? {
        'X-SessionId': session
    } : null);
};

var getRawHeaders = function getRawHeaders() {
    return {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    };
};

var config = {
    RP_18yo: 'eighteenYears',
    RP_isTermsAgreed: 'termsConditions',
    RP_opt_in_daily_updates: 'dailyUpdates'
};

var setCustomParameters = function setCustomParameters(conditions) {
    var customParameters = {};

    parametersNames.forEach(function (name) {
        customParameters[name] = config[name] ? Number(conditions[config[name]]) || 0 : Number(conditions[name.slice(3)]) || 0;
    });

    return customParameters;
};

var getChangeUserDetails = function getChangeUserDetails(key, value, isCustomParameter, isExistent) {
    return {
        op: isExistent ? 'replace' : 'add',
        path: '/' + (isCustomParameter ? 'CustomAccountParameter/' : '') + key,
        value: value
    };
};

var getCustomParametersArray = function getCustomParametersArray(conditions, customParameters) {
    return Object.keys(conditions).map(function (key) {
        var hasKey = key in customParameters;
        return getChangeUserDetails(key, conditions[key], true, hasKey);
    });
};

var getUserAmendDataArray = function getUserAmendDataArray(existingData, newData) {
    var dataArray = [];
    Object.keys(newData).forEach(function (key) {
        if (key === 'conditions') {
            dataArray.push.apply(dataArray, _toConsumableArray(getCustomParametersArray(setCustomParameters(newData[key]), existingData.customParameters)));
        } else if (key.toLowerCase() === 'lastname') {
            dataArray.push(getChangeUserDetails('surname', newData[key], false, true));
        } else if (key.toLowerCase() === 'phone') {
            dataArray.push(getChangeUserDetails('phonenumber', newData[key], false, true));
        } else {
            dataArray.push(getChangeUserDetails(key.toLowerCase(), newData[key], false, true));
        }
    });

    return dataArray;
};

var signInOptions = function signInOptions(sessionId, email, clientUserId) {
    return {
        url: sessionUrl,
        method: 'put',
        headers: getRawHeaders(),
        data: _qs2.default.stringify({
            sessionId: sessionId,
            email: email,
            clientUserId: clientUserId
        })
    };
};

var getUserInfo = exports.getUserInfo = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountReference, sessionToken) {
        var getAccountInfoOptions, _ref2, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        getAccountInfoOptions = {
                            url: ACCOUNTS_URL + '/' + accountReference,
                            method: 'get',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context.prev = 1;
                        _context.next = 4;
                        return (0, _axios2.default)(getAccountInfoOptions);

                    case 4:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        return _context.abrupt('return', data);

                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context['catch'](1);
                        throw _context.t0;

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[1, 9]]);
    }));

    return function getUserInfo(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var getUserCardInfo = exports.getUserCardInfo = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountReference, sessionToken) {
        var getAccountPaymentInfoOptions, _ref4, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        getAccountPaymentInfoOptions = {
                            url: ACCOUNTS_URL + '/' + accountReference + '/payment-details',
                            method: 'get',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context2.prev = 1;
                        _context2.next = 4;
                        return (0, _axios2.default)(getAccountPaymentInfoOptions);

                    case 4:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        return _context2.abrupt('return', data);

                    case 9:
                        _context2.prev = 9;
                        _context2.t0 = _context2['catch'](1);
                        throw _context2.t0;

                    case 12:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined, [[1, 9]]);
    }));

    return function getUserCardInfo(_x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

var sendVerificationEmail = exports.sendVerificationEmail = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(accountReference, sessionToken) {
        var emailVerificationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        emailVerificationOptions = {
                            url: '' + getAccountReferenceUrl(accountReference) + EMAIL_VERIFICATION_URL,
                            method: 'post',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context3.prev = 1;
                        _context3.next = 4;
                        return (0, _axios2.default)(emailVerificationOptions);

                    case 4:
                        return _context3.abrupt('return', _context3.sent);

                    case 7:
                        _context3.prev = 7;
                        _context3.t0 = _context3['catch'](1);
                        throw _context3.t0;

                    case 10:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined, [[1, 7]]);
    }));

    return function sendVerificationEmail(_x5, _x6) {
        return _ref5.apply(this, arguments);
    };
}();

var confirmVerificationEmail = exports.confirmVerificationEmail = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(verificationToken) {
        var emailConfirmationOptions;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        emailConfirmationOptions = {
                            url: '' + ACCOUNTS_URL + EMAIL_VERIFICATION_URL,
                            method: 'patch',
                            headers: getMPPHeaders(),
                            data: {
                                verificationToken: verificationToken
                            }
                        };
                        _context4.prev = 1;
                        _context4.next = 4;
                        return (0, _axios2.default)(emailConfirmationOptions);

                    case 4:
                        return _context4.abrupt('return', _context4.sent);

                    case 7:
                        _context4.prev = 7;
                        _context4.t0 = _context4['catch'](1);
                        throw _context4.t0;

                    case 10:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, undefined, [[1, 7]]);
    }));

    return function confirmVerificationEmail(_x7) {
        return _ref6.apply(this, arguments);
    };
}();

var getApplicableToMove = exports.getApplicableToMove = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(accountReference, sessionToken, currentServiceId) {
        var availableSubscriptionOptions, _ref8, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        availableSubscriptionOptions = {
                            url: getSubscriptionMoveUrl(accountReference, currentServiceId) + 's/Available',
                            method: 'get',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context5.prev = 1;
                        _context5.next = 4;
                        return (0, _axios2.default)(availableSubscriptionOptions);

                    case 4:
                        _ref8 = _context5.sent;
                        data = _ref8.data;
                        return _context5.abrupt('return', data);

                    case 9:
                        _context5.prev = 9;
                        _context5.t0 = _context5['catch'](1);
                        throw _context5.t0;

                    case 12:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, undefined, [[1, 9]]);
    }));

    return function getApplicableToMove(_x8, _x9, _x10) {
        return _ref7.apply(this, arguments);
    };
}();

var AuthSignIn = exports.AuthSignIn = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(email, password) {
        var checkEmailVeriied = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var MPPSignInOptions, _ref10, _ref10$data, resourceReference, sessionToken, _ref11, verified, clientUserId, error;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        MPPSignInOptions = {
                            url: AUTHENTICATION_URL,
                            method: 'post',
                            headers: getMPPHeaders(null, '10.2.0'),
                            data: { email: email, password: password }
                        };
                        _context6.prev = 1;
                        _context6.next = 4;
                        return (0, _axios2.default)(MPPSignInOptions);

                    case 4:
                        _ref10 = _context6.sent;
                        _ref10$data = _ref10.data;
                        resourceReference = _ref10$data.resourceReference;
                        sessionToken = _ref10$data.sessionToken;
                        _context6.next = 10;
                        return getUserInfo(resourceReference, sessionToken);

                    case 10:
                        _ref11 = _context6.sent;
                        verified = _ref11.verified;
                        clientUserId = _ref11.clientUserId;

                        if (!(checkEmailVeriied && !verified)) {
                            _context6.next = 19;
                            break;
                        }

                        error = new Error('Account not verified');

                        error.accountNotVerified = !verified;
                        error.accountId = resourceReference;
                        error.session = sessionToken;
                        throw error;

                    case 19:
                        _context6.next = 21;
                        return (0, _axios2.default)(signInOptions(sessionToken, email, clientUserId));

                    case 21:
                        return _context6.abrupt('return', _context6.sent);

                    case 24:
                        _context6.prev = 24;
                        _context6.t0 = _context6['catch'](1);
                        throw _context6.t0;

                    case 27:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, undefined, [[1, 24]]);
    }));

    return function AuthSignIn(_x11, _x12) {
        return _ref9.apply(this, arguments);
    };
}();

var AuthSignUp = exports.AuthSignUp = function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref13) {
        var email = _ref13.email,
            password = _ref13.password,
            conditions = _ref13.conditions;

        var MPPSignUpOptions, _ref14, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        MPPSignUpOptions = {
                            url: ACCOUNTS_URL,
                            method: 'post',
                            headers: getMPPHeaders(),
                            data: {
                                email: email,
                                password: password,
                                customParameters: setCustomParameters(conditions)
                            }
                        };
                        _context7.prev = 1;
                        _context7.next = 4;
                        return (0, _axios2.default)(MPPSignUpOptions);

                    case 4:
                        _ref14 = _context7.sent;
                        data = _ref14.data;
                        _context7.next = 8;
                        return sendVerificationEmail(data.accountReference, data.sessionToken);

                    case 8:
                        return _context7.abrupt('return', data);

                    case 11:
                        _context7.prev = 11;
                        _context7.t0 = _context7['catch'](1);
                        throw _context7.t0;

                    case 14:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, undefined, [[1, 11]]);
    }));

    return function AuthSignUp(_x14) {
        return _ref12.apply(this, arguments);
    };
}();

var getSession = exports.getSession = function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _ref16, session;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.prev = 0;
                        _context8.next = 3;
                        return (0, _axios2.default)(sessionUrl);

                    case 3:
                        _ref16 = _context8.sent;
                        session = _ref16.data.session;
                        return _context8.abrupt('return', session ? Promise.resolve(session) : Promise.reject(new Error('Session expired')));

                    case 8:
                        _context8.prev = 8;
                        _context8.t0 = _context8['catch'](0);
                        throw _context8.t0;

                    case 11:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, undefined, [[0, 8]]);
    }));

    return function getSession() {
        return _ref15.apply(this, arguments);
    };
}();

var getAccess = exports.getAccess = function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref18) {
        var requestUrl = _ref18.requestUrl;

        var _ref19, access;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.prev = 0;
                        _context9.next = 3;
                        return (0, _axios2.default)(accessUrl, {
                            params: { url: requestUrl }
                        });

                    case 3:
                        _ref19 = _context9.sent;
                        access = _ref19.data.access;
                        return _context9.abrupt('return', access ? Promise.resolve(access) : Promise.resolve(false));

                    case 8:
                        _context9.prev = 8;
                        _context9.t0 = _context9['catch'](0);
                        throw _context9.t0;

                    case 11:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, undefined, [[0, 8]]);
    }));

    return function getAccess(_x15) {
        return _ref17.apply(this, arguments);
    };
}();

var deleteSession = exports.deleteSession = function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var getSessionOptions, session;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        getSessionOptions = function getSessionOptions(session) {
                            return {
                                url: SESSIONS_URL,
                                method: 'delete',
                                headers: getMPPHeaders(session)
                            };
                        };

                        _context10.prev = 1;
                        _context10.next = 4;
                        return getSession();

                    case 4:
                        session = _context10.sent;
                        _context10.next = 7;
                        return _axios2.default.delete(sessionUrl);

                    case 7:
                        if (!session) {
                            _context10.next = 10;
                            break;
                        }

                        _context10.next = 10;
                        return (0, _axios2.default)(getSessionOptions(session));

                    case 10:
                        return _context10.abrupt('return', session);

                    case 13:
                        _context10.prev = 13;
                        _context10.t0 = _context10['catch'](1);
                        return _context10.abrupt('return', { session: false });

                    case 16:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, undefined, [[1, 13]]);
    }));

    return function deleteSession() {
        return _ref20.apply(this, arguments);
    };
}();

var getSubscriptions = exports.getSubscriptions = function getSubscriptions() {
    return _axios2.default.get('/members-club/services');
};

var getSessionStatus = exports.getSessionStatus = function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var getSessionOptions, session, _ref22, data;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        getSessionOptions = function getSessionOptions(session) {
                            return {
                                url: SESSIONS_URL,
                                method: 'get',
                                headers: getMPPHeaders(session)
                            };
                        };

                        _context11.prev = 1;
                        _context11.next = 4;
                        return getSession();

                    case 4:
                        session = _context11.sent;

                        if (session) {
                            _context11.next = 7;
                            break;
                        }

                        return _context11.abrupt('return', { session: false });

                    case 7:
                        _context11.next = 9;
                        return (0, _axios2.default)(getSessionOptions(session));

                    case 9:
                        _ref22 = _context11.sent;
                        data = _ref22.data;
                        return _context11.abrupt('return', { sessionStatus: data, session: session });

                    case 14:
                        _context11.prev = 14;
                        _context11.t0 = _context11['catch'](1);
                        throw _context11.t0;

                    case 17:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, undefined, [[1, 14]]);
    }));

    return function getSessionStatus() {
        return _ref21.apply(this, arguments);
    };
}();

var getUserAmend = exports.getUserAmend = function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(newInfo, sessionInfo) {
        var MPPUserAmendOptions, sessionInfoData, accountReference, session, userInfo, _ref24, data;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        MPPUserAmendOptions = function MPPUserAmendOptions(accountReference, session, userInfo) {
                            return {
                                url: '' + getAccountReferenceUrl(accountReference),
                                method: 'patch',
                                headers: getMPPHeaders(session),
                                data: getUserAmendDataArray(userInfo, newInfo)
                            };
                        };

                        _context12.prev = 1;
                        _context12.t0 = sessionInfo;

                        if (_context12.t0) {
                            _context12.next = 7;
                            break;
                        }

                        _context12.next = 6;
                        return getSessionStatus();

                    case 6:
                        _context12.t0 = _context12.sent;

                    case 7:
                        sessionInfoData = _context12.t0;
                        accountReference = sessionInfoData.sessionStatus.accountReference, session = sessionInfoData.session;
                        _context12.next = 11;
                        return getUserInfo(accountReference, session);

                    case 11:
                        userInfo = _context12.sent;
                        _context12.next = 14;
                        return (0, _axios2.default)(MPPUserAmendOptions(accountReference, session, userInfo));

                    case 14:
                        _ref24 = _context12.sent;
                        data = _ref24.data;
                        return _context12.abrupt('return', data);

                    case 19:
                        _context12.prev = 19;
                        _context12.t1 = _context12['catch'](1);
                        throw _context12.t1;

                    case 22:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, undefined, [[1, 19]]);
    }));

    return function getUserAmend(_x16, _x17) {
        return _ref23.apply(this, arguments);
    };
}();

var getUserServices = exports.getUserServices = function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(accountReference, sessionToken) {
        var userServicesOptions, _ref26, data;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        userServicesOptions = {
                            url: '' + getAccountReferenceUrl(accountReference) + SUBSCRIPTIONS_URL,
                            method: 'get',
                            headers: getMPPHeaders(sessionToken, '10.6.0')
                        };
                        _context13.prev = 1;
                        _context13.next = 4;
                        return (0, _axios2.default)(userServicesOptions);

                    case 4:
                        _ref26 = _context13.sent;
                        data = _ref26.data;
                        return _context13.abrupt('return', data);

                    case 9:
                        _context13.prev = 9;
                        _context13.t0 = _context13['catch'](1);
                        throw _context13.t0;

                    case 12:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, undefined, [[1, 9]]);
    }));

    return function getUserServices(_x18, _x19) {
        return _ref25.apply(this, arguments);
    };
}();

var getUserPackage = exports.getUserPackage = function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var _ref28, accountReference, session, _ref29, subscriptions;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        _context14.prev = 0;
                        _context14.next = 3;
                        return getSessionStatus();

                    case 3:
                        _ref28 = _context14.sent;
                        accountReference = _ref28.sessionStatus.accountReference;
                        session = _ref28.session;
                        _context14.next = 8;
                        return getUserServices(accountReference, session);

                    case 8:
                        _ref29 = _context14.sent;
                        subscriptions = _ref29.subscriptions;
                        return _context14.abrupt('return', subscriptions && subscriptions.length && subscriptions[0].defaultSubscriptionInfo.subscriptionTitle);

                    case 13:
                        _context14.prev = 13;
                        _context14.t0 = _context14['catch'](0);
                        throw _context14.t0;

                    case 16:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, undefined, [[0, 13]]);
    }));

    return function getUserPackage() {
        return _ref27.apply(this, arguments);
    };
}();

var resetUserPassword = exports.resetUserPassword = function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(email, password, newPassword) {
        var resetPasswordOptions, _ref31, accountReference, session, _ref32, data;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        resetPasswordOptions = function resetPasswordOptions(accountReference, session) {
                            return {
                                url: '' + getAccountReferenceUrl(accountReference),
                                method: 'patch',
                                headers: getMPPHeaders(session),
                                data: [getChangeUserDetails('password', newPassword, false, true)]
                            };
                        };

                        _context15.prev = 1;
                        _context15.next = 4;
                        return AuthSignIn(email, password);

                    case 4:
                        _context15.next = 6;
                        return getSessionStatus();

                    case 6:
                        _ref31 = _context15.sent;
                        accountReference = _ref31.sessionStatus.accountReference;
                        session = _ref31.session;
                        _context15.next = 11;
                        return (0, _axios2.default)(resetPasswordOptions(accountReference, session));

                    case 11:
                        _ref32 = _context15.sent;
                        data = _ref32.data;
                        return _context15.abrupt('return', data);

                    case 16:
                        _context15.prev = 16;
                        _context15.t0 = _context15['catch'](1);
                        throw _context15.t0;

                    case 19:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, undefined, [[1, 16]]);
    }));

    return function resetUserPassword(_x20, _x21, _x22) {
        return _ref30.apply(this, arguments);
    };
}();

var requestPasswordChange = exports.requestPasswordChange = function () {
    var _ref33 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(emailAddress) {
        var requestPasswordOptions;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        requestPasswordOptions = {
                            url: '' + FORGOTTEN_PASSWORD_URL,
                            method: 'post',
                            headers: getMPPHeaders(),
                            data: { emailAddress: emailAddress }
                        };
                        _context16.prev = 1;
                        _context16.next = 4;
                        return (0, _axios2.default)(requestPasswordOptions);

                    case 4:
                        return _context16.abrupt('return', _context16.sent);

                    case 7:
                        _context16.prev = 7;
                        _context16.t0 = _context16['catch'](1);
                        throw _context16.t0;

                    case 10:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, undefined, [[1, 7]]);
    }));

    return function requestPasswordChange(_x23) {
        return _ref33.apply(this, arguments);
    };
}();

var createUserPassword = exports.createUserPassword = function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(token, password) {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.prev = 0;
                        _context17.next = 3;
                        return (0, _axios2.default)({
                            url: '' + RESET_PASSWORD_URL,
                            method: 'patch',
                            headers: getMPPHeaders(token),
                            data: { password: password, login: false }
                        });

                    case 3:
                        return _context17.abrupt('return', _context17.sent);

                    case 6:
                        _context17.prev = 6;
                        _context17.t0 = _context17['catch'](0);
                        throw _context17.t0;

                    case 9:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, undefined, [[0, 6]]);
    }));

    return function createUserPassword(_x24, _x25) {
        return _ref34.apply(this, arguments);
    };
}();

var confirmSubscription = exports.confirmSubscription = function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(payload) {
        var confirmSubscriptionOptions, _ref36, data;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        confirmSubscriptionOptions = {
                            url: sessionUrl + '/payment',
                            method: 'put',
                            headers: getRawHeaders(),
                            data: _qs2.default.stringify(payload),
                            withCredentials: true
                        };
                        _context18.prev = 1;
                        _context18.next = 4;
                        return (0, _axios2.default)(confirmSubscriptionOptions);

                    case 4:
                        _ref36 = _context18.sent;
                        data = _ref36.data;
                        return _context18.abrupt('return', data);

                    case 9:
                        _context18.prev = 9;
                        _context18.t0 = _context18['catch'](1);
                        throw _context18.t0;

                    case 12:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, undefined, [[1, 9]]);
    }));

    return function confirmSubscription(_x26) {
        return _ref35.apply(this, arguments);
    };
}();

var renewSubscription = exports.renewSubscription = function () {
    var _ref37 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(payload) {
        var renewSubscriptionOptions, _ref38, accountReference, _ref39, data;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        renewSubscriptionOptions = function renewSubscriptionOptions(accountReference) {
                            return {
                                url: '/members-club/my-account/subscription/add',
                                method: 'post',
                                headers: getRawHeaders(),
                                data: _qs2.default.stringify({ servicePriceId: payload.resourceReference, accountReference: accountReference }),
                                withCredentials: true
                            };
                        };

                        _context19.prev = 1;
                        _context19.next = 4;
                        return getSessionStatus();

                    case 4:
                        _ref38 = _context19.sent;
                        accountReference = _ref38.sessionStatus.accountReference;
                        _context19.next = 8;
                        return (0, _axios2.default)(renewSubscriptionOptions(accountReference));

                    case 8:
                        _ref39 = _context19.sent;
                        data = _ref39.data;
                        return _context19.abrupt('return', data);

                    case 13:
                        _context19.prev = 13;
                        _context19.t0 = _context19['catch'](1);
                        throw _context19.t0;

                    case 16:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, undefined, [[1, 13]]);
    }));

    return function renewSubscription(_x27) {
        return _ref37.apply(this, arguments);
    };
}();

var upgradeSubscription = exports.upgradeSubscription = function () {
    var _ref40 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(_ref41) {
        var currentServiceId = _ref41.currentServiceId,
            servicePriceId = _ref41.servicePriceId;

        var upgradeSubscriptionOptions, _ref42, accountReference, session, _ref43, data;

        return regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        upgradeSubscriptionOptions = function upgradeSubscriptionOptions(accountReference, sessionToken) {
                            return {
                                url: getSubscriptionMoveUrl(accountReference, currentServiceId),
                                method: 'post',
                                headers: getMPPHeaders(sessionToken),
                                data: {
                                    servicePriceResourceReference: servicePriceId,
                                    upgradeSubscription: 'Refund',
                                    immediateSwitch: true
                                }
                            };
                        };

                        _context20.prev = 1;
                        _context20.next = 4;
                        return getSessionStatus();

                    case 4:
                        _ref42 = _context20.sent;
                        accountReference = _ref42.sessionStatus.accountReference;
                        session = _ref42.session;
                        _context20.next = 9;
                        return (0, _axios2.default)(upgradeSubscriptionOptions(accountReference, session));

                    case 9:
                        _ref43 = _context20.sent;
                        data = _ref43.data;
                        return _context20.abrupt('return', data);

                    case 14:
                        _context20.prev = 14;
                        _context20.t0 = _context20['catch'](1);
                        throw _context20.t0;

                    case 17:
                    case 'end':
                        return _context20.stop();
                }
            }
        }, _callee20, undefined, [[1, 14]]);
    }));

    return function upgradeSubscription(_x28) {
        return _ref40.apply(this, arguments);
    };
}();

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(283);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/sass-loader/lib/loader.js!./fields.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/sass-loader/lib/loader.js!./fields.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_16__;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cleanLegacy = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsCookie = __webpack_require__(25);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _legacy = __webpack_require__(130);

var _legacy2 = _interopRequireDefault(_legacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rpCookie = function (cookie) {
    var cookieType = {
        sharedSession: 'RDSS',
        sharedPermanent: 'RDSP',
        privateSession: 'RDPS',
        privatePermanent: 'RDPP'
    };
    var cookieProp = {
        domain: window.location.hostname.split('.').slice(-2).join('.'),
        lifetime: 365,
        secure: true
    };

    function init(_ref) {
        var name = _ref.name,
            shared = _ref.shared,
            domain = _ref.domain,
            expires = _ref.expires,
            secure = _ref.secure;

        return {
            set: function set(key, value) {
                var cookieValue = _defineProperty({}, key, value);

                if (cookie.getJSON(name)) {
                    cookieValue = _extends(cookie.getJSON(name), cookieValue);
                }

                if (value === null) {
                    cookieValue = cookie.getJSON(name);
                    delete cookieValue[key];
                }

                if (shared) {
                    if (expires) {
                        cookie.set(name, cookieValue, { domain: domain, expires: expires, secure: secure });
                    } else {
                        cookie.set(name, cookieValue, { domain: domain, secure: secure });
                    }
                } else {
                    if (expires) {
                        cookie.set(name, cookieValue, { expires: expires, secure: secure });
                    } else {
                        cookie.set(name, cookieValue, { secure: secure });
                    }
                }
            },
            get: function get(key) {
                var cookieJSON = cookie.getJSON(name);
                if (!cookieJSON) {
                    return undefined;
                }
                return key ? cookieJSON[key] : cookieJSON;
            },
            remove: function remove(key) {
                this.set(key, null);
            }
        };
    }

    var sharedSession = init({
        name: cookieType.sharedSession,
        shared: true,
        domain: cookieProp.domain,
        secure: cookieProp.secure
    });
    var sharedPermanent = init({
        name: cookieType.sharedPermanent,
        shared: true,
        domain: cookieProp.domain,
        expires: cookieProp.lifetime,
        secure: cookieProp.secure
    });
    var privateSession = init({
        name: cookieType.privateSession,
        shared: false,
        secure: cookieProp.secure
    });
    var privatePermanent = init({
        name: cookieType.privatePermanent,
        shared: false,
        expires: cookieProp.lifetime,
        secure: cookieProp.secure
    });

    return {
        sharedSession: sharedSession,
        sharedPermanent: sharedPermanent,
        privateSession: privateSession,
        privatePermanent: privatePermanent
    };
}(_jsCookie2.default);

exports.default = rpCookie;
exports.cleanLegacy = _legacy2.default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Constants
 * @type {string}
 */
var DEFAULT_AFFILIATION = exports.DEFAULT_AFFILIATION = 'www.racingpost.com';
var CATEGORY_UPGRADE = exports.CATEGORY_UPGRADE = 'upgrade';
var CATEGORY_SUBSCRIPTION = exports.CATEGORY_SUBSCRIPTION = 'subscription';
var MESSAGE_ERROR_NO_ANALYTICS = exports.MESSAGE_ERROR_NO_ANALYTICS = 'window.analytics is not defined.';
var MESSAGE_ERROR_NO_ANALYTICS_DEBUG = exports.MESSAGE_ERROR_NO_ANALYTICS_DEBUG = 'window.analytics.debug is not defined.';
var MESSAGE_ERROR_NO_PERMUTIVE = exports.MESSAGE_ERROR_NO_PERMUTIVE = 'window.permutive is not defined.';

var EVENT_KEY = exports.EVENT_KEY = 'event';
var LOCATION_KEY = exports.LOCATION_KEY = 'Location';
var BOOKMAKER_KEY = exports.BOOKMAKER_KEY = 'Bookmaker';
var EVENT_TYPE_KEY = exports.EVENT_TYPE_KEY = 'Event_Type';
var EVENT_NAME = exports.EVENT_NAME = 'Bookmaker_Event';

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COOKIE_NAME_USER_PACKAGE = exports.COOKIE_NAME_USER_PACKAGE = 'rp_package';
var COOKIE_NAME_DB_USER_ID = exports.COOKIE_NAME_DB_USER_ID = 'rp_uid';
var COOKIE_NAME_UNIQUE_USER_ID = exports.COOKIE_NAME_UNIQUE_USER_ID = '__t';
var COOKIE_NAME_USER_LOGIN = exports.COOKIE_NAME_USER_LOGIN = 'rp_email';

var COOKIE_UTM_KEY_FIRST = exports.COOKIE_UTM_KEY_FIRST = 'utmFirst';
var COOKIE_UTM_KEY_LAST = exports.COOKIE_UTM_KEY_LAST = 'utmLast';

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lightbox = __webpack_require__(292);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Lightbox2.default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onSignInSuccess = exports.onSignUpSuccess = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rpAnalytics = __webpack_require__(23);

var _api = __webpack_require__(14);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var conditionNames = {
    horseBetting: 'communicationHorseBetting',
    horseNews: 'communicationHorseNews',
    bloodstock: 'communicationBloodstock',
    sportBetting: 'communicationSportBetting',
    competitions: 'communicationCompetitions',
    newsletterThirdParty: 'thirdPartyContact',
    eighteenYears: 'communicationEighteen'
};

var getConditionsArray = function getConditionsArray(conditions) {
    return Object.keys(conditionNames).reduce(function (acc, name) {
        return _extends({}, acc, _defineProperty({}, conditionNames[name], Number(conditions[name])));
    }, {});
};
function checkAllComunications(option) {
    return option === 1;
}
var onSignUpSuccess = exports.onSignUpSuccess = function onSignUpSuccess(email, conditions) {
    var conds = getConditionsArray(conditions);
    (0, _rpAnalytics.identify)(conds).then(function () {
        var _extends3;

        var TRAIT_RACING_POST_CONTACT = 'racingPostContact';
        var allComunicationOptions = [conds.communicationBloodstock, conds.communicationCompetitions, conds.communicationHorseBetting, conds.communicationHorseNews, conds.communicationSportBetting];

        var racingPostContact = allComunicationOptions.every(checkAllComunications) ? 1 : 0;
        (0, _rpAnalytics.trackRegister)(_extends((_extends3 = {}, _defineProperty(_extends3, _rpAnalytics.TRAIT_EMAIL, email), _defineProperty(_extends3, TRAIT_RACING_POST_CONTACT, racingPostContact), _extends3), conds));
        (0, _rpAnalytics.trackLogin)(_defineProperty({}, _rpAnalytics.TRAIT_EMAIL, email));
    });
};

var onSignInSuccess = exports.onSignInSuccess = function onSignInSuccess(email) {
    return (0, _api.getUserPackage)().then(function (userPackage) {
        return (0, _rpAnalytics.identify)().then(function () {
            var _trackLogin2;

            (0, _rpAnalytics.trackLogin)((_trackLogin2 = {}, _defineProperty(_trackLogin2, _rpAnalytics.TRAIT_EMAIL, email), _defineProperty(_trackLogin2, _rpAnalytics.TRAIT_PACKAGE, userPackage), _trackLogin2));
        });
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(296);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./modal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./modal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackCardIndexClick = exports.trackRacecardOfferButtonClicked = exports.trackRacecardOfferAccordionClosed = exports.trackRacecardOfferAccordionOpened = exports.trackRaceMatrixClick = exports.trackVoucherCodeRemoved = exports.trackVoucherCodeEntered = exports.trackVoucherCodeDenied = exports.trackVoucherCodeApplied = exports.trackUpgradeStarted = exports.trackUpgradeCompleted = exports.trackSubscriptionUpgraded = exports.trackSubscriptionViewed = exports.trackSubscriptionStarted = exports.trackSubscriptionSaleAttempt = exports.trackSubscriptionSale = exports.trackSubscriptionDetailsViewed = exports.trackSubscriptionDetailsCompleted = exports.trackSubscriptionCompleted = exports.trackRemoveSelectionButtonClick = exports.trackRegister = exports.trackQuickStakeButtonsClick = exports.trackPreferencesUpdate = exports.trackBetslipErrorMessage = exports.trackPlaceBet = exports.trackOrderCompleted = exports.trackOpenAccount = exports.trackOfferAccordionOpened = exports.trackOfferAccordionClosed = exports.trackNavigationClick = exports.trackBookmakerOfferClaimButtonClick = exports.trackBookmakerLoginSuccess = exports.trackBookmakerLoginFailure = exports.trackBookmakerLoginAttempt = exports.trackCancelBetButtonClick = exports.trackLogin = exports.trackHorseTrackerSettings = exports.trackFooterClick = exports.trackEmailVerification = exports.trackDiscardSlipButtonClick = exports.trackCardCustomisation = exports.trackBookmakerRegister = exports.trackBookmakerLogin = exports.trackBettingOfferClick = exports.trackBetReceipt = exports.trackBetButtonClick = exports.trackBarrierUltimateSubscribe = exports.trackBarrierUltimateShow = exports.trackBarrierUltimateOnlyUpgrade = exports.trackBarrierUltimateOnlyShow = exports.trackBarrierSubscribe = exports.trackBarrierSignInShow = exports.trackBarrierSignInPassword = exports.trackBarrierSignIn = exports.trackBarrierShow = exports.trackBarrierEssentialSubscribe = exports.trackBarrierEssentialShow = exports.identifySubscriptionSale = exports.identifyRegister = exports.identifyLogin = exports.clearCommonTraits = exports.setCommonTraits = exports.getCommonTraits = exports.enableDebug = exports.enableLogging = exports.alias = exports.identify = exports.page = exports.track = undefined;

var _events = __webpack_require__(3);

Object.keys(_events).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _events[key];
        }
    });
});

var _traits = __webpack_require__(1);

Object.keys(_traits).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _traits[key];
        }
    });
});

var _registerEvents = __webpack_require__(99);

var _registerEvents2 = _interopRequireDefault(_registerEvents);

var _setUTMParams = __webpack_require__(131);

var _setUTMParams2 = _interopRequireDefault(_setUTMParams);

var _enableLogging = __webpack_require__(146);

var _enableLogging2 = _interopRequireDefault(_enableLogging);

var _enableDebug = __webpack_require__(147);

var _enableDebug2 = _interopRequireDefault(_enableDebug);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _page = __webpack_require__(151);

var _page2 = _interopRequireDefault(_page);

var _identify = __webpack_require__(30);

var _identify2 = _interopRequireDefault(_identify);

var _alias = __webpack_require__(152);

var _alias2 = _interopRequireDefault(_alias);

var _commonTraits = __webpack_require__(29);

var _identifyLogin = __webpack_require__(154);

var _identifyLogin2 = _interopRequireDefault(_identifyLogin);

var _identifyRegister = __webpack_require__(155);

var _identifyRegister2 = _interopRequireDefault(_identifyRegister);

var _identifySubscriptionSale = __webpack_require__(156);

var _identifySubscriptionSale2 = _interopRequireDefault(_identifySubscriptionSale);

var _trackBarrierEssentialShow = __webpack_require__(157);

var _trackBarrierEssentialShow2 = _interopRequireDefault(_trackBarrierEssentialShow);

var _trackBarrierEssentialSubscribe = __webpack_require__(158);

var _trackBarrierEssentialSubscribe2 = _interopRequireDefault(_trackBarrierEssentialSubscribe);

var _trackBarrierShow = __webpack_require__(159);

var _trackBarrierShow2 = _interopRequireDefault(_trackBarrierShow);

var _trackBarrierSignIn = __webpack_require__(160);

var _trackBarrierSignIn2 = _interopRequireDefault(_trackBarrierSignIn);

var _trackBarrierSignInPassword = __webpack_require__(161);

var _trackBarrierSignInPassword2 = _interopRequireDefault(_trackBarrierSignInPassword);

var _trackBarrierSignInShow = __webpack_require__(162);

var _trackBarrierSignInShow2 = _interopRequireDefault(_trackBarrierSignInShow);

var _trackBarrierSubscribe = __webpack_require__(163);

var _trackBarrierSubscribe2 = _interopRequireDefault(_trackBarrierSubscribe);

var _trackBarrierUltimateOnlyShow = __webpack_require__(164);

var _trackBarrierUltimateOnlyShow2 = _interopRequireDefault(_trackBarrierUltimateOnlyShow);

var _trackBarrierUltimateOnlyUpgrade = __webpack_require__(165);

var _trackBarrierUltimateOnlyUpgrade2 = _interopRequireDefault(_trackBarrierUltimateOnlyUpgrade);

var _trackBarrierUltimateShow = __webpack_require__(166);

var _trackBarrierUltimateShow2 = _interopRequireDefault(_trackBarrierUltimateShow);

var _trackBarrierUltimateSubscribe = __webpack_require__(167);

var _trackBarrierUltimateSubscribe2 = _interopRequireDefault(_trackBarrierUltimateSubscribe);

var _trackBetButtonClick = __webpack_require__(168);

var _trackBetButtonClick2 = _interopRequireDefault(_trackBetButtonClick);

var _trackBetReceipt = __webpack_require__(169);

var _trackBetReceipt2 = _interopRequireDefault(_trackBetReceipt);

var _trackBettingOfferClick = __webpack_require__(170);

var _trackBettingOfferClick2 = _interopRequireDefault(_trackBettingOfferClick);

var _trackBookmakerLogin = __webpack_require__(171);

var _trackBookmakerLogin2 = _interopRequireDefault(_trackBookmakerLogin);

var _trackBookmakerRegister = __webpack_require__(172);

var _trackBookmakerRegister2 = _interopRequireDefault(_trackBookmakerRegister);

var _trackBookmakerLoginAttempt = __webpack_require__(173);

var _trackBookmakerLoginAttempt2 = _interopRequireDefault(_trackBookmakerLoginAttempt);

var _trackBookmakerLoginFailure = __webpack_require__(174);

var _trackBookmakerLoginFailure2 = _interopRequireDefault(_trackBookmakerLoginFailure);

var _trackBookmakerLoginSuccess = __webpack_require__(175);

var _trackBookmakerLoginSuccess2 = _interopRequireDefault(_trackBookmakerLoginSuccess);

var _trackBookmakerOfferClaimButtonClick = __webpack_require__(176);

var _trackBookmakerOfferClaimButtonClick2 = _interopRequireDefault(_trackBookmakerOfferClaimButtonClick);

var _trackLogin = __webpack_require__(177);

var _trackLogin2 = _interopRequireDefault(_trackLogin);

var _trackCancelBetButtonClick = __webpack_require__(178);

var _trackCancelBetButtonClick2 = _interopRequireDefault(_trackCancelBetButtonClick);

var _trackCardCustomisation = __webpack_require__(179);

var _trackCardCustomisation2 = _interopRequireDefault(_trackCardCustomisation);

var _trackDiscardSlipButtonClick = __webpack_require__(180);

var _trackDiscardSlipButtonClick2 = _interopRequireDefault(_trackDiscardSlipButtonClick);

var _trackHorseTrackerSettings = __webpack_require__(181);

var _trackHorseTrackerSettings2 = _interopRequireDefault(_trackHorseTrackerSettings);

var _trackEmailVerification = __webpack_require__(182);

var _trackEmailVerification2 = _interopRequireDefault(_trackEmailVerification);

var _trackNavigationClick = __webpack_require__(183);

var _trackNavigationClick2 = _interopRequireDefault(_trackNavigationClick);

var _trackFooterClick = __webpack_require__(184);

var _trackFooterClick2 = _interopRequireDefault(_trackFooterClick);

var _trackOfferAccordionClosed = __webpack_require__(185);

var _trackOfferAccordionClosed2 = _interopRequireDefault(_trackOfferAccordionClosed);

var _trackOfferAccordionOpened = __webpack_require__(186);

var _trackOfferAccordionOpened2 = _interopRequireDefault(_trackOfferAccordionOpened);

var _trackOpenAccount = __webpack_require__(187);

var _trackOpenAccount2 = _interopRequireDefault(_trackOpenAccount);

var _trackOrderCompleted = __webpack_require__(188);

var _trackOrderCompleted2 = _interopRequireDefault(_trackOrderCompleted);

var _trackPlaceBet = __webpack_require__(189);

var _trackPlaceBet2 = _interopRequireDefault(_trackPlaceBet);

var _trackBetslipErrorMessage = __webpack_require__(190);

var _trackBetslipErrorMessage2 = _interopRequireDefault(_trackBetslipErrorMessage);

var _trackPreferencesUpdate = __webpack_require__(191);

var _trackPreferencesUpdate2 = _interopRequireDefault(_trackPreferencesUpdate);

var _trackQuickStakeButtonsClick = __webpack_require__(192);

var _trackQuickStakeButtonsClick2 = _interopRequireDefault(_trackQuickStakeButtonsClick);

var _trackRegister = __webpack_require__(193);

var _trackRegister2 = _interopRequireDefault(_trackRegister);

var _trackRemoveSelectionButtonClick = __webpack_require__(194);

var _trackRemoveSelectionButtonClick2 = _interopRequireDefault(_trackRemoveSelectionButtonClick);

var _trackSubscriptionCompleted = __webpack_require__(195);

var _trackSubscriptionCompleted2 = _interopRequireDefault(_trackSubscriptionCompleted);

var _trackSubscriptionDetailsCompleted = __webpack_require__(196);

var _trackSubscriptionDetailsCompleted2 = _interopRequireDefault(_trackSubscriptionDetailsCompleted);

var _trackSubscriptionDetailsViewed = __webpack_require__(197);

var _trackSubscriptionDetailsViewed2 = _interopRequireDefault(_trackSubscriptionDetailsViewed);

var _trackSubscriptionSale = __webpack_require__(198);

var _trackSubscriptionSale2 = _interopRequireDefault(_trackSubscriptionSale);

var _trackSubscriptionSaleAttempt = __webpack_require__(199);

var _trackSubscriptionSaleAttempt2 = _interopRequireDefault(_trackSubscriptionSaleAttempt);

var _trackSubscriptionStarted = __webpack_require__(200);

var _trackSubscriptionStarted2 = _interopRequireDefault(_trackSubscriptionStarted);

var _trackSubscriptionViewed = __webpack_require__(201);

var _trackSubscriptionViewed2 = _interopRequireDefault(_trackSubscriptionViewed);

var _trackSubscriptionUpgraded = __webpack_require__(202);

var _trackSubscriptionUpgraded2 = _interopRequireDefault(_trackSubscriptionUpgraded);

var _trackUpgradeCompleted = __webpack_require__(203);

var _trackUpgradeCompleted2 = _interopRequireDefault(_trackUpgradeCompleted);

var _trackUpgradeStarted = __webpack_require__(204);

var _trackUpgradeStarted2 = _interopRequireDefault(_trackUpgradeStarted);

var _trackVoucherCodeApplied = __webpack_require__(205);

var _trackVoucherCodeApplied2 = _interopRequireDefault(_trackVoucherCodeApplied);

var _trackVoucherCodeDenied = __webpack_require__(206);

var _trackVoucherCodeDenied2 = _interopRequireDefault(_trackVoucherCodeDenied);

var _trackVoucherCodeEntered = __webpack_require__(207);

var _trackVoucherCodeEntered2 = _interopRequireDefault(_trackVoucherCodeEntered);

var _trackVoucherCodeRemoved = __webpack_require__(208);

var _trackVoucherCodeRemoved2 = _interopRequireDefault(_trackVoucherCodeRemoved);

var _trackRaceMatrixClick = __webpack_require__(209);

var _trackRaceMatrixClick2 = _interopRequireDefault(_trackRaceMatrixClick);

var _trackRacecardOfferAccordionOpened = __webpack_require__(210);

var _trackRacecardOfferAccordionOpened2 = _interopRequireDefault(_trackRacecardOfferAccordionOpened);

var _trackRacecardOfferAccordionClosed = __webpack_require__(211);

var _trackRacecardOfferAccordionClosed2 = _interopRequireDefault(_trackRacecardOfferAccordionClosed);

var _trackRacecardOfferButtonClicked = __webpack_require__(212);

var _trackRacecardOfferButtonClicked2 = _interopRequireDefault(_trackRacecardOfferButtonClicked);

var _trackCardIndexClick = __webpack_require__(213);

var _trackCardIndexClick2 = _interopRequireDefault(_trackCardIndexClick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _registerEvents2.default)(); /**
                                  * Helper for using segmentio API.
                                  * Provides public interface for calling segmentio
                                  * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
                                  * @author Serhii Kotyk <serhii.kotyk@racingpost.com>
                                  */

(0, _setUTMParams2.default)(location.search.substr(1));

exports.track = _track2.default;
exports.page = _page2.default;
exports.identify = _identify2.default;
exports.alias = _alias2.default;
exports.enableLogging = _enableLogging2.default;
exports.enableDebug = _enableDebug2.default;
exports.getCommonTraits = _commonTraits.getCommonTraits;
exports.setCommonTraits = _commonTraits.setCommonTraits;
exports.clearCommonTraits = _commonTraits.clearCommonTraits;
exports.identifyLogin = _identifyLogin2.default;
exports.identifyRegister = _identifyRegister2.default;
exports.identifySubscriptionSale = _identifySubscriptionSale2.default;
exports.trackBarrierEssentialShow = _trackBarrierEssentialShow2.default;
exports.trackBarrierEssentialSubscribe = _trackBarrierEssentialSubscribe2.default;
exports.trackBarrierShow = _trackBarrierShow2.default;
exports.trackBarrierSignIn = _trackBarrierSignIn2.default;
exports.trackBarrierSignInPassword = _trackBarrierSignInPassword2.default;
exports.trackBarrierSignInShow = _trackBarrierSignInShow2.default;
exports.trackBarrierSubscribe = _trackBarrierSubscribe2.default;
exports.trackBarrierUltimateOnlyShow = _trackBarrierUltimateOnlyShow2.default;
exports.trackBarrierUltimateOnlyUpgrade = _trackBarrierUltimateOnlyUpgrade2.default;
exports.trackBarrierUltimateShow = _trackBarrierUltimateShow2.default;
exports.trackBarrierUltimateSubscribe = _trackBarrierUltimateSubscribe2.default;
exports.trackBetButtonClick = _trackBetButtonClick2.default;
exports.trackBetReceipt = _trackBetReceipt2.default;
exports.trackBettingOfferClick = _trackBettingOfferClick2.default;
exports.trackBookmakerLogin = _trackBookmakerLogin2.default;
exports.trackBookmakerRegister = _trackBookmakerRegister2.default;
exports.trackCardCustomisation = _trackCardCustomisation2.default;
exports.trackDiscardSlipButtonClick = _trackDiscardSlipButtonClick2.default;
exports.trackEmailVerification = _trackEmailVerification2.default;
exports.trackFooterClick = _trackFooterClick2.default;
exports.trackHorseTrackerSettings = _trackHorseTrackerSettings2.default;
exports.trackLogin = _trackLogin2.default;
exports.trackCancelBetButtonClick = _trackCancelBetButtonClick2.default;
exports.trackBookmakerLoginAttempt = _trackBookmakerLoginAttempt2.default;
exports.trackBookmakerLoginFailure = _trackBookmakerLoginFailure2.default;
exports.trackBookmakerLoginSuccess = _trackBookmakerLoginSuccess2.default;
exports.trackBookmakerOfferClaimButtonClick = _trackBookmakerOfferClaimButtonClick2.default;
exports.trackNavigationClick = _trackNavigationClick2.default;
exports.trackOfferAccordionClosed = _trackOfferAccordionClosed2.default;
exports.trackOfferAccordionOpened = _trackOfferAccordionOpened2.default;
exports.trackOpenAccount = _trackOpenAccount2.default;
exports.trackOrderCompleted = _trackOrderCompleted2.default;
exports.trackPlaceBet = _trackPlaceBet2.default;
exports.trackBetslipErrorMessage = _trackBetslipErrorMessage2.default;
exports.trackPreferencesUpdate = _trackPreferencesUpdate2.default;
exports.trackQuickStakeButtonsClick = _trackQuickStakeButtonsClick2.default;
exports.trackRegister = _trackRegister2.default;
exports.trackRemoveSelectionButtonClick = _trackRemoveSelectionButtonClick2.default;
exports.trackSubscriptionCompleted = _trackSubscriptionCompleted2.default;
exports.trackSubscriptionDetailsCompleted = _trackSubscriptionDetailsCompleted2.default;
exports.trackSubscriptionDetailsViewed = _trackSubscriptionDetailsViewed2.default;
exports.trackSubscriptionSale = _trackSubscriptionSale2.default;
exports.trackSubscriptionSaleAttempt = _trackSubscriptionSaleAttempt2.default;
exports.trackSubscriptionStarted = _trackSubscriptionStarted2.default;
exports.trackSubscriptionViewed = _trackSubscriptionViewed2.default;
exports.trackSubscriptionUpgraded = _trackSubscriptionUpgraded2.default;
exports.trackUpgradeCompleted = _trackUpgradeCompleted2.default;
exports.trackUpgradeStarted = _trackUpgradeStarted2.default;
exports.trackVoucherCodeApplied = _trackVoucherCodeApplied2.default;
exports.trackVoucherCodeDenied = _trackVoucherCodeDenied2.default;
exports.trackVoucherCodeEntered = _trackVoucherCodeEntered2.default;
exports.trackVoucherCodeRemoved = _trackVoucherCodeRemoved2.default;
exports.trackRaceMatrixClick = _trackRaceMatrixClick2.default;
exports.trackRacecardOfferAccordionOpened = _trackRacecardOfferAccordionOpened2.default;
exports.trackRacecardOfferAccordionClosed = _trackRacecardOfferAccordionClosed2.default;
exports.trackRacecardOfferButtonClicked = _trackRacecardOfferButtonClicked2.default;
exports.trackCardIndexClick = _trackCardIndexClick2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(38)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserId() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_DB_USER_ID);
}

exports.default = getUserId;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserPackage() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_USER_PACKAGE);
}

exports.default = getUserPackage;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCommonTraits = exports.getCommonTraits = function getCommonTraits() {
    if (!global.analyticsCommonTraits) {
        return false;
    }

    return Object.assign({}, global.analyticsCommonTraits);
};

var setCommonTraits = exports.setCommonTraits = function setCommonTraits(newCommonTraits) {
    if (!global.analyticsCommonTraits && !newCommonTraits) return;

    global.analyticsCommonTraits = Object.assign({}, global.analyticsCommonTraits, newCommonTraits);
};

var clearCommonTraits = exports.clearCommonTraits = function clearCommonTraits() {
    if (!global.analyticsCommonTraits) {
        return;
    }
    global.analyticsCommonTraits = false;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

exports.cleanUsedTraits = cleanUsedTraits;

var _constants = __webpack_require__(18);

var _nonCanonical = __webpack_require__(41);

var _getDeviceType = __webpack_require__(42);

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = __webpack_require__(43);

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = __webpack_require__(44);

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = __webpack_require__(26);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = __webpack_require__(29);

var _getUTMParams = __webpack_require__(45);

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

var usedTraits = {};

function cleanUsedTraits() {
    usedTraits = {};
}

function identify() {
    var _extends2;

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    properties = (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends2), properties, (0, _getUTMParams2.default)(), props);

    var keys = Object.keys(properties);
    var isSameTraits = keys.every(function (prop) {
        return properties[prop] === usedTraits[prop];
    });

    if (isSameTraits) {
        return Promise.resolve();
    }

    usedTraits = Object.assign({}, properties);

    return new Promise(function (resolve) {
        // Segment Identify event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        if (userId) {
            global.analytics.identify(userId, properties, options, resolve);
        } else {
            global.analytics.identify(properties, options, resolve);
        }
    }).then(function () {
        // Permutive Identify event
        if (!global.permutive) {
            console.warn(_constants.MESSAGE_ERROR_NO_PERMUTIVE);
            return;
        }

        if (userId) {
            global.permutive.identify(userId);
        }
    });
}

exports.default = identify;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthSync = function () {
    function AuthSync() {
        var _this = this;

        _classCallCheck(this, AuthSync);

        this.key = 'reload';
        this.defaultValue = 11;
        this.interval = 1000;
        this.lightboxAllowParam = 'authme';

        this.currentValue = undefined;
        /**
         * We use an array of intervalIds coz module may be use as a singleton
         * @type {Array}
         */
        this.intervalIds = [];

        window.addEventListener('beforeunload', function () {
            _this.stopListening();
        });
    }

    _createClass(AuthSync, [{
        key: 'run',
        value: function run() {
            this.startListening();
        }
    }, {
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.intervalIds.push(setInterval(function () {
                if (_this2.getStatus()) {
                    _this2.reloadCurrentPage();
                    _this2.stopListening();
                }
            }, this.interval));
        }
    }, {
        key: 'startListening',
        value: function startListening() {
            if (!this.get()) {
                this.set();
            }
            this.currentValue = this.get();

            this.listen();
        }
    }, {
        key: 'stopListening',
        value: function stopListening() {
            this.intervalIds.forEach(function (interval) {
                clearInterval(interval);
            });
        }
    }, {
        key: 'set',
        value: function set() {
            _rpCookie2.default.sharedSession.set(this.key, this.defaultValue);
        }
    }, {
        key: 'get',
        value: function get() {
            return _rpCookie2.default.sharedSession.get(this.key);
        }
    }, {
        key: 'getStatus',
        value: function getStatus() {
            return this.currentValue !== this.get();
        }
    }, {
        key: 'reloadCurrentPage',
        value: function reloadCurrentPage() {
            var query = window.location.search;

            var param = '?' + this.lightboxAllowParam;
            if (query.indexOf(param) !== -1) {
                window.location.search = window.location.search.replace(param, '?');
            } else {
                window.location.reload();
            }
        }

        /**
         * @deprecated please use reloadAll() instead
         */

    }, {
        key: 'reload',
        value: function reload() {
            this.reloadAll();
        }
    }, {
        key: 'reloadOther',
        value: function reloadOther() {
            _rpCookie2.default.sharedSession.set(this.key, ++this.currentValue);
        }
    }, {
        key: 'reloadAll',
        value: function reloadAll() {
            _rpCookie2.default.sharedSession.set(this.key, this.currentValue + 1);
        }
    }]);

    return AuthSync;
}();

exports.default = new AuthSync();

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _startCase = __webpack_require__(255);

var _startCase2 = _interopRequireDefault(_startCase);

var _isFunction = __webpack_require__(281);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _ValidationIcon = __webpack_require__(52);

var _ValidationIcon2 = _interopRequireDefault(_ValidationIcon);

var _ForgottenPasswordBtn = __webpack_require__(89);

var _ForgottenPasswordBtn2 = _interopRequireDefault(_ForgottenPasswordBtn);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/label-has-for: 0 */


var msg = 'This email address is already used on another Racing Post account.';

var _ref2 = _jsx('div', {}, void 0, msg);

var FormField = function (_PureComponent) {
    _inherits(FormField, _PureComponent);

    function FormField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FormField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormField.__proto__ || Object.getPrototypeOf(FormField)).call.apply(_ref, [this].concat(args))), _this), _this.state = { dirty: false, empty: true }, _this.onBlur = function (e) {
            _this.setState({ dirty: true, empty: !e.target.value.trim() });
            _this.props.validate(e.target);
        }, _this.onChange = function (e) {
            if (_this.props.onlyBlur) {
                return;
            }
            _this.setState({ dirty: true, empty: !e.target.value.trim() });
            _this.props.validate(e.target);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FormField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                type = _props.type,
                hasError = _props.hasError,
                error = _props.error,
                signUpError = _props.signUpError,
                handleClick = _props.handleClick,
                label = _props.label,
                children = _props.children;
            var _state = this.state,
                dirty = _state.dirty,
                empty = _state.empty;


            return _jsx('div', {
                className: _fields2.default.field
            }, void 0, _jsx('label', {
                className: _fields2.default.label
            }, void 0, label || (0, _startCase2.default)(name), _jsx('div', {
                className: _fields2.default.validationWrapper
            }, void 0, _jsx('input', {
                type: type || name,
                name: name,
                autoComplete: 'off',
                className: 'ui-input',
                onBlur: this.onBlur,
                onChange: this.onChange
            }), (dirty || hasError) && _jsx(_ValidationIcon2.default, {
                noValidate: this.props.noValidate,
                hasError: hasError
            }))), hasError && _jsx('div', {
                className: _fields2.default.error
            }, void 0, (0, _isFunction2.default)(error) ? error(dirty, empty) : error), signUpError && _jsx('div', {
                className: _fields2.default.error,
                id: 'pwd-reset'
            }, void 0, _ref2, _jsx(_ForgottenPasswordBtn2.default, {
                onClick: handleClick,
                className: _fields2.default.link
            })), children);
        }
    }]);

    return FormField;
}(_react.PureComponent);

FormField.defaultProps = {
    signUpError: false,
    handleClick: function handleClick() {
        return null;
    },
    label: '',
    children: null,
    noValidate: false,
    onlyBlur: undefined,
    type: undefined
};

exports.default = FormField;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getActiveButtonClass = function getActiveButtonClass(loading) {
    return (0, _classnames2.default)('ui-btn', 'ui-btn_large', 'ui-btn_primary', _fields2.default.submit, _defineProperty({}, _fields2.default.submitActive, loading));
};

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'spinner',
    size: 'Large',
    className: 'ui-animation_spinnerAnimation'
});

var SubmitBtn = function SubmitBtn(_ref) {
    var label = _ref.label,
        loading = _ref.loading;
    return _jsx('div', {
        className: _fields2.default.submitField
    }, void 0, _jsx('button', {
        type: 'submit',
        className: getActiveButtonClass(loading)
    }, void 0, loading ? _ref2 : label));
};

exports.default = SubmitBtn;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint max-len: 0 */
var email = function email(val) {
    return (/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2}(?:[a-z0-9-]*[a-z0-9])?$/i.test(val)
    );
};

var password = function password(val) {
    return new RegExp('(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$').test(val);
};

var passwordNotEmpty = function passwordNotEmpty(val) {
    return Boolean(val.trim().length);
};

var confirmPassword = function confirmPassword(val, otherVal) {
    return val && val === otherVal;
};

var newPassword = password;

var termsConditions = function termsConditions(val) {
    return val;
};

exports.default = {
    email: email, password: password, newPassword: newPassword, passwordNotEmpty: passwordNotEmpty, confirmPassword: confirmPassword, termsConditions: termsConditions
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(136);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(139)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(39);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getNonCanonicalPath = exports.getNonCanonicalPath = function getNonCanonicalPath() {
    return global.location.pathname;
};

var getNonCanonicalUrl = exports.getNonCanonicalUrl = function getNonCanonicalUrl() {
    var url = global.location.href;
    var i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEVICE_DESKTOP = exports.DEVICE_TABLET = exports.DEVICE_PHONE = undefined;

var _mobileDetect = __webpack_require__(148);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEVICE_PHONE = exports.DEVICE_PHONE = 'phone';
var DEVICE_TABLET = exports.DEVICE_TABLET = 'tablet';
var DEVICE_DESKTOP = exports.DEVICE_DESKTOP = 'desktop';

function getDeviceType() {
    var mobileDetect = new _mobileDetect2.default(window.navigator.userAgent);

    if (mobileDetect.phone()) {
        return DEVICE_PHONE;
    }

    if (mobileDetect.tablet()) {
        return DEVICE_TABLET;
    }

    return DEVICE_DESKTOP;
}

exports.default = getDeviceType;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cookieNames = {
    coral: 'c-c',
    ladbrokes: 'lb-c',
    paddyPower: 'pp-c',
    williamHill: 'wh-c',
    bet365: 'bet365-c',
    betway: 'bw-c'
};

function isCookieActive(cookieName) {
    var cookies = document.cookie.split(';');
    return cookies.some(function (cookie) {
        return cookie.split('=')[0].trim() === cookieName;
    });
}

function getBettingAccountLoggedInStatus() {
    var bookies = Object.keys(cookieNames);
    var isBettingAccountLoggedIn = bookies.some(function (bookie) {
        return isCookieActive(cookieNames[bookie]);
    });

    return isBettingAccountLoggedIn;
}

exports.default = getBettingAccountLoggedInStatus;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserName() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_USER_LOGIN);
}

exports.default = getUserName;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _getUTMFirst = __webpack_require__(75);

var _getUTMFirst2 = _interopRequireDefault(_getUTMFirst);

var _getUTMLast = __webpack_require__(150);

var _getUTMLast2 = _interopRequireDefault(_getUTMLast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMParams() {
    var utmFirst = (0, _getUTMFirst2.default)();
    var utmLast = (0, _getUTMLast2.default)();

    return (0, _extends4.default)({}, utmFirst, utmLast ? Object.keys(utmLast).reduce(function (result, key) {
        return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key + ' [last touch]', utmLast[key]));
    }, {}) : null);
}

exports.default = getUTMParams;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(13);
var normalizeHeaderName = __webpack_require__(219);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(78);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(78);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(218)))

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__(240);

// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js
var es = __webpack_require__(85);

// CONCATENATED MODULE: ./node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!lodash_es_isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[es["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es["a" /* default */]] = observable, _ref2;
}
// CONCATENATED MODULE: ./node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ./node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!lodash_es_isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ./node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ./node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _rpAnalytics = __webpack_require__(23);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverComponent = function (_PureComponent) {
    _inherits(PopoverComponent, _PureComponent);

    function PopoverComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PopoverComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopoverComponent.__proto__ || Object.getPrototypeOf(PopoverComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = { popoverType: null }, _this.onOutsideClick = function (event) {
            var domNode = _this.node;
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        }, _this.closePopover = function () {
            _this.setState({ popoverType: null }); // eslint-disable-line react/no-unused-state
        }, _this.togglePopover = function (popoverType) {
            if (popoverType === 'ForgottenPass') {
                (0, _rpAnalytics.identify)().then(function () {
                    (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, global.location.href));
                });
            }

            _this.setState(function (_ref2) {
                var oldPopoverType = _ref2.popoverType;
                return oldPopoverType === popoverType ? { popoverType: null } : { popoverType: popoverType };
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PopoverComponent, [{
        key: 'componentDidMount',
        // eslint-disable-line react/no-unused-state

        value: function componentDidMount() {
            document.querySelector('.ui-header').classList.add('authModalPopover');

            document.addEventListener('click', this.onOutsideClick, true);
            document.addEventListener('touchstart', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.querySelector('.ui-header').classList.remove('authModalPopover');

            document.removeEventListener('click', this.onOutsideClick, true);
            document.removeEventListener('touchstart', this.onOutsideClick, true);
        }
    }]);

    return PopoverComponent;
}(_react.PureComponent);

exports.default = PopoverComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignInForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(8);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpAuthSync = __webpack_require__(31);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _recompose = __webpack_require__(11);

var _actions = __webpack_require__(12);

var _api = __webpack_require__(14);

var _FormField = __webpack_require__(32);

var _FormField2 = _interopRequireDefault(_FormField);

var _PasswordErrorSignIn = __webpack_require__(284);

var _PasswordErrorSignIn2 = _interopRequireDefault(_PasswordErrorSignIn);

var _ForgottenPasswordBtn = __webpack_require__(89);

var _ForgottenPasswordBtn2 = _interopRequireDefault(_ForgottenPasswordBtn);

var _EmailErrorSignIn = __webpack_require__(90);

var _EmailErrorSignIn2 = _interopRequireDefault(_EmailErrorSignIn);

var _SubmitBtn = __webpack_require__(34);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _SwitchFormBtn = __webpack_require__(91);

var _SwitchFormBtn2 = _interopRequireDefault(_SwitchFormBtn);

var _validation = __webpack_require__(35);

var _validation2 = _interopRequireDefault(_validation);

var _forms = __webpack_require__(92);

var _forms2 = _interopRequireDefault(_forms);

var _goToUrl = __webpack_require__(53);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var counter = 0;

function performSignIn(email_, password_, back_url_, onSignInError_, onSignInLoadComplete_, onSignInSuccess_, goToForgottenPass_, goToEmailVerification_, dispatchSetEmailVerificationData_, goToErrorDialog_) {
    function onSuccess(_ref) {
        var session = _ref.data.session;

        if (!session) return;

        onSignInLoadComplete_();
        (0, _actions.signIn)();
        if (!onSignInSuccess_) return;

        var afterSignInSuccess_ = function afterSignInSuccess_() {
            setTimeout(function () {
                if (back_url_) {
                    (0, _goToUrl2.default)(back_url_);
                } else {
                    _rpAuthSync2.default.reloadAll();
                }
            }, 1000);
        };

        onSignInSuccess_(email_).then(afterSignInSuccess_);
    }

    function onError(error_) {
        if (error_ && error_.response && error_.response.status === 400) {
            onSignInError_();
            onSignInLoadComplete_();

            counter += 1;

            if (counter > 4) goToForgottenPass_();

            return;
        }

        if (error_.accountNotVerified) {
            onSignInLoadComplete_();

            if (!dispatchSetEmailVerificationData_) {
                (0, _actions.setEmailVerificationData)(email_, error_.accountId, error_.session); // mandatory login
            } else {
                dispatchSetEmailVerificationData_(email_, error_.accountId, error_.session);
            }

            goToEmailVerification_(error_.accountId, error_.session);

            return;
        }

        goToErrorDialog_();

        throw error_;
    }

    (0, _api.AuthSignIn)(email_, password_).then(onSuccess, onError).catch(function (error_) {
        throw error_;
    });
}

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.performSignIn = performSignIn;
}

constructGlobalAuthApi();

var SignInForm = exports.SignInForm = function (_Component) {
    _inherits(SignInForm, _Component);

    function SignInForm() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, SignInForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SignInForm.__proto__ || Object.getPrototypeOf(SignInForm)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            emailError: false,
            passwordError: false,
            loading: false,
            signInError: false
        }, _this.onSubmit = function (event_) {
            event_.preventDefault();

            var _this$form = _this.form,
                email = _this$form.email,
                password = _this$form.password;

            var is_form_valid_ = [email, password].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!is_form_valid_) return;

            var _this$props = _this.props,
                backUrl = _this$props.backUrl,
                onSignInSuccess = _this$props.onSignInSuccess,
                goToForgottenPass = _this$props.goToForgottenPass,
                goToEmailVerification = _this$props.goToEmailVerification,
                dispatchSetEmailVerificationData = _this$props.dispatchSetEmailVerificationData,
                goToErrorDialog = _this$props.goToErrorDialog;


            _this.setState({ loading: true });

            var onSignInError_ = function onSignInError_() {
                _this.setState({ signInError: true });
            };

            var onSignInLoadComplete_ = function onSignInLoadComplete_() {
                _this.setState({ loading: false });
            };

            performSignIn(email.value, password.value, backUrl, onSignInError_, onSignInLoadComplete_, onSignInSuccess, goToForgottenPass, goToEmailVerification, dispatchSetEmailVerificationData, goToErrorDialog);
        }, _this.validate = function (_ref3) {
            var name = _ref3.name,
                value = _ref3.value;

            var fieldName = name;
            if (name === 'password') fieldName += 'NotEmpty';
            var validate = _validation2.default[fieldName];
            var isValid = validate(value);
            _this.setState(_defineProperty({}, name + 'Error', !isValid));
            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignInForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                emailError = _state.emailError,
                passwordError = _state.passwordError,
                loading = _state.loading,
                signInError = _state.signInError;
            var _props = this.props,
                goToForgottenPass = _props.goToForgottenPass,
                goToSignUp = _props.goToSignUp,
                hidden = _props.hidden,
                switchFormLabel = _props.switchFormLabel;


            return _react2.default.createElement(
                'form',
                {
                    className: _forms2.default.form + ' ' + _forms2.default.signIn,
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _jsx(_FormField2.default, {
                    name: 'email',
                    validate: this.validate,
                    hasError: emailError,
                    error: _EmailErrorSignIn2.default,
                    onlyBlur: true
                }),
                _jsx(_FormField2.default, {
                    name: 'password',
                    validate: this.validate,
                    hasError: passwordError,
                    error: _PasswordErrorSignIn2.default,
                    onlyBlur: true
                }),
                _jsx(_ForgottenPasswordBtn2.default, {
                    onClick: goToForgottenPass,
                    error: signInError
                }),
                _jsx(_SubmitBtn2.default, {
                    label: 'Sign In',
                    loading: loading
                }),
                _jsx(_SwitchFormBtn2.default, {
                    className: 'signIn',
                    label: switchFormLabel,
                    onClick: goToSignUp,
                    hidden: hidden
                })
            );
        }
    }]);

    return SignInForm;
}(_react.Component);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignInForm'), (0, _recompose.defaultProps)({
    backUrl: null,
    switchFormLabel: 'Create account',
    onSignInSuccess: function onSignInSuccess() {
        return null;
    }
}), (0, _reactRedux.connect)(null, {
    dispatchSignIn: _actions.signIn,
    dispatchSetEmailVerificationData: _actions.setEmailVerificationData
}), (0, _recompose.setPropTypes)({
    goToSignUp: _propTypes2.default.func.isRequired,
    goToForgottenPass: _propTypes2.default.func.isRequired,
    goToErrorDialog: _propTypes2.default.func.isRequired,
    goToEmailVerification: _propTypes2.default.func.isRequired,
    dispatchSignIn: _propTypes2.default.func.isRequired,
    dispatchSetEmailVerificationData: _propTypes2.default.func.isRequired,
    hidden: _propTypes2.default.bool.isRequired,
    backUrl: _propTypes2.default.string,
    switchFormLabel: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    onSignInSuccess: _propTypes2.default.func
}))(SignInForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(261);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(262);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cross',
    size: 'Medium'
});

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'tick',
    size: 'Medium'
});

var ValidationIcon = function ValidationIcon(_ref) {
    var _classNames;

    var hasError = _ref.hasError,
        noValidate = _ref.noValidate;

    var isError = hasError;
    var isSuccess = !noValidate && !hasError;
    var className = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _fields2.default.iconError, isError), _defineProperty(_classNames, _fields2.default.iconSuccess, isSuccess), _classNames), _fields2.default.iconWrapper);
    return _jsx('div', {
        className: className
    }, void 0, isError && _ref2, isSuccess && _ref3);
};

ValidationIcon.defaultProps = {
    noValidate: false
};

exports.default = ValidationIcon;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by Serhii_Kotyk on 09-Sep-16.
 */
var goToUrl = function goToUrl(url) {
    var loc = window.location;
    if (loc) {
        // timeout is required for safari
        // otherwise it only reloads the page
        // but should work fine as well for all browsers
        setTimeout(function () {
            if (loc.href !== url) {
                loc.assign(url);
            } else {
                // issue was spotted on profiles pages
                // assigning url with hash to window location
                // does not trigger page reload
                // https://racingpost.atlassian.net/browse/QW-390
                loc.reload();
            }
        }, 1);
    }
};

exports.default = goToUrl;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dropdown = __webpack_require__(286);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'ui-popoverPointer'
});

var Dropdown = function Dropdown(_ref) {
    var children = _ref.children,
        title = _ref.title,
        close = _ref.close;
    return _jsx('div', {
        className: 'ui-popover ui-popover_headless ' + _dropdown2.default.dropdown
    }, void 0, _ref2, _jsx('div', {
        className: 'ui-popoverHeader'
    }, void 0, _jsx('span', {
        className: 'ui-popoverHeader__title'
    }, void 0, title), _jsx('button', {
        className: 'ui-btn ui-btn_secondary ui-popoverHeader__btn',
        onClick: close
    }, void 0, 'Done')), children);
};

exports.default = Dropdown;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUpForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = __webpack_require__(32);

var _FormField2 = _interopRequireDefault(_FormField);

var _PasswordError = __webpack_require__(56);

var _PasswordError2 = _interopRequireDefault(_PasswordError);

var _SubmitBtn = __webpack_require__(34);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _SwitchFormBtn = __webpack_require__(91);

var _SwitchFormBtn2 = _interopRequireDefault(_SwitchFormBtn);

var _Conditions = __webpack_require__(289);

var _Conditions2 = _interopRequireDefault(_Conditions);

var _EmailErrorSignIn = __webpack_require__(90);

var _EmailErrorSignIn2 = _interopRequireDefault(_EmailErrorSignIn);

var _validation = __webpack_require__(35);

var _validation2 = _interopRequireDefault(_validation);

var _api = __webpack_require__(14);

var _forms = __webpack_require__(92);

var _forms2 = _interopRequireDefault(_forms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function performSignUp(email_, password_, options_, onSignUpError_, onSignUpLoadComplete_, showErrorDialog_, onSignUpSuccess_) {
    var conditions = _extends({
        horseBetting: false,
        horseNews: false,
        bloodstock: false,
        sportBetting: false,
        competitions: false
    }, options_);

    function onSuccess_() {
        onSignUpLoadComplete_();

        if (!onSignUpSuccess_) return;

        onSignUpSuccess_(email_.value, conditions);
    }

    function onError_(error_) {
        if (error_ && error_.response && error_.response.data.errorMessage === 'The email is already in use.') {
            onSignUpError_();
            onSignUpLoadComplete_();

            return;
        }

        showErrorDialog_();
    }

    (0, _api.AuthSignUp)({
        email: email_,
        password: password_,
        conditions: conditions
    }).then(onSuccess_, onError_).catch(function (error_) {
        throw error_;
    });
}

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.performSignUp = performSignUp;
}

constructGlobalAuthApi();

var SignUpForm = exports.SignUpForm = function (_Component) {
    _inherits(SignUpForm, _Component);

    function SignUpForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SignUpForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            emailError: false,
            passwordError: false,
            confirmPasswordError: false,
            termsConditionsError: false,
            loading: false,
            signUpError: false
        }, _this.onSubmit = function (event_) {
            event_.preventDefault();

            var _this$form = _this.form,
                email = _this$form.email,
                password = _this$form.password,
                confirmPassword = _this$form.confirmPassword,
                termsConditions = _this$form.termsConditions,
                allConditions = _this$form.allConditions,
                horseBetting = _this$form.horseBetting,
                horseNews = _this$form.horseNews,
                bloodstock = _this$form.bloodstock,
                sportBetting = _this$form.sportBetting,
                competitions = _this$form.competitions,
                newsletterThirdParty = _this$form.newsletterThirdParty,
                eighteenYears = _this$form.eighteenYears;


            var is_form_valid_ = [email, password, confirmPassword, termsConditions].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!is_form_valid_) return;

            _this.setState({ loading: true });

            var conditions = {};

            var _this$props = _this.props,
                onSignUpSuccess = _this$props.onSignUpSuccess,
                disableConditions = _this$props.disableConditions,
                goToSignUpComplete = _this$props.goToSignUpComplete,
                goToErrorDialog = _this$props.goToErrorDialog;


            if (!disableConditions) {
                conditions = {
                    horseBetting: allConditions && allConditions.checked ? true : horseBetting.checked,
                    horseNews: allConditions && allConditions.checked ? true : horseNews.checked,
                    bloodstock: allConditions && allConditions.checked ? true : bloodstock.checked,
                    sportBetting: allConditions && allConditions.checked ? true : sportBetting.checked,
                    competitions: allConditions && allConditions.checked ? true : competitions.checked,
                    newsletterThirdParty: newsletterThirdParty && newsletterThirdParty.checked,
                    eighteenYears: eighteenYears && eighteenYears.checked,
                    termsConditions: termsConditions && termsConditions.checked
                };
            } else {
                conditions = {
                    horseBetting: false,
                    horseNews: false,
                    bloodstock: false,
                    sportBetting: false,
                    competitions: false,
                    newsletterThirdParty: false,
                    eighteenYears: false,
                    termsConditions: termsConditions && termsConditions.checked
                };
            }

            var onSignUpSuccess_ = function onSignUpSuccess_() {
                if (onSignUpSuccess) onSignUpSuccess(email.value, conditions);

                goToSignUpComplete();
            };

            var onSignUpError_ = function onSignUpError_() {
                _this.setState({ signUpError: true });
            };

            var onSignUpLoadComplete_ = function onSignUpLoadComplete_() {
                _this.setState({ loading: false });
            };

            performSignUp(email.value, password.value, conditions, onSignUpError_, onSignUpLoadComplete_, goToErrorDialog, onSignUpSuccess_);
        }, _this.validate = function (_ref2) {
            var name = _ref2.name,
                type = _ref2.type,
                checked = _ref2.checked,
                value = _ref2.value;

            var validate = _validation2.default[name];
            var inputValue = type === 'checkbox' ? checked : value;
            var isValid = validate(inputValue, _this.form.password.value);
            _this.setState(function (prevState) {
                var _ref3;

                return _ref3 = {}, _defineProperty(_ref3, name + 'Error', !isValid), _defineProperty(_ref3, 'signUpError', name === 'email' ? false : prevState.signUpError), _ref3;
            });

            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignUpForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                emailError = _state.emailError,
                passwordError = _state.passwordError,
                confirmPasswordError = _state.confirmPasswordError,
                termsConditionsError = _state.termsConditionsError,
                loading = _state.loading,
                signUpError = _state.signUpError;
            var _props = this.props,
                goToForgottenPass = _props.goToForgottenPass,
                disableConditions = _props.disableConditions,
                submitLabel = _props.submitLabel,
                switchFormLabel = _props.switchFormLabel,
                goToSignIn = _props.goToSignIn,
                hidden = _props.hidden;


            return _react2.default.createElement(
                'form',
                {
                    className: _forms2.default.form + ' ' + _forms2.default.signUp,
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _jsx(_FormField2.default, {
                    name: 'email',
                    validate: this.validate,
                    hasError: emailError,
                    signUpError: signUpError,
                    handleClick: goToForgottenPass,
                    error: _EmailErrorSignIn2.default
                }),
                _jsx(_FormField2.default, {
                    name: 'password',
                    validate: this.validate,
                    hasError: passwordError,
                    error: _PasswordError2.default
                }),
                _jsx(_FormField2.default, {
                    name: 'confirmPassword',
                    type: 'password',
                    validate: this.validate,
                    hasError: confirmPasswordError,
                    error: 'Passwords do not match'
                }),
                _jsx(_Conditions2.default, {
                    validate: this.validate,
                    disableConditions: disableConditions,
                    termsConditionsError: termsConditionsError
                }),
                _jsx(_SubmitBtn2.default, {
                    label: submitLabel,
                    loading: loading
                }),
                _jsx(_SwitchFormBtn2.default, {
                    className: 'signUp',
                    label: switchFormLabel,
                    onClick: goToSignIn,
                    hidden: hidden
                })
            );
        }
    }]);

    return SignUpForm;
}(_react.Component);

SignUpForm.defaultProps = {
    onSignUpSuccess: function onSignUpSuccess() {
        return null;
    },
    disableConditions: false,
    submitLabel: 'Sign Up',
    switchFormLabel: 'Sign In'
};

exports.default = SignUpForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint no-mixed-operators: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('li', {}, void 0, 'Contain at least 1 number');

var _ref2 = _jsx('li', {}, void 0, 'Contain an upper and lower case character');

var _ref3 = _jsx('li', {}, void 0, 'Be at least 8 characters long');

var PasswordError = function PasswordError(props) {
    return _jsx('div', {
        className: props && _fields2.default[props.className] || _fields2.default.comment
    }, void 0, _jsx('span', {
        className: _fields2.default.commentTitle
    }, void 0, 'Passwords must:'), _jsx('ul', {
        className: _fields2.default.commentList
    }, void 0, _ref, _ref2, _ref3));
};

PasswordError.defaultProps = {
    className: ''
};

exports.default = PasswordError;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPassword = __webpack_require__(295);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForgottenPassword2.default;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUpComplete = __webpack_require__(298);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUpComplete2.default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _ErrorDialog = __webpack_require__(60);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorPopup = function ErrorPopup(_ref) {
    var closePopover = _ref.closePopover,
        message = _ref.message;
    return _jsx(_Lightbox2.default, {
        close: closePopover
    }, void 0, _jsx(_ErrorDialog2.default, {
        close: closePopover,
        message: message
    }));
};

ErrorPopup.defaultProps = {
    message: ''
};

exports.default = ErrorPopup;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ErrorDialog = __webpack_require__(299);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ErrorDialog2.default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _EmailVerification = __webpack_require__(94);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerificationPopup = function EmailVerificationPopup(_ref) {
    var closePopover = _ref.closePopover,
        message = _ref.message,
        accountId = _ref.accountId,
        session = _ref.session,
        goToSignIn = _ref.goToSignIn,
        goToErrorDialog = _ref.goToErrorDialog;
    return _jsx(_Lightbox2.default, {
        close: closePopover
    }, void 0, _jsx(_EmailVerification2.default, {
        email: message,
        accountId: accountId,
        session: session,
        onSuccess: goToSignIn,
        onError: goToErrorDialog
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerificationPopup'), (0, _recompose.defaultProps)({
    message: ''
}), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showEmailVerifi = _ref2.showEmailVerification,
        message = _ref2$showEmailVerifi.message,
        accountId = _ref2$showEmailVerifi.accountId,
        session = _ref2$showEmailVerifi.session;
    return { message: message, accountId: accountId, session: session };
}), (0, _recompose.setPropTypes)({
    closePopover: _propTypes2.default.func.isRequired,
    goToErrorDialog: _propTypes2.default.func.isRequired,
    message: _propTypes2.default.string
}))(EmailVerificationPopup);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(36);
var core = __webpack_require__(27);
var ctx = __webpack_require__(103);
var hide = __webpack_require__(105);
var has = __webpack_require__(64);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(106);
var IE8_DOM_DEFINE = __webpack_require__(107);
var toPrimitive = __webpack_require__(109);
var dP = Object.defineProperty;

exports.f = __webpack_require__(24) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(66);
var defined = __webpack_require__(67);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(114);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EMPTY_EVENT = exports.EMPTY_EVENT = {};
var config = {};

function createConfigProvider() {
    return {
        registerEvent: function registerEvent(event, getPropTypes, buildProps) {
            config[event] = {
                getPropTypes: getPropTypes,
                buildProps: buildProps
            };
        },
        getEvent: function getEvent(event) {
            return event in config ? config[event] : EMPTY_EVENT;
        }
    };
}

var configProvider = createConfigProvider();

exports.default = configProvider;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_70__;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(133);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(135);
var RequireObjectCoercible = __webpack_require__(137);
var callBound = __webpack_require__(141);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

module.exports = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (has(obj, key) && $isEnumerable(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(73);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMFirst() {
    return _rpCookie2.default.sharedPermanent.get(_constants.COOKIE_UTM_KEY_FIRST);
}

exports.default = getUTMFirst;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mandatoryLoginReducer = exports.errorDialogReducer = exports.forgottenPassReducer = exports.resetPassReducer = exports.emailVerificationReducer = exports.barrierReducer = exports.userReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsCookie = __webpack_require__(25);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _actions = __webpack_require__(12);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookie = _jsCookie2.default.get('RDSP');
var isLoggedIn = cookie && JSON.parse(cookie).rp_uid;

var userReducer = exports.userReducer = function userReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !!isLoggedIn;
    var action = arguments[1];

    switch (action.type) {
        case actions.SIGN_IN:
            return true;
        case actions.SIGN_OUT:
            return false;
        default:
            return state;
    }
};

var initialBarrierState = {
    show: false,
    step: 'Subscriptions',
    backUrl: '',
    text: '',
    service: '',
    showTitle: false
};

var barrierReducer = exports.barrierReducer = function barrierReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialBarrierState;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_BARRIER:
            return _extends({}, state, {
                step: action.step,
                backUrl: action.backUrl,
                text: action.text,
                service: action.service,
                showTitle: action.showTitle || false,
                show: true
            });
        case actions.HIDE_BARRIER:
            return _extends({}, state, {
                show: false
            });
        default:
            return state;
    }
};

var emailVerificationReducer = exports.emailVerificationReducer = function emailVerificationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isVisible: false,
        message: '',
        accountId: null,
        session: null
    };
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_EMAIL_VERIFICATION:
            return {
                isVisible: true,
                message: action.message || state.message,
                accountId: action.accountId || state.accountId,
                session: action.session || state.session
            };
        case actions.HIDE_EMAIL_VERIFICATION:
            return {
                isVisible: false,
                message: '',
                accountId: null,
                session: null
            };
        case actions.SET_EMAIL_VERIFICATION_MESSAGE:
            return _extends({}, state, {
                message: action.message,
                accountId: action.accountId,
                session: action.session
            });
        default:
            return state;
    }
};

var resetPassReducer = exports.resetPassReducer = function resetPassReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isVisible: false,
        email: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_RESET_PASSWORD:
            return {
                isVisible: true,
                email: action.email
            };
        case actions.HIDE_RESET_PASSWORD:
            return {
                isVisible: false,
                email: ''
            };
        default:
            return state;
    }
};

var forgottenPassReducer = exports.forgottenPassReducer = function forgottenPassReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_FORGOTTEN_PASSWORD:
            return true;
        case actions.HIDE_FORGOTTEN_PASSWORD:
            return false;
        default:
            return state;
    }
};

var errorDialogReducer = exports.errorDialogReducer = function errorDialogReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isVisible: false,
        message: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_ERROR_DIALOG:
            return {
                isVisible: true,
                message: action.message
            };
        case actions.HIDE_ERROR_DIALOG:
            return {
                isVisible: false,
                message: ''
            };
        default:
            return state;
    }
};

var initialMandatoryLoginState = {
    show: false,
    step: 'SignUp',
    target: null
};

var mandatoryLoginReducer = exports.mandatoryLoginReducer = function mandatoryLoginReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMandatoryLoginState;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_MANDATORY_LOGIN:
            return _extends({}, state, {
                show: true,
                step: action.step,
                target: action.target
            });
        case actions.HIDE_MANDATORY_LOGIN:
            return _extends({}, state, {
                show: false
            });
        default:
            return state;
    }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var settle = __webpack_require__(220);
var buildURL = __webpack_require__(222);
var parseHeaders = __webpack_require__(223);
var isURLSameOrigin = __webpack_require__(224);
var createError = __webpack_require__(79);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(225);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(221);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldCheckForBarrier = exports.getParams = undefined;

var _parseParams = __webpack_require__(234);

var _parseParams2 = _interopRequireDefault(_parseParams);

var _handleCookie = __webpack_require__(235);

var _handleCookie2 = _interopRequireDefault(_handleCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIGHTBOX_ALLOW_PARAM = 'authme';

var getParams = exports.getParams = function getParams() {
    return (0, _parseParams2.default)((0, _handleCookie2.default)());
};

var shouldCheckForBarrier = exports.shouldCheckForBarrier = function shouldCheckForBarrier() {
    var search = window.location.search;


    return search.indexOf('?' + LIGHTBOX_ALLOW_PARAM) !== -1 || search.indexOf('&' + LIGHTBOX_ALLOW_PARAM) !== -1;
};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(238);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(242);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7), __webpack_require__(241)(module)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AuthNavBtn = __webpack_require__(247);

var _AuthNavBtn2 = _interopRequireDefault(_AuthNavBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AuthNavBtn2.default;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    getRawTag = __webpack_require__(267),
    objectToString = __webpack_require__(268);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {}, void 0, 'Your details are incorrect. Please try again');

var ForgottenPasswordBtn = function ForgottenPasswordBtn(_ref) {
    var _onClick = _ref.onClick,
        error = _ref.error,
        className = _ref.className;
    return _jsx('div', {
        className: _fields2.default.field + ' ' + className
    }, void 0, _jsx('button', {
        type: 'button',
        className: 'ui-link ui-link_secondary ui-reset-for-btn',
        onClick: function onClick(e) {
            e.preventDefault();
            _onClick();
        }
    }, void 0, 'Forgotten password?'), error && _jsx('div', {
        className: _fields2.default.error,
        id: 'error-sign-in'
    }, void 0, _ref2));
};

ForgottenPasswordBtn.defaultProps = {
    error: false,
    className: ''
};

exports.default = ForgottenPasswordBtn;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint no-mixed-operators: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailErrorSignIn = function EmailErrorSignIn(dirty, empty) {
    return _jsx('div', {
        className: _fields2.default.comment
    }, void 0, _jsx('span', {}, void 0, dirty && empty || !dirty ? 'Please specify your email address' : 'Please use a valid email address'));
};

exports.default = EmailErrorSignIn;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchFormBtn = function SwitchFormBtn(_ref) {
    var className = _ref.className,
        label = _ref.label,
        onClick = _ref.onClick,
        hidden = _ref.hidden;
    return _jsx('div', {
        className: (0, _classnames2.default)({ 'hidden-lg-up': hidden }, '' + _fields2.default.switchField, _fields2.default[className])
    }, void 0, _jsx('button', {
        type: 'button',
        className: 'ui-reset-for-btn ui-link ui-link_secondary',
        onClick: onClick
    }, void 0, label));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SwitchFormBtn'), (0, _recompose.defaultProps)({
    className: ''
}), (0, _recompose.setPropTypes)({
    className: _propTypes2.default.string,
    label: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
    onClick: _propTypes2.default.func.isRequired,
    hidden: _propTypes2.default.bool.isRequired
}))(SwitchFormBtn);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(285);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./forms.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./forms.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _ForgottenPassword = __webpack_require__(57);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgottenPass = function ForgottenPass(_ref) {
    var closePopover = _ref.closePopover;
    return _jsx(_Lightbox2.default, {
        close: closePopover
    }, void 0, _jsx(_ForgottenPassword2.default, {
        close: closePopover
    }));
};

exports.default = ForgottenPass;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailVerification = __webpack_require__(302);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmailVerification2.default;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Barrier = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _BarrierContent = __webpack_require__(312);

var _BarrierContent2 = _interopRequireDefault(_BarrierContent);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var Barrier = exports.Barrier = function (_PureComponent) {
    _inherits(Barrier, _PureComponent);

    function Barrier(props) {
        _classCallCheck(this, Barrier);

        var _this = _possibleConstructorReturn(this, (Barrier.__proto__ || Object.getPrototypeOf(Barrier)).call(this, props));

        _this.goToStep = function (nextStep) {
            _this.setState({ step: nextStep });
        };

        _this.state = {
            step: props.step
        };
        return _this;
    }

    _createClass(Barrier, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var step = _ref.step;

            if (step !== this.state.step) {
                this.goToStep(step);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                show = _props.show,
                _close = _props.close,
                backUrl = _props.backUrl,
                showTitle = _props.showTitle;
            var step = this.state.step;

            return show ? _jsx(_Lightbox2.default, {
                close: function close() {
                    if (_this2.state.step === 'SignUpComplete') {
                        _this2.goToStep('SignIn');
                    } else {
                        _close();
                    }
                }
            }, void 0, _jsx(_BarrierContent2.default, {
                step: step,
                close: _close,
                backUrl: backUrl,
                onStepChange: this.goToStep,
                showTitle: showTitle
            })) : null;
        }
    }]);

    return Barrier;
}(_react.PureComponent);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Barrier'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showBarrier = _ref2.showBarrier,
        show = _ref2$showBarrier.show,
        step = _ref2$showBarrier.step,
        backUrl = _ref2$showBarrier.backUrl,
        showTitle = _ref2$showBarrier.showTitle;
    return {
        show: show, step: step, backUrl: backUrl, showTitle: showTitle
    };
}, { close: _actions.hideBarriers }), (0, _recompose.setPropTypes)({
    show: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired,
    step: _propTypes2.default.string.isRequired,
    backUrl: _propTypes2.default.string,
    showTitle: _propTypes2.default.bool.isRequired
}))(Barrier);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(354);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/sass-loader/lib/loader.js!./App.scss", function() {
		var newContent = require("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/sass-loader/lib/loader.js!./App.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(47);

var _reduxDevtoolsExtension = __webpack_require__(356);

var _reducers = __webpack_require__(76);

var composeEnhancers = _redux.compose;
var middlewares = [];

if (false) {
    composeEnhancers = _reduxDevtoolsExtension.composeWithDevTools;
    new Promise(function (resolve) {
        require.ensure([], function (require) {
            resolve(require('redux-logger'));
        });
    }).then(function (_ref) {
        var createLogger = _ref.createLogger;

        middlewares.push(createLogger());
    });
}

var store = (0, _redux.createStore)((0, _redux.combineReducers)({
    userLoggedIn: _reducers.userReducer,
    showBarrier: _reducers.barrierReducer,
    showEmailVerification: _reducers.emailVerificationReducer,
    showResetPassword: _reducers.resetPassReducer,
    showForgottenPassword: _reducers.forgottenPassReducer,
    showErrorDialog: _reducers.errorDialogReducer,
    showMandatoryLogin: _reducers.mandatoryLoginReducer
}), composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

exports.default = store;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getParams = exports.dispatchSignOut = exports.dispatchSignIn = exports.api = exports.reducers = exports.actions = exports.showMandatoryLoginForm = exports.showEmailVerification = exports.showForgottenPass = exports.showErrorDialog = exports.showResetPass = exports.showError = exports.checkForAccess = exports.createBarriers = exports.render = undefined;

var _actions = __webpack_require__(12);

var actions = _interopRequireWildcard(_actions);

var _reducers = __webpack_require__(76);

var reducers = _interopRequireWildcard(_reducers);

var _api = __webpack_require__(14);

var api = _interopRequireWildcard(_api);

var _helpers = __webpack_require__(82);

var _render = __webpack_require__(236);

var _render2 = _interopRequireDefault(_render);

var _analytics = __webpack_require__(21);

var _authApi = __webpack_require__(357);

var _MandatoryLoginOverlay = __webpack_require__(358);

var MandatoryLoginOverlay = _interopRequireWildcard(_MandatoryLoginOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.MandatoryLoginOverlay = MandatoryLoginOverlay;
    global.authApi.checkForAccess = _authApi.checkForAccess;
    global.authApi.showError = _authApi.showError;
    global.authApi.showForgottenPass = _authApi.showForgottenPass;
    global.authApi.showEmailVerification = _authApi.showEmailVerification;
    global.authApi.onSignInSuccess = _analytics.onSignInSuccess;
    global.authApi.onSignUpSuccess = _analytics.onSignUpSuccess;
}

constructGlobalAuthApi();

exports.render = _render2.default;
exports.createBarriers = _render.createBarriers;
exports.checkForAccess = _authApi.checkForAccess;
exports.showError = _authApi.showError;
exports.showResetPass = _authApi.showResetPass;
exports.showErrorDialog = _authApi.showErrorDialog;
exports.showForgottenPass = _authApi.showForgottenPass;
exports.showEmailVerification = _authApi.showEmailVerification;
exports.showMandatoryLoginForm = _authApi.showMandatoryLoginForm;
exports.actions = actions;
exports.reducers = reducers;
exports.api = api;
exports.dispatchSignIn = _authApi.dispatchSignIn;
exports.dispatchSignOut = _authApi.dispatchSignOut;
exports.getParams = _helpers.getParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _configProvider = __webpack_require__(69);

var _configProvider2 = _interopRequireDefault(_configProvider);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _logIn = __webpack_require__(129);

var _logIn2 = _interopRequireDefault(_logIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    _configProvider2.default.registerEvent(_logIn2.default);

    _configProvider2.default.registerEvent(_events.EVENT_BARRIER_SIGN_IN);

    _configProvider2.default.registerEvent(_events.EVENT_BARRIER_SUBSCRIBE);

    _configProvider2.default.registerEvent(_events.EVENT_BETTING_OFFER_CLICK, function () {
        return (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes2.default.string.isRequired);
    }, function (props) {
        return (0, _extends3.default)({}, props);
    });
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(102);
module.exports = __webpack_require__(27).Object.assign;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(62);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(111) });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(104);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(63);
var createDesc = __webpack_require__(110);
module.exports = __webpack_require__(24) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(24) && !__webpack_require__(38)(function () {
  return Object.defineProperty(__webpack_require__(108)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);
var document = __webpack_require__(36).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(37);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(24);
var getKeys = __webpack_require__(112);
var gOPS = __webpack_require__(123);
var pIE = __webpack_require__(124);
var toObject = __webpack_require__(125);
var IObject = __webpack_require__(66);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(38)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(113);
var enumBugKeys = __webpack_require__(122);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(64);
var toIObject = __webpack_require__(65);
var arrayIndexOf = __webpack_require__(115)(false);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(65);
var toLength = __webpack_require__(116);
var toAbsoluteIndex = __webpack_require__(117);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(68);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(68);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(119)('keys');
var uid = __webpack_require__(121);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(27);
var global = __webpack_require__(36);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(120) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 123 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(67);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(127), __esModule: true };

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
var $Object = __webpack_require__(27).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(62);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(24), 'Object', { defineProperty: __webpack_require__(63).f });


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _getUserPackage = __webpack_require__(28);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    event: _events.EVENT_LOG_IN,
    validateProps: function validateProps() {
        var _ref;

        return _ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_EMAIL, _propTypes2.default.string.isRequired), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PACKAGE, _propTypes2.default.string), _ref;
    },
    traitsToProps: function traitsToProps(traits) {
        var _ref2;

        return _ref2 = {}, (0, _defineProperty3.default)(_ref2, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_ref2, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()), _ref2;
    }
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cleanLegacy;

var _jsCookie = __webpack_require__(25);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var legacyCookies = ['RP_PS_SESSIONID', 'RP_SP_DATA0', 'RP_SP_SESSIONID', 'RP_SS_SESSIONID', 'RP_ST_DATA0', 'RP_ST_DATA1', 'RP_ST_SESSIONID'];

var domain = window.location.hostname.split('.').slice(-2).join('.');

function cleanLegacy() {
    var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : legacyCookies;

    cookies.forEach(function (name) {
        _jsCookie2.default.remove(name);
        _jsCookie2.default.remove(name, { domain: domain });
    });
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _qs = __webpack_require__(70);

var _qs2 = _interopRequireDefault(_qs);

var _object = __webpack_require__(132);

var _object2 = _interopRequireDefault(_object);

var _getUTMFirst = __webpack_require__(75);

var _getUTMFirst2 = _interopRequireDefault(_getUTMFirst);

var _setUTMFirst = __webpack_require__(144);

var _setUTMFirst2 = _interopRequireDefault(_setUTMFirst);

var _setUTMLast = __webpack_require__(145);

var _setUTMLast2 = _interopRequireDefault(_setUTMLast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMParams(query) {
    /* eslint-disable camelcase */
    var _qs$parse = _qs2.default.parse(query),
        _qs$parse$utm_source = _qs$parse.utm_source,
        utm_source = _qs$parse$utm_source === undefined ? '' : _qs$parse$utm_source,
        _qs$parse$utm_medium = _qs$parse.utm_medium,
        utm_medium = _qs$parse$utm_medium === undefined ? '' : _qs$parse$utm_medium,
        _qs$parse$utm_campaig = _qs$parse.utm_campaign,
        utm_campaign = _qs$parse$utm_campaig === undefined ? '' : _qs$parse$utm_campaig,
        _qs$parse$utm_term = _qs$parse.utm_term,
        utm_term = _qs$parse$utm_term === undefined ? '' : _qs$parse$utm_term,
        _qs$parse$utm_content = _qs$parse.utm_content,
        utm_content = _qs$parse$utm_content === undefined ? '' : _qs$parse$utm_content;

    /* eslint-enable camelcase */


    var utmCurrent = {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_term: utm_term,
        utm_content: utm_content
    };

    if (!Object.values) {
        _object2.default.shim();
    }

    if (Object.values(utmCurrent).some(function (value) {
        return !!value;
    })) {
        if (!(0, _getUTMFirst2.default)()) {
            (0, _setUTMFirst2.default)(utmCurrent);
        } else {
            (0, _setUTMLast2.default)(utmCurrent);
        }
    }
}

exports.default = setUTMParams;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(71);

var implementation = __webpack_require__(73);
var getPolyfill = __webpack_require__(74);
var shim = __webpack_require__(143);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(72);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(134);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(72); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(39);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(138);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40);

var $TypeError = GetIntrinsic('%TypeError%');

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(140);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(40);

var callBind = __webpack_require__(142);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(39);

var GetIntrinsic = __webpack_require__(40);

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

module.exports = function callBind() {
	return bind.apply($call, arguments);
};

module.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(74);
var define = __webpack_require__(71);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMFirst(currentUTM) {
    _rpCookie2.default.sharedPermanent.set(_constants.COOKIE_UTM_KEY_FIRST, currentUTM);
}

exports.default = setUTMFirst;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMLast(currentUTM) {
    _rpCookie2.default.sharedPermanent.set(_constants.COOKIE_UTM_KEY_LAST, currentUTM);
}

exports.default = setUTMLast;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-console */
var EVENT = 'event';
var TRAITS = 'traits';
var OPTIONS = 'options';

var previousEvents = {};

var DEFAULT_SETTINGS = exports.DEFAULT_SETTINGS = {
    alias: true,
    group: true,
    identify: true,
    track: true,
    page: true
};

function logHandler(event, properties, options) {
    console.group(EVENT, event);
    console.log(TRAITS, properties);
    console.log(OPTIONS, options);
    console.groupEnd(EVENT);
}

function enableLogging() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SETTINGS;

    Object.keys(previousEvents).forEach(function (event) {
        if (previousEvents[event]) {
            global.analytics.off(event, logHandler);
        }
    });
    Object.keys(events).forEach(function (event) {
        if (events[event]) {
            global.analytics.on(event, logHandler);
        }
    });
    Object.assign(previousEvents, events);
}

exports.default = enableLogging;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(18);

function enableDebug() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (global.analytics) {
        if (global.analytics.debug) {
            if (key) {
                global.analytics.debug();
            } else {
                global.analytics.debug(false);
            }
        } else {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS_DEBUG);
        }
    } else {
        console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
    }
}

exports.default = enableDebug;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.4 2019-09-21*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "OnePlus": "ONEPLUS",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android.*\\bG1\\b(?!\\))",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "iPadOS": "CPU OS 13",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "WeChat": "\\bMicroMessenger\\b",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.4 2019-09-21';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__(149);
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMLast() {
    return _rpCookie2.default.sharedPermanent.get(_constants.COOKIE_UTM_KEY_LAST);
}

exports.default = getUTMLast;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _constants = __webpack_require__(18);

var _nonCanonical = __webpack_require__(41);

var _getDeviceType = __webpack_require__(42);

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = __webpack_require__(43);

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = __webpack_require__(44);

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = __webpack_require__(26);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = __webpack_require__(29);

var _getUTMParams = __webpack_require__(45);

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

function dispatchGlobalPageViewEvent() {
    /* window_.dispatchEvent(new Event('RP_PAGE_VIEW')); IE does not work with this */
    var event = global.document.createEvent('Event');
    event.initEvent('RP_PAGE_VIEW', false, true);
    global.dispatchEvent(event);
}

function page(name) {
    var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _extends2;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;
    var permutiveProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var permutiveType = null;
    var permutiveSections = [];

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];

        permutiveType = commonTraits[_traits.TRAIT_SITE_SECTION];
        if (commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1]) {
            permutiveSections.push(commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1]);
        }
        if (commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2]) {
            permutiveSections.push(commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2]);
        }
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    properties = (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends2), properties, (0, _getUTMParams2.default)(), traits);

    return new Promise(function (resolve) {
        // Segment Page event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.page(name, properties, options, resolve);
    }).then(function () {
        // Permutive Page event
        if (!global.permutive) {
            console.warn(_constants.MESSAGE_ERROR_NO_PERMUTIVE);
            return;
        }

        global.permutive.addon('web', {
            page: (0, _extends4.default)({
                type: permutiveType,
                sections: permutiveSections,
                user: {
                    loggedIn: !!userId,
                    bettingAccountLoggedIn: !!bettingAccountLoggedIn,
                    id: userId
                }
            }, permutiveProps)
        });
    }).then(dispatchGlobalPageViewEvent);
}

page.DEFAULT_OPTIONS = DEFAULT_OPTIONS;

exports.default = page;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getUserId = __webpack_require__(26);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _getPreviousId = __webpack_require__(153);

var _getPreviousId2 = _interopRequireDefault(_getPreviousId);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function alias() {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _getUserId2.default)();
    var previousId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _getPreviousId2.default)();

    return new Promise(function (resolve) {
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.alias(userId, previousId, null, resolve);
    });
}

exports.default = alias;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(17);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPreviousId() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_UNIQUE_USER_ID);
}

exports.default = getPreviousId;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = __webpack_require__(30);

var _identify3 = _interopRequireDefault(_identify2);

var _traits = __webpack_require__(1);

var _getUserPackage = __webpack_require__(28);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string), _propTypes);

/** *
 * @param traits
 * @returns Object {} with tracking params
 */
function identifyLogin() {
    var _identify;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifyLogin.displayName + ' method');
    return (0, _identify3.default)((_identify = {}, (0, _defineProperty3.default)(_identify, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()), _identify));
}

identifyLogin.displayName = 'identifyLogin';

exports.default = identifyLogin;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = __webpack_require__(30);

var _identify3 = _interopRequireDefault(_identify2);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CREATED_AT, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACINGPOST_CONTACT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_THIRDPARTY_CONTACT, _propTypes3.default.string.isRequired), _propTypes);
/**
 *
 * @param traits
 * @returns Object {} with tracking params
 */
function identifyRegister() {
    var _identify;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifyRegister.displayName + ' method');
    return (0, _identify3.default)((_identify = {}, (0, _defineProperty3.default)(_identify, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_CREATED_AT, traits[_traits.TRAIT_CREATED_AT] || Date.now()), (0, _defineProperty3.default)(_identify, _traits.TRAIT_RACINGPOST_CONTACT, traits[_traits.TRAIT_RACINGPOST_CONTACT]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_THIRDPARTY_CONTACT, traits[_traits.TRAIT_THIRDPARTY_CONTACT]), _identify));
}

identifyRegister.displayName = 'identifyRegister';

exports.default = identifyRegister;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = __webpack_require__(30);

var _identify3 = _interopRequireDefault(_identify2);

var _traits = __webpack_require__(1);

var _getUserPackage = __webpack_require__(28);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, _propTypes3.default.string);
/**
 * @param traits
 * @returns Object {} with tracking params
 */
function identifySubscriptionSale() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifySubscriptionSale.displayName + ' method');
    return (0, _identify3.default)((0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()));
}

identifySubscriptionSale.displayName = 'identifySubscriptionSale';

exports.default = identifySubscriptionSale;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a show of essential barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierEssentialShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ESSENTIAL_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ESSENTIAL_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierEssentialShow;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PRODUCT, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a click on subscribe of essential barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierEssentialSubscribe() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierEssentialSubscribe;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a show of barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierShow;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper function to trigger SegmentIO function to track sign in from barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierSignIn() {
  return (0, _track2.default)(_events.EVENT_BARRIER_SIGN_IN);
}

exports.default = trackBarrierSignIn;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierSignInPassword() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_SIGNIN_PASSWORD + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_SIGNIN_PASSWORD, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierSignInPassword;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierSignInShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_SIGNIN_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_SIGNIN_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierSignInShow;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierSubscribe() {
    return (0, _track2.default)(_events.EVENT_BARRIER_SUBSCRIBE);
}

exports.default = trackBarrierSubscribe;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierUltimateOnlyShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ULTIMATE_ONLY_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_ONLY_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierUltimateOnlyShow;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierUltimateOnlyUpgrade() {
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE);
}

exports.default = trackBarrierUltimateOnlyUpgrade;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierUltimateShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ULTIMATE_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierUltimateShow;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierUltimateSubscribe() {
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_SUBSCRIBE);
}

exports.default = trackBarrierUltimateSubscribe;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOf(['SP', 'Odds'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBetButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BET_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_BET_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackBetButtonClick;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ODDS, _propTypes3.default.oneOf(['SP', 'Odds'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TIME_OF_EVENT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BET_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RECEIPT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BET_COUNT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RECEIPT_TYPE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BET_TYPE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STAKE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_REVENUE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_WIN_EW, _propTypes3.default.oneOf(['Each Way', 'Win'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CURRENCY, _propTypes3.default.string.isRequired), _propTypes);

function trackBetReceipt() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_BET_RECEIPT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_BET_RECEIPT, (0, _extends3.default)({}, traits));
}

exports.default = trackBetReceipt;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number), _propTypes);

function trackBettingOfferClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_OPEN_ACCOUNT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_OPEN_ACCOUNT, (0, _extends3.default)({}, traits));
}

exports.default = trackBettingOfferClick;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number), _propTypes);

function trackBookmakerLogin() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLogin;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number.isRequired), _propTypes);

function trackBookmakerRegister() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_REGISTER_BUTTON + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_REGISTER_BUTTON, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerRegister;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerLoginAttempt() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_ATTEMPT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_ATTEMPT, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginAttempt;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ERROR, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), _propTypes);

function trackBookmakerLoginFailure() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_FAILURE + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_FAILURE, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginFailure;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerLoginSuccess() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_SUCCESS + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_SUCCESS, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginSuccess;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerOfferClaimButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerOfferClaimButtonClick;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _getUserPackage = __webpack_require__(28);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a login
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackLogin() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_LOG_IN + ' event');
    return (0, _track3.default)(_events.EVENT_LOG_IN, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()), _track));
}

exports.default = trackLogin;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackCancelBetButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CANCEL_BET_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_CANCEL_BET_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackCancelBetButtonClick;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_CONDITIONS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_FORM, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_MY_NOTES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SPOTLIGHTS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COMMENTS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OWNER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_QUOTES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PEDIGREES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RTF, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DECIMAL_ODDS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE_HISTORY, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_BY_PRICE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETTING_FORCAST, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_MY_RATINGS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SHOW_PRICES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LAST_CHANGED_OPTION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), _propTypes);

function trackCardCustomisation() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CARD_CUSTOMISATION + ' event');
    return (0, _track2.default)(_events.EVENT_CARD_CUSTOMISATION, (0, _extends3.default)({}, traits));
}

exports.default = trackCardCustomisation;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired);
/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackDiscardSlipButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_DISCARD_SLIP_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_DISCARD_SLIP_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackDiscardSlipButtonClick;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_ENTERED, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_DECLARED, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SHOW_PEDIGREE, _propTypes3.default.string.isRequired), _propTypes);

function trackHorseTrackerSettings() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_HORSE_TRACKING_SETTINGS + ' event');
    return (0, _track2.default)(_events.EVENT_HORSE_TRACKING_SETTINGS, (0, _extends3.default)({}, traits));
}

exports.default = trackHorseTrackerSettings;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track3 = __webpack_require__(4);

var _track4 = _interopRequireDefault(_track3);

var _getUserId = __webpack_require__(26);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OUTCOME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_USER_ID, _propTypes3.default.number), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a email verification
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackEmailVerification() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var userId = (0, _getUserId2.default)();
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_EMAIL_VERIFICATION + ' event');
    if (userId) {
        var _track;

        return (0, _track4.default)(_events.EVENT_EMAIL_VERIFICATION, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_OUTCOME, traits[_traits.TRAIT_OUTCOME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_USER_ID, userId), _track));
    }

    return (0, _track4.default)(_events.EVENT_EMAIL_VERIFICATION, (0, _defineProperty3.default)({}, _traits.TRAIT_OUTCOME, traits[_traits.TRAIT_OUTCOME]));
}

exports.default = trackEmailVerification;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_SELECTION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackNavigationClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_NAVIGATION_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_NAVIGATION_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackNavigationClick;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_SELECTION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a click on link in footer
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackFooterClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_FOOTER_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_FOOTER_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackFooterClick;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ACCORDION_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number), _propTypes);

function trackOfferAccordionClosed() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_OFFER_ACCORDION_CLOSED + ' event');
    return (0, _track2.default)(_events.EVENT_OFFER_ACCORDION_CLOSED, (0, _extends3.default)({}, traits));
}

exports.default = trackOfferAccordionClosed;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ACCORDION_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number), _propTypes);

function trackOfferAccordionOpened() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_OFFER_ACCORDION_OPENED + ' event');
    return (0, _track2.default)(_events.EVENT_OFFER_ACCORDION_OPENED, (0, _extends3.default)({}, traits));
}

exports.default = trackOfferAccordionOpened;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackOpenAccount() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_OPEN_ACCOUNT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_OPEN_ACCOUNT, (0, _extends3.default)({}, traits));
}

exports.default = trackOpenAccount;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TOTAL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackOrderCompleted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_ORDER_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_ORDER_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_TOTAL, traits[_traits.TRAIT_TOTAL]), (0, _defineProperty3.default)(_track, _traits.TRAIT_COUPON, traits[_traits.TRAIT_COUPON]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackOrderCompleted;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_API_OUTCOME, _propTypes3.default.string.isRequired), _propTypes);

function trackPlaceBet() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_PLACE_BET + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_PLACE_BET, (0, _extends3.default)({}, traits));
}

exports.default = trackPlaceBet;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_API_OUTCOME, _propTypes3.default.string.isRequired), _propTypes);

function trackBetslipErrorMessage() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BETSLIP_ERROR_MESSAGE + ' event');
    return (0, _track2.default)(_events.EVENT_BETSLIP_ERROR_MESSAGE, (0, _extends3.default)({}, traits));
}

exports.default = trackBetslipErrorMessage;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_BETTING, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NEWS, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COMPETITIONS, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BLOODSTOCK, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SPORT_BETTING, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OVER_EIGHTEEN, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_R4R, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DAYLY_UPDATES, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_THIRD_PARTY, _propTypes3.default.number.isRequired), _propTypes);

function trackPreferencesUpdate() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_PREFERENCE_UPDATE + ' event');
    return (0, _track3.default)(_events.EVENT_PREFERENCE_UPDATE, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_HORSE_BETTING, traits[_traits.TRAIT_HORSE_BETTING]), (0, _defineProperty3.default)(_track, _traits.TRAIT_HORSE_NEWS, traits[_traits.TRAIT_HORSE_NEWS]), (0, _defineProperty3.default)(_track, _traits.TRAIT_COMPETITIONS, traits[_traits.TRAIT_COMPETITIONS]), (0, _defineProperty3.default)(_track, _traits.TRAIT_BLOODSTOCK, traits[_traits.TRAIT_BLOODSTOCK]), (0, _defineProperty3.default)(_track, _traits.TRAIT_SPORT_BETTING, traits[_traits.TRAIT_SPORT_BETTING]), (0, _defineProperty3.default)(_track, _traits.TRAIT_OVER_EIGHTEEN, traits[_traits.TRAIT_OVER_EIGHTEEN]), (0, _defineProperty3.default)(_track, _traits.TRAIT_R4R, traits[_traits.TRAIT_R4R]), (0, _defineProperty3.default)(_track, _traits.TRAIT_DAYLY_UPDATES, traits[_traits.TRAIT_DAYLY_UPDATES]), (0, _defineProperty3.default)(_track, _traits.TRAIT_THIRD_PARTY, traits[_traits.TRAIT_THIRD_PARTY]), _track));
}

exports.default = trackPreferencesUpdate;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ODDS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STAKE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackQuickStakeButtonsClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_QUICK_STAKE_BUTTONS_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_QUICK_STAKE_BUTTONS_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackQuickStakeButtonsClick;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CREATED_AT, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number])), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track registration events
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackRegister() {
    var _extends2;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_REGISTRATION + ' event');
    return (0, _track2.default)(_events.EVENT_REGISTRATION, (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_CREATED_AT, traits[_traits.TRAIT_CREATED_AT] || Date.now()), _extends2), traits));
}

exports.default = trackRegister;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired);
/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackRemoveSelectionButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_REMOVE_SELECTION_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_REMOVE_SELECTION_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackRemoveSelectionButtonClick;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionCompleted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 1), _track));
}

exports.default = trackSubscriptionCompleted;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionDetailsCompleted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 2), _track));
}

exports.default = trackSubscriptionDetailsCompleted;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionDetailsViewed() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_VIEWED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_VIEWED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 2), _track));
}

exports.default = trackSubscriptionDetailsViewed;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STATUS, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionSale() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_SUBSCRIPTION_SALE + ' event');
    return (0, _track3.default)(_events.EVENT_SUBSCRIPTION_SALE, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_REVENUE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STATUS, traits[_traits.TRAIT_STATUS]), _track));
}

exports.default = trackSubscriptionSale;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_REWARDS_FOR_RACING, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DAILY_CONTACT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_FIRST_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LAST_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PHONE_NUMBER, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionSaleAttempt() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_SUBSCRIPTION_SALE_ATTEMPT + ' event');
    return (0, _track2.default)(_events.EVENT_SUBSCRIPTION_SALE_ATTEMPT, (0, _extends3.default)({}, traits));
}

exports.default = trackSubscriptionSaleAttempt;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackSubscriptionStarted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STARTED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STARTED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackSubscriptionStarted;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionViewed() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_VIEWED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_VIEWED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 1), _track));
}

exports.default = trackSubscriptionViewed;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE_ORIGIN, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE_DESTINATION, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionUpgraded() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_PACKAGE_UPGRADE + ' event');
    return (0, _track2.default)(_events.EVENT_PACKAGE_UPGRADE, (0, _extends3.default)({}, traits));
}

exports.default = trackSubscriptionUpgraded;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TOTAL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackUpgradeCompleted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_ORDER_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_ORDER_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_TOTAL, traits[_traits.TRAIT_TOTAL]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_UPGRADE), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackUpgradeCompleted;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackUpgradeStarted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STARTED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STARTED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_UPGRADE), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackUpgradeStarted;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DISCOUNT, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeApplied() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_APPLIED + ' event');
    // TODO
    // import track helper
    // throw an error or track `eventName ERROR`
    // analytics.onload -> logging
    return (0, _track2.default)(_events.EVENT_COUPON_APPLIED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeApplied;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeDenied() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_DENIED + ' event');
    return (0, _track2.default)(_events.EVENT_COUPON_DENIED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeDenied;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeEntered() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_ENTERED + ' event');
    return (0, _track2.default)(_events.EVENT_COUPON_ENTERED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeEntered;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DISCOUNT, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeRemoved() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_REMOVED + ' event');
    return (0, _track2.default)(_events.EVENT_COUPON_REMOVED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeRemoved;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_OFFERS_AVAILABLE, _propTypes3.default.string.isRequired), _propTypes);

function trackRaceMatrixClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACE_MATRIX_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_RACE_MATRIX_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackRaceMatrixClick;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferAccordionOpened() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_ACCORDION_OPENED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_ACCORDION_OPENED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferAccordionOpened;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferAccordionClosed() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_ACCORDION_CLOSED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_ACCORDION_CLOSED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferAccordionClosed;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_BOOKMAKER_OFFER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferButtonClicked() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_BUTTON_CLICKED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_BUTTON_CLICKED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferButtonClicked;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(2);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(3);

var _traits = __webpack_require__(1);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_OFFERS_AVAILABLE, _propTypes3.default.oneOf(['Yes', 'No'])), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackCardIndexClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CARD_INDEX_CLICKED + ' event');
    return (0, _track2.default)(_events.EVENT_CARD_INDEX_CLICKED, (0, _extends3.default)({}, traits));
}

exports.default = trackCardIndexClick;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var bind = __webpack_require__(77);
var Axios = __webpack_require__(217);
var defaults = __webpack_require__(46);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(81);
axios.CancelToken = __webpack_require__(231);
axios.isCancel = __webpack_require__(80);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(232);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(46);
var utils = __webpack_require__(13);
var InterceptorManager = __webpack_require__(226);
var dispatchRequest = __webpack_require__(227);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(79);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);
var transformData = __webpack_require__(228);
var isCancel = __webpack_require__(80);
var defaults = __webpack_require__(46);
var isAbsoluteURL = __webpack_require__(229);
var combineURLs = __webpack_require__(230);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(13);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(81);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var MPP_ATTRIBUTES = {
    esuitejsEndpoint: {
        selector: '[data-esuitejs-endpoint]',
        defaultValue: 'edeveloperuat.mppglobal.com'
    },
    esuitejsVersion: {
        selector: '[data-esuitejs-version]',
        defaultValue: 'v8'
    },
    esuitejsToken: {
        selector: '[data-esuitejs-token]',
        defaultValue: '46CC6A70007D437688C705F739D431DD'
    },
    esuitejsRestEndpoint: {
        selector: '[data-esuitejs-rest-endpoint]',
        defaultValue: 'https://uat.mppglobal.com'
    },
    esuitejsRestVersion: {
        selector: '[data-esuitejs-rest-version]',
        defaultValue: '9.0.0'
    }
};

exports.default = function () {
    return Object.entries(_extends({}, MPP_ATTRIBUTES)).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            _ref2$ = _ref2[1],
            selector = _ref2$.selector,
            defaultValue = _ref2$.defaultValue;

        var settings = document.querySelector(selector);

        if (!settings) {
            acc[key] = defaultValue;
        } else {
            acc[key] = settings.dataset[key];
        }

        return acc;
    }, {});
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var parseParams = function parseParams(rawParams) {
    var regexp = /(?:\{\{([a-z]+?) (.+?)}})+?/gi;
    var match = regexp.exec(rawParams);
    var params = {};

    while (match) {
        var _match = match,
            _match2 = _slicedToArray(_match, 3),
            secondMatch = _match2[1],
            thirdMatch = _match2[2];

        params[secondMatch] = thirdMatch;
        match = regexp.exec(rawParams);
    }

    return params;
};

exports.default = parseParams;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(25);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COOKIE_NAME = 'x-cookie';

var split = function split(source) {
    var cookies = {};

    source.split(';;').forEach(function (part) {
        cookies[part.split('=')[0]] = part.split('=').slice(1).join('=');
    });

    return cookies;
};

var handleCookie = function handleCookie() {
    var source = _jsCookie2.default.get(COOKIE_NAME);
    var domain = window.location.hostname.split('.').slice(-2).join('.');
    if (!source) {
        return undefined;
    }

    var _split = split(source),
        AccessToken = _split.AccessToken,
        Lightbox = _split.Lightbox;

    if (AccessToken) {
        _jsCookie2.default.set('AccessToken', AccessToken, {
            domain: domain,
            expires: 365
        });
    }

    _jsCookie2.default.remove(COOKIE_NAME, { domain: domain });

    return Lightbox;
};

exports.default = handleCookie;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createBarriers = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(83);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(8);

var _App = __webpack_require__(243);

var _App2 = _interopRequireDefault(_App);

var _AppBarrier = __webpack_require__(355);

var _AppBarrier2 = _interopRequireDefault(_AppBarrier);

var _store = __webpack_require__(97);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_reactRedux.Provider, {
    store: _store2.default
}, void 0, _jsx(_App2.default, {}));

var render = function render() {
    _reactDom2.default.render(_ref, document.getElementById('react-rp-auth-root'));
};

var _ref2 = _jsx(_reactRedux.Provider, {
    store: _store2.default
}, void 0, _jsx(_AppBarrier2.default, {}));

var createBarriers = exports.createBarriers = function createBarriers() {
    var appRoot = document.createElement('div');
    appRoot.id = 'react-rp-auth-root';
    document.body.appendChild(appRoot);

    _reactDom2.default.render(_ref2, document.getElementById('react-rp-auth-root'));
};

exports.default = render;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(84);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rpAuthSync = __webpack_require__(31);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(8);

var _NavBtns = __webpack_require__(244);

var _NavBtns2 = _interopRequireDefault(_NavBtns);

var _Barrier = __webpack_require__(95);

var _Barrier2 = _interopRequireDefault(_Barrier);

var _CreatePassword = __webpack_require__(322);

var _CreatePassword2 = _interopRequireDefault(_CreatePassword);

var _ResetPasswordPopup = __webpack_require__(325);

var _ResetPasswordPopup2 = _interopRequireDefault(_ResetPasswordPopup);

var _ForgottenPasswordPopup = __webpack_require__(327);

var _ForgottenPasswordPopup2 = _interopRequireDefault(_ForgottenPasswordPopup);

var _EmailVerificationPopup = __webpack_require__(328);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _ErrorDialogPopup = __webpack_require__(329);

var _ErrorDialogPopup2 = _interopRequireDefault(_ErrorDialogPopup);

var _MandatoryLogin = __webpack_require__(330);

var _MandatoryLogin2 = _interopRequireDefault(_MandatoryLogin);

var _actions = __webpack_require__(12);

var _api = __webpack_require__(14);

__webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_Barrier2.default, {});

var _ref2 = _jsx(_CreatePassword2.default, {});

var _ref3 = _jsx(_ResetPasswordPopup2.default, {});

var _ref4 = _jsx(_ForgottenPasswordPopup2.default, {});

var _ref5 = _jsx(_EmailVerificationPopup2.default, {});

var _ref6 = _jsx(_ErrorDialogPopup2.default, {});

var _ref7 = _jsx(_MandatoryLogin2.default, {});

var App = function (_PureComponent) {
    _inherits(App, _PureComponent);

    function App() {
        _classCallCheck(this, App);

        return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
    }

    _createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            _rpAuthSync2.default.run();
            (0, _api.getSession)().then(this.props.dispatchSignIn, this.props.dispatchSignOut);
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx('div', {
                className: 'ui-flex'
            }, void 0, _jsx(_NavBtns2.default, {
                isLoggedIn: this.props.isLoggedIn
            }), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
        }
    }]);

    return App;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(function (state) {
    return { isLoggedIn: state.userLoggedIn };
}, {
    dispatchSignIn: _actions.signIn,
    dispatchSignOut: _actions.signOut
})(App);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignInUp = __webpack_require__(245);

var _SignInUp2 = _interopRequireDefault(_SignInUp);

var _MyAccount = __webpack_require__(308);

var _MyAccount2 = _interopRequireDefault(_MyAccount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_MyAccount2.default, {});

var _ref3 = _jsx(_SignInUp2.default, {});

var NavBtns = function NavBtns(_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn ? _ref2 : _ref3;
};

exports.default = NavBtns;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _jsCookie = __webpack_require__(25);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _PopoverComponent2 = __webpack_require__(48);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

var _AuthNav = __webpack_require__(246);

var _AuthNav2 = _interopRequireDefault(_AuthNav);

var _SignIn = __webpack_require__(251);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _SignUp = __webpack_require__(288);

var _SignUp2 = _interopRequireDefault(_SignUp);

var _ForgottenPass = __webpack_require__(93);

var _ForgottenPass2 = _interopRequireDefault(_ForgottenPass);

var _SignUpCompletePopup = __webpack_require__(297);

var _SignUpCompletePopup2 = _interopRequireDefault(_SignUpCompletePopup);

var _ErrorPopup = __webpack_require__(59);

var _ErrorPopup2 = _interopRequireDefault(_ErrorPopup);

var _EmailVerificationPopup = __webpack_require__(61);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _EmailVerificationCompletePopup = __webpack_require__(305);

var _EmailVerificationCompletePopup2 = _interopRequireDefault(_EmailVerificationCompletePopup);

var _signInUp = __webpack_require__(306);

var _signInUp2 = _interopRequireDefault(_signInUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var popovers = {
    SignIn: _SignIn2.default,
    SignUp: _SignUp2.default,
    ForgottenPass: _ForgottenPass2.default,
    SignUpCompletePopup: _SignUpCompletePopup2.default,
    ErrorPopup: _ErrorPopup2.default,
    EmailVerificationPopup: _EmailVerificationPopup2.default,
    EmailVerificationCompletePopup: _EmailVerificationCompletePopup2.default
};

var SignInUp = function (_PopoverComponent) {
    _inherits(SignInUp, _PopoverComponent);

    function SignInUp() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SignInUp);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignInUp.__proto__ || Object.getPrototypeOf(SignInUp)).call.apply(_ref, [this].concat(args))), _this), _this.goToSignIn = function () {
            return _this.togglePopover('SignIn');
        }, _this.goToSignUp = function () {
            return _this.togglePopover('SignUp');
        }, _this.goToForgottenPass = function () {
            return _this.togglePopover('ForgottenPass');
        }, _this.goToSignUpComplete = function () {
            return _this.togglePopover('SignUpCompletePopup');
        }, _this.goToErrorDialog = function () {
            return _this.togglePopover('ErrorPopup');
        }, _this.goToEmailVerification = function () {
            return _this.togglePopover('EmailVerificationPopup');
        }, _this.goToEmailVerificationComplete = function () {
            return _this.togglePopover('EmailVerificationCompletePopup');
        }, _this.showSignUp = function () {
            _this.setState({ popoverType: 'SignUp' });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignInUp, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var hash = global.location.hash;


            if (hash.indexOf('#register') === -1) return;

            if (_jsCookie2.default.get('CookieConsent')) {
                this.showSignUp();
                return;
            }

            document.addEventListener('COOKIEBOT_DIALOG_CLOSED', this.showSignUp);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var popoverType = this.state.popoverType;

            var Popover = popovers[popoverType];
            var wrapperClass = _signInUp2.default[popoverType] || _signInUp2.default.popoverContainer;

            return _react2.default.createElement(
                'div',
                { className: wrapperClass, ref: function ref(node) {
                        _this2.node = node;
                    } },
                _jsx(_AuthNav2.default, {
                    goToSignIn: this.goToSignIn,
                    goToSignUp: this.goToSignUp,
                    goToForgottenPass: this.goToForgottenPass
                }),
                Popover && _jsx(Popover, {
                    goToSignIn: this.goToSignIn,
                    goToSignUp: this.goToSignUp,
                    goToForgottenPass: this.goToForgottenPass,
                    goToSignUpComplete: this.goToSignUpComplete,
                    goToErrorDialog: this.goToErrorDialog,
                    goToEmailVerification: this.goToEmailVerification,
                    goToEmailVerificationComplete: this.goToEmailVerificationComplete,
                    closePopover: this.closePopover,
                    backUrl: SignInUp.backUrl
                })
            );
        }
    }], [{
        key: 'backUrl',
        get: function get() {
            var _global$location = global.location,
                pathname = _global$location.pathname,
                origin = _global$location.origin;

            return pathname.includes('/members-club/my-account/email-confirmation') ? origin.concat('/members-club/my-account/') : null;
        }
    }]);

    return SignInUp;
}(_PopoverComponent3.default);

exports.default = SignInUp;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuthNavBtn = __webpack_require__(86);

var _AuthNavBtn2 = _interopRequireDefault(_AuthNavBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {}, void 0, 'Sign In', _jsx('span', {
    className: 'hidden-lg-up'
}, void 0, '/Up'));

var AuthNav = function AuthNav(_ref) {
    var goToSignIn = _ref.goToSignIn,
        goToSignUp = _ref.goToSignUp;
    return _jsx('div', {
        className: 'ui-flex'
    }, void 0, _jsx(_AuthNavBtn2.default, {
        iconName: 'my-account',
        onClick: goToSignIn
    }, void 0, _ref2), _jsx(_AuthNavBtn2.default, {
        iconName: 'sign-up',
        onClick: goToSignUp
    }, void 0, 'Sign Up'));
};

exports.default = AuthNav;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _authNavBtn = __webpack_require__(248);

var _authNavBtn2 = _interopRequireDefault(_authNavBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthNavBtn = function AuthNavBtn(_ref) {
    var iconName = _ref.iconName,
        children = _ref.children,
        onClick = _ref.onClick;
    return (
        // TODO: replace active elements with button tag as soon as iOS10 bug with flex for button fixed
        _jsx('div', {
            role: 'button',
            tabIndex: 0,
            className: 'ui-reset-for-btn rn-menuBar__navItem ' + _authNavBtn2.default.btn,
            onClick: onClick
        }, void 0, _jsx(_rpReactSvgIcon2.default, {
            isInlined: true,
            iconName: iconName,
            className: 'rn-menuBar__navItem__icon'
        }), _jsx('span', {}, void 0, children))
    );
};

exports.default = AuthNavBtn;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(249);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./authNavBtn.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./authNavBtn.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.authNavBtn__signUp___21hnm {\n  display: none; }\n  @media (min-width: 990px) {\n    .authNavBtn__signUp___21hnm {\n      display: inline-flex; } }\n\n.authNavBtn__btn___1NGPm {\n  color: inherit;\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"signUp": "authNavBtn__signUp___21hnm",
	"btn": "authNavBtn__btn___1NGPm"
};

/***/ }),
/* 250 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignInForm = __webpack_require__(49);

var _SignInForm2 = _interopRequireDefault(_SignInForm);

var _Dropdown = __webpack_require__(54);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _analytics = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignIn = function SignIn(_ref) {
    var closePopover = _ref.closePopover,
        goToSignUp = _ref.goToSignUp,
        goToForgottenPass = _ref.goToForgottenPass,
        goToErrorDialog = _ref.goToErrorDialog,
        goToEmailVerification = _ref.goToEmailVerification,
        backUrl = _ref.backUrl;
    return _jsx(_Dropdown2.default, {
        title: 'Sign In',
        close: closePopover
    }, void 0, _jsx(_SignInForm2.default, {
        goToSignUp: goToSignUp,
        goToForgottenPass: goToForgottenPass,
        goToErrorDialog: goToErrorDialog,
        goToEmailVerification: goToEmailVerification,
        hidden: true,
        onSignInSuccess: _analytics.onSignInSuccess,
        backUrl: backUrl
    }));
};

SignIn.defaultProps = {
    backUrl: undefined
};

exports.default = SignIn;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(256),
    upperFirst = __webpack_require__(274);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(257),
    deburr = __webpack_require__(258),
    words = __webpack_require__(270);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(259),
    toString = __webpack_require__(50);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(260);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51),
    arrayMap = __webpack_require__(264),
    isArray = __webpack_require__(265),
    isSymbol = __webpack_require__(266);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(263);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 264 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 265 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(87),
    isObjectLike = __webpack_require__(269);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 269 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(271),
    hasUnicodeWord = __webpack_require__(272),
    toString = __webpack_require__(50),
    unicodeWords = __webpack_require__(273);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 272 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 273 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(275);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(276),
    hasUnicode = __webpack_require__(88),
    stringToArray = __webpack_require__(278),
    toString = __webpack_require__(50);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(277);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 277 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(279),
    hasUnicode = __webpack_require__(88),
    unicodeToArray = __webpack_require__(280);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 279 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(87),
    isObject = __webpack_require__(282);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.fields__label___2HyXF {\n  display: block;\n  font: 14px/19px \"proxima-nova-a\", sans-serif; }\n\n.fields__labelTitle___3r-oo {\n  color: #171717; }\n\n.fields__checkboxIcon___15ALd {\n  position: absolute; }\n\n.fields__labelCheckbox___3zadt {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer; }\n  .fields__labelCheckbox___3zadt span {\n    display: block;\n    padding: 0 0 0 32px; }\n  .fields__labelCheckboxText___1TErW {\n    color: #7B7A78; }\n\n.fields__validationWrapper___3D3Kv {\n  position: relative;\n  padding-right: 24px;\n  margin-right: 8px;\n  margin-top: 3px; }\n\n.fields__iconWrapper___3DBgM {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%; }\n  .fields__iconWrapper___3DBgM svg {\n    height: 100%; }\n\n.fields__icon___O1I5n {\n  display: block;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  width: 16px;\n  height: 100%; }\n\n.fields__iconError___2WBbV {\n  fill: #D11F25; }\n\n.fields__iconSuccess___2-CLI {\n  fill: #2CB34A; }\n\n.fields__error___FxMe3 {\n  display: block;\n  font: 14px/19px \"proxima-nova-a\", sans-serif;\n  color: #D11F25;\n  margin-top: 8px; }\n\n.fields__commentTitle___3oqGj {\n  display: block;\n  font-family: \"proxima-nova-a-bold\", sans-serif; }\n\n.fields__commentList___2uPWB {\n  margin: 0;\n  padding: 0;\n  list-style: disc inside; }\n\n.fields__buttonContainer___puO3G {\n  padding: 16px; }\n\n.fields__button___3u0VX {\n  width: 100%; }\n\n.fields__submitField___T-_wW {\n  padding: 16px; }\n\n.fields__submit___34l0l {\n  width: 100%; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .fields__submit___34l0l {\n      display: block;\n      margin: 0 auto;\n      max-width: 304px; } }\n  .fields__submit___34l0l svg {\n    height: 100%; }\n\n.fields__submitActive___3TLb7 {\n  opacity: .6; }\n\n.fields__switchField___38zLD {\n  padding: 0 16px 16px;\n  text-align: center; }\n\n.fields__checkbox___3_nD5 {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer; }\n\n.fields__field___1dXdm.fields__link___3gOtL {\n  padding-left: 0; }\n\n.fields__hint___25qFJ {\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  color: #7B7A78;\n  margin-top: 8px; }\n\n.fields__field___1dXdm {\n  padding: 8px 15px;\n  color: #171717; }\n  .fields__field___1dXdm .ui-input {\n    width: 100%;\n    -webkit-appearance: none;\n    appearance: none; }\n\n.fields__fieldsGroup___10gOH {\n  position: relative;\n  padding: 0 10px 15px 15px; }\n  .fields__fieldsGroup___10gOH .fields__field___1dXdm {\n    padding-left: 0;\n    padding-right: 0; }\n  .fields__fieldsGroup___10gOH .fields__validationWrapper___3D3Kv {\n    padding-right: 0; }\n\n.fields__fieldsGroup___10gOH:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  height: 1px;\n  width: 90%;\n  background-color: #F0EFF1; }\n\n.fields__fieldsHeader___2vSYc {\n  font-size: 17px; }\n\n.fields__fieldsDelimiter___3vR_h {\n  display: block;\n  padding-top: 12px;\n  padding-bottom: 12px; }\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .fields__field___1dXdm .ui-input, .fields__field___1dXdm input.ui-input:focus, .fields__field___1dXdm input.ui-input:hover {\n    font-size: 16px; } }\n\n.RC-mandatoryLogIn .fields__signIn___qhk_N {\n  padding: 0; }\n\n.RC-mandatoryLogIn .fields__signUp___2UIzX {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 120px;\n  padding: 0;\n  margin: 16px 16px 0 0;\n  font-size: 16px; }\n  .RC-mandatoryLogIn .fields__signUp___2UIzX .ui-reset-for-btn {\n    text-align: right; }\n", ""]);

// exports
exports.locals = {
	"label": "fields__label___2HyXF",
	"labelTitle": "fields__labelTitle___3r-oo fields__label___2HyXF",
	"checkboxIcon": "fields__checkboxIcon___15ALd",
	"labelCheckbox": "fields__labelCheckbox___3zadt fields__label___2HyXF",
	"labelCheckboxText": "fields__labelCheckboxText___1TErW",
	"validationWrapper": "fields__validationWrapper___3D3Kv",
	"iconWrapper": "fields__iconWrapper___3DBgM",
	"icon": "fields__icon___O1I5n",
	"iconError": "fields__iconError___2WBbV",
	"iconSuccess": "fields__iconSuccess___2-CLI",
	"error": "fields__error___FxMe3",
	"commentTitle": "fields__commentTitle___3oqGj",
	"commentList": "fields__commentList___2uPWB",
	"buttonContainer": "fields__buttonContainer___puO3G",
	"button": "fields__button___3u0VX",
	"submitField": "fields__submitField___T-_wW",
	"submit": "fields__submit___34l0l",
	"submitActive": "fields__submitActive___3TLb7",
	"switchField": "fields__switchField___38zLD",
	"checkbox": "fields__checkbox___3_nD5",
	"field": "fields__field___1dXdm",
	"link": "fields__link___3gOtL",
	"hint": "fields__hint___25qFJ",
	"fieldsGroup": "fields__fieldsGroup___10gOH",
	"fieldsHeader": "fields__fieldsHeader___2vSYc fields__labelTitle___3r-oo fields__label___2HyXF",
	"fieldsDelimiter": "fields__fieldsDelimiter___3vR_h fields__field___1dXdm",
	"signIn": "fields__signIn___qhk_N",
	"signUp": "fields__signUp___2UIzX"
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint no-mixed-operators: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('span', {}, void 0, 'Please enter your password');

var PasswordErrorSignIn = function PasswordErrorSignIn() {
    return _jsx('div', {
        className: _fields2.default.comment
    }, void 0, _ref);
};

exports.default = PasswordErrorSignIn;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, ".RC-mandatoryLogIn .forms__form___3xt5N {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(1) {\n    order: 1; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(2) {\n    order: 2; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(3) {\n    order: 3; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(4) {\n    order: 4; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(5) {\n    order: 5; }\n\n.RC-mandatoryLogIn .forms__signUp___3IrMA > *:nth-child(5) {\n  margin-top: auto; }\n\n.RC-mandatoryLogIn .forms__signIn___EVdcx > *:nth-child(5) {\n  order: 3;\n  margin-top: auto; }\n", ""]);

// exports
exports.locals = {
	"form": "forms__form___3xt5N",
	"signUp": "forms__signUp___3IrMA",
	"signIn": "forms__signIn___EVdcx"
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(287);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./dropdown.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./dropdown.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.dropdown__dropdown___uVDWI {\n  margin-bottom: 8px;\n  box-shadow: 0 999999px 0 999999px rgba(23, 23, 23, 0.5); }\n  @media (min-width: 720px) {\n    .dropdown__dropdown___uVDWI {\n      width: 304px;\n      left: 50%;\n      top: 60px;\n      height: auto;\n      transform: translateX(-50%);\n      box-shadow: 0 2px 10px rgba(23, 23, 23, 0.5); } }\n", ""]);

// exports
exports.locals = {
	"dropdown": "dropdown__dropdown___uVDWI"
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analytics = __webpack_require__(21);

var _SignUpForm = __webpack_require__(55);

var _SignUpForm2 = _interopRequireDefault(_SignUpForm);

var _Dropdown = __webpack_require__(54);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUp = function SignUp(_ref) {
    var goToSignIn = _ref.goToSignIn,
        closePopover = _ref.closePopover,
        goToErrorDialog = _ref.goToErrorDialog,
        goToForgottenPass = _ref.goToForgottenPass,
        goToSignUpComplete = _ref.goToSignUpComplete;
    return _jsx(_Dropdown2.default, {
        title: 'Sign Up',
        close: closePopover
    }, void 0, _jsx(_SignUpForm2.default, {
        goToSignIn: goToSignIn,
        goToForgottenPass: goToForgottenPass,
        goToSignUpComplete: goToSignUpComplete,
        goToErrorDialog: goToErrorDialog,
        onSignUpSuccess: _analytics.onSignUpSuccess,
        hidden: true
    }));
};

exports.default = SignUp;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CheckField = __webpack_require__(290);

var _CheckField2 = _interopRequireDefault(_CheckField);

var _CheckboxField = __webpack_require__(291);

var _CheckboxField2 = _interopRequireDefault(_CheckboxField);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */


var _ref2 = _jsx('a', {
    href: 'https://racingpost.zendesk.com/hc/en-us/articles/208996085-Terms-and-conditions',
    className: 'ui-link ui-link_secondary',
    target: '_blank',
    rel: 'noopener noreferrer'
}, void 0, 'Terms and Conditions');

var _ref3 = _jsx('span', {
    className: 'labelDelimiter'
}, void 0, 'Subscribe to emails and receive free tipping advice, news and special offers');

var _ref4 = _jsx('span', {}, void 0, 'Horseracing betting');

var _ref5 = _jsx('span', {}, void 0, 'Horseracing news');

var _ref6 = _jsx('span', {}, void 0, 'Bloodstock');

var _ref7 = _jsx('span', {}, void 0, 'Football and other sport betting');

var _ref8 = _jsx('span', {}, void 0, 'Competitions, promotions and special offers');

var _ref9 = _jsx(_CheckField2.default, {
    name: 'newsletterThirdParty'
}, void 0, _jsx('span', {}, void 0, 'Carefully selected and relevant third-parties'));

var _ref10 = _jsx('a', {
    href: 'https://racingpost.zendesk.com/hc/en-us/articles/208996085-Terms-and-conditions',
    className: 'ui-link ui-link_secondary',
    target: '_blank',
    rel: 'noopener noreferrer'
}, void 0, 'Terms and Conditions');

var Conditions = function (_Component) {
    _inherits(Conditions, _Component);

    function Conditions(props) {
        _classCallCheck(this, Conditions);

        var _this = _possibleConstructorReturn(this, (Conditions.__proto__ || Object.getPrototypeOf(Conditions)).call(this, props));

        _this.toggleConditions = function (_ref) {
            var checked = _ref.checked,
                name = _ref.name;

            if (name === 'allConditions') {
                var _this$setState;

                _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, checked), _defineProperty(_this$setState, 'horseBetting', checked), _defineProperty(_this$setState, 'horseNews', checked), _defineProperty(_this$setState, 'bloodstock', checked), _defineProperty(_this$setState, 'sportBetting', checked), _defineProperty(_this$setState, 'competitions', checked), _this$setState));
            } else {
                var _this$setState2;

                var currentState = _this.state;
                currentState[name] = checked;

                _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, checked), _defineProperty(_this$setState2, 'allConditions', !!(!Object.entries(currentState).filter(function (val) {
                    return val[0] !== 'allConditions' && !val[1];
                }).length && checked)), _this$setState2));
            }
        };

        _this.state = {
            allConditions: false,
            horseBetting: false,
            horseNews: false,
            bloodstock: false,
            sportBetting: false,
            competitions: false
        };
        return _this;
    }

    _createClass(Conditions, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                validate = _props.validate,
                termsConditionsError = _props.termsConditionsError;
            var _state = this.state,
                bloodstock = _state.bloodstock,
                sportBetting = _state.sportBetting,
                competitions = _state.competitions,
                horseBetting = _state.horseBetting,
                horseNews = _state.horseNews,
                allConditions = _state.allConditions;


            return _jsx('div', {}, void 0, this.props.disableConditions ? _jsx(_CheckField2.default, {
                name: 'termsConditions',
                validate: validate,
                hasError: termsConditionsError,
                errorText: 'You need to agree to our terms and conditions to register'
            }, void 0, _jsx('span', {
                className: _fields2.default.labelTitle
            }, void 0, 'I accept the\xA0', _ref2)) : _jsx(_react.Fragment, {}, void 0, _jsx('div', {
                className: _fields2.default.fieldsGroup
            }, void 0, _jsx('h2', {
                className: _fields2.default.fieldsHeader
            }, void 0, 'Email Communication'), _jsx(_CheckboxField2.default, {
                name: 'allConditions',
                checked: allConditions,
                onCheck: this.toggleConditions
            }, void 0, _ref3), _jsx('span', {
                className: _fields2.default.fieldsDelimiter
            }, void 0, 'Or select from the email topics below:'), _jsx(_CheckboxField2.default, {
                name: 'horseBetting',
                checked: horseBetting,
                onCheck: this.toggleConditions
            }, void 0, _ref4), _jsx(_CheckboxField2.default, {
                name: 'horseNews',
                checked: horseNews,
                onCheck: this.toggleConditions
            }, void 0, _ref5), _jsx(_CheckboxField2.default, {
                name: 'bloodstock',
                checked: bloodstock,
                onCheck: this.toggleConditions
            }, void 0, _ref6), _jsx(_CheckboxField2.default, {
                name: 'sportBetting',
                checked: sportBetting,
                onCheck: this.toggleConditions
            }, void 0, _ref7), _jsx(_CheckboxField2.default, {
                name: 'competitions',
                checked: competitions,
                onCheck: this.toggleConditions
            }, void 0, _ref8)), _jsx('div', {
                className: _fields2.default.fieldsGroup
            }, void 0, _jsx('h2', {
                className: _fields2.default.fieldsHeader
            }, void 0, 'Third-party Communication'), _ref9), _jsx(_CheckField2.default, {
                name: 'eighteenYears'
            }, void 0, _jsx('span', {
                className: _fields2.default.labelTitle
            }, void 0, '18+'), _jsx('span', {
                className: _fields2.default.labelCheckboxText
            }, void 0, 'I confirm I am 18 years old or over')), _jsx(_CheckField2.default, {
                name: 'termsConditions',
                validate: validate,
                hasError: termsConditionsError,
                errorText: 'You need to agree to our terms and conditions to register'
            }, void 0, _jsx('span', {
                className: _fields2.default.labelTitle
            }, void 0, 'I accept the\xA0', _ref10))));
        }
    }]);

    return Conditions;
}(_react.Component);

Conditions.defaultProps = {
    disableConditions: false
};

exports.default = Conditions;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationIcon = __webpack_require__(52);

var _ValidationIcon2 = _interopRequireDefault(_ValidationIcon);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var id = function id(name) {
    return 'rp-auth-input-' + name;
};

var CheckField = function CheckField(_ref) {
    var hasError = _ref.hasError,
        validate = _ref.validate,
        children = _ref.children,
        errorText = _ref.errorText,
        name = _ref.name,
        checked = _ref.checked;
    return _jsx('div', {
        className: _fields2.default.field
    }, void 0, _jsx('div', {
        className: _fields2.default.validationWrapper
    }, void 0, _jsx('input', {
        type: 'checkbox',
        name: name,
        className: _fields2.default.checkbox + ' ui-checkbox_input',
        onChange: function onChange(e) {
            return validate(e.target);
        },
        defaultChecked: checked,
        id: id(name)
    }), _jsx('div', {
        className: _fields2.default.checkboxIcon + ' ui-checkbox'
    }), _jsx('label', {
        className: _fields2.default.labelCheckbox,
        htmlFor: id(name)
    }, void 0, children), hasError && _jsx(_ValidationIcon2.default, {
        hasError: hasError
    })), hasError && _jsx('div', {
        className: _fields2.default.error
    }, void 0, errorText));
};

CheckField.defaultProps = {
    hasError: false,
    validate: function validate() {
        return null;
    },
    errorText: '',
    checked: false
};

exports.default = CheckField;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationIcon = __webpack_require__(52);

var _ValidationIcon2 = _interopRequireDefault(_ValidationIcon);

var _fields = __webpack_require__(15);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var id = function id(name) {
    return 'rp-auth-input-' + name;
};

var CheckboxField = function (_PureComponent) {
    _inherits(CheckboxField, _PureComponent);

    function CheckboxField(props) {
        _classCallCheck(this, CheckboxField);

        var _this = _possibleConstructorReturn(this, (CheckboxField.__proto__ || Object.getPrototypeOf(CheckboxField)).call(this, props));

        _this.state = {
            checked: _this.props.checked || false
        };
        return _this;
    }

    _createClass(CheckboxField, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ checked: nextProps.checked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                hasError = _props.hasError,
                validate = _props.validate,
                children = _props.children,
                errorText = _props.errorText,
                name = _props.name,
                onCheck = _props.onCheck;

            return _jsx('div', {
                className: _fields2.default.field
            }, void 0, _jsx('div', {
                className: _fields2.default.validationWrapper
            }, void 0, _jsx('input', {
                type: 'checkbox',
                name: name,
                className: _fields2.default.checkbox + ' ui-checkbox_input',
                onChange: function onChange(e) {
                    _this2.setState({ checked: e.target.checked });
                    if (onCheck) {
                        onCheck(e.target);
                    }
                    validate(e.target);
                },
                checked: this.state.checked,
                id: id(name)
            }), _jsx('div', {
                className: _fields2.default.checkboxIcon + ' ui-checkbox'
            }), _jsx('label', {
                className: _fields2.default.labelCheckbox,
                htmlFor: id(name)
            }, void 0, children), hasError && _jsx(_ValidationIcon2.default, {
                hasError: hasError
            })), hasError && _jsx('div', {
                className: _fields2.default.error
            }, void 0, errorText));
        }
    }]);

    return CheckboxField;
}(_react.PureComponent);

CheckboxField.defaultProps = {
    hasError: false,
    validate: function validate() {
        return null;
    },
    errorText: '',
    checked: false,
    onCheck: undefined
};

exports.default = CheckboxField;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _lightbox = __webpack_require__(293);

var _lightbox2 = _interopRequireDefault(_lightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'cross',
    size: 'Medium'
});

var Lightbox = function Lightbox(_ref) {
    var close = _ref.close,
        children = _ref.children;

    var overlayContentNode = void 0;

    var onOutsideClick = function onOutsideClick(event) {
        if (overlayContentNode && !overlayContentNode.contains(event.target)) {
            close();
        }
    };

    return _jsx('div', {
        role: 'button',
        tabIndex: 0,
        className: 'ui-overlay ' + _lightbox2.default.overlay,
        onClick: onOutsideClick
    }, void 0, _jsx('div', {
        className: 'ui-overlay__container'
    }, void 0, _react2.default.createElement(
        'div',
        {
            className: 'ui-modal rn-modal',
            ref: function ref(node) {
                overlayContentNode = node;
            }
        },
        _jsx('button', {
            className: 'ui-reset-for-btn ui-modal__closeBtn',
            onClick: close
        }, void 0, _ref2),
        _jsx('div', {
            className: 'ui-modal__canvas'
        }, void 0, children)
    )));
};

exports.default = Lightbox;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(294);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./lightbox.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./lightbox.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, ".lightbox__overlay___1kSfO {\n  z-index: 999; }\n", ""]);

// exports
exports.locals = {
	"overlay": "lightbox__overlay___1kSfO"
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpAnalytics = __webpack_require__(23);

var _api = __webpack_require__(14);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

var _PopoverComponent2 = __webpack_require__(48);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var onPasswordReset = function onPasswordReset(backUrl, close) {
    (0, _rpAnalytics.identify)().then(function () {
        (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, backUrl));
    }).then(function () {
        return close();
    }).catch(function (err) {
        throw err;
    });
};

function performPasswordReset(email_, back_url_, onSuccess_, onError_, onFinalized_) {
    function onFinalized() {
        if (!onFinalized_) return;

        onFinalized_();
    }

    function onSuccess() {
        onSuccess_();

        if (!back_url_) {
            onFinalized();

            return;
        }

        onPasswordReset(back_url_, onFinalized);
    }

    function onError() {
        if (!onError_) {
            onFinalized_();

            return;
        }

        onError_();

        onFinalized_();
    }

    (0, _api.requestPasswordChange)(email_).then(onSuccess).catch(onError);
}

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.performPasswordReset = performPasswordReset;
}

constructGlobalAuthApi();

var _ref2 = _jsx('a', {
    href: 'mailto:help@racingpost.com',
    className: 'ui-link ui-link_secondary'
}, void 0, 'help@racingpost.com');

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'spinner',
    size: 'Large',
    className: 'ui-animation_spinnerAnimation'
});

var ForgottenPassword = function (_PopoverComponent) {
    _inherits(ForgottenPassword, _PopoverComponent);

    function ForgottenPassword() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ForgottenPassword);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ForgottenPassword.__proto__ || Object.getPrototypeOf(ForgottenPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            loading: false
        }, _this.onSubmit = function (event) {
            event.preventDefault();

            var _this$props = _this.props,
                close = _this$props.close,
                backUrl = _this$props.backUrl;
            var email = _this.email.value;


            if (email === '') return;

            _this.setState({ loading: true });

            function onSuccess() {
                this.setState({ loading: false });
            }

            function onError() {
                // close(); // will be closed by onFinalized
            }

            function onFinalized() {
                close();
            }

            performPasswordReset(email, backUrl, onSuccess, onError, onFinalized);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ForgottenPassword, [{
        key: 'render',


        /* eslint-disable */
        value: function render() {
            var _this2 = this;

            var loading = this.state.loading;

            return _jsx('div', {
                className: _modal2.default.container
            }, void 0, this.props.backLink, _jsx('h2', {
                className: _modal2.default.title
            }, void 0, 'Forgotten Password'), _jsx('div', {
                className: _modal2.default.content
            }, void 0, _jsx('p', {
                className: _modal2.default.paragraph
            }, void 0, 'Please enter the email address that you\u2019ve registered with Racing Post (check your spam folder if it doesn\u2019t appear shortly). If you don\u2019t have the associated email address anymore or you encounter further issues, please contact\xA0', _ref2), _jsx('form', {
                method: 'post',
                action: '/',
                onSubmit: this.onSubmit,
                className: _modal2.default.form,
                noValidate: true
            }, void 0, _jsx('div', {
                className: _modal2.default.field
            }, void 0, _jsx('label', {
                htmlFor: 'input-email',
                className: _modal2.default.fieldLabel
            }, void 0, 'Your Email'), _jsx('div', {
                className: 'ui-flex'
            }, void 0, _react2.default.createElement('input', {
                type: 'email',
                name: 'emailAddress',
                id: 'input-email',
                className: _modal2.default.fieldInput + ' ui-input',
                autoComplete: 'off',
                ref: function ref(node) {
                    _this2.email = node;
                }
            }), _jsx('button', {
                className: (0, _classnames2.default)('ui-btn', 'ui-btn_default', 'ui-btn_primary', _modal2.default.button, _defineProperty({}, _modal2.default.submitActive, loading)),
                type: 'submit',
                id: 'button-pwd-reset'
            }, void 0, loading ? _ref3 : 'Send'))))));
        }
    }]);

    return ForgottenPassword;
}(_PopoverComponent3.default);
/* eslint-enable */

ForgottenPassword.defaultProps = {
    backUrl: undefined,
    backLink: undefined
};

ForgottenPassword.propTypes = {
    close: _propTypes2.default.func.isRequired,
    backUrl: _propTypes2.default.string,
    backLink: _propTypes2.default.node
};

exports.default = ForgottenPassword;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.modal__container___2q-aa {\n  background-color: #FFFFFF;\n  margin: 0 auto;\n  color: #171717;\n  border-radius: 4px; }\n  .RC-mandatoryLogIn .modal__container___2q-aa {\n    padding: 16px; }\n\n.modal__title___3d9VK {\n  padding: 16px;\n  margin: 0 auto;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  text-align: center;\n  color: #171717; }\n\n.modal__content___35-fc {\n  margin: 0 8px; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .modal__content___35-fc {\n      width: 464px;\n      margin: 0 auto 8px; } }\n\n.modal__paragraph___1bQON {\n  margin: 0;\n  padding-bottom: 16px; }\n  .modal__paragraph__subtitle___35Kn_ {\n    padding-bottom: 8px;\n    margin: auto;\n    font-family: \"proxima-nova-a-bold\", sans-serif;\n    text-align: center; }\n    @media (min-width: 480px) and (max-width: 719.9px) {\n      .modal__paragraph__subtitle___35Kn_ {\n        width: 400px; } }\n    @media (min-width: 720px) {\n      .modal__paragraph__subtitle___35Kn_ {\n        width: 348px; } }\n\n.modal__form___2tl_S {\n  margin: 0;\n  padding: 0; }\n\n.modal__field___1x69t {\n  padding: 0 0 24px; }\n  .modal__fieldLabel___3iqdw {\n    display: block; }\n    @media (max-width: 479.9px) {\n      .modal__fieldLabel___3iqdw {\n        width: 100%; } }\n  .modal__fieldInput___1Q_bK {\n    width: 248px;\n    margin-right: 16px; }\n    @media (min-width: 480px) and (max-width: 719.9px) {\n      .modal__fieldInput___1Q_bK {\n        width: auto;\n        flex-grow: 1; } }\n\n.modal__button___2hRhc {\n  width: auto;\n  margin: 0; }\n\n.modal__submitActive___bu9Zn {\n  opacity: .6; }\n\n.modal__successTitle___3C94i {\n  padding-bottom: 0;\n  font-family: \"proxima-nova-a\", sans-serif; }\n\n.modal__successContent___2k4nQ {\n  text-align: center;\n  padding-bottom: 24px;\n  white-space: pre-wrap; }\n\n.modal__successIcon___XDNbO {\n  display: block;\n  fill: #2CB34A;\n  margin: 16px auto; }\n\n.modal__description___1i5XU {\n  text-align: center;\n  margin: 8px; }\n\n.modal__barriersTitle___fx_UX {\n  padding: 16px 0;\n  font-family: \"proxima-nova-a\", sans-serif;\n  text-align: left;\n  margin: 0 auto; }\n\n.modal__barriersServices___1l0vD {\n  display: flex;\n  justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"container": "modal__container___2q-aa",
	"title": "modal__title___3d9VK",
	"content": "modal__content___35-fc",
	"paragraph": "modal__paragraph___1bQON",
	"paragraph__subtitle": "modal__paragraph__subtitle___35Kn_",
	"form": "modal__form___2tl_S",
	"field": "modal__field___1x69t",
	"fieldLabel": "modal__fieldLabel___3iqdw",
	"fieldInput": "modal__fieldInput___1Q_bK",
	"button": "modal__button___2hRhc",
	"submitActive": "modal__submitActive___bu9Zn",
	"successTitle": "modal__successTitle___3C94i modal__title___3d9VK",
	"successContent": "modal__successContent___2k4nQ modal__content___35-fc",
	"successIcon": "modal__successIcon___XDNbO",
	"description": "modal__description___1i5XU",
	"barriersTitle": "modal__barriersTitle___fx_UX modal__title___3d9VK",
	"barriersServices": "modal__barriersServices___1l0vD"
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(8);

var _SignUpComplete = __webpack_require__(58);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_SignUpComplete2.default, {});

var SignUpCompletePopup = function SignUpCompletePopup(_ref) {
    var closePopover = _ref.closePopover;
    return _jsx(_Lightbox2.default, {
        close: function close() {
            closePopover();
        }
    }, void 0, _ref2);
};

exports.default = (0, _reactRedux.connect)(null, { dispatchSignIn: _actions.signIn })(SignUpCompletePopup);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('br', {});

var SignUpComplete = function SignUpComplete() {
    return _jsx('div', {
        className: 'ui-modal__canvas'
    }, void 0, _jsx('h2', {
        className: _modal2.default.successTitle
    }, void 0, 'Sign up complete'), _jsx(_rpReactSvgIcon2.default, {
        isInlined: true,
        iconName: 'tick',
        className: 'ui-icon ui-icon_size3XL ' + _modal2.default.successIcon
    }), _jsx('p', {
        className: _modal2.default.successContent
    }, void 0, 'Thank you for signing up ', _ref, 'An email has been sent to you to confirm your registration'));
};

exports.default = SignUpComplete;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _errorDialog = __webpack_require__(300);

var _errorDialog2 = _interopRequireDefault(_errorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDialog = function ErrorDialog(_ref) {
    var close = _ref.close,
        message = _ref.message;
    return _jsx('div', {
        className: _errorDialog2.default.wrapper
    }, void 0, _jsx('h2', {
        className: _errorDialog2.default.title
    }, void 0, 'Oh no!'), _jsx('p', {
        className: _errorDialog2.default.paragraph
    }, void 0, message || 'Something has gone wrong, please try again.'), _jsx('button', {
        className: 'ui-btn ui-btn_large ui-btn_primary ' + _errorDialog2.default.button,
        onClick: close
    }, void 0, 'Try Again'));
};

ErrorDialog.defaultProps = {
    message: ''
};

exports.default = ErrorDialog;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(301);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./errorDialog.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./errorDialog.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.errorDialog__title___3JzZD {\n  margin: 0 auto;\n  padding: 24px 0;\n  text-align: center; }\n\n.errorDialog__paragraph___1a9dA {\n  padding: 0;\n  text-align: center; }\n\n.errorDialog__button___Za7fG {\n  width: 100%;\n  margin-top: 24px; }\n\n.errorDialog__wrapper___-hcvb {\n  padding: 0 16px 16px;\n  box-sizing: border-box; }\n", ""]);

// exports
exports.locals = {
	"title": "errorDialog__title___3JzZD",
	"paragraph": "errorDialog__paragraph___1a9dA",
	"button": "errorDialog__button___Za7fG",
	"wrapper": "errorDialog__wrapper___-hcvb"
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _api = __webpack_require__(14);

var _EmailVerification = __webpack_require__(303);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerification = function EmailVerification(_ref) {
    var email = _ref.email,
        accountId = _ref.accountId,
        session = _ref.session,
        onSuccess = _ref.onSuccess,
        onError = _ref.onError;

    var handleClick = function handleClick() {
        (0, _api.sendVerificationEmail)(accountId, session).then(onSuccess, onError);
    };

    return _jsx('div', {
        className: _EmailVerification2.default.wrapper
    }, void 0, _jsx('h2', {
        className: _EmailVerification2.default.title
    }, void 0, 'Please verify your email address'), _jsx('p', {
        className: _EmailVerification2.default.email
    }, void 0, email), _jsx('p', {
        className: _EmailVerification2.default.paragraph
    }, void 0, 'In order to continue using your Racing Post account we will need to verify the above email address is yours.'), _jsx('p', {
        className: _EmailVerification2.default.paragraph
    }, void 0, 'We will send you an email to the above email address, please click on the link in the email to complete your verification. Please check your junk mail folder if you do not receive the email in your inbox.'), _jsx('button', {
        className: 'ui-btn ui-btn_large ui-btn_primary ' + _EmailVerification2.default.button,
        onClick: handleClick
    }, void 0, 'Continue'), _jsx('p', {
        className: _EmailVerification2.default.copyright
    }, void 0, 'For assistance please contact customer services at help@racingpost.com or call ', _jsx('span', {
        className: _EmailVerification2.default.phone
    }, void 0, '+44 (0) 207 748 3771')));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerification'), (0, _recompose.setPropTypes)({
    email: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.string.isRequired,
    onSuccess: _propTypes2.default.func.isRequired,
    onError: _propTypes2.default.func.isRequired
}))(EmailVerification);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(304);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./EmailVerification.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./EmailVerification.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.EmailVerification__title___2wXMv {\n  font: 20px/21px \"proxima-nova-a\", sans-serif;\n  margin: 0 auto;\n  padding: 24px 0;\n  text-align: center; }\n\n.EmailVerification__paragraph___11BU_ {\n  font: 14px/19px \"proxima-nova-a\", sans-serif;\n  padding: 0;\n  text-align: center; }\n\n.EmailVerification__button___3effe {\n  margin-top: 24px;\n  margin-bottom: 12px;\n  padding-right: 46px;\n  padding-left: 46px; }\n\n.EmailVerification__wrapper___37MTc {\n  padding: 0 38px 16px;\n  text-align: center;\n  box-sizing: border-box; }\n\n.EmailVerification__email___1DgES {\n  margin-top: 0;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  color: #171717;\n  text-align: center; }\n\n.EmailVerification__copyright___7IvL3 {\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  text-align: center; }\n\n.EmailVerification__phone___2Fros {\n  white-space: nowrap; }\n", ""]);

// exports
exports.locals = {
	"title": "EmailVerification__title___2wXMv",
	"paragraph": "EmailVerification__paragraph___11BU_",
	"button": "EmailVerification__button___3effe",
	"wrapper": "EmailVerification__wrapper___37MTc",
	"email": "EmailVerification__email___1DgES",
	"copyright": "EmailVerification__copyright___7IvL3",
	"phone": "EmailVerification__phone___2Fros"
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(8);

var _SignUpComplete = __webpack_require__(58);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_SignUpComplete2.default, {});

var EmailVerificationCompletePopup = function EmailVerificationCompletePopup(_ref) {
    var goToSignIn = _ref.goToSignIn;
    return _jsx(_Lightbox2.default, {
        close: function close() {
            goToSignIn();
        }
    }, void 0, _ref2);
};

exports.default = (0, _reactRedux.connect)(null, { dispatchSignIn: _actions.signIn })(EmailVerificationCompletePopup);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(307);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./signInUp.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./signInUp.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.signInUp__popoverContainer___1NPl2 {\n  display: flex;\n  height: 100%;\n  width: 100%; }\n  @media (min-width: 720px) {\n    .signInUp__popoverContainer___1NPl2 {\n      position: relative; } }\n  .signInUp__popoverContainer___1NPl2 .rn-menuBar__navItem:last-child {\n    display: none; }\n    @media (min-width: 990px) {\n      .signInUp__popoverContainer___1NPl2 .rn-menuBar__navItem:last-child {\n        display: flex; } }\n  @media (max-width: 719.9px) {\n    .signInUp__popoverContainer___1NPl2 .ui-popover {\n      /*\n            Modal position should be absolute for appropriate inputs behavior on iOS 11\n            https://racingpost.atlassian.net/browse/QW-1132\n            https://hackernoon.com/how-to-fix-the-ios-11-input-element-in-fixed-modals-bug-aaf66c7ba3f8\n         */\n      position: absolute;\n      max-height: 100vh;\n      overflow-y: auto; } }\n\n.signInUp__popoverContainerSelected___2KnP3 { }\n  .signInUp__popoverContainerSelected___2KnP3 .rn-menuBar__navItem:first-child {\n    background-color: #D11F25;\n    color: #FFFFFF; }\n    .signInUp__popoverContainerSelected___2KnP3 .rn-menuBar__navItem:first-child .ui-icon {\n      fill: #FFFFFF; }\n\n.signInUp__SignIn___17EBs { }\n  @media (min-width: 990px) {\n    .signInUp__SignIn___17EBs .ui-popover {\n      left: 25%; } }\n\n.signInUp__SignUp___1Wp4H { }\n  @media (min-width: 990px) {\n    .signInUp__SignUp___1Wp4H .ui-popover {\n      left: 75%; }\n    .signInUp__SignUp___1Wp4H .rn-menuBar__navItem:first-child {\n      background-color: #FFFFFF;\n      color: #171717; }\n      .signInUp__SignUp___1Wp4H .rn-menuBar__navItem:first-child .ui-icon {\n        fill: #171717; }\n    .signInUp__SignUp___1Wp4H .rn-menuBar__navItem:last-child {\n      background-color: #D11F25;\n      color: #FFFFFF; }\n      .signInUp__SignUp___1Wp4H .rn-menuBar__navItem:last-child .ui-icon {\n        fill: #FFFFFF; } }\n", ""]);

// exports
exports.locals = {
	"popoverContainer": "signInUp__popoverContainer___1NPl2",
	"popoverContainerSelected": "signInUp__popoverContainerSelected___2KnP3 signInUp__popoverContainer___1NPl2",
	"SignIn": "signInUp__SignIn___17EBs signInUp__popoverContainerSelected___2KnP3 signInUp__popoverContainer___1NPl2",
	"SignUp": "signInUp__SignUp___1Wp4H signInUp__popoverContainerSelected___2KnP3 signInUp__popoverContainer___1NPl2"
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MyAccount = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(8);

var _rpAuthSync = __webpack_require__(31);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _PopoverComponent2 = __webpack_require__(48);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

var _AuthNavBtn = __webpack_require__(86);

var _AuthNavBtn2 = _interopRequireDefault(_AuthNavBtn);

var _Dropdown = __webpack_require__(309);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _actions = __webpack_require__(12);

var _myAccount = __webpack_require__(310);

var _myAccount2 = _interopRequireDefault(_myAccount);

var _api = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var btnClasses = {
    goToAccount: 'ui-btn ui-btn_large ' + _myAccount2.default.buttonAccount,
    signOut: 'ui-btn ui-btn_large ui-btn_primary ' + _myAccount2.default.button
};

var MyAccount = exports.MyAccount = function (_PopoverComponent) {
    _inherits(MyAccount, _PopoverComponent);

    function MyAccount() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MyAccount);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MyAccount.__proto__ || Object.getPrototypeOf(MyAccount)).call.apply(_ref, [this].concat(args))), _this), _this.toggleAccountPopover = function () {
            return _this.togglePopover('MyAccount');
        }, _this.signOutHandler = function () {
            (0, _api.deleteSession)().then(function () {
                _this.props.dispatchSignOut();
                _rpAuthSync2.default.reloadAll();
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MyAccount, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                {
                    className: (this.state.popoverType ? _myAccount2.default.popoverContainerSelected : _myAccount2.default.popoverContainer) + '\n                    ' + _myAccount2.default.popoverContainerAccount,
                    ref: function ref(node) {
                        _this2.node = node;
                    }
                },
                _jsx(_AuthNavBtn2.default, {
                    iconName: 'my-account',
                    onClick: this.toggleAccountPopover
                }, void 0, 'My Account'),
                this.state.popoverType && _jsx(_Dropdown2.default, {
                    title: 'MyAccount',
                    close: this.closePopover
                }, void 0, _jsx('div', {
                    className: _myAccount2.default.wrapper
                }, void 0, _jsx('a', {
                    href: '/members-club/my-account/',
                    className: btnClasses.goToAccount
                }, void 0, 'Go to My Account'), _jsx('button', {
                    className: btnClasses.signOut,
                    onClick: this.signOutHandler
                }, void 0, 'Sign Out')))
            );
        }
    }]);

    return MyAccount;
}(_PopoverComponent3.default);

exports.default = (0, _reactRedux.connect)(null, { dispatchSignOut: _actions.signOut })(MyAccount);

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dropdown = __webpack_require__(54);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dropdown2.default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(311);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./myAccount.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./myAccount.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.myAccount__popoverContainer___37eO6 {\n  display: flex;\n  height: 100%;\n  width: 100%; }\n  @media (min-width: 720px) {\n    .myAccount__popoverContainer___37eO6 {\n      position: relative; } }\n  .myAccount__popoverContainer___37eO6 .rn-menuBar__navItem:last-child {\n    display: none; }\n    @media (min-width: 990px) {\n      .myAccount__popoverContainer___37eO6 .rn-menuBar__navItem:last-child {\n        display: flex; } }\n  @media (max-width: 719.9px) {\n    .myAccount__popoverContainer___37eO6 .ui-popover {\n      /*\n            Modal position should be absolute for appropriate inputs behavior on iOS 11\n            https://racingpost.atlassian.net/browse/QW-1132\n            https://hackernoon.com/how-to-fix-the-ios-11-input-element-in-fixed-modals-bug-aaf66c7ba3f8\n         */\n      position: absolute;\n      max-height: 100vh;\n      overflow-y: auto; } }\n\n.myAccount__popoverContainerSelected___gQa_m { }\n  .myAccount__popoverContainerSelected___gQa_m .rn-menuBar__navItem:first-child {\n    background-color: #D11F25;\n    color: #FFFFFF; }\n    .myAccount__popoverContainerSelected___gQa_m .rn-menuBar__navItem:first-child .ui-icon {\n      fill: #FFFFFF; }\n\n.myAccount__wrapper___24EoM {\n  padding: 16px 8px; }\n\n.myAccount__button___3j7nF {\n  width: 100%; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .myAccount__button___3j7nF {\n      display: block;\n      margin: 0 auto;\n      max-width: 304px; } }\n\n.myAccount__buttonAccount___1FT6B {\n  margin-bottom: 16px; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .myAccount__buttonAccount___1FT6B {\n      display: block;\n      margin: 0 auto 16px;\n      max-width: 304px; } }\n\n.myAccount__popoverContainerAccount___3QaZA .rn-menuBar__navItem:last-child {\n  display: flex; }\n", ""]);

// exports
exports.locals = {
	"popoverContainer": "myAccount__popoverContainer___37eO6",
	"popoverContainerSelected": "myAccount__popoverContainerSelected___gQa_m myAccount__popoverContainer___37eO6",
	"wrapper": "myAccount__wrapper___24EoM",
	"button": "myAccount__button___3j7nF",
	"buttonAccount": "myAccount__buttonAccount___1FT6B myAccount__button___3j7nF",
	"popoverContainerAccount": "myAccount__popoverContainerAccount___3QaZA"
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BarrierContent = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _rpAnalytics = __webpack_require__(23);

var _Subscriptions = __webpack_require__(313);

var _Subscriptions2 = _interopRequireDefault(_Subscriptions);

var _ForgottenPassword = __webpack_require__(57);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

var _SignUpComplete = __webpack_require__(58);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

var _ErrorDialog = __webpack_require__(60);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

var _EmailVerification = __webpack_require__(316);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

var _SignIn = __webpack_require__(318);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _SignUp = __webpack_require__(320);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var barrierSteps = {
    Subscriptions: _Subscriptions2.default,
    SignIn: _SignIn2.default,
    SignUp: _SignUp2.default,
    ForgottenPassword: _ForgottenPassword2.default,
    SignUpComplete: _SignUpComplete2.default,
    ErrorDialog: _ErrorDialog2.default,
    EmailVerification: _EmailVerification2.default
};

var BarrierContent = exports.BarrierContent = function (_PureComponent) {
    _inherits(BarrierContent, _PureComponent);

    function BarrierContent(props) {
        _classCallCheck(this, BarrierContent);

        var _this = _possibleConstructorReturn(this, (BarrierContent.__proto__ || Object.getPrototypeOf(BarrierContent)).call(this, props));

        _this.goToStep = function (step) {
            _this.setState({ step: step }, function () {
                _this.props.onStepChange(_this.state.step);
            });

            if (step === 'Subscriptions') {
                (0, _rpAnalytics.identify)().then(function () {
                    return (0, _rpAnalytics.trackBarrierShow)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, _this.props.backUrl));
                });
            } else if (step === 'ForgottenPassword') {
                (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, _this.props.backUrl));
            }
        };

        _this.state = {
            step: _this.props.step
        };
        return _this;
    }

    _createClass(BarrierContent, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var step = _ref.step;

            if (step === 'SignIn') {
                this.goToStep('SignIn');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var step = this.state.step;
            var _props = this.props,
                backUrl = _props.backUrl,
                close = _props.close,
                showTitle = _props.showTitle;

            var ShownStep = barrierSteps[step];

            return _jsx(ShownStep, {
                goToStep: this.goToStep,
                backUrl: backUrl,
                close: close,
                showTitle: showTitle
            });
        }
    }]);

    return BarrierContent;
}(_react.PureComponent);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('BarrierContent'), (0, _recompose.setPropTypes)({
    step: _propTypes2.default.string.isRequired,
    backUrl: _propTypes2.default.string,
    close: _propTypes2.default.func.isRequired,
    onStepChange: _propTypes2.default.func.isRequired,
    showTitle: _propTypes2.default.bool.isRequired
}), (0, _recompose.defaultProps)({
    backUrl: undefined
}))(BarrierContent);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Subscriptions = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _rpAnalytics = __webpack_require__(23);

var _reactRedux = __webpack_require__(8);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _goToUrl = __webpack_require__(53);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

var _Subscriptions = __webpack_require__(314);

var _Subscriptions2 = _interopRequireDefault(_Subscriptions);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matrixUrl = '/members-club/matrix';

var Subscriptions = exports.Subscriptions = function Subscriptions(_ref) {
    var goToStep = _ref.goToStep,
        userLoggedIn = _ref.userLoggedIn,
        text = _ref.text,
        step = _ref.step,
        service = _ref.service;
    return _jsx('div', {
        className: _modal2.default.container + ' ' + _Subscriptions2.default.container
    }, void 0, _jsx(_rpReactSvgIcon2.default, {
        iconName: 'members-club-logo',
        className: _Subscriptions2.default.logo
    }), _jsx('h2', {
        className: _modal2.default.barriersTitle
    }, void 0, text && step === 'Subscriptions' && (text.indexOf('^') !== -1 ? text.split('^').map(function (txt) {
        return _jsx('div', {}, txt, txt);
    }) : text), !text && 'Subscribe now to see this premium content'), _jsx('button', {
        className: 'js-popup-link ui-btn ui-btn_primary ui-btn_XL ' + _Subscriptions2.default.btn,
        onClick: function onClick(e) {
            e.preventDefault();
            (0, _rpAnalytics.identify)().then(function () {
                (0, _rpAnalytics.trackBarrierSubscribe)();
                (0, _goToUrl2.default)('' + global.location.origin + matrixUrl);
            });
        }
    }, void 0, 'Subscribe'), service !== 'upgrade' ? _jsx('div', {
        className: _Subscriptions2.default.footer
    }, void 0, 'Already in the Members\u2019 Club?\xA0', _jsx('button', {
        className: 'ui-reset-for-btn ui-link ui-link_secondary ' + _Subscriptions2.default.link,
        onClick: function onClick() {
            if (!userLoggedIn) {
                (0, _rpAnalytics.trackBarrierSignIn)();
                goToStep('SignIn');
            } else {
                (0, _goToUrl2.default)(global.location.origin.concat('/members-club/my-account/'));
            }
        }
    }, void 0, 'Sign in')) : null);
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Subscriptions'), (0, _recompose.setPropTypes)({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        title: _propTypes2.default.string.isRequired,
        description: _propTypes2.default.string.isRequired,
        features: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
        priceId: _propTypes2.default.number.isRequired,
        price: _propTypes2.default.string.isRequired,
        pricePerMonth: _propTypes2.default.string.isRequired,
        period: _propTypes2.default.number.isRequired,
        periodUnit: _propTypes2.default.string.isRequired
    })).isRequired,
    goToStep: _propTypes2.default.func.isRequired,
    userLoggedIn: _propTypes2.default.bool.isRequired,
    text: _propTypes2.default.string.isRequired,
    step: _propTypes2.default.string.isRequired,
    service: _propTypes2.default.string.isRequired
}), (0, _reactRedux.connect)(function (_ref2) {
    var userLoggedIn = _ref2.userLoggedIn,
        _ref2$showBarrier = _ref2.showBarrier,
        text = _ref2$showBarrier.text,
        step = _ref2$showBarrier.step,
        service = _ref2$showBarrier.service;
    return {
        userLoggedIn: userLoggedIn, text: text, step: step, service: service
    };
}))(Subscriptions);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(315);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./Subscriptions.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./Subscriptions.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.Subscriptions__container___3eEfl {\n  padding: 16px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5); }\n\n.Subscriptions__footer___3Ri15 {\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n  border-top: 1px solid #F0EFF1; }\n\n.Subscriptions__link___2LElU {\n  cursor: pointer;\n  font-family: \"proxima-nova-a-bold\", sans-serif; }\n\n.Subscriptions__btn___2Jiby {\n  display: block;\n  margin: 16px auto;\n  padding: 0 32px; }\n\n.Subscriptions__logo___1L0UR {\n  width: 262px;\n  height: 46px;\n  margin: 40px 20px 0 0; }\n  @media (max-width: 479.9px) {\n    .Subscriptions__logo___1L0UR {\n      width: 233px;\n      height: 41px; } }\n", ""]);

// exports
exports.locals = {
	"container": "Subscriptions__container___3eEfl",
	"footer": "Subscriptions__footer___3Ri15",
	"link": "Subscriptions__link___2LElU",
	"btn": "Subscriptions__btn___2Jiby",
	"logo": "Subscriptions__logo___1L0UR"
};

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailVerification = __webpack_require__(317);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmailVerification2.default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailVerification = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _EmailVerification = __webpack_require__(94);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerification = exports.EmailVerification = function EmailVerification(_ref) {
    var goToStep = _ref.goToStep,
        message = _ref.message,
        accountId = _ref.accountId,
        session = _ref.session;
    return _jsx(_EmailVerification2.default, {
        accountId: accountId,
        session: session,
        email: message,
        onSuccess: function onSuccess() {
            return goToStep('SignIn');
        },
        onError: function onError() {
            return goToStep('ErrorDialog');
        }
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerification'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showEmailVerifi = _ref2.showEmailVerification,
        message = _ref2$showEmailVerifi.message,
        accountId = _ref2$showEmailVerifi.accountId,
        session = _ref2$showEmailVerifi.session;
    return { message: message, accountId: accountId, session: session };
}), (0, _recompose.setPropTypes)({
    message: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.string.isRequired,
    session: _propTypes2.default.string.isRequired,
    goToStep: _propTypes2.default.func.isRequired
}))(EmailVerification);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignIn = __webpack_require__(319);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignIn2.default;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignIn = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _analytics = __webpack_require__(21);

var _SignInForm = __webpack_require__(49);

var _SignInForm2 = _interopRequireDefault(_SignInForm);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignIn = exports.SignIn = function SignIn(_ref) {
    var goToStep = _ref.goToStep,
        backUrl = _ref.backUrl,
        showTitle = _ref.showTitle,
        text = _ref.text,
        step = _ref.step;
    return _jsx('div', {}, void 0, _jsx('h2', {
        className: _modal2.default.title
    }, void 0, 'Sign In'), (showTitle || text && step === 'SignIn') && _jsx('div', {
        className: _modal2.default.description
    }, void 0, text || 'You need to sign in to get access to your account details'), _jsx(_SignInForm2.default, {
        goToSignUp: function goToSignUp() {
            return goToStep('SignUp');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        goToEmailVerification: function goToEmailVerification() {
            return goToStep('EmailVerification');
        },
        hidden: false,
        backUrl: backUrl,
        onSignInSuccess: _analytics.onSignInSuccess
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignIn'), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired,
    backUrl: _propTypes2.default.string,
    text: _propTypes2.default.string,
    step: _propTypes2.default.string.isRequired,
    showTitle: _propTypes2.default.bool.isRequired
}), (0, _recompose.defaultProps)({
    backUrl: undefined,
    text: ''
}), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showBarrier = _ref2.showBarrier,
        text = _ref2$showBarrier.text,
        step = _ref2$showBarrier.step;
    return { text: text, step: step };
}))(SignIn);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUp = __webpack_require__(321);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUp2.default;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUp = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _SignUpForm = __webpack_require__(55);

var _SignUpForm2 = _interopRequireDefault(_SignUpForm);

var _analytics = __webpack_require__(21);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUp = exports.SignUp = function SignUp(_ref) {
    var goToStep = _ref.goToStep,
        backUrl = _ref.backUrl;
    return _jsx('div', {}, void 0, _jsx('h2', {
        className: _modal2.default.title
    }, void 0, 'Sign Up'), _jsx(_SignUpForm2.default, {
        goToSignIn: function goToSignIn() {
            return goToStep('SignIn');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToSignUpComplete: function goToSignUpComplete() {
            return goToStep('SignUpComplete');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        hidden: false,
        backUrl: backUrl,
        onSignUpSuccess: _analytics.onSignUpSuccess
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignUp'), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired,
    backUrl: _propTypes2.default.string
}), (0, _recompose.defaultProps)({
    backUrl: undefined
}))(SignUp);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CreatePassword = __webpack_require__(323);

var _CreatePassword2 = _interopRequireDefault(_CreatePassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CreatePassword2.default;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreatePassword = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(8);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _CreatePasswordForm = __webpack_require__(324);

var _CreatePasswordForm2 = _interopRequireDefault(_CreatePasswordForm);

var _actions = __webpack_require__(12);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePassword = exports.CreatePassword = function (_React$Component) {
    _inherits(CreatePassword, _React$Component);

    function CreatePassword() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CreatePassword);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreatePassword.__proto__ || Object.getPrototypeOf(CreatePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isVisible: false,
            token: ''
        }, _this.check = function () {
            if (window.location.hash.indexOf('#reset') === 0) {
                _this.setState({
                    isVisible: true,
                    token: window.location.hash.split('=')[1]
                });
                if (!window.history) {
                    window.location.hash = '#' + Math.random();
                } else {
                    window.history.pushState({}, document.title, window.location.href.split('#')[0]);
                }
            }
        }, _this.close = function () {
            _this.setState({
                isVisible: false,
                token: ''
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CreatePassword, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.check();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('hashchange', this.check);
        }
    }, {
        key: 'componentWillUnmont',
        value: function componentWillUnmont() {
            window.removeEventListener('hashchange', this.check);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isVisible = _state.isVisible,
                token = _state.token;
            var showError = this.props.showError;


            if (!isVisible) {
                return null;
            }

            return _jsx(_Lightbox2.default, {
                close: this.close
            }, void 0, _jsx('div', {
                className: _modal2.default.container
            }, void 0, _jsx('h2', {
                className: _modal2.default.title
            }, void 0, 'Create new password'), _jsx('div', {
                className: _modal2.default.content
            }, void 0, _jsx(_CreatePasswordForm2.default, {
                showError: showError,
                close: this.close,
                token: token
            }))));
        }
    }]);

    return CreatePassword;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(null, { showError: _actions.showErrorDialog })(CreatePassword);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = __webpack_require__(32);

var _FormField2 = _interopRequireDefault(_FormField);

var _SubmitBtn = __webpack_require__(34);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _PasswordError = __webpack_require__(56);

var _PasswordError2 = _interopRequireDefault(_PasswordError);

var _validation = __webpack_require__(35);

var _validation2 = _interopRequireDefault(_validation);

var _api = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx(_PasswordError2.default, {
    className: 'hint'
});

var CreatePasswordForm = function (_Component) {
    _inherits(CreatePasswordForm, _Component);

    function CreatePasswordForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CreatePasswordForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreatePasswordForm.__proto__ || Object.getPrototypeOf(CreatePasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            confirmPasswordError: false,
            passwordError: false,
            loading: false
        }, _this.onSubmit = function (e) {
            e.preventDefault();

            var _this$form = _this.form,
                password = _this$form.password,
                confirmPassword = _this$form.confirmPassword;


            var isFormValid = [password, confirmPassword].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!isFormValid) {
                return;
            }

            _this.setState({ loading: true });

            (0, _api.createUserPassword)(_this.props.token, password.value).then(_this.close).catch(_this.showError);
        }, _this.close = function () {
            _this.setState({ loading: false });
            _this.props.close();
        }, _this.showError = function () {
            _this.setState({ loading: false });
            _this.props.showError('Your password reset link has expired.\n            If you\'re still having problems signing in please\n            try requesting another link or contact customer\n            services on +44 (0)207 748 3771');
        }, _this.validate = function (_ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            var validate = _validation2.default[name];
            var isValid = validate(value, _this.form.password.value);
            _this.setState(_defineProperty({}, name + 'Error', !isValid));
            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CreatePasswordForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                passwordError = _state.passwordError,
                confirmPasswordError = _state.confirmPasswordError,
                loading = _state.loading;


            return _react2.default.createElement(
                'form',
                {
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _jsx(_FormField2.default, {
                    name: 'password',
                    label: 'Enter a new password',
                    validate: this.validate,
                    hasError: passwordError,
                    error: 'Please enter a valid password',
                    onlyBlur: true
                }),
                _jsx(_FormField2.default, {
                    name: 'confirmPassword',
                    type: 'password',
                    label: 'Confirm your new password',
                    validate: this.validate,
                    hasError: confirmPasswordError,
                    error: 'Passwords do not match',
                    onlyBlur: true
                }, void 0, _ref3),
                _jsx(_SubmitBtn2.default, {
                    label: 'Create',
                    loading: loading
                })
            );
        }
    }]);

    return CreatePasswordForm;
}(_react.Component);

exports.default = CreatePasswordForm;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResetPasswordPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _Lightbox = __webpack_require__(20);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _ResetPasswordForm = __webpack_require__(326);

var _ResetPasswordForm2 = _interopRequireDefault(_ResetPasswordForm);

var _actions = __webpack_require__(12);

var _modal = __webpack_require__(22);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordPopup = exports.ResetPasswordPopup = function ResetPasswordPopup(_ref) {
    var showError = _ref.showError,
        close = _ref.close,
        email = _ref.email;
    return _jsx(_Lightbox2.default, {
        close: close
    }, void 0, _jsx('div', {
        className: _modal2.default.container
    }, void 0, _jsx('h2', {
        className: _modal2.default.title
    }, void 0, 'Reset password'), _jsx('div', {
        className: _modal2.default.content
    }, void 0, _jsx('p', {
        className: _modal2.default.paragraph__subtitle
    }, void 0, 'Please complete the requests below to create and confirm your new password\xA0'), _jsx(_ResetPasswordForm2.default, {
        showError: showError,
        close: close,
        email: email
    }))));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ResetPasswordPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showResetPasswo = _ref2.showResetPassword,
        isVisible = _ref2$showResetPasswo.isVisible,
        email = _ref2$showResetPasswo.email;
    return { isVisible: isVisible, email: email };
}, {
    close: _actions.hideResetPassword,
    showError: _actions.showErrorDialog
}), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    isVisible: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired
}))(ResetPasswordPopup);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = __webpack_require__(32);

var _FormField2 = _interopRequireDefault(_FormField);

var _SubmitBtn = __webpack_require__(34);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _PasswordError = __webpack_require__(56);

var _PasswordError2 = _interopRequireDefault(_PasswordError);

var _validation = __webpack_require__(35);

var _validation2 = _interopRequireDefault(_validation);

var _api = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var errorMessages = {
    password: 'Please enter a valid password',
    newPassword: 'Please enter a valid password',
    confirmPassword: 'Passwords do not match'
};

var _ref3 = _jsx(_PasswordError2.default, {
    className: 'hint'
});

var ResetPasswordForm = function (_Component) {
    _inherits(ResetPasswordForm, _Component);

    function ResetPasswordForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ResetPasswordForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordForm.__proto__ || Object.getPrototypeOf(ResetPasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            passwordError: {
                hasError: false,
                error: ''
            },
            newPasswordError: {
                hasError: false,
                error: ''
            },
            confirmPasswordError: {
                hasError: false,
                error: ''
            },
            loading: false
        }, _this.onSubmit = function (e) {
            e.preventDefault();

            var _this$form = _this.form,
                password = _this$form.password,
                newPassword = _this$form.newPassword,
                confirmPassword = _this$form.confirmPassword;


            var isFormValid = [newPassword, confirmPassword].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!isFormValid) {
                return;
            }

            _this.setState({ loading: true });

            (0, _api.resetUserPassword)(_this.props.email, password.value, newPassword.value).then(function () {
                return _this.close();
            }).catch(function (error) {
                return _this.requestErrorHandler(error);
            });
        }, _this.requestErrorHandler = function (error) {
            if (error && error.response && error.response.data.ErrorNumber === 1009) {
                _this.setState({
                    loading: false,
                    passwordError: {
                        hasError: true,
                        error: 'Current password is invalid'
                    }
                });
            } else {
                _this.showError();
            }
        }, _this.close = function () {
            _this.setState({ loading: false });
            _this.props.close();
        }, _this.showError = function () {
            _this.setState({ loading: false });
            _this.props.showError();
        }, _this.validate = function (_ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            var validate = name === 'password' ? function () {
                return true;
            } : _validation2.default[name];
            var isValid = validate(value, _this.form.newPassword.value);
            _this.setState(_defineProperty({}, name + 'Error', {
                hasError: !isValid,
                error: errorMessages[name]
            }));
            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ResetPasswordForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                passwordError = _state.passwordError,
                newPasswordError = _state.newPasswordError,
                confirmPasswordError = _state.confirmPasswordError,
                loading = _state.loading;


            return _react2.default.createElement(
                'form',
                {
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _react2.default.createElement(_FormField2.default, _extends({
                    name: 'password',
                    label: 'Enter current password',
                    validate: this.validate,
                    noValidate: true
                }, passwordError)),
                _react2.default.createElement(_FormField2.default, _extends({
                    name: 'newPassword',
                    type: 'password',
                    label: 'Enter a new password',
                    validate: this.validate,
                    onlyBlur: true
                }, newPasswordError)),
                _react2.default.createElement(
                    _FormField2.default,
                    _extends({
                        name: 'confirmPassword',
                        type: 'password',
                        label: 'Confirm your new password',
                        validate: this.validate,
                        onlyBlur: true
                    }, confirmPasswordError),
                    _ref3
                ),
                _jsx(_SubmitBtn2.default, {
                    label: 'Create',
                    loading: loading
                })
            );
        }
    }]);

    return ResetPasswordForm;
}(_react.Component);

exports.default = ResetPasswordForm;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgottenPasswordPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _ForgottenPass = __webpack_require__(93);

var _ForgottenPass2 = _interopRequireDefault(_ForgottenPass);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgottenPasswordPopup = exports.ForgottenPasswordPopup = function ForgottenPasswordPopup(_ref) {
    var close = _ref.close;
    return _jsx(_ForgottenPass2.default, {
        closePopover: close
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ForgottenPasswordPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var isVisible = _ref2.showForgottenPassword;
    return { isVisible: isVisible };
}, { close: _actions.hideForgottenPassword }), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    close: _propTypes2.default.func.isRequired,
    isVisible: _propTypes2.default.bool.isRequired
}))(ForgottenPasswordPopup);

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailVerificationPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _EmailVerificationPopup = __webpack_require__(61);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerificationPopup = exports.EmailVerificationPopup = function EmailVerificationPopup(_ref) {
    var open = _ref.open,
        close = _ref.close,
        showError = _ref.showError;
    return _jsx(_EmailVerificationPopup2.default, {
        closePopover: close,
        goToSignIn: close,
        goToErrorDialog: function goToErrorDialog() {
            close();showError(null, open);
        }
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerificationPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var isVisible = _ref2.showEmailVerification.isVisible;
    return { isVisible: isVisible };
}, { open: _actions.showEmailVerification, close: _actions.hideEmailVerification, showError: _actions.showErrorDialog }), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    close: _propTypes2.default.func.isRequired,
    isVisible: _propTypes2.default.bool.isRequired
}))(EmailVerificationPopup);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorDialogPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(8);

var _recompose = __webpack_require__(11);

var _ErrorPopup = __webpack_require__(59);

var _ErrorPopup2 = _interopRequireDefault(_ErrorPopup);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDialogPopup = exports.ErrorDialogPopup = function ErrorDialogPopup(_ref) {
    var close = _ref.close,
        message = _ref.message;
    return _jsx(_ErrorPopup2.default, {
        closePopover: function closePopover() {
            close();
        },
        message: message
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ErrorDialogPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showErrorDialog = _ref2.showErrorDialog,
        isVisible = _ref2$showErrorDialog.isVisible,
        message = _ref2$showErrorDialog.message;
    return { isVisible: isVisible, message: message };
}, { close: _actions.hideErrorDialog }), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    message: _propTypes2.default.string.isRequired,
    isVisible: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired
}))(ErrorDialogPopup);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MandatoryLogin = __webpack_require__(331);

var _MandatoryLogin2 = _interopRequireDefault(_MandatoryLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MandatoryLogin2.default;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MandatoryLogin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(83);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _reactRedux = __webpack_require__(8);

var _actions = __webpack_require__(12);

var _ForgottenPassword = __webpack_require__(332);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

var _ErrorDialog = __webpack_require__(336);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

var _SignIn = __webpack_require__(338);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _SignUp = __webpack_require__(342);

var _SignUp2 = _interopRequireDefault(_SignUp);

var _SignUpComplete = __webpack_require__(346);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

var _MandatoryLogin = __webpack_require__(352);

var _MandatoryLogin2 = _interopRequireDefault(_MandatoryLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var mandatoryLoginSteps = {
    SignIn: _SignIn2.default,
    SignUp: _SignUp2.default,
    ForgottenPassword: _ForgottenPassword2.default,
    SignUpComplete: _SignUpComplete2.default,
    ErrorDialog: _ErrorDialog2.default
};

var MandatoryLogin = exports.MandatoryLogin = function (_PureComponent) {
    _inherits(MandatoryLogin, _PureComponent);

    function MandatoryLogin(props, context) {
        _classCallCheck(this, MandatoryLogin);

        var _this = _possibleConstructorReturn(this, (MandatoryLogin.__proto__ || Object.getPrototypeOf(MandatoryLogin)).call(this, props, context));

        _this.state = {
            prevStep: null,
            step: _this.props.step
        };

        _this.goToStep = _this.goToStep.bind(_this);
        return _this;
    }

    _createClass(MandatoryLogin, [{
        key: 'goToStep',
        value: function goToStep(nextStep) {
            this.setState(function (prevState) {
                return {
                    prevStep: prevState.step,
                    step: nextStep
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var step = this.state.step;
            var _props = this.props,
                target = _props.target,
                close = _props.close;

            var ShownStep = mandatoryLoginSteps[step];

            return (0, _reactDom.createPortal)(_jsx('div', {
                className: _MandatoryLogin2.default.root
            }, void 0, _jsx(ShownStep, {
                goToStep: this.goToStep,
                close: close,
                prevStep: this.state.prevStep
            })), document.querySelector(target));
        }
    }]);

    return MandatoryLogin;
}(_react.PureComponent);

function mergeProps(stateProps, dispatchProps) {
    return _extends({}, stateProps, dispatchProps, {
        onShowMandatoryLogin: function onShowMandatoryLogin(_ref) {
            var _ref$detail = _ref.detail,
                step = _ref$detail.step,
                target = _ref$detail.target;

            dispatchProps.open(step, target);
        },
        onHideMandatoryLogin: function onHideMandatoryLogin() {
            dispatchProps.close();
        }
    });
}

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('MandatoryLogin'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showMandatoryLo = _ref2.showMandatoryLogin,
        show = _ref2$showMandatoryLo.show,
        step = _ref2$showMandatoryLo.step,
        target = _ref2$showMandatoryLo.target;
    return { show: show, step: step, target: target };
}, { open: _actions.showMandatoryLogin, close: _actions.hideMandatoryLogin }, mergeProps), (0, _recompose.lifecycle)({
    componentWillMount: function componentWillMount() {
        document.addEventListener('rpAuth:ShowMandatoryLogin', this.props.onShowMandatoryLogin);
        document.addEventListener('rpAuth:HideMandatoryLogin', this.props.onHideMandatoryLogin);
    },
    componentDidMount: function componentDidMount() {
        var initializeMandatoryLoginEvent = new CustomEvent('rpAuth:Initialize');
        document.dispatchEvent(initializeMandatoryLoginEvent);
    },
    componentWillUnmount: function componentWillUnmount() {
        document.removeEventListener('rpAuth:ShowMandatoryLogin', this.props.onShowMandatoryLogin);
        document.removeEventListener('rpAuth:HideMandatoryLogin', this.props.onHideMandatoryLogin);
    }
}), (0, _recompose.branch)(function (_ref3) {
    var show = _ref3.show;
    return !show;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    step: _propTypes2.default.string.isRequired,
    target: _propTypes2.default.string.isRequired,
    close: _propTypes2.default.func.isRequired
}))(MandatoryLogin);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPassword = __webpack_require__(333);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForgottenPassword2.default;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _ForgottenPassword = __webpack_require__(57);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

var _ForgotternPassword = __webpack_require__(334);

var _ForgotternPassword2 = _interopRequireDefault(_ForgotternPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackLink = function BackLink(_ref) {
    var onClick = _ref.onClick;
    return _jsx('button', {
        type: 'button',
        className: 'ui-link ui-link_secondary ui-reset-for-btn',
        onClick: onClick
    }, void 0, _jsx(_rpReactSvgIcon2.default, {
        iconName: 'left',
        size: 'Normal',
        className: _ForgotternPassword2.default.icon
    }), 'Back');
};

var ForgottenPassword = function ForgottenPassword(_ref2) {
    var goToStep = _ref2.goToStep,
        prevStep = _ref2.prevStep;
    return _jsx(_ForgottenPassword2.default, {
        backLink: _jsx(BackLink, {
            onClick: function onClick() {
                return goToStep(prevStep);
            }
        }),
        close: function close() {
            return goToStep(prevStep);
        }
    });
};

exports.default = ForgottenPassword;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(335);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./ForgotternPassword.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./ForgotternPassword.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.ForgotternPassword__icon___398ol {\n  margin-right: 4px;\n  fill: #171717; }\n", ""]);

// exports
exports.locals = {
	"icon": "ForgotternPassword__icon___398ol"
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ErrorDialog = __webpack_require__(337);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ErrorDialog2.default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorDialog = __webpack_require__(60);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDialog = function ErrorDialog(_ref) {
    var goToStep = _ref.goToStep,
        prevStep = _ref.prevStep;
    return _jsx(_ErrorDialog2.default, {
        close: function close() {
            return goToStep(prevStep);
        }
    });
};

exports.default = ErrorDialog;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignIn = __webpack_require__(339);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignIn2.default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignIn = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _analytics = __webpack_require__(21);

var _SignInForm = __webpack_require__(49);

var _SignInForm2 = _interopRequireDefault(_SignInForm);

var _EmailVerificationPopup = __webpack_require__(61);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _ErrorPopup = __webpack_require__(59);

var _ErrorPopup2 = _interopRequireDefault(_ErrorPopup);

var _SignIn = __webpack_require__(340);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchFormLabel = function SwitchFormLabel() {
    return _jsx('span', {}, void 0, _jsx(_rpReactSvgIcon2.default, {
        iconName: 'left',
        size: 'Normal',
        className: _SignIn2.default.icon
    }), 'Back');
};

var _ref2 = _jsx(SwitchFormLabel, {});

var SignIn = exports.SignIn = function SignIn(_ref) {
    var emailVerification = _ref.emailVerification,
        error = _ref.error,
        goToStep = _ref.goToStep,
        showEmailVerification = _ref.showEmailVerification,
        hideEmailVerification = _ref.hideEmailVerification,
        showError = _ref.showError,
        hideError = _ref.hideError;
    return _jsx('div', {
        className: _SignIn2.default.root
    }, void 0, _jsx('h2', {
        className: _SignIn2.default.title
    }, void 0, 'Sign In'), _jsx(_SignInForm2.default, {
        goToSignUp: function goToSignUp() {
            return goToStep('SignUp');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        goToEmailVerification: showEmailVerification,
        hidden: false,
        switchFormLabel: _ref2,
        onSignInSuccess: _analytics.onSignInSuccess
    }), emailVerification && !error && _jsx(_EmailVerificationPopup2.default, {
        closePopover: hideEmailVerification,
        goToSignIn: hideEmailVerification,
        goToErrorDialog: showError
    }), error && _jsx(_ErrorPopup2.default, {
        closePopover: hideError
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignIn'), (0, _recompose.withState)('emailVerification', 'setEmailVerification', false), (0, _recompose.withState)('error', 'setError', false), (0, _recompose.withHandlers)({
    showEmailVerification: function showEmailVerification(_ref3) {
        var setEmailVerification = _ref3.setEmailVerification;
        return function () {
            setEmailVerification(true);
        };
    },
    hideEmailVerification: function hideEmailVerification(_ref4) {
        var setEmailVerification = _ref4.setEmailVerification;
        return function () {
            setEmailVerification(false);
        };
    },
    showError: function showError(_ref5) {
        var setError = _ref5.setError;
        return function () {
            setError(true);
        };
    },
    hideError: function hideError(_ref6) {
        var setError = _ref6.setError;
        return function () {
            setError(false);
        };
    }
}), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired,
    emailVerification: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.bool.isRequired,
    showEmailVerification: _propTypes2.default.func.isRequired,
    hideEmailVerification: _propTypes2.default.func.isRequired,
    showError: _propTypes2.default.func.isRequired,
    hideError: _propTypes2.default.func.isRequired
}))(SignIn);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(341);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignIn.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignIn.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignIn__root___3pY3A {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #FFFFFF; }\n\n.SignIn__title___3JPBh {\n  margin: 0;\n  padding: 16px 16px 8px;\n  font: 36px/37px \"utopia-std-subh\", serif; }\n\n.SignIn__icon___2RW5f {\n  margin-right: 4px;\n  fill: #171717; }\n", ""]);

// exports
exports.locals = {
	"root": "SignIn__root___3pY3A",
	"title": "SignIn__title___3JPBh",
	"icon": "SignIn__icon___2RW5f"
};

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUp = __webpack_require__(343);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUp2.default;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SwitchFormLabel = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(11);

var _rpReactSvgIcon = __webpack_require__(16);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SignUpForm = __webpack_require__(55);

var _SignUpForm2 = _interopRequireDefault(_SignUpForm);

var _analytics = __webpack_require__(21);

var _SignUp = __webpack_require__(344);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchFormLabel = exports.SwitchFormLabel = function SwitchFormLabel() {
    return _jsx('span', {}, void 0, _jsx(_rpReactSvgIcon2.default, {
        isInlined: true,
        iconName: 'right',
        size: 'Normal',
        className: _SignUp2.default.icon
    }), 'I already have an account');
};

var _ref2 = _jsx(SwitchFormLabel, {});

var SignUp = function SignUp(_ref) {
    var goToStep = _ref.goToStep;
    return _jsx('div', {
        className: _SignUp2.default.root
    }, void 0, _jsx('h2', {
        className: _SignUp2.default.title
    }, void 0, 'Register'), _jsx(_SignUpForm2.default, {
        goToSignIn: function goToSignIn() {
            return goToStep('SignIn');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToSignUpComplete: function goToSignUpComplete() {
            return goToStep('SignUpComplete');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        hidden: false,
        disableConditions: true,
        submitLabel: 'Register for FREE',
        switchFormLabel: _ref2,
        onSignUpSuccess: _analytics.onSignUpSuccess
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignUp'), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired
}))(SignUp);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(345);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUp.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUp.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignUp__root___lBkgu {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #FFFFFF; }\n\n.SignUp__title___2A6Ra {\n  margin: 0;\n  padding: 16px 16px 8px;\n  font: 36px/37px \"utopia-std-subh\", serif; }\n\n.SignUp__icon___hprUn {\n  margin-right: 4px;\n  fill: #171717; }\n", ""]);

// exports
exports.locals = {
	"root": "SignUp__root___lBkgu",
	"title": "SignUp__title___2A6Ra",
	"icon": "SignUp__icon___hprUn"
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUpComplete = __webpack_require__(347);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUpComplete2.default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUpComplete = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpComplete = __webpack_require__(348);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('br', {});

var SignUpComplete = exports.SignUpComplete = function (_PureComponent) {
    _inherits(SignUpComplete, _PureComponent);

    function SignUpComplete() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SignUpComplete);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignUpComplete.__proto__ || Object.getPrototypeOf(SignUpComplete)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            _this.props.close();
            var closeEvent = new CustomEvent('rpAuth:Close', {
                detail: {
                    status: 'success'
                },
                bubbles: true,
                cancelable: false
            });

            document.dispatchEvent(closeEvent);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignUpComplete, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var successEvent = new CustomEvent('rpAuth:SignUp', {
                detail: {
                    status: 'success'
                },
                bubbles: true,
                cancelable: false
            });

            document.dispatchEvent(successEvent);
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx('div', {
                className: _SignUpComplete2.default.root
            }, void 0, _jsx('h2', {
                className: _SignUpComplete2.default.successTitle
            }, void 0, 'Sign up complete'), _jsx('div', {
                className: _SignUpComplete2.default.icon
            }), _jsx('p', {
                className: _SignUpComplete2.default.successContent
            }, void 0, 'Thank you for signing up ', _ref2, 'An email has been sent to you to confirm your registration'), _jsx('button', {
                type: 'button',
                className: 'ui-btn ui-btn_large ui-btn_primary',
                onClick: this.handleClick
            }, void 0, 'Continue to Racing Post'));
        }
    }]);

    return SignUpComplete;
}(_react.PureComponent);

exports.default = SignUpComplete;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(349);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUpComplete.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUpComplete.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(350);
exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignUpComplete__root___-N13a {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%; }\n\n.SignUpComplete__icon___XDkTM {\n  background-image: url(" + escape(__webpack_require__(351)) + ");\n  width: 150px;\n  height: 150px;\n  background-size: contain;\n  align-self: center;\n  margin: auto; }\n\n.SignUpComplete__title___12a5o {\n  margin: 0 auto;\n  padding: 24px 0 8px;\n  font: 20px/26px \"proxima-nova-a-bold\", sans-serif;\n  text-align: center;\n  color: #171717; }\n  @media (min-width: 720px) {\n    .SignUpComplete__title___12a5o {\n      padding: 24px 0 16px; } }\n\n.SignUpComplete__content___3TOVe {\n  margin: 0 8px; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SignUpComplete__content___3TOVe {\n      width: 464px;\n      margin: 0 auto 8px; } }\n\n.SignUpComplete__successTitle___1M7BR {\n  padding-bottom: 0;\n  font-family: \"proxima-nova-a\", sans-serif; }\n\n.SignUpComplete__successContent___9Oikx {\n  text-align: center;\n  padding-bottom: 24px;\n  white-space: pre-wrap; }\n", ""]);

// exports
exports.locals = {
	"root": "SignUpComplete__root___-N13a",
	"icon": "SignUpComplete__icon___XDkTM",
	"title": "SignUpComplete__title___12a5o",
	"content": "SignUpComplete__content___3TOVe",
	"successTitle": "SignUpComplete__successTitle___1M7BR SignUpComplete__title___12a5o",
	"successContent": "SignUpComplete__successContent___9Oikx SignUpComplete__content___3TOVe"
};

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(353);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(10)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/sass-loader/lib/loader.js!./MandatoryLogin.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/sass-loader/lib/loader.js!./MandatoryLogin.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, ".MandatoryLogin__root___2WvPw {\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"root": "MandatoryLogin__root___2WvPw"
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.rpAuthRoot {\n  height: 100%;\n  justify-content: center; }\n  @media (max-width: 719.9px) {\n    .rpAuthRoot {\n      width: 20%; }\n      .rpAuthRoot .rn-menuBar__navItem {\n        width: 100%;\n        border: none; } }\n  .rpAuthRoot .ui-flex {\n    height: 100%;\n    width: 100%; }\n\n@media (max-width: 719.9px) {\n  .authModalPopover .rn-canvas {\n    position: static; } }\n", ""]);

// exports


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rpAuthSync = __webpack_require__(31);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _Barrier = __webpack_require__(95);

var _Barrier2 = _interopRequireDefault(_Barrier);

__webpack_require__(96);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
    className: 'ui-flex'
}, void 0, _jsx(_Barrier2.default, {}));

var AppBarrier = function (_PureComponent) {
    _inherits(AppBarrier, _PureComponent);

    function AppBarrier() {
        _classCallCheck(this, AppBarrier);

        return _possibleConstructorReturn(this, (AppBarrier.__proto__ || Object.getPrototypeOf(AppBarrier)).apply(this, arguments));
    }

    _createClass(AppBarrier, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            _rpAuthSync2.default.run();
        }
    }, {
        key: 'render',
        value: function render() {
            return _ref;
        }
    }]);

    return AppBarrier;
}(_react.PureComponent);

exports.default = AppBarrier;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(47).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideMandatoryLoginForm = exports.showMandatoryLoginForm = exports.dispatchSignOut = exports.dispatchSignIn = exports.showError = exports.showEmailVerification = exports.showForgottenPass = exports.showResetPass = exports.checkForAccess = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = __webpack_require__(97);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(12);

var _helpers = __webpack_require__(82);

var _goToUrl = __webpack_require__(53);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

var _api = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var steps = {
    subscribe: 'Subscriptions',
    signin: 'SignIn',
    signup: 'SignUp',
    'sign-in': 'SignIn',
    'sign-up': 'SignUp',
    forgottenPassword: 'ForgottenPassword'
};

var checkForAccess = exports.checkForAccess = function checkForAccess(step) {
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isHighSecure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var barrierParams = arguments[3];

    var cookieParams = (0, _helpers.getParams)();

    var _cookieParams$barrier = _extends({}, cookieParams, barrierParams),
        type = _cookieParams$barrier.type,
        r = _cookieParams$barrier.r,
        text = _cookieParams$barrier.text,
        service = _cookieParams$barrier.service;

    var isAuthorized = null;

    if (r && !cookieParams.r) {
        isAuthorized = (0, _api.getAccess)({ requestUrl: r }).then(function (hasAccess) {
            var href = global.location.href;


            if (!hasAccess && ((0, _helpers.shouldCheckForBarrier)() || show) || hasAccess && !isHighSecure && ((0, _helpers.shouldCheckForBarrier)() || show)) {
                if (!steps[type] && !show && !(0, _helpers.shouldCheckForBarrier)()) {
                    (0, _goToUrl2.default)(href.replace('?authme', ''));
                    return null;
                }

                var cookie = (0, _helpers.getParams)();
                _store2.default.dispatch((0, _actions.showBarriers)(steps[type] || step, href, cookie.text || text, service, show));
            }

            return hasAccess;
        });
    } else {
        isAuthorized = Promise.resolve(false);

        if ((0, _helpers.shouldCheckForBarrier)() || show) {
            _store2.default.dispatch((0, _actions.showBarriers)(steps[type] || step, r, text, service, show));
        }
    }

    return isAuthorized;
};

var showResetPass = exports.showResetPass = function showResetPass(email) {
    _store2.default.dispatch((0, _actions.showResetPassword)(email));
};

var showForgottenPass = exports.showForgottenPass = function showForgottenPass() {
    _store2.default.dispatch((0, _actions.showForgottenPassword)());
};

var showEmailVerification = exports.showEmailVerification = function showEmailVerification(email, guid) {
    _store2.default.dispatch((0, _actions.showEmailVerification)(email, guid));
};

var showError = exports.showError = function showError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _store2.default.dispatch((0, _actions.showErrorDialog)(message));
};

var dispatchSignIn = exports.dispatchSignIn = function dispatchSignIn() {
    _store2.default.dispatch((0, _actions.signIn)());
};

var dispatchSignOut = exports.dispatchSignOut = function dispatchSignOut() {
    _store2.default.dispatch((0, _actions.signOut)());
};

var showMandatoryLoginForm = exports.showMandatoryLoginForm = function showMandatoryLoginForm(step, target) {
    _store2.default.dispatch((0, _actions.showMandatoryLogin)(step, target));
};

var hideMandatoryLoginForm = exports.hideMandatoryLoginForm = function hideMandatoryLoginForm() {
    _store2.default.dispatch((0, _actions.hideMandatoryLogin)());
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.show = exports.open = exports.run = undefined;

var _scriptRaw = __webpack_require__(359);

var _scriptRaw2 = _interopRequireDefault(_scriptRaw);

var _ml = __webpack_require__(360);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var was_run_ = false;

var run = exports.run = function run() {

    if (was_run_) return;

    console.log('authApi.MandatoryLoginOverlay.run()');

    was_run_ = true;

    var new_script_ = document.createElement('script');
    var inline_script_ = document.createTextNode(_scriptRaw2.default);
    new_script_.appendChild(inline_script_);

    var html_ = (0, _ml.getHtml)();
    var new_html_ = document.createElement('div');
    new_html_.innerHTML = html_;

    new_html_.appendChild(new_script_);

    document.getElementsByTagName('body')[0].appendChild(new_html_);
};

var open = exports.open = function open(is_debug_) {
    console.log('Run first: authApi.MandatoryLoginOverlay.run();');
};

var show = exports.show = function show(is_debug_) {
    console.log('authApi.MandatoryLoginOverlay.show()');

    run();
    authApi.MandatoryLoginOverlay.open(is_debug_);
};
/* eslint-enable */

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = "/* eslint-disable */\n(function MandatoryLoginOverlay(auth_api_) {\n\n    var DEBUG = false;\n\n    function consoleLog()\n    {\n        if (!DEBUG) return;\n        \n        console.log.apply(this, arguments);\n    }\n\n    /* will be handled inside optimizely code checks\n    \n    function getCookie(cookie_name_) \n    {\n        //consoleLog(document.cookie);\n\n        var name_ = cookie_name_ + \"=\";\n\n        var ca = document.cookie.split(';');\n\n        for(var i = 0; i < ca.length; i++) \n        {\n            var c = ca[i];\n\n            while (c.charAt(0) == ' ') {\n                c = c.substring(1);\n            }\n\n            if (c.indexOf(name_) == 0) {\n                return c.substring(name_.length, c.length);\n            }\n        }\n\n        return '';\n    }\n\n    function getCookieObject(cookie_name_)\n    {\n        var cookie_string_ = getCookie(cookie_name_);\n        \n        //cookie_string_ = '{\"rp_package\":\"Free\",\"rp_email\":\"jordan.enchev.ext@racingpost.com\",\"rp_md5cookie\":\"b2b0d112439ce46a8f425f0398e28068\"}';\n        \n        var object_string_ = decodeURIComponent(cookie_string_ ? cookie_string_ : encodeURIComponent('{}'));\n\n        var object_ = JSON.parse(object_string_);\n        \n        return object_;\n    }\n\n    var RDSP_cookie_ = getCookieObject('RDSP');\n    var RFPV_cookie_ = getCookieObject('PathforaPageView'); \n\n    consoleLog('RDSP_cookie', RDSP_cookie_);\n    consoleLog('RFPV_cookie', RFPV_cookie_);\n    */\n\n    function showState()\n    {\n        consoleLog('.showState()', state_);\n\n        validateAll();\n\n        pageShowState();\n        buttonsShowState();\n        backgroundsShowState();\n        inputsShowState();\n\n        onShowAction();\n    }\n\n    function pageShowState()\n    {\n        consoleLog('.pageShowState()');\n\n        var state_item_;\n\n        var index_;\n        var length_ = states_.length;\n\n        for(index_ = 0; index_ < length_; index_++) \n        {\n            state_item_ = states_[index_];\n\n            if (state_item_ == state_) continue;\n\n            box_.toggleClass(state_item_ + '_size', false);\n\n            box_.find('.' + state_item_).hide();\n        }\n\n        box_.toggleClass(state_ + '_size', true);\n\n        box_.find('.' + state_).show();\n        box_.find('.' + state_).fadeIn();\n\n        content_.toggleClass('align_left'   , state_ == 'register');\n        content_.toggleClass('align_right'  , state_ == 'login' || state_ == 'reset' || state_ == 'reset_done');\n    }\n\n    function buttonsShowState()\n    {\n        consoleLog('.buttonsShowState()');\n\n        var button_name_;\n        var button_on_state_;\n        var button_;\n\n        var index_;\n        var length_ = buttons_names_.length;\n\n        for(index_ = 0; index_ < length_; index_++) \n        {\n            button_name_        = buttons_names_[index_];\n            button_             = buttons_[index_];\n\n            button_on_state_    = button_name_;\n\n            if (button_name_ == 'back')\n            {\n                button_on_state_  = state_ == 'terms_and_conditions' ? state_ : '';\n            }\n\n            if (button_name_ == 'login')\n            {\n                button_on_state_  = state_ == 'reset' || state_ == 'reset_done' ? state_ : button_name_;\n            }\n\n            button_.toggleClass('button_selected', button_on_state_ == state_);\n\n            selector_underline_.toggleClass(button_name_ + '_size_position', button_on_state_ == state_);\n        }\n\n        selector_underline_.toggleClass('full_size_position', state_ == 'register_done');\n        (state_ == 'terms_and_conditions') || (state_ == 'register_done') ? vertical_separator_.hide() : vertical_separator_.show();\n\n        if (state_ == 'register_done')\n        {\n            button_login_.fadeOut();\n            button_register_.fadeOut();\n            button_back_.fadeOut();\n\n            return;\n        }\n\n        if (state_ == 'terms_and_conditions')\n        {\n            button_login_.fadeOut();\n            button_register_.fadeOut();\n\n            button_back_.fadeIn();\n\n            return;\n        } \n\n        button_login_.fadeIn();\n        button_register_.fadeIn();\n        \n        button_back_.fadeOut();\n    }\n\n    function backgroundsShowState()\n    {\n        consoleLog('.backgroundsShowState()');\n\n        var fade_duration_ = 250;\n\n        (state_ == 'login' || state_ == 'reset' || state_ == 'reset_done') ? background_login_.fadeIn(fade_duration_) : background_login_.fadeOut(fade_duration_);\n\n        state_ == 'register'        ?  background_register_.fadeIn(fade_duration_)      : background_register_.fadeOut(fade_duration_);\n        state_ == 'register_done'   ?  background_registered_.fadeIn(fade_duration_)    : background_registered_.fadeOut(fade_duration_);\n    }\n\n    function inputsShowState()\n    {\n        consoleLog('.inputsShowState()');\n\n        var should_show_email_ = state_ == 'register' || state_ == 'login' || state_ == 'reset';\n\n        should_show_email_ ? email_.parent().show('fast') : email_.parent().hide('fast');\n\n        var should_show_password_ = state_ == 'register' || state_ == 'login';\n\n        should_show_password_ ? password_.parent().show('fast') : password_.parent().hide('fast');\n\n        var should_show_forgotten_password_ = state_ == 'login';\n\n        should_show_forgotten_password_ ? forgotten_password_.show('fast') : forgotten_password_.hide('fast');\n\n        var should_show_action_button_ = state_ != 'terms_and_conditions';\n\n        should_show_action_button_ ? action_button_.show('fast') : action_button_.hide('fast');\n\n        state_ == 'register' ? register_input_.show('fast') : register_input_.hide('fast');\n    }\n\n    function showRegister()\n    {\n        consoleLog('.showRegister()');\n\n        state_ = 'register';\n\n        showState();\n    }\n\n    function showRegisterDone()\n    {\n        consoleLog('.showRegisterDone()');\n\n        state_ = 'register_done';\n\n        showState();\n    }\n\n    function showLogin()\n    {\n        consoleLog('.showLogin()');\n\n        state_ = 'login';\n\n        showState();\n    }\n\n    function showReset()\n    {\n        consoleLog('.showReset()');\n\n        state_ = 'reset';\n\n        showState();\n    }\n\n    function showResetSent()\n    {\n        consoleLog('.showResetSent()');\n\n        state_ = 'reset_done';\n\n        showState();\n    }\n\n    function showTermsAndConditions()\n    {\n        consoleLog('.showTermsAndConditions()');\n\n        state_ = 'terms_and_conditions';\n\n        showState();\n    }\n\n    function onForgottenPassword()\n    {\n        consoleLog('.onForgottenPassword()');\n\n    }\n\n    function onAction(target_)\n    {\n        consoleLog('.onAction() state: ', state_, target_);\n\n        if (action_button_loading_) return;\n\n        var actions_ = {\n            'register'      : register,\n            'register_done' : close,\n            'login'         : login,\n            'reset'         : reset,\n            'reset_done'    : close\n        };\n\n        showSpinner();\n\n        actions_[state_]();\n    }\n\n    function showSpinner()\n    {\n        consoleLog('.showSpinner()');\n\n        action_button_loading_ = true;\n\n        action_button_text_.hide();\n        action_button_spinner_.show();\n\n        hideSignInUpErrors();\n    }\n\n    function hideSpinner()\n    {\n        consoleLog('.hideSpinner()');\n\n        action_button_loading_ = false\n\n        action_button_text_.show();\n        action_button_spinner_.hide();\n    }\n\n    function hideSignInUpErrors()\n    {\n        consoleLog('.hideSignInUpErrors()');\n\n        sign_in_error_.hide();\n        sign_up_error_.hide();\n    }\n\n    function onShowAction()\n    {\n        consoleLog('.onShowAction()');\n\n        var actions_ = {\n            'register'      : 'Register',\n            'register_done' : 'Close',\n            'login'         : 'Login',\n            'reset'         : 'Reset password',\n            'reset_done'    : 'Close'\n        };\n\n        action_button_text_.text(actions_[state_]);\n    }\n\n    function open(is_debug_)\n    {\n        DEBUG = is_debug_;\n\n        consoleLog('.open() is_debug: ' + is_debug_);\n\n        if (auth_api_.checkForAccess())\n        {\n            consoleLog('.open() user is already logged in');\n\n            return;\n        }\n\n        /*\n        if (RFPV_cookie_ < 3)\n        {\n            consoleLog('.open() show only on 3 or more page views');\n\n            return;\n        }\n        */\n\n        showRegister();\n\n        mandatory_.fadeIn();\n    }\n\n    function close()\n    {\n        consoleLog('.close()');\n\n        mandatory_.fadeOut();\n    }\n\n    function login()\n    {\n        consoleLog('.login()');\n\n        if (!validateAll(true)) return;\n\n        var back_url_                           = undefined;\n        var onSignInSuccess_                    = function(email_) { consoleLog('.login() -> success email: ' + email_); return auth_api_.onSignInSuccess(email_); };\n        var onSignInError_                      = function() { consoleLog('.login() -> sign error'  ); hideSpinner(); sign_in_error_.show(); };\n        var showForgottenPasswordDialog_        = function() { consoleLog('.login() -> forotten'    ); hideSpinner(); auth_api_.showForgottenPass();   close(); };\n        var goToEmailVerification_              = function(account_id_) { consoleLog('.login() -> unverified account_id: ' + account_id_); hideSpinner(); auth_api_.showEmailVerification(email_.val(), account_id_); close(); };\n        var dispatchSetEmailVerificationData_   = null;\n        var showErrorDialog_                    = function() { consoleLog('.login() -> error'       ); hideSpinner(); auth_api_.showError();           close(); };\n        var onSignInLoadComplete_               = function() { consoleLog('.login() -> load done'   ); hideSpinner(); };\n\n        auth_api_.performSignIn(\n            email_.val(), \n            password_.val(),\n            back_url_, \n            onSignInError_,\n            onSignInLoadComplete_,\n            onSignInSuccess_,\n            showForgottenPasswordDialog_,\n            goToEmailVerification_,\n            dispatchSetEmailVerificationData_,\n            showErrorDialog_\n        );\n    }\n\n    function reset()\n    {\n        consoleLog('.reset()');\n\n        if (!validateAll(true)) return;\n\n        var back_url_                       = undefined;\n        var onPasswordResetSuccess_         = function() { consoleLog('.reset() -> success'     ); hideSpinner(); showResetSent(); };\n        var onPasswordResetError_           = function() { consoleLog('.reset() -> error'       ); hideSpinner(); auth_api_.showError(); close(); };\n        var onPasswordResetLoadComplete_    = function() { consoleLog('.reset() -> load done'   ); hideSpinner(); };\n\n        auth_api_.performPasswordReset(\n            email_.val(),\n            back_url_,\n            onPasswordResetSuccess_,\n            onPasswordResetError_,\n            onPasswordResetLoadComplete_\n        );\n    }\n\n    function register()\n    {\n        consoleLog('.register()');\n\n        if (!validateAll(true)) return;\n\n        var should_recieve_mails_   = recieve_mails_.prop('checked');\n        var is_over_18_             = over_18_.prop('checked');\n\n        var options_ = {\n            horseBetting    : should_recieve_mails_,\n            horseNews       : should_recieve_mails_,\n            bloodstock      : should_recieve_mails_,\n            sportBetting    : should_recieve_mails_,\n            competitions    : should_recieve_mails_,\n            eighteenYears   : is_over_18_,\n            termsConditions : true,\n        };\n\n        var onSignUpError_          = function() { consoleLog('.register() -> sign up error'); hideSpinner(); sign_up_error_.show(); };\n        var onSignUpLoadComplete_   = function() { consoleLog('.register() -> load done'    ); hideSpinner(); };\n        var showErrorDialog_        = function() { consoleLog('.register() -> error dialog' ); hideSpinner(); auth_api_.showError(); close(); };\n        var onSignUpSuccess_        = function(email_, options_) { consoleLog('.register() -> succcess'); hideSpinner(); auth_api_.onSignUpSuccess(email_, options_); showRegisterDone(); };\n\n        auth_api_.performSignUp(\n            email_.val(),\n            password_.val(), \n            options_,\n            onSignUpError_,\n            onSignUpLoadComplete_,\n            showErrorDialog_,\n            onSignUpSuccess_\n        );\n    }\n\n    function onChange()\n    {\n        consoleLog('.onChange()');\n\n        validateAll();\n    }\n\n    function combinationsOf(values_)\n    {\n        var combinations_ = [];\n        var permutations_;\n\n        var no_repeat_;\n\n        var index_;\n        var index_;\n        var length_ = values_.length;\n\n        for(index_ = 1; index_ <= length_; index_++)\n        {\n            permutations_   = permutationsOf(values_, index_, no_repeat_ = true);\n\n            combinations_   = combinations_.concat(permutations_);\n        }\n\n        return combinations_;\n    }\n\n    function addNexpermValue(permutations_, values_, position_, of_n_, permutation_, no_repeat_)\n    {\n        if (position_ == of_n_) \n        {\n            permutations_.push(permutation_);\n\n            return;\n        }\n\n        var value_;\n        var index_;\n        var length_ = values_.length;\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            value_ = values_[index_];\n\n            if (no_repeat_ && permutation_.indexOf(value_) != -1) continue;\n\n            permutation_[position_] = value_;\n\n            addNexpermValue(permutations_, values_, position_ + 1, of_n_, permutation_.concat(), no_repeat_);\n        }\n    }\n\n    function permutationsOf(values_, of_n_, no_repeat_)\n    {\n        var permutations_ = [];\n\n        var index_;\n        var length_ = values_.length;\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            addNexpermValue(permutations_, values_, 0, of_n_, [], no_repeat_);\n        }\n\n        return permutations_;\n    }\n\n    function removeCombinationOfClassesFrom(classes_, delimiter_, end_, element_)\n    {\n        var combinations_ = combinationsOf(classes_);\n\n        //consoleLog(combinations_);\n\n        var class_;\n\n        var index_;\n        var length_ = combinations_.length;\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            class_ = combinations_[index_].join(delimiter_) + end_;\n\n            //consoleLog('| ' + class_);\n\n            element_.toggleClass(class_, false);\n        }\n    }\n\n    function validate(input_, validator_, is_strong_)\n    {\n        //consoleLog('.validate() input: ',input_);\n\n        var is_valid_ = validator_(input_, is_strong_);\n\n        if (is_strong_ && (is_valid_ == null)) is_valid_ = false;\n\n        consoleLog('.validate() input: ', input_, ' is_valid: ' + is_valid_ + ' is_strong: ' + is_strong_);\n\n        return is_valid_;\n    }\n\n    function validateEmail(value_)\n    {\n        consoleLog('.validateEmail() value: ' + value_);\n\n        if (!value_) return is_valid_ = null;\n\n        var email_validator_ = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9]{2}(?:[a-z0-9-]*[a-z0-9])?$/i;\n\n        var is_valid_ = email_validator_.test(value_);\n\n        return is_valid_;\n    }\n\n    function validatePassword(value_)\n    {\n        consoleLog('.validatePassword() value: ' + value_);\n\n        if (!value_) return is_valid_ = null;\n\n        var passowrd_validator_ = new RegExp('(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');\n        \n        var is_valid_ = passowrd_validator_.test(value_);\n\n        return is_valid_;\n    }\n\n    function validateConfirmPassword(value_, other_value_)\n    {\n        consoleLog('.validateConfirmPassword() value: ' + value_ + ' other_value: ' + other_value_);\n\n        var is_valid_ = value_ == other_value_;\n\n        if (other_value_ == '') return null;\n\n        return is_valid_;\n    }\n\n    function validateIsSelected(input_, is_strong_)\n    {\n        // consoleLog('.validateIsSelected() input: ' + input_);\n\n        var is_checked_ = input_.prop('checked');\n\n        consoleLog('.validateIsSelected()  input: ', input_,' is_checked: ' + is_checked_ + ' is_strong: ' + is_strong_);\n\n        var is_valid_   = is_checked_;\n\n        if (!is_strong_ && !is_valid_) is_valid_ = true;\n\n        return is_valid_;\n    }\n\n    function resetField(input_, name_)\n    {\n        consoleLog('.resetField() name: '+ name_);\n\n        var ok_     = input_.parent().find('.ok');\n        var not_ok_ = input_.parent().find('.not_ok');\n\n        input_.toggleClass('valid'     , false);\n        input_.toggleClass('invalid'   , false);\n\n        not_ok_.hide();\n        ok_.hide();\n\n        input_.parent().toggleClass('invalid'   , false);\n        input_.parent().toggleClass('valid'     , false);\n    }\n\n    function updateFieldView(input_, name_, is_valid_, is_valid_overal_, is_strong_)\n    {\n        consoleLog('.updateFieldView()  name: '+ name_,' is_valid: ' + is_valid_ + ' is_valid_overal: ' + is_valid_overal_ + ' is_strong: ' + is_strong_);\n\n        resetField(input_, name_);\n\n        var ok_     = input_.parent().find('.ok');\n        var not_ok_ = input_.parent().find('.not_ok');\n\n        if (is_valid_ == null)\n        {\n            is_valid_ = true;\n\n        } else {\n\n            if (is_strong_ || !is_valid_overal_ || (is_valid_overal_ && name_ != undefined)) \n            {\n                input_.toggleClass('valid'     , is_valid_);\n                input_.toggleClass('invalid'   , !is_valid_);\n\n            } else if (is_valid_overal_ && name_ == undefined) {\n                is_valid_ = true;\n            }\n\n            is_valid_   ? not_ok_.hide() : not_ok_.show();\n            !is_valid_  ? ok_.hide()     : ok_.show();\n        }\n\n        updateErrorView(input_, is_valid_, is_valid_overal_);\n\n        return is_valid_;\n    }\n\n    function updateErrorView(input_, is_valid_, is_valid_overal_)\n    {\n        var error_ = input_.parent().find('.error');\n\n        if (error_.length == 0 ) \n        {\n            if (is_valid_overal_ && !is_valid_)\n            {\n                input_.parent().toggleClass('invalid'   , true);\n                input_.parent().toggleClass('valid'     , false);\n            }  else if (is_valid_overal_ && is_valid_)\n            {\n                input_.parent().toggleClass('invalid'   , false);\n                input_.parent().toggleClass('valid'     , true);\n            } else {\n                input_.parent().toggleClass('invalid'   , !is_valid_);\n                input_.parent().toggleClass('valid'     , is_valid_);\n            }\n        }\n\n        is_valid_ ? error_.hide() : error_.show();\n    }\n\n    function setInputIsValid(input_, is_valid_)\n    {\n        input_.toggleClass('valid'     , is_valid_);\n    }\n\n    function validateAll(is_strong_)\n    {\n        consoleLog('.validateAll() is_strong: ' + is_strong_);\n\n        var validations_ = [\n            {\n                'name'      : 'email',\n                'input'     : email_,\n                'validator' : function() {return validateEmail(email_.val());}\n            },\n            {\n                'is_enabled': state_ == 'register' || state_ == 'login',\n                'name'      : 'password',\n                'input'     : password_,\n                'validator' : function() {return validatePassword(password_.val());}\n            },\n            {\n                'is_enabled': state_ == 'register',\n                'name'      : 'confirm_password',\n                'input'     : confirm_password_,\n                'validator' : function() {return validateConfirmPassword(password_.val(), confirm_password_.val());}\n            },\n            {\n                'is_enabled': state_ == 'register',\n                'input'     : accepts_terms_,\n                'validator' : function() {return validateIsSelected(accepts_terms_, is_strong_);}\n            } \n        ];\n\n        var possible_errors_ = validations_.map(function(value_) {\n            return value_.name;\n        });\n\n        possible_errors_ = possible_errors_.filter(function(value_) {\n            return value_ !== undefined}\n        );\n\n        consoleLog('.validateAll() possible_errors: ', possible_errors_);\n\n        var name_;\n        var input_;\n        var validation_;\n        var validator_;\n        var is_valid_;\n        var is_valid_overal_ = true;\n\n        var errors_ = [];\n\n        var index_;\n        var length_ = validations_.length\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            validation_ = validations_[index_];\n\n            if (validation_.is_enabled === false) continue;\n\n            name_       = validation_.name;\n            input_      = validation_.input;\n            validator_  = validation_.validator;\n\n            is_valid_   = validate(input_, validator_, is_strong_);\n\n            is_valid_   = updateFieldView(input_, name_, is_valid_, is_valid_overal_, is_strong_);\n\n            if (!is_valid_ && name_) errors_.push(name_);\n\n            is_valid_overal_ = is_valid_overal_ && is_valid_;\n        }\n\n        removeCombinationOfClassesFrom(possible_errors_, '_', '_error', box_);\n\n        consoleLog('.validateAll() errors: ' + errors_);\n\n        if (errors_.length > 0) box_.toggleClass(errors_.join('_') + '_error', !is_valid_overal_);\n\n        if (!is_valid_overal_) hideSpinner();\n\n        hideSignInUpErrors();\n\n        consoleLog('.validateAll() is_valid_overal: ' + is_valid_overal_);\n\n        return is_valid_overal_;\n    }\n\n    var mandatory_              = $('.mandatory_login');\n    var box_                    = mandatory_.find('.box');\n    var content_                = box_.find('.content');\n\n    var email_                  = box_.find('.email');\n    var password_               = box_.find('.password');\n    var confirm_password_       = box_.find('.confirm_password');\n\n    var register_input_         = box_.find('.register_input');\n    var recieve_mails_          = box_.find('.recieve_mails input');\n    var over_18_                = box_.find('.over_18 input');\n    var accepts_terms_          = box_.find('.accepts_terms input');\n\n    var forgotten_password_     = box_.find('.forgotten_passoword');\n    var terms_and_conditions_   = box_.find('.go_to_terms_and_conditions');\n    var action_button_          = box_.find('.action_button');\n    var action_button_text_     = box_.find('.action_button_text');\n    var action_button_spinner_  = box_.find('.action_button_spinner');\n    var sign_in_error_          = box_.find('.sign_in_error');\n    var sign_up_error_          = box_.find('.sign_up_error');\n    var action_button_loading_  = false;\n\n    var background_login_       = box_.find('.background_login');\n    var background_register_    = box_.find('.background_register');\n    var background_registered_  = box_.find('.background_registered');\n\n    var button_login_           = box_.find('.button_login');\n    var button_register_        = box_.find('.button_register');\n    var button_back_            = box_.find('.button_back');\n\n    var selector_underline_     = box_.find('.selector_underline');\n    var vertical_separator_     = box_.find('.vertical_separator');\n\n    var state_                  = 'register';\n    var states_                 = ['register', 'register_done', 'login', 'reset', 'reset_done', 'terms_and_conditions'];\n\n    var buttons_names_          = ['register'       , 'login'           , 'back'        ];\n    var buttons_                = [button_register_ , button_login_     , button_back_  ];\n\n    button_login_.on(           'click', showLogin      );\n    button_register_.on(        'click', showRegister   );\n    button_back_.on(            'click', showRegister   );\n\n    action_button_.on(          'click', onAction       );\n\n    forgotten_password_.on(     'click', showReset              );\n    terms_and_conditions_.on(   'click', showTermsAndConditions );\n\n    email_.on(                  'input', onChange);\n    password_.on(               'input', onChange);\n    confirm_password_.on(       'input', onChange);\n\n    recieve_mails_.change(      onChange);\n    over_18_.change(            onChange);\n    accepts_terms_.change(      onChange);\n\n    auth_api_.MandatoryLoginOverlay.open = open;\n\n})(global.authApi);\n/* eslint-enable */\n"

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getHtml = undefined;

var _loginRaw = __webpack_require__(361);

var _loginRaw2 = _interopRequireDefault(_loginRaw);

var _register_contentRaw = __webpack_require__(362);

var _register_contentRaw2 = _interopRequireDefault(_register_contentRaw);

var _register_done_contentRaw = __webpack_require__(363);

var _register_done_contentRaw2 = _interopRequireDefault(_register_done_contentRaw);

var _login_contentRaw = __webpack_require__(364);

var _login_contentRaw2 = _interopRequireDefault(_login_contentRaw);

var _reset_contentRaw = __webpack_require__(365);

var _reset_contentRaw2 = _interopRequireDefault(_reset_contentRaw);

var _reset_done_contentRaw = __webpack_require__(366);

var _reset_done_contentRaw2 = _interopRequireDefault(_reset_done_contentRaw);

var _background_loginPngRaw = __webpack_require__(367);

var _background_loginPngRaw2 = _interopRequireDefault(_background_loginPngRaw);

var _background_registerPngRaw = __webpack_require__(368);

var _background_registerPngRaw2 = _interopRequireDefault(_background_registerPngRaw);

var _background_registeredPngRaw = __webpack_require__(369);

var _background_registeredPngRaw2 = _interopRequireDefault(_background_registeredPngRaw);

var _register_successPngRaw = __webpack_require__(370);

var _register_successPngRaw2 = _interopRequireDefault(_register_successPngRaw);

var _terms_and_conditionsRaw = __webpack_require__(371);

var _terms_and_conditionsRaw2 = _interopRequireDefault(_terms_and_conditionsRaw);

var _stylesRaw = __webpack_require__(372);

var _stylesRaw2 = _interopRequireDefault(_stylesRaw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var getHtml = exports.getHtml = function getHtml() {
	var html = _loginRaw2.default.replace('%REGISTER_CONTENT%', _register_contentRaw2.default);
	html = html.replace('%REGISTER_DONE_CONTENT%', _register_done_contentRaw2.default);

	html = html.replace('%LOGIN_CONTENT%', _login_contentRaw2.default);

	html = html.replace('%RESET_CONTENT%', _reset_contentRaw2.default);
	html = html.replace('%RESET_DONE_CONTENT%', _reset_done_contentRaw2.default);

	html = html.replace('%TERMS_AND_CONDITIONS%', _terms_and_conditionsRaw2.default);

	// images
	html = html.replace('%BACKGROUND_LOGIN%', _background_loginPngRaw2.default);
	html = html.replace('%BACKGROUND_REGISTER%', _background_registerPngRaw2.default);
	html = html.replace('%BACKGROUND_REGISTERED%', _background_registeredPngRaw2.default);
	html = html.replace('%REGISTER_SUCCESS%', _register_successPngRaw2.default);

	html += '<style type="text/css">' + "\n" + _stylesRaw2.default + "\n" + '</style>';

	return html;
};
/* eslint-enable */

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mandatory_login\" style=\"display:none;\">\n\n\t<div class=\"overlay\" ></div>\n\n\t<div class=\"box\">\n\n\t\t<div class=\"form\">\n\n\t\t\t<div class=\"content\">\n\n\t\t\t\t<img class=\"background_login\" \t\talt=\"background login\" \t\tsrc=\"%BACKGROUND_LOGIN%\" />\n\t\t\t\t<img class=\"background_register\" \talt=\"background register\" \tsrc=\"%BACKGROUND_REGISTER%\" />\n\t\t\t\t<img class=\"background_registered\" \talt=\"background registered\" src=\"%BACKGROUND_REGISTERED%\" />\n\n\t\t\t\t<div class=\"sub_content\">\n\n\t\t\t\t\t<div class=\"register\"\t\t>%REGISTER_CONTENT%</div>\n\t\t\t\t\t<div class=\"register_done\"\t>%REGISTER_DONE_CONTENT%</div>\n\t\t\t\t\t<div class=\"login\"\t\t\t>%LOGIN_CONTENT%</div>\n\t\t\t\t\t<div class=\"reset\" \t\t\t>%RESET_CONTENT%</div>\n\t\t\t\t\t<div class=\"reset_done\" \t>%RESET_DONE_CONTENT%</div>\n\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<div class=\"field field_email\">\n\t\t\t\t\t\t\t<input class=\"email\" name=\"email\" type=\"email\" placeholder=\"Email\" onfocus=\"this.placeholder=''\" onblur=\"this.placeholder='Email'\"/>\n\t\t\t\t\t\t\t<div class=\"error invalid\">Please use a valid email adress</div>\n\n\t\t\t\t\t\t\t<div class=\"ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#78BE20\" fill-rule=\"nonzero\" />\n\t\t\t\t\t\t\t\t\t\t<path d=\"M0 0h12.727v12.727H0z\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.38 8.852L3.254 6.858l-.709.664 2.835 2.66 6.075-5.699-.71-.665z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"not_ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 11 11\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"5.5\" cy=\"5.5\" r=\"5.5\" fill=\"#EE4341\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" d=\"M5.944 5.5l1.778 1.778-.444.444L5.5 5.944 3.722 7.722l-.444-.444L5.056 5.5 3.278 3.722l.444-.444L5.5 5.056l1.778-1.778.444.444L5.944 5.5z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"field field_password\">\n\t\t\t\t\t\t\t<input class=\"password\" name=\"password\" type=\"password\" placeholder=\"Password\" onfocus=\"this.placeholder=''\" onblur=\"this.placeholder='Password'\"/>\n\t\t\t\t\t\t\t<div class=\"error invalid\">\n\t\t\t\t\t\t\t\t<strong>Please use a valid password:</strong><br />\n\t\t\t\t\t\t\t\t• Contain at least 1 number <br />\n\t\t\t\t\t\t\t\t• Contain an upper and lower case character <br />\n\t\t\t\t\t\t\t\t• Be at least 8 characters long\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#78BE20\" fill-rule=\"nonzero\" />\n\t\t\t\t\t\t\t\t\t\t<path d=\"M0 0h12.727v12.727H0z\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.38 8.852L3.254 6.858l-.709.664 2.835 2.66 6.075-5.699-.71-.665z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"not_ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 11 11\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"5.5\" cy=\"5.5\" r=\"5.5\" fill=\"#EE4341\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" d=\"M5.944 5.5l1.778 1.778-.444.444L5.5 5.944 3.722 7.722l-.444-.444L5.056 5.5 3.278 3.722l.444-.444L5.5 5.056l1.778-1.778.444.444L5.944 5.5z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"forgotten_passoword\">Forgot password?</div>\n\n\t\t\t\t\t\t<div class=\"register_input\">\n\n\t\t\t\t\t\t\t<div class=\"field field_confirm_password\">\n\t\t\t\t\t\t\t\t<input class=\"confirm_password\" name=\"confirm_password\" type=\"password\" placeholder=\"Confirm Password\" onfocus=\"this.placeholder=''\" onblur=\"this.placeholder='Confirm Password'\"/>\n\t\t\t\t\t\t\t\t<div class=\"error invalid\">Passwords do not match</div>\n\n\t\t\t\t\t\t\t\t<div class=\"ok\">\n\t\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n\t\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t\t\t<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#78BE20\" fill-rule=\"nonzero\" />\n\t\t\t\t\t\t\t\t\t\t\t<path d=\"M0 0h12.727v12.727H0z\" />\n\t\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.38 8.852L3.254 6.858l-.709.664 2.835 2.66 6.075-5.699-.71-.665z\" />\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"not_ok\">\n\t\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 11 11\">\n\t\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t\t\t<circle cx=\"5.5\" cy=\"5.5\" r=\"5.5\" fill=\"#EE4341\" />\n\t\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" d=\"M5.944 5.5l1.778 1.778-.444.444L5.5 5.944 3.722 7.722l-.444-.444L5.056 5.5 3.278 3.722l.444-.444L5.5 5.056l1.778-1.778.444.444L5.944 5.5z\" />\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"info_text smaller recieve_mails specBox\">\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"recieve_mails\" \tvalue=\"\" />\n\t\t\t\t\t\t\t\t<span class=\"checkmark\"></span>\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\tSubscribe to emails and receive free tipping&nbsp;advice,&nbsp;news and special&nbsp;offers\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"info_text smaller over_18 specBox\">\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"over_18\" value=\"\" />\n\t\t\t\t\t\t\t\t<span class=\"checkmark\"></span>\n\t\t\t\t\t\t\t\t<div>I am over the age of 18</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"info_text smaller accepts_terms specBox\">\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"accepts_terms\" value=\"\" />\n\t\t\t\t\t\t\t\t<span class=\"checkmark\"></span>\n\t\t\t\t\t\t\t\t<div>I accept the <span class=\"go_to_terms_and_conditions\">Terms and Conditions</span></div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"terms_and_conditions info_text\">%TERMS_AND_CONDITIONS%</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=\"button_register\"\t>Register\t</div>\n\t\t<div class=\"button_login\"\t\t>Login\t\t</div>\n\n\t\t<div class=\"button_back button_selected\">\n\n\t\t\t<div class=\"left_arrow\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"21\" viewBox=\"0 0 13 21\">\n\t\t\t\t\t<path fill=\"#0072DD\" fill-rule=\"evenodd\" d=\"M0 10.5L10.5 0l2 2L4 10.5l8.5 8.5-2 2z\" />\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<span>Back</span>\n\n\t\t</div>\n\n\t\t<div class=\"selector_underline\"></div>\n\n\t\t<div class=\"vertical_separator\"></div> \n\n\t\t<div class=\"sign_in_error error\">Your details are incorrect. Please try again.</div>\n\t\t<div class=\"sign_up_error error\">The email is already in use.</div>\n\n\t\t<div class=\"action_button\">\n\t\t\t<div class=\"action_button_text\"></div>\n\t\t\t<div class=\"action_button_spinner\">\n\t\t\t\t<svg class=\"ui-icon ui-icon_sizeLarge ui-animation_spinnerAnimation\" viewBox=\"0 0 100 100\">\n\t\t\t\t\t<path fill=\"#E3E7EA\" d=\"M50,3.1C24.1,3.1,3.1,24.1,3.1,50c0,25.9,21,46.9,46.9,46.9s46.9-21,46.9-46.9C96.9,24.1,75.9,3.1,50,3.1z\n\t\t\t\t\t\tM50,90.6C27.6,90.6,9.4,72.4,9.4,50S27.6,9.4,50,9.4S90.6,27.6,90.6,50S72.4,90.6,50,90.6z\"></path>\n\t\t\t\t\t<path fill=\"#0073DE\" d=\"M21.6,21c3.8-3.7,8.4-6.7,13.4-8.7l-2.4-5.8c-5.8,2.3-11,5.7-15.4,10L21.6,21z\"></path>\n\t\t\t\t\t<path fill=\"#0073DE\" d=\"M83.4,82.8L79,78.5c-3.7,3.7-8,6.8-12.9,8.9l2.3,5.8C74.1,90.7,79.2,87.2,83.4,82.8z\"></path>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"form_cap\"></div>\n\n\t</div>\n\n</div>\n"

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Please register to access<br/>racingpost.com for free</div>\n<div class=\"info_text small\">Don't worry, registration is quick and easy.<br/>You'll also stay signed in for 30 days.</div>\n"

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = "<div class=\"register_done_title\"><!--<img alt=\"register success\" src=\"%REGISTER_SUCCESS%\" />-->Almost there</div>\n\n<div class=\"info_text middle\">We've now sent a link to the email you just provided us. Please click on it to verify that address and you're all done.</div>\n"

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Please login to access<br/> racingpost.com for free</div>\n<div class=\"info_text small\">Don't worry, login is quick and easy.<br/>You'll also stay signed in for 30 days.</div>\n<br/>"

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Please enter your email<br/>to reset your password</div>\n"

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Mail has been sent.<br/> Please follow instructions<br/> to complete the process</div>\n"

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAABAlBMVEUAAABftQBfsQBgtQBgtQBgtgBgtQBgtgBgtABftABctgBgtgBUuQBgtQBftQBhuABgtQBhuQBgtwBgtABhtwBhtQBhtgBhtwBhtwBhuABgtQBgtABftQBgtgBgtgBftQBguQBitwBctwBgtAD///9gtQBiuABbswBetABasgBjuwDw+Ob2+/Hj8tJ4wSbz+uvb78WOy0qAxDNuvBec0V9muAt8wy50vyGGxz2Exjnp9dvd8Mnu9+Ps9+CJyUL1+u34/POj1Gxzvh/m89bR6rTO6K/E5KG74JK534+43o2m1nCk1WyRzE7V7LuVzlTW7LzJ5qjJ5qff8cuv2oCf0mZitgt1nNt5AAAAJHRSTlMAag3S972lhzsuEdcG5Sb8+/dvZl9848+79O/vwsGSU1AnJ30aeuDLAAAELUlEQVRYw6SV2XKiQBiFQRBR4262yV7VNIuoqKAmZpIYdzPZat7/XeZ0NGEYB0PLuaCKbuqr868I3ypzpZaVMyknyznpTCmrVxkhnhJpUZFOKKR9iEInkiKmE7sS99KpwyK1AAyI4qh4mErv7WKyeiRbjGfopm4YK6Dx8cLIlnxU5bWbESVqrYheuzWcTZ4Ho9HgeTIbttreimtRSczwBF7JMpOGqTXcad0mAdn1qdvQTIPZzVYiJ0FNUobUO+7YBwbBY7ejMyw9UqMlM3VsMWRjfku26HbeYFjrOBUhtfmkRYHsLZrkGzUXPWCplcx/x7w4gE3dG9ZIBNWGng6zBxfbmWKJ2ew7JKKcPjNbErcx9wtgakubRJa91EAt7Iczz1F1vfNOuPTe0dEF56E+KdL56BBOOY9ILA3xKhbA7NYJt+pdUAv/zetliYJ5Q3bQDai0dLnJzOfA7Pk++bz2QM3lN+YoaWlGxyE7yukYmpX8d7ZSYGpvZGe9aaCmgkxVRvBLEkNLJEBWA7sOwevXD3GgD9c6EvD3JqxgkDyHxJLjYbQqPjOTRfBPJKaekIBsxm97VKlXiwut9VAr8audmNEFia0Fs/rZVlUYbTS5GbfDl0FwazdgtbqGstLPuZk/26bZeQ4czVkDrJhpGbNU42b2Teyf4AzWMFdy+nOYTJc79rauQeZL4NQ112OVkLBGx7zMa/hk0N+B4zEWq5Rg0RdRJpuT2YdPSP8VnEIbpSqy+EX0E2f0tb65Yr7ck6BcdJUIqILaT/mYd+vYW2AGNUX9FYwoUurVuZifsW8ySd1DUjNC/gfVu3Y8n77srk5P8oJKcc3HDPUJtUyNqkKZb0E1v5jN0FVVFhSs0ll0Zmsd+13IrphhqSrCKaCT6D7XNQpjkgmgp4KEb17j+vT1imtJyOE5iMv0NcB9TpDxHG1ePtxs/AbvwVzFvmWljfCB/Kc4a1dBIAhiIAhWFhYKoo0Wy4Inclj4Rq4+FUT//1fkdCDqaFbB4HY2Ibs3zmSSN6CL/LxZPWGWxnNmmATUru8lV8zXjzxDChPXrz7U7vmieUUq3KOOKE+c3fVD9V+UVHZd8MAVmGHOMK2k+ih+xxRcgcl4ovhf/02zsT3gjdhoH+3n6hNF0bKG4lGNWgWzLYNhrhkeGgpan+dqj7jdc0zf+tCkvTi2ZywDHpgdNGk3Thyq7fohxRPjhA2+o6GivOjB4KMj+lhEYCbXFoxoLiaWRUhiOjHRqUH2EFS+XnnZA4FGUAPj6QVaWkpOihg5Ty8l06I3m54Yphe9EnmuWCQkK49iOZOskYqFV7GaS0yE39sd7abCmFFYSBqzS2/L4QwFBqLA6lSYsnYG39vHA4XR/XNLvt74Q3hAY45DFXMcXMzx/0BGFB0h5Oo+hlzdL0IuHsf1bnFc77M47gIY8ig5ZQYHNwAAAABJRU5ErkJggg=="

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = "<b>USER TERMS & CONDITIONS (\"the Agreement\")</b>\n\n\nPLEASE READ THIS AGREEMENT CAREFULLY. IT SETS OUT THE TERMS UNDER WHICH CENTURYCOMM LIMITED TRADING AS RACING POST OFFERS YOU USE OF ITS INTERACTIVE SERVICES AS DEFINED IN CLAUSE 1.1 OF THIS AGREEMENT AND ITS WEB SITE RACING POST ONLINE LOCATED AT WWW.RACINGPOST.COM AND ITS MOBILE AND TABLET APPS, FOR EXAMPLE, ITS ANDROID, IPHONE AND IPAD APPS   (\"THE SITE\"). BY USING ANY OF THE INTERACTIVE SERVICES AND/OR THE SITE YOU AGREE THAT YOU HAVE READ AND ACCEPT THESE TERMS AND CONDITIONS AND  THAT THEY SHALL APPLY TO YOUR USE. IF YOU DO NOT WISH TO BE BOUND BY THEM, PLEASE LEAVE THIS WEB SITE.  \n\nThis Agreement is made between you and Centurycomm Limited trading as Racing Post (registered number 3387163)   whose registered office is 5 Fleet Place, London, EC4M 7RD, London, England (\"we\" or \"us\").\n\n1. Interactive Services\n\n1.1 We may make available to you on or via the Site chat areas, forums and/or other means by which communications may be made available and/or disseminated publicly; shopping and other commercial and/or transactional services including, without limitation, the supply of goods and/or services; advisory services; and/or competitions and/or prize draws (all together the \"Interactive Services\").\n\nInteractive Services also include the content on the Site which is only available by subscription (\"the Racing Post Members' Club Services\")  or the iPad App. You should visit the Terms and Conditions and the More Information about the Racing Post Members' Club section of the Site relating to the Racing Post Members' Club Services for more details about them, including access, costs and cancellation.\n\nThe information in any More Information about the Racing Post Members' Club sections of the Site,  More Information about Racing Post Members' Club Daily and Multi Day Passes as part Racing Post Members' Club Services are also incorporated into these Terms and Conditions.\n\n1.2 The Interactive Services may be operated by third parties and where they are this will be made clear to you. Where such Interactive Services are operated by a third party you may be asked to supply information and/or data (including, without limitation, financial, credit card and/or bank data), where that third party may have specific additional terms and conditions which apply. Further, when using such Interactive Services operated by such third parties, you will be dealing with them directly and as such any contracts and/or arrangements will be formed between you and them, without us as a party and we cannot be held liable for your use of or any liability arising out of the same (save to the extent required by law).\n\n2. Use of the Site and the Interactive Services\n\n2.1 The Site and the Interactive Services are for personal and non-commercial use only. You may copy electronically and print portions of the Site and/or the Interactive Services for your personal, non-commercial use only. In particular, you may not use any information from any directory or other listing or information retrieval service (if any) made available on or by the Site and/or the Interactive Services, in connection with any business or commercial undertaking (whether or not for profit). You must not display the Site or the Interactive Services or any part thereof in public. Any other use of materials on the Site and/or the Interactive Services, including User Generated Content (including without limitation reproduction for a purpose other than that noted above and any modification, distribution or republication) without our prior written permission is strictly prohibited. You also agree not to deep-link and/or frame to any of the Site for any purpose, unless specifically authorised by us to do so.\n\nYou agree that:\n\n(a) you shall not use the Site or the Interactive Services to transmit or knowingly or recklessly receive (or knowingly or recklessly authorise or permit any other person to receive or transmit) material which is obscene, threatening, menacing, offensive, defamatory, abusive, in breach of confidence, in breach of any intellectual property right (including copyright) or otherwise violates any applicable law or regulation or code, or which makes excessive demands for bandwidth or contains any virus or which may otherwise impair or harm our computer systems or any third party computer system; and\n\n(b) you will keep your password(s) if any relevant to the Site and/or the Interactive Services secure and not let them become public knowledge or be used by any third party.\n\n2.2 You agree that you will not submit any material to us (\"User Generated Content\") :\n\n(a) that is in any way, threatening, abusive, offensive, defamatory, invasive of another ‘s privacy, in breach of confidence or privacy, embarrassing to any person, hateful, blasphemous, pornographic, or racially, ethnically or otherwise objectionable;\n\n(b) in respect of which you do not have the necessary licences or approvals;\n\n(c) which constitutes or encourages conduct that would be considered a criminal offenceor otherwise contrary to any law,  regulation or code of practice, give rise to civil liability  or infringe the rights of any third party;\n\n(d) which is technically harmful;\n\n(e) which is or may be deemed to be advertising or promotional materials;\n\n(f)  collect or store other users' personal data.\n\nYou will not impersonate any person or entity when submitting User Generated Content or misrepresent any affiliation with any person or entity.\n\nWe reserve the right to require you to change your user name for any reason.\n\nYou acknowledge that we have no obligation to monitor any User Generated Content but we have the sole discretion to display, modify, distribute or delete any such User Generated Content in our sole discretion and may remove any such material at any time. Notwithstanding this, you are solely responsible for and bear the risk associated with such User Generated Content, including any reliance on the accuracy, completeness or usefulness of the same.\n\nIn the event that you are in breach of these Terms and Conditions and/or our Standards for User Generated Content at any time, we may suspend or  terminate any account that you have with us. You may not open another account with us and if you do, we reserve the right to terminate any such account. In the event that you continue to contravene these Terms and Conditions and/or the Standards for User Generated Content we reserve the right to contact your employer or your internet service provider.\n\nWe will co-operate with law enforcement or regulatory authorities or any court order requesting or requiring us to disclose the identity or location of anyone who has submitted User Generated Content to us in breach or allegedly in breach of these Terms and Conditions and/or the Standards for User Generated Content\n\nIn relation to any User Generated Content, you automatically and  hereby grant to us a perpetual, royalty free, irrevocable, non-exclusive right and licence to use, edit, reproduce, modify, publish, translate, create derivative works from and distribute such User Generated Content, in whole or on part,  in any form, medium or technology now known or hereafter developed. In addition, as between you and us, you waive any and all moral rights in such User Generated Content.\n\nPlease also see our Standards for User Generated Content which also apply to User Generated Content and which are incorporated into these Terms and Conditions. In the event that you submit any material to us for publication, you will be deemed to have accepted these Terms and Conditions and Standards.\n\nIf you see in the Site and/or the Interactive Services any material submitted by a third party user of the Site which you believe to be in breach of these Terms and Conditions and/or the Standards for User Generated Content you may report it by sending an email to help@racingpost.com. We cannot guarantee that any action will be taken as a result of your email.\n\n2.3 The intellectual property in all design, text, graphics and other material and the selection or arrangement of such material in the Site and/or the Interactive Services is owned by us and/or our respective licensors.\n\n2.4 Save to the extent required by law, we make no representations, warranties or terms of any kind including (without limitation) implied warranties as to completeness, accuracy, satisfactory quality and fitness for a particular purpose are made in respect of the Site and/or the Interactive Services or their contents (including, without limitation, any views or comment made) which are provided on an \"as is\" basis). We do not warrant that the Site and/or the Interactive Services or their contents (including, without limitation, any views or comment made) will meet your particular expectations or requirements or that they will be uninterrupted, timely, secure or error-free; nor do we make any warranty as to results or the accuracy of any information obtained by you through the Site and/or the Interactive Services or their contents (including, without limitation, any views or comment made), all of which arehereby excluded to the greatest extent permitted by law. All information and/or data included in and/or on the Site, the Interactive Services and/or in any directory or other listings or information retrieval service made available on or by the Site and/or the Interactive Services has been so made available for guidance only. Your use of such information and/or data is therefore entirely at your own risk. Nothing in these terms of use excludes or limits our liability for death or personal injury arising from our negligence, or our fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by English law. We will not be liable to any user for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:\n\n•     use of, or inability to use, our site; or\n•     use of, or reliance on, any content displayed on our site.\n\nPlease note that we only provide our site for domestic and private use. You agree not to use our site for any commercial or business purposes, and we have no liability to you for any loss of profit, loss of business, business interruption, or loss of business opportunity.\nWe will not be liable for any loss or damage caused by a virus, distributed denial-of-service attack, or other technologically harmful material that may infect your computer equipment, computer programs, data or other proprietary material due to your use of our site or to your downloading of any content on it, or on any website linked to it. We assume no responsibility for the content of websites linked on our site. Such links should not be interpreted as endorsement by us of those linked websites. We will not be liable for any loss or damage that may arise from your use of them.\n\n2.5 The Site and/or the Interactive Services may include links to web sites and/or services owned and/or operated by third parties. These are provided for your convenience only and we are not responsible for and do not give any warranties or make any representations regarding any such web sites and/or services and is not responsible for or liable in relation to the content or your use of such web sites (save to the extent required by law).\n\n2.6 We are the owner of:\n\n(a) those trade mark(s) indicated as such throughout the Site from time to time; and\n\n(b) all other trade marks used in the Site and/or the Interactive Service which are not licensed to it by any third party. All other trade marks, product names and company names or logos cited therein are the property of their respective owners\n\n2.7 The provisions in clause 5 and our Privacy Policy on Data Protection and Use of Personal Information apply in respect of your use of the Site and/or the Interactive Services.\n \n2.8 Viruses\n \n(a) We do not guarantee that our site will be secure or free from bugs or viruses. You are responsible for configuring your information technology, computer programmes and platform in order to access our site. You should use your own virus protection software. You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You must not attempt to gain unauthorized access to our site, the server on which our site is stored or any server, computer or database connected to our site. You must not attack our site via a denial-of-service attack or a distributed denial-of service attack. By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will report any such breach to the relevant law enforcement authorities and we will co-operate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our site will cease immediately.\n\n3. Availability and Security of the Site and the Interactive Service\n3.1 Due to the nature of the Internet, we do not promise full and error free operation of the Site and/or the Interactive Services at all times. All of our liability and that of our directors or employees howsoever arising for any loss whatsoever arising from your use of or inability to use the Site and/or the Interactive Services is excluded, insofar as it is possible to do so in law.\n\n3.2 Any and all information or material of whatever nature added to or stored by you on the Site (\"your material\") is so added or stored entirely at your own risk. All of our and the liability of our directors or employees in respect of the loss or deletion of your material or your inability for whatever reason to access your material is excluded to the fullest extent permitted by law.\n\n3.3 We shall use reasonable endeavours to ensure that the Site, the Interactive Services and any information it holds on you are kept secure. However, due to the nature of the Internet, we cannot accept any liability for those who intentionally attempt to and/or gain unauthorised access to the same by means such as, without limitation, computer hacking (save to the extent that we are unable to exclude such liability by law).\n\n3.4 From time to time, your access to the Site and/or the Interactive Services may be suspended in order for work to be carried out relating to upgrading or maintenance or otherwise as necessary for the provision of the Site and/or the Interactive Services. We shall endeavour to ensure that such works are carried out as expeditiously as is possible in the circumstances.\n\n4. Registration\n\nWhere you are asked to complete a registration form for us the personal details that you provide must be true, accurate and complete.\n\n5. Data Protection and Use of Personal Information\n\nFull details of the way we hold and process information  which you provide to us and/or from which we can identify you are set out in our Privacy Policy\n\n6. Payment\n\n6.1 Subject to the remainder of clause 6 below and to any charges made for Racing Post Members' Club Services or the iPad App Edition,  the Site is currently made available without charge to you by us. However, you are responsible for all telephone charges necessary to access and use the Site including, for the avoidance of doubt, the Interactive Services which are made available.\n\n6.2 In addition to the Racing Post Members' Club Services, access to some other parts of the Interactive Services is currently made available by payment only.  These include Racing Post Members' Club Daily / Multi Day Pass Services and the iPad App edition.\n\n6.3 The iPad App edition is available via iTunes.  If you have any problems with any payments in respect of the iPad App edition, please contact our Support Centre on +44 (0) 20 7748 3771.\n\n6.4 You must provide us with complete and accurate payment information. You can pay by either credit or debit card. By submitting credit or debit card payment details to us you warrant that you are entitled to purchase the Interactive Services, including  the Racing Post Members' Club Services, using those payment details. We will continue to collect these recurring payments for your subscription until you cancel the service, see 7 below. We will use the standard card Updater file service used by banks and subscription providers to collect expiring and other card details if and when these become out of date. This is done according to the UK banks procedures for collecting and distributing this data. In the case of unauthorised payments we reserve the right to suspend or terminate your access to the Interactive Services and the Racing Post Members' Club Services. If we do not receive payment authorisation or any authorisation is subsequently cancelled, we may immediately terminate or suspend your access to any Interactive Services, including the Racing Post Members' Club Services. Please ensure that your payment card details are kept up to date. If we are unable to process payment from your card, it will be necessary to suspend your access to the Interactive Services, until you provide us with details of a valid credit card. You can do this by telephoning Racing Post Customer Services on the numbers provided or by updating your card details on your www.racingpost.com ‘My Account' page. You will still be liable for any outstanding payments that could not be met when your access to the Interactive Services was suspended.\n\n6.5 We will try to process your payment promptly but this does not guarantee that the Interactive Services or the Racing Post Members' Club Services will be available to you by any specified time. A contract with you for receipt of the Interactive Services or the Racing Post Members' Club Services or Racing Post Members' Club Daily / Multi Day Pass Services will become legally binding from the time at which we take payment from you.\n\n6.6 We will charge you in British PoundsSterling or, at our discretion, in Euros, depending on the service and your country of residence. You may also have to pay any applicable local taxes.\n\n6.7  If a free trial is made available to you, you will only be charged with effect from the expiry of that free trial period. No more than one free trial per subscriber is allowed. We reserve the right without notice and at any time to terminate any free trial.\n\nIpad app edition\n\n6.8 We offer a 30 day free trial for the iPad App Edition, valid from the time you first download the iPad App if you provide us with your name and email address  and agree to these Terms and Conditions. We may use this information  to seek your feedback on the Site, including  the iPad App Edition and to notify you of new products and features and otherwise in accordance with our Privacy Policy [link] but we will not make it available to any third party. If you access the Site or the Interactive Services via the iPad App Edition as part of the free trial, then these terms and conditions will apply to you other than in relation to payment for the iPad App Edition. No more than one free trial per subscriber is allowed. We may terminate the free trial at any time for any reason and if you wish to continue to use the  iPad App Edition you will need to pay for it.\n7. Refunds, Returns & Cancellation\n\nThese Terms & Conditions relating to refunds, returns & cancellation do not affect Your Statutory Right to Cancel\n\n7.1  Refunds for all Interactive Services including Racing Post Members' Club Services\n\n(a) Any reimbursement or refund made by us in relation to Interactive Services, including Racing Post Members' Club Services will only be made to the bank account or debit/credit card used to make payment or part payment for the Interactive Services, including the Racing Post Members' Club Services concerned.  We will in no circumstances pay money to the credit of a third party or to any other bank account, debit or credit card. If we are for any reason unable to make a refund to your bank account or debit/credit card for any reason the refund will be sent by cheque to you to the address you have notified to us as part of the original registration process or any update of such address. \n\n(b) We may also charge you a reasonable sum to cover our administrative costs in processing any request for a refund.\n\n(c) We will refund to you all monies due to you in relation to your cancellation or downgrading of your subscription package within 30 days of the date on which such cancellation or downgrade takes effect.\n\nTo upgrade, downgrade please email help@racingpost.com or telephone our Customer Services team on 020 7748 3771 Monday to Saturday 8am-10pm, Sundays and bank holidays 10am-10pm.\n\nTo cancel your subscription please telephone our Members' Club subscription cancellation team on +44 (0) 1933 445177 Monday - Friday 9am-8pm.\n\n7.1 Returns Policy for books, audio, DVD and software and other items purchased from the Racing Post shop\n\n21-day Returns Policy\n\nOur 21-day returns guarantee\n\nOur 21-day returns policy guarantee means that if for any reason you are unhappy with any purchase, you can return it to us in its original condition so that we receive it within 21 days of the date you received the item, (with any seals and shrink-wrap intact in the case of audio, video or DVD or software products) and we will issue a full refund for the price you paid for the item--see our Refunds Policy in paragraph 7.2. We can only accept the return of opened items of audio, video or DVD or software products if they are faulty.\n\n7.2 Refunds Policy for books, audio, DVD and software and other items purchased from the Racing Post shop\n\nOur refunds policy for books, audio, DVD and software and other items purchased from the Racing Post shop does not affect your statutory rights.\n\nWhen you send your item back to us, we'll process the returned item then notify you via e-mail of your refund. You can expect a refund in the same form of payment originally used for purchase within three weeks of our receiving your return.\n\nFor more information on shop refunds please contact the shop team on +44 (0)19 33304 845 for further assistance.\n\n7.3  Your Statutory Right to cancel and cancellation of Racing Post Members' Club Services\n\nBy law, you have the right to cancel the contract for the purchase of goods and services within seven working days beginning with the day after the date an item is delivered. To cancel any purchase, when it consists of physical products such as books, videos, DVDs or software products, within the seven working-day period, please contact our Support Centre on +44 (0) 1933 304 858 or e-mail us at shop@racingpost.com  for advice on how to  return purchased items.\n\nHowever, we cannot accept cancellations of contracts for audio, video or DVD or software products where the item has been unsealed.\n\nAdditionally, we are unable to accept cancellation of, or make refunds for, digital items such as PDFs where the item has been downloaded or in relation to any part of the Interactive Services for which payment is required, once these Services have been accessed in respect of which you may cancel in accordance with the More Information about Member's Club Services section of the Site following which refunds will be made in accordance with paragraph 7.1.\n\nHowever, if you have not downloaded the digital item or accessed it via the Interactive Services or accessed Racing Post Members' Club Services (whether  you are a new subscriber or have upgraded or downgraded your package),  you may cancel the contract (or your upgrade or downgrade) at any time before the end of the seven working-day period by contacting  +44 (0) 2077 483 771.\n\nThis means that in relation to Racing Post Members' Club Services if you have not accessed the package to which you have subscribed (whether  you are a new subscriber or have upgraded or downgraded your package) within the seven working-day period you may cancel the contract (or your upgrade or downgrade) pursuant to your statutory right to cancel by contacting +44 (0) 207 7483 771. If you do not cancel within this time you will be able to cancel in accordance with the More Information about Member's Club Services. In both cases any refunds due to you will be paid in accordance with paragraph 7.1 and 7.1.1.\n\nYour statutory right to cancel an upgrade or downgrade does not mean that  you can cancel the whole contract.  If you cancel an upgrade or a downgrade pursuant to your statutory right to cancel you will revert to the package you were subscribed to before.\n\n8. Termination\n\n8.1 We may permanently terminate your access to the Interactive Services immediately for any reason.\n\n8.2 There is no specific time limit applying to your use of the Interactive Services on these terms and conditions. However, we reserve the right to suspend or terminate your access to the Interactive Services if you breach these terms and conditions, with or without notice and without further obligation to you.\n\n8.3  In the event that we terminate your access to the Interactive Services as a result of your breach of these Terms and Conditions or the Racing Post Members' Club Terms and Conditions there will be no refund to you of the unused portion of any Membership Fees.\n\n9. Claims\n\nWhere a claim is brought against us by a third party in relation to your use of the Site and/or the Interactive Services or any User Generated Content,  you agree to fully reimburse us and all companies within our group of companies  (i.e. companies which share the same ultimate parent company) for all losses, costs, actions, claims, damages, expenses (including reasonable legal costs and expenses) or liabilities, whatsoever suffered or incurred by us or companies within our group  (i.e. companies which share the same ultimate parent company)  in or as a consequence of your breach of this Agreement and/or your use of the Site and/or Interactive Service and/or any User Generated Content which is included in the Site and/or the Interactive Service.\n\n10. Force Majeure\n\nNeither party shall be liable to the other, for any loss or damage which may be suffered by the other party due to any cause beyond the first party's reasonable control including without limitation any power failure.\n\n11. Notices\n\nAny notices we send to you will be sent to the email address you supply during the Racing Post registration process or any updated email address. Any notices you send us should be sent by email to help@racingpost.com. Notices will be deemed to have been delivered at the time and date of sending of the email, which time and date are specified in the email.\n\nEither party may also give notice to the other by first class post to the other party's address. Any notices we send to you by first class post will be sent to the address you supply during the Racing Post registration process or any updated address. You may send notices to us at the address set out at the head of these Terms and Conditions.   Any notice sent by first class post shall be deemed (in the absence of evidence of early receipt) to have been delivered two days after posting.\n\n12. Assignment\n\n12.1 This Agreement shall be personal to you and you may not assign, transfer, sublet, lease or delegate all or any of your rights and obligations, without our prior written consent.\n\n12.2 We reserve the right to assign or transfer all or any of our rights and obligations under this Agreement to any companies in the same group (i.e. companies which share the same ultimate parent company) or another third party. In the event of assignment or transfer, notification will either be given to you by e-mail or posted on the Site.\n\n13. No Waiver\n\nFailure by either party to exercise or enforce any right conferred shall not be deemed to be a waiver of any such right nor operate so as to bar that exercise or enforcement thereof or of any other right on any later occasion.\n\n14. Entire Agreement\n\nThis Agreement, together with any other terms and conditions or other contractual terms relating to your access to or use of any Interactive Services, including, without limitation, the Racing Post Members’ Club Daily / Multi day pass services, constitutes the entire agreement between us and you with respect to this subject-matter and excludes any representations or warranties previously given or made (other than any fraudulent misrepresentation) and it may be amended only by us on notice to you.\n\n15. Variation of Terms\n\nWe reserve the right to vary this Agreement from time to time. Such changes shall either be notified to you by e-mail or posted here. We recommend you check back regularly to ensure you are aware of any changes. Changes  made in this manner shall be deemed to have been accepted if you continue to use the Site and/or the Interactive Services after the date of transmission of the e-mail or of posting here, whichever occurs later.\n\n16. Law and Jurisdiction\n\nThese Terms and Conditions and your access to and use of Site and/or the Interactive Services are subject to the laws of England and you submit to the exclusive jurisdiction of the courts of England.\n\n17. Invalidity\n\nIf the whole or any part of any provision of these Terms is or becomes invalid, void or unenforceable for any reason the same shall to the extent required be severed from these Terms and rendered ineffective so far as is possible without modifying the remaining provisions of these Terms and shall in no way affect the validity or enforceability of any other provisions.\n\n18. ThirdParty Rights\n\nThese Terms are not intended to create and shall not create any rights, entitlements, claims or benefits enforceable by any third party by virtue of the Contracts (Rights of Third Parties) Act 1999.\n"

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports = ".mandatory_login \n{\n  position  : fixed;\n  overflow  : auto;\n\n  top       : 0;\n  left      : 0;\n  \n  width     : 100%;\n  height    : 100%;\n\n  z-index   : 9999;\n}\n\n.mandatory_login div \n{\n  box-sizing: border-box;\n}\n\n.mandatory_login .overlay \n{\n  position  : fixed;\n  top       : 0;\n  left      : 0;\n\n  width     : 100%;\n  height    : 100%;\n\n  background-color: #000;\n  \n  opacity   : 0.85;\n}\n\n.mandatory_login .box \n{\n  position        : relative;\n  top             : 0px;\n  left            : 0px;\n\n  width           : 320px;\n  height          : 320px;\n  min-width       : 320px;\n\n  margin          : auto;\n  margin-top      : 100px;\n  margin-bottom   : 10px;\n\n  overflow        : hidden;\n\n  font-family     : Helvetica;\n  font-weight     : normal;\n  font-style      : normal;\n  font-stretch    : normal;\n  line-height     : normal;\n  font-size       : 18px;\n  letter-spacing  : -0.4px;\n\n  transition      : width 0.5s, height 0.5s;\n  /*transition-timing-function: ease-in-out;*/\n}\n\n.mandatory_login .box.register_size\n{\n  width     : 320px;\n  max-width : 98%;\n  min-width : 320px;\n  height    : 456px;\n}\n\n.mandatory_login .box.register_size.email_error\n{\n  height  : 470px;\n}\n\n.mandatory_login .box.register_size.password_error\n{\n  height  : 500px;\n}\n\n.mandatory_login .box.register_size.confirm_password_error\n{\n  height  : 496px;\n}\n\n.mandatory_login .box.register_size.email_password_error\n{\n  height  : 516px;\n}\n\n.mandatory_login .box.register_size.email_confirm_password_error\n{\n  height  : 530px;\n}\n\n.mandatory_login .box.register_size.email_password_confirm_password_error\n{\n  height  : 530px;\n}\n\n.mandatory_login .box.register_size.password_confirm_password_error\n{\n  height  : 530px;\n}\n\n.mandatory_login .box.register_done_size\n{\n  width   : 320px;\n  height  : 395px;\n}\n\n.mandatory_login .box.login_size\n{\n  width   : 320px;\n  height  : 360px;\n}\n\n.mandatory_login .box.login_size.email_error\n{\n  height  : 374px;\n}\n\n.mandatory_login .box.login_size.password_error\n{\n  height  : 400px;\n}\n\n.mandatory_login .box.login_size.email_password_error\n{\n  height  : 414px;\n}\n\n.mandatory_login .box.reset_size\n{\n  width   :320px;\n  height  :248px;\n}\n\n.mandatory_login .box.reset_done_size\n{\n  width   :320px;\n  height  :248px;\n}\n\n.mandatory_login .box.terms_and_conditions_size\n{\n  width     :820px;\n  max-width :98%;\n  height    :520px;\n}\n\n.mandatory_login .form_cap \n{\n  width     : 100%;\n  height    : 5px;\n  \n  position  : relative;\n  \n  top       : 0px;\n  left      : 0px;\n  \n  background-color: #d8e8f3;\n\n  border-top-left-radius  : 4px;\n  border-top-right-radius : 4px;\n\n  box-shadow: 0 1px 0 0 rgba(95, 125, 145, 0.5);\n}\n\n.mandatory_login .form\n{\n  position        : absolute;\n  height          : 100%;\n  width           : 100%;\n  top             : 0;\n  \n  background-color: #fff;\n  border-radius   : 4px;\n\n  box-shadow      : 0 2px 7px 0 rgba(0, 0, 0, 0.12);\n}\n\n.mandatory_login .content\n{\n  position      : absolute;\n  top           : 0px;\n\n  width         : 100%;\n  height        : 100%;\n\n  padding-left  : 26px;\n  padding-right : 26px;\n\n  text-align    : center;\n}\n\n.mandatory_login .terms_and_conditions_size .content\n{\n  padding-left  : 0px;\n  padding-right : 0px;\n}\n\n.mandatory_login .sub_content \n{\n  position      : relative;\n  padding-top   : 54px;\n}\n\n.mandatory_login .button_login, .mandatory_login .button_register , .mandatory_login .button_back \n{\n  position        : relative;\n  height          : 54px;\n  width           : 50%;\n\n  line-height     : 54px;\n  text-align      : center;\n  \n  color           : #cac9ca;\n\n  cursor          : pointer;\n}\n\n.mandatory_login .button_login, .mandatory_login .button_register \n{\n  float           : left;\n}\n\n.mandatory_login .button_back \n{\n  position        : absolute;\n\n  width           : 160px;\n\n  text-align      : left;\n}\n.mandatory_login .button_back span\n{\n  display         : block;\n}\n\n.mandatory_login .button_selected \n{\n  color         : #4a4a4a !important;\n}\n\n.mandatory_login .action_button \n{\n  position        : absolute;\n  bottom          : 16px;\n\n  width           : 85%;\n  height          : 40px;\n\n  margin-left     : 7.5%;\n\n  border-radius   : 4px;\n\n  background-color: #0072dd;\n\n  box-shadow      : inset 0 -3px 0 0 rgba(0, 0, 0, 0.08);\n\n  line-height     : 40px;\n  font-size       : 14px;\n  letter-spacing  : 0.3px;\n  text-align      : center;\n  color           : #ffffff;\n\n  cursor          : pointer;\n}\n\n.mandatory_login .action_button_spinner\n{\n  display         : none;\n  padding-top     : 6px;\n}\n\n.mandatory_login .selector_underline\n{\n  position          : absolute;\n  top               : 54px;\n  left              : 0;\n  height            : 2px;\n  width             : 50%;\n\n  background-color  : #0072dd;\n  \n  transition        : left 0.4s, top 0.4s;\n}\n\n.mandatory_login .selector_underline.full_size_position\n{\n  width   : 100%;\n}\n\n.mandatory_login .selector_underline.login_size_position\n{\n  left    : 50%;\n}\n\n.mandatory_login .selector_underline.register_size_position\n{\n  left    : 0;\n}\n\n.mandatory_login .selector_underline.back_size_position\n{\n  left    : 0;\n  width   : 160px;\n}\n\n.mandatory_login .vertical_separator\n{\n  position          : absolute;\n  left              : 50%;\n  top               : 8px;\n\n  width             : 1px;\n  height            : 44px;\n  opacity           : 0.1;\n  background-color  : #979797;\n}\n\n.mandatory_login .left_arrow \n{\n  margin-top  : 4px;\n  margin-left : 41px;\n  margin-right: 10px;\n\n  width       : 12.5px;\n  height      : 21px;\n\n  float       : left;\n}\n\n.mandatory_login .info_text \n{\n  color           : #4a4a4a;\n\n  padding-top     : 15px;\n  padding-bottom  : 7px;\n}\n\n.mandatory_login .info_text.middle\n{\n  font-size       : 14px;\n}\n\n.mandatory_login .register_done .info_text.middle\n{\n  padding-top: 20px;\n}\n\n.mandatory_login .info_text.small, .mandatory_login .info_text.smaller\n{\n  letter-spacing  : -0.2px;\n  color           : #9b9b9b;\n}\n\n.mandatory_login .info_text.small\n{\n  font-size       : 12px;\n\n  padding-top     : 2px;\n}\n\n.mandatory_login .info_text.smaller\n{\n  font-size       : 10px;\n\n  clear           : both;\n  padding-top     : 10px;\n  padding-bottom  : 10px;\n}\n\n.mandatory_login .info_text.smaller input\n{\n  float         : left;\n\n  margin-right  : 5px; \n  font-size     : 12px;\n\n  padding       : 10px;\n\n  color         : #9b9b9b;\n}\n\n.mandatory_login .info_text.smaller input.invalid\n{\n  border-color  : #ee4341;\n}\n\n.mandatory_login .info_text.smaller div\n{\n  float       : left;\n  margin-top  : 2px;\n  width       : 180px;\n}\n\n.mandatory_login .terms_and_conditions\n{\n  padding-left  : 24px;\n  padding-right : 24px;\n  \n  height        : 438px;\n  \n  white-space   : pre-wrap;\n  \n  text-align    : left;\n  overflow      : auto;\n}\n\n.mandatory_login .background_login\n{\n  width   :auto;\n  height  :306px;\n\n  position: absolute;\n  top     : 50px;\n  left    : 0px;\n}\n\n.mandatory_login .background_register\n{\n  width   :auto;\n  height  :387px;\n\n  position: absolute;\n  bottom  : 4px;\n  right   : 0px;\n}\n\n.mandatory_login .background_registered\n{\n  width   :auto;\n  height  :180px;\n\n  position: absolute;\n  top     : 135px;\n  left    : 19px;\n}\n\n.mandatory_login input\n{\n  outline : none;\n}\n\n.mandatory_login input:hover, .mandatory_login input:focus\n{\n  border-color  : #3c99dc;\n}\n\n.mandatory_login input:checked \n{\n  color         : #78be20;\n  border-color  : #78be20;\n}\n\n.mandatory_login .email, .mandatory_login .password, .mandatory_login .confirm_password\n{\n  width           : 75%;\n  height          : 35px;\n\n  margin-top      : 11px;\n  padding         : 10px 25px 10px 10px;\n\n  font-size       : 12px;\n\n  background-color: #ffffff;\n  \n  border          : solid 1px #9b9b9b;\n  border-radius   : 4px;\n}\n\n.mandatory_login .valid\n{\n  color         : #78be20 !important;\n  border-color  : #78be20 !important;\n}\n\n.mandatory_login .invalid\n{\n  color         : #ee4341 !important;\n  border-color  : #ee4341 !important;\n}\n\n.mandatory_login .error\n{\n  display         : none;\n\n  padding-top     : 4px;\n  padding-bottom  : 4px;\n\n  font-size       : 9px;\n  letter-spacing  : -0.2px;\n}\n\n.mandatory_login input.email\n{\n  margin-top  :0px;\n}\n\n.mandatory_login .register_done_title\n{\n  font-size       : 14px;\n  letter-spacing  : -0.3px;\n  text-align      : center;\n  margin-top      : 8px;\n  height          : 30px;\n}\n\n.mandatory_login .register_done_title img\n{\n  position  : relative;\n\n  top       : 6px;\n  right     : 4px;\n}\n\n.mandatory_login .forgotten_passoword\n{\n  padding-top     : 5px;\n  font-size       : 10px;\n  letter-spacing  : -0.2px;\n  text-decoration : underline;\n\n  color           : #3c99dc;\n  cursor          : pointer;\n}\n\n.mandatory_login .accepts_terms.invalid .checkmark\n{\n  border-color     : #ee4341!important;\n}\n\n.mandatory_login .accepts_terms.invalid\n{\n  color           : #ee4341!important;\n  font-weight     : bold;\n}\n\n.mandatory_login .accepts_terms.valid\n{\n  color           : #9b9b9b!important;\n}\n\n.mandatory_login .go_to_terms_and_conditions\n{\n  color           : #00abee;\n  cursor          : pointer;\n  text-decoration : underline;\n}\n\n.mandatory_login .invalid .go_to_terms_and_conditions\n{\n  color           : #ee4341;\n}\n\n.mandatory_login .register_done\n{\n  position  : relative;\n  top       : -45px;\n  text-align: center;\n}\n\n.mandatory_login .register_done_title \n{\n  font-size   : 21px;\n  text-align  : center;\n}\n\n.mandatory_login .register_done_title img\n{\n  width   :28px;\n  height  :28px;\n}\n\n.mandatory_login .clear\n{\n  background: #3333;\n}\n\n.mandatory_login .align_right\n{\n  text-align: right;\n}\n\n.mandatory_login .align_left\n{\n  text-align: left;\n}\n\n.mandatory_login .field\n{\n  position : relative;\n}\n\n.mandatory_login .ok,\n.mandatory_login .not_ok\n{\n  display  : none;\n  position : absolute;\n  right    : 7px;\n  top      : 8px;\n  cursor   : default;\n}\n\n.mandatory_login .field_password .ok,\n.mandatory_login .field_password .not_ok,\n.mandatory_login .field_confirm_password .ok,\n.mandatory_login .field_confirm_password .not_ok\n{\n  top      : 18px;\n}\n\n.mandatory_login .align_left .ok,\n.mandatory_login .align_left .not_ok\n{\n  right    : auto;\n  left     : calc(75% - 20px);\n}\n\n.mandatory_login .sign_in_error,\n.mandatory_login .sign_up_error\n{\n  position  : absolute;\n  bottom    : 60px;\n  display   : none;\n  color     : #ee4341 !important;\n}\n\n.mandatory_login .sign_in_error\n{\n  right     : 26px;\n}\n\n.mandatory_login .sign_up_error\n{\n  left     : 26px;\n}\n\n\n\n\n\n.specBox {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n/* Hide the browser's default checkbox */\n.specBox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  position: absolute;\n  left: 0;\n  width: 15px;\n  height: 15px;\n  z-index: 1000;\n}\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  left: 0;\n  height: 15px;\n  width: 15px;\n  border: 1px solid #979797;\n  border-radius: 2px;\n  z-index: 1;\n}\n/* When the checkbox is checked, add a #78be20 background */\n.specBox input:checked ~ .checkmark {\n  border: 1px solid #78be20;\n}\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n/* Show the checkmark when checked */\n.specBox input:checked ~ .checkmark:after {\n  display: block;\n}\n/* Style the checkmark/indicator */\n.specBox .checkmark:after {\n  left: 4px;\n  top: 1px;\n  width: 5px;\n  height: 10px;\n  border: solid #78be20;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n\n@media only screen and (max-width: 479px) \n{\n  .mandatory_login .box  \n  {\n    top       : 50%;\n    transform : translateY(-50%);\n\n    width     : 98%!important;\n    margin    : auto;\n  }\n\n  .mandatory_login .box.register_size \n  {\n    height: 554px!important;\n  }\n\n  .mandatory_login .box.register_size.email_error \n  {\n    height: 554px!important;\n  }\n\n  .mandatory_login .box.register_size.password_error \n  {\n    height: 582px!important;\n  }\n\n  .mandatory_login .box.register_size.email_confirm_password_error \n  {\n    height: 564px!important;\n  }\n\n  .mandatory_login .box.register_size.email_password_error \n  {\n    height: 615px!important;\n  }\n\n  .box.register_size.password_confirm_password_error \n  {\n    height: 604px!important;\n  }\n\n  .box.register_size.email_password_confirm_password_error \n  {\n    height: 635px!important;\n  }\n\n  .mandatory_login .box.register_size.password_confirm_password_error \n  {\n    height: 604px!important;\n  }\n\n  .mandatory_login .box.login_size \n  {\n    height: 440px!important;\n  }\n\n  .mandatory_login .box.login_size.email_error \n  {\n    height: 440px!important;\n  }\n\n  .mandatory_login .box.login_size.email_password_error \n  {\n    height: 495px!important;\n  }\n\n  .mandatory_login .box.login_size.password_error \n  {\n    height: 475px!important;\n  }\n\n  .mandatory_login .box.reset_size \n  {\n    height: 300px!important;\n  }\n\n  .mandatory_login .box.reset_done_size\n  {\n    height  :300px!important;\n  }\n\n  .mandatory_login .box.terms_and_conditions_size \n  {\n    height: 554px!important;\n}\n\n  .mandatory_login .register_done \n  {\n    top: -50px;\n  }\n\n  .mandatory_login .button_login, .mandatory_login .button_register , .mandatory_login .button_back \n  {\n    height      : 66px;\n    line-height : 66px;\n\n    width       : 50%;\n  }\n\n  .mandatory_login .vertical_separator\n  {\n    height      : 56px;\n  }\n\n  .mandatory_login .selector_underline\n  {\n    top         : 66px!important;\n  }\n\n  .mandatory_login .selector_underline.back_size_position \n  {\n    width: 50%;\n  }\n\n  .mandatory_login .sub_content \n  {\n    padding-top   : 66px;\n  }\n\n  .mandatory_login .action_button \n  {\n    height          : 50px;\n\n    line-height     : 50px;\n  }\n\n  .mandatory_login .background_login \n  {\n    height  : 360px;\n    top     : 72px;\n    left    : calc(20% - 100px);\n  }\n\n  .mandatory_login .background_registered \n  {\n    left      : 50%;\n    transform : translateX(-50%);\n  }\n\n  .mandatory_login .info_text \n  {\n    font-size       : 23px;\n    letter-spacing  : -0.5px;\n    line-height     : 23px;\n  }\n\n  .mandatory_login .align_right .info_text \n  {\n    padding-left: 20px;\n  }\n\n  .mandatory_login .register_done .info_text\n  {\n    line-height   : 17px;\n    letter-spacing: -0.3px;\n  }\n\n  .mandatory_login .info_text.small \n  {\n    font-size       : 15px;\n    letter-spacing  : -0.3px;\n  }\n\n  .mandatory_login .login .info_text.small \n  {\n    width: 100%;\n  }\n\n  .mandatory_login .info_text.smaller \n  {\n    font-size       : 14px;\n    letter-spacing  : -0.3px;\n    line-height     : 14px;\n  }\n\n  .mandatory_login .forgotten_passoword \n  {\n    font-size       : 13px;\n    letter-spacing  : -0.3px;\n  }\n\n  .mandatory_login .info_text.smaller div \n  {\n    margin-top      : 0px;\n    width           : 82%;\n    padding-left    : 10px;\n  }\n\n  .mandatory_login .email, .mandatory_login .password, .mandatory_login .confirm_password\n  {\n    height          : 44px;\n    font-size       : 14px;\n  }\n\n  .mandatory_login .align_left .ok, .mandatory_login .align_left .not_ok \n  {\n    left: calc(75% - 26px);\n  }\n\n  .mandatory_login .ok, .mandatory_login .not_ok \n  {\n    right: 10px;\n  }\n\n  .mandatory_login .ok,\n  .mandatory_login .not_ok\n  {\n    top         : 13px;\n    transform   : scale(1.3);\n  }\n\n  .mandatory_login .field_password .ok,\n  .mandatory_login .field_password .not_ok,\n  .mandatory_login .field_confirm_password .ok,\n  .mandatory_login .field_confirm_password .not_ok\n  {\n    top      : 24px!important;\n  }\n\n  .mandatory_login .error \n  {\n    font-size     : 11px!important;\n  }\n\n  .mandatory_login .accepts_terms \n  {\n    white-space   : nowrap;\n  }\n\n  .mandatory_login .terms_and_conditions\n  {\n    height        : 460px!important;\n    font-size     : 18px!important;\n  }\n\n  .mandatory_login .sign_in_error, .mandatory_login .sign_up_error \n  {\n    bottom: 70px;\n  }\n\n  .specBox input \n  {\n    width   : 20px;\n    height  : 20px;\n  }\n\n  .checkmark\n  {\n    height      : 20px;\n    width       : 20px;\n    margin-top  : -2px;\n  }\n\n  .specBox .checkmark:after \n  {\n      left    : 6px;\n      top     : 2px;\n      width   : 6px;\n      height  : 12px;\n  }\n}\n\n@media only screen and (max-height: 635px)\n{\n  .mandatory_login .box  \n  {\n    top       : 0px!important;\n    transform : none!important;\n  }\n}"

/***/ })
/******/ ]);
});
//# sourceMappingURL=rp-auth.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersInput = __webpack_require__(197);

var _FiltersInput2 = _interopRequireDefault(_FiltersInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersInput2.default;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FiltersInput;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Input = __webpack_require__(69);

var _Input2 = _interopRequireDefault(_Input);

var _FiltersInput = __webpack_require__(201);

var _FiltersInput2 = _interopRequireDefault(_FiltersInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FiltersInput(_ref) {
    var className = _ref.className,
        label = _ref.label,
        value = _ref.value,
        onChange = _ref.onChange;

    /* eslint-disable jsx-a11y/label-has-for */
    return _react2.default.createElement(
        'label',
        { className: _FiltersInput2.default.root + ' ' + className },
        _react2.default.createElement(
            'div',
            null,
            label
        ),
        _react2.default.createElement(_Input2.default, {
            className: _FiltersInput2.default.input,
            placeholder: label,
            debounce: 300,
            value: value,
            onChange: onChange
        })
    );
    /* eslint-enable jsx-a11y/label-has-for */
}

FiltersInput.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

FiltersInput.defaultProps = {
    className: '',
    value: ''
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce2 = __webpack_require__(199);

var _debounce3 = _interopRequireDefault(_debounce2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_PureComponent) {
    _inherits(Input, _PureComponent);

    function Input() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Input);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            value: _this.props.value
        }, _this.changeDebounced = (0, _debounce3.default)(_this.change, _this.props.debounce), _this.handleChange = function (ev) {
            var value = ev.target.value;
            var debounce = _this.props.debounce;

            if (debounce) {
                _this.setState({ value: value });
                _this.changeDebounced(value);
            } else {
                _this.change(value);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Input, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var debounce = _ref2.debounce,
                value = _ref2.value,
                onChange = _ref2.onChange;

            if (value !== this.props.value) {
                this.setState({ value: value });
            }
            if (debounce !== this.props.debounce || onChange !== this.props.onChange) {
                this.changeDebounced = (0, _debounce3.default)(onChange, debounce);
            }
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return this.props.formatter(this.props.debounce ? this.state.value : this.props.value) || '';
        }
    }, {
        key: 'change',
        value: function change(value) {
            return this.props.onChange(this.props.parser(value));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                debounce = _props.debounce,
                value = _props.value,
                parser = _props.parser,
                formatter = _props.formatter,
                onChange = _props.onChange,
                otherProps = _objectWithoutProperties(_props, ['className', 'debounce', 'value', 'parser', 'formatter', 'onChange']);

            return _react2.default.createElement('input', _extends({
                className: 'ui-input ' + className,
                value: this.getValue(),
                onChange: this.handleChange
            }, otherProps));
        }
    }]);

    return Input;
}(_react.PureComponent);

Input.propTypes = {
    className: _propTypes2.default.string,
    debounce: _propTypes2.default.number,
    // value is string by default, any other with parser/formatter
    value: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    parser: _propTypes2.default.func,
    formatter: _propTypes2.default.func,
    onChange: _propTypes2.default.func.isRequired
};
Input.defaultProps = {
    className: '',
    debounce: 0,
    parser: function parser(value) {
        return value;
    },
    formatter: function formatter(value) {
        return value;
    }
};
exports.default = Input;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16),
    now = __webpack_require__(200),
    toNumber = __webpack_require__(40);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(202);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersInput.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersInput.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.FiltersInput__root___16bED {\n  display: block; }\n\n.FiltersInput__input___GG4Af {\n  width: 100%; }\n  @media (max-width: 1277.9px) {\n    .FiltersInput__input___GG4Af {\n      font: 16px/22px \"proxima-nova-a\", sans-serif; } }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersInput__root___16bED",
	"input": "FiltersInput__input___GG4Af"
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersNav = __webpack_require__(204);

var _FiltersNav2 = _interopRequireDefault(_FiltersNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersNav2.default;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ALIGN_VERTICAL = exports.ALIGN_HORIZONTAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FiltersNav;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RadioButton = __webpack_require__(205);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _FiltersNav = __webpack_require__(209);

var _FiltersNav2 = _interopRequireDefault(_FiltersNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALIGN_HORIZONTAL = exports.ALIGN_HORIZONTAL = 'horizontal';
var ALIGN_VERTICAL = exports.ALIGN_VERTICAL = 'vertical';

function FiltersNav(_ref) {
    var className = _ref.className,
        name = _ref.name,
        options = _ref.options,
        value = _ref.value,
        onChange = _ref.onChange,
        align = _ref.align;

    var alignRoot = 'root_align_' + align;
    var alignOption = 'option_align_' + align;

    function handleChange(val) {
        onChange(val);
    }

    return _react2.default.createElement(
        'div',
        { className: _FiltersNav2.default.root + ' ' + _FiltersNav2.default[alignRoot] + ' ' + className },
        options.map(function (option) {
            return _react2.default.createElement(_RadioButton2.default, _extends({
                key: option.value,
                className: _FiltersNav2.default.option + ' ' + _FiltersNav2.default[alignOption],
                name: name,
                checked: option.value === value,
                onChange: handleChange
            }, option));
        })
    );
}

FiltersNav.ALIGN_HORIZONTAL = ALIGN_HORIZONTAL;
FiltersNav.ALIGN_VERTICAL = ALIGN_VERTICAL;

FiltersNav.propTypes = {
    className: _propTypes2.default.string,
    name: _propTypes2.default.string.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired
    })).isRequired,
    value: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    align: _propTypes2.default.oneOf([ALIGN_VERTICAL, ALIGN_HORIZONTAL]),
    onChange: _propTypes2.default.func.isRequired
};

FiltersNav.defaultProps = {
    className: '',
    align: ALIGN_HORIZONTAL
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadioButton = __webpack_require__(206);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RadioButton2.default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RadioButton = __webpack_require__(207);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = function (_PureComponent) {
    _inherits(RadioButton, _PureComponent);

    function RadioButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RadioButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function () {
            return _this.props.onChange(_this.props.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                label = _props.label,
                name = _props.name,
                value = _props.value,
                checked = _props.checked;

            return (
                /* eslint-disable jsx-a11y/label-has-for */
                _react2.default.createElement(
                    'label',
                    {
                        className: 'ui-btn ' + (checked ? 'ui-btn_primary' : 'ui-btn_secondary') + ' ' + className
                    },
                    _react2.default.createElement('input', {
                        className: _RadioButton2.default.input,
                        type: 'radio',
                        name: name,
                        value: value,
                        checked: checked,
                        onChange: this.handleChange
                    }),
                    label
                )
                /* eslint-enable jsx-a11y/label-has-for */

            );
        }
    }]);

    return RadioButton;
}(_react.PureComponent);

RadioButton.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    checked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};
RadioButton.defaultProps = {
    className: '',
    checked: false
};
exports.default = RadioButton;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(208);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RadioButton.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RadioButton.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RadioButton__input___3fikD {\n  display: none; }\n", ""]);

// exports
exports.locals = {
	"input": "RadioButton__input___3fikD"
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersNav.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersNav.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".FiltersNav__root___1JmaU {\n  display: flex;\n  flex-direction: column; }\n  @media (max-width: 479.9px) {\n    .FiltersNav__root_align_horizontal___Pi63c {\n      flex-direction: row;\n      flex-wrap: wrap; } }\n\n.FiltersNav__option___2Lcg4 {\n  margin: 8px 0 0 0; }\n  @media (max-width: 479.9px) {\n    .FiltersNav__option_align_horizontal___1bhQH {\n      margin-right: 2%;\n      width: 48%; } }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersNav__root___1JmaU",
	"root_align_horizontal": "FiltersNav__root_align_horizontal___Pi63c",
	"option": "FiltersNav__option___2Lcg4",
	"option_align_horizontal": "FiltersNav__option_align_horizontal___1bhQH"
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersReset = __webpack_require__(212);

var _FiltersReset2 = _interopRequireDefault(_FiltersReset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersReset2.default;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FiltersReset;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FiltersReset(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'button',
        {
            className: (0, _classnames2.default)(className, 'ui-btn', 'ui-btn_secondary'),
            disabled: disabled,
            onClick: onClick
        },
        _react2.default.createElement(
            'span',
            null,
            'Reset'
        )
    );
}

FiltersReset.propTypes = {
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

FiltersReset.defaultProps = {
    className: '',
    disabled: false,
    onClick: null
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersSelect = __webpack_require__(214);

var _FiltersSelect2 = _interopRequireDefault(_FiltersSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersSelect2.default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FiltersSelect;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSelect = __webpack_require__(215);

var _rpReactSelect2 = _interopRequireDefault(_rpReactSelect);

var _FiltersSelect = __webpack_require__(216);

var _FiltersSelect2 = _interopRequireDefault(_FiltersSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function FiltersSelect(_ref) {
    var className = _ref.className,
        label = _ref.label,
        onOpen = _ref.onOpen,
        otherProps = _objectWithoutProperties(_ref, ['className', 'label', 'onOpen']);

    /* eslint-disable jsx-a11y/label-has-for */
    return _react2.default.createElement(
        'label',
        { className: _FiltersSelect2.default.root + ' ' + className },
        _react2.default.createElement(
            'span',
            null,
            label
        ),
        _react2.default.createElement(_rpReactSelect2.default, _extends({
            title: label,
            onPopoverDidOpen: onOpen
        }, otherProps))
    );
    /* eslint-enable jsx-a11y/label-has-for */
}

FiltersSelect.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    onOpen: _propTypes2.default.func
};

FiltersSelect.defaultProps = {
    className: '',
    onOpen: null
};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_215__;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersSelect.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersSelect.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".FiltersSelect__root___sFwHz {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersSelect__root___sFwHz"
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersToggle = __webpack_require__(219);

var _FiltersToggle2 = _interopRequireDefault(_FiltersToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersToggle2.default;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FiltersToggle;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FiltersToggle = __webpack_require__(220);

var _FiltersToggle2 = _interopRequireDefault(_FiltersToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FiltersToggle(_ref) {
    var className = _ref.className,
        open = _ref.open,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'div',
        { className: _FiltersToggle2.default.root + ' ' + className },
        _react2.default.createElement(
            'button',
            {
                className: _FiltersToggle2.default.button + ' ui-btn ui-btn_tiertiary',
                onClick: onClick
            },
            _react2.default.createElement(
                'span',
                null,
                open ? 'Close' : 'Refine Search'
            )
        )
    );
}

FiltersToggle.propTypes = {
    className: _propTypes2.default.string,
    open: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

FiltersToggle.defaultProps = {
    className: '',
    open: false,
    onClick: null
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersToggle.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersToggle.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".FiltersToggle__root___LhWHb {\n  position: relative; }\n\n.FiltersToggle__button___h3_oH {\n  display: block;\n  margin: 0 auto; }\n  .FiltersToggle__button___h3_oH::before {\n    z-index: -1;\n    content: \"\";\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 1px;\n    top: 50%;\n    left: 0;\n    background-color: #F0EFF1; }\n\n.FiltersToggle__icon___gKTg5 {\n  fill: #D11F25;\n  height: 12px;\n  width: 12px;\n  margin-left: 8px; }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersToggle__root___LhWHb",
	"button": "FiltersToggle__button___h3_oH",
	"icon": "FiltersToggle__icon___gKTg5"
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePicker = __webpack_require__(223);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DatePicker2.default;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(224);

var _jquery = __webpack_require__(225);

var _jquery2 = _interopRequireDefault(_jquery);

var _dateFns = __webpack_require__(226);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _DatePicker = __webpack_require__(227);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents date field with integrated datepicker jquery component
 */
var DatePicker = function (_PureComponent) {
    _inherits(DatePicker, _PureComponent);

    function DatePicker() {
        _classCallCheck(this, DatePicker);

        return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
    }

    _createClass(DatePicker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                min = _props.min,
                max = _props.max,
                value = _props.value;

            (0, _jquery2.default)(this.buttonRef).datePicker({
                minDate: min,
                maxDate: max,
                date: value,
                autoClose: true,
                track: true
            }).on('change.rp.datePicker', function (ev, date) {
                return _this2.props.onChange((0, _dateFns.format)(date, _this2.props.valueFormat));
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var min = _ref.min,
                max = _ref.max;

            if (this.isValueChanged(min, this.props.min)) {
                (0, _jquery2.default)(this.buttonRef).datePicker('minDate', min);
            }
            if (this.isValueChanged(max, this.props.max)) {
                (0, _jquery2.default)(this.buttonRef).datePicker('maxDate', max);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(this.buttonRef).datePicker('destroy');
        }
    }, {
        key: 'isValueChanged',
        value: function isValueChanged(next, current) {
            var fmt = this.props.valueFormat;
            return (0, _dateFns.format)(next, fmt) !== (0, _dateFns.format)(current, fmt);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                className = _props2.className,
                label = _props2.label,
                placeholder = _props2.placeholder,
                displayFormat = _props2.displayFormat,
                value = _props2.value;

            return _react2.default.createElement(
                'div',
                { className: _DatePicker2.default.root + ' ' + className },
                _react2.default.createElement(
                    'div',
                    null,
                    label
                ),
                _react2.default.createElement(
                    'button',
                    {
                        ref: function ref(_ref2) {
                            _this3.buttonRef = _ref2;
                        },
                        className: _DatePicker2.default.button + ' ui-btn ui-btn_tiertiary',
                        type: 'button'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _DatePicker2.default.date },
                        _react2.default.createElement(
                            'span',
                            null,
                            value ? (0, _dateFns.format)(value, displayFormat) : placeholder
                        ),
                        _react2.default.createElement(_rpReactSvgIcon2.default, {
                            size: 'Medium',
                            iconName: 'date'
                        })
                    )
                )
            );
        }
    }]);

    return DatePicker;
}(_react.PureComponent);

DatePicker.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    placeholder: _propTypes2.default.string,
    displayFormat: _propTypes2.default.string,
    valueFormat: _propTypes2.default.string,
    value: _propTypes2.default.string,
    min: _propTypes2.default.string,
    max: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};
DatePicker.defaultProps = {
    className: '',
    placeholder: 'Select date',
    displayFormat: 'DD.MM.YYYY',
    valueFormat: 'YYYY-MM-DD',
    value: null,
    min: null,
    max: null
};
exports.default = DatePicker;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_224__;

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_225__;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_226__;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./DatePicker.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./DatePicker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".DatePicker__root___1ILA7 {\n  display: inline-block;\n  min-width: 120px; }\n\n.DatePicker__button___1vpKZ {\n  width: 100%; }\n\n.DatePicker__date___1q1ox {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  fill: #D11F25; }\n", ""]);

// exports
exports.locals = {
	"root": "DatePicker__root___1ILA7",
	"button": "DatePicker__button___1vpKZ",
	"date": "DatePicker__date___1q1ox"
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Checkbox = __webpack_require__(230);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_PureComponent) {
    _inherits(Checkbox, _PureComponent);

    function Checkbox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Checkbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (ev) {
            return _this.props.onChange(ev.target.checked);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Checkbox, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                disabled = _props.disabled,
                value = _props.value;
            /* eslint-disable jsx-a11y/label-has-for */

            return _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _Checkbox2.default.wrap },
                    _react2.default.createElement('input', {
                        className: _Checkbox2.default.input + ' ui-checkbox_input',
                        type: 'checkbox',
                        disabled: disabled,
                        checked: value || false,
                        onChange: this.handleChange
                    }),
                    _react2.default.createElement('div', { className: _Checkbox2.default.tick + ' ui-checkbox' }),
                    _react2.default.createElement(
                        'span',
                        { className: _Checkbox2.default.label },
                        label
                    )
                )
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    }]);

    return Checkbox;
}(_react.PureComponent);

Checkbox.propTypes = {
    label: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool,
    value: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};
Checkbox.defaultProps = {
    value: false,
    disabled: false
};
exports.default = Checkbox;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(231);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Checkbox.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Checkbox.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".Checkbox__input___1srz1 {\n  display: none; }\n  .Checkbox__input___1srz1:checked + .Checkbox__tick___Qg7gs:after {\n    left: 5px;\n    top: 1px;\n    width: 5px;\n    height: 10px; }\n\n.Checkbox__tick___Qg7gs {\n  display: inline-block;\n  width: 16px;\n  height: 16px; }\n\n.Checkbox__label___2e-fu {\n  margin: 0 0 0 8px; }\n", ""]);

// exports
exports.locals = {
	"input": "Checkbox__input___1srz1",
	"tick": "Checkbox__tick___Qg7gs",
	"label": "Checkbox__label___2e-fu"
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResultsFiltersSale = __webpack_require__(233);

var _SearchResultsFiltersSale2 = _interopRequireDefault(_SearchResultsFiltersSale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResultsFiltersSale2.default;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Input = __webpack_require__(69);

var _Input2 = _interopRequireDefault(_Input);

var _SearchResultsFiltersSale = __webpack_require__(234);

var _SearchResultsFiltersSale2 = _interopRequireDefault(_SearchResultsFiltersSale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultsFiltersSale = function (_PureComponent) {
    _inherits(SearchResultsFiltersSale, _PureComponent);

    function SearchResultsFiltersSale() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResultsFiltersSale);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsFiltersSale.__proto__ || Object.getPrototypeOf(SearchResultsFiltersSale)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonClick = function () {
            return _this.props.onChange('');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResultsFiltersSale, [{
        key: 'render',
        value: function render() {
            /* eslint-disable jsx-a11y/label-has-for */
            var _props = this.props,
                className = _props.className,
                value = _props.value,
                onChange = _props.onChange;

            return _react2.default.createElement(
                'label',
                { className: _SearchResultsFiltersSale2.default.root + ' ' + className },
                _react2.default.createElement(
                    'span',
                    null,
                    'Sale Name'
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFiltersSale2.default.group },
                    _react2.default.createElement(_Input2.default, {
                        className: _SearchResultsFiltersSale2.default.input,
                        placeholder: 'All sales',
                        debounce: 300,
                        value: value,
                        onChange: onChange
                    }),
                    _react2.default.createElement(
                        'button',
                        {
                            className: _SearchResultsFiltersSale2.default.button + ' ui-btn ui-btn_secondary',
                            disabled: !value,
                            onClick: this.handleButtonClick
                        },
                        _react2.default.createElement(
                            'span',
                            {
                                className: _SearchResultsFiltersSale2.default.buttonLabel
                            },
                            'All Sales'
                        )
                    )
                )
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    }]);

    return SearchResultsFiltersSale;
}(_react.PureComponent);

exports.default = SearchResultsFiltersSale;


SearchResultsFiltersSale.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

SearchResultsFiltersSale.defaultProps = {
    className: '',
    value: ''
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(235);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFiltersSale.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFiltersSale.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SearchResultsFiltersSale__root___3cAEK {\n  width: 100%; }\n\n.SearchResultsFiltersSale__group___3lBoZ {\n  display: flex; }\n\n.SearchResultsFiltersSale__input___3bSEt {\n  flex-grow: 1;\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFiltersSale__input___3bSEt {\n      width: 100%;\n      flex-basis: auto; } }\n  @media (max-width: 719.9px) {\n    .SearchResultsFiltersSale__input___3bSEt {\n      min-width: 0;\n      flex: 1 1; } }\n  @media (max-width: 1277.9px) {\n    .SearchResultsFiltersSale__input___3bSEt {\n      font: 16px/22px \"proxima-nova-a\", sans-serif; } }\n\n.SearchResultsFiltersSale__button___3KuVm {\n  flex-grow: 0;\n  flex-shrink: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  height: 36px; }\n  .SearchResultsFiltersSale__buttonLabel___2GLtL {\n    margin: 0; }\n", ""]);

// exports
exports.locals = {
	"root": "SearchResultsFiltersSale__root___3cAEK",
	"group": "SearchResultsFiltersSale__group___3lBoZ",
	"input": "SearchResultsFiltersSale__input___3bSEt",
	"button": "SearchResultsFiltersSale__button___3KuVm",
	"buttonLabel": "SearchResultsFiltersSale__buttonLabel___2GLtL"
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFilters.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFilters.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SearchResultsFilters__top___7HEAg {\n  align-items: baseline;\n  justify-content: center; }\n  @media (min-width: 720px) {\n    .SearchResultsFilters__top___7HEAg {\n      text-align: center; } }\n\n.SearchResultsFilters__heading___nqmlz {\n  display: none; }\n  @media (min-width: 720px) {\n    .SearchResultsFilters__heading___nqmlz {\n      display: block; } }\n\n.SearchResultsFilters__description___3ghYo {\n  font: 12px/17px \"proxima-nova-a\", sans-serif; }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsFilters__description___3ghYo {\n      margin-left: 190px;\n      width: 328px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsFilters__description___3ghYo {\n      margin-left: 176px;\n      width: 306px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__description___3ghYo {\n      margin-left: 224px;\n      width: 459px; } }\n\n.SearchResultsFilters__date___3UETw {\n  display: block;\n  margin-bottom: 8px; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__date___3UETw {\n      flex-basis: 48%;\n      margin-right: 2%; } }\n\n.SearchResultsFilters__center___3dnRy {\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__center___3dnRy {\n      flex: 100% 1 1; } }\n\n@media (max-width: 479.9px) {\n  .SearchResultsFilters__content___u_3lw {\n    order: 2;\n    padding-top: 8px;\n    flex-wrap: nowrap; } }\n\n.SearchResultsFilters__wrap___2AnDq {\n  flex-wrap: wrap; }\n\n.SearchResultsFilters__nav___2-Xa- {\n  flex-grow: 0;\n  flex-shrink: 0; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      width: 84%;\n      order: 0; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 120px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 174px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 160px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 208px; } }\n\n.SearchResultsFilters__buttons___1SjGT {\n  display: flex;\n  flex: 100% 1 0;\n  margin-top: 24px;\n  justify-content: center; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__buttons___1SjGT {\n      margin-bottom: 16px;\n      order: 1;\n      justify-content: flex-start; } }\n\n.SearchResultsFilters__reset___3jwrG {\n  margin-right: 8px; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__reset___3jwrG {\n      width: calc(50% - 16px); } }\n  @media (min-width: 480px) {\n    .SearchResultsFilters__reset___3jwrG {\n      width: 200px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__reset___3jwrG {\n      margin-right: 16px; } }\n\n@media (max-width: 479.9px) {\n  .SearchResultsFilters__search___2lLxO {\n    width: calc(50% - 16px); } }\n\n@media (min-width: 480px) {\n  .SearchResultsFilters__search___2lLxO {\n    width: 200px; } }\n\n.SearchResultsFilters__filter___3dLWx {\n  width: 100%; }\n  .SearchResultsFilters__filter___3dLWx:nth-child(n+2) {\n    margin-top: 8px; }\n\n.SearchResultsFilters__form___38Q5S {\n  flex: 1 0;\n  margin: 0 0 0 8px;\n  padding: 0 0 0 8px;\n  border-left: 1px solid #171717; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0 1 66.66667%;\n      border-left: 0;\n      margin: 0; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 233px;\n      width: 233px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 337px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 313px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 465px; } }\n\n.SearchResultsFilters__lots___1Wffi {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 0 8px;\n  padding: 0 0 0 8px;\n  border-left: 1px solid #171717; }\n  @media (min-width: 990px) {\n    .SearchResultsFilters__lots___1Wffi {\n      margin: 0 0 0 32px; } }\n  .SearchResultsFilters__lotsInfo___UvPe1 {\n    flex-grow: 1;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; }\n  .SearchResultsFilters__lotsNum___3puEU {\n    margin-top: 16px;\n    font-size: 38px;\n    font-weight: bold; }\n  .SearchResultsFilters__lotsFilter___2_M1a {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.SearchResultsFilters__bottom___2u52I {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px; }\n\n.SearchResultsFilters__status___3j5dX {\n  font-size: 20px; }\n  .SearchResultsFilters__statusLotsNum___3uvov {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 8px;\n    padding: 1px 4px;\n    background: #2CB34A;\n    border-radius: 4px;\n    color: #FFFFFF;\n    font: 12px/17px \"proxima-nova-a-bold\", sans-serif; }\n\n.SearchResultsFilters__priceRange___2GNke {\n  display: flex; }\n  .SearchResultsFilters__priceRangeMax___2f0SO {\n    margin-left: 8px; }\n\n.SearchResultsFilters__history___BJUwB {\n  margin-top: 16px;\n  font: 16px/22px \"proxima-nova-a-bold\", sans-serif;\n  overflow-wrap: break-word; }\n\n.SearchResultsFilters__datepicker___1v__C {\n  padding: 8px 0; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__datepicker___1v__C {\n      display: flex; } }\n\n.SearchResultsFilters__toggle___1zA_i {\n  margin-bottom: 16px; }\n", ""]);

// exports
exports.locals = {
	"top": "SearchResultsFilters__top___7HEAg",
	"heading": "SearchResultsFilters__heading___nqmlz",
	"description": "SearchResultsFilters__description___3ghYo",
	"date": "SearchResultsFilters__date___3UETw",
	"center": "SearchResultsFilters__center___3dnRy",
	"content": "SearchResultsFilters__content___u_3lw",
	"wrap": "SearchResultsFilters__wrap___2AnDq",
	"nav": "SearchResultsFilters__nav___2-Xa-",
	"buttons": "SearchResultsFilters__buttons___1SjGT",
	"reset": "SearchResultsFilters__reset___3jwrG",
	"search": "SearchResultsFilters__search___2lLxO",
	"filter": "SearchResultsFilters__filter___3dLWx",
	"form": "SearchResultsFilters__form___38Q5S",
	"lots": "SearchResultsFilters__lots___1Wffi",
	"lotsInfo": "SearchResultsFilters__lotsInfo___UvPe1",
	"lotsNum": "SearchResultsFilters__lotsNum___3puEU",
	"lotsFilter": "SearchResultsFilters__lotsFilter___2_M1a",
	"bottom": "SearchResultsFilters__bottom___2u52I",
	"status": "SearchResultsFilters__status___3j5dX",
	"statusLotsNum": "SearchResultsFilters__statusLotsNum___3uvov",
	"priceRange": "SearchResultsFilters__priceRange___2GNke",
	"priceRangeMax": "SearchResultsFilters__priceRangeMax___2f0SO",
	"history": "SearchResultsFilters__history___BJUwB",
	"datepicker": "SearchResultsFilters__datepicker___1v__C",
	"toggle": "SearchResultsFilters__toggle___1zA_i"
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = __webpack_require__(23);

var _Table = __webpack_require__(17);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _RelativesRow = __webpack_require__(82);

var _RelativesRow2 = _interopRequireDefault(_RelativesRow);

var _SearchResultsTable = __webpack_require__(375);

var _SearchResultsTable2 = _interopRequireDefault(_SearchResultsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;

var SearchResultsTable = function (_PureComponent) {
    _inherits(SearchResultsTable, _PureComponent);

    function SearchResultsTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResultsTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsTable.__proto__ || Object.getPrototypeOf(SearchResultsTable)).call.apply(_ref, [this].concat(args))), _this), _this.row = { children: _RelativesRow2.default }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResultsTable, [{
        key: 'getColumns',
        value: function getColumns() {
            var breakpointCode = this.props.breakpointCode;

            var exNarrow = breakpointCode === EXTRA_NARROW;
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var exWide = breakpointCode === EXTRA_WIDE;
            return [{
                className: _SearchResultsTable2.default.toggle,
                name: '_toggle',
                head: '',
                cell: { children: _Table.TableToggle }
            }, {
                className: _SearchResultsTable2.default.lot,
                name: 'lot_no',
                head: 'Lot',
                cell: { children: _Cell.CellLot }
            }, fromMedium ? {
                className: _SearchResultsTable2.default.horse,
                name: 'horse_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Horse name'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellHorseSireUGC }
            } : {
                className: _SearchResultsTable2.default.horse,
                name: 'horse_style_name',
                head: 'Horse name',
                cell: { children: _Cell.CellHorseUGC }
            }, exWide && {
                className: _SearchResultsTable2.default.color,
                name: 'horse_first_colour_code',
                head: 'Col'
            }, fromMedium && {
                className: _SearchResultsTable2.default.sex,
                name: 'horse_sex',
                head: 'Sex'
            }, exWide && {
                className: _SearchResultsTable2.default.age,
                name: 'horse_age',
                head: 'Age'
            }, fromMedium && {
                className: _SearchResultsTable2.default.dam,
                name: 'dam_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam\'s Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellDamDamsSire }
            }, fromMedium && {
                className: _SearchResultsTable2.default.vendor,
                name: 'seller_name',
                head: 'Vendor'
            }, {
                className: _SearchResultsTable2.default.price,
                name: 'price',
                head: 'Price',
                cell: { children: _Cell.CellPrice }
            }, !exNarrow && {
                className: _SearchResultsTable2.default.buyer,
                name: 'buyer_detail',
                head: 'Buyer'
            }, fromMedium && {
                className: _SearchResultsTable2.default.date,
                name: 'sale_date',
                head: 'Date'
            }, fromMedium && {
                className: _SearchResultsTable2.default.sale,
                name: 'sale_name',
                head: 'Sale'
            }].filter(function (item) {
                return !!item;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                loading = _props.loading,
                expansion = _props.expansion,
                sorting = _props.sorting,
                onToggle = _props.onToggle,
                onSort = _props.onSort,
                errorMessage = _props.errorMessage,
                canSortByColumn = _props.canSortByColumn;

            return _react2.default.createElement(_Table2.default, {
                type: 1,
                columns: this.getColumns(),
                row: this.row,
                identity: SearchResultsTable.identity,
                data: data,
                loading: loading,
                expansion: expansion,
                sorting: sorting,
                onToggle: onToggle,
                onSort: onSort,
                placeholder: errorMessage,
                className: _SearchResultsTable2.default.root,
                canSortByColumn: canSortByColumn
            });
        }
    }], [{
        key: 'identity',
        value: function identity(data) {
            return [data.venue_uid, data.sale_date_raw, data.lot_no, data.lot_letter].join('|');
        }
    }]);

    return SearchResultsTable;
}(_react.PureComponent);

SearchResultsTable.propTypes = {
    breakpointCode: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired
    })).isRequired,
    loading: _propTypes2.default.bool,
    expansion: _propTypes2.default.string,
    sorting: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    onToggle: _propTypes2.default.func.isRequired,
    onSort: _propTypes2.default.func.isRequired,
    errorMessage: _propTypes2.default.string.isRequired,
    canSortByColumn: _propTypes2.default.func.isRequired
};
SearchResultsTable.defaultProps = {
    loading: false,
    expansion: null,
    sorting: null
};
exports.default = SearchResultsTable;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(240);

var _get2 = _interopRequireDefault(_get);

var _isArray = __webpack_require__(9);

var _isArray2 = _interopRequireDefault(_isArray);

var _isNil = __webpack_require__(248);

var _isNil2 = _interopRequireDefault(_isNil);

var _isFunction = __webpack_require__(15);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isPlainObject = __webpack_require__(41);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isString = __webpack_require__(249);

var _isString2 = _interopRequireDefault(_isString);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableHead = __webpack_require__(71);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableHeadRow = __webpack_require__(250);

var _TableHeadRow2 = _interopRequireDefault(_TableHeadRow);

var _TableHeadCell = __webpack_require__(72);

var _TableHeadCell2 = _interopRequireDefault(_TableHeadCell);

var _TableBody = __webpack_require__(74);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableBodySpinner = __webpack_require__(253);

var _TableBodySpinner2 = _interopRequireDefault(_TableBodySpinner);

var _TableBodyPlaceholder = __webpack_require__(256);

var _TableBodyPlaceholder2 = _interopRequireDefault(_TableBodyPlaceholder);

var _TableRowConstructor = __webpack_require__(75);

var _TableRowConstructor2 = _interopRequireDefault(_TableRowConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TYPE_1 = 1;
var TYPE_2 = 2;
var TYPE_3 = 3;
var TYPE_4 = 4;
var TYPE_5 = 5;

var Table = function (_Component) {
    _inherits(Table, _Component);

    function Table() {
        _classCallCheck(this, Table);

        return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
    }

    _createClass(Table, [{
        key: 'identify',
        value: function identify(data, i) {
            var identity = this.props.identity;


            if (!identity) return i;

            if ((0, _isString2.default)(identity) || (0, _isArray2.default)(identity)) {
                return (0, _get2.default)(data, identity);
            }

            if ((0, _isFunction2.default)(identity)) {
                return identity(data);
            }

            throw new Error('Table has invalid identity ' + identity);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props = this.props,
                className = _props.className,
                type = _props.type,
                head = _props.head,
                row = _props.row,
                columns = _props.columns,
                data = _props.data,
                loading = _props.loading,
                sorting = _props.sorting,
                expansion = _props.expansion,
                placeholder = _props.placeholder,
                canSortByColumn = _props.canSortByColumn,
                onSort = _props.onSort,
                onToggle = _props.onToggle;

            return _react2.default.createElement(
                'table',
                {
                    className: (0, _classnames3.default)('ui-table', (_classnames = {}, _defineProperty(_classnames, 'ui-table_type' + type, !!type), _defineProperty(_classnames, 'ui-table_sortable', !!sorting), _defineProperty(_classnames, className, !!className), _classnames))
                },

                /**
                    Table Head
                */
                function () {
                    if (head) return head;

                    return _react2.default.createElement(
                        _TableHead2.default,
                        null,
                        _react2.default.createElement(
                            _TableHeadRow2.default,
                            null,
                            columns.map(function (column) {
                                if (_react2.default.isValidElement(column.head)) return column.head;

                                if ((0, _isString2.default)(column.head)) {
                                    return _react2.default.createElement(
                                        _TableHeadCell2.default,
                                        {
                                            key: column.name,
                                            className: column.className,
                                            type: type,
                                            sorting: sorting[column.name],
                                            sortable: canSortByColumn(column.name),
                                            onClick: function onClick() {
                                                return onSort(column.name);
                                            }
                                        },
                                        column.head
                                    );
                                }

                                if ((0, _isPlainObject2.default)(column.head)) {
                                    return _react2.default.createElement(_TableHeadCell2.default, _extends({
                                        key: column.name,
                                        className: column.className,
                                        type: type,
                                        sorting: sorting[column.name],
                                        sortable: canSortByColumn(column.name),
                                        onClick: function onClick() {
                                            return onSort(column.name);
                                        }
                                    }, column.head));
                                }

                                throw new Error('Column ' + column.name + ' has invalid head ' + column.cell);
                            })
                        )
                    );
                }(),

                /**
                    Table Body
                 */
                _react2.default.createElement(
                    _TableBody2.default,
                    { rootRef: function rootRef(ref) {
                            _this2.tableBodyRef = ref;
                        } },
                    function () {
                        if (loading) {
                            var _ref = _this2.tableBodyRef ? _this2.tableBodyRef.getBoundingClientRect() : {},
                                height = _ref.height,
                                top = _ref.top,
                                bottom = _ref.bottom;

                            return _react2.default.createElement(_TableBodySpinner2.default, {
                                colSpan: columns.length,
                                height: height,
                                top: top,
                                bottom: bottom
                            });
                        }

                        if (!data.length) {
                            return _react2.default.createElement(
                                _TableBodyPlaceholder2.default,
                                { colSpan: columns.length },
                                placeholder
                            );
                        }

                        var Row = (0, _isFunction2.default)(row) ? row : _TableRowConstructor2.default;
                        return data.map(function (item, i) {
                            var identity = _this2.identify(item, i);
                            var expanded = !(0, _isNil2.default)(expansion) && [].concat(expansion).includes(identity);
                            return _react2.default.createElement(Row, _extends({
                                key: identity,
                                type: type,
                                columns: columns,
                                data: item,
                                identity: identity,
                                expanded: expanded,
                                onToggle: onToggle
                            }, (0, _isPlainObject2.default)(row) ? row : null));
                        });
                    }()
                )
            );
        }
    }]);

    return Table;
}(_react.Component);

Table.TYPE_1 = TYPE_1;
Table.TYPE_2 = TYPE_2;
Table.TYPE_3 = TYPE_3;
Table.TYPE_4 = TYPE_4;
Table.TYPE_5 = TYPE_5;
exports.default = Table;


Table.propTypes = {
    className: _propTypes2.default.string,
    type: _propTypes2.default.oneOf([TYPE_1, TYPE_2, TYPE_3, TYPE_4, TYPE_5]).isRequired,
    head: _propTypes2.default.node,
    row: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        className: _propTypes2.default.string,
        name: _propTypes2.default.string.isRequired,
        head: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.node]),
        cell: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.func])
    })).isRequired,
    identity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    loading: _propTypes2.default.bool,
    sorting: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    expansion: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
    placeholder: _propTypes2.default.string,
    onSort: _propTypes2.default.func,
    onToggle: _propTypes2.default.func,
    canSortByColumn: _propTypes2.default.func.isRequired
};

Table.defaultProps = {
    className: '',
    head: null,
    row: null,
    identity: null,
    loading: false,
    sorting: {},
    expansion: null,
    placeholder: 'No data found',
    onSort: function onSort() {
        return null;
    },
    onToggle: function onToggle() {
        return null;
    }
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(241);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(242),
    toKey = __webpack_require__(247);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isKey = __webpack_require__(243),
    stringToPath = __webpack_require__(244),
    toString = __webpack_require__(25);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(24);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(245);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(246);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(35);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(24);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isArray = __webpack_require__(9),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableHead;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableHead(props) {
    return _react2.default.createElement('tr', props);
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableHeadSortIcon;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableHead = __webpack_require__(73);

var _TableHead2 = _interopRequireDefault(_TableHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DIRECTION_ASC = 'asc';
var DIRECTION_DESC = 'desc';

function TableHeadSortIcon(_ref) {
    var className = _ref.className,
        direction = _ref.direction;

    if (!direction) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames3.default)(_TableHead2.default.sortIcon, _defineProperty({}, _TableHead2.default.sortIcon_desc, direction === 'desc'), className)
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, { className: _TableHead2.default.sortIcon__down, size: 'small', iconName: 'down' }),
        _react2.default.createElement(_rpReactSvgIcon2.default, { className: _TableHead2.default.sortIcon__minus, size: 'small', iconName: 'minus' })
    );
}

TableHeadSortIcon.DIRECTION_ASC = DIRECTION_ASC;
TableHeadSortIcon.DIRECTION_DESC = DIRECTION_DESC;

TableHeadSortIcon.propTypes = {
    className: _propTypes2.default.string,
    direction: _propTypes2.default.oneOf(['asc', 'desc'])
};

TableHeadSortIcon.defaultProps = {
    className: '',
    direction: null
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableHead__cell__sortIcon___N8HKh {\n  margin-left: 4px; }\n\n.TableHead__cell_unsortable___o_c0c {\n  cursor: default !important; }\n\n.TableHead__sortIcon___NhMiP {\n  display: inline-block;\n  position: relative;\n  width: 8px; }\n  .TableHead__sortIcon__down___1Pusa {\n    position: absolute;\n    left: 0;\n    bottom: -2px;\n    width: 8px;\n    height: 8px; }\n  .TableHead__sortIcon__minus___2HftZ {\n    position: absolute;\n    left: 0;\n    bottom: 1px;\n    width: 8px;\n    height: 8px;\n    transform: rotate(90deg); }\n  .TableHead__sortIcon_desc___3J5ER {\n    transform: rotate(180deg) translate(-8px, 8px); }\n", ""]);

// exports
exports.locals = {
	"cell__sortIcon": "TableHead__cell__sortIcon___N8HKh",
	"cell_unsortable": "TableHead__cell_unsortable___o_c0c",
	"sortIcon": "TableHead__sortIcon___NhMiP",
	"sortIcon__down": "TableHead__sortIcon__down___1Pusa",
	"sortIcon__minus": "TableHead__sortIcon__minus___2HftZ",
	"sortIcon_desc": "TableHead__sortIcon_desc___3J5ER"
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableBodySpinner;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableBody = __webpack_require__(254);

var _TableBody2 = _interopRequireDefault(_TableBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_HEIGHT = 40;

function TableBodySpinner(_ref) {
    var colSpan = _ref.colSpan,
        height = _ref.height,
        top = _ref.top,
        bottom = _ref.bottom;

    var viewHeight = window.innerHeight;
    var center = function () {
        // We see the table bottom
        if (top < 0 && bottom > 0 && bottom < viewHeight) {
            return Math.abs(top) + bottom / 2;
        }

        // We see the table body between top and bottom
        if (top < 0 && bottom >= viewHeight) {
            return Math.abs(top) + viewHeight / 2;
        }

        // We see the table top
        if (top >= 0 && bottom > viewHeight) {
            return (viewHeight - top) / 2;
        }

        // We see the whole table or we don't see it at all
        return height / 2;
    }();
    var paddingTop = Math.floor(center - ICON_HEIGHT / 2);
    return _react2.default.createElement(
        _TableRow2.default,
        null,
        _react2.default.createElement(
            _TableCell2.default,
            {
                className: _TableBody2.default.spinner__cell,
                colSpan: colSpan,
                style: {
                    paddingTop: paddingTop,
                    height: height
                }
            },
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _TableBody2.default.spinner__icon,
                size: '2XL',
                iconName: 'spinner'
            })
        )
    );
}

TableBodySpinner.propTypes = {
    colSpan: _propTypes2.default.number.isRequired,
    // table height
    height: _propTypes2.default.number,
    // space between top of current view and top of table
    top: _propTypes2.default.number,
    // space between top of current view and bottom of table
    bottom: _propTypes2.default.number
};

TableBodySpinner.defaultProps = {
    height: 72,
    top: 0,
    bottom: 0
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(255);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableBody.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableBody.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableBody__spinner__cell___2Tw_- {\n  padding: 0;\n  box-sizing: border-box;\n  vertical-align: top; }\n\n.TableBody__spinner__icon___368CM {\n  display: block;\n  margin: 0 auto;\n  -webkit-animation-name: TableBody__spinner___3krV0;\n  animation-name: TableBody__spinner___3krV0;\n  -webkit-animation-duration: .8s;\n  animation-duration: .8s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  background-size: cover; }\n", ""]);

// exports
exports.locals = {
	"spinner__cell": "TableBody__spinner__cell___2Tw_-",
	"spinner__icon": "TableBody__spinner__icon___368CM",
	"spinner": "TableBody__spinner___3krV0"
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableBodyPlaceholder;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableBodyPlaceholder(_ref) {
    var children = _ref.children,
        colSpan = _ref.colSpan;

    return _react2.default.createElement(
        _TableRow2.default,
        null,
        _react2.default.createElement(
            _TableCell2.default,
            {
                className: 'ui-table__cell_errorMessage',
                colSpan: colSpan
            },
            _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__icon' },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    children
                )
            )
        )
    );
}

TableBodyPlaceholder.propTypes = {
    children: _propTypes2.default.node.isRequired,
    colSpan: _propTypes2.default.number.isRequired
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(258);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableRowConstructor.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableRowConstructor.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableRowConstructor__expansion__cell___R9jOw {\n  border-bottom: 1px solid #F0EFF1; }\n\n.TableRowConstructor__expansion__table___2EbfQ {\n  width: 100%;\n  margin: 0;\n  padding: 0; }\n", ""]);

// exports
exports.locals = {
	"expansion__cell": "TableRowConstructor__expansion__cell___R9jOw",
	"expansion__table": "TableRowConstructor__expansion__table___2EbfQ"
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableToggle;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableToggle = __webpack_require__(260);

var _TableToggle2 = _interopRequireDefault(_TableToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableToggle(_ref) {
    var identity = _ref.identity,
        expanded = _ref.expanded,
        onToggle = _ref.onToggle;

    return _react2.default.createElement(
        'button',
        {
            className: '' + _TableToggle2.default.root,
            onClick: function onClick() {
                return onToggle(identity);
            }
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: 'tableShowIcon ' + _TableToggle2.default.icon,
            size: 'Medium',
            iconName: expanded ? 'up' : 'down'
        })
    );
}

TableToggle.propTypes = {
    identity: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    expanded: _propTypes2.default.bool.isRequired,
    onToggle: _propTypes2.default.func.isRequired
};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(261);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableToggle.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableToggle.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableToggle__root___EosCd {\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer; }\n\n.TableToggle__icon___3LCff {\n  vertical-align: middle;\n  fill: #D11F25; }\n", ""]);

// exports
exports.locals = {
	"root": "TableToggle__root___EosCd",
	"icon": "TableToggle__icon___3LCff"
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellLot;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellLot(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'span',
        null,
        data.lot_no,
        data.lot_letter
    );
}

CellLot.propTypes = {
    data: _propTypes2.default.shape({
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TYPE_HORSE = undefined;
exports.default = ProfileLink;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _url = __webpack_require__(30);

var _ProfileLink = __webpack_require__(270);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPE_HORSE = exports.TYPE_HORSE = 'horse';

function ProfileLink(_ref) {
    var className = _ref.className,
        children = _ref.children,
        type = _ref.type,
        uid = _ref.uid,
        name = _ref.name,
        bold = _ref.bold;

    if (!uid || !name) {
        if (!children) {
            return null;
        }
        return _react2.default.createElement(
            'span',
            {
                className: (0, _classnames2.default)(_ProfileLink2.default.root, className)
            },
            children
        );
    }
    return _react2.default.createElement(
        'a',
        {
            className: (0, _classnames2.default)('js-popupLink ui-link ui-link_table', _ProfileLink2.default.root, _ProfileLink2.default.root_link, bold && _ProfileLink2.default.root_bold, className),
            href: (0, _url.profileUrl)(type, uid, name)
        },
        children,
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: _ProfileLink2.default.icon,
            iconName: 'right'
        })
    );
}

ProfileLink.TYPE_HORSE = TYPE_HORSE;

ProfileLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    type: _propTypes2.default.oneOf([TYPE_HORSE]).isRequired,
    uid: _propTypes2.default.number,
    name: _propTypes2.default.string,
    bold: _propTypes2.default.bool
};

ProfileLink.defaultProps = {
    className: '',
    children: null,
    uid: null,
    name: null,
    bold: false
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(265);
var util = __webpack_require__(266);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(267);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module), __webpack_require__(47)))

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(268);
exports.encode = exports.stringify = __webpack_require__(269);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(271);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./ProfileLink.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./ProfileLink.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.ProfileLink__root___8nP9M {\n  font-weight: normal !important; }\n  .ProfileLink__root_bold___3Wx2I {\n    font-family: \"proxima-nova-a-bold\", sans-serif; }\n  .ProfileLink__root_link___OjVS2 {\n    color: #171717; }\n", ""]);

// exports
exports.locals = {
	"root": "ProfileLink__root___8nP9M",
	"root_bold": "ProfileLink__root_bold___3Wx2I",
	"root_link": "ProfileLink__root_link___OjVS2"
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDamDamsSire;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CellDam = __webpack_require__(78);

var _CellDam2 = _interopRequireDefault(_CellDam);

var _CellDamsSire = __webpack_require__(79);

var _CellDamsSire2 = _interopRequireDefault(_CellDamsSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDamDamsSire(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_CellDam2.default, { data: data })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_CellDamsSire2.default, { data: data })
        )
    );
}

CellDamDamsSire.propTypes = {
    // data is a row with dam and dam's sire data
    // see CellDam and CellDamsSire for details
    data: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellPrice;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CellPrice = __webpack_require__(274);

var _CellPrice2 = _interopRequireDefault(_CellPrice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CellPrice(_ref) {
    var data = _ref.data,
        bold = _ref.bold;

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames3.default)(_CellPrice2.default.root, _defineProperty({}, _CellPrice2.default.root_bold, bold))
        },
        data.price_styled_long
    );
}

CellPrice.propTypes = {
    data: _propTypes2.default.shape({
        price_styled_long: _propTypes2.default.string
    }).isRequired,
    bold: _propTypes2.default.bool
};

CellPrice.defaultProps = {
    bold: true
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(275);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellPrice.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellPrice.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.CellPrice__root_bold___1bHHe {\n  font-family: \"proxima-nova-a-bold\", sans-serif; }\n", ""]);

// exports
exports.locals = {
	"root_bold": "CellPrice__root_bold___1bHHe"
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.toggleShortlist = toggleShortlist;
exports.toggleNote = toggleNote;
exports.fetchNote = fetchNote;
exports.submitNote = submitNote;
exports.bindCatalogue = bindCatalogue;

var _qs = __webpack_require__(26);

var _qs2 = _interopRequireDefault(_qs);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpNavigation = __webpack_require__(277);

var _api = __webpack_require__(7);

var _ugc = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var promise = null;
var catalogue = [];
var listeners = [];

function notify() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
        return listener.apply(undefined, args);
    });
}

function fetchCatalogue() {
    return _rpNavigation.authReady.then(function (auth) {
        if (auth.user.isLoggedIn) {
            return (0, _api.callApi)('/bloodstock/sales/ugc/catalogue/data.json').then(function (data) {
                notify(catalogue = [].concat(_toConsumableArray(data)));
            });
        }
        return null;
    });
}

function changeCatalogue(payload) {
    var venueId = payload.venueId,
        saleDate = payload.saleDate,
        lotNo = payload.lotNo,
        lotLetter = payload.lotLetter;

    var foundItem = (0, _ugc.findCatalogueItem)(catalogue, venueId, saleDate, lotNo, lotLetter);
    catalogue = catalogue.filter(function (item) {
        return item !== foundItem;
    }).concat(_extends({}, (0, _ugc.getDefaultCatalogueItem)(catalogue, venueId, saleDate, lotNo, lotLetter), foundItem, payload));
    notify(catalogue);
}

function toggleShortlist(venueId, saleDate, lotNo, lotLetter, shortlist) {
    var query = { lotNo: lotNo, lotLetter: lotLetter };
    var url = '/bloodstock/sales/ugc/shortlist/' + venueId + '/' + saleDate;
    return _rpNavigation.authReady.then(function () {
        return (0, _rpNavigation.checkForAccess)('SignIn', true, true, {
            text: 'Please sign in to edit your shortlist',
            r: window.location.origin + '/bloodstock/sales/my-shortlist'
        }).then(function (hasAccess) {
            return hasAccess && (0, _api.callApi)(url, { query: query, method: shortlist ? 'PUT' : 'DELETE' }).then(function () {
                return changeCatalogue({
                    venueId: venueId,
                    saleDate: saleDate,
                    lotNo: lotNo,
                    lotLetter: lotLetter,
                    shortlist: shortlist
                });
            });
        });
    });
}

function toggleNote(sireUrl) {
    return _rpNavigation.authReady.then(function () {
        return (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, { r: '' + window.location.origin + sireUrl + '/notes' });
    });
}

function fetchNote(venueId, saleDate, lotNo, lotLetter) {
    var query = {
        lotNo: lotNo,
        lotLetter: lotLetter || ' '
    };
    return (0, _api.callApi)('/bloodstock/sales/ugc/notes/' + venueId + '/' + saleDate, { query: query });
}

function submitNote(venueId, saleDate, lotNo, lotLetter, comment, rating) {
    var url = '/bloodstock/sales/ugc/notes/' + venueId + '/' + saleDate;
    var init = {
        method: 'PUT',
        body: _qs2.default.stringify({
            lotNo: lotNo,
            lotLetter: lotLetter,
            comment: comment,
            rating: rating
        })
    };
    return (0, _api.callApi)(url, init).then(function () {
        return changeCatalogue({
            venueId: venueId,
            saleDate: saleDate,
            lotNo: lotNo,
            lotLetter: lotLetter,
            note: !!comment || !!rating
        });
    });
}

function bindCatalogue(Component) {
    var makeProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (data) {
        return { catalogue: data };
    };

    return function (_PureComponent) {
        _inherits(UGC, _PureComponent);

        function UGC() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, UGC);

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UGC.__proto__ || Object.getPrototypeOf(UGC)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
                data: [].concat(_toConsumableArray(catalogue))
            }, _this.listener = function (data) {
                return _this.setState({ data: data });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(UGC, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                listeners = listeners.concat(this.listener);

                if (!promise) {
                    promise = fetchCatalogue();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var _this2 = this;

                listeners = listeners.filter(function (listener) {
                    return listener !== _this2.listener;
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var data = this.state.data;

                return _react2.default.createElement(Component, _extends({}, this.props, makeProps(data, this.props)));
            }
        }]);

        return UGC;
    }(_react.PureComponent);
}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_277__;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(279),
    getMatchData = __webpack_require__(280);

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(45),
    baseIsEqual = __webpack_require__(44);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(281),
    keys = __webpack_require__(36);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(283);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellHorseUGC.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellHorseUGC.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".CellHorseUGC__root___38-wt {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n\n.CellHorseUGC__horse___lQhmn {\n  flex: 1;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto; }\n\n.CellHorseUGC__ugc___3ZN7o {\n  display: flex; }\n\n.CellHorseUGC__icon___320nt {\n  margin-left: 4px;\n  fill: #D11F25; }\n", ""]);

// exports
exports.locals = {
	"root": "CellHorseUGC__root___38-wt",
	"horse": "CellHorseUGC__horse___lQhmn",
	"ugc": "CellHorseUGC__ugc___3ZN7o",
	"icon": "CellHorseUGC__icon___320nt"
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellHorseSireUGC;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CellHorseUGC = __webpack_require__(80);

var _CellHorseUGC2 = _interopRequireDefault(_CellHorseUGC);

var _CellSire = __webpack_require__(77);

var _CellSire2 = _interopRequireDefault(_CellSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellHorseSireUGC(props) {
    return _react2.default.createElement(
        _CellHorseUGC2.default,
        props,
        _react2.default.createElement(_CellSire2.default, { data: props.data, bold: true })
    );
}

CellHorseSireUGC.propTypes = {
    data: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDateSale;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDateSale(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            null,
            data.sale_date
        ),
        _react2.default.createElement(
            'div',
            null,
            data.sale_name
        )
    );
}

CellDateSale.propTypes = {
    data: _propTypes2.default.shape({
        sale_date: _propTypes2.default.string,
        sale_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellRace;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _url = __webpack_require__(30);

var _CellRace = __webpack_require__(287);

var _CellRace2 = _interopRequireDefault(_CellRace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellRace(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'a',
        {
            className: 'js-popupLink ui-link ui-link_primary ' + _CellRace2.default.root,
            href: (0, _url.raceUrl)(data.course_uid, data.course_style_name, data.race_date, data.race_instance_uid)
        },
        data.title
    );
}

CellRace.propTypes = {
    data: _propTypes2.default.shape({
        race_instance_uid: _propTypes2.default.number.isRequired,
        race_date: _propTypes2.default.string.isRequired,
        course_uid: _propTypes2.default.number.isRequired,
        course_style_name: _propTypes2.default.string.isRequired,
        title: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(288);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellRace.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellRace.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".CellRace__root___lJMCF {\n  color: #D11F25 !important; }\n", ""]);

// exports
exports.locals = {
	"root": "CellRace__root___lJMCF"
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesRow;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Relatives = __webpack_require__(83);

var _Relatives2 = _interopRequireDefault(_Relatives);

var _url = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesRow(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(_Relatives2.default, {
        damUid: data.dam_uid,
        venueId: data.venue_uid,
        saleDate: data.sale_date_raw,
        saleEndDate: data.sale_date_raw,
        birthDate: data.dam_date_of_birth,
        lotNo: data.lot_no,
        lotLetter: data.lot_letter,
        catalogueUrl: data.catalogue_pedigree_pdf_url,
        sireUrl: (0, _url.profileUrl)('horse', data.sire_uid, data.sire_style_name)
    });
}

RelativesRow.propTypes = {
    data: _propTypes2.default.shape({
        dam_uid: _propTypes2.default.number,
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired,
        catalogue_pedigree_pdf_url: _propTypes2.default.string,
        dam_date_of_birth: _propTypes2.default.string,
        sire_uid: _propTypes2.default.string,
        sire_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _Actions = __webpack_require__(301);

var _Actions2 = _interopRequireDefault(_Actions);

var _Results = __webpack_require__(341);

var _Results2 = _interopRequireDefault(_Results);

var _Entries = __webpack_require__(362);

var _Entries2 = _interopRequireDefault(_Entries);

var _Sales = __webpack_require__(366);

var _Sales2 = _interopRequireDefault(_Sales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relatives = function (_PureComponent) {
    _inherits(Relatives, _PureComponent);

    function Relatives() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Relatives);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Relatives.__proto__ || Object.getPrototypeOf(Relatives)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            tab: _Tab2.default.TAB_RESULTS
        }, _this.handleTabChange = function (tab) {
            return _this.setState({ tab: tab });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Relatives, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                venueId = _props.venueId,
                saleDate = _props.saleDate,
                saleEndDate = _props.saleEndDate,
                lotNo = _props.lotNo,
                lotLetter = _props.lotLetter,
                damUid = _props.damUid,
                catalogueUrl = _props.catalogueUrl,
                showShortlist = _props.showShortlist,
                birthDate = _props.birthDate,
                sireUrl = _props.sireUrl;
            var tab = this.state.tab;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Actions2.default, {
                    venueId: venueId,
                    saleDate: saleDate,
                    saleEndDate: saleEndDate,
                    lotNo: lotNo,
                    lotLetter: lotLetter,
                    catalogueUrl: catalogueUrl,
                    showShortlist: showShortlist,
                    sireUrl: sireUrl
                }),
                function () {
                    switch (tab) {
                        case _Tab2.default.TAB_RESULTS:
                            return _react2.default.createElement(_Results2.default, {
                                damUid: damUid,
                                onTabChange: _this2.handleTabChange
                            });
                        case _Tab2.default.TAB_ENTRIES:
                            return _react2.default.createElement(_Entries2.default, {
                                damUid: damUid,
                                onTabChange: _this2.handleTabChange
                            });
                        case _Tab2.default.TAB_SALES:
                            return _react2.default.createElement(_Sales2.default, {
                                venueId: venueId,
                                lotNo: lotNo,
                                damUid: damUid,
                                birthDate: birthDate,
                                saleDate: saleDate,
                                onTabChange: _this2.handleTabChange
                            });
                        default:
                            throw new Error('Unknown tab ' + tab);
                    }
                }()
            );
        }
    }]);

    return Relatives;
}(_react.PureComponent);

Relatives.propTypes = {
    damUid: _propTypes2.default.number.isRequired,
    venueId: _propTypes2.default.number.isRequired,
    saleDate: _propTypes2.default.string.isRequired,
    saleEndDate: _propTypes2.default.string.isRequired,
    birthDate: _propTypes2.default.string.isRequired,
    lotNo: _propTypes2.default.number.isRequired,
    lotLetter: _propTypes2.default.string,
    catalogueUrl: _propTypes2.default.string,
    showShortlist: _propTypes2.default.bool,
    sireUrl: _propTypes2.default.string.isRequired
};
Relatives.defaultProps = {
    lotLetter: ' ',
    catalogueUrl: null,
    showShortlist: true
};
exports.default = Relatives;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesTab;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Switch = __webpack_require__(292);

var _Switch2 = _interopRequireDefault(_Switch);

var _RelativesTab = __webpack_require__(299);

var _RelativesTab2 = _interopRequireDefault(_RelativesTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesTab(_ref) {
    var children = _ref.children,
        tab = _ref.tab,
        filter = _ref.filter,
        onTabChange = _ref.onTabChange;

    return _react2.default.createElement(
        'div',
        { className: _RelativesTab2.default.root },
        _react2.default.createElement(
            'div',
            { className: _RelativesTab2.default.toolbar },
            _react2.default.createElement(_Switch2.default, {
                className: _RelativesTab2.default.switch,
                value: tab,
                onChange: onTabChange
            }),
            _react2.default.createElement(
                'div',
                { className: _RelativesTab2.default.filter },
                filter
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _RelativesTab2.default.content },
            children
        )
    );
}

RelativesTab.TAB_RESULTS = _Switch2.default.TAB_RESULTS;
RelativesTab.TAB_ENTRIES = _Switch2.default.TAB_ENTRIES;
RelativesTab.TAB_SALES = _Switch2.default.TAB_SALES;

RelativesTab.propTypes = {
    children: _propTypes2.default.node.isRequired,
    tab: _propTypes2.default.string.isRequired,
    filter: _propTypes2.default.node,
    onTabChange: _propTypes2.default.func.isRequired
};

RelativesTab.defaultProps = {
    filter: null
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesTabSwitch = __webpack_require__(293);

var _RelativesTabSwitch2 = _interopRequireDefault(_RelativesTabSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesTabSwitch2.default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSwitch;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Switch = __webpack_require__(294);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAB_RESULTS = 'TAB_RESULTS';
var TAB_ENTRIES = 'TAB_ENTRIES';
var TAB_SALES = 'TAB_SALES';

var options = [{ value: TAB_RESULTS, label: 'Results' }, { value: TAB_ENTRIES, label: 'Entries' }, { value: TAB_SALES, label: 'Sales' }];

function RelativesSwitch(_ref) {
    var className = _ref.className,
        value = _ref.value,
        onChange = _ref.onChange;

    return _react2.default.createElement(_Switch2.default, {
        className: className,
        title: 'Relatives',
        options: options,
        value: value,
        onChange: onChange
    });
}

RelativesSwitch.TAB_RESULTS = TAB_RESULTS;
RelativesSwitch.TAB_ENTRIES = TAB_ENTRIES;
RelativesSwitch.TAB_SALES = TAB_SALES;

RelativesSwitch.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

RelativesSwitch.defaultProps = {
    className: '',
    value: null
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(295);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Switch2.default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Switch;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SwitchItem = __webpack_require__(296);

var _SwitchItem2 = _interopRequireDefault(_SwitchItem);

var _Switch = __webpack_require__(297);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Switch(_ref) {
    var className = _ref.className,
        title = _ref.title,
        options = _ref.options,
        value = _ref.value,
        onChange = _ref.onChange;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Switch2.default.switch, className) },
        title && _react2.default.createElement(
            'div',
            {
                className: _Switch2.default.switch__title
            },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: 'ui-switcher' },
            options.map(function (option) {
                return _react2.default.createElement(_SwitchItem2.default, _extends({
                    key: option.value,
                    active: option.value === value,
                    onClick: onChange
                }, option));
            })
        )
    );
}

Switch.propTypes = {
    className: _propTypes2.default.string,
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.string.isRequired
    })).isRequired,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

Switch.defaultProps = {
    className: '',
    title: null,
    value: null
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switch = function (_PureComponent) {
    _inherits(Switch, _PureComponent);

    function Switch() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Switch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            return _this.props.onClick(_this.props.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Switch, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                active = _props.active;

            return _react2.default.createElement(
                'button',
                {
                    className: (0, _classnames2.default)('ui-switcher__btn ui-btn ui-btn_xl', active ? 'ui-btn_primary' : 'ui-btn_secondary'),
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'span',
                    { className: 'ui-switcher__title' },
                    label
                )
            );
        }
    }]);

    return Switch;
}(_react.PureComponent);

Switch.propTypes = {
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    value: _propTypes2.default.string.isRequired,
    active: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};
Switch.defaultProps = {
    active: false
};
exports.default = Switch;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(298);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Switch.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Switch.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.Switch__switch___3zjYZ {\n  display: flex;\n  align-items: center; }\n  .Switch__switch__title___1Surx {\n    font: 16px/22px \"proxima-nova-a\", sans-serif;\n    margin: 0 8px 0 0; }\n", ""]);

// exports
exports.locals = {
	"switch": "Switch__switch___3zjYZ",
	"switch__title": "Switch__switch__title___1Surx"
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(300);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesTab.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesTab.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RelativesTab__root___34W1u {\n  padding: 0 8px 8px; }\n\n.RelativesTab__toolbar___1hEo5 {\n  display: flex;\n  justify-content: space-between; }\n  @media (max-width: 719.9px) {\n    .RelativesTab__toolbar___1hEo5 {\n      flex-direction: column; } }\n\n.RelativesTab__switch___2aJLf, .RelativesTab__filter___3ZnBa {\n  margin-top: 8px; }\n\n.RelativesTab__content___2uRcZ {\n  margin-top: 24px; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesTab__root___34W1u",
	"toolbar": "RelativesTab__toolbar___1hEo5",
	"switch": "RelativesTab__switch___2aJLf",
	"filter": "RelativesTab__filter___3ZnBa",
	"content": "RelativesTab__content___2uRcZ"
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActions = __webpack_require__(302);

var _RelativesActions2 = _interopRequireDefault(_RelativesActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActions2.default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _is_past = __webpack_require__(303);

var _is_past2 = _interopRequireDefault(_is_past);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _UGC = __webpack_require__(42);

var _Shortlist = __webpack_require__(304);

var _Shortlist2 = _interopRequireDefault(_Shortlist);

var _Note = __webpack_require__(308);

var _Note2 = _interopRequireDefault(_Note);

var _NoteForm = __webpack_require__(312);

var _NoteForm2 = _interopRequireDefault(_NoteForm);

var _Link = __webpack_require__(334);

var _Link2 = _interopRequireDefault(_Link);

var _RelativesActions = __webpack_require__(338);

var _RelativesActions2 = _interopRequireDefault(_RelativesActions);

var _externalResources = __webpack_require__(340);

var _externalResources2 = _interopRequireDefault(_externalResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelativesActions = function (_PureComponent) {
    _inherits(RelativesActions, _PureComponent);

    function RelativesActions() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesActions);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesActions.__proto__ || Object.getPrototypeOf(RelativesActions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            noteOpen: false
        }, _this.handleShortlistClick = function () {
            var _this$props = _this.props,
                venueId = _this$props.venueId,
                saleDate = _this$props.saleDate,
                lotNo = _this$props.lotNo,
                lotLetter = _this$props.lotLetter,
                shortlist = _this$props.shortlist;

            return (0, _UGC.toggleShortlist)(venueId, saleDate, lotNo, lotLetter, !shortlist);
        }, _this.handleNoteClick = function () {
            (0, _UGC.toggleNote)(_this.props.sireUrl).then(function (access) {
                _this.setState({
                    noteOpen: access
                });
            });
        }, _this.handleNoteFormFetch = function () {
            var _this$props2 = _this.props,
                venueId = _this$props2.venueId,
                saleDate = _this$props2.saleDate,
                lotNo = _this$props2.lotNo,
                lotLetter = _this$props2.lotLetter;

            return (0, _UGC.fetchNote)(venueId, saleDate, lotNo, lotLetter);
        }, _this.handleNoteFormSubmit = function (_ref2) {
            var comment = _ref2.comment,
                rating = _ref2.rating;
            var _this$props3 = _this.props,
                venueId = _this$props3.venueId,
                saleDate = _this$props3.saleDate,
                lotNo = _this$props3.lotNo,
                lotLetter = _this$props3.lotLetter;

            return (0, _UGC.submitNote)(venueId, saleDate, lotNo, lotLetter, comment, rating);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesActions, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.noteOpen && !this.isNoteAvailable(nextProps)) {
                this.setState({ noteOpen: false });
            }
        }
    }, {
        key: 'isShortlistAvailable',
        value: function isShortlistAvailable() {
            return this.props.showShortlist && (this.props.shortlist || !(0, _is_past2.default)(this.props.saleEndDate));
        }
    }, {
        key: 'isNoteAvailable',
        value: function isNoteAvailable() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.note || !(0, _is_past2.default)(props.saleEndDate);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                shortlist = _props.shortlist,
                note = _props.note,
                catalogueUrl = _props.catalogueUrl;

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _RelativesActions2.default.panel },
                    _react2.default.createElement(
                        'div',
                        { className: _RelativesActions2.default.group },
                        this.isShortlistAvailable() && _react2.default.createElement(_Shortlist2.default, {
                            className: _RelativesActions2.default.action,
                            shortlist: shortlist,
                            onClick: this.handleShortlistClick
                        }),
                        this.isNoteAvailable() && _react2.default.createElement(_Note2.default, {
                            className: _RelativesActions2.default.action,
                            note: note,
                            onClick: this.handleNoteClick
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _RelativesActions2.default.group },
                        catalogueUrl && _react2.default.createElement(_Link2.default, {
                            className: _RelativesActions2.default.action,
                            href: catalogueUrl,
                            label: 'Catalogue page',
                            iconClassName: 'tableShowIcon ' + _RelativesActions2.default.catalogueIcon,
                            icon: 'pdf'
                        }),
                        _react2.default.createElement(_Link2.default, {
                            className: _RelativesActions2.default.action,
                            href: _externalResources2.default.BLOODSTOCK_REPORTS,
                            label: 'Weatherbys Pedigree',
                            iconClassName: 'tableShowIcon',
                            icon: 'weatherby'
                        })
                    )
                ),
                this.state.noteOpen && _react2.default.createElement(
                    'div',
                    { className: _RelativesActions2.default.form },
                    _react2.default.createElement(_NoteForm2.default, {
                        onFetch: this.handleNoteFormFetch,
                        onSubmit: this.handleNoteFormSubmit
                    })
                )
            );
        }
    }]);

    return RelativesActions;
}(_react.PureComponent);

RelativesActions.propTypes = {
    className: _propTypes2.default.string,
    venueId: _propTypes2.default.number.isRequired,
    saleDate: _propTypes2.default.string.isRequired,
    saleEndDate: _propTypes2.default.string.isRequired,
    lotNo: _propTypes2.default.number.isRequired,
    lotLetter: _propTypes2.default.string,
    shortlist: _propTypes2.default.bool.isRequired,
    note: _propTypes2.default.bool.isRequired,
    catalogueUrl: _propTypes2.default.string,
    showShortlist: _propTypes2.default.bool,
    sireUrl: _propTypes2.default.string.isRequired
};
RelativesActions.defaultProps = {
    className: '',
    lotLetter: ' ',
    catalogueUrl: null,
    showShortlist: true,
    lightbox: null
};
exports.default = (0, _UGC.bindCatalogue)(RelativesActions, function (catalogue, ownProps) {
    var venueId = ownProps.venueId,
        saleDate = ownProps.saleDate,
        lotNo = ownProps.lotNo,
        lotLetter = ownProps.lotLetter;

    var _getCatalogueItemSafe = (0, _UGC.getCatalogueItemSafe)(catalogue, venueId, saleDate, lotNo, lotLetter),
        shortlist = _getCatalogueItemSafe.shortlist,
        note = _getCatalogueItemSafe.note;

    return { shortlist: shortlist, note: note };
});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsShortlist = __webpack_require__(305);

var _RelativesActionsShortlist2 = _interopRequireDefault(_RelativesActionsShortlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsShortlist2.default;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isFunction2 = __webpack_require__(15);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _classnames3 = __webpack_require__(5);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _api = __webpack_require__(7);

var _RelativesActionsShortlist = __webpack_require__(306);

var _RelativesActionsShortlist2 = _interopRequireDefault(_RelativesActionsShortlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelativesActionsShortlist = function (_PureComponent) {
    _inherits(RelativesActionsShortlist, _PureComponent);

    function RelativesActionsShortlist() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesActionsShortlist);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesActionsShortlist.__proto__ || Object.getPrototypeOf(RelativesActionsShortlist)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            toggling: false
        }, _this.handleButtonClick = function () {
            var result = _this.props.onClick();
            if ((0, _isFunction3.default)(result.then) && (0, _isFunction3.default)(result.catch)) {
                _this.setState({ toggling: true });
                result.catch(function (resp) {
                    return !(0, _api.isUnauthorized)(resp);
                }).then(function (payload) {
                    return _this.setState(_extends({}, payload, { toggling: false }));
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesActionsShortlist, [{
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                className = _props.className,
                shortlist = _props.shortlist;
            var toggling = this.state.toggling;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames4.default)(_RelativesActionsShortlist2.default.button, className, 'ui-btn ui-btn_tiertiary'),
                        disabled: toggling,
                        onClick: this.handleButtonClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, _RelativesActionsShortlist2.default.icon, true), _defineProperty(_classnames, _RelativesActionsShortlist2.default.icon_highlighted, !shortlist), _classnames)),
                        size: 'Medium',
                        iconName: 'starHollow'
                    }),
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, _RelativesActionsShortlist2.default.icon, true), _defineProperty(_classnames2, _RelativesActionsShortlist2.default.icon_highlighted, shortlist), _classnames2)),
                        size: 'Medium',
                        iconName: 'starFilled'
                    }),
                    'Add to My Shortlist'
                )
            );
        }
    }]);

    return RelativesActionsShortlist;
}(_react.PureComponent);

RelativesActionsShortlist.propTypes = {
    className: _propTypes2.default.string,
    shortlist: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};
RelativesActionsShortlist.defaultProps = {
    className: ''
};
exports.default = RelativesActionsShortlist;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(307);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsShortlist.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsShortlist.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsShortlist__button___TdsFl {\n  display: flex;\n  align-items: center;\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  height: 24px; }\n\n.RelativesActionsShortlist__icon___1xV8x {\n  margin-right: 4px;\n  display: none; }\n  .RelativesActionsShortlist__icon_highlighted___1wEyA {\n    fill: #D11F25;\n    display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"button": "RelativesActionsShortlist__button___TdsFl",
	"icon": "RelativesActionsShortlist__icon___1xV8x",
	"icon_highlighted": "RelativesActionsShortlist__icon_highlighted___1wEyA"
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsNote = __webpack_require__(309);

var _RelativesActionsNote2 = _interopRequireDefault(_RelativesActionsNote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsNote2.default;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesActionsNote;

var _classnames3 = __webpack_require__(5);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _RelativesActionsNote = __webpack_require__(310);

var _RelativesActionsNote2 = _interopRequireDefault(_RelativesActionsNote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function RelativesActionsNote(_ref) {
    var _classnames, _classnames2;

    var className = _ref.className,
        note = _ref.note,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'button',
        {
            className: (0, _classnames4.default)(_RelativesActionsNote2.default.root, className, 'ui-btn ui-btn_tiertiary'),
            onClick: onClick
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, _RelativesActionsNote2.default.icon, true), _defineProperty(_classnames, _RelativesActionsNote2.default.icon_highlighted, !note), _classnames)),
            size: 'Medium',
            iconName: 'note'
        }),
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, _RelativesActionsNote2.default.icon, true), _defineProperty(_classnames2, _RelativesActionsNote2.default.icon_highlighted, note), _classnames2)),
            size: 'Medium',
            iconName: 'note-dark'
        }),
        note ? 'View/edit notes' : 'Add a note'
    );
}

RelativesActionsNote.propTypes = {
    className: _propTypes2.default.string,
    note: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

RelativesActionsNote.defaultProps = {
    className: ''
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(311);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNote.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNote.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsNote__root___ux4Zm {\n  display: flex;\n  align-items: center;\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  height: 24px; }\n\n.RelativesActionsNote__icon___25eG0 {\n  margin-right: 4px;\n  display: none; }\n  .RelativesActionsNote__icon_highlighted___1vQ3Q {\n    fill: #D11F25;\n    display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesActionsNote__root___ux4Zm",
	"icon": "RelativesActionsNote__icon___25eG0",
	"icon_highlighted": "RelativesActionsNote__icon_highlighted___1vQ3Q"
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsNoteForm = __webpack_require__(313);

var _RelativesActionsNoteForm2 = _interopRequireDefault(_RelativesActionsNoteForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsNoteForm2.default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual2 = __webpack_require__(32);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _isFunction2 = __webpack_require__(15);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _trim2 = __webpack_require__(314);

var _trim3 = _interopRequireDefault(_trim2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTextareaAutosize = __webpack_require__(320);

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Rate = __webpack_require__(321);

var _Rate2 = _interopRequireDefault(_Rate);

var _Lightbox = __webpack_require__(325);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _api = __webpack_require__(7);

var _RelativesActionsNoteForm = __webpack_require__(332);

var _RelativesActionsNoteForm2 = _interopRequireDefault(_RelativesActionsNoteForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LIGHTBOX_SUBMIT_FAILURE = 'submitFailure';

var RelativesActionsNoteForm = function (_PureComponent) {
    _inherits(RelativesActionsNoteForm, _PureComponent);

    function RelativesActionsNoteForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesActionsNoteForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesActionsNoteForm.__proto__ || Object.getPrototypeOf(RelativesActionsNoteForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, RelativesActionsNoteForm.nilValue, {
            lightbox: null,
            mounting: false,
            submitting: false,
            submitted: false
        }), _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.submit();
        }, _this.handleCommentChange = function (e) {
            return _this.setState({ comment: e.target.value });
        }, _this.handleRatingChange = function (rating) {
            return _this.setState({ rating: rating });
        }, _this.handleRatingClear = function () {
            return _this.setState({ rating: RelativesActionsNoteForm.nilValue.rating });
        }, _this.handleClear = function () {
            return _this.setState(RelativesActionsNoteForm.nilValue);
        }, _this.handleHereClick = function () {
            _this.fetch();
            _this.closeLightbox();
        }, _this.handleLightboxClose = function () {
            return _this.closeLightbox();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesActionsNoteForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetch();
        }
    }, {
        key: 'fetch',
        value: function fetch() {
            var _this2 = this;

            var result = this.props.onFetch();
            if ((0, _isFunction3.default)(result.then) && (0, _isFunction3.default)(result.catch)) {
                this.setState({ mounting: true }); // eslint-disable-line react/no-did-mount-set-state
                result.then(function (data) {
                    _this2.srvValue = RelativesActionsNoteForm.getValue(data);
                    return _this2.srvValue;
                }).catch(function (resp) {
                    return !(0, _api.isUnauthorized)(resp);
                }).then(function (payload) {
                    _this2.setState(_extends({}, payload, { mounting: false }));
                });
            }
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this3 = this;

            var value = RelativesActionsNoteForm.getValue(this.state);
            var result = this.props.onSubmit(value);
            if ((0, _isFunction3.default)(result.then) && (0, _isFunction3.default)(result.catch)) {
                this.setState({ submitting: true });
                result.then(function () {
                    _this3.srvValue = value;
                    return { submitted: true };
                }).catch(function (resp) {
                    return !(0, _api.isUnauthorized)(resp) && { lightbox: LIGHTBOX_SUBMIT_FAILURE };
                }).then(function (payload) {
                    return _this3.setState(_extends({}, payload, { submitting: false }));
                });
            }
        }
    }, {
        key: 'closeLightbox',
        value: function closeLightbox() {
            this.setState({ lightbox: null });
        }
    }, {
        key: 'isSubmitDisabled',
        value: function isSubmitDisabled() {
            return this.state.submitting || (0, _isEqual3.default)(RelativesActionsNoteForm.getValue(this.state), this.srvValue);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                comment = _state.comment,
                rating = _state.rating,
                lightbox = _state.lightbox,
                mounting = _state.mounting,
                submitted = _state.submitted;

            var submitDisabled = this.isSubmitDisabled();

            if (mounting) {
                return _react2.default.createElement(_rpReactSvgIcon2.default, {
                    className: _RelativesActionsNoteForm2.default.spinner,
                    size: '2XL',
                    iconName: 'spinner'
                });
            }

            return _react2.default.createElement(
                'form',
                {
                    className: _RelativesActionsNoteForm2.default.root,
                    onSubmit: this.handleSubmit
                },
                _react2.default.createElement(_Lightbox2.default, {
                    open: lightbox === LIGHTBOX_SUBMIT_FAILURE,
                    title: 'Something\'s gone wrong and your changes could not be saved',
                    text: 'Press save to try again',
                    onClose: this.handleLightboxClose
                }),
                _react2.default.createElement(
                    'div',
                    { className: _RelativesActionsNoteForm2.default.content },
                    _react2.default.createElement(_reactTextareaAutosize2.default, {
                        className: _RelativesActionsNoteForm2.default.comment,
                        placeholder: 'add a note...',
                        value: comment,
                        onChange: this.handleCommentChange
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _RelativesActionsNoteForm2.default.rating },
                        'My Rating',
                        _react2.default.createElement(_Rate2.default, {
                            className: _RelativesActionsNoteForm2.default.ratingInput,
                            value: rating,
                            onChange: this.handleRatingChange
                        }),
                        _react2.default.createElement(
                            'button',
                            {
                                className: _RelativesActionsNoteForm2.default.ratingClear,
                                type: 'button',
                                onClick: this.handleRatingClear
                            },
                            _react2.default.createElement(_rpReactSvgIcon2.default, {
                                className: _RelativesActionsNoteForm2.default.ratingClearIcon,
                                size: 'Medium',
                                iconName: 'cross'
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _RelativesActionsNoteForm2.default.panel },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'ui-btn ui-btn_primary ui-btn_small ' + _RelativesActionsNoteForm2.default.panelButton,
                            type: 'submit',
                            disabled: submitDisabled
                        },
                        submitted && submitDisabled ? _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_rpReactSvgIcon2.default, {
                                className: _RelativesActionsNoteForm2.default.saveIcon,
                                iconName: 'tick',
                                size: 'Medium'
                            }),
                            'Saved'
                        ) : 'Save'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'ui-btn ui-btn_secondary ui-btn_small ' + _RelativesActionsNoteForm2.default.panelButton,
                            type: 'button',
                            onClick: this.handleClear
                        },
                        'Clear'
                    )
                )
            );
        }
    }], [{
        key: 'getValue',
        value: function getValue(_ref2) {
            var comment = _ref2.comment,
                rating = _ref2.rating;

            return {
                comment: (0, _trim3.default)(comment),
                rating: rating || 0
            };
        }
    }]);

    return RelativesActionsNoteForm;
}(_react.PureComponent);

RelativesActionsNoteForm.propTypes = {
    onFetch: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func.isRequired
};
RelativesActionsNoteForm.nilValue = {
    comment: '',
    rating: 0
};
exports.default = RelativesActionsNoteForm;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(62),
    castSlice = __webpack_require__(64),
    charsEndIndex = __webpack_require__(315),
    charsStartIndex = __webpack_require__(319),
    stringToArray = __webpack_require__(66),
    toString = __webpack_require__(25);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(84);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(84);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_320__;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rate = __webpack_require__(322);

var _Rate2 = _interopRequireDefault(_Rate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Rate2.default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Rate = __webpack_require__(323);

var _Rate2 = _interopRequireDefault(_Rate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rate = function (_PureComponent) {
    _inherits(Rate, _PureComponent);

    function Rate() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Rate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rate.__proto__ || Object.getPrototypeOf(Rate)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            return _this.props.onChange(Number(e.target.value));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Rate, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                value = _props.value;
            /* eslint-disable jsx-a11y/label-has-for */

            return _react2.default.createElement(
                'div',
                { className: _Rate2.default.root + ' ' + className },
                [5, 4, 3, 2, 1].map(function (i) {
                    var checked = i === value;
                    return _react2.default.createElement(
                        'label',
                        {
                            key: i,
                            className: (0, _classnames3.default)(_Rate2.default.tick, _defineProperty({}, _Rate2.default.tick_checked, checked))
                        },
                        _react2.default.createElement('input', {
                            className: _Rate2.default.input,
                            type: 'radio',
                            name: 'rating',
                            value: i,
                            checked: checked,
                            onChange: _this2.handleChange
                        }),
                        _react2.default.createElement(_rpReactSvgIcon2.default, {
                            className: _Rate2.default.icon,
                            iconName: 'tick'
                        })
                    );
                })
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    }]);

    return Rate;
}(_react.PureComponent);

exports.default = Rate;


Rate.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.number,
    onChange: _propTypes2.default.func.isRequired
};

Rate.defaultProps = {
    className: '',
    value: 0
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(324);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Rate.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Rate.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.Rate__root___2D5tX {\n  background: #FFFFFF;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  height: 16px;\n  width: 80px; }\n\n.Rate__tick___1hdWY {\n  background: #FFFFFF;\n  border: 1px solid #F0EFF1;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  transition: background linear 100ms; }\n  .Rate__tick___1hdWY:not(:last-of-type) {\n    border-width: 1px 1px 1px 0; }\n  .Rate__tick___1hdWY:last-of-type {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px; }\n  .Rate__tick___1hdWY:first-of-type {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px; }\n  .Rate__tick___1hdWY:hover,\n  .Rate__tick___1hdWY:hover ~ .Rate__tick___1hdWY, .Rate__tick_checked____Sjxo,\n  .Rate__tick_checked____Sjxo ~ .Rate__tick___1hdWY {\n    background-color: #2CB34A; }\n\n.Rate__input___2zgK8 {\n  display: none; }\n\n.Rate__icon___bb7_W {\n  height: 8px;\n  width: 8px;\n  fill: #F0EFF1;\n  transition: fill linear 100ms; }\n  .Rate__icon___bb7_W:hover {\n    fill: #F0EFF1; }\n\n.Rate__tick___1hdWY:hover > .Rate__icon___bb7_W,\n.Rate__tick___1hdWY:hover ~ .Rate__tick___1hdWY > .Rate__icon___bb7_W,\n.Rate__tick_checked____Sjxo > .Rate__icon___bb7_W,\n.Rate__tick_checked____Sjxo ~ .Rate__tick___1hdWY > .Rate__icon___bb7_W {\n  fill: #FFFFFF; }\n", ""]);

// exports
exports.locals = {
	"root": "Rate__root___2D5tX",
	"tick": "Rate__tick___1hdWY",
	"tick_checked": "Rate__tick_checked____Sjxo",
	"input": "Rate__input___2zgK8",
	"icon": "Rate__icon___bb7_W"
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsLightbox = __webpack_require__(326);

var _RelativesActionsLightbox2 = _interopRequireDefault(_RelativesActionsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsLightbox2.default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesActionsLightbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(43);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _RelativesActionsLightbox = __webpack_require__(330);

var _RelativesActionsLightbox2 = _interopRequireDefault(_RelativesActionsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesActionsLightbox(_ref) {
    var title = _ref.title,
        text = _ref.text,
        open = _ref.open,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        _Lightbox2.default,
        {
            open: open,
            onClose: onClose,
            closeButton: true
        },
        _react2.default.createElement(
            'div',
            { className: _RelativesActionsLightbox2.default.lightbox__wrap },
            _react2.default.createElement(
                'h2',
                { className: _RelativesActionsLightbox2.default.lightbox__title },
                title
            ),
            _react2.default.createElement(
                'p',
                { className: _RelativesActionsLightbox2.default.lightbox__text },
                text
            ),
            _react2.default.createElement(
                'button',
                {
                    className: 'ui-btn ui-btn_primary ui-btn_large ' + _RelativesActionsLightbox2.default.lightbox__button,
                    onClick: onClose
                },
                'ok'
            )
        )
    );
}

RelativesActionsLightbox.propTypes = {
    title: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    open: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

RelativesActionsLightbox.defaultProps = {
    text: ''
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Lightbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LightboxBackdrop = __webpack_require__(85);

var _LightboxBackdrop2 = _interopRequireDefault(_LightboxBackdrop);

var _LightboxDialog = __webpack_require__(86);

var _LightboxDialog2 = _interopRequireDefault(_LightboxDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Lightbox(_ref) {
    var children = _ref.children,
        open = _ref.open,
        closeButton = _ref.closeButton,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        _LightboxBackdrop2.default,
        {
            open: open,
            onClose: onClose
        },
        _react2.default.createElement(
            _LightboxDialog2.default,
            {
                closeButton: closeButton,
                onClose: onClose
            },
            children
        )
    );
}

Lightbox.propTypes = {
    children: _propTypes2.default.node,
    open: _propTypes2.default.bool,
    closeButton: _propTypes2.default.bool,
    onClose: _propTypes2.default.func
};

Lightbox.defaultProps = {
    children: null,
    open: false,
    closeButton: false,
    onClose: null
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(329);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./LightboxDialog.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./LightboxDialog.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".LightboxDialog__closeButton___1CBYh {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: block;\n  border: 0;\n  background: none;\n  padding: 16px;\n  margin-left: auto;\n  line-height: 0;\n  cursor: pointer;\n  outline: none; }\n  .LightboxDialog__closeButtonIcon___3HcCb {\n    padding: 0;\n    margin: 0;\n    fill: #F0EFF1; }\n", ""]);

// exports
exports.locals = {
	"closeButton": "LightboxDialog__closeButton___1CBYh",
	"closeButtonIcon": "LightboxDialog__closeButtonIcon___3HcCb"
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLightbox.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLightbox.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsLightbox__lightbox__wrap___3_McO {\n  font-size: 14px/19px \"proxima-nova-a\", sans-serif;\n  text-align: center;\n  padding: 40px 17px 24px 17px; }\n  @media (min-width: 720px) {\n    .RelativesActionsLightbox__lightbox__wrap___3_McO {\n      width: 304px; } }\n\n.RelativesActionsLightbox__lightbox__title___1948F {\n  color: #D11F25;\n  font: 20px/26px \"proxima-nova-a-bold\", sans-serif;\n  margin: 0; }\n\n.RelativesActionsLightbox__lightbox__text___2mZ-2 {\n  font: 14px/19px \"proxima-nova-a\", sans-serif;\n  margin: 16px 0 0 0; }\n\n.RelativesActionsLightbox__lightbox__button___3ASNN {\n  margin: 16px 0 0 0;\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"lightbox__wrap": "RelativesActionsLightbox__lightbox__wrap___3_McO",
	"lightbox__title": "RelativesActionsLightbox__lightbox__title___1948F",
	"lightbox__text": "RelativesActionsLightbox__lightbox__text___2mZ-2",
	"lightbox__button": "RelativesActionsLightbox__lightbox__button___3ASNN"
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(333);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNoteForm.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNoteForm.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsNoteForm__root___2Ca4g {\n  display: flex;\n  padding: 0 0 16px 0; }\n  @media (max-width: 479.9px) {\n    .RelativesActionsNoteForm__root___2Ca4g {\n      flex-direction: column; } }\n\n.RelativesActionsNoteForm__spinner___2j4zk {\n  display: block;\n  margin: 16px auto;\n  -webkit-animation-name: RelativesActionsNoteForm__spinner___2j4zk;\n  animation-name: RelativesActionsNoteForm__spinner___2j4zk;\n  -webkit-animation-duration: .8s;\n  animation-duration: .8s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  background-size: cover; }\n\n.RelativesActionsNoteForm__content___2OCpg {\n  flex: 1;\n  display: flex;\n  flex-direction: column; }\n\n.RelativesActionsNoteForm__comment___3M1Ki {\n  border: 1px solid #F0EFF1;\n  resize: none;\n  outline: none;\n  font: 16px/22px \"proxima-nova-a\", sans-serif;\n  flex: 1;\n  min-height: 56px;\n  margin: 8px 0 0 0;\n  padding: 4px; }\n\n.RelativesActionsNoteForm__rating___2Nmrz {\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  height: 16px;\n  margin: 8px 0 0 0; }\n  .RelativesActionsNoteForm__ratingInput___4Ug10 {\n    margin: 0 8px; }\n  .RelativesActionsNoteForm__ratingClear___2OEqt {\n    background: none;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    height: 16px;\n    padding: 0; }\n    .RelativesActionsNoteForm__ratingClearIcon___FtcHb {\n      fill: #F0EFF1; }\n\n.RelativesActionsNoteForm__panel___1c5W6 {\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 0 8px; }\n  @media (max-width: 479.9px) {\n    .RelativesActionsNoteForm__panel___1c5W6 {\n      flex-direction: row-reverse;\n      justify-content: flex-start;\n      flex: 1;\n      margin-top: 8px; } }\n  .RelativesActionsNoteForm__panelButton___1UOpg {\n    width: 60px;\n    margin: 8px 0 0;\n    padding: 0; }\n    @media (max-width: 479.9px) {\n      .RelativesActionsNoteForm__panelButton___1UOpg {\n        margin-left: 8px; } }\n    .RelativesActionsNoteForm__panelButton___1UOpg:disabled {\n      opacity: .4; }\n\n.RelativesActionsNoteForm__saveIcon___28otZ {\n  fill: #FFFFFF;\n  margin: -1px 2px 0 0; }\n\n.RelativesActionsNoteForm__here___2STOf {\n  background: none;\n  border: none;\n  outline: none;\n  font-family: \"proxima-nova-a-bold\", sans-serif;\n  cursor: pointer;\n  margin: 0;\n  padding: 0; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesActionsNoteForm__root___2Ca4g",
	"spinner": "RelativesActionsNoteForm__spinner___2j4zk",
	"content": "RelativesActionsNoteForm__content___2OCpg",
	"comment": "RelativesActionsNoteForm__comment___3M1Ki",
	"rating": "RelativesActionsNoteForm__rating___2Nmrz",
	"ratingInput": "RelativesActionsNoteForm__ratingInput___4Ug10",
	"ratingClear": "RelativesActionsNoteForm__ratingClear___2OEqt",
	"ratingClearIcon": "RelativesActionsNoteForm__ratingClearIcon___FtcHb",
	"panel": "RelativesActionsNoteForm__panel___1c5W6",
	"panelButton": "RelativesActionsNoteForm__panelButton___1UOpg",
	"saveIcon": "RelativesActionsNoteForm__saveIcon___28otZ",
	"here": "RelativesActionsNoteForm__here___2STOf"
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsLink = __webpack_require__(335);

var _RelativesActionsLink2 = _interopRequireDefault(_RelativesActionsLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsLink2.default;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesActionsLink;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _RelativesActionsLink = __webpack_require__(336);

var _RelativesActionsLink2 = _interopRequireDefault(_RelativesActionsLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesActionsLink(_ref) {
    var className = _ref.className,
        href = _ref.href,
        label = _ref.label,
        iconClassName = _ref.iconClassName,
        icon = _ref.icon;

    return _react2.default.createElement(
        'a',
        {
            className: _RelativesActionsLink2.default.root + ' ' + className + ' ui-link ui-link_table',
            href: href,
            target: '_blank',
            rel: 'noopener noreferrer'
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: _RelativesActionsLink2.default.icon + ' ' + iconClassName,
            size: 'Medium',
            iconName: icon
        }),
        label
    );
}

RelativesActionsLink.propTypes = {
    className: _propTypes2.default.string,
    href: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    iconClassName: _propTypes2.default.string,
    icon: _propTypes2.default.string.isRequired
};

RelativesActionsLink.defaultProps = {
    className: '',
    iconClassName: ''
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLink.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLink.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsLink__root___3EplX {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  background: none;\n  border: none;\n  color: #171717;\n  cursor: pointer;\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  text-decoration: none;\n  outline: none; }\n\n.RelativesActionsLink__icon___3xtS8 {\n  margin-right: 4px; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesActionsLink__root___3EplX",
	"icon": "RelativesActionsLink__icon___3xtS8"
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(339);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesActions.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesActions.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActions__panel___f-dhn {\n  display: flex;\n  justify-content: center;\n  background-color: #F0EFF1; }\n  @media (max-width: 479.9px) {\n    .RelativesActions__panel___f-dhn {\n      flex-direction: column;\n      align-items: center; } }\n\n.RelativesActions__group___V_Qq0 {\n  display: flex;\n  margin: 4px 0; }\n\n.RelativesActions__action___3OSvl {\n  margin: 0 8px; }\n  .RelativesActions__action___3OSvl:hover {\n    text-decoration: underline; }\n\n.RelativesActions__catalogueIcon___2h42X {\n  fill: #D11F25; }\n\n.RelativesActions__form___3E953 {\n  padding: 0 8px 8px; }\n", ""]);

// exports
exports.locals = {
	"panel": "RelativesActions__panel___f-dhn",
	"group": "RelativesActions__group___V_Qq0",
	"action": "RelativesActions__action___3OSvl",
	"catalogueIcon": "RelativesActions__catalogueIcon___2h42X",
	"form": "RelativesActions__form___3E953"
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BLOODSTOCK_REPORTS: 'https://www.bloodstockreports.co.uk'
};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesResults = __webpack_require__(342);

var _RelativesResults2 = _interopRequireDefault(_RelativesResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesResults2.default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Filter = __webpack_require__(343);

var _Filter2 = _interopRequireDefault(_Filter);

var _Breakpoints = __webpack_require__(10);

var _Table = __webpack_require__(17);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _api = __webpack_require__(7);

var _RelativesResults = __webpack_require__(360);

var _RelativesResults2 = _interopRequireDefault(_RelativesResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXTRA_NARROW = _Breakpoints.codes.EXTRA_NARROW,
    NARROW = _Breakpoints.codes.NARROW,
    MEDIUM = _Breakpoints.codes.MEDIUM,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;


function getParamOptions(parameters, name) {
    return ((parameters.find(function (param) {
        return param.name === name;
    }) || {}).options || []).map(function (_ref) {
        var value = _ref.value,
            displayName = _ref.displayName;
        return {
            value: value,
            label: displayName
        };
    });
}
function getSelectedValue(filter) {
    return filter && filter.options.find(function (option) {
        return option.selected;
    }).value;
}

function setCategories(_ref2, flat, jumps) {
    var raceType = _ref2.raceType,
        yearFlat = _ref2.yearFlat,
        yearJumps = _ref2.yearJumps;

    var params = {
        raceType: {
            title: 'Race Type',
            options: [flat.length > 0 && { value: 'flat', label: 'Flat' }, jumps.length > 0 && { value: 'jumps', label: 'Jumps' }].filter(function (item) {
                return !!item;
            })
        }
    };
    params.raceType.options.forEach(function (option) {
        if (option.value === raceType) option.selected = true;
    });

    if (raceType === 'flat' && flat.length > 0) {
        params.yearFlat = {
            title: 'Time period',
            options: flat
        };
        params.yearFlat.options.forEach(function (option) {
            if (option.value === yearFlat) option.selected = true;
        });
    } else if (raceType === 'jumps' && jumps.length > 0) {
        params.yearJumps = {
            title: 'Time period',
            options: jumps
        };
        params.yearJumps.options.forEach(function (option) {
            if (option.value === yearJumps) option.selected = true;
        });
    }

    return params;
}

var RelativesResults = function (_PureComponent) {
    _inherits(RelativesResults, _PureComponent);

    function RelativesResults() {
        var _ref3;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesResults);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = RelativesResults.__proto__ || Object.getPrototypeOf(RelativesResults)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
            results: [],
            flat: [],
            jumps: [],
            fetching: true,
            sort: 'horse_name',
            categories: {}
        }, _this.handleFilterApply = function (categories) {
            return _this.reloadResults({ categories: categories });
        }, _this.handleTableSort = function (sort) {
            return _this.reloadResults({ sort: sort });
        }, _this.categoriesReducer = function (categories) {
            return categories;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesResults, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            Promise.all([this.fetchSeasons(), this.fetchResults()]).then(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    seasons = _ref5[0],
                    results = _ref5[1];

                var _seasons$defaults = seasons.defaults,
                    yearFlat = _seasons$defaults.yearFlat,
                    yearJumps = _seasons$defaults.yearJumps,
                    parameters = seasons.parameters;

                var filter = {
                    yearFlat: yearFlat,
                    yearJumps: yearJumps,
                    raceType: results.length ? results[0].main_type.toLowerCase() : null
                };
                var flat = getParamOptions(parameters, 'yearFlat');
                var jumps = getParamOptions(parameters, 'yearJumps');

                _this2.setState({
                    results: results,
                    flat: flat,
                    jumps: jumps,
                    fetching: false,
                    categories: setCategories(filter, flat, jumps)
                });
            }).catch(function () {
                return _this2.setState({ fetching: false });
            });
        }
    }, {
        key: 'getTableColumns',
        value: function getTableColumns() {
            var breakpointCode = this.props.breakpointCode;

            var exNarrow = breakpointCode === EXTRA_NARROW;
            var exWide = breakpointCode === EXTRA_WIDE;
            var fromNarrow = [NARROW, MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var toMedium = [EXTRA_NARROW, NARROW].includes(breakpointCode);
            return [{
                className: _RelativesResults2.default.table__horse,
                name: 'horse_name',
                head: 'Horse',
                cell: { children: _Cell.CellHorse }
            }, {
                className: _RelativesResults2.default.table__sire,
                name: 'sire_name',
                head: exWide ? 'Sire' : 'Sire (Awd)',
                cell: { children: _Cell.CellSire }
            }, fromMedium && {
                className: _RelativesResults2.default.table__wins,
                name: 'wins',
                head: 'Wins'
            }, fromMedium && {
                className: _RelativesResults2.default.table__places,
                name: 'places',
                head: 'Places'
            }, fromMedium && {
                className: _RelativesResults2.default.table__runs,
                name: 'runs',
                head: 'Runs'
            }, toMedium && {
                className: _RelativesResults2.default.table__winsRuns,
                name: 'wins_runs',
                head: exNarrow ? 'W / R' : 'Wins / Runs'
            }, fromMedium && {
                className: _RelativesResults2.default.table__prize,
                name: 'prize',
                head: '\xA3 Prize'
            }, fromNarrow && {
                className: _RelativesResults2.default.table__rpr,
                name: 'rpr',
                head: 'Rpr'
            }, fromMedium && {
                className: _RelativesResults2.default.table__dist,
                name: 'dist',
                head: 'Dist'
            }].filter(function (column) {
                return !!column;
            });
        }
    }, {
        key: 'fetchSeasons',
        value: function fetchSeasons() {
            var damUid = this.props.damUid;

            return (0, _api.callApi)('/bloodstock/sales/relatives/results/seasons/' + damUid + '/data.json').catch(function () {
                return {
                    defaults: { yearFlat: null, yearJumps: null },
                    parameters: []
                };
            });
        }
    }, {
        key: 'fetchResults',
        value: function fetchResults(nextState) {
            var damUid = this.props.damUid;
            var sort = this.state.sort;

            var raceType = nextState && getSelectedValue(nextState.raceType);
            var query = {
                sort: sort,
                filter: {
                    raceType: raceType,
                    year: function () {
                        switch (raceType) {
                            case 'flat':
                                return getSelectedValue(nextState.yearFlat);
                            case 'jumps':
                                return getSelectedValue(nextState.yearJumps);
                            default:
                                return null;
                        }
                    }()
                }
            };
            return (0, _api.callApi)('/bloodstock/sales/relatives/results/' + damUid + '/data.json', { query: query }).then(function (data) {
                return data.rows;
            }).catch(function () {
                return [];
            });
        }
    }, {
        key: 'reloadResults',
        value: function reloadResults(nextState) {
            var _this3 = this;

            this.setState(_extends({}, nextState, { fetching: true }));
            this.fetchResults(nextState).then(function (results) {
                return _this3.setState({ results: results, fetching: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var onTabChange = this.props.onTabChange;
            var _state = this.state,
                results = _state.results,
                fetching = _state.fetching,
                sort = _state.sort,
                categories = _state.categories;

            return _react2.default.createElement(
                _Tab2.default,
                {
                    tab: _Tab2.default.TAB_RESULTS,
                    filter: !fetching && _react2.default.createElement(
                        'div',
                        { className: _RelativesResults2.default.filter + ' RelativesResults__filter' },
                        _react2.default.createElement(_Filter2.default, {
                            onFilterApply: this.handleFilterApply,
                            categories: categories,
                            categoriesReducer: this.categoriesReducer
                        })
                    ),
                    onTabChange: onTabChange
                },
                _react2.default.createElement(_Table2.default, {
                    className: _RelativesResults2.default.table,
                    type: 5,
                    placeholder: 'No relatives results in our records',
                    loading: fetching,
                    columns: this.getTableColumns(),
                    data: results,
                    canSortByColumn: function canSortByColumn() {
                        return true;
                    },
                    sorting: _defineProperty({}, sort, 'asc'),
                    onSort: this.handleTableSort
                })
            );
        }
    }]);

    return RelativesResults;
}(_react.PureComponent);

RelativesResults.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    // it's assumed that props 'damUid'
    // do not change after component rendered
    damUid: _propTypes2.default.number.isRequired,
    onTabChange: _propTypes2.default.func.isRequired
};
exports.default = (0, _Breakpoints.bindCode)(RelativesResults);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selection = undefined;

var _Filter = __webpack_require__(344);

var _Filter2 = _interopRequireDefault(_Filter);

var _selection = __webpack_require__(88);

var _selection2 = _interopRequireDefault(_selection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.selection = _selection2.default;
exports.default = _Filter2.default;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__(345);

var _Popover2 = _interopRequireDefault(_Popover);

var _FilterStatus = __webpack_require__(358);

var _FilterStatus2 = _interopRequireDefault(_FilterStatus);

var _updateCategories = __webpack_require__(359);

var _updateCategories2 = _interopRequireDefault(_updateCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_PureComponent) {
    _inherits(Filter, _PureComponent);

    function Filter(props) {
        _classCallCheck(this, Filter);

        var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

        _this.dispatch = function (action) {
            var categoriesReducer = _this.props.categoriesReducer;


            _this.setState(function (_ref) {
                var categories = _ref.categories;
                return {
                    categories: (0, _updateCategories2.default)(categories, categoriesReducer, action)
                };
            });
        };

        _this.resetCategories = function () {
            _this.setState({ categories: _this.props.categories });
        };

        _this.applyFilter = function () {
            _this.props.onFilterApply(_this.state.categories);
        };

        _this.state = {
            categories: props.categories
        };
        return _this;
    }

    _createClass(Filter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var categories = _ref2.categories;

            this.setState({ categories: categories });
        }

        /**
         * When some option is changed we are using two reducers
         * (one that passed through props and one that change selected option)
         * to handle options transformations
         */

    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;
            var categories = this.state.categories;


            if (!categories) return null;

            return _react2.default.createElement(
                'div',
                { className: 'cmn-filter' },
                children || _react2.default.createElement(_FilterStatus2.default, { categories: this.props.categories }),
                _react2.default.createElement(_Popover2.default, {
                    categories: categories,
                    resetCategories: this.resetCategories,
                    applyFilter: this.applyFilter,
                    dispatch: this.dispatch
                })
            );
        }
    }]);

    return Filter;
}(_react.PureComponent);

Filter.defaultProps = {
    categoriesReducer: function categoriesReducer(categories) {
        return categories;
    }
};

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
Filter.propTypes = {
    categories: _propTypes2.default.objectOf(_propTypes2.default.shape({
        title: _propTypes2.default.string.isRequired,
        options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            value: strOrNum.isRequired,
            label: strOrNum.isRequired,
            statusLabel: strOrNum
        }))
    })),
    categoriesReducer: _propTypes2.default.func,
    children: _propTypes2.default.node,
    onFilterApply: _propTypes2.default.func.isRequired
};

exports.default = Filter;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PopoverComponent2 = __webpack_require__(346);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

var _PopoverHeader = __webpack_require__(348);

var _PopoverHeader2 = _interopRequireDefault(_PopoverHeader);

var _PopoverFooter = __webpack_require__(349);

var _PopoverFooter2 = _interopRequireDefault(_PopoverFooter);

var _PopoverBody = __webpack_require__(350);

var _PopoverBody2 = _interopRequireDefault(_PopoverBody);

var _getFilterPosition = __webpack_require__(357);

var _getFilterPosition2 = _interopRequireDefault(_getFilterPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_PopoverComponent) {
    _inherits(Popover, _PopoverComponent);

    function Popover() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Popover);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.closePopover = function () {
            _this.setState({ expanded: false });
            _this.props.resetCategories();
        }, _this.openPopover = function (_ref2) {
            var currentTarget = _ref2.currentTarget;

            _this.setState({
                expanded: true,
                position: (0, _getFilterPosition2.default)(currentTarget)
            });
        }, _this.applyFilter = function () {
            _this.props.applyFilter();
            _this.setState({ expanded: false });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Overriding "closePopover" function from PopoverComponent.
     * So when popover is closed, categories went back to default
     */


    /**
     * Overriding "openPopover" function from PopoverComponent.
     * So we can calculate position of filter popover
     */


    _createClass(Popover, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                expanded = _state.expanded,
                position = _state.position;
            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;


            return _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        _this2.node = node;
                    } },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'ui-btn ui-btn_tiertiary',
                        onClick: this.togglePopover
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        iconName: 'filter',
                        size: 'Medium',
                        className: 'cmn-filter__btnIcon tableShowIcon'
                    }),
                    'Filter'
                ),
                expanded && _react2.default.createElement(
                    'div',
                    { className: 'ui-popover cmn-filter__popover pos_' + position },
                    _react2.default.createElement('div', { className: 'cmn-filter__pointer ui-popoverPointer' }),
                    _react2.default.createElement(_PopoverHeader2.default, {
                        cancelFilter: this.closePopover
                    }),
                    _react2.default.createElement(_PopoverBody2.default, {
                        categories: categories,
                        dispatch: dispatch
                    }),
                    _react2.default.createElement(_PopoverFooter2.default, {
                        cancelFilter: this.closePopover,
                        applyFilter: this.applyFilter
                    })
                )
            );
        }
    }]);

    return Popover;
}(_PopoverComponent3.default);

Popover.propTypes = {
    categories: _propTypes2.default.shape({}),
    resetCategories: _propTypes2.default.func.isRequired,
    applyFilter: _propTypes2.default.func.isRequired
};

exports.default = Popover;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverComponent = __webpack_require__(347);

var _PopoverComponent2 = _interopRequireDefault(_PopoverComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PopoverComponent2.default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverComponent = function (_PureComponent) {
    _inherits(PopoverComponent, _PureComponent);

    function PopoverComponent(props) {
        _classCallCheck(this, PopoverComponent);

        var _this = _possibleConstructorReturn(this, (PopoverComponent.__proto__ || Object.getPrototypeOf(PopoverComponent)).call(this, props));

        _this.onOutsideClick = function (event) {
            var domNode = _this.node;
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        };

        _this.closePopover = function () {
            _this.setState({ expanded: false });
        };

        _this.openPopover = function () {
            _this.setState({ expanded: true });
        };

        _this.togglePopover = function (e) {
            if (_this.state.expanded) {
                _this.closePopover(e);
            } else {
                _this.openPopover(e);
            }
        };

        _this.state = { expanded: false };
        return _this;
    }

    _createClass(PopoverComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }]);

    return PopoverComponent;
}(_react.PureComponent);

exports.default = PopoverComponent;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverHeader = function PopoverHeader(_ref) {
    var cancelFilter = _ref.cancelFilter;
    return _react2.default.createElement(
        'div',
        { className: 'ui-popoverHeader cmn-filter__popoverHeader' },
        'Choose Filters',
        _react2.default.createElement(
            'button',
            {
                className: 'ui-btn ui-btn_secondary cmn-filter__crossBtn',
                onClick: cancelFilter
            },
            _react2.default.createElement(_rpReactSvgIcon2.default, { isInlined: true, iconName: 'cross', className: 'tableShowIcon', size: 'Medium' })
        )
    );
};

PopoverHeader.propTypes = {
    cancelFilter: _propTypes2.default.func.isRequired
};

exports.default = PopoverHeader;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var btnCls = 'cmn-filter__footerBtn ui-btn';

var PopoverFooter = function PopoverFooter(_ref) {
    var cancelFilter = _ref.cancelFilter,
        applyFilter = _ref.applyFilter;
    return _react2.default.createElement(
        'div',
        { className: 'cmn-filter__popoverFooter' },
        _react2.default.createElement(
            'button',
            {
                className: btnCls + ' ' + btnCls + '_secondary',
                onClick: cancelFilter
            },
            'Cancel'
        ),
        _react2.default.createElement(
            'button',
            {
                className: btnCls + ' ' + btnCls + '_primary',
                onClick: applyFilter
            },
            'Apply'
        )
    );
};

PopoverFooter.propTypes = {
    applyFilter: _propTypes2.default.func.isRequired,
    cancelFilter: _propTypes2.default.func.isRequired
};

exports.default = PopoverFooter;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

var _Category = __webpack_require__(355);

var _Category2 = _interopRequireDefault(_Category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverBody = function (_PureComponent) {
    _inherits(PopoverBody, _PureComponent);

    function PopoverBody(props) {
        _classCallCheck(this, PopoverBody);

        var _this = _possibleConstructorReturn(this, (PopoverBody.__proto__ || Object.getPrototypeOf(PopoverBody)).call(this, props));

        _initialiseProps.call(_this);

        var expandedCategory = (0, _entries2.default)(props.categories).length === 1 ? (0, _entries2.default)(props.categories)[0][0] : null;

        _this.state = { expandedCategory: expandedCategory };
        return _this;
    }

    // setting current expanded category


    _createClass(PopoverBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;
            var expandedCategory = this.state.expandedCategory;


            return _react2.default.createElement(
                'div',
                { className: 'cmn-filter__popoverBody' },
                (0, _entries2.default)(categories).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        categoryName = _ref2[0],
                        category = _ref2[1];

                    return _react2.default.createElement(_Category2.default, {
                        key: categoryName,
                        type: categoryName,
                        toggleExpanded: _this2.toggleExpanded,
                        expanded: expandedCategory === categoryName,
                        title: category.title,
                        options: category.options,
                        dispatch: dispatch,
                        isHidden: category.isHidden
                    });
                })
            );
        }
    }]);

    return PopoverBody;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.toggleExpanded = function (category) {
        _this3.setState(function (_ref3) {
            var expandedCategory = _ref3.expandedCategory;
            return {
                expandedCategory: expandedCategory === category ? null : category
            };
        });
    };
};

PopoverBody.propTypes = {
    categories: _propTypes2.default.shape({}),
    dispatch: _propTypes2.default.func.isRequired
};

exports.default = PopoverBody;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(352),
    keys = __webpack_require__(36);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(353),
    getTag = __webpack_require__(57),
    mapToArray = __webpack_require__(50),
    setToPairs = __webpack_require__(354);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(63);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Option = __webpack_require__(356);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Category = function Category(_ref) {
    var type = _ref.type,
        options = _ref.options,
        title = _ref.title,
        dispatch = _ref.dispatch,
        expanded = _ref.expanded,
        toggleExpanded = _ref.toggleExpanded,
        isHidden = _ref.isHidden;
    return options && !isHidden ? _react2.default.createElement(
        'div',
        {
            className: 'cmn-filter__category',
            onClick: function onClick() {
                return toggleExpanded(type);
            }
        },
        _react2.default.createElement(
            'div',
            {
                className: (0, _classnames2.default)('ui-accordion__header', 'cmn-filter__categoryRow', { 'ui-accordion__header_active': expanded })
            },
            _react2.default.createElement(
                'span',
                { className: 'cmn-filter__categoryName' },
                title,
                _react2.default.createElement(
                    'span',
                    { className: 'cmn-filter__categorySelected' },
                    options.find(function (option) {
                        return option.selected;
                    }).label !== 'No filter' && options.find(function (option) {
                        return option.selected;
                    }).label
                )
            ),
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                iconName: 'minus',
                size: 'Medium',
                className: 'accordionMinus ui-accordion__arrow tableShowIcon'
            }),
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                iconName: 'plus',
                size: 'Medium',
                className: 'accordionPlus ui-accordion__arrow tableShowIcon'
            })
        ),
        expanded && _react2.default.createElement(
            'ul',
            null,
            options.map(function (_ref2) {
                var value = _ref2.value,
                    label = _ref2.label,
                    selected = _ref2.selected;
                return _react2.default.createElement(_Option2.default, {
                    key: label,
                    label: label,
                    selected: selected,
                    onClick: function onClick() {
                        return dispatch({ type: type, value: value, label: label });
                    }
                });
            })
        )
    ) : null;
}; /* eslint jsx-a11y/no-static-element-interactions:0 */


var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
Category.propTypes = {
    title: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    dispatch: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: strOrNum.isRequired,
        label: strOrNum.isRequired
    })),
    expanded: _propTypes2.default.bool,
    toggleExpanded: _propTypes2.default.func,
    isHidden: _propTypes2.default.bool
};

exports.default = Category;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint jsx-a11y/no-static-element-interactions:0 */
var Option = function Option(_ref) {
    var label = _ref.label,
        selected = _ref.selected,
        onClick = _ref.onClick;
    return _react2.default.createElement(
        'li',
        {
            className: (0, _classnames2.default)('ui-popoverList__link cmn-filter__option', selected && 'cmn-filter__option_selected'),
            onClick: onClick
        },
        label,
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            isInlined: true,
            iconName: 'tick',
            size: 'Medium',
            className: 'cmn-filter__optionTick tableShowIcon'
        })
    );
};

Option.propTypes = {
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    selected: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = Option;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var requiredHeight = 450;

var getFilterPosition = function getFilterPosition(btn) {
    var _btn$getBoundingClien = btn.getBoundingClientRect(),
        topSpace = _btn$getBoundingClien.top,
        bottom = _btn$getBoundingClien.bottom;

    var bottomSpace = window.innerHeight - bottom;

    if (bottomSpace > requiredHeight) {
        return 'bottom';
    } else if (topSpace > requiredHeight) {
        return 'top';
    }
    return 'left';
};

exports.default = getFilterPosition;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selection = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */


var FilterStatus = function (_PureComponent) {
    _inherits(FilterStatus, _PureComponent);

    function FilterStatus() {
        _classCallCheck(this, FilterStatus);

        return _possibleConstructorReturn(this, (FilterStatus.__proto__ || Object.getPrototypeOf(FilterStatus)).apply(this, arguments));
    }

    _createClass(FilterStatus, [{
        key: 'render',
        value: function render() {
            var labels = (0, _selection.getStatusLabels)(this.props.categories);

            return _react2.default.createElement(
                'h2',
                { className: 'cmn-filter__status' },
                Object.values(labels).filter(function (label) {
                    return label && label !== 'No filter';
                }).join(', ')
            );
        }
    }]);

    return FilterStatus;
}(_react.PureComponent);

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
FilterStatus.propTypes = {
    categories: _propTypes2.default.shape({
        options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            value: strOrNum.isRequired,
            label: strOrNum.isRequired,
            statusLabel: strOrNum
        }))
    }).isRequired
};

exports.default = FilterStatus;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleSelected = function toggleSelected(arr, value) {
    return arr.map(function (item) {
        if (item.value === value) {
            return _extends({}, item, { selected: true });
        }
        if (item.selected) {
            return _extends({}, item, { selected: false });
        }
        return item;
    });
};

var setSelectReducer = function setSelectReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    return _extends({}, categories, _defineProperty({}, type, _extends({}, categories[type], {
        options: toggleSelected(categories[type].options, value)
    })));
};

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
var updateCategories = function updateCategories(categories, reducer, action) {
    return setSelectReducer(reducer(categories, action), action);
};

exports.default = updateCategories;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(361);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesResults.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesResults.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesResults__table___20RTN .ui-table__cell {\n  background: transparent !important; }\n\n.RelativesResults__table__horse___2YpNy, .RelativesResults__table__sire___1IWym {\n  text-align: left !important; }\n\n.RelativesResults__table__wins___2g6qq, .RelativesResults__table__places___3AYx_, .RelativesResults__table__runs___3eZ4X {\n  text-align: center !important; }\n\n.RelativesResults__table__prize___3x0kn, .RelativesResults__table__rpr___2sVT4, .RelativesResults__table__dist___18K77 {\n  text-align: right !important; }\n\n.RelativesResults__table__horse___2YpNy {\n  padding-right: 4px !important; }\n\n@media (max-width: 479.9px) {\n  .RelativesResults__table__horse___2YpNy {\n    width: 38%; }\n  .RelativesResults__table__sire___1IWym {\n    width: 40%; }\n  .RelativesResults__table__winsRuns___Tyf9q {\n    text-align: right !important;\n    width: 22%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .RelativesResults__table__horse___2YpNy, .RelativesResults__table__sire___1IWym {\n    width: 30%; }\n  .RelativesResults__table__winsRuns___Tyf9q {\n    width: 25%; }\n  .RelativesResults__table__rpr___2sVT4 {\n    width: 15%; }\n  .RelativesResults__table__winsRuns___Tyf9q {\n    text-align: center !important; } }\n\n@media (min-width: 720px) {\n  .RelativesResults__table__horse___2YpNy {\n    width: 23%; }\n  .RelativesResults__table__sire___1IWym {\n    width: 20%; }\n  .RelativesResults__table__wins___2g6qq {\n    width: 10%; }\n  .RelativesResults__table__places___3AYx_ {\n    width: 11%; }\n  .RelativesResults__table__runs___3eZ4X {\n    width: 9%; }\n  .RelativesResults__table__prize___3x0kn {\n    width: 11%; }\n  .RelativesResults__table__rpr___2sVT4, .RelativesResults__table__dist___18K77 {\n    width: 8%; } }\n\n.RelativesResults__filter___1bVpy {\n  display: flex;\n  align-items: center; }\n  .RelativesResults__filter__status___1x5Re {\n    font: 16px/22px \"proxima-nova-a-bold\", sans-serif; }\n  .RelativesResults__filter__filter___2IgyI {\n    margin: 0 0 0 8px; }\n", ""]);

// exports
exports.locals = {
	"table": "RelativesResults__table___20RTN",
	"table__horse": "RelativesResults__table__horse___2YpNy",
	"table__sire": "RelativesResults__table__sire___1IWym",
	"table__wins": "RelativesResults__table__wins___2g6qq",
	"table__places": "RelativesResults__table__places___3AYx_",
	"table__runs": "RelativesResults__table__runs___3eZ4X",
	"table__prize": "RelativesResults__table__prize___3x0kn",
	"table__rpr": "RelativesResults__table__rpr___2sVT4",
	"table__dist": "RelativesResults__table__dist___18K77",
	"table__winsRuns": "RelativesResults__table__winsRuns___Tyf9q",
	"filter": "RelativesResults__filter___1bVpy",
	"filter__status": "RelativesResults__filter__status___1x5Re",
	"filter__filter": "RelativesResults__filter__filter___2IgyI"
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesEntries = __webpack_require__(363);

var _RelativesEntries2 = _interopRequireDefault(_RelativesEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesEntries2.default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _Table = __webpack_require__(17);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _api = __webpack_require__(7);

var _RelativesEntries = __webpack_require__(364);

var _RelativesEntries2 = _interopRequireDefault(_RelativesEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MEDIUM = _Breakpoints.codes.MEDIUM,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;

var RelativesEntries = function (_PureComponent) {
    _inherits(RelativesEntries, _PureComponent);

    function RelativesEntries() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesEntries);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesEntries.__proto__ || Object.getPrototypeOf(RelativesEntries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: [],
            fetching: true,
            sort: 'date'
        }, _this.handleSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesEntries, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var damUid = _ref2.damUid;

            if (damUid !== this.props.damUid) {
                this.fetchData();
            }
        }
    }, {
        key: 'getColumns',
        value: function getColumns() {
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(this.props.breakpointCode);
            return [{
                className: _RelativesEntries2.default.table__horse,
                name: 'horse_name',
                head: 'Horse',
                cell: { children: _Cell.CellHorse }
            }, fromMedium && {
                className: _RelativesEntries2.default.table__title,
                name: 'title',
                head: 'Title',
                cell: { children: _Cell.CellRace }
            }, {
                className: _RelativesEntries2.default.table__course,
                name: 'course_time',
                head: 'Course / Time'
            }, {
                className: _RelativesEntries2.default.table__places,
                name: 'date',
                head: 'Date'
            }].filter(function (column) {
                return !!column;
            });
        }
    }, {
        key: 'fetchData',
        value: function fetchData(nextState) {
            var _this2 = this;

            this.setState(_extends({}, nextState, { fetching: true }));

            var damUid = this.props.damUid;

            var _state$nextState = _extends({}, this.state, nextState),
                sort = _state$nextState.sort;

            (0, _api.callApi)('/bloodstock/sales/relatives/entries/' + damUid + '/data.json', { query: { sort: sort } }).then(function (data) {
                return data.rows;
            }).catch(function () {
                return [];
            }).then(function (data) {
                return _this2.setState({ data: data, fetching: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var onTabChange = this.props.onTabChange;
            var _state = this.state,
                data = _state.data,
                fetching = _state.fetching,
                sort = _state.sort;

            return _react2.default.createElement(
                _Tab2.default,
                {
                    tab: _Tab2.default.TAB_ENTRIES,
                    onTabChange: onTabChange
                },
                _react2.default.createElement(_Table2.default, {
                    className: _RelativesEntries2.default.table,
                    type: 5,
                    placeholder: 'No relatives entries in our records',
                    loading: fetching,
                    columns: this.getColumns(),
                    data: data,
                    sorting: _defineProperty({}, sort, 'asc'),
                    canSortByColumn: function canSortByColumn() {
                        return true;
                    },
                    onSort: this.handleSort
                })
            );
        }
    }]);

    return RelativesEntries;
}(_react.PureComponent);

RelativesEntries.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    // it's assumed that props 'damUid'
    // do not change after component rendered
    damUid: _propTypes2.default.number.isRequired,
    onTabChange: _propTypes2.default.func.isRequired
};
exports.default = (0, _Breakpoints.bindCode)(RelativesEntries);

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(365);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesEntries.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesEntries.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RelativesEntries__table___38-P_ .ui-table__cell {\n  background: transparent !important; }\n\n.RelativesEntries__table__horse___3zPI9, .RelativesEntries__table__title___YbcGg {\n  text-align: left !important; }\n\n.RelativesEntries__table__course___34Hvb, .RelativesEntries__table__date___1dgEf {\n  text-align: right !important; }\n\n.RelativesEntries__table__horse___3zPI9 {\n  padding-right: 4px !important; }\n\n@media (max-width: 719.9px) {\n  .RelativesEntries__table__horse___3zPI9, .RelativesEntries__table__course___34Hvb {\n    width: 40%; }\n  .RelativesEntries__table__date___1dgEf {\n    width: 20%; } }\n\n@media (min-width: 720px) {\n  .RelativesEntries__table__horse___3zPI9 {\n    width: 26%; }\n  .RelativesEntries__table__title___YbcGg {\n    width: 46%; }\n  .RelativesEntries__table__course___34Hvb {\n    width: 17%; }\n  .RelativesEntries__table__date___1dgEf {\n    width: 12%; } }\n", ""]);

// exports
exports.locals = {
	"table": "RelativesEntries__table___38-P_",
	"table__horse": "RelativesEntries__table__horse___3zPI9",
	"table__title": "RelativesEntries__table__title___YbcGg",
	"table__course": "RelativesEntries__table__course___34Hvb",
	"table__date": "RelativesEntries__table__date___1dgEf"
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesSales = __webpack_require__(367);

var _RelativesSales2 = _interopRequireDefault(_RelativesSales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesSales2.default;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _format = __webpack_require__(38);

var _format2 = _interopRequireDefault(_format);

var _add_years = __webpack_require__(368);

var _add_years2 = _interopRequireDefault(_add_years);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _Table = __webpack_require__(17);

var _Table2 = _interopRequireDefault(_Table);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _RelativesSalesCellHorse = __webpack_require__(369);

var _RelativesSalesCellHorse2 = _interopRequireDefault(_RelativesSalesCellHorse);

var _RelativesSalesCellSire = __webpack_require__(370);

var _RelativesSalesCellSire2 = _interopRequireDefault(_RelativesSalesCellSire);

var _RelativesSalesCellSale = __webpack_require__(371);

var _RelativesSalesCellSale2 = _interopRequireDefault(_RelativesSalesCellSale);

var _RelativesSalesCellPrice = __webpack_require__(372);

var _RelativesSalesCellPrice2 = _interopRequireDefault(_RelativesSalesCellPrice);

var _api = __webpack_require__(7);

var _RelativesSales = __webpack_require__(373);

var _RelativesSales2 = _interopRequireDefault(_RelativesSales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NARROW = _Breakpoints.codes.NARROW,
    MEDIUM = _Breakpoints.codes.MEDIUM,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;


var DATE_OF_BIRTH_DIFF = 4;
var DATE_FORMAT = 'YYYY-MM-DD';

var RelativesSales = function (_PureComponent) {
    _inherits(RelativesSales, _PureComponent);

    function RelativesSales() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesSales);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesSales.__proto__ || Object.getPrototypeOf(RelativesSales)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: [],
            fetching: true,
            sort: 'horse_name'
        }, _this.handleSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesSales, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData();
        }
    }, {
        key: 'fetchData',
        value: function fetchData(nextState) {
            var _this2 = this;

            this.setState(_extends({}, nextState, { fetching: true }));
            var _props = this.props,
                damUid = _props.damUid,
                birthDate = _props.birthDate,
                saleDate = _props.saleDate,
                lotNo = _props.lotNo,
                venueId = _props.venueId;

            var currentDate = (0, _format2.default)(Date.now(), DATE_FORMAT);
            var birthSaleDate = (0, _format2.default)((0, _add_years2.default)(birthDate, DATE_OF_BIRTH_DIFF), DATE_FORMAT);

            var _state$nextState = _extends({}, this.state, nextState),
                sort = _state$nextState.sort;

            var url = '/bloodstock/sales/relatives/sales/' + damUid + '/' + birthSaleDate + '/' + currentDate + '/data.json';
            var init = { query: { sort: sort, filter: { lotNo: lotNo, venueId: venueId, saleDate: saleDate } } };
            (0, _api.callApi)(url, init).then(function (json) {
                return json.rows;
            }).catch(function () {
                return [];
            }).then(function (data) {
                return _this2.setState({ data: data, fetching: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                breakpointCode = _props2.breakpointCode,
                onTabChange = _props2.onTabChange;
            var _state = this.state,
                data = _state.data,
                fetching = _state.fetching,
                sort = _state.sort;

            var fromNarrow = [NARROW, MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            return _react2.default.createElement(
                _Tab2.default,
                {
                    tab: _Tab2.default.TAB_SALES,
                    onTabChange: onTabChange
                },
                _react2.default.createElement(_Table2.default, {
                    className: _RelativesSales2.default.table,
                    type: 5,
                    placeholder: 'No relatives sales in our records',
                    loading: fetching,
                    columns: [{
                        className: _RelativesSales2.default.table__horse,
                        name: 'horse_name',
                        head: 'Horse',
                        cell: { children: _RelativesSalesCellHorse2.default }
                    }, fromNarrow && {
                        className: _RelativesSales2.default.table__sire,
                        name: 'sire_name',
                        head: 'Sire (Dam\'s Sire)',
                        cell: { children: _RelativesSalesCellSire2.default }
                    }, {
                        className: _RelativesSales2.default.table__price,
                        name: 'price',
                        head: 'Price',
                        cell: { children: _RelativesSalesCellPrice2.default }
                    }, {
                        className: _RelativesSales2.default.table__buyer,
                        name: 'buyer',
                        head: 'Buyer'
                    }, fromMedium && {
                        className: _RelativesSales2.default.table__sale,
                        name: 'sale',
                        head: 'Sale',
                        cell: { children: _RelativesSalesCellSale2.default }
                    }].filter(function (column) {
                        return !!column;
                    }),
                    data: data,
                    sorting: _defineProperty({}, sort, 'asc'),
                    canSortByColumn: function canSortByColumn() {
                        return true;
                    },
                    onSort: this.handleSort
                })
            );
        }
    }]);

    return RelativesSales;
}(_react.PureComponent);

RelativesSales.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    // it's assumed that props 'damUid', 'birthDate', 'saleDate'
    // do not change after component has been rendered
    damUid: _propTypes2.default.number.isRequired,
    birthDate: _propTypes2.default.string.isRequired,
    saleDate: _propTypes2.default.string.isRequired,
    onTabChange: _propTypes2.default.func.isRequired,
    venueId: _propTypes2.default.number.isRequired,
    lotNo: _propTypes2.default.number.isRequired
};
exports.default = (0, _Breakpoints.bindCode)(RelativesSales);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(59)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSalesCellHorse;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cell = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellHorse(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_Cell.CellHorse, { data: data }),
        '\xA0',
        data.horse_name_codes
    );
}

RelativesSalesCellHorse.propTypes = {
    data: _propTypes2.default.shape({
        horse_name_codes: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSalesCellSire;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cell = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellSire(props) {
    return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_Cell.CellSire, props),
        ' ',
        '(',
        _react2.default.createElement(_Cell.CellDamsSire, props),
        ')'
    );
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSalesCellSale;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _url = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellSale(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'a',
        {
            className: 'ui-link ui-link_table',
            href: (0, _url.lotUrl)(data.venue_uid, data.sale_raw_date, data.lot_no || data.sale, data.lot_letter)
        },
        data.sale,
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            iconName: 'right',
            size: 'XSmall'
        })
    );
}

RelativesSalesCellSale.propTypes = {
    data: _propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_raw_date: _propTypes2.default.string,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired,
        sale: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = RelativesSalesCellPrice;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cell = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellPrice(props) {
    return _react2.default.createElement(_Cell.CellPrice, _extends({}, props, { bold: false }));
}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesSales.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesSales.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RelativesSales__table___2tPBi .ui-table__cell {\n  background: transparent !important; }\n\n.RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj, .RelativesSales__table__price___6roeC, .RelativesSales__table__buyer___3poq4 {\n  text-align: left !important;\n  padding-right: 4px !important; }\n\n.RelativesSales__table__sale___zJVmh {\n  text-align: left !important;\n  padding-right: 0 !important; }\n\n@media (max-width: 479.9px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__buyer___3poq4 {\n    width: 40%; }\n  .RelativesSales__table__price___6roeC {\n    width: 20%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj, .RelativesSales__table__buyer___3poq4 {\n    width: 29%; }\n  .RelativesSales__table__price___6roeC {\n    width: 13%; } }\n\n@media (min-width: 720px) and (max-width: 1277.9px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj {\n    width: 25%; }\n  .RelativesSales__table__price___6roeC, .RelativesSales__table__sale___zJVmh {\n    width: 15%; }\n  .RelativesSales__table__buyer___3poq4 {\n    width: 20%; } }\n\n@media (min-width: 1278px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj {\n    width: 23%; }\n  .RelativesSales__table__price___6roeC, .RelativesSales__table__sale___zJVmh {\n    width: 15%; }\n  .RelativesSales__table__buyer___3poq4 {\n    width: 24%; } }\n", ""]);

// exports
exports.locals = {
	"table": "RelativesSales__table___2tPBi",
	"table__horse": "RelativesSales__table__horse___iN5lA",
	"table__sire": "RelativesSales__table__sire___10qfj",
	"table__price": "RelativesSales__table__price___6roeC",
	"table__buyer": "RelativesSales__table__buyer___3poq4",
	"table__sale": "RelativesSales__table__sale___zJVmh"
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(376);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsTable.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsTable.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchResultsTable__root___3n-9S {\n  color: #171717; }\n\n.SearchResultsTable__toggle___2DjXo,\n.SearchResultsTable__lot___2zz_n,\n.SearchResultsTable__color___3S-ja,\n.SearchResultsTable__sex___1lE0g,\n.SearchResultsTable__age___18Ltc {\n  text-align: center; }\n\n.SearchResultsTable__horse___32Whn,\n.SearchResultsTable__dam___K7J5s,\n.SearchResultsTable__vendor___1Vo1r,\n.SearchResultsTable__price___KovC0,\n.SearchResultsTable__buyer___3HVL9,\n.SearchResultsTable__date___35W4r {\n  text-align: left; }\n\n.SearchResultsTable__sale___26NZg {\n  text-align: right; }\n\n@media (max-width: 479.9px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 11%; }\n  .SearchResultsTable__lot___2zz_n {\n    width: 13%; }\n  .SearchResultsTable__horse___32Whn {\n    width: 46%; }\n  .SearchResultsTable__price___KovC0 {\n    width: 30%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 7%; }\n  .SearchResultsTable__lot___2zz_n {\n    width: 9%; }\n  .SearchResultsTable__horse___32Whn {\n    width: 30%; }\n  .SearchResultsTable__price___KovC0 {\n    width: 24%; }\n  .SearchResultsTable__buyer___3HVL9 {\n    width: 30%; } }\n\n@media (min-width: 720px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 4%; }\n  .SearchResultsTable__lot___2zz_n,\n  .SearchResultsTable__sex___1lE0g {\n    width: 5%; }\n  .SearchResultsTable__dam___K7J5s {\n    width: 12%; }\n  .SearchResultsTable__horse___32Whn,\n  .SearchResultsTable__vendor___1Vo1r {\n    width: 14%; }\n  .SearchResultsTable__buyer___3HVL9 {\n    width: 12%; }\n  .SearchResultsTable__price___KovC0,\n  .SearchResultsTable__date___35W4r {\n    width: 9%; }\n  .SearchResultsTable__sale___26NZg {\n    width: 16%; } }\n\n@media (min-width: 1278px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 3%; }\n  .SearchResultsTable__lot___2zz_n,\n  .SearchResultsTable__color___3S-ja,\n  .SearchResultsTable__sex___1lE0g,\n  .SearchResultsTable__age___18Ltc {\n    width: 4%; }\n  .SearchResultsTable__horse___32Whn,\n  .SearchResultsTable__dam___K7J5s,\n  .SearchResultsTable__vendor___1Vo1r,\n  .SearchResultsTable__buyer___3HVL9 {\n    width: 14%; }\n  .SearchResultsTable__price___KovC0 {\n    width: 7%; }\n  .SearchResultsTable__date___35W4r {\n    width: 6%; }\n  .SearchResultsTable__sale___26NZg {\n    width: 12%; } }\n", ""]);

// exports
exports.locals = {
	"root": "SearchResultsTable__root___3n-9S",
	"toggle": "SearchResultsTable__toggle___2DjXo",
	"lot": "SearchResultsTable__lot___2zz_n",
	"color": "SearchResultsTable__color___3S-ja",
	"sex": "SearchResultsTable__sex___1lE0g",
	"age": "SearchResultsTable__age___18Ltc",
	"horse": "SearchResultsTable__horse___32Whn",
	"dam": "SearchResultsTable__dam___K7J5s",
	"vendor": "SearchResultsTable__vendor___1Vo1r",
	"price": "SearchResultsTable__price___KovC0",
	"buyer": "SearchResultsTable__buyer___3HVL9",
	"date": "SearchResultsTable__date___35W4r",
	"sale": "SearchResultsTable__sale___26NZg"
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _SearchResultsLightbox = __webpack_require__(378);

var _SearchResultsLightbox2 = _interopRequireDefault(_SearchResultsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResultsLightbox2.default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchResultsLightbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Lightbox = __webpack_require__(43);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _SearchResultsLightbox = __webpack_require__(379);

var _SearchResultsLightbox2 = _interopRequireDefault(_SearchResultsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchResultsLightbox(_ref) {
    var open = _ref.open,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        _Lightbox2.default,
        {
            open: open,
            closeButton: true,
            onClose: onClose
        },
        _react2.default.createElement(
            'div',
            { className: _SearchResultsLightbox2.default.wrap },
            _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(_rpReactSvgIcon2.default, {
                    iconName: 'results',
                    size: 'XL'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    'Your search is too broad. Please limit your date range to one month or select two of the following filters: Sale Name, Horse name, pedigree, vendor or price range.'
                )
            ),
            _react2.default.createElement(
                'button',
                {
                    className: _SearchResultsLightbox2.default.button + ' ui-btn ui-btn_primary ui-btn_large',
                    onClick: onClose
                },
                'OK'
            )
        )
    );
}

SearchResultsLightbox.propTypes = {
    open: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(380);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsLightbox.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsLightbox.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchResultsLightbox__wrap___1q_Qb {\n  padding: 0 8px 16px;\n  width: 100%;\n  text-align: center; }\n  @media (min-width: 720px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      padding: 0 16px 24px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      width: 464px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      width: 640px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      width: 832px; } }\n\n.SearchResultsLightbox__button___1skm7 {\n  width: 100%; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchResultsLightbox__button___1skm7 {\n      width: 304px; } }\n", ""]);

// exports
exports.locals = {
	"wrap": "SearchResultsLightbox__wrap___1q_Qb",
	"button": "SearchResultsLightbox__button___1skm7"
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(382);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchResults.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchResults.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchResults__table___3MRcj {\n  margin-top: 16px;\n  color: #171717; }\n\n.SearchResults__filters___2k8Yd {\n  margin-top: 24px;\n  color: #171717; }\n", ""]);

// exports
exports.locals = {
	"table": "SearchResults__table___3MRcj",
	"filters": "SearchResults__filters___2k8Yd"
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchEntries = __webpack_require__(384);

var _SearchEntries2 = _interopRequireDefault(_SearchEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchEntries2.default;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isEqual2 = __webpack_require__(32);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _Breakpoints = __webpack_require__(10);

var _Pagination = __webpack_require__(61);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _SearchEntriesFilters = __webpack_require__(385);

var _SearchEntriesFilters2 = _interopRequireDefault(_SearchEntriesFilters);

var _SearchEntriesTable = __webpack_require__(388);

var _SearchEntriesTable2 = _interopRequireDefault(_SearchEntriesTable);

var _api = __webpack_require__(7);

var _SearchEntries = __webpack_require__(391);

var _SearchEntries2 = _interopRequireDefault(_SearchEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchEntries = function (_PureComponent) {
    _inherits(SearchEntries, _PureComponent);

    function SearchEntries() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchEntries);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchEntries.__proto__ || Object.getPrototypeOf(SearchEntries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            fetching: false,
            totalLotsNum: 0,
            totalPagesNum: 0,
            filters: SearchEntries.getInitialFilters(),
            filtersUsed: false,
            page: 0,
            data: [],
            header: [],
            expansion: null,
            sort: 'lot_no'
        }, _this.isSortable = function (sort) {
            return _this.state.header.find(function (headerCellData) {
                return headerCellData.name === sort && headerCellData.sortLink;
            });
        }, _this.handleFiltersChange = function (filters) {
            if ((0, _isEqual3.default)(filters, SearchEntries.getInitialFilters())) {
                _this.handleFiltersReset();
            } else {
                _this.fetchData({ filters: filters });
            }
        }, _this.handleFiltersReset = function () {
            _this.setState({
                fetching: false,
                filtersUsed: false,
                filters: SearchEntries.getInitialFilters(),
                totalLotsNum: 0,
                totalPagesNum: 0,
                data: []
            });
        }, _this.handleTableToggle = function (expansion) {
            return _this.setState({
                expansion: expansion === _this.state.expansion ? null : expansion
            });
        }, _this.handleTableSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _this.handlePageChange = function (page) {
            return _this.fetchData({ page: page });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchEntries, [{
        key: 'fetchData',
        value: function fetchData(params) {
            var _this2 = this;

            var _state$params = _extends({}, this.state, params),
                filters = _state$params.filters,
                sort = _state$params.sort,
                page = _state$params.page;

            this.setState({ filters: filters, sort: sort, page: page, fetching: true, filtersUsed: true });
            var sireName = this.props.sireName;

            var query = {
                sort: sort,
                page: page,
                q: Object.keys(filters).reduce(function (result, key) {
                    var value = key === _SearchEntriesFilters.FILTERS_PROP_SIRE && sireName ? sireName : filters[key];
                    return value ? _extends({}, result, _defineProperty({}, key, value)) : result;
                }, {})
            };

            return (0, _api.callApi)('/bloodstock/sales/search/entries/data.json', { query: query }).then(function (data) {
                return _this2.setState({
                    fetching: false,
                    totalLotsNum: data.pagination.totalItems,
                    totalPagesNum: data.pagination.totalPages,
                    page: data.pagination.currentPage,
                    data: data.rows,
                    header: data.header
                });
            }).catch(function () {
                return _this2.setState({
                    fetching: false,
                    totalLotsNum: 0,
                    totalPagesNum: 0,
                    data: [],
                    header: []
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                breakpointCode = _props.breakpointCode,
                sireUid = _props.sireUid;
            var _state = this.state,
                fetching = _state.fetching,
                totalLotsNum = _state.totalLotsNum,
                totalPagesNum = _state.totalPagesNum,
                filters = _state.filters,
                page = _state.page,
                data = _state.data,
                expansion = _state.expansion,
                sort = _state.sort,
                filtersUsed = _state.filtersUsed;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _SearchEntries2.default.filters },
                    _react2.default.createElement(_SearchEntriesFilters2.default, {
                        breakpointCode: breakpointCode,
                        sireUid: sireUid,
                        filters: filters,
                        lotsNum: totalLotsNum,
                        onChange: this.handleFiltersChange,
                        onReset: this.handleFiltersReset
                    })
                ),
                (fetching || filtersUsed) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _SearchEntries2.default.table },
                        _react2.default.createElement(_SearchEntriesTable2.default, {
                            breakpointCode: breakpointCode,
                            data: data,
                            loading: fetching,
                            expansion: expansion,
                            sorting: _defineProperty({}, sort, 'asc'),
                            onToggle: this.handleTableToggle,
                            onSort: this.handleTableSort,
                            canSortByColumn: this.isSortable
                        })
                    ),
                    _react2.default.createElement(_Pagination2.default, {
                        displayedPagesNum: 5,
                        totalPagesNum: totalPagesNum,
                        page: page,
                        onPageChange: this.handlePageChange
                    })
                )
            );
        }
    }], [{
        key: 'getInitialFilters',
        value: function getInitialFilters() {
            return _SearchEntriesFilters.FILTERS_PROPS_ALL.reduce(function (result, prop) {
                return _extends({}, result, _defineProperty({}, prop, _SearchEntriesFilters.FILTERS_PROP_ENTERED !== prop ? null : false));
            }, {});
        }
    }]);

    return SearchEntries;
}(_react.PureComponent);

SearchEntries.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    sireUid: _propTypes2.default.number,
    sireName: _propTypes2.default.string
};
SearchEntries.defaultProps = {
    sireUid: null,
    sireName: null
};
exports.default = (0, _Breakpoints.bindCode)(SearchEntries);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FILTERS_PROPS_ALL = exports.FILTERS_PROP_ENTERED = exports.FILTERS_PROP_VENDOR = exports.FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM = exports.FILTERS_PROP_SIRE = exports.FILTERS_PROP_NAME = exports.FILTERS_PROP_AGE = exports.FILTERS_PROP_SEX = exports.FILTERS_PROP_SALE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FILTER_STATE_TO_URL_, _filtersLabels, _propTypes$shape;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Filters = __webpack_require__(68);

var _Checkbox = __webpack_require__(70);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Breakpoints = __webpack_require__(10);

var _api = __webpack_require__(7);

var _SearchEntriesFilters = __webpack_require__(386);

var _SearchEntriesFilters2 = _interopRequireDefault(_SearchEntriesFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TAB_SALE = 'TAB_SALE';
var TAB_HORSE = 'TAB_HORSE';
var TAB_PEDIGREE = 'TAB_PEDIGREE';
var TAB_VENDOR = 'TAB_VENDOR';

var NAV_OPTIONS = [{ label: 'Sale', value: TAB_SALE }, { label: 'Horse', value: TAB_HORSE }, { label: 'Pedigree', value: TAB_PEDIGREE }, { label: 'Vendor', value: TAB_VENDOR }];

var ONLY_WITH_ENTRIES_LABEL = 'Show only lots with entries';

var FILTERS_PROP_SALE = exports.FILTERS_PROP_SALE = 'sale';
var FILTERS_PROP_SEX = exports.FILTERS_PROP_SEX = 'sex';
var FILTERS_PROP_AGE = exports.FILTERS_PROP_AGE = 'age';
var FILTERS_PROP_NAME = exports.FILTERS_PROP_NAME = 'name';
var FILTERS_PROP_SIRE = exports.FILTERS_PROP_SIRE = 'sire';
var FILTERS_PROP_DAM = exports.FILTERS_PROP_DAM = 'dam';
var FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM_SIRE = 'damSire';
var FILTERS_PROP_VENDOR = exports.FILTERS_PROP_VENDOR = 'vendor';
var FILTERS_PROP_ENTERED = exports.FILTERS_PROP_ENTERED = 'entered';

var FILTERS_PROPS_SELECT = [FILTERS_PROP_SALE, FILTERS_PROP_SEX, FILTERS_PROP_AGE, FILTERS_PROP_NAME, FILTERS_PROP_SIRE, FILTERS_PROP_DAM, FILTERS_PROP_DAM_SIRE, FILTERS_PROP_VENDOR];
var FILTERS_PROPS_ALL = exports.FILTERS_PROPS_ALL = [].concat(FILTERS_PROPS_SELECT, [FILTERS_PROP_ENTERED]);

var FILTER_STATE_TO_URL_HASH = (_FILTER_STATE_TO_URL_ = {}, _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_SALE, 'sale_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_SEX, 'horse_sex'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_AGE, 'horse_age'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_NAME, 'horse_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_SIRE, 'sire_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_DAM, 'dam_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_DAM_SIRE, 'sire_of_dam_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_VENDOR, 'seller_name'), _FILTER_STATE_TO_URL_);

var filtersLabels = (_filtersLabels = {}, _defineProperty(_filtersLabels, FILTERS_PROP_SEX, 'Sex'), _defineProperty(_filtersLabels, FILTERS_PROP_AGE, 'Age'), _defineProperty(_filtersLabels, FILTERS_PROP_NAME, 'Name'), _defineProperty(_filtersLabels, FILTERS_PROP_SIRE, 'Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM, 'Dam'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM_SIRE, 'Dam\'s Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_VENDOR, 'Vendor'), _filtersLabels);

var SearchEntriesFilters = function (_PureComponent) {
    _inherits(SearchEntriesFilters, _PureComponent);

    function SearchEntriesFilters() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchEntriesFilters);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchEntriesFilters.__proto__ || Object.getPrototypeOf(SearchEntriesFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            open: true,
            tab: TAB_SALE,
            options: FILTERS_PROPS_SELECT.reduce(function (result, prop) {
                return _extends({}, result, _defineProperty({}, prop, []));
            }, {}),
            history: []
        }, _this.createFilterOpenHandler = function (urlProp, stateProp) {
            return function () {
                var _this$props = _this.props,
                    sireUid = _this$props.sireUid,
                    filters = _this$props.filters;

                var url = '/bloodstock/sales/search/entries/' + urlProp + '/data.json';
                var init = {
                    query: {
                        refine: FILTERS_PROPS_SELECT.reduce(function (result, prop) {
                            var value = filters[prop];
                            if (prop === stateProp || !value) {
                                return result;
                            }
                            return _extends({}, result, _defineProperty({}, FILTER_STATE_TO_URL_HASH[prop], value));
                        }, sireUid ? { sire_uid: sireUid } : {})
                    }
                };
                return (0, _api.callApi)(url, init).then(function (options) {
                    return _this.setState({
                        options: _extends({}, _this.state.options, _defineProperty({}, stateProp, options))
                    });
                });
            };
        }, _this.filterOpenHandlers = FILTERS_PROPS_SELECT.reduce(function (result, prop) {
            return _extends({}, result, _defineProperty({}, prop, _this.createFilterOpenHandler(FILTER_STATE_TO_URL_HASH[prop], prop)));
        }, {}), _this.createFilterChangeHandler = function (prop) {
            return function (value, option) {
                var filters = _this.props.filters;

                if (filters[prop] === value) {
                    return;
                }

                _this.setState({
                    history: _this.state.history.filter(function (item) {
                        return item.prop !== prop;
                    }).concat(value ? {
                        prop: prop,
                        value: function () {
                            switch (prop) {
                                case FILTERS_PROP_ENTERED:
                                    return ONLY_WITH_ENTRIES_LABEL;
                                default:
                                    return option.name;
                            }
                        }()
                    } : [])
                });

                _this.props.onChange(_extends({}, filters, _defineProperty({}, prop, value)));
            };
        }, _this.filterChangeHandlers = FILTERS_PROPS_ALL.reduce(function (result, prop) {
            return _extends({}, result, _defineProperty({}, prop, _this.createFilterChangeHandler(prop)));
        }, {}), _this.handleToggleClick = function () {
            return _this.setState({ open: !_this.state.open });
        }, _this.handleTabChange = function (tab) {
            return _this.setState({ tab: tab });
        }, _this.handleResetClick = function () {
            _this.setState({ history: [] });
            return _this.props.onReset();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchEntriesFilters, [{
        key: 'getFilterProps',
        value: function getFilterProps(prop) {
            return {
                className: _SearchEntriesFilters2.default.filter,
                options: this.state.options[prop],
                labelGetter: 'name',
                value: this.props.filters[prop],
                disabled: prop === FILTERS_PROP_NAME ? this.isNameDisabled() : this.isNameSelected(),
                onOpen: this.filterOpenHandlers[prop],
                onChange: this.filterChangeHandlers[prop]
            };
        }
    }, {
        key: 'isNameSelected',
        value: function isNameSelected() {
            return !!this.props.filters[FILTERS_PROP_NAME];
        }
    }, {
        key: 'isNameDisabled',
        value: function isNameDisabled() {
            var _this2 = this;

            return FILTERS_PROPS_ALL.some(function (prop) {
                if (prop === FILTERS_PROP_NAME) {
                    return false;
                }
                return !!_this2.props.filters[prop];
            });
        }
    }, {
        key: 'isResetDisabled',
        value: function isResetDisabled() {
            var _this3 = this;

            return FILTERS_PROPS_ALL.every(function (prop) {
                return !_this3.props.filters[prop];
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                breakpointCode = _props.breakpointCode,
                filters = _props.filters,
                lotsNum = _props.lotsNum;
            var _state = this.state,
                open = _state.open,
                tab = _state.tab,
                options = _state.options,
                history = _state.history;

            var exNarrow = breakpointCode === _Breakpoints.codes.EXTRA_NARROW;
            var toNarrow = [_Breakpoints.codes.EXTRA_NARROW, _Breakpoints.codes.NARROW].includes(breakpointCode);
            var toWide = [_Breakpoints.codes.WIDE, _Breakpoints.codes.EXTRA_WIDE].includes(breakpointCode);
            var historyFiltered = history.filter(function (item) {
                return item.prop !== FILTERS_PROP_SALE;
            });
            return _react2.default.createElement(
                'div',
                null,
                toNarrow && _react2.default.createElement(_Filters.FiltersToggle, {
                    open: open,
                    onClick: this.handleToggleClick
                }),
                (open || !toNarrow) && _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames3.default)(_SearchEntriesFilters2.default.filters, _defineProperty({}, _SearchEntriesFilters2.default.filters_open, toNarrow))
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _SearchEntriesFilters2.default.navWrap },
                        _react2.default.createElement(_Filters.FiltersNav, {
                            className: _SearchEntriesFilters2.default.nav,
                            name: 'tab',
                            options: NAV_OPTIONS,
                            value: tab,
                            align: exNarrow ? _Filters.FiltersNav.ALIGN_HORIZONTAL : _Filters.FiltersNav.ALIGN_VERTICAL,
                            onChange: this.handleTabChange
                        }),
                        _react2.default.createElement(_Filters.FiltersReset, {
                            className: _SearchEntriesFilters2.default.reset,
                            disabled: this.isResetDisabled(),
                            onClick: this.handleResetClick
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _SearchEntriesFilters2.default.tabWrap },
                        _react2.default.createElement(
                            'div',
                            { className: _SearchEntriesFilters2.default.tab },
                            function () {
                                switch (tab) {
                                    case TAB_SALE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Sale Name',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_SALE)))
                                        );
                                    case TAB_HORSE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Sex'
                                            }, _this4.getFilterProps(FILTERS_PROP_SEX))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Age'
                                            }, _this4.getFilterProps(FILTERS_PROP_AGE))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Name',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_NAME)))
                                        );
                                    case TAB_PEDIGREE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Sire',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_SIRE))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Dam',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_DAM))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Dam\'s Sire',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_DAM_SIRE)))
                                        );
                                    case TAB_VENDOR:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Vendor Name',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_VENDOR)))
                                        );
                                    default:
                                        return null;
                                }
                            }()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchEntriesFilters2.default.panel },
                            _react2.default.createElement(
                                'div',
                                { className: _SearchEntriesFilters2.default.lots },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    'Lots found'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _SearchEntriesFilters2.default.lots__num,
                                        'data-test-selector': 'lots_found_right_block'
                                    },
                                    lotsNum
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_Checkbox2.default, {
                                    label: ONLY_WITH_ENTRIES_LABEL,
                                    value: filters[FILTERS_PROP_ENTERED],
                                    onChange: this.filterChangeHandlers[FILTERS_PROP_ENTERED]
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchEntriesFilters2.default.status },
                    history && history.length > 0 && _react2.default.createElement(
                        'div',
                        { className: _SearchEntriesFilters2.default.status__container },
                        _react2.default.createElement(
                            'span',
                            {
                                className: _SearchEntriesFilters2.default.status__sale,
                                'data-test-selector': 'filters_applied_sale_name'
                            },
                            filters[FILTERS_PROP_SALE] ? options[FILTERS_PROP_SALE].find(function (option) {
                                return option.value === filters[FILTERS_PROP_SALE];
                            }).name : 'All sales'
                        ),
                        ' - ',
                        _react2.default.createElement(
                            'span',
                            null,
                            'Lots found'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _SearchEntriesFilters2.default.status__lots, 'data-test-selector': 'lots_found_above_table' },
                            lotsNum
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchEntriesFilters2.default.history },
                    toWide && history && historyFiltered.length > 0 && _react2.default.createElement(
                        'span',
                        { 'data-test-selector': 'filters_applied' },
                        'Filters Applied: ',
                        historyFiltered.map(function (item) {
                            if (item.prop === FILTERS_PROP_ENTERED) {
                                return item.value;
                            }
                            return filtersLabels[item.prop] + ' - ' + item.value;
                        }).join(', ')
                    )
                )
            );
        }
    }]);

    return SearchEntriesFilters;
}(_react.PureComponent);

SearchEntriesFilters.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    sireUid: _propTypes2.default.string,
    filters: _propTypes2.default.shape((_propTypes$shape = {}, _defineProperty(_propTypes$shape, FILTERS_PROP_SALE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SEX, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_AGE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_NAME, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_VENDOR, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_ENTERED, _propTypes2.default.bool), _propTypes$shape)).isRequired,
    lotsNum: _propTypes2.default.number.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onReset: _propTypes2.default.func.isRequired
};
SearchEntriesFilters.defaultProps = {
    sireUid: null
};
exports.default = SearchEntriesFilters;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(387);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesFilters.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesFilters.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SearchEntriesFilters__filters___28pxi {\n  display: flex; }\n  .SearchEntriesFilters__filters_open___1YWNi {\n    margin-top: 16px; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__filters___28pxi {\n      flex-direction: column; } }\n\n.SearchEntriesFilters__navWrap___2eFqR {\n  flex-shrink: 0; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      margin-bottom: 8px;\n      padding-bottom: 16px;\n      border-bottom: 1px solid #171717; } }\n  @media (min-width: 480px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      padding-right: 8px;\n      border-right: 1px solid #171717; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 120px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 174px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 160px; } }\n  @media (min-width: 1278px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 208px; } }\n\n@media (max-width: 479.9px) {\n  .SearchEntriesFilters__nav___3cHwL {\n    flex: 1; } }\n\n@media (max-width: 479.9px) {\n  .SearchEntriesFilters__reset___fuqpa {\n    margin: 8px auto 0;\n    width: 48%;\n    display: block; } }\n\n@media (min-width: 480px) {\n  .SearchEntriesFilters__reset___fuqpa {\n    width: 100%;\n    margin-top: 24px; } }\n\n.SearchEntriesFilters__tabWrap___p62bW {\n  display: flex; }\n\n.SearchEntriesFilters__tab___3Tvli {\n  flex-shrink: 0;\n  padding: 0 8px; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 66.66667%;\n      height: 168px; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 240px; } }\n  @media (min-width: 720px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      padding-right: 32px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 368px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 344px; } }\n  @media (min-width: 1278px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 496px; } }\n\n.SearchEntriesFilters__filter___kuoNe {\n  width: 100%; }\n  .SearchEntriesFilters__filter___kuoNe:nth-child(n+2) {\n    margin-top: 8px; }\n\n.SearchEntriesFilters__panel___IJaez {\n  display: flex;\n  flex-direction: column;\n  padding-left: 8px;\n  border-left: 1px solid #171717; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 33.33%; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 104px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 138px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 120px; } }\n  @media (min-width: 1278px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 198px; } }\n\n.SearchEntriesFilters__lots___1q9E_ {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .SearchEntriesFilters__lots__num___3BjxY {\n    font-size: 48px;\n    font-family: \"proxima-nova-a-bold\", sans-serif;\n    line-height: 52px; }\n\n.SearchEntriesFilters__status___39B7h {\n  margin-top: 24px;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  white-space: pre; }\n  .SearchEntriesFilters__status__container___OTZRf {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    white-space: pre-wrap; }\n  .SearchEntriesFilters__status__sale___2IqHr {\n    font-family: \"proxima-nova-a-bold\", sans-serif; }\n  .SearchEntriesFilters__status__lots___1f2HH {\n    display: flex;\n    align-items: center;\n    height: 16px;\n    margin-left: 8px;\n    padding: 0 3px;\n    background: #2CB34A;\n    border-radius: 4px;\n    color: #FFFFFF;\n    font: 12px/17px \"proxima-nova-a-bold\", sans-serif; }\n\n.SearchEntriesFilters__history___1_u8e {\n  margin-top: 16px;\n  font: 16px/22px \"proxima-nova-a-bold\", sans-serif; }\n", ""]);

// exports
exports.locals = {
	"filters": "SearchEntriesFilters__filters___28pxi",
	"filters_open": "SearchEntriesFilters__filters_open___1YWNi",
	"navWrap": "SearchEntriesFilters__navWrap___2eFqR",
	"nav": "SearchEntriesFilters__nav___3cHwL",
	"reset": "SearchEntriesFilters__reset___fuqpa",
	"tabWrap": "SearchEntriesFilters__tabWrap___p62bW",
	"tab": "SearchEntriesFilters__tab___3Tvli",
	"filter": "SearchEntriesFilters__filter___kuoNe",
	"panel": "SearchEntriesFilters__panel___IJaez",
	"lots": "SearchEntriesFilters__lots___1q9E_",
	"lots__num": "SearchEntriesFilters__lots__num___3BjxY",
	"status": "SearchEntriesFilters__status___39B7h",
	"status__container": "SearchEntriesFilters__status__container___OTZRf",
	"status__sale": "SearchEntriesFilters__status__sale___2IqHr",
	"status__lots": "SearchEntriesFilters__status__lots___1f2HH",
	"history": "SearchEntriesFilters__history___1_u8e"
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = __webpack_require__(23);

var _Table = __webpack_require__(17);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _RelativesRow = __webpack_require__(82);

var _RelativesRow2 = _interopRequireDefault(_RelativesRow);

var _SearchEntriesTable = __webpack_require__(389);

var _SearchEntriesTable2 = _interopRequireDefault(_SearchEntriesTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;

var SearchEntriesTable = function (_PureComponent) {
    _inherits(SearchEntriesTable, _PureComponent);

    function SearchEntriesTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchEntriesTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchEntriesTable.__proto__ || Object.getPrototypeOf(SearchEntriesTable)).call.apply(_ref, [this].concat(args))), _this), _this.row = { children: _RelativesRow2.default }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchEntriesTable, [{
        key: 'getColumns',
        value: function getColumns() {
            var breakpointCode = this.props.breakpointCode;

            var narrow = breakpointCode === NARROW;
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            return [{
                className: _SearchEntriesTable2.default.toggle,
                name: '_toggle',
                head: '',
                cell: { children: _Table.TableToggle }
            }, {
                className: _SearchEntriesTable2.default.lot,
                name: 'lot_no',
                head: 'Lot',
                cell: { children: _Cell.CellLot }
            }, {
                className: _SearchEntriesTable2.default.horse,
                name: 'horse_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Horse name'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellHorseSireUGC }
            }, fromMedium && {
                className: _SearchEntriesTable2.default.color,
                name: 'horse_first_colour_code',
                head: 'Col'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.sex,
                name: 'horse_sex',
                head: 'Sex'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.age,
                name: 'horse_age',
                head: 'Age'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.dam,
                name: 'dam_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam\'s Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellDamDamsSire }
            }, fromMedium && {
                className: _SearchEntriesTable2.default.vendor,
                name: 'seller_name',
                head: 'Vendor'
            }, narrow && {
                className: _SearchEntriesTable2.default.date,
                name: 'sale_date',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Date'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Sale'
                        )
                    )
                },
                cell: { children: _Cell.CellDateSale }
            }, !narrow && {
                className: _SearchEntriesTable2.default.date,
                name: 'sale_date',
                head: 'Date'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.sale,
                name: 'sale_name',
                head: 'Sale'
            }].filter(function (item) {
                return !!item;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                loading = _props.loading,
                expansion = _props.expansion,
                sorting = _props.sorting,
                onToggle = _props.onToggle,
                onSort = _props.onSort,
                canSortByColumn = _props.canSortByColumn;

            return _react2.default.createElement(_Table2.default, {
                type: 1,
                columns: this.getColumns(),
                row: this.row,
                identity: SearchEntriesTable.identity,
                data: data,
                loading: loading,
                expansion: expansion,
                sorting: sorting,
                onToggle: onToggle,
                onSort: onSort,
                canSortByColumn: canSortByColumn,
                placeholder: 'No results found'
            });
        }
    }], [{
        key: 'identity',
        value: function identity(data) {
            return [data.venue_uid, data.sale_date_raw, data.lot_no, data.lot_letter].join('|');
        }
    }]);

    return SearchEntriesTable;
}(_react.PureComponent);

SearchEntriesTable.propTypes = {
    breakpointCode: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired
    })).isRequired,
    loading: _propTypes2.default.bool,
    expansion: _propTypes2.default.string,
    sorting: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    onToggle: _propTypes2.default.func.isRequired,
    onSort: _propTypes2.default.func.isRequired,
    canSortByColumn: _propTypes2.default.func.isRequired
};
SearchEntriesTable.defaultProps = {
    loading: false,
    expansion: null,
    sorting: null
};
exports.default = SearchEntriesTable;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesTable.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesTable.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchEntriesTable__toggle___1u30g,\n.SearchEntriesTable__lot___3V4Fl,\n.SearchEntriesTable__color___2R7qF,\n.SearchEntriesTable__sex___1X3vX,\n.SearchEntriesTable__age___3gnfT {\n  text-align: center; }\n\n.SearchEntriesTable__horse___2gh4w,\n.SearchEntriesTable__dam___35TI_,\n.SearchEntriesTable__vendor___O39Xn,\n.SearchEntriesTable__date___30leV {\n  text-align: left; }\n\n.SearchEntriesTable__sale___1RaTK {\n  text-align: right; }\n\n@media (max-width: 479.9px) {\n  .SearchEntriesTable__toggle___1u30g {\n    width: 11%; }\n  .SearchEntriesTable__lot___3V4Fl {\n    width: 13%; }\n  .SearchEntriesTable__horse___2gh4w {\n    width: 52%; }\n  .SearchEntriesTable__price___2mWuI {\n    width: 24%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .SearchEntriesTable__toggle___1u30g {\n    width: 7%; }\n  .SearchEntriesTable__lot___3V4Fl {\n    width: 9%; }\n  .SearchEntriesTable__horse___2gh4w {\n    width: 42%; }\n  .SearchEntriesTable__date___30leV {\n    width: 42%; } }\n\n@media (min-width: 720px) {\n  .SearchEntriesTable__toggle___1u30g {\n    width: 4%; }\n  .SearchEntriesTable__lot___3V4Fl,\n  .SearchEntriesTable__color___2R7qF,\n  .SearchEntriesTable__sex___1X3vX,\n  .SearchEntriesTable__age___3gnfT {\n    width: 5%; }\n  .SearchEntriesTable__horse___2gh4w,\n  .SearchEntriesTable__dam___35TI_,\n  .SearchEntriesTable__vendor___O39Xn,\n  .SearchEntriesTable__sale___1RaTK {\n    width: 17%; }\n  .SearchEntriesTable__date___30leV {\n    width: 8%; } }\n", ""]);

// exports
exports.locals = {
	"toggle": "SearchEntriesTable__toggle___1u30g",
	"lot": "SearchEntriesTable__lot___3V4Fl",
	"color": "SearchEntriesTable__color___2R7qF",
	"sex": "SearchEntriesTable__sex___1X3vX",
	"age": "SearchEntriesTable__age___3gnfT",
	"horse": "SearchEntriesTable__horse___2gh4w",
	"dam": "SearchEntriesTable__dam___35TI_",
	"vendor": "SearchEntriesTable__vendor___O39Xn",
	"date": "SearchEntriesTable__date___30leV",
	"sale": "SearchEntriesTable__sale___1RaTK",
	"price": "SearchEntriesTable__price___2mWuI"
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(392);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchEntries.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchEntries.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchEntries__table___2dmsi {\n  margin-top: 16px;\n  color: #171717; }\n\n.SearchEntries__filters___2jsS0 {\n  margin-top: 24px;\n  color: #171717; }\n", ""]);

// exports
exports.locals = {
	"table": "SearchEntries__table___2dmsi",
	"filters": "SearchEntries__filters___2jsS0"
};

/***/ })
/******/ ]);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pricesProvider = exports.PRICE_HANDLER_EVENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(230);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpDiffusionConnector = __webpack_require__(337);

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

var _DiffusionServiceUtils = __webpack_require__(191);

var _PricesStateStore = __webpack_require__(190);

var _HorsesListStore = __webpack_require__(926);

var _PubSub2 = __webpack_require__(2267);

var _PubSub3 = _interopRequireDefault(_PubSub2);

var _DiffusionSubscriber = __webpack_require__(2266);

var _DiffusionSubscriber2 = _interopRequireDefault(_DiffusionSubscriber);

var _EVENTS = __webpack_require__(925);

var _EVENTS2 = _interopRequireDefault(_EVENTS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRICE_HANDLER_EVENTS = exports.PRICE_HANDLER_EVENTS = {
    PRICE_RECEIVED: 'PRICE_RECEIVED',
    PRICES_WILL_BE_UPDATED: 'PRICES_WILL_BE_UPDATED',
    PRICES_SETTINGS_CHANGED: 'PRICES_SETTINGS_CHANGED',
    RACE_INFO_RECEIVED: 'RACE_INFO_RECEIVED'
};

var PricesProvider = function (_PubSub) {
    _inherits(PricesProvider, _PubSub);

    function PricesProvider() {
        _classCallCheck(this, PricesProvider);

        var _this = _possibleConstructorReturn(this, (PricesProvider.__proto__ || Object.getPrototypeOf(PricesProvider)).call(this));

        _this.config = {
            session: {
                onDataFunction: _this.onDataReceive.bind(_this),
                onCallbackFunction: _this.onConnectionStatusChange.bind(_this)
            }
        };
        return _this;
    }

    _createClass(PricesProvider, [{
        key: 'init',
        value: function init(bookmakerName) {
            _PricesStateStore.pricesStateStore.setCurrentBookmaker(bookmakerName);
            if (_jsCookie2.default.get('customizeSettings')) {
                this.setPriceViewType();
            }
            this.session = new _rpDiffusionConnector2.default(this.config.session);
            this.subscriber = new _DiffusionSubscriber2.default(this.session);
            this.subscriber.run();
            this.bindEvents();
            _HorsesListStore.horsesListStore.updateHorsesData();
            // TODO: move it out of provider (JIRA: PC-4559)
            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmakerName);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _jquery2.default)(document).on(_EVENTS2.default.BOOKMAKER_CHANGED, this.onBookmakerChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicPricesUpdated.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onHorsesListChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
        }

        /* eslint-disable class-methods-use-this */

    }, {
        key: 'setPriceViewType',
        value: function setPriceViewType() {
            var showDecimal = JSON.parse(_jsCookie2.default.get('customizeSettings')).decimalOdds;
            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
            }
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(event, newBookmakerName) {
            var horsesList = _HorsesListStore.horsesListStore.getHorsesList();

            this.unsubscribeAll();
            _PricesStateStore.pricesStateStore.setCurrentBookmaker(newBookmakerName);
            this.publish(PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED);
            this.subscribeForPrices(horsesList, newBookmakerName);
        }
    }, {
        key: 'onDynamicPricesUpdated',
        value: function onDynamicPricesUpdated() {
            var newHorsesData = _HorsesListStore.horsesListStore.updateHorsesData();
            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

            this.subscribeForPrices(newHorsesData, bookmaker);
        }
    }, {
        key: 'onHorsesListChanged',
        value: function onHorsesListChanged() {
            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

            this.unsubscribeAll();
            _HorsesListStore.horsesListStore.updateHorsesData();
            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmaker);
        }
    }, {
        key: 'onUserSettingsChanged',
        value: function onUserSettingsChanged(event, userSettings) {
            var showDecimal = userSettings.decimalOdds;

            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
                this.publish(PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, { showDecimal: showDecimal });
            }
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.subscriber.unsubscribeAll();
        }
    }, {
        key: 'subscribeForPrices',
        value: function subscribeForPrices(horsesList, bookmaker) {
            if (!bookmaker) {
                return;
            }

            var topics = horsesList.filter(function (horseData) {
                return horseData;
            }).map(function (horseData) {
                var courseName = horseData.courseName,
                    raceTime = horseData.raceTime,
                    raceDate = horseData.raceDate,
                    horseName = horseData.horseName;

                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic({
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate,
                    horseName: horseName,
                    bookmaker: bookmaker
                });
                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate,
                    bookmaker: bookmaker
                });

                return [priceTopic, infoTopic];
            }).reduce(function (acum, value) {
                return acum.concat(value);
            }, []).filter(function (topic) {
                return topic;
            });

            this.subscriber.subscribe(topics);
        }
    }, {
        key: 'unsubscribeFromPrices',
        value: function unsubscribeFromPrices(horsesList, bookmaker) {
            var _this2 = this;

            horsesList.map(function (horseData) {
                return _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(_extends(horseData, { bookmaker: bookmaker }));
            }).filter(function (topic) {
                return topic;
            }).forEach(function (topic) {
                return _this2.session.unsubscribe({ topic: topic });
            });
        }
    }, {
        key: 'onDataReceive',
        value: function onDataReceive(WebClientMessage) {
            var topic = WebClientMessage.getTopic();

            if (topic.includes('#INFO')) {
                this.handleRaceInfo(WebClientMessage);
            } else {
                this.handleHorsePrice(WebClientMessage);
            }
        }
    }, {
        key: 'onConnectionStatusChange',
        value: function onConnectionStatusChange(isOpened) {
            if (isOpened) {
                this.subscriber.run();
            } else {
                this.subscriber.stop();
            }
        }
    }, {
        key: 'handleHorsePrice',
        value: function handleHorsePrice(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);

            this.publish(PRICE_HANDLER_EVENTS.PRICE_RECEIVED, renderConfig);
            (0, _jquery2.default)(document).trigger(_EVENTS2.default.PRICES_NEED_SORTING);
        }
    }, {
        key: 'handleRaceInfo',
        value: function handleRaceInfo(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

            _PricesStateStore.pricesStateStore.updateRaceInfo(renderConfig);
            this.publish(PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, renderConfig);
        }
    }]);

    return PricesProvider;
}(_PubSub3.default);
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)


var pricesProvider = exports.pricesProvider = new PricesProvider();

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    USER_SETTINGS_CHANGED: 'userSettingsChanged.SETTINGS',
    DYNAMIC_PRICES_UPDATED: 'dynamicPricesUpdated.PRICES',
    RESIZE: 'resize',
    SWITCH_BREAKPOINTS: 'rpBreakpointsSwitch',
    MAKE_SELECTION: 'RC.makeSelection',
    BOOKMAKER_CHANGED: 'bookieChanged.BOOKMAKER',
    INFO_TOPIC_UPDATED: 'infoTopicUpdate.PRICES',
    HORSES_LIST_CHANGED: 'horsesListChanged',
    // TODO: RC - Race card related prefix (JIRA: PC-4557)
    PRICES_NEED_SORTING: 'RC.priceUpdatedToSort'
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.horsesListStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _DiffusionServiceUtils = __webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var newHorseElementsSelector = '.js-diffusionHorsesList:not(.js-PC-subscribed)';
var subscribedHorseseClass = 'js-PC-subscribed';

var HorsesListStore = function () {
    function HorsesListStore() {
        _classCallCheck(this, HorsesListStore);

        this.horsesList = [];
    }

    _createClass(HorsesListStore, [{
        key: 'getHorsesList',
        value: function getHorsesList() {
            return this.horsesList;
        }

        // TODO: move to private function, utils or static method (JIRA: PC-4559)
        /* eslint-disable class-methods-use-this */

    }, {
        key: 'getNotSubscribedHorses',
        value: function getNotSubscribedHorses() {
            var diffusionHorsesNodeList = (0, _jquery2.default)(newHorseElementsSelector).toArray();
            var notSubscribedHorses = diffusionHorsesNodeList.map(_DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData.bind(_DiffusionServiceUtils.diffusionServiceUtils));

            diffusionHorsesNodeList.forEach(function (element) {
                element.classList.add(subscribedHorseseClass);
            });

            return notSubscribedHorses;
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'updateHorsesData',
        value: function updateHorsesData() {
            var notSubscribedHorses = this.getNotSubscribedHorses();

            this.horsesList = this.horsesList.concat(notSubscribedHorses);

            return notSubscribedHorses;
        }
    }]);

    return HorsesListStore;
}();
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */


var horsesListStore = exports.horsesListStore = new HorsesListStore();

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopOver = function () {
    function PopOver(popOverConfig) {
        _classCallCheck(this, PopOver);

        var defaultConfig = {
            popOverSelector: '.js-popOver',
            openAreaSelectors: ['.js-popOver__openArea'],
            toggleAreaSelector: '.js-popOver__toggleArea',
            closeAreaSelectors: ['.js-popOver__shadow', '.js-popOver__closeBtn'],
            activeClass: 'ui-popOver_active',
            onOpen: null,
            onClose: null,
            name: ''
        };
        this.config = _jquery2.default.extend(true, defaultConfig, popOverConfig);
        this.init();
    }

    _createClass(PopOver, [{
        key: 'init',
        value: function init() {
            this.popOver = (0, _jquery2.default)(this.config.popOverSelector)[0];
            this.openArea = (0, _jquery2.default)(this.config.openAreaSelectors.join(','));
            this.toggleArea = (0, _jquery2.default)(this.config.toggleAreaSelector)[0];
            this.closeArea = (0, _jquery2.default)(this.config.closeAreaSelectors.join(','));

            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this = this;

            Array.prototype.forEach.call(this.openArea, function (element) {
                return element.addEventListener('click', function (e) {
                    _this.onOpenAreaClicked(e);
                }, false);
            });

            if (this.toggleArea) {
                this.toggleArea.addEventListener('click', function (e) {
                    _this.onTogglePopOver(e);
                }, false);
            }

            Array.prototype.forEach.call(this.closeArea, function (element) {
                return element.addEventListener('click', function (e) {
                    _this.onCloseAreaClicked(e);
                }, false);
            });
        }
    }, {
        key: 'onOpenAreaClicked',
        value: function onOpenAreaClicked(event) {
            event.preventDefault();
            this.open(event);
        }
    }, {
        key: 'onTogglePopOver',
        value: function onTogglePopOver(event) {
            event.preventDefault();
            this.toggle();
        }
    }, {
        key: 'onCloseAreaClicked',
        value: function onCloseAreaClicked(event) {
            this.close(event);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            var _this2 = this;

            Array.prototype.forEach.call(this.openArea, function (element) {
                element.removeEventListener('click', function (e) {
                    _this2.onOpenAreaClicked(e);
                }, false);
            });

            if (this.toggleArea) {
                this.toggleArea.removeEventListener('click', function (e) {
                    _this2.onTogglePopOver(e);
                }, false);
            }

            Array.prototype.forEach.call(this.closeArea, function (element) {
                element.removeEventListener('click', function (e) {
                    _this2.onCloseAreaClicked(e);
                }, false);
            });
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isActive()) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: 'open',
        value: function open(event) {
            if (this.popOver) {
                this.popOver.classList.add(this.config.activeClass);
            }

            if (this.config.onOpen instanceof Function) {
                this.config.onOpen(event);
            }

            _jquery2.default.event.trigger('popoverOpened' + this.config.name);
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.config.onClose instanceof Function) {
                this.config.onClose();
            }

            if (this.popOver) {
                this.popOver.classList.remove(this.config.activeClass);
            }

            _jquery2.default.event.trigger('popoverClosed' + this.config.name);
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.popOver.classList.contains(this.config.activeClass);
        }
    }]);

    return PopOver;
}();

exports.default = PopOver;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(
    'div',
    { className: 'ui-centered-wrapper' },
    _react2.default.createElement(_rpReactSvgIcon2.default, {
      iconName: 'spinner',
      size: '2XL',
      className: 'ui-animation_spinnerAnimation'
    })
  );
};

exports.default = Loading;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoData = function NoData(_ref) {
  var text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'ui-errorMessage' },
    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'results', size: '2XL' }),
    _react2.default.createElement(
      'div',
      { className: 'ui-errorMessage__text' },
      text
    )
  );
};

NoData.propTypes = {
  text: _propTypes2.default.string
};

exports.default = NoData;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowMore = function ShowMore(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'ui-centered-wrapper' },
    _react2.default.createElement(
      'button',
      {
        className: 'rp-table-showmore ui-link ui-link_chevron',
        onClick: onClick
      },
      'Show more',
      _react2.default.createElement(_rpReactSvgIcon2.default, {
        iconName: 'down',
        size: 'Small',
        className: 'ui-icon ui-icon__btn'
      })
    )
  );
};

ShowMore.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

exports.default = ShowMore;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _shortid = __webpack_require__(331);

var _shortid2 = _interopRequireDefault(_shortid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addId = function addId(data) {
  return data.map(function (item) {
    return _extends({}, item, {
      __id: _shortid2.default.generate()
    });
  });
};

exports.default = addId;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMPTINESS_SIGN = exports.EMPTINESS_SIGN = '—';

var isFinite = Number.isFinite;


var handleEmpty = function handleEmpty(value) {
  return isFinite(value) || value ? value : EMPTINESS_SIGN;
};

exports.default = handleEmpty;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(6);

var _compareFns = __webpack_require__(934);

var _compareFns2 = _interopRequireDefault(_compareFns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSortFn = function addSortFn(col) {
  var sortFn = col.sortFn,
      key = col.key;


  if (!sortFn) return _extends({}, col, { sortFn: _compareFns2.default.numeric(key) });

  if ((0, _lodash.isFunction)(sortFn)) return col;

  return _extends({}, col, { sortFn: _compareFns2.default[sortFn](key) });
};

var addSortFns = function addSortFns(cols, sortable, initialIdx, defaultIdx) {
  if (sortable) {
    return cols.map(addSortFn);
  }

  return cols.map(function (col, idx) {
    return idx === initialIdx || idx === defaultIdx ? addSortFn(col) : col;
  });
};

exports.default = addSortFns;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alphabetic = __webpack_require__(2280);

var _alphabetic2 = _interopRequireDefault(_alphabetic);

var _numeric = __webpack_require__(2282);

var _byLastName = __webpack_require__(2281);

var _byLastName2 = _interopRequireDefault(_byLastName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  alphabetic: _alphabetic2.default, numeric: _numeric.numeric, numericReverse: _numeric.numericReverse, byLastName: _byLastName2.default
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _thenby = __webpack_require__(2300);

var _thenby2 = _interopRequireDefault(_thenby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
                                                                                                                                                                                                     * Sort table using particular column's sorting fn
                                                                                                                                                                                                     */


var sortData = function sortData(data, columns, idx, defaultIdx) {
  return [].concat(_toConsumableArray(data)).sort((0, _thenby2.default)(columns[idx].sortFn).thenBy(columns[defaultIdx].sortFn));
};

exports.default = sortData;

/***/ }),
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CoursePage = __webpack_require__(1032);

var _CoursePage2 = _interopRequireDefault(_CoursePage);

var _CourseMap = __webpack_require__(1035);

var _CourseMap2 = _interopRequireDefault(_CourseMap);

var _CourseInfo = __webpack_require__(1033);

var _CourseInfo2 = _interopRequireDefault(_CourseInfo);

var _Signposts = __webpack_require__(1049);

var _Signposts2 = _interopRequireDefault(_Signposts);

var _Stats = __webpack_require__(1055);

var _Stats2 = _interopRequireDefault(_Stats);

var _Favourites = __webpack_require__(1039);

var _Favourites2 = _interopRequireDefault(_Favourites);

var _Results = __webpack_require__(1046);

var _Results2 = _interopRequireDefault(_Results);

var _CourseRecords = __webpack_require__(1037);

var _CourseRecords2 = _interopRequireDefault(_CourseRecords);

var _PageProvider = __webpack_require__(354);

var _PageProvider2 = _interopRequireDefault(_PageProvider);

var _TabFetchProvider = __webpack_require__(257);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _TabProvider = __webpack_require__(355);

var _TabProvider2 = _interopRequireDefault(_TabProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = {
    path: 'course/:id/:name',
    component: _PageProvider2.default,
    Page: _CoursePage2.default,
    indexRoute: {
        component: _TabFetchProvider2.default,
        Tab: _Stats2.default,
        fetchPath: 'stats'
    },
    childRoutes: [{
        path: 'stats',
        component: _TabFetchProvider2.default,
        Tab: _Stats2.default
    }, {
        path: 'course-map',
        component: _TabProvider2.default,
        Tab: _CourseMap2.default
    }, {
        path: 'course-records',
        component: _TabProvider2.default,
        Tab: _CourseRecords2.default
    }, {
        path: 'favourites',
        component: _TabFetchProvider2.default,
        Tab: _Favourites2.default
    }, {
        path: 'signposts',
        component: _TabFetchProvider2.default,
        Tab: _Signposts2.default
    }, {
        path: 'course-info',
        component: _TabProvider2.default,
        Tab: _CourseInfo2.default
    }, {
        path: 'results',
        component: _TabFetchProvider2.default,
        Tab: _Results2.default
    }]
};

exports.default = routes;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // data providers


// page and index tab


// common horse tabs


// progeny present on stallion and dam


// dam tabs


// stallion tabs


var _PageProvider = __webpack_require__(354);

var _PageProvider2 = _interopRequireDefault(_PageProvider);

var _TabFetchProvider = __webpack_require__(257);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _TabProvider = __webpack_require__(355);

var _TabProvider2 = _interopRequireDefault(_TabProvider);

var _HorsePage = __webpack_require__(1058);

var _HorsePage2 = _interopRequireDefault(_HorsePage);

var _IndexTab = __webpack_require__(1059);

var _IndexTab2 = _interopRequireDefault(_IndexTab);

var _Form = __webpack_require__(559);

var _Form2 = _interopRequireDefault(_Form);

var _Entries = __webpack_require__(574);

var _Entries2 = _interopRequireDefault(_Entries);

var _Stats = __webpack_require__(1137);

var _Stats2 = _interopRequireDefault(_Stats);

var _Quotes = __webpack_require__(1127);

var _Quotes2 = _interopRequireDefault(_Quotes);

var _Pedigree = __webpack_require__(1101);

var _Pedigree2 = _interopRequireDefault(_Pedigree);

var _Sales = __webpack_require__(1128);

var _Sales2 = _interopRequireDefault(_Sales);

var _Notes = __webpack_require__(1096);

var _Notes2 = _interopRequireDefault(_Notes);

var _Progeny = __webpack_require__(563);

var _Progeny2 = _interopRequireDefault(_Progeny);

var _ProgenyEntries = __webpack_require__(1115);

var _ProgenyEntries2 = _interopRequireDefault(_ProgenyEntries);

var _ProgenySales = __webpack_require__(1120);

var _ProgenySales2 = _interopRequireDefault(_ProgenySales);

var _WeatherbysOverview = __webpack_require__(568);

var _WeatherbysOverview2 = _interopRequireDefault(_WeatherbysOverview);

var _SireReference = __webpack_require__(1136);

var _SireReference2 = _interopRequireDefault(_SireReference);

var _ProgenyStatistics = __webpack_require__(1124);

var _ProgenyStatistics2 = _interopRequireDefault(_ProgenyStatistics);

var _SalesStatistics = __webpack_require__(1132);

var _SalesStatistics2 = _interopRequireDefault(_SalesStatistics);

var _FeeHistory = __webpack_require__(1067);

var _FeeHistory2 = _interopRequireDefault(_FeeHistory);

var _Nicks = __webpack_require__(1092);

var _Nicks2 = _interopRequireDefault(_Nicks);

var _ProgenyResults = __webpack_require__(1116);

var _ProgenyResults2 = _interopRequireDefault(_ProgenyResults);

var _SalesResults = __webpack_require__(1131);

var _SalesResults2 = _interopRequireDefault(_SalesResults);

var _SalesEntries = __webpack_require__(1130);

var _SalesEntries2 = _interopRequireDefault(_SalesEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childRoutes = [
// common horse tabs
{ path: 'form', Tab: _Form2.default, childRoutes: [{ path: 'my-ratings' }] }, { path: 'entries', Tab: _Entries2.default }, { path: 'stats', Tab: _Stats2.default }, { path: 'quotes', Tab: _Quotes2.default }, { path: 'pedigree', Tab: _Pedigree2.default }, { path: 'sales', Tab: _Sales2.default }, { path: 'notes', Tab: _Notes2.default },

// progeny present on stallion and dam
{ path: 'progeny', Tab: _Progeny2.default },

// dam tabs
{ path: 'progeny-entries', Tab: _ProgenyEntries2.default }, { path: 'progeny-sales', Tab: _ProgenySales2.default },

// stallion tabs
{ path: 'weatherbys-overview', Tab: _WeatherbysOverview2.default }, { path: 'sire-reference', Tab: _SireReference2.default }, { path: 'progeny-dams-sire', Tab: _Progeny2.default }, { path: 'progeny-statistics', Tab: _ProgenyStatistics2.default }, { path: 'progeny-results', Tab: _ProgenyResults2.default }, { path: 'nicks', Tab: _Nicks2.default }, { path: 'fee-history', Tab: _FeeHistory2.default }, { path: 'sales-statistics', Tab: _SalesStatistics2.default }, { path: 'sales-results', Tab: _SalesResults2.default }, { path: 'sales-entries', Tab: _SalesEntries2.default }];

var noFetchTabs = ['entries', 'weatherbys-overview', 'sales-results', 'sales-entries'];

var routes = {
    path: 'horse/:id/:name',
    component: _PageProvider2.default,
    Page: _HorsePage2.default,
    indexRoute: { component: _IndexTab2.default },
    childRoutes: childRoutes.map(function (route) {
        return _extends({}, route, {
            component: noFetchTabs.includes(route.path) ? _TabProvider2.default : _TabFetchProvider2.default
        });
    })
};

exports.default = routes;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HumanPage = __webpack_require__(1141);

var _HumanPage2 = _interopRequireDefault(_HumanPage);

var _Form = __webpack_require__(1147);

var _Form2 = _interopRequireDefault(_Form);

var _Entries = __webpack_require__(574);

var _Entries2 = _interopRequireDefault(_Entries);

var _Horses = __webpack_require__(1159);

var _Horses2 = _interopRequireDefault(_Horses);

var _Stats = __webpack_require__(1166);

var _Stats2 = _interopRequireDefault(_Stats);

var _PageProvider = __webpack_require__(354);

var _PageProvider2 = _interopRequireDefault(_PageProvider);

var _TabFetchProvider = __webpack_require__(257);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _TabProvider = __webpack_require__(355);

var _TabProvider2 = _interopRequireDefault(_TabProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var humans = ['jockey', 'trainer', 'owner'];

var routes = humans.map(function (human) {
    return {
        path: human + '/:id/:name',
        component: _PageProvider2.default,
        Page: _HumanPage2.default,
        indexRoute: {
            component: _TabProvider2.default,
            Tab: _Form2.default
        },
        childRoutes: [{
            path: 'form',
            component: _TabProvider2.default,
            Tab: _Form2.default
        }, {
            path: human === 'jockey' ? 'booked-rides' : 'entries',
            component: _TabProvider2.default,
            Tab: _Entries2.default
        }, {
            path: 'horses',
            component: _TabFetchProvider2.default,
            Tab: _Horses2.default
        }, {
            path: 'stats',
            component: _TabFetchProvider2.default,
            Tab: _Stats2.default
        }]
    };
});

exports.default = routes;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpGuiGuide = __webpack_require__(113);

var _rpGuiGuide2 = _interopRequireDefault(_rpGuiGuide);

var _rpPopup = __webpack_require__(338);

var _rpPopup2 = _interopRequireDefault(_rpPopup);

var _rpUrlNavigationPrefs = __webpack_require__(2283);

var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);

var _initAds = __webpack_require__(1172);

var _initAds2 = _interopRequireDefault(_initAds);

var _initPrices = __webpack_require__(1173);

var _initPrices2 = _interopRequireDefault(_initPrices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    beforeRender: function beforeRender() {
        (0, _rpGuiGuide2.default)({
            // transform svg to inline
            svg: { polyfill: true }
        });
    },
    afterRender: function afterRender() {
        (0, _initAds2.default)();
        (0, _initPrices2.default)();
        (0, _rpPopup2.default)();
        (0, _rpPopup.backLink)();
        (0, _rpUrlNavigationPrefs2.default)();
    }
};

/***/ }),
/* 954 */,
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(153);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(766);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(767);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(768);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(462);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(1795);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(463);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(228);

var _Actions = _interopRequireWildcard(_Actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions;

/***/ }),
/* 957 */,
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var bind = __webpack_require__(542);
var Axios = __webpack_require__(960);
var defaults = __webpack_require__(339);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(539);
axios.CancelToken = __webpack_require__(959);
axios.isCancel = __webpack_require__(540);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(974);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(539);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(339);
var utils = __webpack_require__(73);
var InterceptorManager = __webpack_require__(961);
var dispatchRequest = __webpack_require__(962);
var isAbsoluteURL = __webpack_require__(970);
var combineURLs = __webpack_require__(968);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);
var transformData = __webpack_require__(965);
var isCancel = __webpack_require__(540);
var defaults = __webpack_require__(339);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(541);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(73);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Abbr = function Abbr(_ref) {
    var title = _ref.title,
        children = _ref.children,
        breakpoint = _ref.breakpoint;
    return _jsx('abbr', {
        className: 'cmn-abbr cmn-abbr_from-' + breakpoint,
        title: title
    }, void 0, _jsx('span', {
        className: 'cmn-abbr__inner'
    }, void 0, children || title.charAt(0)));
};

exports.default = Abbr;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Abbr = __webpack_require__(983);

var _Abbr2 = _interopRequireDefault(_Abbr);

__webpack_require__(1765);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Abbr2.default;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__(989);

var _Popover2 = _interopRequireDefault(_Popover);

var _FilterStatus = __webpack_require__(987);

var _FilterStatus2 = _interopRequireDefault(_FilterStatus);

var _updateCategories = __webpack_require__(994);

var _updateCategories2 = _interopRequireDefault(_updateCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_PureComponent) {
    _inherits(Filter, _PureComponent);

    function Filter(props) {
        _classCallCheck(this, Filter);

        var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

        _this.dispatch = function (action) {
            var categoriesReducer = _this.props.categoriesReducer;


            _this.setState(function (_ref) {
                var categories = _ref.categories;
                return {
                    categories: (0, _updateCategories2.default)(categories, categoriesReducer, action)
                };
            });
        };

        _this.resetCategories = function () {
            _this.setState({ categories: _this.props.categories });
        };

        _this.applyFilter = function () {
            _this.props.onFilterApply(_this.state.categories);
        };

        _this.state = {
            categories: props.categories
        };
        return _this;
    }

    _createClass(Filter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var categories = _ref2.categories;

            this.setState({ categories: categories });
        }

        /**
         * When some option is changed we are using two reducers
         * (one that passed through props and one that change selected option)
         * to handle options transformations
         */

    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;
            var categories = this.state.categories;


            if (!categories) return null;

            return _jsx('div', {
                className: 'cmn-filter'
            }, void 0, children || _jsx(_FilterStatus2.default, {
                categories: this.props.categories
            }), _jsx(_Popover2.default, {
                categories: categories,
                resetCategories: this.resetCategories,
                applyFilter: this.applyFilter,
                dispatch: this.dispatch
            }));
        }
    }]);

    return Filter;
}(_react.PureComponent);

Filter.defaultProps = {
    categoriesReducer: function categoriesReducer(categories) {
        return categories;
    }
};

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
exports.default = Filter;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Option = __webpack_require__(988);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'minus',
    size: 'Medium',
    className: 'accordionMinus ui-accordion__arrow tableShowIcon'
});

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'plus',
    size: 'Medium',
    className: 'accordionPlus ui-accordion__arrow tableShowIcon'
});

var Category = function Category(_ref) {
    var type = _ref.type,
        options = _ref.options,
        title = _ref.title,
        dispatch = _ref.dispatch,
        expanded = _ref.expanded,
        toggleExpanded = _ref.toggleExpanded,
        isHidden = _ref.isHidden;
    return options && !isHidden ? _jsx('div', {
        className: 'cmn-filter__category',
        onClick: function onClick() {
            return toggleExpanded(type);
        }
    }, void 0, _jsx('div', {
        className: (0, _classnames2.default)('ui-accordion__header', 'cmn-filter__categoryRow', { 'ui-accordion__header_active': expanded })
    }, void 0, _jsx('span', {
        className: 'cmn-filter__categoryName'
    }, void 0, title, _jsx('span', {
        className: 'cmn-filter__categorySelected'
    }, void 0, options.find(function (option) {
        return option.selected;
    }).label !== 'No filter' && options.find(function (option) {
        return option.selected;
    }).label)), _ref2, _ref3), expanded && _jsx('ul', {}, void 0, options.map(function (_ref4) {
        var value = _ref4.value,
            label = _ref4.label,
            selected = _ref4.selected;
        return _jsx(_Option2.default, {
            label: label,
            selected: selected,
            onClick: function onClick() {
                return dispatch({ type: type, value: value, label: label });
            }
        }, label);
    }))) : null;
};

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
exports.default = Category;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selection = __webpack_require__(547);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */


var FilterStatus = function (_PureComponent) {
    _inherits(FilterStatus, _PureComponent);

    function FilterStatus() {
        _classCallCheck(this, FilterStatus);

        return _possibleConstructorReturn(this, (FilterStatus.__proto__ || Object.getPrototypeOf(FilterStatus)).apply(this, arguments));
    }

    _createClass(FilterStatus, [{
        key: 'render',
        value: function render() {
            var labels = (0, _selection.getStatusLabels)(this.props.categories);

            return _jsx('h2', {
                className: 'cmn-filter__status'
            }, void 0, Object.values(labels).filter(function (label) {
                return label && label !== 'No filter';
            }).join(', '));
        }
    }]);

    return FilterStatus;
}(_react.PureComponent);

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
exports.default = FilterStatus;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'tick',
    size: 'Medium',
    className: 'cmn-filter__optionTick tableShowIcon'
});

var Option = function Option(_ref) {
    var label = _ref.label,
        selected = _ref.selected,
        onClick = _ref.onClick;
    return _jsx('li', {
        className: (0, _classnames2.default)('ui-popoverList__link cmn-filter__option', selected && 'cmn-filter__option_selected'),
        onClick: onClick
    }, void 0, label, _ref2);
};

exports.default = Option;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PopoverComponent2 = __webpack_require__(548);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

var _PopoverHeader = __webpack_require__(992);

var _PopoverHeader2 = _interopRequireDefault(_PopoverHeader);

var _PopoverFooter = __webpack_require__(991);

var _PopoverFooter2 = _interopRequireDefault(_PopoverFooter);

var _PopoverBody = __webpack_require__(990);

var _PopoverBody2 = _interopRequireDefault(_PopoverBody);

var _getFilterPosition = __webpack_require__(993);

var _getFilterPosition2 = _interopRequireDefault(_getFilterPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'filter',
    size: 'Medium',
    className: 'cmn-filter__btnIcon tableShowIcon'
});

var _ref4 = _jsx('div', {
    className: 'cmn-filter__pointer ui-popoverPointer'
});

var Popover = function (_PopoverComponent) {
    _inherits(Popover, _PopoverComponent);

    function Popover() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Popover);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.closePopover = function () {
            _this.setState({ expanded: false });
            _this.props.resetCategories();
        }, _this.openPopover = function (_ref2) {
            var currentTarget = _ref2.currentTarget;

            _this.setState({
                expanded: true,
                position: (0, _getFilterPosition2.default)(currentTarget)
            });
        }, _this.applyFilter = function () {
            _this.props.applyFilter();
            _this.setState({ expanded: false });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Overriding "closePopover" function from PopoverComponent.
     * So when popover is closed, categories went back to default
     */


    /**
     * Overriding "openPopover" function from PopoverComponent.
     * So we can calculate position of filter popover
     */


    _createClass(Popover, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                expanded = _state.expanded,
                position = _state.position;
            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;


            return _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        _this2.node = node;
                    } },
                _jsx('button', {
                    className: 'ui-btn ui-btn_tiertiary',
                    onClick: this.togglePopover
                }, void 0, _ref3, 'Filter'),
                expanded && _jsx('div', {
                    className: 'ui-popover cmn-filter__popover pos_' + position
                }, void 0, _ref4, _jsx(_PopoverHeader2.default, {
                    cancelFilter: this.closePopover
                }), _jsx(_PopoverBody2.default, {
                    categories: categories,
                    dispatch: dispatch
                }), _jsx(_PopoverFooter2.default, {
                    cancelFilter: this.closePopover,
                    applyFilter: this.applyFilter
                }))
            );
        }
    }]);

    return Popover;
}(_PopoverComponent3.default);

Popover.propTypes = {
    categories: _propTypes2.default.shape({}),
    resetCategories: _propTypes2.default.func.isRequired,
    applyFilter: _propTypes2.default.func.isRequired
};

exports.default = Popover;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entries = __webpack_require__(815);

var _entries2 = _interopRequireDefault(_entries);

var _Category = __webpack_require__(986);

var _Category2 = _interopRequireDefault(_Category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverBody = function (_PureComponent) {
    _inherits(PopoverBody, _PureComponent);

    function PopoverBody(props) {
        _classCallCheck(this, PopoverBody);

        var _this = _possibleConstructorReturn(this, (PopoverBody.__proto__ || Object.getPrototypeOf(PopoverBody)).call(this, props));

        _initialiseProps.call(_this);

        var expandedCategory = (0, _entries2.default)(props.categories).length === 1 ? (0, _entries2.default)(props.categories)[0][0] : null;

        _this.state = { expandedCategory: expandedCategory };
        return _this;
    }

    // setting current expanded category


    _createClass(PopoverBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;
            var expandedCategory = this.state.expandedCategory;


            return _jsx('div', {
                className: 'cmn-filter__popoverBody'
            }, void 0, (0, _entries2.default)(categories).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    categoryName = _ref2[0],
                    category = _ref2[1];

                return _jsx(_Category2.default, {
                    type: categoryName,
                    toggleExpanded: _this2.toggleExpanded,
                    expanded: expandedCategory === categoryName,
                    title: category.title,
                    options: category.options,
                    dispatch: dispatch,
                    isHidden: category.isHidden
                }, categoryName);
            }));
        }
    }]);

    return PopoverBody;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.toggleExpanded = function (category) {
        _this3.setState(function (_ref3) {
            var expandedCategory = _ref3.expandedCategory;
            return {
                expandedCategory: expandedCategory === category ? null : category
            };
        });
    };
};

exports.default = PopoverBody;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var btnCls = 'cmn-filter__footerBtn ui-btn';

var PopoverFooter = function PopoverFooter(_ref) {
    var cancelFilter = _ref.cancelFilter,
        applyFilter = _ref.applyFilter;
    return _jsx('div', {
        className: 'cmn-filter__popoverFooter'
    }, void 0, _jsx('button', {
        className: btnCls + ' ' + btnCls + '_secondary',
        onClick: cancelFilter
    }, void 0, 'Cancel'), _jsx('button', {
        className: btnCls + ' ' + btnCls + '_primary',
        onClick: applyFilter
    }, void 0, 'Apply'));
};

exports.default = PopoverFooter;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'cross',
    className: 'tableShowIcon',
    size: 'Medium'
});

var PopoverHeader = function PopoverHeader(_ref) {
    var cancelFilter = _ref.cancelFilter;
    return _jsx('div', {
        className: 'ui-popoverHeader cmn-filter__popoverHeader'
    }, void 0, 'Choose Filters', _jsx('button', {
        className: 'ui-btn ui-btn_secondary cmn-filter__crossBtn',
        onClick: cancelFilter
    }, void 0, _ref2));
};

exports.default = PopoverHeader;

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var requiredHeight = 450;

var getFilterPosition = function getFilterPosition(btn) {
    var _btn$getBoundingClien = btn.getBoundingClientRect(),
        topSpace = _btn$getBoundingClien.top,
        bottom = _btn$getBoundingClien.bottom;

    var bottomSpace = window.innerHeight - bottom;

    if (bottomSpace > requiredHeight) {
        return 'bottom';
    } else if (topSpace > requiredHeight) {
        return 'top';
    }
    return 'left';
};

exports.default = getFilterPosition;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleSelected = function toggleSelected(arr, value) {
    return arr.map(function (item) {
        if (item.value === value) {
            return _extends({}, item, { selected: true });
        }
        if (item.selected) {
            return _extends({}, item, { selected: false });
        }
        return item;
    });
};

var setSelectReducer = function setSelectReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    return _extends({}, categories, _defineProperty({}, type, _extends({}, categories[type], {
        options: toggleSelected(categories[type].options, value)
    })));
};

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
var updateCategories = function updateCategories(categories, reducer, action) {
    return setSelectReducer(reducer(categories, action), action);
};

exports.default = updateCategories;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverComponent = function (_PureComponent) {
    _inherits(PopoverComponent, _PureComponent);

    function PopoverComponent(props) {
        _classCallCheck(this, PopoverComponent);

        var _this = _possibleConstructorReturn(this, (PopoverComponent.__proto__ || Object.getPrototypeOf(PopoverComponent)).call(this, props));

        _this.onOutsideClick = function (event) {
            var domNode = _this.node;
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        };

        _this.closePopover = function () {
            _this.setState({ expanded: false });
        };

        _this.openPopover = function () {
            _this.setState({ expanded: true });
        };

        _this.togglePopover = function (e) {
            if (_this.state.expanded) {
                _this.closePopover(e);
            } else {
                _this.openPopover(e);
            }
        };

        _this.state = { expanded: false };
        return _this;
    }

    _createClass(PopoverComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }]);

    return PopoverComponent;
}(_react.PureComponent);

exports.default = PopoverComponent;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

__webpack_require__(1766);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'ui-popoverList__icon'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'tick',
    size: 'Medium'
}));

var PopoverListItem = function PopoverListItem(_ref) {
    var isSelected = _ref.isSelected,
        text = _ref.text,
        onSelect = _ref.onSelect;
    return _jsx('div', {
        className: (0, _classnames2.default)('ui-popoverList__item', 'cm-popoverList__popoverLink', { 'cm-popoverList__popoverLink_selected': isSelected }),
        onClick: onSelect
    }, void 0, _jsx('span', {
        className: (0, _classnames2.default)('ui-popoverList__label', 'cm-popoverList__popoverLabel')
    }, void 0, text), _ref2);
};

PopoverListItem.defaultProps = {
    text: null
};

exports.default = PopoverListItem;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverListItem = __webpack_require__(996);

var _PopoverListItem2 = _interopRequireDefault(_PopoverListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PopoverListItem2.default;

/***/ }),
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaData = __webpack_require__(352);

var _MetaData2 = _interopRequireDefault(_MetaData);

var _NameRow = __webpack_require__(1043);

var _NameRow2 = _interopRequireDefault(_NameRow);

var _RaceDays = __webpack_require__(1044);

var _RaceDays2 = _interopRequireDefault(_RaceDays);

var _Nav = __webpack_require__(353);

var _Nav2 = _interopRequireDefault(_Nav);

var _object = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoursePage = function CoursePage(_ref) {
    var data = _ref.data,
        children = _ref.children,
        params = _ref.params;

    var courseInfoTab = Object.assign({}, data.admission, data.directions);

    var tabsToExclude = [(0, _object.areAllFieldsEmpty)(data.standardTimes) && 'course-records', (0, _object.areAllFieldsEmpty)(courseInfoTab) && 'course-info', !data.courseMap && 'course-map'];

    return _jsx('div', {}, void 0, _jsx('section', {}, void 0, _jsx(_MetaData2.default, {
        type: params.type,
        page: params.tab ? params.tab : 'stats',
        name: data.profile.courseStyleName
    }), _jsx(_NameRow2.default, {
        profile: data.profile
    }), _jsx(_RaceDays2.default, {
        data: data.upcomingRaces || [],
        params: params
    })), _jsx(_Nav2.default, {
        params: params,
        helpUrl: data.helpCenterUrl,
        tabsToExclude: tabsToExclude
    }), (0, _react.cloneElement)(children, { data: data, params: params }));
};

exports.default = CoursePage;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Address');

var _ref3 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Admission');

var _ref4 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'How to get there');

var _ref5 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Parking');

var _ref6 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Disabled');

var CourseInfo = function CourseInfo(_ref) {
    var _ref$data = _ref.data,
        _ref$data$directions = _ref$data.directions,
        courseAddress = _ref$data$directions.courseAddress,
        rpParking = _ref$data$directions.rpParking,
        rpDisabled = _ref$data$directions.rpDisabled,
        howToGetThere = _ref$data$directions.howToGetThere,
        _ref$data$admission = _ref$data.admission,
        rpAdmissionPrices = _ref$data$admission.rpAdmissionPrices,
        rpChildren = _ref$data$admission.rpChildren;
    return _jsx('section', {
        className: 'cp-courseInfo'
    }, void 0, courseAddress && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref2, courseAddress), ((0, _lodash.trim)(rpAdmissionPrices) || (0, _lodash.trim)(rpChildren)) && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref3, (0, _lodash.trim)(rpAdmissionPrices) && _jsx('p', {
        className: 'cp-courseInfo__row'
    }, void 0, 'General Admission: ', rpAdmissionPrices), (0, _lodash.trim)(rpChildren) && _jsx('p', {
        className: 'cp-courseInfo__row'
    }, void 0, 'Children: ', rpChildren)), _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref4, (0, _lodash.keys)(howToGetThere).map(function (key) {
        return howToGetThere[key] ? _jsx('span', {}, key, _jsx('span', {
            className: 'cp-courseInfo__subtitle'
        }, void 0, key, ': '), howToGetThere[key], '\xA0') : null;
    })), (0, _lodash.trim)(rpParking) && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref5, rpParking), (0, _lodash.trim)(rpDisabled) && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref6, rpDisabled));
};

exports.default = CourseInfo;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGoogleMaps = __webpack_require__(2070);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseGoogleMap = (0, _reactGoogleMaps.withGoogleMap)(function (_ref) {
    var defaultZoom = _ref.defaultZoom,
        pos = _ref.pos;
    return _jsx(_reactGoogleMaps.GoogleMap, {
        defaultZoom: defaultZoom,
        defaultCenter: pos,
        defaultMapTypeId: 'satellite'
    }, void 0, _jsx(_reactGoogleMaps.Marker, {
        position: pos
    }));
});

CourseGoogleMap.propTypes = {
    defaultZoom: _propTypes2.default.number.isRequired,
    pos: _propTypes2.default.shape({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }).isRequired
};

exports.default = CourseGoogleMap;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Switcher = __webpack_require__(253);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(161);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _helpers = __webpack_require__(1036);

var _CourseGoogleMap = __webpack_require__(1034);

var _CourseGoogleMap2 = _interopRequireDefault(_CourseGoogleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapWrappers = {
    containerElement: _jsx('div', {
        className: 'cp-courseMap__container'
    }),
    mapElement: _jsx('div', {
        className: 'cp-courseMap__map'
    })
};

var CourseMap = function (_PureComponent) {
    _inherits(CourseMap, _PureComponent);

    function CourseMap(props) {
        _classCallCheck(this, CourseMap);

        var _this = _possibleConstructorReturn(this, (CourseMap.__proto__ || Object.getPrototypeOf(CourseMap)).call(this, props));

        _this.setSelected = function (selected) {
            _this.setState({ selected: selected }, function () {
                (0, _fixMobileSafariWhiteScreenBug2.default)();
            });
        };

        _this.state = { selected: 0 };
        return _this;
    }

    _createClass(CourseMap, [{
        key: 'render',
        value: function render() {
            var selected = this.state.selected;
            var courseMap = this.props.data.courseMap;

            var titles = courseMap.map(_helpers.getSwitcherTitle);
            var item = courseMap[selected];

            var _courseMap$ = courseMap[0],
                zoom = _courseMap$.zoom,
                lat = _courseMap$.latitude,
                lng = _courseMap$.longitude;

            var pos = { lat: lat, lng: lng };

            return _jsx('section', {
                className: 'cp-courseMap'
            }, void 0, _jsx('div', {
                className: 'cp-courseMap__switchDescWrapper'
            }, void 0, _jsx(_Switcher2.default, {
                items: titles,
                selected: selected,
                setSelected: this.setSelected
            }), _jsx('div', {
                className: 'cp-courseMap__description'
            }, void 0, (0, _helpers.getDescription)(item))), item.largeMapImagePath && _jsx('figure', {
                className: 'pp-figure'
            }, void 0, _jsx('img', {
                src: item.largeMapImagePath,
                alt: 'Course Map'
            })), _react2.default.createElement(_CourseGoogleMap2.default, _extends({
                defaultZoom: zoom,
                pos: pos
            }, mapWrappers)));
        }
    }]);

    return CourseMap;
}(_react.PureComponent);

exports.default = CourseMap;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDescription = exports.getSwitcherTitle = undefined;

var _lodash = __webpack_require__(6);

var getSwitcherTitle = exports.getSwitcherTitle = function getSwitcherTitle(_ref) {
    var code = _ref.raceTypeCode[0];

    switch (code) {
        case 'F':
        case 'W':
        case 'X':
            return 'Flat';
        case 'H':
            return 'Hurdle';
        case 'U':
        case 'C':
            return 'Chase';
        default:
            return '';
    }
};

var getDescription = exports.getDescription = function getDescription(_ref2) {
    var raceTypeCode = _ref2.raceTypeCode,
        rpDetailedAwDesc = _ref2.rpDetailedAwDesc,
        rpDetailedFlatDesc = _ref2.rpDetailedFlatDesc,
        rpDetailedJumpDesc = _ref2.rpDetailedJumpDesc;

    if ((0, _lodash.intersection)(raceTypeCode, ['W', 'X', 'Y', 'Z']).length) {
        return rpDetailedAwDesc;
    } else if (raceTypeCode.includes('F')) {
        return rpDetailedFlatDesc;
    } else if ((0, _lodash.intersection)(raceTypeCode, ['U', 'C', 'P', 'H', 'B']).length) {
        return rpDetailedJumpDesc;
    }
    return '';
};

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(6);

var _Switcher = __webpack_require__(253);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(161);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _columns = __webpack_require__(1038);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_rpReactTable.NoData, {});

var CourseRecords = function (_PureComponent) {
    _inherits(CourseRecords, _PureComponent);

    function CourseRecords(props) {
        _classCallCheck(this, CourseRecords);

        var _this = _possibleConstructorReturn(this, (CourseRecords.__proto__ || Object.getPrototypeOf(CourseRecords)).call(this, props));

        _this.setSelected = function (selected) {
            _this.setState({ selected: selected }, function () {
                (0, _fixMobileSafariWhiteScreenBug2.default)();
            });
        };

        _this.state = { selected: 0 };
        return _this;
    }

    _createClass(CourseRecords, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                standardTimes = _props.data.standardTimes,
                _props$params = _props.params,
                id = _props$params.id,
                name = _props$params.name;
            var selected = this.state.selected;

            var availableTypes = [];

            if (standardTimes.flat) {
                availableTypes.push('flat');
            }
            if (standardTimes.jumps) {
                availableTypes.push('jumps');
            }

            var selectedType = availableTypes[selected];
            var tableData = (0, _lodash.sortBy)(standardTimes[selectedType], ['distanceYards', 'horseName']);

            // selectedType could be empty only if you get here by direct link
            return selectedType ? _jsx('section', {
                className: 'cp-courseRecords'
            }, void 0, availableTypes.length > 1 ? _jsx(_Switcher2.default, {
                items: availableTypes,
                selected: selected,
                setSelected: this.setSelected
            }) : null, _jsx(_rpReactTable2.default, {
                columns: (0, _columns2.default)(name, id, selectedType),
                data: tableData
            })) : _ref;
        }
    }]);

    return CourseRecords;
}(_react.PureComponent);

var recordPropTypes = _propTypes2.default.shape({
    averageTimeSec: _propTypes2.default.number,
    courseRecordHorseName: _propTypes2.default.string,
    distanceYards: _propTypes2.default.number,
    horseCountryOriginCode: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    noOfFences: _propTypes2.default.number,
    raceDate: _propTypes2.default.string,
    raceInstanceUid: _propTypes2.default.number,
    raceTypeCode: _propTypes2.default.string,
    rpAgesAllowedDesc: _propTypes2.default.string,
    straightRoundJubileeCode: _propTypes2.default.string,
    winnersTime: _propTypes2.default.number
});

exports.default = CourseRecords;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactTable = __webpack_require__(22);

var _ProfileLink = __webpack_require__(24);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _distance = __webpack_require__(93);

var _date = __webpack_require__(19);

var _formatTime = __webpack_require__(1200);

var _formatTime2 = _interopRequireDefault(_formatTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(courseName, courseUid, raceType) {
    return [{
        key: 'distanceYards',
        header: 'distance',
        /** for IRE courses use average-times request
         *  it has distanceYard and noOfObstacles instead of distanceYards and noOfFences
         */
        cell: function cell(_ref) {
            var distanceYards = _ref.distanceYards,
                distanceYard = _ref.distanceYard,
                raceTypeCode = _ref.raceTypeCode,
                noOfFences = _ref.noOfFences,
                noOfObstacles = _ref.noOfObstacles;
            return _jsx('span', {}, void 0, (0, _distance.yardsToFurlongs)(distanceYards || distanceYard), raceType === 'jumps' && raceTypeCode ? '(' + raceTypeCode + ')' : '', noOfFences || noOfObstacles ? '(' + (noOfFences || noOfObstacles) + ')' : '');
        }
    }, {
        key: 'horseName',
        header: 'record holder',
        cell: function cell(_ref2) {
            var horseName = _ref2.horseName,
                horseUid = _ref2.horseUid,
                horseCountryOriginCode = _ref2.horseCountryOriginCode,
                rpAgesAllowedDesc = _ref2.rpAgesAllowedDesc;
            return horseUid || horseName ? _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
                horseUid: horseUid,
                horseStyleName: horseName
            }), '\xA0(', horseCountryOriginCode, ') \xA0(', rpAgesAllowedDesc, ')') : _rpReactTable.EMPTINESS_SIGN;
        }
    }, {
        key: 'raceDate',
        header: 'date',
        cell: function cell(_ref3) {
            var raceInstanceUid = _ref3.raceInstanceUid,
                raceDate = _ref3.raceDate;
            return _jsx(_ResultLink2.default, {
                courseName: courseName,
                courseUid: +courseUid,
                raceInstanceUid: raceInstanceUid,
                raceDatetime: raceDate
            }, void 0, (0, _date.formatDate)(raceDate, 'DDMMMYY'));
        }
    }, {
        key: 'winnersTime',
        header: 'course record',
        cell: function cell(_ref4) {
            var raceInstanceUid = _ref4.raceInstanceUid,
                raceDate = _ref4.raceDate,
                winnersTime = _ref4.winnersTime;
            return winnersTime ? _jsx(_Abbr2.default, {
                title: (0, _formatTime2.default)(winnersTime)
            }, void 0, _jsx(_ResultLink2.default, {
                courseName: courseName,
                courseUid: +courseUid,
                raceInstanceUid: raceInstanceUid,
                raceDatetime: raceDate,
                className: 'pp-abbr__inner'
            }, void 0, (0, _formatTime2.default)(winnersTime))) : _rpReactTable.EMPTINESS_SIGN;
        }
    }, {
        key: 'averageTimeSec',
        header: 'rp standard',
        cell: function cell(_ref5) {
            var averageTimeSec = _ref5.averageTimeSec;
            return (0, _formatTime2.default)(averageTimeSec);
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _lodash = __webpack_require__(6);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(66);

var _HeaderRow = __webpack_require__(1040);

var _HeaderRow2 = _interopRequireDefault(_HeaderRow);

var _columns = __webpack_require__(1041);

var _columns2 = _interopRequireDefault(_columns);

var _name = __webpack_require__(195);

var _object = __webpack_require__(260);

var _categories = __webpack_require__(556);

var _categories2 = _interopRequireDefault(_categories);

var _reducer = __webpack_require__(1042);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noDataText = 'No favourites records available in the Racing Post database for this year.';

var Favourites = function (_FilteringComponent) {
    _inherits(Favourites, _FilteringComponent);

    function Favourites(props) {
        _classCallCheck(this, Favourites);

        var _this = _possibleConstructorReturn(this, (Favourites.__proto__ || Object.getPrototypeOf(Favourites)).call(this, props));

        var _this$props$data = _this.props.data,
            favourites = _this$props$data.favourites,
            profile = _this$props$data.profile,
            seasonDefaults = _this$props$data.seasonDefaults;
        var courseCountryCode = profile.courseCountryCode,
            courseTypeCode = profile.courseTypeCode;
        var seasonRaceType = seasonDefaults.seasonRaceType;


        _this.dataKey = 'favourites';
        _this.emptyData = { handicap: {}, nonHandicap: {} };

        _this.state = {
            categories: (0, _categories2.default)(seasonRaceType, courseCountryCode, courseTypeCode),
            data: favourites || _this.emptyData,
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(Favourites, [{
        key: 'renderStatus',
        value: function renderStatus() {
            var categories = this.state.categories;

            var raceType = _filter3.selection.getCaption(categories, 'raceType');

            var _selection$getOption = _filter3.selection.getOption(categories, 'timePeriod'),
                value = _selection$getOption.value,
                label = _selection$getOption.label;

            if (value.match(/last5/)) {
                return _jsx('h2', {
                    className: 'ui-filter__statusText'
                }, void 0, raceType, ', ', (0, _lodash.toLower)(label));
            }

            var years = (0, _lodash.uniq)(value.split('/').slice(0, 2));
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceType, ', ', years.join('-'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                categories = _state.categories,
                _state$data = _state.data,
                handicap = _state$data.handicap,
                nonHandicap = _state$data.nonHandicap,
                loading = _state.loading,
                fetchError = _state.fetchError;


            var isEmptyTable = (0, _object.areAllFieldsEmpty)(handicap) || (0, _object.areAllFieldsEmpty)(nonHandicap);
            // merging "handicap" and "nonHandicap" objects into one array
            var data = (0, _lodash.keys)(handicap).map(function (key) {
                return _extends({
                    // key of object is the raceName
                    raceName: (0, _name.formatRaceName)(key)
                }, handicap[key], {
                    // for non-handicap keys added preffix "nh_"
                    // to avoid key duplication
                    nh_percentage: nonHandicap[key].percentage,
                    nh_wins: nonHandicap[key].wins,
                    nh_runs: nonHandicap[key].runs,
                    nh_stake: nonHandicap[key].stake
                });
            });

            // extract total row from array
            var total = isEmptyTable ? null : data.find(function (_ref) {
                var raceName = _ref.raceName;
                return raceName === 'TOTAL';
            });
            var tableData = isEmptyTable ? null : (0, _lodash.without)(data, total);

            return _jsx('section', {
                className: 'cp-favourites'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: tableData,
                footerData: total,
                columns: _columns2.default,
                initialSortIdx: 0,
                sortable: true,
                className: 'cp-favouritesTable',
                headerRow: _HeaderRow2.default,
                loading: loading,
                noDataText: noDataText
            }));
        }
    }]);

    return Favourites;
}(_filter2.default);

// shape of handicap and non-handicap objects


var itemPropsShape = _propTypes2.default.shape({
    percentage: _propTypes2.default.number,
    runs: _propTypes2.default.number.isRequired,
    stake: _propTypes2.default.number.isRequired,
    wins: _propTypes2.default.number.isRequired
});

Favourites.propTypes = {
    data: _propTypes2.default.shape({
        favourites: _propTypes2.default.shape({
            handicap: _propTypes2.default.objectOf(itemPropsShape),
            nonHandicap: _propTypes2.default.objectOf(itemPropsShape)
        }),
        profile: _propTypes2.default.shape({
            courseTypeCode: _propTypes2.default.string.isRequired,
            courseCountryCode: _propTypes2.default.string.isRequired
        }),
        seasonDefaults: _propTypes2.default.shape({
            seasonRaceType: _propTypes2.default.string.isRequired
        })
    }).isRequired,
    params: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
    }).isRequired
};

exports.default = Favourites;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx("tr", {}, void 0, _jsx("th", {}), _jsx("th", {
    className: "cp-favourites__specialCell hidden-sm-up",
    colSpan: "2"
}, void 0, "non handicap"), _jsx("th", {
    className: "cp-favourites__specialCell hidden-sm-up",
    colSpan: "2"
}, void 0, "handicap"), _jsx("th", {
    className: "cp-favourites__specialCell hidden-xs-down",
    colSpan: "4"
}, void 0, "non handicap"), _jsx("th", {
    className: "cp-favourites__specialCell hidden-xs-down",
    colSpan: "4"
}, void 0, "handicap"));

var HeaderRow = function HeaderRow() {
    return _ref;
};

exports.default = HeaderRow;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _name = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var handicapColumns = function handicapColumns(prefix) {
    return [{
        key: prefix + 'wins',
        header: 'wins'
    }, {
        key: prefix + 'runs',
        header: 'runs'
    }, {
        key: prefix + 'percentage',
        header: '%'
    }, {
        key: prefix + 'stake',
        header: '£1 stake'
    }];
};

var _ref = _jsx(_Abbr2.default, {
    title: 'by favourites'
}, void 0, 'fav');

var columns = [{
    key: 'raceName',
    header: function header() {
        return _ref;
    },
    sortFn: (0, _name.sortByRaceName)('raceName')
}].concat(_toConsumableArray(handicapColumns('nh_')), _toConsumableArray(handicapColumns('')));

exports.default = columns;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(556);

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        countryCode = _timePeriod$createdBy.countryCode;


    if (action.type === 'raceType' && raceType !== action.value) {
        return (0, _categories.timePeriodFactory)(action.value, countryCode);
    }

    return timePeriod;
};

var categoriesReducer = function categoriesReducer(_ref, action) {
    var raceType = _ref.raceType,
        timePeriod = _ref.timePeriod;
    return {
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpGuiGuide = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameRow = function NameRow(_ref) {
    var _ref$profile = _ref.profile,
        courseStyleName = _ref$profile.courseStyleName,
        courseClerk = _ref$profile.courseClerk,
        courseTel = _ref$profile.courseTel;
    return _jsx('div', {
        className: 'cp-nameRow'
    }, void 0, _jsx('h1', {
        className: 'cp-nameRow__name'
    }, void 0, courseStyleName), courseClerk && _jsx('div', {}, void 0, 'Clerk of the course\xA0', _jsx('span', {
        className: 'cp-nameRow__data'
    }, void 0, courseClerk)), courseTel && _jsx('div', {}, void 0, 'Racecourse contact\xA0', _rpGuiGuide.mobileDetect.isPhone() ? _jsx('a', {
        href: 'tel: ' + courseTel,
        className: 'ui-link cp-nameRow__data'
    }, void 0, courseTel) : _jsx('span', {
        className: 'cp-nameRow__data'
    }, void 0, courseTel)));
};

exports.default = NameRow;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _columns = __webpack_require__(1045);

var _columns2 = _interopRequireDefault(_columns);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('h2', {
    className: 'cp-raceDays__title'
}, void 0, 'Upcoming Racedays');

var RaceDays = function (_PureComponent) {
    _inherits(RaceDays, _PureComponent);

    function RaceDays(props) {
        _classCallCheck(this, RaceDays);

        var _this = _possibleConstructorReturn(this, (RaceDays.__proto__ || Object.getPrototypeOf(RaceDays)).call(this, props));

        _this.toggle = function () {
            _this.setState({
                expanded: !_this.state.expanded
            });
        };

        _this.state = {
            expanded: false,
            data: props.data.sort((0, _date.sortByDate)('raceDate', true))
        };
        return _this;
    }

    _createClass(RaceDays, [{
        key: 'render',
        value: function render() {
            var _props$params = this.props.params,
                name = _props$params.name,
                id = _props$params.id;
            var _state = this.state,
                expanded = _state.expanded,
                data = _state.data;

            var slicedData = expanded ? data : data.slice(0, 5);
            var iconName = expanded ? 'up' : 'down';

            return _jsx('div', {
                className: 'cp-raceDays'
            }, void 0, _ref, _jsx(_rpReactTable2.default, {
                data: slicedData,
                columns: (0, _columns2.default)(name, id),
                uiType: 5,
                noDataText: 'No upcoming racedays'
            }), data && data.length > 5 && _jsx('button', {
                className: 'ui-btn',
                onClick: this.toggle
            }, void 0, _jsx(_rpReactSvgIcon2.default, {
                iconName: iconName,
                size: 'Medium'
            }, iconName)));
        }
    }]);

    return RaceDays;
}(_react.PureComponent);

exports.default = RaceDays;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _RaceDayLink = __webpack_require__(1185);

var _RaceDayLink2 = _interopRequireDefault(_RaceDayLink);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(name, id) {
    return [{
        key: 'raceDate',
        header: 'date',
        cell: function cell(_ref) {
            var raceDate = _ref.raceDate;
            return _jsx(_RaceDayLink2.default, {
                courseName: name,
                courseUid: +id,
                raceDate: raceDate
            }, void 0, _jsx('span', {
                className: 'hidden-sm-up'
            }, void 0, (0, _date.formatDate)(raceDate, 'DDMMMYY')), _jsx('span', {
                className: 'hidden-xs-down'
            }, void 0, (0, _date.formatDate)(raceDate, 'dddd, D MMMM Y')));
        }
    }, {
        key: 'raceDatetimeFirst',
        header: 'first race',
        cell: function cell(_ref2) {
            var raceDatetimeFirst = _ref2.raceDatetimeFirst;
            return (0, _date.formatDate)(raceDatetimeFirst, 'h:mm');
        }
    }, {
        key: 'raceDatetimeLast',
        header: 'last race',
        cell: function cell(_ref3) {
            var raceDatetimeLast = _ref3.raceDatetimeLast;
            return (0, _date.formatDate)(raceDatetimeLast, 'h:mm');
        }
    }, {
        key: '',
        header: ' ',
        cell: function cell() {
            return null;
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _columns = __webpack_require__(1047);

var _columns2 = _interopRequireDefault(_columns);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _categories = __webpack_require__(557);

var _categories2 = _interopRequireDefault(_categories);

var _reducer = __webpack_require__(1048);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Results = function (_FilteringComponent) {
    _inherits(Results, _FilteringComponent);

    function Results(props) {
        _classCallCheck(this, Results);

        var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));

        var _props$data = props.data,
            seasonInfo = _props$data.seasonInfo,
            seasonsAvailable = _props$data.seasonsAvailable,
            courseTypeCode = _props$data.profile.courseTypeCode,
            principleRaceResults = _props$data.principleRaceResults;
        var coursePrincipalSeason = seasonInfo.coursePrincipalSeason,
            raceType = seasonInfo.raceType,
            raceStatusType = seasonInfo.raceStatusType;


        _this.state = {
            data: principleRaceResults,
            categories: (0, _categories2.default)(raceStatusType, courseTypeCode, raceType, coursePrincipalSeason, seasonsAvailable),
            loading: false,
            fetchError: false
        };

        var _this$props$params = _this.props.params,
            name = _this$props$params.name,
            id = _this$props$params.id;

        _this.columns = (0, _columns2.default)(name, id);

        // key for getting info from API request
        _this.dataKey = 'principleRaceResults';
        return _this;
    }

    _createClass(Results, [{
        key: 'renderDefaultStatus',
        value: function renderDefaultStatus() {
            var _props$data$seasonInf = this.props.data.seasonInfo,
                raceStatusType = _props$data$seasonInf.raceStatusType,
                raceType = _props$data$seasonInf.raceType,
                year = _props$data$seasonInf.coursePrincipalSeason;


            var years = raceType === 'jumps' ? year + '-' + (year + 1) : year;
            var raceStatus = raceStatusType === 'big-race' ? 'Big races' : 'All races';

            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceStatus, ', ', raceType, ', ', years);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'cp-results'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                columns: this.columns,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                columns: this.columns,
                data: data,
                loading: loading,
                initialSortIdx: 0,
                noDataText: 'No results found'
            }));
        }
    }]);

    return Results;
}(_filter2.default);

Results.propTypes = {
    data: _propTypes2.default.shape({
        seasonInfo: _propTypes2.default.shape({
            coursePrincipalSeason: _propTypes2.default.number,
            raceStatusType: _propTypes2.default.string,
            raceType: _propTypes2.default.string
        }),
        principleRaceResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            horseStyleName: _propTypes2.default.string,
            horseUid: _propTypes2.default.number,
            prizeSterling: _propTypes2.default.number,
            raceDatetime: _propTypes2.default.string,
            raceInstanceTitle: _propTypes2.default.string,
            raceInstanceUid: _propTypes2.default.number,
            trainerStyleName: _propTypes2.default.string,
            trainerUid: _propTypes2.default.number
        }))
    }).isRequired,
    params: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.string.isRequired
    }).isRequired
};

exports.default = Results;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(24);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _date = __webpack_require__(19);

var _money = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(name, id) {
    return [{
        key: 'raceDatetime',
        header: 'date',
        sortFn: (0, _date.sortByDate)('raceDatetime'),
        cell: function cell(_ref) {
            var raceDatetime = _ref.raceDatetime;
            return (0, _date.formatDate)(raceDatetime, 'DDMMMYY');
        }
    }, {
        key: 'raceInstanceUid',
        header: 'race name',
        cell: function cell(row) {
            return _react2.default.createElement(_ResultLink2.default, _extends({}, row, {
                courseName: name,
                courseUid: +id
            }));
        }
    }, {
        key: 'horseUid',
        header: 'winner',
        cell: _ProfileLink.HorseLink
    }, {
        key: 'trainerUid',
        header: 'trainer',
        cell: _ProfileLink.TrainerLink
    }, {
        key: 'prizeSterling',
        header: 'winnings',
        cell: function cell(_ref2) {
            var prizeSterling = _ref2.prizeSterling;
            return (0, _money.formatMoney)(prizeSterling);
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(557);

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        principalSeason = _timePeriod$createdBy.principalSeason,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable;


    if (action.type === 'raceType' && raceType !== action.value) {
        return (0, _categories.timePeriodFactory)(action.value, principalSeason, seasonsAvailable);
    }

    return timePeriod;
};

var categoriesReducer = function categoriesReducer(_ref, action) {
    var raceCategory = _ref.raceCategory,
        raceType = _ref.raceType,
        timePeriod = _ref.timePeriod;
    return {
        raceCategory: raceCategory,
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _columns = __webpack_require__(1053);

var _columns2 = _interopRequireDefault(_columns);

var _Select = __webpack_require__(350);

var _Select2 = _interopRequireDefault(_Select);

var _date = __webpack_require__(19);

var _transformData = __webpack_require__(1054);

var _transformData2 = _interopRequireDefault(_transformData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tableKeys = ['travelersCheck', 'firstTimeBlinkers', 'sevenDayWinners'];
var tableHeaders = ['Travellers\' Check', 'First Time Blinkers', 'Seven-Day Winners'];

var _ref2 = _jsx('strong', {}, void 0, 'Meeting');

var _ref3 = _jsx(_rpReactTable.Loading, {});

var Signposts = function (_PureComponent) {
    _inherits(Signposts, _PureComponent);

    function Signposts(props) {
        _classCallCheck(this, Signposts);

        var _this = _possibleConstructorReturn(this, (Signposts.__proto__ || Object.getPrototypeOf(Signposts)).call(this, props));

        _this.onSelect = function (val) {
            if (_this.state.selectValue === +val) {
                return;
            }
            _this.fetchData(+val);
        };

        var dates = (props.data.upcomingRaces || []).sort((0, _date.sortByDate)('raceDate', true)).map(function (item) {
            return item.raceDate;
        });
        _this.state = {
            signposts: props.data.signposts,
            optionDates: dates.map(function (date) {
                return (0, _date.formatDate)(date, 'dddd, DD MMM Y');
            }),
            urlDates: dates.map(function (date) {
                return (0, _date.formatDate)(date, 'Y-MM-DD');
            }),
            selectValue: 0,
            loading: false
        };
        return _this;
    }

    _createClass(Signposts, [{
        key: 'fetchData',
        value: function fetchData(selectValue) {
            var _this2 = this;

            this.setState({ selectValue: selectValue, loading: true });

            var id = this.props.params.id;

            var urlDate = this.state.urlDates[selectValue];
            _axios2.default.get('course/filter/signposts/' + id + '/' + urlDate).then(function (_ref) {
                var data = _ref.data;

                _this2.setState({
                    loading: false,
                    signposts: data.signposts
                });
            }).catch(function (error) {
                return console.warn(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                signposts = _state.signposts,
                optionDates = _state.optionDates,
                loading = _state.loading,
                selectValue = _state.selectValue;
            var params = this.props.params;

            var transSignposts = (0, _transformData2.default)(signposts, params);

            return _jsx('section', {
                className: 'cp-signposts'
            }, void 0, optionDates.length > 1 && _jsx('div', {
                className: 'cp-signposts__dropdown'
            }, void 0, _ref2, _jsx(_Select2.default, {
                value: selectValue,
                options: optionDates,
                onSelect: this.onSelect
            })), loading ? _ref3 : tableKeys.map(function (key, i) {
                return _jsx('div', {
                    className: 'cp-signposts__' + key
                }, key, _jsx('h3', {}, void 0, tableHeaders[i]), _jsx(_rpReactTable2.default, {
                    columns: _columns2.default[key],
                    data: transSignposts[key],
                    sortable: key === 'travelersCheck',
                    initialSortIdx: key === 'travelersCheck' ? 3 : 1,
                    noDataText: 'No ' + tableHeaders[i] + ' data available\n                                for this meeting in the Racing Post database'
                }));
            }));
        }
    }]);

    return Signposts;
}(_react.PureComponent);

var columnPropsShape = {
    horseStyleName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    raceDatetime: _propTypes2.default.string
};

exports.default = Signposts;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

var _RaceCardLink = __webpack_require__(255);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TravellersRaceCell = function TravellersRaceCell(props) {
    return _react2.default.createElement(
        _RaceCardLink2.default,
        props,
        (0, _date.formatDate)(props.raceDatetime, 'h:mm')
    );
};

exports.default = TravellersRaceCell;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

var _RaceCardLink = __webpack_require__(255);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpcomingRaceCell = function UpcomingRaceCell(_ref) {
    var upcomingRace = _ref.upcomingRace;
    return _react2.default.createElement(
        _RaceCardLink2.default,
        upcomingRace,
        (0, _date.formatDate)(upcomingRace.raceDatetime, 'h:mm')
    );
};

exports.default = UpcomingRaceCell;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Last cell for Seven-Day Winners table on Signposts Tab
 */
var WonCell = function WonCell(_ref) {
    var courseStyleName = _ref.courseStyleName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceInstanceUid = _ref.raceInstanceUid,
        raceInstanceTitle = _ref.raceInstanceTitle;
    return _jsx('span', {}, void 0, courseStyleName, '\xA0', _jsx(_ResultLink2.default, {
        courseUid: courseUid,
        courseName: courseStyleName,
        raceDatetime: raceDatetime,
        raceInstanceUid: raceInstanceUid,
        raceInstanceTitle: raceInstanceTitle
    }, void 0, (0, _date.formatDate)(raceDatetime, 'h:mm')), '\xA0', (0, _date.formatDate)(raceDatetime, 'DDMMMYY'));
};

exports.default = WonCell;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ProfileLink = __webpack_require__(24);

var _WonCell = __webpack_require__(1052);

var _WonCell2 = _interopRequireDefault(_WonCell);

var _date = __webpack_require__(19);

var _UpcomingRaceCell = __webpack_require__(1051);

var _UpcomingRaceCell2 = _interopRequireDefault(_UpcomingRaceCell);

var _TravellersRaceCell = __webpack_require__(1050);

var _TravellersRaceCell2 = _interopRequireDefault(_TravellersRaceCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var horseCol = {
    key: 'horseStyleName',
    header: 'horse',
    cell: _ProfileLink.HorseLink,
    sortFn: 'alphabetic'
};

var timeCol = {
    key: 'raceDatetime',
    header: 'race',
    cell: _TravellersRaceCell2.default,
    sortFn: (0, _date.sortByDate)('raceDatetime', true)
};

var trainerCol = {
    key: 'trainerStyleName',
    header: 'trainer',
    cell: _ProfileLink.TrainerLink,
    sortFn: 'byLastName'
};

var milesCol = { key: 'miles' };

var timeCol2 = {
    key: 'upcomingRace',
    header: 'race',
    cell: _UpcomingRaceCell2.default,
    sortFn: (0, _date.sortByDate)('upcomingRace.raceDatetime', true)
};

var wonCol = {
    key: 'raceInstanceUid',
    header: 'race won',
    cell: _WonCell2.default
};

exports.default = {
    travelersCheck: [horseCol, trainerCol, timeCol, milesCol],
    firstTimeBlinkers: [horseCol, timeCol],
    sevenDayWinners: [horseCol, timeCol2, wonCol]
};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var transformData = function transformData(data, params) {
    var transformedData = {
        travelersCheck: [],
        firstTimeBlinkers: [],
        sevenDayWinners: []
    };

    if (!data) {
        return transformedData;
    }

    Object.keys(transformedData).forEach(function (key) {
        transformedData[key] = Array.isArray(data[key]) ? data[key] : transformedData[key];
    });

    var sevenDayWinners = transformedData.sevenDayWinners,
        firstTimeBlinkers = transformedData.firstTimeBlinkers,
        travelersCheck = transformedData.travelersCheck;


    return {
        firstTimeBlinkers: firstTimeBlinkers.map(function (firstTimeBlinker) {
            return _extends({}, firstTimeBlinker, {
                courseUid: +params.id,
                courseName: params.name
            });
        }),
        travelersCheck: travelersCheck.map(function (traveller) {
            return _extends({}, traveller, {
                courseName: params.name
            });
        }),
        sevenDayWinners: sevenDayWinners.map(function (winner) {
            return _extends({}, winner, {
                upcomingRace: _extends({}, winner.upcomingRace, {
                    courseUid: +params.id,
                    courseName: params.name
                })
            });
        })
    };
};

exports.default = transformData;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(6);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _columns = __webpack_require__(1056);

var _columns2 = _interopRequireDefault(_columns);

var _categories = __webpack_require__(558);

var _reducer = __webpack_require__(1057);

var _reducer2 = _interopRequireDefault(_reducer);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dataKeys = ['topJockeys', 'topTrainers', 'topHorses', 'topOwners'];

var _ref = _jsx(_rpReactTable.Loading, {});

var Stats = function (_FilteringComponent) {
    _inherits(Stats, _FilteringComponent);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _this.dataKey = 'statistics';
        _this.emptyData = {};
        _this.tab = 'stats';

        var _props$data = props.data,
            _props$data$profile = _props$data.profile,
            courseTypeCode = _props$data$profile.courseTypeCode,
            courseCountryCode = _props$data$profile.courseCountryCode,
            raceType = _props$data.seasonInfo.raceType,
            statistics = _props$data.statistics,
            seasonsAvailable = _props$data.seasonsAvailable;


        var categories = (0, _categories.categoriesFactory)(courseTypeCode, courseCountryCode, raceType, seasonsAvailable);

        _this.state = {
            data: statistics || _this.emptyData,
            categories: categories,
            fetchError: false
        };
        return _this;
    }

    _createClass(Stats, [{
        key: 'renderStatus',
        value: function renderStatus() {
            var categories = this.state.categories;

            var raceType = _filter3.selection.getCaption(categories, 'raceType');

            var _selection$getOption = _filter3.selection.getOption(categories, 'timePeriod'),
                value = _selection$getOption.value,
                label = _selection$getOption.label;

            if (value.match(/last5/)) {
                return _jsx('h2', {
                    className: 'ui-filter__statusText'
                }, void 0, raceType, ', ', (0, _lodash.toLower)(label));
            }

            var years = (0, _lodash.uniq)(value.split('/').slice(0, 2));
            if (years.length > 1) {
                years[1] = years[1].slice(2);
            }
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceType, ', ', years.join('-'));
        }
    }, {
        key: 'renderDefaultStatus',
        value: function renderDefaultStatus() {
            var _props$data$stats$sea = this.props.data.stats.seasonInfo,
                raceType = _props$data$stats$sea.raceType,
                seasonYearBegin = _props$data$stats$sea.seasonYearBegin,
                seasonYearEnd = _props$data$stats$sea.seasonYearEnd;

            var years = seasonYearBegin === seasonYearEnd ? seasonYearBegin : seasonYearBegin + '-' + seasonYearEnd;

            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, (0, _lodash.capitalize)(raceType), ', ', years);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                categories = _state.categories,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'cp-stats'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && (!loading ? _jsx('div', {
                className: 'cp-stats__tablesWrapper'
            }, void 0, dataKeys.map(function (dataKey) {
                return _jsx(_rpReactTable2.default, {
                    data: data[dataKey],
                    columns: _columns2.default[dataKey],
                    noDataText: 'No stats found',
                    className: 'cp-stats__table_' + (dataKey === 'topHorses' ? 'horse' : 'human')
                }, dataKey);
            })) : _ref));
        }
    }]);

    return Stats;
}(_filter2.default);

var genericRow = {
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    stake: _propTypes2.default.number,
    styleName: _propTypes2.default.string,
    winPercent: _propTypes2.default.number
};

Stats.propTypes = {
    data: _propTypes2.default.shape({
        seasonInfo: _propTypes2.default.shape({
            seasonYearBegin: _propTypes2.default.number,
            seasonYearEnd: _propTypes2.default.number,
            raceType: _propTypes2.default.string
        }),
        stats: _propTypes2.default.shape({
            statistics: _propTypes2.default.shape({
                topJockeys: _propTypes2.default.arrayOf(_propTypes2.default.shape(genericRow)),
                topTrainers: _propTypes2.default.arrayOf(_propTypes2.default.shape(genericRow)),
                topHorses: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, genericRow, {
                    trainerName: _propTypes2.default.string,
                    topRpr: _propTypes2.default.number
                }))),
                topOwners: _propTypes2.default.arrayOf(_propTypes2.default.shape(genericRow))
            })
        }),
        profile: _propTypes2.default.shape({
            courseCountryCode: _propTypes2.default.string
        })
    }),
    params: _propTypes2.default.shape({
        id: _propTypes2.default.string
    })
};

exports.default = Stats;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(24);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

var _StakeCell = __webpack_require__(254);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint react/prop-types: 0 */


var humanColumnsFactory = function humanColumnsFactory(type) {
    return [{
        key: 'styleName',
        header: 'Top ' + type,
        cell: function cell(row) {
            var StaffLink = _ProfileLink2.default[type];
            var nameProp = _defineProperty({}, type + 'StyleName', row.styleName);
            return _react2.default.createElement(StaffLink, _extends({}, row, nameProp));
        }
    }, {
        key: 'wins',
        header: 'wins-' + (type === 'jockey' ? 'rides' : 'runs'),
        cell: function cell(_ref) {
            var wins = _ref.wins,
                runs = _ref.runs;
            return wins + '-' + runs;
        }
    }, {
        key: 'winPercent',
        header: '%'
    }, {
        key: 'stake',
        header: '£1 stake',
        cell: _StakeCell2.default
    }];
};

var horse = [{
    key: 'styleName',
    header: 'Course Specialist',
    cell: function cell(_ref2) {
        var horseUid = _ref2.horseUid,
            styleName = _ref2.styleName;
        return _jsx(_ProfileLink.HorseLink, {
            horseStyleName: styleName,
            horseUid: horseUid
        });
    }
}, {
    key: 'wins',
    header: 'wins-runs',
    cell: function cell(_ref3) {
        var wins = _ref3.wins,
            runs = _ref3.runs;
        return wins + '-' + runs;
    }
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'trainerName',
    header: 'Trainer',
    cell: function cell(_ref4) {
        var trainerUid = _ref4.trainerUid,
            trainerName = _ref4.trainerName;
        return _jsx(_ProfileLink.TrainerLink, {
            trainerStyleName: trainerName,
            trainerUid: trainerUid
        });
    }
}, {
    key: 'topRpr',
    header: 'Best Course RPR'
}, {
    key: 'stake',
    header: '£1 stake',
    cell: _StakeCell2.default
}];

exports.default = {
    topJockeys: humanColumnsFactory('jockey'),
    topTrainers: humanColumnsFactory('trainer'),
    topHorses: horse,
    topOwners: humanColumnsFactory('owner')
};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _categories = __webpack_require__(558);

var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable,
        country = _timePeriod$createdBy.country;

    if (action.type === 'raceType') {
        var newRaceType = getRaceType(action.value);
        if (raceType !== newRaceType) {
            return (0, _categories.timePeriodsFactory)(country, newRaceType, seasonsAvailable);
        }
    }
    return timePeriod;
};

var categoriesReducer = function categoriesReducer(categories, action) {
    return _extends({}, categories, {
        timePeriod: timePeriodReducer(categories.timePeriod, action)
    });
};

exports.default = categoriesReducer;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTabName = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _NameRow = __webpack_require__(1089);

var _NameRow2 = _interopRequireDefault(_NameRow);

var _Nav = __webpack_require__(353);

var _Nav2 = _interopRequireDefault(_Nav);

var _DeclaredBox = __webpack_require__(1060);

var _DeclaredBox2 = _interopRequireDefault(_DeclaredBox);

var _Details = __webpack_require__(1062);

var _Details2 = _interopRequireDefault(_Details);

var _horse = __webpack_require__(259);

var _MetaData = __webpack_require__(352);

var _MetaData2 = _interopRequireDefault(_MetaData);

var _BestOdds = __webpack_require__(579);

var _BestOdds2 = _interopRequireDefault(_BestOdds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getTabName = exports.getTabName = function getTabName(_ref, _ref2) {
    var tab = _ref.tab,
        subTab = _ref.subTab;
    var sireStatus = _ref2.sireStatus,
        damStatus = _ref2.damStatus,
        weatherbysUid = _ref2.weatherbysUid;

    if (subTab) {
        return subTab;
    }
    if (tab) {
        return tab;
    }
    if (!sireStatus && !damStatus) {
        return 'form';
    }
    if (sireStatus && weatherbysUid) {
        return 'weatherbys-overview';
    }
    return 'progeny';
};

var _ref3 = _jsx(_BestOdds2.default, {});

var HorsePage = function (_React$Component) {
    _inherits(HorsePage, _React$Component);

    function HorsePage(props) {
        _classCallCheck(this, HorsePage);

        var _this = _possibleConstructorReturn(this, (HorsePage.__proto__ || Object.getPrototypeOf(HorsePage)).call(this, props));

        _this.showMyRatings = _this.showMyRatings.bind(_this);
        _this.hideMyRatings = _this.hideMyRatings.bind(_this);

        _this.state = {
            isMyRatingShown: props.params.subTab === 'my-ratings'
        };
        return _this;
    }

    _createClass(HorsePage, [{
        key: 'showMyRatings',
        value: function showMyRatings() {
            this.setState({ isMyRatingShown: true });
        }
    }, {
        key: 'hideMyRatings',
        value: function hideMyRatings() {
            this.setState({ isMyRatingShown: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                children = _props.children,
                params = _props.params;
            var _data$externalLinks = data.externalLinks,
                helpCenterUrl = _data$externalLinks.helpCenterUrl,
                imagesUrl = _data$externalLinks.imagesUrl,
                profile = data.profile,
                entries = data.entries,
                quotes = data.quotes;
            var weatherbysUid = profile.weatherbysUid,
                sireStatus = profile.sireStatus,
                comments = profile.comments,
                horseName = profile.horseName;


            var tabsToExclude = [(!weatherbysUid || !sireStatus) && 'stallionDetails', (0, _horse.hasProgeny)(profile) && (0, _lodash.isEmpty)(entries) && 'entries', (0, _lodash.isEmpty)(quotes) && 'quotes'];

            params.mr = {
                show: this.showMyRatings,
                hide: this.hideMyRatings,
                isShown: this.state.isMyRatingShown
            };

            return _jsx('div', {}, void 0, _jsx(_MetaData2.default, {
                type: params.type,
                page: getTabName(params, profile),
                profile: profile
            }), _jsx('section', {}, void 0, _jsx(_NameRow2.default, {
                profile: profile,
                params: params,
                imagesHost: imagesUrl
            }), _react2.default.createElement(_Details2.default, profile), _jsx(_DeclaredBox2.default, {
                horseName: horseName,
                entries: entries || [],
                comments: comments || []
            }), _ref3), _jsx(_Nav2.default, {
                params: params,
                horseType: (0, _horse.getHorseType)(profile),
                helpUrl: helpCenterUrl,
                tabsToExclude: tabsToExclude
            }), (0, _react.cloneElement)(children, { data: data, params: params }));
        }
    }]);

    return HorsePage;
}(_react2.default.Component);

exports.default = HorsePage;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TabFetchProvider = __webpack_require__(257);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _Form = __webpack_require__(559);

var _Form2 = _interopRequireDefault(_Form);

var _Progeny = __webpack_require__(563);

var _Progeny2 = _interopRequireDefault(_Progeny);

var _WeatherbysOverview = __webpack_require__(568);

var _WeatherbysOverview2 = _interopRequireDefault(_WeatherbysOverview);

var _horse = __webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = {
    form: {
        Tab: _Form2.default,
        fetchPath: 'form'
    },
    progeny: {
        Tab: _Progeny2.default,
        fetchPath: 'progeny'
    }
};

var IndexTab = function IndexTab(props) {
    var profile = props.data.profile;


    if (profile.weatherbysUid) {
        return _react2.default.createElement(_WeatherbysOverview2.default, props);
    }

    var route = (0, _horse.hasProgeny)(profile) ? routes.progeny : routes.form;
    return _react2.default.createElement(_TabFetchProvider2.default, _extends({}, props, { route: route }));
};

exports.default = IndexTab;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

var _distance = __webpack_require__(93);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

var _RaceCardLink = __webpack_require__(255);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

var _ProfileLink = __webpack_require__(24);

var _PriceButton = __webpack_require__(580);

var _PriceButton2 = _interopRequireDefault(_PriceButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref3 = _jsx('strong', {
    className: 'hp-declared__title'
}, void 0, 'DECLARED');

var DeclaredBox = function DeclaredBox(_ref) {
    var entries = _ref.entries,
        comments = _ref.comments,
        horseName = _ref.horseName;

    var overnightRaces = entries.filter(function (_ref2) {
        var raceStatusCode = _ref2.raceStatusCode;
        return raceStatusCode === 'O';
    }).map(function (entry) {
        return _extends({}, entry, {
            comment: (comments.find(function (c) {
                return c.raceInstanceUid === entry.raceInstanceUid;
            }) || {}).individualComment
        });
    });

    if (!overnightRaces.length) {
        return null;
    }

    return _jsx('div', {
        className: 'js-diffusionTopicSettingsRace'
    }, void 0, overnightRaces.map(function (race) {
        return _jsx('div', {
            className: 'hp-declared'
        }, race.raceInstanceUid, _jsx('dl', {
            className: 'hp-declared__box'
        }, void 0, _ref3, _jsx(_Definition2.default, {
            term: (0, _date.formatEntryDate)(race.raceDatetime, 'ddd, DD MMMM YYYY')
        }, void 0, _react2.default.createElement(
            _RaceCardLink2.default,
            race,
            (0, _date.formatEntryTime)(race.raceDatetime),
            '\xA0',
            race.courseStyleName
        ), '\xA0', _jsx('span', {
            className: 'hidden-sm-down'
        }, void 0, (0, _distance.yardsToFurlongs)(race.distanceYard))), race.jockeyStyleName && _jsx(_Definition2.default, {
            term: 'Jockey'
        }, void 0, _react2.default.createElement(_ProfileLink.JockeyLink, race), _jsx('span', {
            className: 'hp-declared__jockeyStats'
        }, void 0, '\xA0(Last 14 days:\xA0', race.jockeyLast14Days.wins, '-', race.jockeyLast14Days.runs, ',', race.jockeyLast14Days.percent, '%)')), _jsx(_Definition2.default, {
            term: 'RPR',
            description: race.rpPostmark
        }), _jsx(_Definition2.default, {
            className: 'hp-declared__comments',
            term: 'Comment',
            description: race.comment
        })), _react2.default.createElement(_PriceButton2.default, _extends({
            horseName: horseName
        }, race)));
    }));
};

exports.default = DeclaredBox;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Breeder = __webpack_require__(342);

var _Breeder2 = _interopRequireDefault(_Breeder);

var _Trainer = __webpack_require__(347);

var _Trainer2 = _interopRequireDefault(_Trainer);

var _Owner = __webpack_require__(345);

var _Owner2 = _interopRequireDefault(_Owner);

var _Age = __webpack_require__(341);

var _Age2 = _interopRequireDefault(_Age);

var _Sire = __webpack_require__(346);

var _Sire2 = _interopRequireDefault(_Sire);

var _Dam = __webpack_require__(343);

var _Dam2 = _interopRequireDefault(_Dam);

var _DamSire = __webpack_require__(344);

var _DamSire2 = _interopRequireDefault(_DamSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DamDetails = function DamDetails(props) {
    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, props)), _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, props)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, props)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, props))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, props)), _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, props, { hasPedigree: true })), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, props, { hasPedigree: true })))));
};

exports.default = DamDetails;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _DamDetails = __webpack_require__(1061);

var _DamDetails2 = _interopRequireDefault(_DamDetails);

var _StallionDetails = __webpack_require__(1064);

var _StallionDetails2 = _interopRequireDefault(_StallionDetails);

var _GenericDetails = __webpack_require__(1063);

var _GenericDetails2 = _interopRequireDefault(_GenericDetails);

var _horse = __webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stallionKeys = ['trainerUid', 'ownerUid', 'sireComment'];
var genericKeys = ['sireUid', 'damUid', 'damSireUid'];
var requiredKeys = ['horseDateOfBirth', 'horseSexCode', 'breederName'].concat(genericKeys, stallionKeys);

var isExtraDataPresent = function isExtraDataPresent(data, isSire) {
    return (isSire ? stallionKeys : genericKeys).every(function (key) {
        return data[key];
    });
};

var getTypeSpecificDetails = function getTypeSpecificDetails(props, type) {
    if (type === 'sire') {
        return _react2.default.createElement(_StallionDetails2.default, props);
    }
    if (type === 'dam') {
        return _react2.default.createElement(_DamDetails2.default, props);
    }
    return _react2.default.createElement(_GenericDetails2.default, props);
};

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'down',
    size: 'Medium'
});

var Details = function (_PureComponent) {
    _inherits(Details, _PureComponent);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.toggleDetails = function () {
            _this.setState(function (state) {
                return { expanded: !state.expanded };
            });
        };

        _this.state = {
            expanded: false
        };
        _this.isEmpty = requiredKeys.every(function (key) {
            return !props[key];
        });

        var type = (0, _horse.getHorseType)(props);
        _this.typeSpecificDetails = getTypeSpecificDetails(props, type);
        _this.isExtraDataPresent = isExtraDataPresent(props, type === 'sire');
        return _this;
    }

    _createClass(Details, [{
        key: 'render',
        value: function render() {
            return this.isEmpty ? null : _jsx('div', {
                className: (0, _classnames2.default)('hp-details', this.state.expanded && 'hp-details__expanded')
            }, void 0, this.typeSpecificDetails, this.isExtraDataPresent && _jsx('button', {
                className: 'ui-btn hidden-md-up hp-details__expandBtn',
                onClick: this.toggleDetails
            }, void 0, _ref));
        }
    }]);

    return Details;
}(_react.PureComponent);

exports.default = Details;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Breeder = __webpack_require__(342);

var _Breeder2 = _interopRequireDefault(_Breeder);

var _Trainer = __webpack_require__(347);

var _Trainer2 = _interopRequireDefault(_Trainer);

var _Owner = __webpack_require__(345);

var _Owner2 = _interopRequireDefault(_Owner);

var _Age = __webpack_require__(341);

var _Age2 = _interopRequireDefault(_Age);

var _Sire = __webpack_require__(346);

var _Sire2 = _interopRequireDefault(_Sire);

var _Dam = __webpack_require__(343);

var _Dam2 = _interopRequireDefault(_Dam);

var _DamSire = __webpack_require__(344);

var _DamSire2 = _interopRequireDefault(_DamSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericDetails = function GenericDetails(props) {
    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, props)), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder_xn' }, props, { className: 'hidden-md-up' })), _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, props)), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, props))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, props)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, props)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, props))), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, props, { className: 'hidden-sm-down' }))));
};

exports.default = GenericDetails;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Breeder = __webpack_require__(342);

var _Breeder2 = _interopRequireDefault(_Breeder);

var _Age = __webpack_require__(341);

var _Age2 = _interopRequireDefault(_Age);

var _Sire = __webpack_require__(346);

var _Sire2 = _interopRequireDefault(_Sire);

var _Dam = __webpack_require__(343);

var _Dam2 = _interopRequireDefault(_Dam);

var _Trainer = __webpack_require__(347);

var _Trainer2 = _interopRequireDefault(_Trainer);

var _Owner = __webpack_require__(345);

var _Owner2 = _interopRequireDefault(_Owner);

var _DamSire = __webpack_require__(344);

var _DamSire2 = _interopRequireDefault(_DamSire);

var _Standing = __webpack_require__(1066);

var _Standing2 = _interopRequireDefault(_Standing);

var _SireComment = __webpack_require__(1065);

var _SireComment2 = _interopRequireDefault(_SireComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StallionDetails = function StallionDetails(props) {
    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, props)), _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, props)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, props)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, props)), _react2.default.createElement(_Standing2.default, _extends({ key: 'Standing' }, props))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_SireComment2.default, _extends({ key: 'SireComment' }, props)), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, props)), _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, props, { hasPedigree: true })), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, props, { hasPedigree: true })))));
};

exports.default = StallionDetails;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SireComment = function SireComment(_ref) {
    var sireComment = _ref.sireComment;
    return !!sireComment && _jsx(_Definition2.default, {
        term: 'Sire\xA0comment',
        description: sireComment
    });
};

exports.default = SireComment;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(115);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param studFee array|null
 * @returns {*}
 * @constructor
 */
var Standing = function Standing(_ref) {
    var studFee = _ref.studFee;

    if (studFee && studFee.length) {
        var _studFee$ = studFee[0],
            studName = _studFee$.studName,
            countryCode = _studFee$.countryCode;


        return _jsx(_Definition2.default, {
            term: 'Standing'
        }, void 0, _jsx('span', {}, void 0, studName, ' (', countryCode, ')'));
    }
    return null;
};

exports.default = Standing;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1068);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeeHistory = function FeeHistory(_ref) {
    var data = _ref.data;
    return _jsx('section', {
        className: 'hp-feeHistory'
    }, void 0, _jsx(_rpReactTable2.default, {
        data: data.feeHistory || [],
        columns: _columns2.default,
        sortable: true,
        initialSortIdx: 0,
        noDataText: 'No fee history data for this sire in the Racing Post database'
    }));
};

exports.default = FeeHistory;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(6);

var _money = __webpack_require__(32);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'country'
}, void 0, 'cntry');

var columns = [{
    key: 'nominationYear',
    header: 'year'
}, {
    key: 'studFee',
    header: 'stud fee',
    cell: function cell(_ref) {
        var studFee = _ref.studFee,
            currencyCode = _ref.currencyCode;
        return (0, _lodash.isString)(studFee) ? studFee : currencyCode + ' ' + (0, _money.formatPrice)(studFee);
    },
    sortFn: function sortFn(a, b) {
        if ((0, _lodash.isString)(a.studFee)) {
            return 1;
        }
        if ((0, _lodash.isString)(b.studFee)) {
            return -1;
        }
        return b.studFee - a.studFee;
    }
}, {
    key: 'countryDesc',
    header: function header() {
        return _ref2;
    },
    cell: function cell(_ref3) {
        var countryCode = _ref3.countryCode,
            countryDesc = _ref3.countryDesc;
        return countryDesc && countryCode ? _jsx(_Abbr2.default, {
            title: countryDesc
        }, void 0, countryCode) : '—';
    },
    sortFn: 'alphabetic'
}, {
    key: 'studName',
    header: 'standing',
    sortFn: 'alphabetic'
}];

exports.default = columns;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonSpecialRow = function CommonSpecialRow(_ref) {
    var raceDatetime = _ref.raceDatetime,
        specialText = _ref.specialText,
        trainerFrom = _ref.trainerFrom,
        trainerTo = _ref.trainerTo;
    return _jsx('tr', {
        className: 'ui-table__row hp-formTable__special'
    }, raceDatetime, _jsx('td', {
        className: 'ui-table__cell hp-formTable__special__date'
    }, void 0, (0, _date.formatDate)(raceDatetime, 'DDMMMYY')), _jsx('td', {
        className: 'ui-table__cell',
        colSpan: 10
    }, void 0, specialText || _jsx('span', {}, void 0, 'Changed Trainer notification: ', _react2.default.createElement(_ProfileLink.TrainerLink, trainerFrom), ' ', 'to ', _react2.default.createElement(_ProfileLink.TrainerLink, trainerTo))));
};

var trainerProp = {
    trainerStyleName: _propTypes2.default.string.isRequired,
    trainerUid: _propTypes2.default.number.isRequired
};

exports.default = CommonSpecialRow;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _distance = __webpack_require__(93);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionsCell = function ConditionsCell(_ref) {
    var courseComments = _ref.courseComments,
        courseStyleName = _ref.courseStyleName,
        courseRpAbbrev3 = _ref.courseRpAbbrev3,
        distanceYard = _ref.distanceYard,
        goingTypeServicesDesc = _ref.goingTypeServicesDesc,
        courseUid = _ref.courseUid,
        raceDescription = _ref.raceDescription,
        raceClass = _ref.raceClass,
        prizeSterling = _ref.prizeSterling,
        jubileeDesc = _ref.rpStraightRoundJubileeDesc,
        raceOutcomeCode = _ref.raceOutcomeCode,
        rpCloseUpComment = _ref.rpCloseUpComment;

    var filteredJubileeDesc = jubileeDesc && (0, _lodash.lowerCase)(jubileeDesc.replace(/oms\s?/i, ''));
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.CourseLink, {
        courseStyleName: courseStyleName,
        courseUid: courseUid,
        title: courseComments,
        className: 'hp-formTable__course'
    }, void 0, _jsx('span', {
        className: 'hidden-md-down'
    }, void 0, courseStyleName), _jsx('span', {
        className: 'hidden-lg-up'
    }, void 0, (0, _lodash.capitalize)(courseRpAbbrev3))), filteredJubileeDesc ? _jsx('span', {}, void 0, '\xA0', filteredJubileeDesc) : null, _jsx('span', {
        className: 'hidden-sm-up'
    }, void 0, '\xA0', (0, _distance.yardsToFurlongs)(distanceYard), ' ', goingTypeServicesDesc), raceClass ? ' C' : ' ', raceDescription, _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, '\xA0', (0, _money.formatPrize)(prizeSterling)), raceOutcomeCode === 'NR' && _jsx('div', {}, void 0, _jsx('strong', {
        className: 'nonRunnerSliderSwitcherData__exNarrow'
    }, void 0, 'Non Runner', !!rpCloseUpComment && ' (' + rpCloseUpComment + ')')));
};

exports.default = ConditionsCell;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _PopoverComponent = __webpack_require__(548);

var _PopoverComponent2 = _interopRequireDefault(_PopoverComponent);

var _PopoverListItem = __webpack_require__(997);

var _PopoverListItem2 = _interopRequireDefault(_PopoverListItem);

var _Abbr = __webpack_require__(984);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/no-static-element-interactions: 0 */


var popoverListConfig = ['course', 'class', 'prize'];

var _ref = _jsx(_Abbr2.default, {
    title: 'Course / Class / Type / Prize',
    breakpoint: 'sm'
}, void 0, 'conditions');

var CustomHeaderCell = function (_Popover) {
    _inherits(CustomHeaderCell, _Popover);

    function CustomHeaderCell(props) {
        _classCallCheck(this, CustomHeaderCell);

        var _this = _possibleConstructorReturn(this, (CustomHeaderCell.__proto__ || Object.getPrototypeOf(CustomHeaderCell)).call(this, props));

        _initialiseProps.call(_this);

        var expanded = props.expanded,
            sortBy = props.sortBy;

        _this.state = {
            expanded: expanded,
            sortBy: sortBy
        };

        _this.cancelStopPropag = false;
        return _this;
    }

    _createClass(CustomHeaderCell, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                expanded = _state.expanded,
                sortBy = _state.sortBy;


            return _react2.default.createElement(
                'div',
                {
                    className: 'cm-popoverList__popoverWrapper',
                    onClick: this.handleClick,
                    ref: function ref(el) {
                        _this2.node = el;
                    }
                },
                _ref,
                expanded && _jsx('div', {
                    className: (0, _classnames2.default)('cm-popoverList__popover', 'ui-popover', 'ui-popover_customised')
                }, void 0, popoverListConfig.map(function (listItem) {
                    return _jsx(_PopoverListItem2.default, {
                        isSelected: sortBy === listItem,
                        onSelect: function onSelect() {
                            return _this2.onSelect(listItem);
                        },
                        text: listItem === 'prize' ? 'prize money' : listItem
                    }, listItem);
                }))
            );
        }
    }]);

    return CustomHeaderCell;
}(_PopoverComponent2.default);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleClick = function (e) {
        var sortBy = _this3.props.sortBy;

        _this3.setState({
            expanded: !_this3.state.expanded
        });

        if (!_this3.cancelStopPropag) {
            e.stopPropagation();

            var isHeaderCellSorted = _this3.node.closest('.ui-table__cell_header').classList.contains('ui-table__cell_sorted');

            if (sortBy !== '' && !isHeaderCellSorted) {
                _this3.setState({
                    sortBy: ''
                });
            }
        } else {
            _this3.cancelStopPropag = false;
        }
    };

    this.onSelect = function (sortBy) {
        _this3.setState({
            sortBy: sortBy
        });
        _this3.props.onUpdate(sortBy);
        _this3.cancelStopPropag = true;
    };
};

CustomHeaderCell.propTypes = {
    expanded: _propTypes2.default.bool,
    sortBy: _propTypes2.default.string
};

exports.default = CustomHeaderCell;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hp-formTable__delimiterLine'
});

var DelimiterRow = function DelimiterRow(_ref) {
    var raceDatetime = _ref.raceDatetime,
        daysBreak = _ref.daysBreak;
    return _jsx('tr', {
        className: 'ui-table__row hp-formTable__delimiter'
    }, raceDatetime, _jsx('td', {
        className: 'ui-table__cell hp-formTable__delimiterCell',
        colSpan: 11
    }, void 0, _ref2, _jsx('span', {
        className: 'hp-formTable__delimiterText'
    }, void 0, daysBreak, ' days break')));
};

exports.default = DelimiterRow;

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _formatWeight = __webpack_require__(258);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDistance(outcomeCode, winDist, distToWin) {
    if (!winDist && !distToWin) {
        return null;
    }
    if (+outcomeCode === 1) {
        return _jsx('span', {}, void 0, 'by ', winDist, '\xA0');
    }
    return _jsx('span', {}, void 0, 'btn ', distToWin, '\xA0');
}

var _ref2 = _jsx('span', {
    className: 'nonRunnerSliderSwitcherData__exNarrow'
}, void 0, _rpReactTable.EMPTINESS_SIGN);

var FinishingCell = function FinishingCell(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode,
        rpCloseUpComment = _ref.rpCloseUpComment,
        rpBettingMovements = _ref.rpBettingMovements,
        noOfRunners = _ref.noOfRunners,
        _ref$otherHorse = _ref.otherHorse,
        otherHorse = _ref$otherHorse === undefined ? {} : _ref$otherHorse,
        winningDistance = _ref.winningDistance,
        distanceToWinner = _ref.distanceToWinner,
        courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceInstanceUid = _ref.raceInstanceUid;
    return _jsx('span', {}, void 0, _jsx('span', {
        className: raceOutcomeCode === 'NR' && 'nonRunnerSliderSwitcherHideData'
    }, void 0, _jsx('strong', {}, void 0, raceOutcomeCode), '/', noOfRunners, '\xA0', _jsx(_ResultLink2.default, {
        courseName: courseName,
        courseUid: courseUid,
        raceDatetime: raceDatetime,
        raceInstanceUid: raceInstanceUid,
        raceInstanceTitle: '' + rpCloseUpComment + (rpBettingMovements ? ' (' + rpBettingMovements + ')' : ''),
        className: 'hidden-sm-down'
    }, void 0, getDistance(raceOutcomeCode, winningDistance, distanceToWinner), otherHorse && _jsx('span', {}, void 0, otherHorse.styleName, '\xA0', (0, _formatWeight2.default)(otherHorse.weightCarriedLbs)))), raceOutcomeCode === 'NR' && _jsx('span', {}, void 0, _jsx('strong', {
        className: 'nonRunnerSliderSwitcherData'
    }, void 0, 'Non Runner', !!rpCloseUpComment && ' (' + rpCloseUpComment + ')'), _ref2));
};

exports.default = FinishingCell;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _index = __webpack_require__(349);

var _index2 = _interopRequireDefault(_index);

var _columns = __webpack_require__(1079);

var _columns2 = _interopRequireDefault(_columns);

var _getSortFn = __webpack_require__(1081);

var _getSortFn2 = _interopRequireDefault(_getSortFn);

var _SpecialRow = __webpack_require__(1077);

var _SpecialRow2 = _interopRequireDefault(_SpecialRow);

var _Slider = __webpack_require__(1076);

var _Slider2 = _interopRequireDefault(_Slider);

var _helper = __webpack_require__(251);

var _mergeWithMR = __webpack_require__(1082);

var _mergeWithMR2 = _interopRequireDefault(_mergeWithMR);

var _dataPropTypes = __webpack_require__(348);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sliderConfig = {
    nonRunnerSwitcher: { stateProp: 'isNRShown', title: 'Non-Runner Info' },
    delimiterLineSwitcher: { stateProp: 'isBreakShown', title: 'Breaks (50+ days)' },
    myRatingSwitcher: { title: 'My Rating' }
};

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'spinner',
    size: 'Large',
    className: 'ui-animation_spinnerAnimation'
});

var FormTable = function (_Component) {
    _inherits(FormTable, _Component);

    function FormTable(props) {
        _classCallCheck(this, FormTable);

        var _this = _possibleConstructorReturn(this, (FormTable.__proto__ || Object.getPrototypeOf(FormTable)).call(this, props));

        _this.onSortIndexChange = function (index) {
            _this.setState({
                indexDefault: index
            });
        };

        _this.myRatingToggle = function (show) {
            var _this$props$params = _this.props.params,
                id = _this$props$params.id,
                name = _this$props$params.name,
                myRatings = _this$props$params.mr;

            var myRatingState = show ? 'show' : 'hide';
            var configUrl = {
                show: 'horse/' + id + '/' + name + '/form/my-ratings',
                hide: 'horse/' + id + '/' + name + '/form'
            };
            _index2.default.replace(configUrl[myRatingState]);
            if (myRatings[myRatingState]) {
                myRatings[myRatingState]();
            }
        };

        _this.updateSortBy = function (sortBy) {
            if (sortBy !== _this.state.sortBy) {
                _this.setState({
                    sortBy: sortBy
                });
            }
        };

        if (localStorage.getItem('myRatingSwitcher')) {
            _this.myRatingToggle(true);
        } else {
            _this.myRatingToggle();
        }

        if (localStorage.getItem('delimiterLineSwitcher') === null) {
            localStorage.setItem('delimiterLineSwitcher', true);
        }

        _this.state = {
            isNRShown: localStorage.getItem('nonRunnerSwitcher') === 'true',
            isBreakShown: localStorage.getItem('delimiterLineSwitcher') === 'true',
            sortBy: '',
            indexDefault: 0
        };

        _this.getColumnsConfig = _columns2.default.bind(null, _this.updateSortBy);
        _this.handleSlider = _this.handleSlider.bind(_this);
        _this.handleMyRatingSlider = _this.handleMyRatingSlider.bind(_this);
        return _this;
    }

    _createClass(FormTable, [{
        key: 'handleSlider',
        value: function handleSlider(key) {
            if (localStorage.getItem(key) === 'true') {
                this.setState(_defineProperty({}, sliderConfig[key].stateProp, false));
                localStorage.setItem(key, false);
            } else {
                this.setState(_defineProperty({}, sliderConfig[key].stateProp, true));
                localStorage.setItem(key, true);
            }
        }
    }, {
        key: 'handleMyRatingSlider',
        value: function handleMyRatingSlider() {
            var myRatings = this.props.params.mr;

            var key = 'myRatingSwitcher';

            if (!myRatings.isShown) {
                localStorage.setItem(key, true);
                this.myRatingToggle(true);
            } else {
                localStorage.removeItem(key);
                this.myRatingToggle();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                _props$data = _props.data,
                loading = _props$data.loading,
                form = _props$data.form,
                myRatings = _props$data.myRatings,
                selectedFilter = _props.selectedFilter,
                hasSpecial = _props.hasSpecial,
                params = _props.params;
            var isMRShown = params.mr.isShown;
            var _state = this.state,
                isNRShown = _state.isNRShown,
                isBreakShown = _state.isBreakShown,
                sortBy = _state.sortBy,
                indexDefault = _state.indexDefault;

            var tableData = isNRShown ? form : form.filter(_helper.isRunner);
            tableData = isMRShown ? (0, _mergeWithMR2.default)(tableData, myRatings) : tableData;

            return _jsx('section', {}, void 0, _jsx('div', {
                className: 'hp-formTable__header'
            }, void 0, _jsx('h2', {
                className: 'hp-formTable__title'
            }, void 0, 'Form ', selectedFilter && '- ' + selectedFilter), _jsx('div', {
                className: 'hp-formTable__sliderContainer'
            }, void 0, Object.keys(sliderConfig).map(function (key) {
                return _jsx(_Slider2.default, {
                    handleSlider: function handleSlider() {
                        return key === 'myRatingSwitcher' ? _this2.handleMyRatingSlider() : _this2.handleSlider(key);
                    },
                    sliderState: key === 'myRatingSwitcher' ? isMRShown : _this2.state[sliderConfig[key].stateProp],
                    title: sliderConfig[key].title,
                    id: key,
                    disabled: key === 'delimiterLineSwitcher' && (selectedFilter || indexDefault !== 0)
                }, key);
            })), loading && _ref), _jsx(_rpReactTable2.default, {
                className: (0, _classnames2.default)('hp-formTable', isMRShown && 'hp-formTable__my-ratings', isNRShown && 'nonRunnerSliderSwitcher', !isBreakShown && 'hp-formTable__delimiterHide'),
                data: tableData,
                columns: this.getColumnsConfig(sortBy),
                noDataText: 'No form for this horse',
                sortable: true,
                initialSortIdx: indexDefault,
                filter: (0, _getSortFn2.default)(selectedFilter),
                specialRow: hasSpecial ? _SpecialRow2.default : undefined,
                onSortUpdate: this.onSortIndexChange
            }));
        }
    }]);

    return FormTable;
}(_react.Component);

exports.default = FormTable;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _helper = __webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValue = function getValue(value, zeroToDash) {
    if (value || !zeroToDash && value === 0) {
        return value;
    }
    return _rpReactTable.EMPTINESS_SIGN;
};

var NonRunnerSwitcherTableCell = function NonRunnerSwitcherTableCell(_ref) {
    var code = _ref.code,
        value = _ref.value,
        zeroToDash = _ref.zeroToDash;
    return _jsx('span', {}, void 0, (0, _helper.isRunnerCode)(code) ? _jsx('span', {}, void 0, getValue(value, zeroToDash)) : _rpReactTable.EMPTINESS_SIGN);
};

exports.default = NonRunnerSwitcherTableCell;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'slider__trigger'
});

var Slider = function Slider(_ref) {
    var sliderState = _ref.sliderState,
        handleSlider = _ref.handleSlider,
        title = _ref.title,
        id = _ref.id,
        disabled = _ref.disabled;
    return _jsx('div', {
        className: (0, _classnames2.default)('sliderInfo', id + 'Slider', disabled && 'sliderInfo_disabled')
    }, void 0, _jsx('span', {
        className: 'sliderInfo__title'
    }, void 0, title), _jsx('label', {
        className: 'slider',
        htmlFor: id
    }, void 0, _jsx('input', {
        className: 'sliderInput',
        type: 'checkbox',
        checked: sliderState,
        onChange: handleSlider,
        id: id,
        disabled: disabled
    }), _ref2));
};

exports.default = Slider;

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CommonSpecialRow = __webpack_require__(1069);

var _CommonSpecialRow2 = _interopRequireDefault(_CommonSpecialRow);

var _DelimiterRow = __webpack_require__(1072);

var _DelimiterRow2 = _interopRequireDefault(_DelimiterRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SpecialRow = function SpecialRow(_ref) {
    var isSpecial = _ref.isSpecial,
        daysBreak = _ref.daysBreak,
        props = _objectWithoutProperties(_ref, ['isSpecial', 'daysBreak']);

    return isSpecial && (daysBreak ? _react2.default.createElement(_DelimiterRow2.default, _extends({ daysBreak: daysBreak }, props)) : _react2.default.createElement(_CommonSpecialRow2.default, props));
};

exports.default = SpecialRow;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formatWeight = __webpack_require__(258);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('sup', {}, void 0, '1');

var WeightCell = function WeightCell(_ref) {
    var weightCarriedLbs = _ref.weightCarriedLbs,
        horseHeadGear = _ref.horseHeadGear,
        firstTimeHeadgear = _ref.firstTimeHeadgear;
    return _jsx('span', {}, void 0, (0, _formatWeight2.default)(weightCarriedLbs), horseHeadGear && _jsx('span', {}, void 0, '\xA0', horseHeadGear, firstTimeHeadgear && _ref2));
};

exports.default = WeightCell;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _date = __webpack_require__(19);

var _distance = __webpack_require__(93);

var _going = __webpack_require__(581);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _ConditionsCell = __webpack_require__(1070);

var _ConditionsCell2 = _interopRequireDefault(_ConditionsCell);

var _FinishingCell = __webpack_require__(1073);

var _FinishingCell2 = _interopRequireDefault(_FinishingCell);

var _CustomHeaderCell = __webpack_require__(1071);

var _CustomHeaderCell2 = _interopRequireDefault(_CustomHeaderCell);

var _columnsCells = __webpack_require__(1080);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortConfig = {
    course: { key: 'courseName', sortFn: 'alphabetic' },
    class: { key: 'raceClass', sortFn: 'numericReverse' },
    prize: { key: 'prizeSterling', sortFn: 'numeric' }
};

var _ref3 = _jsx(_Abbr2.default, {
    title: 'Pos. Finish dist / winner or Runner-up / Wgt',
    breakpoint: 'fromMedium'
}, void 0, 'Pos.');

var columns = function columns(onUpdate, sortKey) {
    var _ref = _jsx(_CustomHeaderCell2.default, {
        onUpdate: onUpdate,
        sortBy: sortKey
    });

    return [{
        key: 'raceDatetime',
        header: 'date',
        cell: _columnsCells.raceDatetimeCell,
        sortFn: (0, _date.sortByDate)('raceDatetime')
    }, {
        key: sortConfig[sortKey] ? sortConfig[sortKey].key : sortKey,
        header: function header() {
            return _ref;
        },
        cell: _ConditionsCell2.default,
        sortFn: sortConfig[sortKey] ? sortConfig[sortKey].sortFn : function () {
            return null;
        }
    }, {
        key: 'distanceFurlong',
        header: 'dist.',
        cell: function cell(_ref2) {
            var distanceYard = _ref2.distanceYard;
            return (0, _distance.yardsToFurlongs)(distanceYard);
        },
        sortFn: 'numericReverse'
    }, {
        key: 'goingTypeServicesDesc',
        header: 'gng.',
        sortFn: _going.goingCodeSortFn
    }, {
        key: 'weightCarriedLbs',
        header: 'wgt / hdgr',
        cell: _columnsCells.weightCarriedLbsCell
    }, {
        key: 'raceOutcomeCode',
        header: function header() {
            return _ref3;
        },
        cell: _FinishingCell2.default,
        sortFn: 'numericReverse'
    }, {
        key: 'oddsValue',
        header: 'sp',
        cell: _columnsCells.oddsValueCell,
        sortFn: 'numericReverse'
    }, {
        key: 'jockeyShortName',
        header: 'jockey',
        cell: _columnsCells.jockeyShortNameCell,
        sortFn: 'byLastName'
    }, {
        key: 'officialRatingRanOff',
        header: 'or',
        cell: _columnsCells.officialRatingRanOffCell
    }, {
        key: 'rpTopspeed',
        header: 'ts',
        cell: _columnsCells.rpTopspeedCell
    }, {
        key: 'rpPostmark',
        header: 'rpr',
        cell: _columnsCells.rpPostmarkCell
    }, {
        key: 'myRating',
        header: 'mr'
    }];
};

exports.default = columns;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.weightCarriedLbsCell = exports.rpPostmarkCell = exports.rpTopspeedCell = exports.officialRatingRanOffCell = exports.jockeyShortNameCell = exports.oddsValueCell = exports.raceDatetimeCell = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactTable = __webpack_require__(22);

var _get = __webpack_require__(486);

var _get2 = _interopRequireDefault(_get);

var _helper = __webpack_require__(251);

var _ProfileLink = __webpack_require__(24);

var _date = __webpack_require__(19);

var _WeightCell = __webpack_require__(1078);

var _WeightCell2 = _interopRequireDefault(_WeightCell);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ReplayLink = __webpack_require__(576);

var _ReplayLink2 = _interopRequireDefault(_ReplayLink);

var _NonRunnerSwitcherTableCell = __webpack_require__(1075);

var _NonRunnerSwitcherTableCell2 = _interopRequireDefault(_NonRunnerSwitcherTableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raceDatetimeCell = exports.raceDatetimeCell = function raceDatetimeCell(props) {
    var isVideoAvailable = !!(0, _get2.default)(props, 'videoDetail[0].finishRaceUid');
    return _jsx('div', {
        className: 'hp-formTable__dateWrapper'
    }, void 0, isVideoAvailable && _react2.default.createElement(_ReplayLink2.default, props), _react2.default.createElement(
        _ResultLink2.default,
        _extends({}, props, {
            className: (0, _classnames2.default)(!isVideoAvailable && 'hp-formTable__withoutVideo')
        }),
        (0, _date.formatDate)(props.raceDatetime, 'DDMMMYY')
    ));
};

var oddsValueCell = exports.oddsValueCell = function oddsValueCell(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode,
        oddsDesc = _ref.oddsDesc;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: oddsDesc,
        zeroToDash: true
    });
};

var jockeyShortNameCell = exports.jockeyShortNameCell = function jockeyShortNameCell(rowData) {
    return (0, _helper.isRunner)(rowData) ? _jsx('span', {}, void 0, _react2.default.createElement(_ProfileLink.JockeyLink, rowData), !!rowData.weightAllowanceLbs && _jsx('sup', {
        className: 'hp-formTable__jockeyAllowance'
    }, void 0, rowData.weightAllowanceLbs)) : _rpReactTable.EMPTINESS_SIGN;
};

var officialRatingRanOffCell = exports.officialRatingRanOffCell = function officialRatingRanOffCell(_ref2) {
    var raceOutcomeCode = _ref2.raceOutcomeCode,
        officialRatingRanOff = _ref2.officialRatingRanOff;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: officialRatingRanOff,
        zeroToDash: true
    });
};

var rpTopspeedCell = exports.rpTopspeedCell = function rpTopspeedCell(_ref3) {
    var raceOutcomeCode = _ref3.raceOutcomeCode,
        rpTopspeed = _ref3.rpTopspeed;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: rpTopspeed
    });
};

var rpPostmarkCell = exports.rpPostmarkCell = function rpPostmarkCell(_ref4) {
    var raceOutcomeCode = _ref4.raceOutcomeCode,
        rpPostmark = _ref4.rpPostmark;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: rpPostmark
    });
};

var weightCarriedLbsCell = exports.weightCarriedLbsCell = function weightCarriedLbsCell(rowData) {
    return (0, _helper.isRunner)(rowData) ? _react2.default.createElement(_WeightCell2.default, rowData) : _rpReactTable.EMPTINESS_SIGN;
};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _filterArrays = __webpack_require__(560);

var _filterArrays2 = _interopRequireDefault(_filterArrays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stakesGroupIds = [1, 2, 3, 4, 5, 7, 8, 9, 11, 12, 13, 14, 15, 16]; /*
                                                                           Flat turf - race_type_code = F
                                                                           AW - race_type_code = X
                                                                           NHF - race_type_code = B & W
                                                                           Hurdle - race_type_code = H, Y
                                                                           Chase - race_type_code = C, U, Z
                                                                           PTP - race_type_code = P
                                                                           Rules Races - race_type_code != P
                                                                           A Stakes race will be any race that has
                                                                           race_group_uid = 1,2,3,4,5,7,8,9,11,12,13,14,15,16
                                                                       */


var filterFuncs = {
    'Rules Races': function RulesRaces(_ref) {
        var raceTypeCode = _ref.raceTypeCode;
        return raceTypeCode && raceTypeCode !== 'P';
    },
    Stakes: function Stakes(_ref2) {
        var raceGroupUid = _ref2.raceGroupUid;
        return stakesGroupIds.includes(raceGroupUid);
    }
};

var getSortFn = function getSortFn(name) {
    if (_filterArrays2.default[name]) {
        return function (_ref3) {
            var raceTypeCode = _ref3.raceTypeCode;
            return _filterArrays2.default[name].includes(raceTypeCode);
        };
    }

    if (filterFuncs[name]) {
        return filterFuncs[name];
    }

    return function () {
        return true;
    };
};

exports.default = getSortFn;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (data, myRatings) {
    if (!myRatings) {
        return data;
    }

    return data.map(function (item) {
        return _extends({}, item, {
            myRating: myRatings[item.raceInstanceUid]
        });
    });
};

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _shortid = __webpack_require__(331);

var _shortid2 = _interopRequireDefault(_shortid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var FigureRow = function FigureRow(_ref) {
    var figures = _ref.figures,
        type = _ref.type;
    return (0, _lodash.isEmpty)(figures) ? null : _jsx('div', {
        className: 'hp-raceRecords__figuresRow'
    }, void 0, _jsx('span', {}, void 0, (0, _lodash.capitalize)(type), ' placings: '), '\xA0', [].concat(_toConsumableArray(figures)).reverse().map(function (_ref2) {
        var raceTypeCode = _ref2.raceTypeCode,
            formFigure = _ref2.formFigure;
        return ['X', 'P'].includes(raceTypeCode) ? _jsx('strong', {}, _shortid2.default.generate(), formFigure) : formFigure;
    }));
};

exports.default = FigureRow;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var xnLabel = {
    'Rules Races': 'Rules',
    'All-weather': 'AW'
};

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cross',
    size: 'Small',
    className: 'hp-raceRecords__cross tableShowIcon'
});

var FilterBtn = function FilterBtn(_ref) {
    var raceType = _ref.raceType,
        onClick = _ref.onClick,
        isSelected = _ref.isSelected;
    return _jsx('button', {
        className: (0, _classnames2.default)('ui-btn ui-btn_tiertiary', isSelected && 'ui-btn_major hp-raceRecords__colSelectedBtn'),
        onClick: onClick,
        value: raceType
    }, void 0, _jsx('span', {
        className: 'hp-raceRecords__filterButton'
    }, void 0, _jsx('span', {
        className: 'hp-raceRecords__label'
    }, void 0, xnLabel[raceType] ? _jsx(_Abbr2.default, {
        title: raceType
    }, void 0, xnLabel[raceType]) : raceType), isSelected && _ref2));
};

exports.default = FilterBtn;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1086);

var _columns2 = _interopRequireDefault(_columns);

var _FigureRow = __webpack_require__(1083);

var _FigureRow2 = _interopRequireDefault(_FigureRow);

var _mergeWithMR = __webpack_require__(1087);

var _mergeWithMR2 = _interopRequireDefault(_mergeWithMR);

var _dataPropTypes = __webpack_require__(348);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h2', {
    className: 'hp-raceRecords__title'
}, void 0, 'Race Record');

var RaceRecords = function RaceRecords(_ref) {
    var figures = _ref.figures,
        data = _ref.data,
        onFilterClick = _ref.onFilterClick,
        selectedFilter = _ref.selectedFilter,
        isMRShown = _ref.params.mr.isShown;
    return _jsx('section', {
        className: 'hp-raceRecords'
    }, void 0, _jsx('div', {
        className: 'hp-raceRecords__header'
    }, void 0, _ref2, _jsx('div', {}, void 0, Object.keys(figures).map(function (key) {
        return _jsx(_FigureRow2.default, {
            figures: figures[key],
            type: key
        }, key);
    }))), _jsx(_rpReactTable2.default, {
        data: isMRShown ? (0, _mergeWithMR2.default)(data) : data.raceRecords,
        className: (0, _classnames2.default)('hp-raceRecords', isMRShown && 'hp-raceRecords__my-ratings'),
        columns: (0, _columns2.default)(onFilterClick, selectedFilter),
        uiType: 2,
        initialSortIdx: 10,
        noDataText: 'No race record for this horse'
    }));
};

exports.default = RaceRecords;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FilterBtn = __webpack_require__(1084);

var _FilterBtn2 = _interopRequireDefault(_FilterBtn);

var _money = __webpack_require__(32);

var _number = __webpack_require__(196);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'wins',
    breakpoint: 'fromMedium'
}, void 0, 'wins runs');

var columns = function columns(onFilterClick, selectedFilter) {
    return [{
        key: 'raceType',
        header: 'lifetime record',
        cell: function cell(_ref) {
            var raceType = _ref.raceType;
            return _jsx(_FilterBtn2.default, {
                raceType: raceType,
                onClick: onFilterClick,
                isSelected: raceType === selectedFilter
            });
        }
    }, {
        key: 'starts',
        header: 'runs'
    }, {
        key: 'wins',
        header: function header() {
            return _ref2;
        },
        cell: function cell(_ref3) {
            var wins = _ref3.wins,
                starts = _ref3.starts;
            return _jsx('span', {}, void 0, wins, _jsx('span', {
                className: 'hidden-md-up'
            }, void 0, '/', starts));
        }
    }, {
        key: '2nds'
    }, {
        key: '3rds'
    }, {
        key: 'winPrize',
        header: 'winnings',
        cell: function cell(_ref4) {
            var netWinPrize = _ref4.netWinPrize;
            return (0, _money.formatMoney)(netWinPrize);
        }
    }, {
        key: 'totalPrize',
        header: 'prize',
        cell: function cell(_ref5) {
            var netTotalPrize = _ref5.netTotalPrize;
            return (0, _money.formatPrize)(netTotalPrize);
        }

    }, {
        key: 'totalPrizeFormatted',
        header: 'earnings',
        cell: function cell(_ref6) {
            var netTotalPrize = _ref6.netTotalPrize;
            return (0, _money.formatMoney)(netTotalPrize);
        }
    }, {
        key: 'or+',
        header: 'or',
        cell: (0, _number.zeroToDash)('or+')
    }, {
        key: 'bestTs',
        cell: (0, _number.zeroToDash)('bestTs')
    }, {
        key: 'bestRpr',
        cell: (0, _number.zeroToDash)('bestRpr')
    }, {
        key: 'myRating',
        header: 'best mr'
    }];
};

exports.default = columns;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filterArrays = __webpack_require__(560);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref) {
    var _ref$form = _ref.form,
        form = _ref$form === undefined ? [] : _ref$form,
        myRatings = _ref.myRatings,
        _ref$raceRecords = _ref.raceRecords,
        raceRecords = _ref$raceRecords === undefined ? [] : _ref$raceRecords;

    if (!myRatings) {
        return raceRecords;
    }

    var hasRating = function hasRating(id) {
        return Boolean(myRatings[id]);
    };
    var findRaceById = function findRaceById(id) {
        return form.find(function (_ref2) {
            var uid = _ref2.raceInstanceUid;
            return Number(id) === uid;
        });
    };

    var preparedData = Object.keys(myRatings).filter(hasRating).map(function (id) {
        var _findRaceById = findRaceById(id),
            raceTypeCode = _findRaceById.raceTypeCode;

        return raceTypeCode ? {
            type: (0, _filterArrays.findTypeByCode)(raceTypeCode),
            rating: myRatings[id]
        } : {};
    }).reduce(function (acc, _ref3) {
        var type = _ref3.type,
            rating = _ref3.rating;
        return _extends({}, acc, _defineProperty({}, type, Math.max(acc[type] || 0, rating)));
    }, {});

    return raceRecords.map(function (row) {
        return _extends({}, row, {
            myRating: preparedData[row.raceType]
        });
    });
};

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(6);

var _object = __webpack_require__(260);

var _date = __webpack_require__(19);

var _helper = __webpack_require__(251);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getSpecialRow = function getSpecialRow(specialText, raceDatetime) {
    return {
        isSpecial: true,
        raceDatetime: raceDatetime,
        specialText: specialText
    };
};

var geldRow = getSpecialRow.bind(null, 'Gelded notification');
var windRow = function windRow(_ref) {
    var medicalDate = _ref.medicalDate,
        medicalType = _ref.medicalType;
    return getSpecialRow(medicalType, medicalDate);
};

var trainersRows = function trainersRows(previousTrainers, currentTrainer) {
    return previousTrainers.sort((0, _date.sortByDate)('trainerChangeDate')).map(function (_ref2, i) {
        var trainerChangeDate = _ref2.trainerChangeDate,
            trainer = _objectWithoutProperties(_ref2, ['trainerChangeDate']);

        return {
            isSpecial: true,
            raceDatetime: trainerChangeDate,
            trainerFrom: trainer,
            trainerTo: previousTrainers[i - 1] || currentTrainer
        };
    });
};

var isMoreThen50Days = function isMoreThen50Days(daysCount) {
    return daysCount >= 50;
};

var DATE_FORMAT = 'YYYY-MM-DD';

var breakRows = function breakRows(form) {
    return (0, _lodash.sortBy)(form, 'raceDatetime').filter(_helper.isRunner).map(function (row, i, arr) {
        return i < arr.length ? { prev: row, next: arr[i + 1] } : null;
    }).reduce(function (acc, current) {
        var prev = current.prev,
            next = current.next;

        if (!prev || !next) {
            return acc;
        }

        var day = (0, _moment2.default)(prev.raceDatetime).format(DATE_FORMAT);
        var timePrev = (0, _moment2.default)(day);
        day = (0, _moment2.default)(next.raceDatetime).format(DATE_FORMAT);
        var timeNext = (0, _moment2.default)(day);
        var daysBreak = Math.abs(timePrev.diff(timeNext, 'days'));

        return isMoreThen50Days(daysBreak) ? [].concat(_toConsumableArray(acc), [{
            raceDatetime: (0, _moment2.default)(next.raceDatetime).subtract(1, 'second').format(),
            daysBreak: daysBreak,
            isSpecial: true }]) : acc;
    }, []);
};

var transformData = function transformData(data) {
    if (!data) return {};

    var _data$raceRecords = data.raceRecords,
        records = _data$raceRecords.lifetimeRecords,
        jumps = _data$raceRecords.jumpsFiguresCalculated,
        flat = _data$raceRecords.flatFiguresCalculated,
        _data$profile = data.profile,
        dateGelded = _data$profile.dateGelded,
        previousTrainers = _data$profile.previousTrainers,
        trainerUid = _data$profile.trainerUid,
        trainerStyleName = _data$profile.trainerName,
        medical = _data$profile.medical,
        form = data.form;

    var currentTrainer = { trainerStyleName: trainerStyleName, trainerUid: trainerUid };
    var gelded = dateGelded ? [geldRow(dateGelded)] : [];
    var medicalData = medical ? medical.map(windRow) : [];
    var trainers = previousTrainers ? trainersRows(previousTrainers, currentTrainer) : [];
    var breaks = (0, _helper.duplicateArrayVals)(breakRows([].concat(_toConsumableArray(Object.values(form)))));

    var specialRows = [].concat(_toConsumableArray(medicalData), gelded, _toConsumableArray(trainers), _toConsumableArray(breaks));

    return {
        records: (0, _object.fromObjToArray)(records, 'raceType'),
        figures: { jumps: jumps, flat: flat },
        form: [].concat(_toConsumableArray(Object.values(form)), _toConsumableArray(specialRows)),
        hasSpecial: !!specialRows.length
    };
};

exports.default = transformData;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(6);

var _RunnerSelect = __webpack_require__(1090);

var _RunnerSelect2 = _interopRequireDefault(_RunnerSelect);

var _StudFee = __webpack_require__(1091);

var _StudFee2 = _interopRequireDefault(_StudFee);

var _NameContainer = __webpack_require__(561);

var _NameContainer2 = _interopRequireDefault(_NameContainer);

var _horse = __webpack_require__(259);

var horseUtils = _interopRequireWildcard(_horse);

var _Image = __webpack_require__(572);

var _Image2 = _interopRequireDefault(_Image);

var _horseTracker = __webpack_require__(1184);

var _horseTracker2 = _interopRequireDefault(_horseTracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameRow = function (_PureComponent) {
    _inherits(NameRow, _PureComponent);

    function NameRow(props) {
        _classCallCheck(this, NameRow);

        var _this = _possibleConstructorReturn(this, (NameRow.__proto__ || Object.getPrototypeOf(NameRow)).call(this, props));

        _this.state = {
            fetched: false,
            runners: []
        };
        return _this;
    }

    _createClass(NameRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var hash = this.props.params.hash;

            if (!hash) {
                return;
            }

            var raceId = hash.split('=').pop();
            this.fetchData(raceId);
        }
    }, {
        key: 'fetchData',
        value: function fetchData(raceId) {
            var _this2 = this;

            _axios2.default.get('horse/data/cardrunners/' + raceId + '.json').then(function (_ref) {
                var runners = _ref.data.runners;

                _this2.setState({
                    runners: (0, _lodash.sortBy)(runners, 'startNumber'),
                    fetched: true
                });
            }).catch(function (error) {
                return console.warn(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                runners = _state.runners,
                fetched = _state.fetched;
            var _props = this.props,
                imagesHost = _props.imagesHost,
                profile = _props.profile,
                params = _props.params;
            var horseName = profile.horseName,
                horseUid = profile.horseUid,
                horseCountryOriginCode = profile.horseCountryOriginCode,
                silkImagePath = profile.silkImagePath,
                studFee = profile.studFee;


            var horseType = horseUtils.getHorseType(profile);
            var hasProgeny = horseUtils.hasProgeny(profile);

            var selectedHorseIndex = runners.findIndex(function (r) {
                return r.horseUid === horseUid;
            });

            var nameRowClass = (0, _classnames2.default)('hp-nameRow', hasProgeny && 'hp-nameRow_pedigree', params.hash && 'hp-nameRow_inSelect');

            return _jsx('div', {}, void 0, hasProgeny && _jsx('span', {
                className: 'hp-nameRow__progenyIcon'
            }, void 0, _jsx(_rpReactSvgIcon2.default, {
                iconName: horseType,
                size: (0, _lodash.capitalize)(horseType)
            })), _jsx('div', {
                className: nameRowClass
            }, void 0, _jsx('div', {
                className: 'hp-nameRow__horseDetails'
            }, void 0, silkImagePath && _jsx(_Image2.default, {
                src: imagesHost + '/png_silks/' + silkImagePath + '.png',
                imgHost: imagesHost,
                imgClass: 'hp-nameRow__silk',
                alt: 'Horse Profile - Jockey Colours'
            }), fetched && selectedHorseIndex > -1 ? _jsx(_RunnerSelect2.default, {
                runners: runners,
                selectedHorseIndex: selectedHorseIndex
            }) : _jsx(_NameContainer2.default, {
                horseName: horseName,
                countryCode: horseCountryOriginCode
            })), _jsx('div', {
                className: 'hp-nameRow__rightContainer'
            }, void 0, _jsx(_StudFee2.default, {
                data: studFee
            }), _jsx(_horseTracker2.default, {
                profile: profile
            }))));
        }
    }]);

    return NameRow;
}(_react.PureComponent);

exports.default = NameRow;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpPopup = __webpack_require__(338);

var _rpGuiGuide = __webpack_require__(113);

var _Select = __webpack_require__(350);

var _Select2 = _interopRequireDefault(_Select);

var _NameContainer = __webpack_require__(561);

var _NameContainer2 = _interopRequireDefault(_NameContainer);

var _url = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RunnerSelect = function (_PureComponent) {
    _inherits(RunnerSelect, _PureComponent);

    function RunnerSelect() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RunnerSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RunnerSelect.__proto__ || Object.getPrototypeOf(RunnerSelect)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (val) {
            var selectedRunner = _this.props.runners[+val];
            var url = (0, _url.buildProfileUrl)(selectedRunner.horseUid, selectedRunner.horseName, 'horse');
            var urlToRedirect = url + '#race-id=' + selectedRunner.raceInstanceUid;

            if (_rpGuiGuide.mobileDetect.mobile()) {
                _rpPopup.journeyHandler.trackJourney(urlToRedirect);
            }
            window.location.href = urlToRedirect;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RunnerSelect, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                runners = _props.runners,
                selectedHorseIndex = _props.selectedHorseIndex;
            var _runners$selectedHors = runners[selectedHorseIndex],
                horseName = _runners$selectedHors.horseName,
                countryOriginCode = _runners$selectedHors.countryOriginCode,
                startNumber = _runners$selectedHors.startNumber;


            var options = runners.map(function (r) {
                return r.startNumber + '. ' + r.horseName + ' (' + r.countryOriginCode + ')';
            });

            return _jsx(_Select2.default, {
                value: selectedHorseIndex,
                options: options,
                onSelect: this.onChange,
                wrapperClass: 'pp-select_runners ui-btn_hollow'
            }, void 0, _jsx(_NameContainer2.default, {
                horseName: horseName,
                countryCode: countryOriginCode,
                number: startNumber
            }));
        }
    }]);

    return RunnerSelect;
}(_react.PureComponent);

exports.default = RunnerSelect;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _money = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudFee = function StudFee(_ref) {
    var data = _ref.data;

    if (!data || !data.length) {
        return null;
    }

    var _data$ = data[0],
        nominationFee = _data$.nominationFee,
        studFeeCondition = _data$.studFeeCondition,
        curCode = _data$.curCode,
        nominationYear = _data$.nominationYear;


    var nomination = (0, _lodash.toLower)(studFeeCondition) === 'private' ? 'Private' : (0, _money.formatSalePrice)(nominationFee, curCode);

    return nomination === '—' ? null : _jsx('span', {
        className: 'hp-nameRow__studFee'
    }, void 0, _jsx('span', {
        className: 'hp-nameRow__studFee__value'
    }, void 0, nomination), nominationYear && _jsx('span', {
        className: 'hp-nameRow__studFee__label'
    }, void 0, nominationYear, ' stud fee'));
};

exports.default = StudFee;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(6);

var _rpReactTable = __webpack_require__(22);

var _columns = __webpack_require__(1093);

var _columns2 = _interopRequireDefault(_columns);

var _NickRow = __webpack_require__(1095);

var _NickRow2 = _interopRequireDefault(_NickRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tableClassName = 'ui-table ui-table_type1 ui-table_sortable';
var initialSortIdx = 2;
var defaultSortIdx = initialSortIdx;
var perPage = 50;

var _ref = _jsx('tr', {
    className: 'ui-table__row'
}, void 0, _jsx('td', {
    colSpan: '8'
}, void 0, _jsx(_rpReactTable.NoData, {
    text: 'No nicks for this sire in the Racing Post database'
})));

var Nicks = function (_PureComponent) {
    _inherits(Nicks, _PureComponent);

    function Nicks(props) {
        _classCallCheck(this, Nicks);

        var _this = _possibleConstructorReturn(this, (Nicks.__proto__ || Object.getPrototypeOf(Nicks)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data$nick = props.data.nick,
            data = _props$data$nick === undefined ? [] : _props$data$nick;


        var bindedColumns = (0, _columns2.default)(_this.onIconClick);
        _this.columns = (0, _rpReactTable.addSortFns)(bindedColumns, true);

        var tableData = (0, _rpReactTable.sortData)((0, _rpReactTable.addIds)(data), _this.columns, initialSortIdx, defaultSortIdx);

        _this.state = {
            tableData: tableData,
            sortIdx: initialSortIdx,
            itemsShown: perPage,
            expandedRowIds: [],
            dataStorage: {}
        };
        return _this;
    }

    _createClass(Nicks, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                tableData = _state.tableData,
                sortIdx = _state.sortIdx,
                itemsShown = _state.itemsShown,
                expandedRowIds = _state.expandedRowIds,
                dataStorage = _state.dataStorage;


            return _jsx('section', {
                className: 'hp-nicks'
            }, void 0, _jsx('table', {
                className: tableClassName
            }, void 0, _jsx(_rpReactTable.Header, {
                columns: this.columns,
                sortIdx: sortIdx,
                sortable: !!tableData.length,
                sortTable: this.sortTable,
                onHeaderCellClick: this.sortTable
            }), !tableData.length && _ref, tableData.slice(0, itemsShown).map(function (rowData) {
                var expanded = expandedRowIds.includes(rowData.horseUid);

                return _jsx(_NickRow2.default, {
                    rowData: rowData,
                    columns: _this2.columns,
                    expanded: expanded,
                    data: expanded ? dataStorage[rowData.horseUid] : null
                }, rowData.horseUid);
            })), itemsShown < tableData.length && _jsx(_rpReactTable.ShowMore, {
                onClick: this.showMore
            }));
        }
    }]);

    return Nicks;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onIconClick = function (horseUid) {
        if (_this3.state.expandedRowIds.includes(horseUid)) {
            _this3.setState(function (_ref2) {
                var expandedRowIds = _ref2.expandedRowIds;
                return {
                    expandedRowIds: (0, _lodash.without)(expandedRowIds, horseUid)
                };
            });

            return;
        }

        _this3.setState(function (_ref3) {
            var expandedRowIds = _ref3.expandedRowIds;
            return {
                expandedRowIds: [].concat(_toConsumableArray(expandedRowIds), [horseUid])
            };
        });

        if (_this3.state.dataStorage[horseUid]) {
            return;
        }

        _axios2.default.get('horse/descendants/' + _this3.props.params.id + '/' + horseUid).then(function (_ref4) {
            var data = _ref4.data;

            _this3.setState(function (_ref5) {
                var dataStorage = _ref5.dataStorage;
                return {
                    dataStorage: _extends({}, dataStorage, _defineProperty({}, horseUid, data.nickDescendants || []))
                };
            });
        }).catch(console.warn);
    };

    this.showMore = function () {
        _this3.setState(function (state) {
            return {
                itemsShown: state.itemsShown + perPage
            };
        });
    };

    this.sortTable = function (idx) {
        _this3.setState(function (_ref6) {
            var tableData = _ref6.tableData;
            return {
                tableData: (0, _rpReactTable.sortData)(tableData, _this3.columns, idx, defaultSortIdx),
                sortIdx: idx,
                expandedRowIds: []
            };
        });
    };
};

exports.default = Nicks;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _RatioCell = __webpack_require__(573);

var _RatioCell2 = _interopRequireDefault(_RatioCell);

var _ProfileLink = __webpack_require__(24);

var _money = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    className: 'hp-nicks__arrow tableShowIcon',
    iconName: 'down',
    size: 'Medium'
});

var columns = function columns(_onClick) {
    return [{
        key: 'arrow',
        header: ' ',
        cell: function cell(_ref) {
            var horseUid = _ref.horseUid,
                descendants = _ref.descendants;
            return descendants ? _jsx('button', {
                className: 'hp-nicks__expand',
                onClick: function onClick() {
                    return _onClick(horseUid);
                }
            }, void 0, _ref2) : null;
        }
    }, {
        key: 'styleName',
        header: "dam's sire",
        cell: function cell(_ref3) {
            var styleName = _ref3.styleName,
                horseUid = _ref3.horseUid;
            return _jsx(_ProfileLink.HorseLink, {
                horseStyleName: styleName,
                horseUid: horseUid
            });
        },
        sortFn: 'alphabetic'
    }, {
        key: 'winners',
        header: 'winners / runners',
        cell: function cell(_ref4) {
            var a = _ref4.winners,
                b = _ref4.runners;
            return _jsx(_RatioCell2.default, {
                a: a,
                b: b
            });
        }
    }, {
        key: 'winnersPercent',
        header: '%'
    }, {
        key: 'wins',
        header: 'wins / runs',
        cell: function cell(_ref5) {
            var a = _ref5.wins,
                b = _ref5.runs;
            return _jsx(_RatioCell2.default, {
                a: a,
                b: b
            });
        }
    }, {
        key: 'winsPercent',
        header: '%'
    }, {
        key: 'winPrizeMoney',
        header: 'winnings',
        cell: function cell(_ref6) {
            var winPrizeMoney = _ref6.winPrizeMoney;
            return (0, _money.formatMoney)(winPrizeMoney);
        }
    }, {
        key: 'totalMoney',
        header: 'total earnings',
        cell: function cell(_ref7) {
            var totalMoney = _ref7.totalMoney;
            return (0, _money.formatMoney)(totalMoney);
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref3 = _jsx('span', {}, void 0, 'No descendants found');

var DescendantsList = function DescendantsList(_ref) {
    var data = _ref.data;
    return data.length ? _jsx('ul', {
        className: 'hp-nicks__descendants'
    }, void 0, data.map(function (_ref2) {
        var horseUid = _ref2.horseUid,
            styleName = _ref2.styleName;
        return _jsx('li', {}, horseUid, _jsx(_ProfileLink.HorseLink, {
            horseUid: horseUid,
            horseStyleName: styleName,
            className: 'ui-link_marked'
        }));
    })) : _ref3;
};

exports.default = DescendantsList;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _DescendantsList = __webpack_require__(1094);

var _DescendantsList2 = _interopRequireDefault(_DescendantsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_rpReactTable.Loading, {});

var NicksRow = function (_PureComponent) {
    _inherits(NicksRow, _PureComponent);

    function NicksRow() {
        _classCallCheck(this, NicksRow);

        return _possibleConstructorReturn(this, (NicksRow.__proto__ || Object.getPrototypeOf(NicksRow)).apply(this, arguments));
    }

    _createClass(NicksRow, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var _props = this.props,
                data = _props.data,
                expanded = _props.expanded;

            if (data === nextProps.data && expanded === nextProps.expanded) {
                return false;
            }

            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                rowData = _props2.rowData,
                columns = _props2.columns,
                expanded = _props2.expanded,
                data = _props2.data;


            return _jsx('tbody', {
                className: 'hp-nicks__row'
            }, void 0, _jsx(_rpReactTable.Row, {
                rowData: rowData,
                columns: columns
            }), expanded && _jsx('tr', {
                className: 'ui-table__row'
            }, void 0, _jsx('td', {
                colSpan: '8'
            }, void 0, data ? _jsx(_DescendantsList2.default, {
                data: data
            }) : _ref)));
        }
    }]);

    return NicksRow;
}(_react.PureComponent);

exports.default = NicksRow;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(238);

var _qs2 = _interopRequireDefault(_qs);

var _Note = __webpack_require__(1099);

var _Note2 = _interopRequireDefault(_Note);

var _ErrorNote = __webpack_require__(1098);

var _ErrorNote2 = _interopRequireDefault(_ErrorNote);

var _ActionRow = __webpack_require__(1097);

var _ActionRow2 = _interopRequireDefault(_ActionRow);

var _ErrorModal = __webpack_require__(571);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

var _helpers = __webpack_require__(1100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx('div', {
    className: 'ui-divider'
});

var Notes = function (_PureComponent) {
    _inherits(Notes, _PureComponent);

    function Notes(props) {
        _classCallCheck(this, Notes);

        var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));

        _this.onSaveSuccess = function (data) {
            var notes = _this.state.notes;


            Object.keys(notes).forEach(function (key) {
                notes[key].isExists = !!data[key];
            });

            _this.setState({
                notes: _extends({}, notes),
                isSaveDisabled: true,
                isDataSaved: true
            });
        };

        _this.onSave = function () {
            var note = _this.state.notes;


            _axios2.default.post(_this.ajaxUrl, _qs2.default.stringify({ note: note })).then(function (_ref) {
                var data = _ref.data;

                var error = Object.keys(data).some(function (item) {
                    return data[item].error;
                });

                if (error) {
                    throw new Error();
                } else {
                    _this.onSaveSuccess(data);
                }
            }).catch(function () {
                return _this.setState({ error: 'postError' });
            });
        };

        _this.onClear = function () {
            var notes = (0, _helpers.initEmptyNotes)(_this.state.notes);
            _helpers.raceTypes.forEach(function (type) {
                notes[type].onChange = _this.onChange.bind(_this, type);
            });

            _this.setState({ notes: notes, isSaveDisabled: false, isDataSaved: false });
        };

        _this.onChange = function (raceType, event) {
            var _event$target = event.target,
                name = _event$target.name,
                value = _event$target.value;

            var notes = _extends({}, _this.state.notes);

            notes[raceType][name] = (0, _helpers.validateInput)(name, value);

            _this.setState({
                notes: notes,
                isSaveDisabled: false,
                isDataSaved: false
            });
        };

        _this.getNotes = function () {
            _axios2.default.get(_this.ajaxUrl).then(function (_ref2) {
                var _ref2$data = _ref2.data,
                    data = _ref2$data.data,
                    error = _ref2$data.error;

                if (error) {
                    throw new Error();
                } else {
                    _this.appendNotes(data);
                }
            }).catch(function () {
                return _this.setState({ error: 'getError' });
            });
        };

        _this.appendNotes = function (data) {
            var notes = _this.state.notes;

            var newNotes = data.reduce(function (acc, cur) {
                return _extends({}, acc, _defineProperty({}, cur.raceTypeCode, {
                    raceType: cur.raceTypeCode,
                    ratingFlag: cur.ratingFlag || '',
                    rating: cur.rating,
                    note: cur.comment || '',
                    isExists: true
                }));
            }, notes);

            _helpers.raceTypes.forEach(function (type) {
                newNotes[type].onChange = _this.onChange.bind(_this, type);
            });

            _this.setState({ notes: _extends({}, newNotes), error: null });
        };

        _this.hideErrorLightbox = function () {
            _this.setState({ error: null });
        };

        _this.state = {
            notes: (0, _helpers.initEmptyNotes)(),
            isSaveDisabled: true,
            isDataSaved: false,
            error: null
        };
        _this.ajaxUrl = (0, _helpers.getAjaxUrl)(_this.props.data.profile.horseUid);
        return _this;
    }

    _createClass(Notes, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getNotes();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                notes = _state.notes,
                isSaveDisabled = _state.isSaveDisabled,
                isDataSaved = _state.isDataSaved,
                error = _state.error;

            var isGetErrorOccurred = error === 'getError';
            var isPostErrorOccurred = error === 'postError';

            return _jsx('section', {
                className: 'hp-notes__container'
            }, void 0, _jsx(_ActionRow2.default, {
                onSave: this.onSave,
                onClear: this.onClear,
                isDisabled: isSaveDisabled,
                isSaved: isDataSaved,
                isErrorOccurred: error
            }), _ref3, Object.entries(notes).map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    type = _ref5[0],
                    value = _ref5[1];

                return isGetErrorOccurred ? _jsx(_ErrorNote2.default, {
                    raceType: type,
                    raceTypeName: _helpers.raceTypeNames[type],
                    onReload: _this2.getNotes
                }, type) : _react2.default.createElement(_Note2.default, _extends({}, value, {
                    raceTypeName: _helpers.raceTypeNames[type],
                    key: type
                }));
            }), _jsx(_ActionRow2.default, {
                onSave: this.onSave,
                onClear: this.onClear,
                isDisabled: isSaveDisabled,
                isSaved: isDataSaved,
                isErrorOccurred: error
            }), isPostErrorOccurred && _jsx(_ErrorModal2.default, {
                text: _helpers.errorMessageText,
                onClose: this.hideErrorLightbox
            }));
        }
    }]);

    return Notes;
}(_react.PureComponent);

exports.default = Notes;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'tick',
    size: 'sizeNotesTick'
}), _jsx('span', {
    className: 'hp-notes__buttonLabel'
}, void 0, 'Saved'));

var ActionRow = function ActionRow(_ref) {
    var onClear = _ref.onClear,
        onSave = _ref.onSave,
        isDisabled = _ref.isDisabled,
        isSaved = _ref.isSaved,
        isErrorOccurred = _ref.isErrorOccurred;
    return _jsx('div', {
        className: 'hp-notes__actionRow'
    }, void 0, _jsx('div', {
        className: 'hp-notes__actionRowButtons'
    }, void 0, _jsx('button', {
        onClick: onClear,
        disabled: isErrorOccurred,
        className: 'hp-notes__button ui-btn ui-btn_secondary ui-btn_hollow'
    }, void 0, 'Clear'), _jsx('button', {
        onClick: onSave,
        disabled: isDisabled,
        className: (0, _classnames2.default)('hp-notes__button ui-btn ui-btn_primary ui-btn_major', isDisabled && 'ui-btn_disabled')
    }, void 0, isSaved ? _ref2 : 'Save')));
};

exports.default = ActionRow;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'ui-input hp-notes__input hp-notes__input_rating'
});

var _ref3 = _jsx('span', {
    className: 'ui-input hp-notes__input hp-notes__input_ratingFlag'
});

var _ref4 = _jsx('div', {
    className: 'ui-divider'
});

var ErrorNote = function ErrorNote(_ref) {
    var raceType = _ref.raceType,
        raceTypeName = _ref.raceTypeName,
        onReload = _ref.onReload;
    return _jsx('div', {}, void 0, _jsx('h3', {
        className: 'hp-notes__title'
    }, void 0, raceTypeName), _jsx('div', {
        className: 'hp-notes__note'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_note'
    }, void 0, _jsx('span', {
        className: 'hp-notes__label_type'
    }, void 0, raceTypeName), 'Note'), _jsx('div', {
        className: 'hp-notes__input_container'
    }, void 0, _jsx('div', {
        className: 'hp-notes__error'
    }, void 0, 'There\'s a technical problem that means notes and ratings content is currently unavailable. We are working to restore the service as fast as possible and are sorry for any inconvenience caused. Please click ', _jsx('span', {
        onClick: onReload,
        className: 'hp-notes__error__link'
    }, void 0, 'here'), ' to refresh the page or try again later.'))), _jsx('div', {
        className: 'hp-notes__fieldSetWrapper'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_rating'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_rating'
    }, void 0, 'Rating'), _ref2), _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_ratingFlag'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_ratingFlag'
    }, void 0, '+/-'), _ref3))), _ref4);
};

exports.default = ErrorNote;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _reactTextareaAutosize = __webpack_require__(885);

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hp-notes__icon'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'note',
    size: 'Medium'
}));

var _ref3 = _jsx('div', {
    className: 'ui-divider'
});

var Note = function Note(_ref) {
    var raceType = _ref.raceType,
        raceTypeName = _ref.raceTypeName,
        rating = _ref.rating,
        ratingFlag = _ref.ratingFlag,
        note = _ref.note,
        onChange = _ref.onChange;
    return _jsx('div', {}, void 0, _jsx('h3', {
        className: 'hp-notes__title'
    }, void 0, raceTypeName), _jsx('div', {
        className: 'hp-notes__note'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_note'
    }, void 0, _jsx('span', {
        className: 'hp-notes__label_type'
    }, void 0, raceTypeName), 'Note'), _jsx('div', {
        className: (0, _classnames2.default)('hp-notes__input_container', note && 'hp-notes__icon_hidden')
    }, void 0, _jsx(_reactTextareaAutosize2.default, {
        onChange: onChange,
        name: 'note',
        value: note,
        id: raceType + '_note',
        rows: 1,
        maxLength: 250,
        className: 'ui-input hp-notes__input'
    }), _ref2)), _jsx('div', {
        className: 'hp-notes__fieldSetWrapper'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_rating'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_rating'
    }, void 0, 'Rating'), _jsx('input', {
        onChange: onChange,
        type: 'text',
        name: 'rating',
        value: rating,
        id: raceType + '_rating',
        maxLength: 3,
        className: 'ui-input hp-notes__input hp-notes__input_rating'
    })), _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_ratingFlag'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_ratingFlag'
    }, void 0, '+/-'), _jsx('input', {
        onChange: onChange,
        type: 'text',
        name: 'ratingFlag',
        value: ratingFlag,
        id: raceType + '_ratingFlag',
        maxLength: 1,
        className: 'ui-input hp-notes__input hp-notes__input_ratingFlag'
    })))), _ref3);
};

exports.default = Note;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var raceTypeNames = exports.raceTypeNames = {
    F: 'Flat Turf and NHF',
    X: 'All Weather',
    H: 'Hurdle',
    C: 'Chase'
};

var raceTypes = exports.raceTypes = Object.keys(raceTypeNames);

var initEmptyNotes = exports.initEmptyNotes = function initEmptyNotes(existingNotes) {
    return raceTypes.reduce(function (acc, type) {
        return _extends({}, acc, _defineProperty({}, type, {
            raceType: type,
            ratingFlag: '',
            rating: '',
            note: '',
            isExists: existingNotes && existingNotes[type].isExists || false
        }));
    }, {});
};

var errorMessageText = exports.errorMessageText = 'Something\'s gone wrong \n     and your changes could not be saved. \n     Press save to try again.';

var getAjaxUrl = exports.getAjaxUrl = function getAjaxUrl(horseUid) {
    return 'horse/ugc/' + horseUid;
};

var validateInput = exports.validateInput = function validateInput(name, value) {
    var rating = value;
    if (name === 'rating') {
        rating = value.replace(/[^0-9]/g, '');
        rating = +rating > 500 ? 500 : rating;
    }

    return rating;
};

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FamilyTree = __webpack_require__(1103);

var _FamilyTree2 = _interopRequireDefault(_FamilyTree);

var _FamilyTreeSummary = __webpack_require__(1104);

var _FamilyTreeSummary2 = _interopRequireDefault(_FamilyTreeSummary);

var _WeatherbysFamilyTree = __webpack_require__(1105);

var _WeatherbysFamilyTree2 = _interopRequireDefault(_WeatherbysFamilyTree);

var _FlatJumpsTables = __webpack_require__(562);

var _FlatJumpsTables2 = _interopRequireDefault(_FlatJumpsTables);

var _Weatherbys = __webpack_require__(351);

var _Weatherbys2 = _interopRequireDefault(_Weatherbys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pedigree = function Pedigree(_ref) {
    var _ref$data = _ref.data,
        pedigree = _ref$data.pedigree,
        weatherbysUid = _ref$data.profile.weatherbysUid,
        relatives = _ref$data.relatives,
        weatherbysPedigreeUrl = _ref$data.weatherbysPedigreeUrl;
    return _jsx('section', {}, void 0, _react2.default.createElement(_FamilyTreeSummary2.default, pedigree), _jsx('p', {}, void 0, pedigree.rpFormText), weatherbysPedigreeUrl ? _jsx(_WeatherbysFamilyTree2.default, {
        url: weatherbysPedigreeUrl
    }) : _jsx(_FamilyTree2.default, {
        pedigree: pedigree
    }), _jsx(_FlatJumpsTables2.default, {
        data: relatives || {},
        disclaimerName: 'Relatives',
        flatTitle: 'Relatives - Flat (GB & IRE)',
        jumpsTitle: 'Relatives - jumps (GB & IRE)',
        flatNoData: 'No relatives that ran on the Flat in our records',
        jumpsNoData: 'No relatives that ran over jumps in our records'
    }), _jsx(_Weatherbys2.default, {
        className: 'hp-weatherbys__pedigree',
        title: 'Extended Pedigree',
        type: 'extended-pedigree',
        weatherbysUid: weatherbysUid
    }));
};

exports.default = Pedigree;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hp-familyTree__block'
});

var FamilyLeaf = function FamilyLeaf(_ref) {
    var data = _ref.data;

    if (data && data.horseName) {
        var horseUid = data.horseUid,
            horseName = data.horseName,
            countryOriginCode = data.countryOriginCode,
            horseDateOfBirth = data.horseDateOfBirth;

        return _jsx(_ProfileLink.HorseLink, {
            className: 'hp-familyTree__block',
            horseUid: horseUid,
            horseStyleName: horseName
        }, void 0, _jsx('span', {
            className: 'hp-familyTree__block__name'
        }, void 0, _jsx('span', {
            className: 'hp-familyTree__block__horseName'
        }, void 0, horseName, _jsx('span', {
            className: 'hp-familyTree__block__code'
        }, void 0, ' (' + countryOriginCode + ') ')), _jsx('span', {
            className: 'hp-familyTree__block__yob'
        }, void 0, horseDateOfBirth && (0, _date.formatDate)(horseDateOfBirth, 'YYYY'))));
    }
    return _ref2;
};

exports.default = FamilyLeaf;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FamilyLeaf = __webpack_require__(1102);

var _FamilyLeaf2 = _interopRequireDefault(_FamilyLeaf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'hp-familyTree__branches'
}, void 0, _jsx('div', {
    className: 'hp-familyTree__branch'
}));

var _ref3 = _jsx('div', {
    className: 'hp-familyTree__branches'
}, void 0, _jsx('div', {
    className: 'hp-familyTree__branch'
}));

var _ref4 = _jsx('div', {
    className: 'hp-familyTree__branches'
}, void 0, _jsx('div', {
    className: 'hp-familyTree__branch'
}));

var FamilyTree = function FamilyTree(_ref) {
    var pedigree = _ref.pedigree;
    return _jsx('div', {
        className: 'hp-familyTree hp-pedigree__familyTree hidden-sm-down'
    }, void 0, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree
    })), _jsx('div', {
        className: 'hp-familyTree__stage hp-familyTree__stage_second'
    }, void 0, _ref2, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree.sire
    }), _jsx(_FamilyLeaf2.default, {
        data: pedigree.dam
    }))), _jsx('div', {
        className: 'hp-familyTree__stage hp-familyTree__stage_third'
    }, void 0, _jsx('div', {
        className: 'hp-familyTree__section'
    }, void 0, _ref3, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree.sire && pedigree.sire.sire
    }), _jsx(_FamilyLeaf2.default, {
        data: pedigree.sire && pedigree.sire.dam
    }))), _jsx('div', {
        className: 'hp-familyTree__section'
    }, void 0, _ref4, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree.dam && pedigree.dam.sire
    }), _jsx(_FamilyLeaf2.default, {
        data: pedigree.dam && pedigree.dam.dam
    })))));
};

var horseTypes = {
    countryOriginCode: _propTypes2.default.string,
    horseDateOfBirth: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number
};
var horseShape = _propTypes2.default.shape(horseTypes);
var sireOrDamShape = _propTypes2.default.shape(_extends({}, horseTypes, {
    sire: horseShape,
    dam: horseShape
}));

exports.default = FamilyTree;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(252);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyTreeSummary = function FamilyTreeSummary(_ref) {
    var sire = _ref.sire,
        dam = _ref.dam;
    return _jsx('dl', {
        className: 'hidden-md-up'
    }, void 0, sire && _react2.default.createElement(_HorseDefinition2.default, _extends({}, sire, {
        term: 'Sire',
        avgFlatWinDist: sire.avgFlatWinDistOfProgeny
    })), dam && _react2.default.createElement(_HorseDefinition2.default, _extends({}, dam, {
        term: 'Dam',
        avgFlatWinDist: dam.avgFlatWinDistOfProgeny
    })), dam && dam.sire && _react2.default.createElement(_HorseDefinition2.default, _extends({}, dam.sire, {
        term: 'Dam\'s Sire',
        avgFlatWinDist: dam.sire.avgFlatWinDistOfProgeny
    })));
};

var horseTypes = {
    avgFlatWinDistOfProgeny: _propTypes2.default.number,
    countryOriginCode: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number
};
exports.default = FamilyTreeSummary;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h2', {
    className: 'hp-weatherbys__title'
}, void 0, 'Weatherbys Pedigree');

var WeatherbysFamilyTree = function WeatherbysFamilyTree(_ref) {
    var url = _ref.url;
    return _jsx('div', {
        className: 'hp-pedigree__familyTree hidden-sm-down'
    }, void 0, _ref2, _jsx('div', {
        className: 'hp-pedigree-weatherbys__frameWrapper'
    }, void 0, _jsx('iframe', {
        className: 'hp-pedigree-weatherbys__frame',
        src: url,
        scrolling: 'no'
    })));
};

exports.default = WeatherbysFamilyTree;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('br', {});

var HorseSireCell = function HorseSireCell(_ref) {
    var avgFlatWinDistOfProgeny = _ref.avgFlatWinDistOfProgeny,
        countryOriginCode = _ref.countryOriginCode,
        horseName = _ref.horseName,
        horseSexCode = _ref.horseSexCode,
        horseUid = _ref.horseUid,
        horseYob = _ref.horseYob,
        sireStyleName = _ref.sireStyleName,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        sireUid = _ref.sireUid,
        stakesWinnerOrPlaced = _ref.stakesWinnerOrPlaced;
    return _jsx('div', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        className: stakesWinnerOrPlaced && 'hp-relatives__stakesPlaced',
        horseStyleName: horseName,
        horseUid: horseUid
    }), _jsx('span', {
        className: 'hp-relatives__horseInfo'
    }, void 0, countryOriginCode && ' (' + countryOriginCode + ') ', horseYob, (0, _lodash.toLower)(horseSexCode)), _ref2, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireStyleName,
        horseUid: sireUid
    }), sireCountryOriginCode && ' (' + sireCountryOriginCode + ')', avgFlatWinDistOfProgeny && ' ' + avgFlatWinDistOfProgeny + 'f');
};

exports.default = HorseSireCell;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1109);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RelativesTable = function RelativesTable(_ref) {
    var data = _ref.data,
        title = _ref.title,
        noDataText = _ref.noDataText;
    return _jsx('section', {
        className: 'hp-relatives'
    }, void 0, _jsx('h2', {
        className: 'hp-relatives__title'
    }, void 0, title), _jsx(_rpReactTable2.default, {
        columns: _columns2.default,
        data: data,
        initialSortIdx: 8,
        noDataText: noDataText,
        sortable: true
    }));
};

exports.default = RelativesTable;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('strong', {}, void 0, 'bold');

var _ref3 = _jsx('p', {
    className: 'pp-bottomText__progenyInfo'
}, void 0, 'Details of horses trained outside GB and Ireland or born prior to 1986 may be incomplete.');

var RelativesTableDisclaimer = function RelativesTableDisclaimer(_ref) {
    var type = _ref.type;
    return _jsx('div', {
        className: 'pp-bottomText'
    }, void 0, _jsx('p', {
        className: 'pp-bottomText__progenyInfo'
    }, void 0, type, ' in ', _ref2, ' are stakes placed. Trainer listed is trainer with whom horse achieved highest RPR.'), _ref3);
};

exports.default = RelativesTableDisclaimer;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _distance = __webpack_require__(93);

var _ProfileLink = __webpack_require__(24);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _HorseSireCell = __webpack_require__(1106);

var _HorseSireCell2 = _interopRequireDefault(_HorseSireCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    breakpoint: 'fromMedium',
    title: 'placed'
}, void 0, 'pld');

var _ref4 = _jsx(_Abbr2.default, {
    breakpoint: 'fromMedium',
    title: 'distance'
}, void 0, 'dist.');

var columns = [{
    key: 'horseName',
    header: 'horse sire',
    cell: function cell(relativeData) {
        return _react2.default.createElement(_HorseSireCell2.default, relativeData);
    },
    sortFn: 'alphabetic'
}, {
    key: 'wins'
}, {
    key: 'runs'
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'places',
    header: function header() {
        return _ref;
    }
}, {
    key: 'trainerName',
    header: 'trainer',
    cell: function cell(_ref2) {
        var trainerName = _ref2.trainerName,
            trainerUid = _ref2.trainerUid;
        return _jsx(_ProfileLink.TrainerLink, {
            className: 'ui-link_marked',
            trainerStyleName: trainerName,
            trainerUid: trainerUid
        });
    },
    sortFn: 'byLastName'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref3) {
        var totalPrizeMoney = _ref3.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}, {
    key: 'distanceYard',
    header: function header() {
        return _ref4;
    },
    cell: function cell(_ref5) {
        var distanceYard = _ref5.distanceYard;
        return (0, _distance.yardsToFurlongs)(distanceYard) || '—';
    },
    sortFn: 'numericReverse'
}, {
    key: 'bestRpPostmark',
    header: 'best rpr'
}];

exports.default = columns;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _Weatherbys = __webpack_require__(351);

var _Weatherbys2 = _interopRequireDefault(_Weatherbys);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _categories = __webpack_require__(565);

var _categories2 = _interopRequireDefault(_categories);

var _categoriesReducer = __webpack_require__(1111);

var _categoriesReducer2 = _interopRequireDefault(_categoriesReducer);

var _columns = __webpack_require__(1114);

var _columns2 = _interopRequireDefault(_columns);

var _columns3 = __webpack_require__(1113);

var _columns4 = _interopRequireDefault(_columns3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getColumns = function getColumns(tab) {
    return !tab || tab === 'progeny' ? _columns2.default : _columns4.default;
};

var _ref2 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, 'Details of horses trained outside GB and Ireland or born prior to 1986 may be incomplete. OR Rating is the latest published.');

var _ref3 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, 'Progeny in magenta coloured text denotes a female horse.');

var ProgenyCommon = function (_FilteringComponent) {
    _inherits(ProgenyCommon, _FilteringComponent);

    function ProgenyCommon(props) {
        _classCallCheck(this, ProgenyCommon);

        var _this = _possibleConstructorReturn(this, (ProgenyCommon.__proto__ || Object.getPrototypeOf(ProgenyCommon)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data = props.data,
            progenyHorses = _props$data.progenyHorses,
            damSireProgenyHorses = _props$data.damSireProgenyHorses,
            seasonInfo = _props$data.seasonInfo;

        var _ref = props.availableSeasonsData.data || {},
            seasonsAvailable = _ref.seasonsAvailable;

        _this.state = {
            data: progenyHorses || damSireProgenyHorses,
            categories: seasonsAvailable && (0, _categories2.default)(seasonsAvailable, seasonInfo),
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(ProgenyCommon, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;
            var _props = this.props,
                tab = _props.tab,
                weatherbysUid = _props.weatherbysUid;

            var columns = getColumns(tab);

            return _jsx('section', {
                className: 'hp-sire-progeny'
            }, void 0, categories && _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _categoriesReducer2.default,
                columns: columns,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: columns,
                loading: loading,
                initialSortIdx: 7,
                sortable: true,
                resultsPerPage: 50,
                noDataText: 'No progeny for this sire in the Racing Post database'
            }), _ref2, _ref3, tab === 'progeny' ? _jsx(_Weatherbys2.default, {
                title: 'Best Progeny',
                type: 'progeny',
                weatherbysUid: weatherbysUid
            }) : null);
        }
    }]);

    return ProgenyCommon;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref4) {
        var raceType = _ref4.raceType,
            timePeriod = _ref4.timePeriod;
        var _props2 = _this2.props,
            id = _props2.id,
            tab = _props2.tab;

        return 'horse/filter/' + (tab || 'progeny') + '/' + id + '/' + timePeriod + '/' + raceType;
    };

    this.onDataReceive = function (_ref5) {
        var progenyHorses = _ref5.progenyHorses,
            damSireProgenyHorses = _ref5.damSireProgenyHorses;

        _this2.setState({
            data: progenyHorses || damSireProgenyHorses || _this2.emptyData,
            loading: false
        });
    };
};

var SireProgenyType = {
    countryOriginCode: _propTypes2.default.string,
    damSireCountryOriginCode: _propTypes2.default.string,
    damSireStyleName: _propTypes2.default.string,
    damSireUid: _propTypes2.default.number,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    places: _propTypes2.default.number,
    rpPostmark: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    totalPrizeMoney: _propTypes2.default.number,
    winPercent: _propTypes2.default.number,
    wins: _propTypes2.default.number
};

var DamsSireProgenyType = _extends({}, SireProgenyType, {
    bestOr: _propTypes2.default.number,
    horseAge: _propTypes2.default.number,
    horseSexCode: _propTypes2.default.string,
    sireCountryOriginCode: _propTypes2.default.string,
    sireStyleName: _propTypes2.default.string,
    sireUid: _propTypes2.default.number
});

ProgenyCommon.propTypes = {
    data: _propTypes2.default.shape({
        progenyHorses: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape(SireProgenyType), _propTypes2.default.shape(DamsSireProgenyType)])),
        seasonInfo: _propTypes2.default.shape({
            raceType: _propTypes2.default.string,
            seasonYearBegin: _propTypes2.default.number,
            seasonYearEnd: _propTypes2.default.number
        })
    }).isRequired,
    id: _propTypes2.default.string,
    tab: _propTypes2.default.string,
    availableSeasonsData: _propTypes2.default.shape({
        data: _propTypes2.default.shape({
            FLAT: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                seasonStartYear: _propTypes2.default.string,
                seasonEndYear: _propTypes2.default.string
            })),
            JUMPS: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                seasonStartYear: _propTypes2.default.string,
                seasonEndYear: _propTypes2.default.string
            }))
        })
    }),
    weatherbysUid: _propTypes2.default.string
};

exports.default = ProgenyCommon;

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(565);

var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable;

    if (action.type === 'raceType') {
        var newRaceType = getRaceType(action.value);
        if (raceType !== newRaceType) {
            return (0, _categories.timePeriodsFactory)(newRaceType, seasonsAvailable);
        }
    }
    return timePeriod;
};

var categoriesReducer = function categoriesReducer(_ref, action) {
    var raceType = _ref.raceType,
        timePeriod = _ref.timePeriod;
    return {
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlatJumpsTables = __webpack_require__(562);

var _FlatJumpsTables2 = _interopRequireDefault(_FlatJumpsTables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progeny = function Progeny(_ref) {
    var data = _ref.data;
    return _jsx(_FlatJumpsTables2.default, {
        data: data,
        disclaimerName: 'Progeny',
        flatTitle: 'Flat',
        jumpsTitle: 'Jumps',
        flatNoData: 'No progeny results on the Flat in our records',
        jumpsNoData: 'No progeny results over jumps in our records'
    });
};

exports.default = Progeny;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

var _HorseCell = __webpack_require__(564);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'horse'
}, void 0, 'horse / sire');

var _ref3 = _jsx(_Abbr2.default, {
    title: 'wins'
}, void 0, 'wins / runs');

var columns = [{
    key: 'horseName',
    header: function header() {
        return _ref;
    },
    cell: _HorseCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'sireStyleName',
    header: 'sire',
    cell: function cell(_ref2) {
        var sireStyleName = _ref2.sireStyleName,
            sireUid = _ref2.sireUid,
            sireCountryOriginCode = _ref2.sireCountryOriginCode;
        return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
            className: 'ui-link_marked',
            horseStyleName: sireStyleName,
            horseUid: sireUid
        }), sireCountryOriginCode ? _jsx('span', {}, void 0, ' (' + sireCountryOriginCode + ')') : null);
    },
    sortFn: 'alphabetic'
}, {
    key: 'wins',
    header: function header() {
        return _ref3;
    },
    cell: function cell(_ref4) {
        var wins = _ref4.wins,
            runs = _ref4.runs;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, wins), _jsx('span', {
            className: 'hidden-sm-up'
        }, void 0, '/', runs));
    }
}, {
    key: 'runs'
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'places',
    header: 'placed'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref5) {
        var totalPrizeMoney = _ref5.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}, {
    key: 'bestOr',
    header: 'best or'
}, {
    key: 'rpPostmark',
    header: 'best rpr'
}];

exports.default = columns;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

var _HorseCell = __webpack_require__(564);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'horse'
}, void 0, 'horse / dam\'s sire');

var _ref3 = _jsx(_Abbr2.default, {
    title: 'wins'
}, void 0, 'wins / runs');

var columns = [{
    key: 'horseName',
    header: function header() {
        return _ref;
    },
    cell: _HorseCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'damSireStyleName',
    header: 'dam\'s sire',
    cell: function cell(_ref2) {
        var damSireStyleName = _ref2.damSireStyleName,
            damSireUid = _ref2.damSireUid,
            damSireCountryOriginCode = _ref2.damSireCountryOriginCode;
        return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
            className: 'ui-link_marked',
            horseStyleName: damSireStyleName,
            horseUid: damSireUid
        }), _jsx('span', {}, void 0, ' (' + damSireCountryOriginCode + ')'));
    },
    sortFn: 'alphabetic'
}, {
    key: 'wins',
    header: function header() {
        return _ref3;
    },
    cell: function cell(_ref4) {
        var wins = _ref4.wins,
            runs = _ref4.runs;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, wins), _jsx('span', {
            className: 'hidden-sm-up'
        }, void 0, '/', runs));
    }
}, {
    key: 'runs'
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'places',
    header: 'placed'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref5) {
        var totalPrizeMoney = _ref5.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}, {
    key: 'bestOr',
    header: 'best or'
}, {
    key: 'rpPostmark',
    header: 'best rpr'
}];

exports.default = columns;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _EntriesList = __webpack_require__(575);

var _EntriesList2 = _interopRequireDefault(_EntriesList);

var _Switcher = __webpack_require__(253);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(161);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var switcherTitles = ['Big Races', 'Flat', 'Jumps'];
var switcherKeys = ['progenyEntriesBigRaces', 'progenyEntriesFlat', 'progenyEntriesJumps'];

var getInitRaceTypeNumber = function getInitRaceTypeNumber(data) {
    for (var idx in switcherKeys) {
        // eslint-disable-line no-restricted-syntax
        if (!(0, _lodash.isEmpty)(data[switcherKeys[idx]].data.progenyEntries)) {
            return +idx;
        }
    }
    return 0;
};

var ProgenyEntries = function (_PureComponent) {
    _inherits(ProgenyEntries, _PureComponent);

    function ProgenyEntries(props) {
        _classCallCheck(this, ProgenyEntries);

        var _this = _possibleConstructorReturn(this, (ProgenyEntries.__proto__ || Object.getPrototypeOf(ProgenyEntries)).call(this, props));

        _this.setSelected = function (raceType) {
            _this.setState({ raceType: raceType }, function () {
                (0, _fixMobileSafariWhiteScreenBug2.default)();
            });
        };

        var sireStatus = props.data.profile.sireStatus;

        _this.state = { raceType: sireStatus && getInitRaceTypeNumber(props.data) };
        return _this;
    }

    _createClass(ProgenyEntries, [{
        key: 'render',
        value: function render() {
            var data = this.props.data;
            var sireStatus = data.profile.sireStatus;

            var entries = (sireStatus ? data[switcherKeys[this.state.raceType]].data.progenyEntries : data.progenyEntries) || [];
            var noDataText = 'No progeny entries' + (sireStatus ? ' for this stallion' : '');

            return _jsx('div', {
                className: 'hp-progenyEntries'
            }, void 0, sireStatus && _jsx('div', {
                className: 'ui-centered-wrapper'
            }, void 0, _jsx(_Switcher2.default, {
                items: switcherTitles,
                selected: this.state.raceType,
                setSelected: this.setSelected
            })), _jsx(_EntriesList2.default, {
                entries: entries,
                noDataText: noDataText,
                isHorseShown: true,
                isDamShown: sireStatus,
                showMore: this.showMore,
                shownItems: this.state.shownItems
            }));
        }
    }]);

    return ProgenyEntries;
}(_react.PureComponent);

var progenyEntriesTypes = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    courseStyleName: _propTypes2.default.string,
    courseUid: _propTypes2.default.number,
    damCountryCode: _propTypes2.default.string,
    damName: _propTypes2.default.string,
    damUid: _propTypes2.default.number,
    horseAge: _propTypes2.default.number,
    horseCountryCode: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    raceDatetime: _propTypes2.default.string,
    raceInstanceTitle: _propTypes2.default.string,
    raceInstanceUid: _propTypes2.default.number,
    raceStatusCode: _propTypes2.default.string,
    raceUid: _propTypes2.default.number
}));
var stallionProgenyEntriesTypes = _propTypes2.default.shape({
    data: _propTypes2.default.shape({ progenyEntries: progenyEntriesTypes })
});

exports.default = ProgenyEntries;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(6);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _columns = __webpack_require__(1117);

var _columns2 = _interopRequireDefault(_columns);

var _categories = __webpack_require__(566);

var _categories2 = _interopRequireDefault(_categories);

var _reducer = __webpack_require__(1119);

var _reducer2 = _interopRequireDefault(_reducer);

var _selection = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noDataText = 'No GB or IRE progeny results for this sire in the Racing Post database';

var emptyData = {
    progenyResults: [],
    seasonInfo: {}
};

var ProgenyResults = function (_FilteringComponent) {
    _inherits(ProgenyResults, _FilteringComponent);

    function ProgenyResults(props) {
        _classCallCheck(this, ProgenyResults);

        var _this = _possibleConstructorReturn(this, (ProgenyResults.__proto__ || Object.getPrototypeOf(ProgenyResults)).call(this, props));

        _initialiseProps.call(_this);

        _this.dataKey = 'progenyResults';
        var data = props.data;

        var _get = (0, _lodash.get)(data, 'progenyResults.data', emptyData),
            progenyResults = _get.progenyResults,
            _get$seasonInfo = _get.seasonInfo,
            countryCode = _get$seasonInfo.countryCode,
            raceType = _get$seasonInfo.raceType,
            surface = _get$seasonInfo.surface,
            seasonYearBegin = _get$seasonInfo.seasonYearBegin,
            seasonYearEnd = _get$seasonInfo.seasonYearEnd;

        var _get2 = (0, _lodash.get)(data, 'availableSeasonsData.data', {}),
            seasonsAvailable = _get2.seasonsAvailable;

        var surfaceUri = surface ? '/' + surface : '';

        _this.state = {
            data: progenyResults || [],
            categories: seasonsAvailable && (0, _categories2.default)(seasonsAvailable, {
                raceType: countryCode + '/' + raceType + surfaceUri,
                timePeriod: seasonYearBegin + '/' + seasonYearEnd
            }),
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(ProgenyResults, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'hp-progeny-results'
            }, void 0, categories && _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                columns: _columns2.default,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: _columns2.default,
                loading: loading,
                initialSortIdx: 0,
                sortable: true,
                resultsPerPage: 50,
                noDataText: noDataText
            }));
        }
    }]);

    return ProgenyResults;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref) {
        var raceType = _ref.raceType,
            timePeriod = _ref.timePeriod,
            month = _ref.month;
        var id = _this2.props.params.id;

        return 'horse/filter/progeny-results/' + id + '/' + timePeriod + '/' + raceType + '/' + month;
    };

    this.renderStatus = function () {
        var categories = _this2.state.categories;

        var typeCaption = (0, _selection.getOption)(categories, 'raceType').label;
        var seasonCaption = (0, _selection.getOption)(categories, 'timePeriod').label;
        var month = (0, _selection.getOption)(categories, 'month');

        return _jsx('h2', {
            className: 'ui-filter__statusText'
        }, void 0, _jsx('strong', {}, void 0, typeCaption, ', ', seasonCaption), month.value && ' (' + month.label + ')');
    };
};

ProgenyResults.propTypes = {
    data: _propTypes2.default.shape({
        progenyResults: _propTypes2.default.shape({
            data: _propTypes2.default.shape({
                progenyResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                    countryCode: _propTypes2.default.string,
                    courseName: _propTypes2.default.string,
                    courseRpAbbrev3: _propTypes2.default.string,
                    courseUid: _propTypes2.default.number,
                    distanceFurlong: _propTypes2.default.number,
                    goingTypeCode: _propTypes2.default.string,
                    horseName: _propTypes2.default.string,
                    horseUid: _propTypes2.default.number,
                    noOfRunners: _propTypes2.default.number,
                    officialRatingRanOff: _propTypes2.default.number,
                    prizeMoney: _propTypes2.default.number,
                    raceDatetime: _propTypes2.default.string,
                    raceDescription: _propTypes2.default.string,
                    raceInstanceUid: _propTypes2.default.number,
                    raceOutcomePosition: _propTypes2.default.number,
                    rpPostmark: _propTypes2.default.number,
                    rpTopspeed: _propTypes2.default.number
                }))
            })
        })
    }).isRequired
};

exports.default = ProgenyResults;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _CourseCell = __webpack_require__(1118);

var _CourseCell2 = _interopRequireDefault(_CourseCell);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ProfileLink = __webpack_require__(24);

var _date = __webpack_require__(19);

var _number = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'position',
    breakpoint: 'fromMedium'
}, void 0, 'pos.');

var _ref4 = _jsx(_Abbr2.default, {
    title: 'course / conditions / prize'
}, void 0, 'crs.');

var columns = [{
    key: 'raceDatetime',
    header: 'date',
    cell: function cell(props) {
        return _react2.default.createElement(
            _ResultLink2.default,
            props,
            (0, _date.formatDate)(props.raceDatetime, 'DDMMMYY')
        );
    },
    sortFn: (0, _date.sortByDate)('raceDatetime')
}, {
    key: 'horseName',
    header: 'horse',
    cell: function cell(_ref) {
        var horseName = _ref.horseName,
            horseUid = _ref.horseUid,
            countryCode = _ref.countryCode;
        return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
            horseStyleName: horseName,
            horseUid: horseUid
        }), _jsx('span', {
            className: 'hp-progeny-results__country'
        }, void 0, ' (', countryCode, ')'));
    },
    sortFn: 'alphabetic'
}, {
    key: 'raceOutcomePosition',
    header: function header() {
        return _ref2;
    },
    cell: function cell(_ref3) {
        var raceOutcomePosition = _ref3.raceOutcomePosition,
            noOfRunners = _ref3.noOfRunners,
            raceOutcomeCode = _ref3.raceOutcomeCode;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, raceOutcomePosition || raceOutcomeCode), '/', noOfRunners);
    },
    sortFn: (0, _number.placesSort)('raceOutcomePosition')
}, {
    key: 'courseName',
    header: function header() {
        return _ref4;
    },
    cell: _CourseCell2.default
}, {
    key: 'officialRatingRanOff',
    header: 'or',
    cell: (0, _number.zeroToDash)('officialRatingRanOff')
}, {
    key: 'rpTopspeed',
    header: 'ts'
}, {
    key: 'rpPostmark',
    header: 'rpr',
    cell: (0, _number.zeroToDash)('rpPostmark')
}];

exports.default = columns;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _ProfileLink = __webpack_require__(24);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _money = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseCell = function CourseCell(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        courseRpAbbrev3 = _ref.courseRpAbbrev3,
        distanceFurlong = _ref.distanceFurlong,
        goingTypeCode = _ref.goingTypeCode,
        raceDescription = _ref.raceDescription,
        prizeMoney = _ref.prizeMoney;
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.CourseLink, {
        courseStyleName: courseName,
        courseUid: courseUid
    }, void 0, _jsx(_Abbr2.default, {
        title: courseName
    }, void 0, (0, _lodash.capitalize)(courseRpAbbrev3))), _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, ' ' + distanceFurlong + goingTypeCode, '\xA0', 'C' + raceDescription, '\xA0', (0, _money.formatMoney)(prizeMoney)));
};

exports.default = CourseCell;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(566);

var getRaceType = function getRaceType(val) {
    return val.split('/')[1].match(/jumps|flat/)[0];
};

var timePeriodReducer = function timePeriodReducer(timePeriod, _ref) {
    var type = _ref.type,
        value = _ref.value;
    var _timePeriod$createdBy = timePeriod.createdBy,
        flatOrJumps = _timePeriod$createdBy.flatOrJumps,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable;

    if (type === 'raceType' && flatOrJumps !== getRaceType(value)) {
        return (0, _categories.timePeriodsFactory)(value, seasonsAvailable);
    }
    return timePeriod;
};

var monthReducer = function monthReducer(month, _ref2) {
    var type = _ref2.type,
        value = _ref2.value;
    var _month$createdBy = month.createdBy,
        flatOrJumps = _month$createdBy.flatOrJumps,
        timePeriod = _month$createdBy.timePeriod,
        seasonsAvailable = _month$createdBy.seasonsAvailable;

    if (type === 'raceType' && flatOrJumps !== getRaceType(value)) {
        return (0, _categories.monthFactory)(value, timePeriod, seasonsAvailable);
    }
    if (type === 'timePeriod' && timePeriod !== value) {
        return (0, _categories.monthFactory)(flatOrJumps, value, seasonsAvailable);
    }
    return month;
};

var categoriesReducer = function categoriesReducer(_ref3, action) {
    var raceType = _ref3.raceType,
        timePeriod = _ref3.timePeriod,
        month = _ref3.month;
    return {
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action),
        month: monthReducer(month, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1121);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgenySales = function ProgenySales(_ref) {
    var progenySales = _ref.data.progenySales;
    return _jsx('section', {
        className: 'hp-progeny-sales'
    }, void 0, _jsx(_rpReactTable2.default, {
        columns: _columns2.default,
        data: progenySales,
        initialSortIdx: 0,
        noDataText: 'No progeny sales',
        sortable: true
    }));
};

exports.default = ProgenySales;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(6);

var _money = __webpack_require__(32);

var _date = __webpack_require__(19);

var _HorseCell = __webpack_require__(1122);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _SireCell = __webpack_require__(1123);

var _SireCell2 = _interopRequireDefault(_SireCell);

var _SalesHorseLink = __webpack_require__(577);

var _SalesHorseLink2 = _interopRequireDefault(_SalesHorseLink);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'horse',
    breakpoint: 'fromMedium'
}, void 0, 'horse', _jsx('br', {}), 'sire (dam\'s sire)');

var _ref2 = _jsx('abbr', {
    className: 'pp-abbr__from'
}, void 0, 'sire', _jsx('br', {}), 'dam\'s sire');

var columns = [{
    key: 'saleDate',
    header: 'date',
    cell: _SalesHorseLink2.default,
    sortFn: (0, _date.sortByDate)('saleDate')
}, {
    key: 'horseName',
    header: function header() {
        return _ref;
    },
    cell: _HorseCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'sireName',
    // using <abbr className="pp-abbr__from"> for A-QA comfort
    header: function header() {
        return _ref2;
    },
    cell: _SireCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'priceGbp',
    header: 'price',
    cell: function cell(_ref3) {
        var price = _ref3.price,
            curCode = _ref3.curCode;
        return (0, _money.formatSalePrice)(price, curCode);
    }
}, {
    key: 'vendor',
    sortFn: 'alphabetic'
}, {
    key: 'buyerDetail',
    header: 'buyer',
    sortFn: 'byLastName'
}, {
    key: 'venueDesc',
    header: 'sale',
    cell: function cell(_ref4) {
        var venueDesc = _ref4.venueDesc;
        return (0, _lodash.capitalize)(venueDesc).substr(0, 3);
    },
    sortFn: 'alphabetic'
}];

exports.default = columns;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _getFormattedAge = __webpack_require__(1201);

var _getFormattedAge2 = _interopRequireDefault(_getFormattedAge);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hidden-md-up'
}, void 0, ',');

var HorseCell = function HorseCell(_ref) {
    var horseName = _ref.horseName,
        horseSaleName = _ref.horseSaleName,
        horseCountryOriginCode = _ref.horseCountryOriginCode,
        horseUid = _ref.horseUid,
        horseFirstColourCode = _ref.horseFirstColourCode,
        horseSex = _ref.horseSex,
        horseAge = _ref.horseAge,
        sireName = _ref.sireName,
        sireUid = _ref.sireUid,
        sireOfDamName = _ref.sireOfDamName,
        sireOfDamUid = _ref.sireOfDamUid;
    return _jsx('div', {}, void 0, horseUid ? _jsx(_ProfileLink.HorseLink, {
        className: 'hp-progeny-sales__horseName',
        horseStyleName: horseName || horseSaleName,
        horseUid: horseUid,
        whenEmpty: 'Unnamed'
    }) : _jsx('span', {}, void 0, horseName || (0, _lodash.startCase)((0, _lodash.toLower)(horseSaleName))), _ref2, horseCountryOriginCode && _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, ' (' + horseCountryOriginCode + ')'), horseFirstColourCode ? ' ' + horseFirstColourCode + ', ' : ' ', horseSex, ', ', (0, _getFormattedAge2.default)(horseAge), _jsx('div', {
        className: 'hidden-md-up'
    }, void 0, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireName,
        horseUid: sireUid
    }), ' ', _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked hp-progeny-sales__secondary-link',
        horseStyleName: sireOfDamName,
        horseUid: sireOfDamUid
    }, void 0, '(' + sireOfDamName + ')')));
};

exports.default = HorseCell;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('br', {
    className: 'hidden-sm-down'
});

var SireCell = function SireCell(_ref) {
    var sireName = _ref.sireName,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        sireUid = _ref.sireUid,
        sireOfDamName = _ref.sireOfDamName,
        sireOfDamCountryOriginCode = _ref.sireOfDamCountryOriginCode,
        sireOfDamUid = _ref.sireOfDamUid;
    return _jsx('div', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireName,
        horseUid: sireUid
    }, void 0, sireName, ' (', sireCountryOriginCode, ')'), _ref2, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireOfDamName,
        horseUid: sireOfDamUid
    }, void 0, sireOfDamName, ' (', sireOfDamCountryOriginCode, ')'));
};

exports.default = SireCell;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _lodash = __webpack_require__(6);

var _columns = __webpack_require__(567);

var _columns2 = _interopRequireDefault(_columns);

var _RaceRow = __webpack_require__(1125);

var _RaceRow2 = _interopRequireDefault(_RaceRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sectionTitles = {
    '1988ToDate': '1988 to Date',
    '2000ToDate': '2000 to Date',
    currentYear: 'Current Year'
};

var noDataText = 'No progeny statistics for this sire in the Racing Post database';
var tableClassName = 'ui-table ui-table_type2 hp-progeny-statistics__table';

var _ref2 = _jsx(_rpReactTable.NoData, {
    text: noDataText
});

var _ref3 = _jsx(_rpReactTable.Header, {
    columns: _columns2.default
});

var ProgenyStatistics = function ProgenyStatistics(_ref) {
    var progenyStatistics = _ref.data.progenyStatistics,
        id = _ref.params.id;
    return _jsx('section', {
        className: 'hp-progeny-statistics'
    }, void 0, (0, _lodash.isEmpty)(progenyStatistics) ? _ref2 : (0, _lodash.keys)(progenyStatistics).map(function (timePeriod) {
        var data = progenyStatistics[timePeriod];

        return (0, _lodash.isEmpty)(data) ? null : _jsx('div', {}, timePeriod, _jsx('h2', {}, void 0, sectionTitles[timePeriod]), _jsx('table', {
            className: tableClassName
        }, void 0, _ref3, data.map(function (rowData) {
            return _jsx(_RaceRow2.default, {
                data: rowData,
                horseId: id,
                timePeriod: timePeriod
            }, rowData.category);
        })));
    }));
};

var statisticsRow = _propTypes2.default.shape({
    category: _propTypes2.default.string,
    winners: _propTypes2.default.number,
    runners: _propTypes2.default.number,
    percentWinnersRunners: _propTypes2.default.number,
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    percentWinsRuns: _propTypes2.default.number,
    place2ndNumber: _propTypes2.default.number,
    place3rdNumber: _propTypes2.default.number,
    totalPrizeMoney: _propTypes2.default.number
});

exports.default = ProgenyStatistics;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _columns = __webpack_require__(567);

var _columns2 = _interopRequireDefault(_columns);

var _columns3 = __webpack_require__(1126);

var _columns4 = _interopRequireDefault(_columns3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions */


var _ref2 = _jsx(_rpReactTable.Loading, {});

var RaceRow = function (_PureComponent) {
    _inherits(RaceRow, _PureComponent);

    function RaceRow(props) {
        _classCallCheck(this, RaceRow);

        var _this = _possibleConstructorReturn(this, (RaceRow.__proto__ || Object.getPrototypeOf(RaceRow)).call(this, props));

        _this.fetchDetails = function () {
            var _this$props = _this.props,
                horseId = _this$props.horseId,
                timePeriod = _this$props.timePeriod,
                category = _this$props.data.category;

            var startYear = parseInt(timePeriod, 10) || new Date().getFullYear();
            var raceType = encodeURI(category);

            _axios2.default.get('horse/accordion-statistics/' + horseId + '/' + startYear + '/' + raceType).then(function (_ref) {
                var _ref$data = _ref.data,
                    progenyStatisticsTop = _ref$data.progenyStatisticsTop,
                    progenyBroodmareSiresStatisticsTop = _ref$data.progenyBroodmareSiresStatisticsTop;

                _this.setState({
                    detailsData: progenyStatisticsTop || progenyBroodmareSiresStatisticsTop,
                    needFetch: false
                });
            }).catch(function (error) {
                console.warn(error);
                _this.setState({ needFetch: false });
            });
        };

        _this.toggleDetails = function (event) {
            if (event.target.nodeName === 'A') {
                return;
            }

            _this.setState(function (state) {
                return { expanded: !state.expanded };
            });

            if (_this.state.needFetch) {
                _this.fetchDetails();
            }
        };

        _this.state = {
            detailsData: [],
            expanded: false,
            needFetch: true
        };
        return _this;
    }

    /* to not pollute global Row component we adding handler for tbody
     and preventing click handling on second table row by css pointer-events: none
     and checking target.nodeName */


    _createClass(RaceRow, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                detailsData = _state.detailsData,
                expanded = _state.expanded,
                needFetch = _state.needFetch;


            return _jsx('tbody', {
                className: expanded && 'hp-progeny-statistics__expanded',
                onClick: this.toggleDetails
            }, void 0, _jsx(_rpReactTable.Row, {
                rowData: this.props.data,
                columns: _columns2.default,
                setRowClass: function setRowClass() {
                    return 'hp-progeny-statistics__row';
                }
            }), expanded && _jsx('tr', {
                className: 'ui-table__row'
            }, void 0, _jsx('td', {
                colSpan: '10',
                className: 'hp-progeny-statistics__detailsTable'
            }, void 0, needFetch ? _ref2 : _jsx(_rpReactTable2.default, {
                data: detailsData,
                columns: (0, _columns4.default)(this.props.data.broodmareCategory),
                uiType: 5
            }))));
        }
    }]);

    return RaceRow;
}(_react.PureComponent);

exports.default = RaceRow;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(isBroodmare) {
    return [{
        key: 'horseUid',
        header: 'horse',
        cell: _ProfileLink.HorseLink
    }, {
        key: 'damSireUid',
        header: isBroodmare ? 'sire' : 'dam\'s sire',
        cell: function cell(_ref) {
            var damSireStyleName = _ref.damSireStyleName,
                damSireUid = _ref.damSireUid,
                sireStyleName = _ref.sireStyleName,
                sireUid = _ref.sireUid;
            return _jsx(_ProfileLink.HorseLink, {
                horseStyleName: damSireStyleName || sireStyleName,
                horseUid: damSireUid || sireUid
            });
        }
    }, {
        key: 'wins'
    }, {
        key: 'runs'
    }, {
        key: 'winsPercent',
        header: '%'
    }, {
        key: 'totalPrizemoney',
        header: 'total earnings',
        cell: function cell(_ref2) {
            var totalPrizemoney = _ref2.totalPrizemoney;
            return (0, _money.formatMoney)(totalPrizemoney);
        }
    }, {
        key: 'rpPostmark',
        header: 'rpr'
    }];
};

exports.default = columns;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(19);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quotes = function Quotes(_ref) {
    var _ref$data = _ref.data,
        quotes = _ref$data.quotes,
        lookupTable = _ref$data.lookupTable;
    return _jsx('section', {
        className: 'hp-quotes'
    }, void 0, quotes && quotes.map(function (_ref2) {
        var raceDate = _ref2.raceDate,
            raceId = _ref2.raceId,
            raceTitle = _ref2.raceTitle,
            courseName = _ref2.courseName,
            courseUid = _ref2.courseUid,
            courseStyleName = _ref2.courseStyleName,
            distanceFurlong = _ref2.distanceFurlong,
            goingTypeCode = _ref2.goingTypeCode,
            rpPostmark = _ref2.rpPostmark,
            notes = _ref2.notes;
        return _jsx('div', {
            className: 'hp-quotes__item'
        }, raceId, _jsx('h2', {
            className: 'hp-quotes__header'
        }, void 0, _jsx(_ResultLink2.default, {
            className: 'hp-quotes__resultsLink',
            courseName: courseName,
            courseUid: +courseUid,
            raceInstanceUid: raceId,
            raceInstanceTitle: raceTitle,
            raceDatetime: raceDate
        }, void 0, (0, _date.formatDate)(raceDate, 'DMMMYY')), '\xA0', courseStyleName, '\xA0 (', distanceFurlong, lookupTable && lookupTable[goingTypeCode].servicesDesc, rpPostmark && ', RPR ' + rpPostmark, ')'), _jsx('p', {
            className: 'hp-quotes__text'
        }, void 0, notes));
    }));
};

exports.default = Quotes;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1129);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sales = function Sales(_ref) {
    var data = _ref.data;
    return _jsx('section', {
        className: 'hp-sales'
    }, void 0, _jsx(_rpReactTable2.default, {
        data: data.sales,
        columns: _columns2.default,
        noDataText: 'No sales data for this horse'
    }));
};

exports.default = Sales;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(6);

var _money = __webpack_require__(32);

var _date = __webpack_require__(19);

var _SalesHorseLink = __webpack_require__(577);

var _SalesHorseLink2 = _interopRequireDefault(_SalesHorseLink);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = [{
    key: 'saleDate',
    header: 'date',
    cell: function cell(data) {
        return _react2.default.createElement(
            _SalesHorseLink2.default,
            data,
            _jsx(_Abbr2.default, {
                title: (0, _date.formatDate)(data.saleDate, 'dddd, DD MMMM YYYY'),
                breakpoint: 'exWide'
            }, void 0, (0, _date.formatDate)(data.saleDate, 'DDMMMYY'))
        );
    }
}, {
    key: 'abbrevName',
    header: 'sale name',
    cell: function cell(_ref) {
        var abbrevName = _ref.abbrevName,
            venueDesc = _ref.venueDesc;
        return _jsx('div', {}, void 0, _jsx('span', {
            className: 'hidden-sm-down'
        }, void 0, abbrevName), _jsx('span', {
            className: 'hidden-md-up'
        }, void 0, (0, _lodash.lowerCase)(venueDesc)));
    }
}, {
    key: 'lotNo',
    header: 'lot'
}, {
    key: 'sellerName',
    header: 'vendor'
}, {
    key: 'buyerDetail',
    header: 'purchaser'
}, {
    key: 'price',
    header: 'price',
    cell: function cell(_ref2) {
        var price = _ref2.price,
            curCode = _ref2.curCode;
        return (0, _money.formatSalePrice)(price, curCode);
    }
}];

exports.default = columns;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

exports.default = SalesEntries;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpBloodstockSearch = __webpack_require__(917);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SalesEntries(_ref) {
    var _ref$data$profile = _ref.data.profile,
        horseUid = _ref$data$profile.horseUid,
        horseName = _ref$data$profile.horseName;

    return _jsx(_rpBloodstockSearch.SearchEntries, {
        sireUid: horseUid,
        sireName: horseName
    });
}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

exports.default = SalesResults;

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpBloodstockSearch = __webpack_require__(917);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_FORMAT = 'YYYY-MM-DD';

function SalesResults(_ref) {
    var horseName = _ref.data.profile.horseName;

    var from = (0, _moment2.default)().add(-1, 'years').format(DATE_FORMAT);
    var to = (0, _moment2.default)().format(DATE_FORMAT);
    return _jsx(_rpBloodstockSearch.SearchResults, {
        sireName: horseName,
        from: from,
        to: to
    });
}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _categories = __webpack_require__(1133);

var _categories2 = _interopRequireDefault(_categories);

var _columns = __webpack_require__(1134);

var _columns2 = _interopRequireDefault(_columns);

var _getMappedStatistic = __webpack_require__(1135);

var _getMappedStatistic2 = _interopRequireDefault(_getMappedStatistic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setRowClass = function setRowClass(_ref) {
    var type = _ref.type;
    return type === 'total' ? 'hp-sales-statistic__totalRow' : '';
};

var _ref2 = _jsx('div', {
    className: 'hp-sales-statistic__subtext'
}, void 0, 'All sales prices are shown in English Guineas');

var SalesStatistic = function (_FilteringComponent) {
    _inherits(SalesStatistic, _FilteringComponent);

    function SalesStatistic(props) {
        _classCallCheck(this, SalesStatistic);

        var _this = _possibleConstructorReturn(this, (SalesStatistic.__proto__ || Object.getPrototypeOf(SalesStatistic)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data = props.data,
            overall = _props$data.overall,
            saleStatistics = _props$data.saleStatistics,
            countryFlag = _props$data.seasonInfo.countryFlag;


        _this.state = {
            data: (0, _getMappedStatistic2.default)(overall, saleStatistics),
            categories: (0, _categories2.default)(countryFlag, 'yearlings'),
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(SalesStatistic, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;

            return _jsx('section', {
                className: 'hp-sales-statistic'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                fetchError: fetchError,
                categoriesReducer: this.categoriesReducer,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: _columns2.default,
                loading: loading,
                uiType: 6,
                setRowClass: setRowClass,
                noDataText: 'No sales statistics in the Racing Post database for this sire'
            }), _ref2);
        }
    }]);

    return SalesStatistic;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref3) {
        var displayBy = _ref3.displayBy,
            regions = _ref3.regions;
        var id = _this2.props.params.id;

        return 'horse/filter/sales-statistics/' + id + '/' + displayBy + '/' + regions;
    };

    this.onDataReceive = function (_ref4) {
        var overall = _ref4.overall,
            saleStatistics = _ref4.saleStatistics;

        _this2.setState({
            data: (0, _getMappedStatistic2.default)(overall, saleStatistics) || _this2.emptyData,
            loading: false
        });
    };

    this.categoriesReducer = function (categories) {
        return categories;
    };
};

var saleTypes = {
    saleYear: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    byersCount: _propTypes2.default.number,
    offeredCount: _propTypes2.default.number,
    salesCount: _propTypes2.default.number,
    soldPercent: _propTypes2.default.number,
    priceAverage: _propTypes2.default.number,
    priceMax: _propTypes2.default.number,
    median: _propTypes2.default.number,
    priceMin: _propTypes2.default.number
};

var segmentShape = _propTypes2.default.shape(_extends({}, saleTypes, {
    colts: _propTypes2.default.shape(saleTypes),
    fillies: _propTypes2.default.shape(saleTypes)
}));

SalesStatistic.propTypes = {
    data: _propTypes2.default.shape({
        saleStatistics: _propTypes2.default.arrayOf(segmentShape),
        overall: segmentShape
    }).isRequired
};

exports.default = SalesStatistic;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _selection = __webpack_require__(131);

var regionsOptions = [{
    label: 'GB',
    value: 'GB'
}, {
    label: 'Ireland',
    value: 'IRE'
}, {
    label: 'GB and Ireland',
    value: 'GB-IRE'
}, {
    label: 'Europe',
    value: 'Europe'
}, {
    label: 'USA',
    value: 'USA'
}, {
    label: 'All',
    value: 'All'
}];

var displayByOptions = [{
    label: 'Foals',
    value: 'foals'
}, {
    label: 'Yearlings',
    value: 'yearlings'
}, {
    label: '2yo',
    value: '2yo'
}, {
    label: '3yo',
    value: '3yo'
}, {
    label: '4yo',
    value: '4yo'
}, {
    label: 'Older horses',
    value: 'older'
}, {
    label: 'Mares',
    value: 'mares'
}];

var regionsFactory = function regionsFactory(region) {
    return {
        title: 'regions',
        options: (0, _selection.setSelected)(regionsOptions, region)
    };
};

var displayByFactory = function displayByFactory(displayBy) {
    return {
        title: 'display by',
        options: (0, _selection.setSelected)(displayByOptions, displayBy)
    };
};

var categoriesFactory = function categoriesFactory(region, displayBy) {
    return {
        regions: regionsFactory(region),
        displayBy: displayByFactory(displayBy)
    };
};

exports.default = categoriesFactory;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'catalogued',
    breakpoint: 'fromMedium'
}, void 0, 'cat\'d');

var _ref3 = _jsx(_Abbr2.default, {
    title: 'offered',
    breakpoint: 'fromMedium'
}, void 0, 'off\'d');

var columns = [{
    key: 'saleYear',
    header: 'horse',
    cell: function cell(_ref) {
        var type = _ref.type,
            saleYear = _ref.saleYear;
        return type === 'total' ? saleYear : saleYear + ' ' + type;
    }
}, {
    key: 'byersCount',
    header: function header() {
        return _ref2;
    }
}, {
    key: 'offeredCount',
    header: function header() {
        return _ref3;
    }
}, {
    key: 'salesCount',
    header: 'sold (%)',
    cell: function cell(_ref4) {
        var salesCount = _ref4.salesCount,
            soldPercent = _ref4.soldPercent;
        return salesCount + ' (' + (soldPercent || '') + '%)';
    }
}, {
    key: 'priceAverage',
    header: 'average',
    cell: function cell(_ref5) {
        var priceAverage = _ref5.priceAverage;
        return (0, _money.formatPrice)(priceAverage);
    }
}, {
    key: 'priceMax',
    header: 'highest',
    cell: function cell(_ref6) {
        var priceMax = _ref6.priceMax;
        return (0, _money.formatPrice)(priceMax);
    }
}, {
    key: 'median',
    cell: function cell(_ref7) {
        var median = _ref7.median;
        return (0, _money.formatPrice)(median);
    }
}, {
    key: 'priceMin',
    header: 'low',
    cell: function cell(_ref8) {
        var priceMin = _ref8.priceMin;
        return (0, _money.formatPrice)(priceMin);
    }
}];

exports.default = columns;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(6);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getObjWithType = function getObjWithType(type, obj) {
    return obj ? _extends({ type: type }, obj) : null;
};

function getMappedStatistic(overall, saleStatistics) {
    var statistic = (0, _lodash.compact)([overall].concat(saleStatistics)).reduce(function (result, _ref) {
        var colts = _ref.colts,
            fillies = _ref.fillies,
            total = _objectWithoutProperties(_ref, ['colts', 'fillies']);

        result.push(getObjWithType('total', total), getObjWithType('colts', colts), getObjWithType('fillies', fillies));
        return result;
    }, []);
    return (0, _lodash.compact)(statistic);
}

exports.default = getMappedStatistic;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/no-danger: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SireReference = function SireReference(_ref) {
    var sireReference = _ref.data.sireReference;
    return sireReference ? _jsx('section', {
        className: 'hp-weatherbys hp-weatherbys__sireReference',
        dangerouslySetInnerHTML: { __html: sireReference }
    }) : null;
};

exports.default = SireReference;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _StatsTables = __webpack_require__(1138);

var _StatsTables2 = _interopRequireDefault(_StatsTables);

var _Switcher = __webpack_require__(253);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(161);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _transformData = __webpack_require__(1140);

var _transformData2 = _interopRequireDefault(_transformData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var raceTypes = ['flat', 'jumps'];

var Stats = function (_PureComponent) {
    _inherits(Stats, _PureComponent);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data$stats = props.data.stats,
            statsFlat = _props$data$stats.statsFlat,
            statsJumps = _props$data$stats.statsJumps;


        _this.raceTypeStats = [(0, _lodash.isEmpty)(statsFlat) ? null : (0, _transformData2.default)(statsFlat.statistics, 'flat'), (0, _lodash.isEmpty)(statsJumps) ? null : (0, _transformData2.default)(statsJumps.statistics, 'jumps')];

        var selected = !_this.raceTypeStats[0] && _this.raceTypeStats[1] ? 1 : 0;

        _this.state = { selected: selected };
        return _this;
    }

    _createClass(Stats, [{
        key: 'render',
        value: function render() {
            var selected = this.state.selected;


            return _jsx('section', {
                className: 'hp-stats'
            }, void 0, _jsx('div', {
                className: 'ui-centered-wrapper'
            }, void 0, _jsx(_Switcher2.default, {
                items: raceTypes,
                selected: selected,
                setSelected: this.setSelected
            })), _jsx(_StatsTables2.default, {
                data: this.raceTypeStats[selected],
                raceType: raceTypes[selected]
            }));
        }
    }]);

    return Stats;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.setSelected = function (selected) {
        _this2.setState({ selected: selected }, function () {
            (0, _fixMobileSafariWhiteScreenBug2.default)();
        });
    };
};

exports.default = Stats;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var tables = ['course', 'distance', 'going', 'month', 'jockey', 'class'];

var StatsTables = function StatsTables(_ref) {
    var data = _ref.data,
        raceType = _ref.raceType;
    return data ? _jsx('div', {}, void 0, tables.map(function (tableKey) {
        return _jsx(_rpReactTable2.default, {
            data: data[tableKey],
            columns: [_columns.firstColumns[tableKey]].concat(_toConsumableArray(_columns.sharedColumns)),
            className: 'hp-stats__table',
            sortable: true,
            initialSortIdx: 0
        }, tableKey);
    })) : _jsx(_rpReactTable.NoData, {
        text: 'No stats for this horse ' + (raceType === 'flat' ? 'on the Flat' : 'over Jumps')
    });
};

var sharedPropTypes = {
    startsNumber: _propTypes2.default.number,
    place1stNumber: _propTypes2.default.number,
    place2ndNumber: _propTypes2.default.number,
    place3rdNumber: _propTypes2.default.number,
    winPrize: _propTypes2.default.number,
    totalPrize: _propTypes2.default.number,
    bestRpTopspeed: _propTypes2.default.number,
    bestRpPostmark: _propTypes2.default.number
};

exports.default = StatsTables;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.firstColumns = exports.sharedColumns = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _number = __webpack_require__(196);

var _date = __webpack_require__(19);

var _going = __webpack_require__(581);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedColumns = exports.sharedColumns = [{
    key: 'startsNumber',
    header: 'runs'
}, {
    key: 'place1stNumber',
    header: 'wins'
}, {
    key: 'place2ndNumber',
    header: '2nd'
}, {
    key: 'place3rdNumber',
    header: '3rd'
}, {
    key: 'netWinPrize',
    header: 'win prize money',
    cell: function cell(_ref) {
        var netWinPrize = _ref.netWinPrize;
        return (0, _money.formatMoney)(netWinPrize);
    }
}, {
    key: 'netTotalPrize',
    header: 'total prize money',
    cell: function cell(_ref2) {
        var netTotalPrize = _ref2.netTotalPrize;
        return (0, _money.formatMoney)(netTotalPrize);
    }
}, {
    key: 'bestRpTopspeed',
    header: 'best ts',
    cell: (0, _number.zeroToDash)('bestRpTopspeed')
}, {
    key: 'bestRpPostmark',
    header: 'best rpr',
    cell: (0, _number.zeroToDash)('bestRpPostmark')
}];

var firstColumns = exports.firstColumns = {
    course: {
        key: 'courseStyleName',
        header: 'course',
        cell: function cell(_ref3) {
            var courseStyleName = _ref3.courseStyleName,
                courseUid = _ref3.courseUid,
                courseComment = _ref3.courseComment;
            return _jsx(_ProfileLink.CourseLink, {
                courseStyleName: courseStyleName,
                courseUid: courseUid,
                title: courseComment
            });
        },
        sortFn: 'alphabetic'
    },
    distance: {
        key: 'distance',
        sortFn: function sortFn(a, b) {
            return a.distanceYard - b.distanceYard;
        }
    },
    jockey: {
        key: 'jockeyStyleName',
        header: 'jockey',
        cell: function cell(_ref4) {
            var jockeyStyleName = _ref4.jockeyStyleName,
                jockeyShortName = _ref4.jockeyShortName,
                jockeyUid = _ref4.jockeyUid;
            return _jsx(_ProfileLink.JockeyLink, {
                jockeyStyleName: jockeyStyleName,
                jockeyUid: jockeyUid
            }, void 0, _jsx(_Abbr2.default, {
                title: jockeyStyleName,
                breakpoint: 'fromMedium'
            }, void 0, jockeyShortName));
        },
        sortFn: 'byLastName'
    },
    going: {
        key: 'going',
        sortFn: _going.goingSortFn
    },
    month: {
        key: 'monthName',
        header: 'month',
        sortFn: (0, _date.sortByDate)('dateStr', true)
    },
    class: {
        key: 'class',
        header: 'class',
        cell: function cell(_ref5) {
            var cls = _ref5.class;

            var match = cls.match(/^Cl(\d+)$/);
            return match ? 'Class ' + match[1] : cls;
        },
        sortFn: 'alphabetic'
    }
};

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint no-param-reassign: 0 */


var _distance = __webpack_require__(93);

var _date = __webpack_require__(19);

var _object = __webpack_require__(260);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// adding year to month to make it parsible for "new Date()"
var year = (0, _date.getYearFromUtc)();
var addDateStr = function addDateStr(data) {
    return data.map(function (row) {
        return _extends({}, row, { dateStr: row.monthName + ' ' + year });
    });
};

// keys that are calculated as summ of values
var summKeys = ['place1stNumber', 'place2ndNumber', 'place3rdNumber', 'startsNumber', 'netWinPrize', 'netTotalPrize'];

// keys that are calculated as maximum of values
var maxKeys = ['distanceYard', 'bestRpTopspeed', 'bestRpPostmark'];

var createEmptyRow = function createEmptyRow() {
    var row = {};
    [].concat(summKeys, maxKeys).forEach(function (key) {
        row[key] = 0;
    });
    return row;
};

// aggregating data by groups
var aggrData = function aggrData(data, groupKey, raceType) {
    var isDistance = groupKey === 'distanceYard';

    var groupedData = data.reduce(function (acc, item) {
        var group = isDistance ? (0, _distance.distanceMap)(item.distanceYard, raceType) : item[groupKey];

        if (!acc[group]) {
            acc[group] = createEmptyRow();
        }

        summKeys.forEach(function (key) {
            acc[group][key] += item[key];
        });

        maxKeys.forEach(function (key) {
            acc[group][key] = Math.max(item[key], acc[group][key]);
        });

        return acc;
    }, {});

    var newGroupKey = isDistance ? 'distance' : 'going';

    return (0, _object.fromObjToArray)(groupedData, newGroupKey);
};

var transformData = function transformData(_ref, raceType) {
    var month = _ref.month,
        going = _ref.going,
        distance = _ref.distance,
        rest = _objectWithoutProperties(_ref, ['month', 'going', 'distance']);

    return _extends({
        month: addDateStr(month),
        going: aggrData(going, 'goingTypeDesc'),
        distance: aggrData(distance, 'distanceYard', raceType)
    }, rest);
};

exports.default = transformData;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Nav = __webpack_require__(353);

var _Nav2 = _interopRequireDefault(_Nav);

var _Details = __webpack_require__(1142);

var _Details2 = _interopRequireDefault(_Details);

var _MetaData = __webpack_require__(352);

var _MetaData2 = _interopRequireDefault(_MetaData);

var _getDetailsData = __webpack_require__(1144);

var _getDetailsData2 = _interopRequireDefault(_getDetailsData);

var _nameRow = __webpack_require__(1165);

var _nameRow2 = _interopRequireDefault(_nameRow);

var _BestOdds = __webpack_require__(579);

var _BestOdds2 = _interopRequireDefault(_BestOdds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_BestOdds2.default, {});

var HumanPage = function HumanPage(_ref) {
    var data = _ref.data,
        children = _ref.children,
        params = _ref.params;

    var NameRow = _nameRow2.default[params.type];
    var detailsData = (0, _getDetailsData2.default)(data.recordsByType, params.type);
    var _data$externalLinks = data.externalLinks,
        imagesUrl = _data$externalLinks.imagesUrl,
        helpCenterUrl = _data$externalLinks.helpCenterUrl,
        profile = data.profile;


    return _jsx('div', {}, void 0, _jsx(_MetaData2.default, {
        type: params.type,
        page: params.tab ? params.tab : 'form',
        name: profile.styleName
    }), _jsx('section', {}, void 0, _jsx(NameRow, {
        profile: profile,
        imagesHost: imagesUrl
    }), _jsx(_Details2.default, {
        data: detailsData,
        type: params.type
    }), _ref2), _jsx(_Nav2.default, {
        params: params,
        helpUrl: helpCenterUrl
    }), (0, _react.cloneElement)(children, { data: data, params: params }));
};

exports.default = HumanPage;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Select = __webpack_require__(350);

var _Select2 = _interopRequireDefault(_Select);

var _columns = __webpack_require__(1143);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Details = function (_PureComponent) {
    _inherits(Details, _PureComponent);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.onSelect = function (val) {
            _this.setState({ selectValue: +val });
        };

        _this.state = { selectValue: 0 };
        return _this;
    }

    _createClass(Details, [{
        key: 'render',
        value: function render() {
            var selectValue = this.state.selectValue;
            var _props = this.props,
                data = _props.data,
                type = _props.type;

            if (!data.length) {
                return null;
            }

            var _data$selectValue$tit = data[selectValue].title,
                race = _data$selectValue$tit.race,
                season = _data$selectValue$tit.season;

            var isIreSelected = race.includes('IRE');
            var classPrefix = type === 'jockey' ? 'jockey' : 'notJockey';

            return _jsx('div', {
                className: 'mp-details mp-details_' + classPrefix
            }, void 0, _jsx(_Select2.default, {
                value: selectValue,
                options: data.map(function (item) {
                    return item.title.option;
                }),
                onSelect: this.onSelect,
                wrapperClass: 'pp-select_details'
            }, void 0, race, '\xA0', _jsx('span', {
                className: 'mp-details__season'
            }, void 0, season)), _jsx('div', {
                className: 'mp-details__wrapper'
            }, void 0, _jsx(_rpReactTable2.default, {
                data: data[selectValue].rows,
                footerData: data[selectValue].total,
                columns: (0, _columns2.default)(type, isIreSelected),
                uiType: 5,
                initialSortIdx: 0
            })));
        }
    }]);

    return Details;
}(_react.PureComponent);

var rowPropTypes = _propTypes2.default.shape({
    // common:
    groupName: _propTypes2.default.string.isRequired,
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    percent: _propTypes2.default.number,
    placed: _propTypes2.default.number,
    stake: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    totalEarnings: _propTypes2.default.string,
    // jockey:
    '2nd': _propTypes2.default.number,
    '3rd': _propTypes2.default.number,
    '4ths': _propTypes2.default.number,
    winnings: _propTypes2.default.string,
    // trainer & owner
    winsHorses: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    rpr: _propTypes2.default.number
});

exports.default = Details;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _ProfileLink = __webpack_require__(24);

var _StakeCell = __webpack_require__(254);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

var _name = __webpack_require__(195);

var _number = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'wins'
});

var _ref2 = _jsx(_Abbr2.default, {
    title: 'placed'
});

var columns = function columns(type, isIreSelected) {
    var stakeCell = {
        key: 'stake',
        header: (isIreSelected ? '€' : '£') + '1 Stake',
        cell: _StakeCell2.default
    };

    var commonColumns = [{
        key: 'groupName',
        header: ' ',
        sortFn: (0, _name.sortByRaceName)('groupName')
    }, {
        key: 'wins',
        header: function header() {
            return _ref;
        }
    }, {
        key: 'runs',
        header: function header() {
            return _jsx(_Abbr2.default, {
                title: type === 'jockey' ? 'rides' : 'runs'
            });
        }
    }, {
        key: 'percent',
        header: '%'
    }, {
        key: 'placed',
        header: function header() {
            return _ref2;
        }
    }];

    if (type === 'jockey') {
        return commonColumns.concat([{
            key: '2nd'
        }, {
            key: '3rd'
        }, {
            key: '4ths'
        }, {
            key: 'winnings'
        }, {
            key: 'totalEarnings'
        }, _extends({}, stakeCell)]);
    }

    return commonColumns.concat([{
        key: 'winsHorses',
        header: 'winners / horses'
    }, {
        key: 'totalEarnings'
    }, _extends({}, stakeCell), {
        key: 'horseUid',
        header: 'best in category',
        cell: _ProfileLink.HorseLink
    }, {
        key: 'rpr',
        cell: (0, _number.zeroToDash)('rpr')
    }]);
};

exports.default = columns;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(6);

var _getRow = __webpack_require__(1145);

var _getRow2 = _interopRequireDefault(_getRow);

var _getTitle = __webpack_require__(1146);

var _getTitle2 = _interopRequireDefault(_getTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var emptyTable = { total: {} };
var seasonsPeriods = [5, 1];

var getDetailsData = function getDetailsData(apiData, profileType) {
    if (!apiData) {
        return [];
    }

    var data = (0, _lodash.keys)(apiData).map(function (key) {
        return seasonsPeriods.map(function (period) {
            var recordsData = apiData[key][period].data;
            var rows = (0, _lodash.values)(recordsData.recordByRaceType);
            var total = rows.find(function (row) {
                return row.groupName === 'total';
            });

            if (!total) {
                return emptyTable;
            }

            var isIre = key.includes('IRE');

            return {
                rows: (0, _lodash.without)(rows, total).map(function (row) {
                    return (0, _getRow2.default)(row, profileType, isIre);
                }),
                total: (0, _getRow2.default)(total, profileType, isIre),
                title: total.racesNumber && (0, _getTitle2.default)(recordsData.seasonInfo)
            };
        });
    });

    var sortedData = [].concat(_toConsumableArray(data)).sort(function (item1, item2) {
        return item2[0].total.runs - item1[0].total.runs;
    });

    return (0, _lodash.flatten)(sortedData).filter(function (item) {
        return item.total.runs;
    });
};

exports.default = getDetailsData;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(6);

var _money = __webpack_require__(32);

var _name = __webpack_require__(195);

var getRow = function getRow(row, profileType, isIre) {
    var res = {
        groupName: (0, _name.formatRaceName)(row.groupName),
        wins: row.place1stNumber,
        runs: row.racesNumber,
        percent: (0, _lodash.isNumber)(row.winPercent) ? row.winPercent : row.percent,
        placed: row.placed,
        stake: row.stake,
        totalEarnings: isIre ? (0, _money.formatSalePrice)(row.euroTotalPrize, 'EUR') : (0, _money.formatSalePrice)(row.totalPrize, 'GBP')
    };

    if (profileType === 'jockey') {
        return _extends({}, res, {
            '2nd': row.place2ndNumber,
            '3rd': row.place3rdNumber,
            '4ths': row.place4thNumber,
            winnings: isIre ? (0, _money.formatSalePrice)(row.euroWinPrize, 'EUR') : (0, _money.formatSalePrice)(row.winPrize, 'GBP')
        });
    }

    return _extends({}, res, {
        winsHorses: row.winners + '/' + row.horses,
        horseStyleName: row.horseName,
        horseUid: row.horseUid,
        rpr: row.bestRpPostmark
    });
};

exports.default = getRow;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(6);

var _date = __webpack_require__(19);

var getTitle = function getTitle(_ref) {
    var seasonDateBegin = _ref.seasonDateBegin,
        seasonDateEnd = _ref.seasonDateEnd,
        seasonYearBegin = _ref.seasonYearBegin,
        seasonYearEnd = _ref.seasonYearEnd,
        countryCode = _ref.countryCode,
        raceType = _ref.raceType;

    var seasons = seasonYearEnd - seasonYearBegin < 4 ? 'current season' : 'last 5 seasons';
    var dateBegin = (0, _date.formatDate)(seasonDateBegin, 'MMM Y');
    var dateEnd = (0, _date.formatDate)(seasonDateEnd, 'MMM Y');
    var type = raceType === 'jumps' ? raceType : (0, _lodash.capitalize)(raceType);

    var race = countryCode + ' ' + type;
    var season = seasons + ' ' + dateBegin + ' - ' + dateEnd;
    var option = race + ' ' + season;

    return { race: race, season: season, option: option };
};

exports.default = getTitle;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Header = __webpack_require__(1152);

var _Header2 = _interopRequireDefault(_Header);

var _columns = __webpack_require__(1148);

var _columns2 = _interopRequireDefault(_columns);

var _getSinceWin = __webpack_require__(1158);

var _getSinceWin2 = _interopRequireDefault(_getSinceWin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, 'DIFF is the difference between the RPR the horse recorded and their expected RPR');

var Form = function Form(_ref) {
    var _ref$data = _ref.data,
        last14Days = _ref$data.last14Days,
        profile = _ref$data.profile,
        entries = _ref$data.entries,
        bookedRides = _ref$data.bookedRides,
        type = _ref.params.type;
    return _jsx('section', {
        className: 'mp-form mp-form_' + type
    }, void 0, _jsx(_Header2.default, {
        winsRuns: profile[type + 'Last14Days'] || undefined,
        sinceWin: (0, _getSinceWin2.default)(profile.sinceAWin, entries || bookedRides),
        upcomingEntries: !!(entries || bookedRides || []).length,
        profileType: type
    }), _jsx(_rpReactTable2.default, {
        data: last14Days || [],
        columns: (0, _columns2.default)(type),
        initialSortIdx: 0,
        noDataText: 'No form for this ' + type,
        sortable: true
    }), _ref2);
};

var profileLast14Days = _propTypes2.default.shape({
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    percent: _propTypes2.default.number
});

exports.default = Form;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.posSortFn = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _DateCell = __webpack_require__(1151);

var _DateCell2 = _interopRequireDefault(_DateCell);

var _CourseHeader = __webpack_require__(1150);

var _CourseHeader2 = _interopRequireDefault(_CourseHeader);

var _CourseCell = __webpack_require__(1149);

var _CourseCell2 = _interopRequireDefault(_CourseCell);

var _HorseHeader = __webpack_require__(1154);

var _HorseHeader2 = _interopRequireDefault(_HorseHeader);

var _HorseCell = __webpack_require__(1153);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _PosCell = __webpack_require__(1155);

var _PosCell2 = _interopRequireDefault(_PosCell);

var _ProfileLink = __webpack_require__(24);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

var _date = __webpack_require__(19);

var _number = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var posSortFn = exports.posSortFn = function posSortFn(a, b) {
    var outcomeCodeA = a.raceOutcomeCode;
    var outcomeCodeB = b.raceOutcomeCode;

    if (isNaN(outcomeCodeA) && isNaN(outcomeCodeB)) {
        return (0, _date.sortByDate)('raceDatetime')(a, b);
    }
    if (isNaN(outcomeCodeA)) {
        return 1;
    }
    if (isNaN(outcomeCodeB)) {
        return -1;
    }
    if (outcomeCodeA !== outcomeCodeB) {
        return outcomeCodeA - outcomeCodeB;
    }

    return (0, _date.sortByDate)('raceDatetime')(a, b);
};

var columns = function columns(profileType) {
    var _ref = _jsx(_HorseHeader2.default, {
        isJockey: profileType === 'jockey'
    });

    var staff = profileType === 'trainer' ? 'jockey' : 'trainer';

    return [{
        key: 'raceDatetime',
        header: 'date',
        cell: _DateCell2.default,
        sortFn: (0, _date.sortByDate)('raceDatetime')
    }, {
        key: 'courseRpAbbrev3',
        header: _CourseHeader2.default,
        cell: _CourseCell2.default,
        sortFn: 'alphabetic'
    }, {
        key: 'raceOutcomeCode',
        header: 'pos.',
        cell: _PosCell2.default,
        sortFn: posSortFn
    }, {
        key: 'horseStyleName',
        header: function header() {
            return _ref;
        },
        cell: function cell(props) {
            return _react2.default.createElement(_HorseCell2.default, _extends({}, props, { profileType: profileType }));
        },
        sortFn: 'alphabetic'
    }, {
        key: 'oddsDesc',
        header: 'sp',
        sortFn: function sortFn(_ref2, _ref3) {
            var a = _ref2.oddsValue;
            var b = _ref3.oddsValue;
            return a - b;
        }
    }, {
        key: staff + 'ShortName',
        header: staff,
        cell: function cell(rowData) {
            var StaffLink = _ProfileLink2.default[staff];
            return _jsx('span', {}, void 0, _react2.default.createElement(StaffLink, rowData), !!rowData.weightAllowanceLbs && staff === 'jockey' && _jsx('sup', {
                className: 'mp-form__jockeyAllowance'
            }, void 0, rowData.weightAllowanceLbs));
        },
        sortFn: 'byLastName'
    }, {
        key: 'rpPostmark',
        header: 'rpr',
        cell: (0, _number.zeroToDash)('rpPostmark')
    }, {
        key: 'rpPostmarkDifference',
        header: 'diff'
    }];
};

exports.default = columns;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _ProfileLink = __webpack_require__(24);

var _money = __webpack_require__(32);

var _distance = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('wbr', {});

var _ref3 = _jsx('wbr', {});

var _ref4 = _jsx('wbr', {});

var CourseCell = function CourseCell(_ref) {
    var courseStyleName = _ref.courseStyleName,
        courseRpAbbrev3 = _ref.courseRpAbbrev3,
        courseUid = _ref.courseUid,
        raceClass = _ref.raceClass,
        raceDescription = _ref.raceDescription,
        distanceYard = _ref.distanceYard,
        goingTypeServicesDesc = _ref.goingTypeServicesDesc,
        prizeSterling = _ref.prizeSterling;
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.CourseLink, {
        courseStyleName: courseStyleName,
        courseShortName: (0, _lodash.upperFirst)((0, _lodash.toLower)(courseRpAbbrev3)),
        courseUid: courseUid
    }), '\xA0', _ref2, _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, (0, _distance.yardsToFurlongs)(distanceYard), goingTypeServicesDesc), '\xA0', _ref3, _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, raceClass && 'C', raceDescription), '\xA0', _ref4, _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, (0, _money.formatPrize)(prizeSterling)));
};

exports.default = CourseCell;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'Course / Conditions / Prize',
    breakpoint: 'fromMedium'
}, void 0, _jsx('span', {
    className: 'hidden-sm-up'
}, void 0, 'Crs.'), _jsx('span', {
    className: 'hidden-xs-down hidden-md-up'
}, void 0, 'Crs / Class / Type'));

var CrsHeader = function CrsHeader() {
    return _ref;
};

exports.default = CrsHeader;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _get = __webpack_require__(486);

var _get2 = _interopRequireDefault(_get);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ReplayLink = __webpack_require__(576);

var _ReplayLink2 = _interopRequireDefault(_ReplayLink);

var _date = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateCell = function DateCell(props) {
    var isVideoAvailable = !!(0, _get2.default)(props, 'videoDetail[0].finishRaceUid');
    return _jsx('div', {
        className: 'mp-form__dateWrapper'
    }, void 0, isVideoAvailable && _react2.default.createElement(_ReplayLink2.default, props), _jsx(_ResultLink2.default, {
        courseName: props.courseName,
        courseUid: props.courseUid,
        raceDatetime: props.raceDatetime,
        raceInstanceUid: props.raceInstanceUid,
        raceInstanceTitle: props.raceInstanceTitle,
        className: (0, _classnames2.default)('mp-form__date', !isVideoAvailable && 'mp-form__date_withoutVideo')
    }, void 0, (0, _date.formatDate)(props.raceDatetime, 'DDMMM'), _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, (0, _date.formatDate)(props.raceDatetime, 'YY'))));
};

exports.default = DateCell;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WinsRuns = __webpack_require__(1157);

var _WinsRuns2 = _interopRequireDefault(_WinsRuns);

var _SinceWin = __webpack_require__(1156);

var _SinceWin2 = _interopRequireDefault(_SinceWin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h2', {
    className: 'mp-form__title'
}, void 0, 'Last 14 days');

var Header = function Header(_ref) {
    var profileType = _ref.profileType,
        winsRuns = _ref.winsRuns,
        sinceWin = _ref.sinceWin,
        upcomingEntries = _ref.upcomingEntries;
    return _jsx('div', {
        className: 'mp-form__header'
    }, void 0, _ref2, (winsRuns.runs || upcomingEntries) && _jsx('div', {
        className: 'mp-form__info'
    }, void 0, winsRuns.runs ? _react2.default.createElement(_WinsRuns2.default, _extends({ profileType: profileType }, winsRuns)) : null, _react2.default.createElement(_SinceWin2.default, _extends({ profileType: profileType }, sinceWin.flat, { type: 'flat' })), _react2.default.createElement(_SinceWin2.default, _extends({ profileType: profileType }, sinceWin.jumps, { type: 'jumps' }))));
};

Header.defaultProps = {
    winsRuns: {}
};

exports.default = Header;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _formatWeight = __webpack_require__(258);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

var _distance = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseCell = function HorseCell(_ref) {
    var profileType = _ref.profileType,
        courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceInstanceUid = _ref.raceInstanceUid,
        raceDatetime = _ref.raceDatetime,
        rpCloseUpComment = _ref.rpCloseUpComment,
        rpBettingMovements = _ref.rpBettingMovements,
        horseStyleName = _ref.horseStyleName,
        raceOutcomeCode = _ref.raceOutcomeCode,
        winningDistance = _ref.winningDistance,
        distanceToWinner = _ref.distanceToWinner,
        weightCarriedLbs = _ref.weightCarriedLbs,
        horseHeadGear = _ref.horseHeadGear;
    return _jsx(_ResultLink2.default, {
        courseName: courseName,
        courseUid: courseUid,
        raceInstanceUid: raceInstanceUid,
        raceDatetime: raceDatetime,
        raceInstanceTitle: '' + rpCloseUpComment + (rpBettingMovements ? ' (' + rpBettingMovements + ')' : ''),
        cssClass: 'mp-form__disabledOnNarrow',
        showAfter: false
    }, void 0, _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, (0, _distance.formatWinDist)(raceOutcomeCode, winningDistance, distanceToWinner)), horseStyleName, weightCarriedLbs && profileType === 'jockey' && _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, '\xA0', (0, _formatWeight2.default)(weightCarriedLbs)), _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, '\xA0', horseHeadGear));
};

exports.default = HorseCell;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hidden-xs-down'
}, void 0, 'Finishing dist / ');

var _ref3 = _jsx('span', {
    className: 'hidden-xs-down'
}, void 0, ' / weight');

var HorseHeader = function HorseHeader(_ref) {
    var isJockey = _ref.isJockey;
    return _jsx(_Abbr2.default, {
        breakpoint: 'fromMedium',
        title: 'Finishing dist / Horse ' + (isJockey ? '/ weight ' : '') + '/ hdgr'
    }, void 0, _ref2, 'Horse', isJockey && _ref3);
};

exports.default = HorseHeader;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PosCell = function PosCell(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode,
        noOfRunners = _ref.noOfRunners,
        disqualificationDesc = _ref.disqualificationDesc;
    return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, _lodash2.default.toLower(disqualificationDesc) === 'disq' ? 'd' : raceOutcomeCode.trim()), '/', noOfRunners);
};

exports.default = PosCell;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SinceWin = function SinceWin(_ref) {
    var profileType = _ref.profileType,
        days = _ref.days,
        runs = _ref.runs,
        type = _ref.type;
    return profileType === 'owner' || !(days || runs) ? null : _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _jsx('span', {
        className: 'mp-form__stats__label'
    }, void 0, 'Since win ', type, ': '), _jsx('strong', {}, void 0, runs, '\xA0'), profileType === 'jockey' ? 'rides' : 'runs', '\xA0', _jsx('strong', {}, void 0, days, '\xA0'), 'days');
};

exports.default = SinceWin;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'mp-form__stats__label'
}, void 0, 'Wins: ');

var WinsRuns = function WinsRuns(_ref) {
    var profileType = _ref.profileType,
        wins = _ref.wins,
        runs = _ref.runs,
        percent = _ref.percent;
    return _jsx('div', {}, void 0, _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _ref2, _jsx('strong', {}, void 0, wins)), _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _jsx('span', {
        className: 'mp-form__stats__label'
    }, void 0, profileType === 'jockey' ? 'Rides: ' : 'Runs: '), _jsx('strong', {}, void 0, runs)), _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _jsx('strong', {}, void 0, '(', percent, '%)')));
};

exports.default = WinsRuns;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getSinceWin = function getSinceWin(sinsWin, entries) {
    /**
     * Flat:  X, F
     * Jumps: J, B
     */
    var flatCodes = ['X', 'F'];
    var jumpsCodes = ['B', 'J'];

    if (!entries) {
        return sinsWin;
    }

    var isFlatEntries = entries.some(function (entry) {
        return flatCodes.includes(entry.courseTypeCode);
    });
    var isJumpsEntries = entries.some(function (entry) {
        return jumpsCodes.includes(entry.courseTypeCode);
    });

    return {
        flat: isFlatEntries ? sinsWin.flat : null,
        jumps: isJumpsEntries ? sinsWin.jumps : null
    };
};

exports.default = getSinceWin;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _columns = __webpack_require__(1161);

var _columns2 = _interopRequireDefault(_columns);

var _categories = __webpack_require__(569);

var _categories2 = _interopRequireDefault(_categories);

var _categoriesReducer = __webpack_require__(1160);

var _categoriesReducer2 = _interopRequireDefault(_categoriesReducer);

var _storage = __webpack_require__(358);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Horses = function (_FilteringComponent) {
    _inherits(Horses, _FilteringComponent);

    function Horses(props) {
        _classCallCheck(this, Horses);

        var _this = _possibleConstructorReturn(this, (Horses.__proto__ || Object.getPrototypeOf(Horses)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            _this$props$data = _this$props.data,
            horses = _this$props$data.horses,
            profileSeasonInfo = _this$props$data.seasonInfo,
            type = _this$props.params.type;

        var _ref = horses || {},
            seasonInfo = _ref.seasonInfo,
            horsesData = _ref.horses;
        // seasonInfo data absent in horses request data when jockey hasn't current year races
        // but it's available in profile overview request


        var _ref2 = seasonInfo || profileSeasonInfo || {},
            countryCode = _ref2.countryCode,
            raceType = _ref2.raceType;

        var categories = (0, _categories2.default)(countryCode, raceType);

        _this.state = {
            data: horsesData || [],
            loading: false,
            categories: categories,
            fetchError: false
        };

        var columnsSet = type === 'trainer' ? 'trainer' : 'default';
        _this.columns = _columns2.default[columnsSet];
        _this.dataKey = 'horses';
        return _this;
    }

    _createClass(Horses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$params = this.props.params,
                tab = _props$params.tab,
                type = _props$params.type;

            var categories = (0, _storage.getCategories)(tab, type, _categoriesReducer2.default, this.state.categories);
            if (categories) {
                this.onFilterApply(categories);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                loading = _state.loading,
                categories = _state.categories,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'mp-horses'
            }, void 0, categories && _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _categoriesReducer2.default,
                columns: this.columns,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: this.columns,
                loading: loading,
                noDataText: 'No horses found',
                resultsPerPage: 50
            }));
        }
    }]);

    return Horses;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref3) {
        var timePeriod = _ref3.timePeriod,
            raceType = _ref3.raceType;
        var _props$params2 = _this2.props.params,
            type = _props$params2.type,
            id = _props$params2.id;

        return 'filter/' + type + '/' + id + '/horses/' + timePeriod.split('/')[0] + '/' + raceType;
    };
};

Horses.defaultProps = {
    data: {
        horses: {
            seasonInfo: {}
        }
    }
};

Horses.propTypes = {
    data: _propTypes2.default.shape({
        horses: _propTypes2.default.object
    }).isRequired,
    params: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        id: _propTypes2.default.string
    }).isRequired
};

exports.default = Horses;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(569);

var _selection = __webpack_require__(131);

var RACE_TYPE = 'raceType';
var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};
var getCountry = function getCountry(val) {
    return val.match(/GB|IRE/)[0];
};

var timePeriodReducer = function timePeriodReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    var timePeriod = categories.timePeriod;


    if (!(0, _selection.hasValue)(categories[type], value)) {
        return timePeriod;
    }

    if (type === RACE_TYPE) {
        var newRaceType = getRaceType(value);
        if (timePeriod.createdBy.raceType !== newRaceType) {
            return (0, _categories.timePeriodsFactory)(getCountry(value), newRaceType);
        }
    }
    return timePeriod;
};

var raceTypeReducer = function raceTypeReducer(categories) {
    return categories.raceType;
};

var categoriesReducer = function categoriesReducer(categories, action) {
    return {
        raceType: raceTypeReducer(categories),
        timePeriod: timePeriodReducer(categories, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

var _StakeCell = __webpack_require__(254);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = [{
    key: 'horseUid',
    header: 'horse',
    cell: function cell(_ref) {
        var horse = _ref.horse,
            horseName = _ref.horseName,
            horseUid = _ref.horseUid;
        return _jsx(_ProfileLink.HorseLink, {
            horseStyleName: horse || horseName,
            horseUid: horseUid
        });
    }
}, {
    key: 'trainerStyleName',
    header: 'trainer',
    cell: function cell(_ref2) {
        var trainerName = _ref2.trainerName,
            trainerUid = _ref2.trainerUid;
        return _jsx(_ProfileLink.TrainerLink, {
            trainerStyleName: trainerName,
            trainerUid: trainerUid
        });
    }
}, {
    key: 'place1stNumber',
    header: 'wins'
}, {
    key: 'racesNumber',
    header: 'runs'
}, {
    key: 'rpr'
}, {
    key: 'totalPrize',
    header: 'total earnings',
    cell: function cell(_ref3) {
        var totalPrize = _ref3.totalPrize;
        return (0, _money.formatMoney)(totalPrize);
    }
}, {
    key: 'winPrize',
    header: 'winnings',
    cell: function cell(_ref4) {
        var winPrize = _ref4.winPrize;
        return (0, _money.formatMoney)(winPrize);
    }
}, {
    key: 'stake',
    header: '£1 stake',
    cell: _StakeCell2.default
}];

var ownerColumn = {
    key: 'ownerStyleName',
    header: 'owner',
    cell: _ProfileLink.OwnerLink
};

var columnsSet = {
    set default(cols) {
        this.default = cols;
    },
    get default() {
        delete this.default;

        this.default = columns;

        return this.default;
    },
    set trainer(cols) {
        this.trainer = cols;
    },
    get trainer() {
        delete this.trainer;
        var trainerColumnIndex = columns.findIndex(function (c) {
            return c.header === 'trainer';
        });
        columns[trainerColumnIndex] = ownerColumn;
        this.trainer = columns;

        return this.trainer;
    }
};

exports.default = columnsSet;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _lodash2 = _interopRequireDefault(_lodash);

var _formatWeight = __webpack_require__(258);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flatLicences = { P: 'Flat', A: 'Apprentice', M: 'Amateur', X: 'Retired' };

var jumpLicences = {
    P: { IRE: 'Jumps', GB: 'Jumps' },
    C: { IRE: 'Claiming Professional', GB: 'Conditional' },
    M: { IRE: 'Amateur', GB: 'Amateur' },
    X: { IRE: 'Retired', GB: 'Retired' }
};

var JockeyNameRow = function JockeyNameRow(_ref) {
    var _ref$profile = _ref.profile,
        styleName = _ref$profile.styleName,
        flat = _ref$profile.flatJockeyTypeCode,
        jump = _ref$profile.jumpJockeyTypeCode,
        country = _ref$profile.countryCode,
        weight = _ref$profile.lowestRidingWeight;

    var licenceNames = [flatLicences[flat], jump && jumpLicences[jump][country]];
    var licence = (0, _lodash2.default)(licenceNames).compact().uniq().join(' & ');

    return _jsx('div', {
        className: 'mp-nameRow'
    }, void 0, _jsx('div', {
        className: 'mp-nameRow__block'
    }, void 0, _jsx('h1', {
        className: 'mp-nameRow__name'
    }, void 0, styleName), licence && _jsx('h2', {
        className: 'mp-nameRow__licenceRow'
    }, void 0, 'Licence\xA0', _jsx('span', {
        className: 'mp-nameRow__licence'
    }, void 0, licence)), _jsx('div', {
        className: 'mp-nameRow__weightRow'
    }, void 0, 'Lowest riding weight in last 12 months\xA0', _jsx('div', {
        className: 'mp-nameRow__weight'
    }, void 0, weight ? (0, _formatWeight2.default)(weight) : null))));
};

exports.default = JockeyNameRow;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = __webpack_require__(572);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OwnerNameRow = function OwnerNameRow(_ref) {
    var _ref$profile = _ref.profile,
        styleName = _ref$profile.styleName,
        silkImagePath = _ref$profile.silkImagePath,
        imagesHost = _ref.imagesHost;
    return _jsx('div', {
        className: 'mp-nameRow'
    }, void 0, _jsx(_Image2.default, {
        src: imagesHost + '/png_silks/' + silkImagePath + '.png',
        imgHost: imagesHost,
        imgClass: 'mp-nameRow__silk',
        alt: 'owner details'
    }), _jsx('h1', {
        className: 'mp-nameRow__name'
    }, void 0, styleName));
};

exports.default = OwnerNameRow;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'mp-nameRow__rtfText'
}, void 0, 'Horses running to');

var _ref3 = _jsx('span', {
    className: 'mp-nameRow__rtfText'
}, void 0, 'form in last 14 days');

var TrainerNameRow = function TrainerNameRow(_ref) {
    var _ref$profile = _ref.profile,
        styleName = _ref$profile.styleName,
        trainerLocation = _ref$profile.trainerLocation,
        runningToForm = _ref$profile.runningToForm;
    return _jsx('div', {
        className: 'mp-nameRow mp-nameRow_trainer'
    }, void 0, _jsx('div', {
        className: 'mp-nameRow__nameBlock'
    }, void 0, _jsx('h1', {
        className: 'mp-nameRow__name'
    }, void 0, styleName), _jsx('span', {
        className: 'mp-nameRow__location'
    }, void 0, trainerLocation)), (0, _lodash.isNumber)(runningToForm) && _jsx('div', {
        className: 'mp-nameRow__rtfBlock'
    }, void 0, _jsx('span', {
        className: 'mp-nameRow__rtfPercentage'
    }, void 0, 'RTF ', Math.round(runningToForm), '%'), _ref2, _ref3));
};

exports.default = TrainerNameRow;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _JockeyNameRow = __webpack_require__(1162);

var _JockeyNameRow2 = _interopRequireDefault(_JockeyNameRow);

var _OwnerNameRow = __webpack_require__(1163);

var _OwnerNameRow2 = _interopRequireDefault(_OwnerNameRow);

var _TrainerNameRow = __webpack_require__(1164);

var _TrainerNameRow2 = _interopRequireDefault(_TrainerNameRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    jockey: _JockeyNameRow2.default,
    owner: _OwnerNameRow2.default,
    trainer: _TrainerNameRow2.default
};

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _Accordion = __webpack_require__(1174);

var _Accordion2 = _interopRequireDefault(_Accordion);

var _BigRaceWins = __webpack_require__(1167);

var _BigRaceWins2 = _interopRequireDefault(_BigRaceWins);

var _StatsTable = __webpack_require__(1169);

var _StatsTable2 = _interopRequireDefault(_StatsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactTable.NoData, {
    text: 'No stats found'
});

var Stats = function Stats(_ref) {
    var _ref$data = _ref.data,
        bigRaceWins = _ref$data.bigRaceWins,
        stats = _ref$data.stats,
        params = _ref.params;
    return _jsx('section', {}, void 0, _jsx(_Accordion2.default, {
        header: 'stats',
        initialExpanded: true
    }, void 0, stats ? _jsx(_StatsTable2.default, {
        data: stats,
        params: params
    }) : _ref2), _jsx(_Accordion2.default, {
        header: 'big race wins'
    }, void 0, _jsx(_BigRaceWins2.default, {
        data: bigRaceWins,
        type: params.type
    })));
};

Stats.defaultProps = {
    data: {
        stats: {
            seasonInfo: {}
        },
        bigRaceWins: []
    }
};

exports.default = Stats;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1168);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BigRaceWins = function BigRaceWins(_ref) {
    var data = _ref.data,
        type = _ref.type;
    return _jsx('div', {
        className: 'mp-bigRaceWins'
    }, void 0, _jsx(_rpReactTable2.default, {
        data: data,
        columns: (0, _columns2.default)(type),
        initialSortIdx: 0,
        noDataText: 'No big race wins',
        resultsPerPage: 50
    }));
};

exports.default = BigRaceWins;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(32);

var _date = __webpack_require__(19);

var _ResultLink = __webpack_require__(82);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(type) {
    return [{
        key: 'raceDate',
        header: 'date',
        cell: function cell(_ref) {
            var raceDate = _ref.raceDate;
            return (0, _date.formatDate)(raceDate, 'DDMMMYY');
        },
        sortFn: (0, _date.sortByDate)('raceDate')
    }, {
        key: 'raceInstanceTitle',
        header: 'race name',
        cell: function cell(rowData) {
            return _react2.default.createElement(
                _ResultLink2.default,
                rowData,
                rowData.raceInstanceTitle
            );
        }
    }, {
        key: 'horseStyleName',
        header: 'horse',
        cell: _ProfileLink.HorseLink
    }, type === 'trainer' ? {
        key: 'jockeyStyleName',
        header: 'jockey',
        cell: _ProfileLink.JockeyLink
    } : {
        key: 'trainerStyleName',
        header: 'trainer',
        cell: _ProfileLink.TrainerLink
    }, {
        key: 'prizeSterling',
        header: 'winnings',
        cell: function cell(_ref2) {
            var prizeSterling = _ref2.prizeSterling;
            return (0, _money.formatMoney)(prizeSterling);
        }
    }];
}; /* eslint react/prop-types: 0 */
exports.default = columns;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(22);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(6);

var _Filter = __webpack_require__(114);

var _Filter2 = _interopRequireDefault(_Filter);

var _categoriesReducer = __webpack_require__(1170);

var _categoriesReducer2 = _interopRequireDefault(_categoriesReducer);

var _categories = __webpack_require__(570);

var _columns = __webpack_require__(1171);

var _filter = __webpack_require__(116);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(66);

var _storage = __webpack_require__(358);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stats = function (_FilteringComponent) {
    _inherits(Stats, _FilteringComponent);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data = props.data,
            statistics = _props$data.statistics,
            statisticalSummary = _props$data.statisticalSummary,
            seasonInfo = _props$data.seasonInfo,
            seasonsAvailable = _props$data.seasonsAvailable;


        var categories = (0, _categories.categoriesFactory)(seasonInfo.countryCode, seasonInfo.raceType, props.params.type, seasonsAvailable);
        var status = (0, _categories.statusFactory)(categories);

        _this.state = {
            tableData: statistics || statisticalSummary || [],
            loading: false,
            fetchError: false,
            categories: categories,
            status: status
        };
        return _this;
    }

    _createClass(Stats, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$params = this.props.params,
                tab = _props$params.tab,
                type = _props$params.type;

            var categories = (0, _storage.getCategories)(tab, type, _categoriesReducer2.default, this.state.categories);
            if (categories) {
                this.onFilterApply(categories);
            }
        }
    }, {
        key: 'renderStatus',
        value: function renderStatus() {
            var _state$status = this.state.status,
                raceType = _state$status.raceType,
                displayBy = _state$status.displayBy,
                timePeriod = _state$status.timePeriod,
                advanced = _state$status.advanced;

            var displayByParts = displayBy.split('(');
            var displayByGeneral = (0, _lodash.toLower)(displayByParts[0].trim());
            var displayByDesc = displayByParts[1];
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceType, ',\xA0', timePeriod, ',\xA0', _jsx('strong', {}, void 0, 'displayed by ', displayByGeneral), '\xA0', displayByDesc ? '(' + displayByDesc : null, advanced ? _jsx('span', {}, void 0, '(', advanced, ')') : null, '\xA0');
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                tableData = _state.tableData,
                loading = _state.loading,
                categories = _state.categories,
                fetchError = _state.fetchError;


            var dynamicColumn = (0, _columns.createDynamicColumn)(categories);

            var isIre = _filter3.selection.getValue(categories, 'raceType').includes('IRE');
            var statsCols = [dynamicColumn].concat(_toConsumableArray((0, _columns.statsColumns)(isIre)));

            var overall = tableData.find(function (row) {
                return row.groupName === 'OVERALL';
            });
            var statsData = (0, _lodash.without)(tableData, overall);

            return _jsx('div', {
                className: 'mp-statsTable'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _categoriesReducer2.default,
                columns: statsCols,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: statsData || [],
                footerData: overall,
                columns: statsCols,
                sortable: true,
                noDataText: 'No stats found',
                initialSortIdx: 0,
                loading: loading
            }));
        }
    }]);

    return Stats;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onDataReceive = function (_ref) {
        var _ref$data = _ref.data,
            statistics = _ref$data.statistics,
            statisticalSummary = _ref$data.statisticalSummary;
        var categories = _this2.state.categories;

        var selectedAdvanced = _filter3.selection.getValue(categories, 'advanced');
        var selectedDisplayBy = _filter3.selection.getValue(categories, 'displayBy');

        var tableData = [];
        if (selectedDisplayBy === 'age-of-horse' || selectedDisplayBy === 'race-category') {
            tableData = (0, _lodash.flatten)(Object.values(statistics));
        } else {
            tableData = (statistics ? statistics[(0, _lodash.toUpper)(selectedAdvanced)] : statisticalSummary) || [];
        }

        _this2.setState({
            tableData: tableData,
            loading: false,
            status: (0, _categories.statusFactory)(categories)
        });
    };

    this.buildUrl = function (_ref2) {
        var timePeriod = _ref2.timePeriod,
            raceType = _ref2.raceType,
            displayBy = _ref2.displayBy;
        var _props$params2 = _this2.props.params,
            id = _props$params2.id,
            type = _props$params2.type;

        var commonPart = 'filter/' + type + '/' + id + '/stats';

        var years = timePeriod.split('/').slice(0, 2).join('/');
        if (displayBy === 'year' || displayBy === 'season') {
            return commonPart + '/summary/' + years + '/' + raceType;
        }
        var racingTypeWithDisplayBy = raceType.match(/turf|aw/) ? raceType.replace(/(turf|aw)/g, displayBy + '/$1') : raceType + '/' + displayBy;

        return commonPart + '/statistics/' + years + '/' + racingTypeWithDisplayBy;
    };
};

var statsPros = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    euroTotalPrize: _propTypes2.default.number,
    euroWinPrize: _propTypes2.default.number,
    place1stNumber: _propTypes2.default.number,
    place2ndNumber: _propTypes2.default.number,
    place3rdNumber: _propTypes2.default.number,
    place4thNumber: _propTypes2.default.number,
    raceNumber: _propTypes2.default.number,
    seasonEndDate: _propTypes2.default.string,
    seasonStartDate: _propTypes2.default.string,
    stake: _propTypes2.default.number,
    totalPrize: _propTypes2.default.number,
    winPercent: _propTypes2.default.number,
    winPrize: _propTypes2.default.number
}));

Stats.propTypes = {
    data: _propTypes2.default.shape({
        stats: statsPros,
        statsResponse: statsPros,
        seasonInfo: _propTypes2.default.shape({
            raceType: _propTypes2.default.string.isRequired,
            countryCode: _propTypes2.default.string.isRequired,
            seasonStartDate: _propTypes2.default.string,
            seasonEndDate: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired,
    params: _propTypes2.default.shape({
        id: _propTypes2.default.string,
        type: _propTypes2.default.string
    }).isRequired
};

exports.default = Stats;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filter = __webpack_require__(66);

var _categories = __webpack_require__(570);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};
var getCountry = function getCountry(val) {
    return val.match(/GB|IRE/)[0];
};
var hasValue = _filter.selection.hasValue,
    getValue = _filter.selection.getValue;


var RACE_TYPE = 'raceType';
var DISPLAY_BY = 'displayBy';

/**
 * Time periods format should change in the following way:
 * for flat - YYYY,
 * for jumps - YYYY-YY
 */
var timePeriodReducer = function timePeriodReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    var timePeriod = categories.timePeriod;
    var seasonsAvailable = timePeriod.seasonsAvailable;
    var getRaceTypeStartYear = _filter.timePeriods.getRaceTypeStartYear,
        getCurrentSeasonEndYear = _filter.timePeriods.getCurrentSeasonEndYear,
        getPeriods = _filter.timePeriods.getPeriods,
        getAll = _filter.timePeriods.getAll,
        getCurrent = _filter.timePeriods.getCurrent,
        getLast5 = _filter.timePeriods.getLast5;


    if (!hasValue(categories[type], value)) {
        return categories.timePeriod;
    }

    if (type === RACE_TYPE) {
        var nextRaceType = getRaceType(value);
        var country = getCountry(value);
        var startYear = getRaceTypeStartYear(nextRaceType, country, seasonsAvailable);
        var endYear = getCurrentSeasonEndYear(nextRaceType, country);
        var lastFivePeriods = getPeriods(endYear - 1, endYear - 6, nextRaceType);
        var newOptions = [getAll(startYear, endYear), getCurrent(endYear, nextRaceType), getLast5(endYear, nextRaceType)].concat(_toConsumableArray(lastFivePeriods));
        newOptions[0].selected = true;
        return _extends({}, timePeriod, {
            options: newOptions,
            title: 'time period',
            createdBy: {
                raceType: nextRaceType
            }
        });
    }
    return timePeriod;
};
/**
 * Display by options should change alongside with race type,
 * for race type specific Display by options see ./categories.js
 *
 * If selected display by option is present for jumps and flat race types -
 * keep it selected and vice versa.
 */
var displayByReducer = function displayByReducer(categories, _ref2) {
    var type = _ref2.type,
        value = _ref2.value;

    if (!hasValue(categories[type], value)) {
        return categories.displayBy;
    }

    if (type === RACE_TYPE) {
        var raceType = getRaceType(value);
        var country = getCountry(value);
        var displayBy = categories.displayBy;

        return (0, _categories.displayByFactory)(country, raceType, categories.displayBy.createdBy.humanType, displayBy.options.find(function (o) {
            return o.selected;
        }).value);
    }
    return categories.displayBy;
};
/**
 * Race type does not depend on other selected values.
 */
var raceTypeReducer = function raceTypeReducer(categories) {
    return categories.raceType;
};
/**
 * Advanced options should be shown only if value,
 * selected in display by category is present for
 * flat and jumps race types.
 *
 * If race type changes and generic display by value is selected -
 * race type specific advanced options should be added to advanced category
 */
var advancedReducer = function advancedReducer(categories, _ref3) {
    var type = _ref3.type,
        value = _ref3.value;

    if (!hasValue(categories[type], value)) {
        return categories.advanced;
    }

    var humanType = categories.displayBy.createdBy.humanType;
    switch (type) {
        case DISPLAY_BY:
            {
                var selectedType = getValue(categories, RACE_TYPE);
                var raceType = getRaceType(selectedType);
                var country = getCountry(selectedType);

                return (0, _categories.advancedFactory)(country, raceType, value, humanType);
            }

        case RACE_TYPE:
            {
                var _raceType = getRaceType(value);
                var _country = getCountry(value);
                var displayBy = getValue(categories, DISPLAY_BY);

                return (0, _categories.advancedFactory)(_country, _raceType, displayBy, humanType);
            }

        default:
            return categories.advanced;

    }
};
/**
 * Reducers composition
 */
var categoriesReducer = function categoriesReducer(categories, action) {
    return {
        raceType: raceTypeReducer(categories),
        displayBy: displayByReducer(categories, action),
        timePeriod: timePeriodReducer(categories, action),
        advanced: advancedReducer(categories, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDynamicColumn = exports.statsColumns = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(6);

var _StakeCell = __webpack_require__(254);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

var _money = __webpack_require__(32);

var _ProfileLink = __webpack_require__(24);

var _date = __webpack_require__(19);

var _name = __webpack_require__(195);

var _distance = __webpack_require__(93);

var _filter = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statsColumns = exports.statsColumns = function statsColumns(isIre) {
    return [{
        key: 'place1stNumber',
        header: 'wins'
    }, {
        key: 'racesNumber',
        header: 'runs'
    }, {
        key: 'winPercent',
        header: '%'
    }, {
        key: 'place2ndNumber',
        header: '2nd'
    }, {
        key: 'place3rdNumber',
        header: '3rd'
    }, {
        key: 'place4thNumber',
        header: '4th'
    }, {
        key: (isIre ? 'euroT' : 't') + 'otalPrize',
        header: 'total earnings',
        cell: function cell(_ref) {
            var totalPrize = _ref.totalPrize,
                euroTotalPrize = _ref.euroTotalPrize;
            return isIre ? (0, _money.formatSalePrice)(euroTotalPrize, 'EUR') : (0, _money.formatSalePrice)(totalPrize, 'GBP');
        }
    }, {
        key: 'stake',
        header: (isIre ? '€' : '£') + '1 stake',
        cell: _StakeCell2.default
    }];
};

var columns = {
    year: {
        header: 'year',
        key: 'seasonEndDate',
        cell: function cell(_ref2) {
            var seasonEndDate = _ref2.seasonEndDate;
            return (0, _date.formatDate)(seasonEndDate, 'YYYY');
        },
        sortFn: (0, _date.sortByDate)('seasonEndDate')
    },
    season: {
        header: 'season',
        key: 'seasonEndDate',
        cell: function cell(_ref3) {
            var seasonEndDate = _ref3.seasonEndDate,
                seasonStartDate = _ref3.seasonStartDate;
            return (0, _date.formatDate)(seasonStartDate, 'YYYY') + '-' + (0, _date.formatDate)(seasonEndDate, 'YY');
        },
        sortFn: (0, _date.sortByDate)('seasonEndDate')
    },
    course: {
        header: 'course',
        key: 'groupName',
        cell: function cell(_ref4) {
            var groupName = _ref4.groupName,
                groupId = _ref4.groupId;
            return _jsx(_ProfileLink.CourseLink, {
                courseStyleName: groupName,
                courseUid: groupId
            });
        },
        sortFn: 'alphabetic'
    },
    distance: {
        header: 'distance',
        key: 'groupName',
        sortFn: 'alphabetic'
    },
    month: {
        header: 'month',
        key: 'groupName',
        sortFn: (0, _date.sortByRecentMonth)('groupName')
    },
    raceType: {
        header: 'race class',
        key: 'groupName',
        sortFn: (0, _name.sortByRaceName)('groupName')
    },
    raceCategory: {
        header: 'race type',
        key: 'groupName',
        sortFn: 'alphabetic'
    },
    ageOfHorse: {
        header: 'age of horse',
        key: 'groupName',
        sortFn: 'alphabetic'
    },
    jockey: {
        header: 'jockey',
        key: 'groupName',
        cell: function cell(_ref5) {
            var groupName = _ref5.groupName,
                groupId = _ref5.groupId;
            return _jsx(_ProfileLink.JockeyLink, {
                jockeyStyleName: groupName,
                jockeyUid: groupId
            });
        },
        sortFn: 'byLastName'
    },
    trainer: {
        header: 'trainer',
        key: 'groupName',
        cell: function cell(_ref6) {
            var groupName = _ref6.groupName,
                groupId = _ref6.groupId;
            return _jsx(_ProfileLink.TrainerLink, {
                trainerStyleName: groupName,
                trainerUid: groupId
            });
        },
        sortFn: 'byLastName'
    }
};

var createDynamicColumn = exports.createDynamicColumn = function createDynamicColumn(categories) {
    var displayBy = (0, _lodash.camelCase)(_filter.selection.getValue(categories, 'displayBy'));
    var column = columns[displayBy];

    if (displayBy !== 'month' && displayBy !== 'distance') {
        return column;
    }

    var raceType = _filter.selection.getValue(categories, 'raceType').match(/flat|jumps/)[0];

    if (displayBy === 'month') {
        var isFlat = raceType === 'flat';

        var selectedTimePeriod = _filter.selection.getValueWithSuffix(categories, 'timePeriod');
        var periodOption = selectedTimePeriod.split('/')[2];
        var isSameYear = periodOption !== 'last5' && periodOption !== 'all';

        return isSameYear && isFlat ? _extends({}, column, {
            cell: function cell(_ref7) {
                var groupName = _ref7.groupName;
                return groupName.split(' ')[0];
            }
        }) : column;
    }

    // distance
    return _extends({}, column, {
        cell: function cell(_ref8) {
            var groupName = _ref8.groupName;
            return (0, _distance.mapYardGroups)(groupName, raceType);
        }
    });
};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpAdvertising = __webpack_require__(535);

var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setTargeting = function setTargeting(targetingStr) {
    var UPDATE_TARGETING = 'updateTargeting';

    if (targetingStr) {
        (0, _rpAdvertising2.default)({
            targeting: [targetingStr],
            targetingEvent: UPDATE_TARGETING
        });
    } else {
        (0, _rpAdvertising2.default)();
    }
};

var initAds = function initAds() {
    var paddyPowerDomain = 'paddypower.com';
    var _document = document,
        referrer = _document.referrer;


    if (referrer.includes(paddyPowerDomain)) {
        setTargeting('paddypower');
    } else {
        setTargeting();
    }
};

exports.default = initAds;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpPricesComponent = __webpack_require__(2263);

var _BetslipInteracter = __webpack_require__(1198);

var _BetslipInteracter2 = _interopRequireDefault(_BetslipInteracter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initPrices() {
    var customizeSettings = _jquery2.default.cookie('customizeSettings');
    var showPrices = false;

    try {
        showPrices = JSON.parse(customizeSettings).showPrices;
    } catch (e) {
        console.warn(e);
    }

    if (showPrices) {
        /* eslint-disable no-new */
        new _rpPricesComponent.BestOdds();
        new _rpPricesComponent.BetHandler();
        /* eslint-enable no-new */

        _rpPricesComponent.priceButton.activate();
        var betslipInteracter = new _BetslipInteracter2.default();
        betslipInteracter.init().then(function (betslipFeedName) {
            return _rpPricesComponent.pricesProvider.init(betslipFeedName);
        });
    }
}

exports.default = initPrices;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'minus',
    size: 'Medium',
    className: 'ui-icon accordionMinus ui-accordion__arrow'
});

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'plus',
    size: 'Medium',
    className: 'ui-icon accordionPlus ui-accordion__arrow'
});

var Accordion = function (_PureComponent) {
    _inherits(Accordion, _PureComponent);

    function Accordion(props) {
        _classCallCheck(this, Accordion);

        var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

        _this.toggleExpandedState = function () {
            _this.setState({ expanded: !_this.state.expanded });
        };

        _this.state = {
            expanded: props.initialExpanded
        };
        return _this;
    }

    _createClass(Accordion, [{
        key: 'render',
        value: function render() {
            var expanded = this.state.expanded;
            var _props = this.props,
                header = _props.header,
                children = _props.children;

            var className = (0, _classnames2.default)('ui-accordion__header', expanded && 'ui-accordion__header_active');

            return _jsx('section', {
                className: 'ui-accordion__row'
            }, void 0, _jsx('button', {
                className: className,
                onClick: this.toggleExpandedState
            }, void 0, _jsx('h2', {
                className: 'ui-accordion__title'
            }, void 0, header), _ref, _ref2), expanded && _jsx('div', {
                className: 'ui-accordion__content'
            }, void 0, children));
        }
    }]);

    return Accordion;
}(_react.PureComponent);

Accordion.defaultProps = {
    initialExpanded: false
};

exports.default = Accordion;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('p', {
    className: 'pp-fetchError__text'
}, void 0, 'There\'s a technical issue that means we are currently unable to retrieve this data.');

var _ref3 = _jsx('p', {
    className: 'pp-fetchError__text'
}, void 0, 'We are working to resolve this and expect service to return to normal shortly.');

var _ref4 = _jsx('p', {
    className: 'pp-fetchError__text'
}, void 0, 'Apologies for any inconvenience this has caused.');

var FetchError = function FetchError(_ref) {
    var refresh = _ref.refresh;
    return _jsx('div', {
        className: 'pp-fetchError'
    }, void 0, _ref2, _ref3, _jsx('p', {
        className: 'pp-fetchError__text'
    }, void 0, 'Your page should refresh in 20 seconds. If it does not refresh please click\xA0', _jsx('button', {
        className: 'ui-link',
        onClick: refresh
    }, void 0, 'here'), '.'), _ref4);
};

exports.default = FetchError;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _reactDom = __webpack_require__(91);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_PureComponent) {
    _inherits(Popover, _PureComponent);

    function Popover(props) {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

        _this.onOutsideClick = function (event) {
            var domNode = (0, _reactDom.findDOMNode)(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        };

        _this.closePopover = function () {
            _this.setState({ expanded: false });
        };

        _this.openPopover = function () {
            _this.setState({ expanded: true });
        };

        _this.togglePopover = function (e) {
            if (_this.state.expanded) {
                _this.closePopover(e);
            } else {
                _this.openPopover(e);
            }
        };

        _this.state = { expanded: false };
        return _this;
    }

    _createClass(Popover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }]);

    return Popover;
}(_react.PureComponent);

exports.default = Popover;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntriesHorseLink = function EntriesHorseLink(_ref) {
    var damCountryCode = _ref.damCountryCode,
        damName = _ref.damName,
        damUid = _ref.damUid,
        horseAge = _ref.horseAge,
        horseCountryCode = _ref.horseCountryCode,
        horseName = _ref.horseName,
        horseUid = _ref.horseUid,
        isDamShown = _ref.isDamShown;
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        horseStyleName: horseName,
        horseUid: horseUid
    }), isDamShown && _jsx('span', {
        className: 'hp-progenyEntries__dam'
    }, void 0, ' (' + horseCountryCode + ') ', horseAge, 'yo\xA0\u2014\xA0', _jsx(_ProfileLink.HorseLink, {
        className: 'hp-progenyEntries__regularLink',
        horseStyleName: damName,
        horseUid: damUid
    }), ' (' + damCountryCode + ')'));
};

exports.default = EntriesHorseLink;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PriceButton = __webpack_require__(580);

var _PriceButton2 = _interopRequireDefault(_PriceButton);

var _RaceCardLink = __webpack_require__(255);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

var _date = __webpack_require__(19);

var _distance = __webpack_require__(93);

var _EntriesHorseLink = __webpack_require__(1177);

var _EntriesHorseLink2 = _interopRequireDefault(_EntriesHorseLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raceStatus = {
    O: 'Overnight',
    C: 'Early closer',
    3: 'Three day',
    4: 'Four day',
    5: 'Five day',
    6: 'Six day'
};

var EntriesRow = function EntriesRow(_ref) {
    var data = _ref.data,
        isHorseShown = _ref.isHorseShown,
        isDamShown = _ref.isDamShown,
        isPriceShown = _ref.isPriceShown;
    var courseStyleName = data.courseStyleName,
        courseUid = data.courseUid,
        raceDatetime = data.raceDatetime,
        raceInstanceTitle = data.raceInstanceTitle,
        raceInstanceUid = data.raceInstanceUid,
        raceStatusCode = data.raceStatusCode,
        raceUid = data.raceUid,
        runningConditions = data.runningConditions,
        distanceYard = data.distanceYard;

    return _jsx('li', {
        className: 'pp-entries__item'
    }, void 0, _jsx('div', {
        className: 'pp-entries__item__wrapper'
    }, void 0, _jsx('div', {
        className: 'pp-entries__item__header'
    }, void 0, _jsx('span', {}, void 0, (0, _date.formatEntryDateTime)(raceDatetime), ' '), isHorseShown && _react2.default.createElement(_EntriesHorseLink2.default, _extends({}, data, {
        isDamShown: isDamShown
    }))), raceStatusCode && '(' + raceStatus[raceStatusCode] + ') ', courseStyleName && 'at ' + courseStyleName + ' ', _jsx(_RaceCardLink2.default, {
        courseName: courseStyleName,
        courseUid: courseUid,
        raceDatetime: raceDatetime,
        raceInstanceUid: raceInstanceUid || raceUid
    }, void 0, raceInstanceTitle), runningConditions && ' (' + runningConditions + ')', distanceYard && ' (' + (0, _distance.yardsToFurlongs)(distanceYard) + ')'), isPriceShown && _react2.default.createElement(_PriceButton2.default, data));
};

exports.default = EntriesRow;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(6);

var _filter = __webpack_require__(66);

var _storage = __webpack_require__(358);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var humans = ['jockey', 'trainer', 'owner'];

var FilteringComponent = function (_PureComponent) {
    _inherits(FilteringComponent, _PureComponent);

    function FilteringComponent(props) {
        _classCallCheck(this, FilteringComponent);

        // key for getting data from API request
        var _this = _possibleConstructorReturn(this, (FilteringComponent.__proto__ || Object.getPrototypeOf(FilteringComponent)).call(this, props));

        _this.onDataReceive = function (data) {
            _this.setState({
                data: (0, _lodash.get)(data, 'data.' + _this.dataKey, _this.emptyData),
                loading: false
            });
        };

        _this.onDataError = function (error) {
            console.warn(error);
            _this.setState({ data: _this.emptyData, loading: false, fetchError: true });
        };

        _this.onFilterApply = function (categories) {
            _this.setState({ categories: categories, loading: true, fetchError: false });

            var selectedValues = _filter.selection.getValues(categories);
            var requestUri = _this.buildUrl(selectedValues);

            var params = _this.props.params;


            if (params && params.tab && params.type && humans.includes(params.type)) {
                (0, _storage.setCategories)(params.tab, params.type, categories);
            }

            _axios2.default.get(requestUri).then(function (_ref) {
                var data = _ref.data;
                return _this.onDataReceive(data);
            }).catch(_this.onDataError);
        };

        _this.buildUrl = function (_ref2) {
            var timePeriod = _ref2.timePeriod,
                raceType = _ref2.raceType,
                raceCategory = _ref2.raceCategory;
            var _this$props$params = _this.props.params,
                type = _this$props$params.type,
                id = _this$props$params.id,
                tab = _this$props$params.tab;

            var uriValues = [timePeriod, raceType, raceCategory];
            return type + '/filter/' + (tab || _this.tab) + '/' + id + '/' + (0, _lodash.compact)(uriValues).join('/');
        };

        _this.dataKey = '';

        // default value that would be passed if response
        // will come with empty data[dataKey]
        _this.emptyData = [];
        return _this;
    }

    // handle received from server data


    // handle received from server error


    // when button "Apply" are clicked we need to save new categories


    // default way to building uri string


    _createClass(FilteringComponent, [{
        key: 'renderStatus',


        // default way to build filter status
        value: function renderStatus() {
            var labels = _filter.selection.getCaptions(this.state.categories);
            var statusText = Object.values(labels).join(', ');
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, statusText);
        }
    }]);

    return FilteringComponent;
}(_react.PureComponent);

exports.default = FilteringComponent;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleSelected = function toggleSelected(arr, value) {
    if (!arr.some(function (option) {
        return option.value === value;
    })) {
        return arr;
    }

    return arr.map(function (item) {
        if (item.value === value) {
            return _extends({}, item, { selected: true });
        }
        if (item.selected) {
            return _extends({}, item, { selected: false });
        }
        return item;
    });
};

var setSelectReducer = function setSelectReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    return _extends({}, categories, _defineProperty({}, type, _extends({}, categories[type], {
        options: toggleSelected(categories[type].options, value)
    })));
};

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
var updateCategories = function updateCategories(categories, reducer, action) {
    return setSelectReducer(reducer(categories, action), action);
};

exports.default = updateCategories;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shortid = __webpack_require__(331);

var _shortid2 = _interopRequireDefault(_shortid);

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _rpNavigation = __webpack_require__(248);

var _rpAnalytics = __webpack_require__(130);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _analyticsPage = __webpack_require__(336);

var _HorseTrackerButton = __webpack_require__(1182);

var _HorseTrackerButton2 = _interopRequireDefault(_HorseTrackerButton);

var _ErrorModal = __webpack_require__(571);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

var _helpers = __webpack_require__(1183);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref5 = _jsx('span', {}, void 0, ' You\'ve reached your limit of 1,000 horses. To add this horse to your tracker please go to ', _jsx('a', {
    className: 'ui-link',
    target: '_blank',
    rel: 'noopener noreferrer',
    href: '/horse-tracker/'
}, void 0, ' Horse Tracker '), ' and remove some horses.');

var HorseTracker = function (_PureComponent) {
    _inherits(HorseTracker, _PureComponent);

    function HorseTracker(props) {
        _classCallCheck(this, HorseTracker);

        var _this = _possibleConstructorReturn(this, (HorseTracker.__proto__ || Object.getPrototypeOf(HorseTracker)).call(this, props));

        _this.onTrack = function () {
            (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, {
                text: "Subscribe to Members' Club and get access to this content and much more",
                r: window.location.origin + '/horse-tracker',
                service: 'both'
            }).then(function (access) {
                if (access) {
                    _axios2.default.get((0, _helpers.getAjaxUrl)(_this.horseUid, 'check')).then(function (_ref) {
                        var data = _ref.data;
                        var alertMe = data.data.alertMe;


                        if (alertMe) {
                            _this.onSuccess('active');
                        } else {
                            _this.trackHorse();
                        }
                    });
                }
            });
        };

        _this.onUntrack = function () {
            _axios2.default.get((0, _helpers.getAjaxUrl)(_this.horseUid, 'untrack')).then(function (_ref2) {
                var data = _ref2.data;
                var result = data.data.result,
                    error = data.error;


                if (error) {
                    _this.onError('untrack');
                }

                if (result) {
                    _this.onSuccess('track');
                    _this.segmentUntrackHorse();
                }
            }).catch(function () {
                return _this.onError('untrack');
            });
        };

        _this.onSuccess = function (buttonKey) {
            _this.setState({ button: buttonKey });
        };

        _this.onError = function (errorKey) {
            _this.setState({ error: errorKey });
        };

        _this.onTracked = function () {
            _this.onSuccess('active');
        };

        _this.onCancel = function () {
            _this.onSuccess('tracked');
        };

        _this.closeErrorModal = function () {
            _this.onError(null);
        };

        _this.trackHorse = function () {
            _axios2.default.get((0, _helpers.getAjaxUrl)(_this.horseUid, 'track')).then(function (_ref3) {
                var data = _ref3.data;
                var result = data.data.result,
                    error = data.error;


                if (error) {
                    if (error.code === 403) {
                        _this.onError('limit');
                    } else {
                        _this.onError('track');
                    }
                }

                if (result) {
                    _this.onSuccess('tracked');
                    _this.segmentTrackHorse();
                }
            }).catch(function () {
                return _this.onError('tracked');
            });
        };

        _this.segmentTrackHorse = function () {
            segmentio.track('Track Horse', { 'Horse Name': (0, _analyticsPage.getHorseName)() });
        };

        _this.segmentUntrackHorse = function () {
            segmentio.track('Untrack Horse', { 'Horse Name': (0, _analyticsPage.getHorseName)() });
        };

        _this.horseUid = _this.props.profile.horseUid;
        _this.state = {
            button: 'pending',
            error: null
        };
        _this.buttons = (0, _helpers.getButtons)(_this.onTrack, _this.onTracked, _this.onCancel);
        _this.controls = (0, _helpers.getControls)(_this.onCancel, _this.onUntrack);
        return _this;
    }

    _createClass(HorseTracker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _rpNavigation.authReady.then(function (auth) {
                if (auth.user.isLoggedIn) {
                    _axios2.default.get((0, _helpers.getAjaxUrl)(_this2.horseUid, 'check')).then(function (_ref4) {
                        var data = _ref4.data;
                        var alertMe = data.data.alertMe;


                        if (alertMe) {
                            _this2.onSuccess('tracked');
                        } else {
                            _this2.onSuccess('track');
                        }
                    }).catch(function () {
                        return _this2.onSuccess('track');
                    });
                } else {
                    _this2.onSuccess('track');
                }
            }).catch(function () {
                return _this2.onSuccess('track');
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var buttonState = this.state.button;
            var shouldShowControls = buttonState === 'active';
            var shouldShowButton = buttonState !== 'pending';
            var errorMessage = _helpers.errorMessages[this.state.error];

            return _jsx('div', {
                className: 'hp-horseTracker'
            }, void 0, shouldShowControls ? _jsx('div', {
                className: 'hp-horseTracker__controls'
            }, void 0, this.controls.map(function (button) {
                return _react2.default.createElement(_HorseTrackerButton2.default, _extends({}, button, { key: _shortid2.default.generate() }));
            })) : null, shouldShowButton ? _react2.default.createElement(_HorseTrackerButton2.default, _extends({}, this.buttons[buttonState], { key: _shortid2.default.generate() })) : null, errorMessage ? _jsx(_ErrorModal2.default, {
                text: errorMessage,
                onClose: this.closeErrorModal
            }, void 0, errorMessage === 'limitError' ? _ref5 : null) : null);
        }
    }]);

    return HorseTracker;
}(_react.PureComponent);

exports.default = HorseTracker;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseTrackerButton = function HorseTrackerButton(_ref) {
    var className = _ref.className,
        label = _ref.label,
        iconName = _ref.iconName,
        onClick = _ref.onClick;
    return _jsx('button', {
        className: (0, _classnames2.default)('hp-horseTracker__button ui-btn ui-btn_primary', className),
        onClick: onClick
    }, void 0, _jsx('span', {
        className: 'hp-horseTracker__label'
    }, void 0, label), iconName ? _jsx(_rpReactSvgIcon2.default, {
        iconName: iconName,
        size: iconName === 'tracker' ? 'Medium' : 'Medium'
    }) : null);
};

exports.default = HorseTrackerButton;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getControls = exports.getControls = function getControls(onCancel, onUntrack) {
    return [{
        className: 'hp-horseTracker__cancel ui-btn_hollow',
        label: 'Cancel',
        onClick: onCancel
    }, {
        className: 'hp-horseTracker__untrack ui-btn_hollow',
        label: 'Untrack',
        onClick: onUntrack
    }];
};

var getButtons = exports.getButtons = function getButtons(onTrack, onTracked, onCancel) {
    return {
        track: {
            className: 'hp-horseTracker__track ui-btn_major',
            label: 'Track Horse',
            iconName: 'tracker',
            onClick: onTrack
        },
        tracked: {
            className: 'hp-horseTracker__tracked ui-btn_hollow',
            label: 'Horse Tracked',
            iconName: 'tick',
            onClick: onTracked
        },
        active: {
            className: 'hp-horseTracker__tracked hp-horseTracker__tracked_active ui-btn_hollow',
            label: 'Horse Tracked',
            iconName: 'tick',
            onClick: onCancel
        }
    };
};

var errorMessages = exports.errorMessages = {
    track: 'Something\'s gone wrong and your horse could\n            not be added to Horse Tracker.\n            Please check you are signed in and try again.',
    untrack: 'Something\'s gone wrong and your horse could\n            not be removed from your Horse Tracker.\n            Please check you are signed in and try again.',
    limit: 'limitError'
};

var getAjaxUrl = exports.getAjaxUrl = function getAjaxUrl(horseUid, action) {
    return 'horse/horse-tracker/ugc/' + horseUid + '/' + action;
};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HorseTracker = __webpack_require__(1181);

var _HorseTracker2 = _interopRequireDefault(_HorseTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HorseTracker2.default;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpGuiGuide = __webpack_require__(113);

var _date = __webpack_require__(19);

var _url = __webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var RaceDayLink = function RaceDayLink(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDate = _ref.raceDate,
        children = _ref.children;

    if (!courseName || !courseUid || !raceDate) {
        return null;
    }

    var date = (0, _date.formatDate)(raceDate, 'Y-MM-DD');
    var name = (0, _url.nameToUrl)(courseName);
    var url = _rpGuiGuide.mobileDetect.isPhone() ? date + '#' + name : courseUid + '/' + name + '/' + date;
    return _jsx('a', {
        className: 'ui-link ui-link_table js-popupLink js-navigate-url',
        href: '/racecards/' + url
    }, void 0, children, _ref2);
};

exports.default = RaceDayLink;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint prefer-template: 0 */
var getCourseMetaTitle = function getCourseMetaTitle(page, name) {
    var titleConfig = {
        stats: 'Racecourse Statistics',
        results: 'Racecourse Results',
        signposts: 'Signposts',
        favourites: 'Favourites Win Rate',
        'course-map': 'Racecourse Map',
        'course-records': 'Course Records',
        'course-info': 'Racecourse Information'
    };

    return name + ' Racecourse | ' + titleConfig[page] + ' | Racing Post';
};

var getCourseMetaDescription = function getCourseMetaDescription(page, name) {
    var descriptionConfig = {
        stats: 'Who are the top performers at ' + name + ' Racecourse?\n            Find out here with detailed jockey,\n            trainer and owner statistics from the Racing Post.',
        results: 'Historical race results for ' + name + ' Racecourse.\n            Brought to you by the Racing Post.',
        signposts: name + ' signposts & travellers check. Information provided on horses\n            that have travelled the furthest to make the race meet, including first\n            time blinkers and seven day winners. Courtesy of the Racing Post.',
        favourites: name + ' racecourse favourites. Data covering the last 5 seasons,\n            split by horse age as well as handicap. Provided courtesy of the Racing Post.',
        'course-map': 'Get a lay of the land with detailed course maps and aerial views of\n            ' + name + ' Racecourse. View up to date information on all upcoming races.',
        'course-records': 'All the racecourse information you need, brought to you by the Racing Post.\n            Distances covered, record course times and RP standard.',
        'course-info': 'Your one stop shop for a great day out at ' + name + '. From ticket prices\n            and admissions, to travel and parking information. We\'ve got it all covered!'
    };

    return descriptionConfig[page];
};

var getCourseMetaData = function getCourseMetaData(page, name) {
    return {
        title: getCourseMetaTitle(page, name),
        description: getCourseMetaDescription(page, name)
    };
};

exports.default = getCourseMetaData;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(6);

var _date = __webpack_require__(19);

/* eslint prefer-template: 0 */
var getHorseMetaTitle = function getHorseMetaTitle(page, name) {
    var titleConfig = {
        'weatherbys-overview': 'Weatherbys Overview',
        'sire-reference': 'Sire Reference',
        progeny: 'Progeny',
        'progeny-dam': 'Progeny',
        'progeny-dams-sire': 'Progeny Dam\'s Sire',
        'progeny-statistics': 'Progeny Statistics',
        'progeny-results': 'Progeny Results',
        'progeny-entries': 'Progeny Entries',
        nicks: 'Nicks',
        'fee-history': 'Fee History',
        'sales-statistics': 'Sales Statistics',
        'sales-results': 'No title',
        'sales-entries': 'No title',
        'progeny-sales': 'Progeny Sales',
        form: 'Race Record & Form',
        'my-ratings': 'Form & My Ratings',
        entries: 'Race Entries',
        stats: 'Race Stats',
        quotes: 'Quotes From Connections',
        pedigree: 'Horse Pedigree',
        sales: 'Sales Details',
        notes: 'Personal Notes'
    };

    return name + ' | ' + titleConfig[page] + ' | Racing Post';
};

var getHorseMetaDescription = function getHorseMetaDescription(page, _ref) {
    var age = _ref.age,
        horseDateOfBirth = _ref.horseDateOfBirth,
        horseColourCode = _ref.horseColourCode,
        horseSexCode = _ref.horseSexCode,
        sireHorseName = _ref.sireHorseName,
        sireAvgFlatWinDist = _ref.sireAvgFlatWinDist,
        damHorseName = _ref.damHorseName,
        damCountryOriginCode = _ref.damCountryOriginCode,
        damSireHorseName = _ref.damSireHorseName,
        damSireAvgFlatWinDist = _ref.damSireAvgFlatWinDist,
        trainerName = _ref.trainerName,
        ownerName = _ref.ownerName,
        breederName = _ref.breederName,
        horseName = _ref.horseName,
        countryCode = _ref.horseCountryOriginCode,
        sireStatus = _ref.sireStatus;

    var horseDetails = age + ' (' + (0, _date.formatDate)(horseDateOfBirth, 'DDMMMYY') + '\n        ' + (0, _lodash.toLower)(horseColourCode) + ' ' + (0, _lodash.toLower)(horseSexCode) + ');\n        ' + sireHorseName + ' (' + sireAvgFlatWinDist + 'f) - ' + damHorseName + '\n        (' + damCountryOriginCode + ') (' + damSireHorseName + ' (' + (damSireAvgFlatWinDist || '') + 'f));\n        Trainer ' + trainerName + '; Owner ' + ownerName + '; Breeder ' + breederName;

    var descriptionConfig = {
        'weatherbys-overview': 'Weatherbys Overview for ' + horseName + ' available on Racing Post Bloodstock.\n            Profile page includes Stud Fee, Sire, Dam, Dam\'s Sire, Standing, Sire Comment,\n            Breeder, Trainer and Owner.',
        'sire-reference': 'Weatherbys Sire Reference for ' + horseName + ' available on Racing Post Bloodstock.\n            Copyright protected. All rights reserved.',
        progeny: 'View detailed progeny statistics for ' + horseName + ' including wins,\n            runs and total earnings',
        'progeny-dams-sire': 'View detailed dam\'s sire progeny statistics for ' + horseName + ' including wins,\n            runs and total earnings',
        'progeny-statistics': 'Stallion statistics from the Racing Post.\n            View wins, runs, earnings and Racing Post Ratings.',
        'progeny-results': 'Historical Progeny Results for ' + horseName + '.\n            Includes statistics on course run, course conditions and prize earnings.',
        'progeny-entries': sireStatus ? 'Historical Progeny Entries for ' + horseName + '. Filter by season or race.' : 'Full list of progeny entries for ' + horseName + ' listed by race and date.',
        nicks: 'View the family related data of ' + horseName + ' including statistics such as wins,\n            win percentage and total earnings.',
        'fee-history': 'Research yearly Stud fee\'s for ' + horseName + ' on the Racing Post.\n            The most comprehensive Horse Racing statistics available today.',
        'sales-statistics': 'In depth sales statistics for ' + horseName + '.\n            Get the most comprehensive Horse Racing statistics available from the Racing Post.',
        'sales-results': 'No description',
        'sales-entries': 'No description',
        'progeny-sales': 'Progeny sales data brought to you by the Racing Post.\n            Track prices, sales, buyer information and more.',
        form: horseName + ' statistics and form.\n            View results and future entries as well as statistics by course,\n            race type and prize money.',
        'my-ratings': horseName + ' statistics and form.\n            View results and future entries as well as statistics by course,\n            race type and prize money.',
        entries: 'Forthcoming race entries for ' + horseName + '.\n            Includes date entered, race time and latest betting odds.',
        stats: horseName + ' Race Statistics provided by the Racing Post.\n            Broken down by course, distance, going, month, jockey and class.',
        quotes: 'Quotes from the connections of ' + horseName + '. ' + horseDetails,
        pedigree: horseName + ' Pedigree. Stallion and Dam details provided.',
        sales: horseName + ' (' + countryCode + ') Sales Details. ' + horseDetails,
        notes: 'Access the "My Notes" section of individual horse profiles.\n            Providing notes according to race type as well as being able\n            to provide your own horse ratings'
    };

    return descriptionConfig[page];
};

var getHorseMetaData = function getHorseMetaData(page, profile) {
    return {
        title: getHorseMetaTitle(page, profile.horseName),
        description: getHorseMetaDescription(page, profile)
    };
};

exports.default = getHorseMetaData;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint prefer-template: 0 */
var getHumanMetaTitle = function getHumanMetaTitle(page, name) {
    var titleConfig = {
        form: 'Record By Race Type',
        entries: 'Historical Race Entries',
        'booked-rides': 'Booked Rides',
        horses: 'Horse Records',
        stats: 'Statistical Summary'
    };

    return name + ' | ' + titleConfig[page] + ' | Racing Post';
};

var getHumanMetaDescription = function getHumanMetaDescription(type, page, name) {
    var descriptionConfig = {
        jockey: {
            form: 'Jockey ' + name + ' statistics and form.\n                View results and future entries as well as statistics by course,\n                race type and prize money.',
            'booked-rides': 'View upcoming rides for Jockey ' + name + '.\n                With unparalleled statistics including wins,\n                earnings and much, much more.',
            horses: 'Jockey ' + name + ' historical horse records.\n                Data includes runs, wins, RPR, winnings and earnings.\n                Drill down by race type and time by using the filter option.',
            stats: 'Statistical summary of results for Jockey ' + name + '.\n                Filter results by race type, check out win ratios,\n                total prize money won plus much, much more.'
        },
        trainer: {
            form: 'Trainer ' + name + ' statistics and form.\n                View results and future entries as well as statistics by course,\n                race type and prize money.',
            entries: 'Forthcoming entries for trainer ' + name + '.\n                Includes date entered, race time and latest betting odds.',
            horses: name + '\'s historical horse records.\n                Data includes runs, wins, RPR, winnings and earnings.',
            stats: 'Statistical summary of results for trainer ' + name + '.\n                Filter results by race type, check out win ratios,\n                total prize money won plus much, much more.'
        },
        owner: {
            form: 'Owner ' + name + ' statistics and form.\n                View results and future entries as well as statistics by course,\n                race type and prize money.',
            entries: 'Historical race entries for owner ' + name + '.\n                A comprehensive list of entries for the last five seasons.\n                Access win ratios, total prize money won, RPR and much more.',
            horses: name + '\'s historical horse records.\n                Filter by race type and time period.\n                Data includes runs, wins, RPR, winnings and earnings.',
            stats: 'Statistical summary of results for owner ' + name + '.\n                Filter results by race type, check out win ratios,\n                total prize money won plus much, much more.'
        }
    };

    return descriptionConfig[type][page];
};

var getHumanMetaData = function getHumanMetaData(type, page, name) {
    return {
        title: getHumanMetaTitle(page, name),
        description: getHumanMetaDescription(type, page, name)
    };
};

exports.default = getHumanMetaData;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cirleHelp',
    size: 'Medium'
});

var HelpLink = function HelpLink(_ref) {
    var url = _ref.url;
    return _jsx('div', {
        className: 'ui-helpCenter pp-tabs__help hidden-sm-down'
    }, void 0, _jsx('a', {
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'ui-link_questionMark'
    }, void 0, _ref2));
};

exports.default = HelpLink;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(6);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Popover2 = __webpack_require__(1176);

var _Popover3 = _interopRequireDefault(_Popover2);

var _Abbr = __webpack_require__(40);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _PopoverLink = __webpack_require__(1192);

var _PopoverLink2 = _interopRequireDefault(_PopoverLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Popover component has state: { expanded } and
// change state.expanded to false on outside click
var _ref = _jsx('span', {
    className: 'ui-tabs__arrow'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'down'
}));

var MoreBtn = function (_Popover) {
    _inherits(MoreBtn, _Popover);

    function MoreBtn() {
        _classCallCheck(this, MoreBtn);

        return _possibleConstructorReturn(this, (MoreBtn.__proto__ || Object.getPrototypeOf(MoreBtn)).apply(this, arguments));
    }

    _createClass(MoreBtn, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                url = _props.url,
                hash = _props.hash,
                tabNames = _props.tabNames,
                currentTab = _props.currentTab,
                is5Tabs = _props.is5Tabs;
            var expanded = this.state.expanded;

            var activeTab = tabNames.find(function (tabName) {
                return tabName === currentTab;
            });
            var isFirstSelected = activeTab === tabNames[0];
            var className = (0, _classnames2.default)('ui-tabs__tab', 'pp-tabs__tab', 'pp-tabs__more', 'hidden-md-up', expanded && 'ui-tabs__tab_more_major', activeTab && 'ui-tabs__tab_selected', isFirstSelected && 'pp-tabs__more_firstSelected', is5Tabs && 'pp-tabs__more_fiveTabs');

            /* eslint jsx-a11y/no-static-element-interactions: 0 */
            return _jsx('div', {
                className: className,
                onClick: this.togglePopover
            }, void 0, _jsx('div', {
                className: 'ui-tabs__tab_more'
            }, void 0, isFirstSelected ? _jsx(_Abbr2.default, {
                title: 'More'
            }, void 0, (0, _lodash.startCase)(activeTab)) : (0, _lodash.startCase)(activeTab) || 'More', _ref), expanded && _jsx('div', {
                className: 'ui-popover ui-popover_customised'
            }, void 0, tabNames.map(function (tabName, i) {
                return _jsx(_PopoverLink2.default, {
                    tabName: tabName,
                    url: url,
                    hash: hash,
                    className: i === 0 ? 'hidden-sm-up' : ''
                }, tabName);
            })));
        }
    }]);

    return MoreBtn;
}(_Popover3.default);

MoreBtn.propTypes = {
    url: _propTypes2.default.string.isRequired,
    hash: _propTypes2.default.string,
    currentTab: _propTypes2.default.string,
    is5Tabs: _propTypes2.default.bool.isRequired,
    tabNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = MoreBtn;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(160);

var _lodash = __webpack_require__(6);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _showBarrier = __webpack_require__(357);

var _showBarrier2 = _interopRequireDefault(_showBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var NavLink = function NavLink(_ref) {
    var url = _ref.url,
        hash = _ref.hash,
        tabName = _ref.tabName,
        tabUrl = _ref.tabUrl,
        activeClassName = _ref.activeClassName,
        cssClasses = _ref.cssClasses;
    return _jsx(_reactRouter.Link, {
        to: url + '/' + tabUrl + hash,
        className: _classnames2.default.apply(undefined, ['ui-tabs__tab', 'pp-tabs__tab'].concat(_toConsumableArray(cssClasses))),
        activeClassName: activeClassName,
        onClick: function onClick(event) {
            return (0, _showBarrier2.default)(event, url + '/' + tabUrl + hash);
        }
    }, void 0, (0, _lodash.startCase)(tabName));
};

NavLink.defaultProps = {
    cssClasses: []
};

exports.default = NavLink;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _reactRouter = __webpack_require__(160);

var _lodash = __webpack_require__(6);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _showBarrier = __webpack_require__(357);

var _showBarrier2 = _interopRequireDefault(_showBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'ui-popoverList__icon'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    className: 'tableShowIcon',
    iconName: 'tick',
    size: 'Medium'
}));

var PopoverLink = function PopoverLink(_ref) {
    var url = _ref.url,
        hash = _ref.hash,
        tabName = _ref.tabName,
        className = _ref.className;
    return _jsx(_reactRouter.Link, {
        to: url + '/' + tabName + hash,
        className: (0, _classnames2.default)('pp-tabs__popoverLink', 'ui-popoverList__item', className),
        activeClassName: 'pp-tabs__popoverLink_selected',
        onClick: function onClick(event) {
            return (0, _showBarrier2.default)(event, url + '/' + tabName + hash);
        }
    }, void 0, _jsx('span', {
        className: 'ui-popoverList__label'
    }, void 0, (0, _lodash.startCase)(tabName)), _ref2);
};

exports.default = PopoverLink;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _SubNavLink = __webpack_require__(1194);

var _SubNavLink2 = _interopRequireDefault(_SubNavLink);

var _tabNames = __webpack_require__(256);

var _calculateTabUrl = __webpack_require__(578);

var _calculateTabUrl2 = _interopRequireDefault(_calculateTabUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNav = function SubNav(_ref) {
    var currentTab = _ref.currentTab,
        url = _ref.url,
        hasWeatherbys = _ref.hasWeatherbys;

    var tab = currentTab || (hasWeatherbys ? 'weatherbys-overview' : 'progeny');

    return _jsx('div', {
        className: (0, _classnames2.default)('pp-subTabs', _tabNames.sireSubTabs.stallionDetails.includes(tab) && 'pp-subTabs_weatherbys')
    }, void 0, Object.values(_tabNames.sireSubTabs).find(function (subTabs) {
        return subTabs.includes(tab);
    }).map(function (subTab, i) {
        return _jsx(_SubNavLink2.default, {
            url: url,
            tabName: subTab,
            tabUrl: (0, _calculateTabUrl2.default)(currentTab, subTab, i)
        }, subTab);
    }));
};

exports.default = SubNav;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(160);

var _lodash = __webpack_require__(6);

var _showBarrier = __webpack_require__(357);

var _showBarrier2 = _interopRequireDefault(_showBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavLink = function SubNavLink(_ref) {
    var url = _ref.url,
        tabName = _ref.tabName,
        tabUrl = _ref.tabUrl;
    return _jsx(_reactRouter.Link, {
        to: url + '/' + tabUrl,
        className: 'ui-link ui-link_primary ui-popoverList__link pp-subTabs__tab',
        activeClassName: 'pp-subTabs__tab_selected',
        onClick: function onClick(event) {
            return (0, _showBarrier2.default)(event, url + '/' + tabUrl);
        }
    }, void 0, tabName === 'progeny-dams-sire' ? 'Damsire' : (0, _lodash.startCase)(tabName));
};

exports.default = SubNavLink;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var weaterbysTabs = ['weatherbys-overview', 'sire-reference'];

var calculateActiveClass = function calculateActiveClass(isSire, hasWeatherbys, isSubTabSelected, tab) {
    if (!isSire || !isSubTabSelected) {
        return 'ui-tabs__tab_selected';
    }

    return 'ui-tabs__tab_selected ' + (hasWeatherbys && (!tab || weaterbysTabs.includes(tab)) ? 'weatherbys' : 'dark');
};

exports.default = calculateActiveClass;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabNames = __webpack_require__(256);

var checkSubTabSelected = function checkSubTabSelected(tab) {
    return tab ? Object.values(_tabNames.sireSubTabs).some(function (arr) {
        return arr.includes(tab);
    }) : true;
};

exports.default = checkSubTabSelected;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isShown = {
    XN: 3,
    N: 4
};

exports.default = isShown;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BetslipInteracter = function () {
    function BetslipInteracter() {
        _classCallCheck(this, BetslipInteracter);

        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
        this.decimalOdds = false;
    }

    _createClass(BetslipInteracter, [{
        key: 'init',
        value: function init(feedName) {
            var deferred = _jquery2.default.Deferred();
            this.resolvePromise = deferred.resolve;
            var customizeSettingsCookie = _jquery2.default.cookie('customizeSettings');
            if (customizeSettingsCookie) {
                var customizeSettings = JSON.parse(customizeSettingsCookie);
                this.decimalOdds = customizeSettings.decimalOdds;
            }
            this.bindEvents();
            if (feedName) {
                this.feedName = feedName;
                this.setBetslipBookmaker(feedName);
            } else {
                this.requestSelectedBookmaker();
            }
            return deferred.promise();
        }
    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(_ref) {
            var bookmaker = _ref.detail.bookmaker;

            (0, _jquery2.default)(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
            this.resolveBookmaker(bookmaker);
        }
    }, {
        key: 'resolveBookmaker',
        value: function resolveBookmaker(bookmaker) {
            if (this.resolvePromise) {
                this.resolvePromise(bookmaker);
                this.resolvePromise = null;
                delete this.resolvePromise;
            }
        }
    }, {
        key: 'onBetslipInitialized',
        value: function onBetslipInitialized() {
            if (this.feedName) {
                this.setBetslipBookmaker(this.feedName);
                this.resolveBookmaker(this.feedName);
            } else {
                this.requestSelectedBookmaker();
            }
        }

        /* eslint-disable class-methods-use-this */

    }, {
        key: 'requestSelectedBookmaker',
        value: function requestSelectedBookmaker() {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'setBetslipBookmaker',
        value: function setBetslipBookmaker(bookmaker) {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                detail: { bookmaker: bookmaker }
            });
            document.dispatchEvent(betslipEvent);
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }]);

    return BetslipInteracter;
}();

exports.default = BetslipInteracter;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var gbFlat = [{
    label: 'GB Flat (turf & AW)',
    value: 'GB/flat'
}, {
    label: 'GB Flat turf',
    value: 'GB/flat/turf'
}, {
    label: 'GB AW',
    value: 'GB/flat/aw'
}];
var gbJumps = [{
    label: 'GB jumps',
    value: 'GB/jumps'
}];
var ireFlat = [{
    label: 'Irish Flat (turf & AW)',
    value: 'IRE/flat'
}, {
    label: 'Irish Flat turf',
    value: 'IRE/flat/turf'
}, {
    label: 'Irish AW',
    value: 'IRE/flat/aw'
}];
var ireJumps = [{
    label: 'Irish jumps',
    value: 'IRE/jumps'
}];

var human = [].concat(gbFlat, gbJumps, ireFlat, ireJumps);

var horse = {
    flat: [].concat(gbFlat, ireFlat),
    jumps: [].concat(gbJumps, ireJumps)
};

var course = {
    flat: {
        value: 'flat',
        label: 'Flat'
    },
    jumps: {
        value: 'jumps',
        label: 'Jumps'
    },
    flatTurf: {
        label: 'Flat turf',
        value: 'flat'
    },
    aw: {
        label: 'AW',
        value: 'flat'
    }
};

var getForCourse = function getForCourse(typeCode, seasonsAvailable) {
    var isStats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var shouldShowJumps = isStats && Object.prototype.hasOwnProperty.call(seasonsAvailable, 'JUMPS');
    var flatTurf = course.flatTurf,
        aw = course.aw,
        jumps = course.jumps;

    switch (typeCode) {
        case 'J':
        case 'P':
            return [jumps];
        case 'F':
            return [flatTurf];
        case 'B':
            return [flatTurf, jumps];
        case 'X':
            return shouldShowJumps ? [aw, jumps] : [aw];
        default:
            return [];
    }
};

exports.default = { human: human, horse: horse, course: course, getForCourse: getForCourse };

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(6);

/**
 * Format time function
 * Takes time in seconds and returns as formatted string
 * Examples:
 * 52    -> 52.00s
 * 60    -> 1m 0.00s
 * 65    -> 1m 5.00s
 * 65.89 -> 1m 5.89s
 * 65.80 -> 1m 6.80s
 *
 * @param seconds float
 * @returns {string}
 */
function formatTime(seconds) {
  var time = (0, _lodash.isNumber)(seconds) ? seconds : 0;
  var integralValue = Math.floor(time / 60);
  var fractionalValue = (time % 60).toFixed(2);
  var integralPart = integralValue ? integralValue + 'm' : '';
  var fractionalPart = fractionalValue + 's';

  return (integralPart + ' ' + fractionalPart).trim();
}

exports.default = formatTime;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ageFormat = { 0: 'f', 1: 'y' };

var getFormattedAge = function getFormattedAge(age) {
  return ageFormat[age] || age + 'yo';
};

exports.default = getFormattedAge;

/***/ }),
/* 1202 */,
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1237), __esModule: true };

/***/ }),
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1245), __esModule: true };

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1248), __esModule: true };

/***/ }),
/* 1210 */,
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1251), __esModule: true };

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1252), __esModule: true };

/***/ }),
/* 1213 */,
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1203);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;﻿/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
    /**
     * Clamps a text node.
     * @param {HTMLElement} element. Element containing the text node to clamp.
     * @param {Object} options. Options to pass to the clamper.
     */
    function clamp(element, options) {
        options = options || {};

        var self = this,
            win = window,
            opt = {
                clamp:              options.clamp || 2,
                useNativeClamp:     typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
                splitOnChars:       options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
                animate:            options.animate || false,
                truncationChar:     options.truncationChar || '…',
                truncationHTML:     options.truncationHTML
            },

            sty = element.style,
            originalText = element.innerHTML,

            supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
            clampValue = opt.clamp,
            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
            truncationHTMLContainer;
            
        if (opt.truncationHTML) {
            truncationHTMLContainer = document.createElement('span');
            truncationHTMLContainer.innerHTML = opt.truncationHTML;
        }


// UTILITY FUNCTIONS __________________________________________________________

        /**
         * Return the current style for an element.
         * @param {HTMLElement} elem The element to compute.
         * @param {string} prop The style property.
         * @returns {number}
         */
        function computeStyle(elem, prop) {
            if (!win.getComputedStyle) {
                win.getComputedStyle = function(el, pseudo) {
                    this.el = el;
                    this.getPropertyValue = function(prop) {
                        var re = /(\-([a-z]){1})/g;
                        if (prop == 'float') prop = 'styleFloat';
                        if (re.test(prop)) {
                            prop = prop.replace(re, function () {
                                return arguments[2].toUpperCase();
                            });
                        }
                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                    }
                    return this;
                }
            }

            return win.getComputedStyle(elem, null).getPropertyValue(prop);
        }

        /**
         * Returns the maximum number of lines of text that should be rendered based
         * on the current height of the element and the line-height of the text.
         */
        function getMaxLines(height) {
            var availHeight = height || element.clientHeight,
                lineHeight = getLineHeight(element);

            return Math.max(Math.floor(availHeight/lineHeight), 0);
        }

        /**
         * Returns the maximum height a given element should have based on the line-
         * height of the text and the given clamp value.
         */
        function getMaxHeight(clmp) {
            var lineHeight = getLineHeight(element);
            return lineHeight * clmp;
        }

        /**
         * Returns the line-height of an element as an integer.
         */
        function getLineHeight(elem) {
            var lh = computeStyle(elem, 'line-height');
            if (lh == 'normal') {
                // Normal line heights vary from browser to browser. The spec recommends
                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
            }
            return parseInt(lh);
        }


// MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
        var splitOnChars = opt.splitOnChars.slice(0),
            splitChar = splitOnChars[0],
            chunks,
            lastChunk;
        
        /**
         * Gets an element's last child. That may be another node or a node's contents.
         */
        function getLastChild(elem) {
            //Current element has children, need to go deeper and get last child as a text node
            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
                return getLastChild(Array.prototype.slice.call(elem.children).pop());
            }
            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
                elem.lastChild.parentNode.removeChild(elem.lastChild);
                return getLastChild(element);
            }
            //This is the last child we want, return it
            else {
                return elem.lastChild;
            }
        }
        
        /**
         * Removes one character at a time from the text until its width or
         * height is beneath the passed-in max param.
         */
        function truncate(target, maxHeight) {
            if (!maxHeight) {return;}
            
            /**
             * Resets global variables.
             */
            function reset() {
                splitOnChars = opt.splitOnChars.slice(0);
                splitChar = splitOnChars[0];
                chunks = null;
                lastChunk = null;
            }
            
            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
            
            //Grab the next chunks
            if (!chunks) {
                //If there are more characters to try, grab the next one
                if (splitOnChars.length > 0) {
                    splitChar = splitOnChars.shift();
                }
                //No characters to chunk by. Go character-by-character
                else {
                    splitChar = '';
                }
                
                chunks = nodeValue.split(splitChar);
            }
            
            //If there are chunks left to remove, remove the last one and see if
            // the nodeValue fits.
            if (chunks.length > 1) {
                // console.log('chunks', chunks);
                lastChunk = chunks.pop();
                // console.log('lastChunk', lastChunk);
                applyEllipsis(target, chunks.join(splitChar));
            }
            //No more chunks can be removed using this character
            else {
                chunks = null;
            }
            
            //Insert the custom HTML before the truncation character
            if (truncationHTMLContainer) {
                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
            }

            //Search produced valid chunks
            if (chunks) {
                //It fits
                if (element.clientHeight <= maxHeight) {
                    //There's still more characters to try splitting on, not quite done yet
                    if (splitOnChars.length >= 0 && splitChar != '') {
                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                        chunks = null;
                    }
                    //Finished!
                    else {
                        return element.innerHTML;
                    }
                }
            }
            //No valid chunks produced
            else {
                //No valid chunks even when splitting by letter, time to move
                //on to the next node
                if (splitChar == '') {
                    applyEllipsis(target, '');
                    target = getLastChild(element);
                    
                    reset();
                }
            }
            
            //If you get here it means still too big, let's keep truncating
            if (opt.animate) {
                setTimeout(function() {
                    truncate(target, maxHeight);
                }, opt.animate === true ? 10 : opt.animate);
            }
            else {
                return truncate(target, maxHeight);
            }
        }
        
        function applyEllipsis(elem, str) {
            elem.nodeValue = str + opt.truncationChar;
        }


// CONSTRUCTOR ________________________________________________________________

        if (clampValue == 'auto') {
            clampValue = getMaxLines();
        }
        else if (isCSSValue) {
            clampValue = getMaxLines(parseInt(clampValue));
        }

        var clampedText;
        if (supportsNativeClamp && opt.useNativeClamp) {
            sty.overflow = 'hidden';
            sty.textOverflow = 'ellipsis';
            sty.webkitBoxOrient = 'vertical';
            sty.display = '-webkit-box';
            sty.webkitLineClamp = clampValue;

            if (isCSSValue) {
                sty.height = opt.clamp + 'px';
            }
        }
        else {
            var height = getMaxHeight(clampValue);
            if (height < element.clientHeight) {
                clampedText = truncate(getLastChild(element), height);
            }
        }
        
        return {
            'original': originalText,
            'clamped': clampedText
        }
    }

    return clamp;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1236 */,
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(204);
__webpack_require__(1277);
module.exports = __webpack_require__(33).Array.from;


/***/ }),
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1283);
var $Object = __webpack_require__(33).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1284);
module.exports = __webpack_require__(33).Object.getPrototypeOf;


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1285);
module.exports = __webpack_require__(33).Object.keys;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1286);
module.exports = __webpack_require__(33).Object.setPrototypeOf;


/***/ }),
/* 1249 */,
/* 1250 */,
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1288);
__webpack_require__(609);
__webpack_require__(1292);
__webpack_require__(1293);
module.exports = __webpack_require__(33).Symbol;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(204);
__webpack_require__(265);
module.exports = __webpack_require__(378).f('iterator');


/***/ }),
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(105);
var createDesc = __webpack_require__(202);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(166);
var gOPS = __webpack_require__(370);
var pIE = __webpack_require__(201);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1258 */,
/* 1259 */,
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(199);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1261 */,
/* 1262 */,
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(264)('meta');
var isObject = __webpack_require__(119);
var has = __webpack_require__(132);
var setDesc = __webpack_require__(105).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(164)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(120);
var gOPN = __webpack_require__(601).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1268 */,
/* 1269 */,
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(119);
var anObject = __webpack_require__(94);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(163)(Function.call, __webpack_require__(369).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(163);
var $export = __webpack_require__(67);
var toObject = __webpack_require__(203);
var call = __webpack_require__(598);
var isArrayIter = __webpack_require__(597);
var toLength = __webpack_require__(375);
var createProperty = __webpack_require__(1256);
var getIterFn = __webpack_require__(379);

$export($export.S + $export.F * !__webpack_require__(600)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(120);
var $getOwnPropertyDescriptor = __webpack_require__(369).f;

__webpack_require__(371)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(203);
var $getPrototypeOf = __webpack_require__(602);

__webpack_require__(371)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(203);
var $keys = __webpack_require__(166);

__webpack_require__(371)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(67);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1270).set });


/***/ }),
/* 1287 */,
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(59);
var has = __webpack_require__(132);
var DESCRIPTORS = __webpack_require__(118);
var $export = __webpack_require__(67);
var redefine = __webpack_require__(606);
var META = __webpack_require__(1263).KEY;
var $fails = __webpack_require__(164);
var shared = __webpack_require__(373);
var setToStringTag = __webpack_require__(263);
var uid = __webpack_require__(264);
var wks = __webpack_require__(60);
var wksExt = __webpack_require__(378);
var wksDefine = __webpack_require__(377);
var enumKeys = __webpack_require__(1257);
var isArray = __webpack_require__(1260);
var anObject = __webpack_require__(94);
var isObject = __webpack_require__(119);
var toIObject = __webpack_require__(120);
var toPrimitive = __webpack_require__(376);
var createDesc = __webpack_require__(202);
var _create = __webpack_require__(368);
var gOPNExt = __webpack_require__(1267);
var $GOPD = __webpack_require__(369);
var $DP = __webpack_require__(105);
var $keys = __webpack_require__(166);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(601).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(201).f = $propertyIsEnumerable;
  __webpack_require__(370).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(200)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(133)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(377)('asyncIterator');


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(377)('observable');


/***/ }),
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(147)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(672)
var parse = __webpack_require__(3)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(284)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(283)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var differenceInCalendarISOYears = __webpack_require__(663)
var compareAsc = __webpack_require__(214)
var subISOYears = __webpack_require__(691)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(283)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(408)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(666)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var differenceInCalendarYears = __webpack_require__(665)
var compareAsc = __webpack_require__(214)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(407)
var parse = __webpack_require__(3)
var differenceInSeconds = __webpack_require__(409)
var enLocale = __webpack_require__(415)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(667)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(669)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(145)
var startOfISOWeek = __webpack_require__(147)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(410)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 1513 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(670)
var getISOWeek = __webpack_require__(412)
var getISOYear = __webpack_require__(145)
var parse = __webpack_require__(3)
var isValid = __webpack_require__(682)
var enLocale = __webpack_require__(415)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(673)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(215)
var addWeeks = __webpack_require__(406)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(212),
  addHours: __webpack_require__(657),
  addISOYears: __webpack_require__(658),
  addMilliseconds: __webpack_require__(213),
  addMinutes: __webpack_require__(659),
  addMonths: __webpack_require__(281),
  addQuarters: __webpack_require__(660),
  addSeconds: __webpack_require__(661),
  addWeeks: __webpack_require__(406),
  addYears: __webpack_require__(662),
  areRangesOverlapping: __webpack_require__(1489),
  closestIndexTo: __webpack_require__(1490),
  closestTo: __webpack_require__(1491),
  compareAsc: __webpack_require__(214),
  compareDesc: __webpack_require__(407),
  differenceInCalendarDays: __webpack_require__(282),
  differenceInCalendarISOWeeks: __webpack_require__(1492),
  differenceInCalendarISOYears: __webpack_require__(663),
  differenceInCalendarMonths: __webpack_require__(664),
  differenceInCalendarQuarters: __webpack_require__(1493),
  differenceInCalendarWeeks: __webpack_require__(1494),
  differenceInCalendarYears: __webpack_require__(665),
  differenceInDays: __webpack_require__(666),
  differenceInHours: __webpack_require__(1495),
  differenceInISOYears: __webpack_require__(1496),
  differenceInMilliseconds: __webpack_require__(283),
  differenceInMinutes: __webpack_require__(1497),
  differenceInMonths: __webpack_require__(408),
  differenceInQuarters: __webpack_require__(1498),
  differenceInSeconds: __webpack_require__(409),
  differenceInWeeks: __webpack_require__(1499),
  differenceInYears: __webpack_require__(1500),
  distanceInWords: __webpack_require__(667),
  distanceInWordsStrict: __webpack_require__(1501),
  distanceInWordsToNow: __webpack_require__(1502),
  eachDay: __webpack_require__(1503),
  endOfDay: __webpack_require__(410),
  endOfHour: __webpack_require__(1504),
  endOfISOWeek: __webpack_require__(1505),
  endOfISOYear: __webpack_require__(1506),
  endOfMinute: __webpack_require__(1507),
  endOfMonth: __webpack_require__(668),
  endOfQuarter: __webpack_require__(1508),
  endOfSecond: __webpack_require__(1509),
  endOfToday: __webpack_require__(1510),
  endOfTomorrow: __webpack_require__(1511),
  endOfWeek: __webpack_require__(669),
  endOfYear: __webpack_require__(1512),
  endOfYesterday: __webpack_require__(1513),
  format: __webpack_require__(1514),
  getDate: __webpack_require__(1515),
  getDay: __webpack_require__(1516),
  getDayOfYear: __webpack_require__(670),
  getDaysInMonth: __webpack_require__(411),
  getDaysInYear: __webpack_require__(1517),
  getHours: __webpack_require__(1518),
  getISODay: __webpack_require__(671),
  getISOWeek: __webpack_require__(412),
  getISOWeeksInYear: __webpack_require__(1519),
  getISOYear: __webpack_require__(145),
  getMilliseconds: __webpack_require__(1520),
  getMinutes: __webpack_require__(1521),
  getMonth: __webpack_require__(1522),
  getOverlappingDaysInRanges: __webpack_require__(1523),
  getQuarter: __webpack_require__(672),
  getSeconds: __webpack_require__(1524),
  getTime: __webpack_require__(1525),
  getYear: __webpack_require__(1526),
  isAfter: __webpack_require__(1528),
  isBefore: __webpack_require__(1529),
  isDate: __webpack_require__(413),
  isEqual: __webpack_require__(1530),
  isFirstDayOfMonth: __webpack_require__(1531),
  isFriday: __webpack_require__(1532),
  isFuture: __webpack_require__(1533),
  isLastDayOfMonth: __webpack_require__(1534),
  isLeapYear: __webpack_require__(673),
  isMonday: __webpack_require__(1535),
  isPast: __webpack_require__(1536),
  isSameDay: __webpack_require__(1537),
  isSameHour: __webpack_require__(674),
  isSameISOWeek: __webpack_require__(675),
  isSameISOYear: __webpack_require__(676),
  isSameMinute: __webpack_require__(677),
  isSameMonth: __webpack_require__(678),
  isSameQuarter: __webpack_require__(679),
  isSameSecond: __webpack_require__(680),
  isSameWeek: __webpack_require__(414),
  isSameYear: __webpack_require__(681),
  isSaturday: __webpack_require__(1538),
  isSunday: __webpack_require__(1539),
  isThisHour: __webpack_require__(1540),
  isThisISOWeek: __webpack_require__(1541),
  isThisISOYear: __webpack_require__(1542),
  isThisMinute: __webpack_require__(1543),
  isThisMonth: __webpack_require__(1544),
  isThisQuarter: __webpack_require__(1545),
  isThisSecond: __webpack_require__(1546),
  isThisWeek: __webpack_require__(1547),
  isThisYear: __webpack_require__(1548),
  isThursday: __webpack_require__(1549),
  isToday: __webpack_require__(1550),
  isTomorrow: __webpack_require__(1551),
  isTuesday: __webpack_require__(1552),
  isValid: __webpack_require__(682),
  isWednesday: __webpack_require__(1553),
  isWeekend: __webpack_require__(1554),
  isWithinRange: __webpack_require__(1555),
  isYesterday: __webpack_require__(1556),
  lastDayOfISOWeek: __webpack_require__(1557),
  lastDayOfISOYear: __webpack_require__(1558),
  lastDayOfMonth: __webpack_require__(1559),
  lastDayOfQuarter: __webpack_require__(1560),
  lastDayOfWeek: __webpack_require__(683),
  lastDayOfYear: __webpack_require__(1561),
  max: __webpack_require__(1565),
  min: __webpack_require__(1566),
  parse: __webpack_require__(3),
  setDate: __webpack_require__(1567),
  setDay: __webpack_require__(1568),
  setDayOfYear: __webpack_require__(1569),
  setHours: __webpack_require__(1570),
  setISODay: __webpack_require__(1571),
  setISOWeek: __webpack_require__(1572),
  setISOYear: __webpack_require__(684),
  setMilliseconds: __webpack_require__(1573),
  setMinutes: __webpack_require__(1574),
  setMonth: __webpack_require__(685),
  setQuarter: __webpack_require__(1575),
  setSeconds: __webpack_require__(1576),
  setYear: __webpack_require__(1577),
  startOfDay: __webpack_require__(146),
  startOfHour: __webpack_require__(686),
  startOfISOWeek: __webpack_require__(147),
  startOfISOYear: __webpack_require__(215),
  startOfMinute: __webpack_require__(687),
  startOfMonth: __webpack_require__(1578),
  startOfQuarter: __webpack_require__(688),
  startOfSecond: __webpack_require__(689),
  startOfToday: __webpack_require__(1579),
  startOfTomorrow: __webpack_require__(1580),
  startOfWeek: __webpack_require__(284),
  startOfYear: __webpack_require__(690),
  startOfYesterday: __webpack_require__(1581),
  subDays: __webpack_require__(1582),
  subHours: __webpack_require__(1583),
  subISOYears: __webpack_require__(691),
  subMilliseconds: __webpack_require__(1584),
  subMinutes: __webpack_require__(1585),
  subMonths: __webpack_require__(1586),
  subQuarters: __webpack_require__(1587),
  subSeconds: __webpack_require__(1588),
  subWeeks: __webpack_require__(1589),
  subYears: __webpack_require__(1590)
}


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var endOfDay = __webpack_require__(410)
var endOfMonth = __webpack_require__(668)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(146)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(674)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(675)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(676)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(677)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(678)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(679)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(680)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(414)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(681)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(146)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(146)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(146)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(683)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(145)
var startOfISOWeek = __webpack_require__(147)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 1562 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 1563 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(1562)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var addDays = __webpack_require__(212)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var addDays = __webpack_require__(212)
var getISODay = __webpack_require__(671)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var getISOWeek = __webpack_require__(412)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)
var setMonth = __webpack_require__(685)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(3)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(146)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(212)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(657)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(213)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(659)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(281)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(660)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(661)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(406)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(662)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(6);

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(63);

var _moment2 = _interopRequireDefault(_moment);

var _rpMqBreakpoints = __webpack_require__(65);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * RP1 Date Picker jQuery plugin
 *
 * @author Roman Kelemen <roman.kelemen@racingpost.com>
 */
(function ($, moment, _, breakpoints) {
    'use strict';

    /**
     * Default configuration options
     * @type {Object}
     */

    var defaults = {
        date: null,
        minDate: null,
        maxDate: null,
        monthPickerAutoClose: false,
        monthAutoPick: false,
        initFromMonthPicker: false,
        weekStart: 1,
        autoOpen: false,
        autoClose: false,
        track: false,
        template: '',
        zIndex: 1000,
        container: null,
        placement: 'body',
        triggers: {
            today: 'ui-datePicker__calendar__btnToday',
            date: 'ui-datePicker__item_day',
            month: 'ui-datePicker__item_month',
            year: 'ui-datePicker__item_year',
            nextMonth: 'ui-datePicker__stepSelect__right',
            prevMonth: 'ui-datePicker__stepSelect__left',
            nextYears: 'ui-datePicker__stepper__right',
            prevYears: 'ui-datePicker__stepper__left',
            pickMonth: 'ui-datePicker__stepSelect__central',
            pickDate: 'ui-datePicker__backBlock',
            selectMonth: 'ui-datePicker__backSection__btnSelect',
            close: 'ui-datePicker__closeBlock'
        },
        css: {
            picker: 'ui-datePicker',
            pickerInline: 'ui-datePicker_inline',
            pointer: 'ui-datePicker__pointer',
            pointerInvert: 'ui-datePicker__pointer_top',
            datePicker: 'ui-datePicker__frontSection',
            monthPicker: 'ui-datePicker__backSection',
            dateDisabled: 'ui-datePicker__item_disabled',
            dateSelected: 'ui-datePicker__item_active',
            datePast: 'ui-datePicker__item_inactive',
            dateFuture: 'ui-datePicker__item_inactive',
            stepDisabled: 'ui-btn_secondary--disabled',
            monthSelected: 'ui-datePicker__item_active',
            monthDisabled: 'ui-datePicker__item_disabled',
            yearSelected: 'ui-datePicker__item_active',
            yearDisabled: 'ui-datePicker__item_disabled'
        },
        position: {
            my: 'center top+8',
            at: 'center bottom',
            collision: 'flipfit'
        },
        pointerPosition: {
            my: 'center-12 top',
            at: 'center bottom'
        }
    };

    /**
     * Default template
     *
     * @type {string}
     */
    var template = '\
        <div class="ui-datePicker__pointer"></div>\
        <div class="ui-datePicker__closeBlock ui-btn ui-btn_tiertiary">\
            <svg class="ui-datePicker__close ui-icon ui-icon_sizeMedium">\
                <use xlink:href="img/icons.svg#icon-cross"/>\
            </svg>\
        </div>\
        <div class="ui-datePicker__frontSection">\
            <div class="ui-datePicker__header ui-datePicker__header_calendar">\
                <span class="ui-datePicker__caption">Select Date</span>\
            </div>\
            <div class="ui-datePicker__calendar">\
                <div class="ui-datePicker__stepSelect ui-btnGroup">\
                    <a href="#" class="ui-datePicker__stepSelect__left ui-btn ui-btn_tiertiary" data-test-selector="button-calendarMonthLeft">\
                        <svg class="ui-icon ui-icon_sizeMedium">\
                            <use xlink:href="img/icons.svg#icon-left"/>\
                        </svg>\
                    </a>\
                    <a href="#" class="ui-datePicker__stepSelect__central ui-btn ui-btn_tiertiary" data-test-selector="link-calendarGoToMonthYear" >\
                        <span><%=viewDate.format("MMMM YYYY") %></span>\
                        <svg class="ui-icon ui-icon_sizeMedium ui-datePicker__centralIcon">\
                            <use xlink:href="img/icons.svg#icon-down"/>\
                        </svg>\
                    </a>\
                    <a href="#" class="ui-datePicker__stepSelect__right ui-btn ui-btn_tiertiary" data-test-selector="button-calendarMonthRight">\
                        <svg class="ui-icon ui-icon_sizeMedium">\
                            <use xlink:href="img/icons.svg#icon-right"/>\
                        </svg>\
                    </a>\
                </div>\
                <div class="ui-datePicker__calendar__footer">\
                    <div class="ui-datePicker__calendar__btnToday ui-btn ui-btn_primary" data-test-selector="link-calendarToday">Today</div>\
                </div>\
                <table class="ui-datePicker__calendar__block">\
                    <thead>\
                        <tr>\
                            <% for(var i = 0; i < week.length; i++) { %>\
                            <td class="ui-datePicker__calendar__cell"><%=week[i] %></td>\
                            <% } %>\
                        </tr>\
                    </thead>\
                    <tbody class="ui-datePicker__calendar__body">\
                        <% for(var i = 0; i < dates.length; i++) { %>\
                        <tr class="ui-datePicker__row">\
                            <% for(var j = 0; j < 7; j++) { %>\
                            <td class="ui-datePicker__cell">\
                                <a href="#" class="ui-datePicker__item ui-datePicker__item_day <%=dates[i][j].classes.join(" ") %>" data-date="<%=dates[i][j].data %>" data-test-selector="link-calendarDate"><%=dates[i][j].label %></a>\
                            </td>\
                            <% } %>\
                        </tr>\
                        <% } %>\
                    </tbody>\
                </table>\
            </div>\
        </div>\
        <div class="ui-datePicker__backSection">\
            <div class="ui-datePicker__header">\
                <div class="ui-datePicker__backBlock ui-btn ui-btn_tiertiary">\
                    <svg class="ui-datePicker__back ui-icon ui-icon_sizeMedium">\
                        <use xlink:href="img/icons.svg#icon-left"/>\
                    </svg>\
                </div>\
                <span class="ui-datePicker__caption">Choose Month</span>\
            </div>\
            <div class="ui-datePicker__months">\
                <table class="ui-datePicker__months__block">\
                    <% for(var i = 0; i < 2; i++) { %>\
                    <tr class="ui-datePicker__row">\
                        <% for(var j = 0; j < 6; j++) { %>\
                        <td class="ui-datePicker__cell ui-datePicker__months__cell">\
                            <a href="#" class="ui-datePicker__item ui-datePicker__item_month <%= months[i][j].classes.join(" ") %>" data-month="<%= months[i][j].data %>" data-test-selector="link-calendarMonthSelect"><%= months[i][j].label %></a>\
                        </td>\
                        <% } %>\
                    </tr>\
                    <% } %>\
                </table>\
            </div>\
            <div class="ui-datePicker__header ui-datePicker__header_years">\
                <span class="ui-datePicker__caption">Choose Year</span>\
            </div>\
            <div class="ui-datePicker__years">\
                <table class="ui-datePicker__years__block">\
                    <% for(var i = 0; i < 2; i++) { %>\
                    <tr class="ui-datePicker__row">\
                    <% for(var j = 0; j < 3; j++) { %>\
                    <td class="ui-datePicker__cell ui-datePicker__years__cell">\
                    <a href="#" class="ui-datePicker__item ui-datePicker__item_year <%= years[i][j].classes.join(" ") %>" data-year="<%= years[i][j].data %>" data-test-selector="link-calendarYearSelect"><%= years[i][j].label %></a>\
                    </td>\
                    <% } %>\
                    </tr>\
                    <% } %>\
                </table>\
                <div class="ui-datePicker__years__footer">\
                    <div class="ui-datePicker__stepper ui-btnGroup">\
                        <a href="#" class="ui-datePicker__stepper__left ui-btn ui-btn_secondary" data-test-selector="button-calendarYearMonthLeft">\
                            <svg class="ui-icon ui-icon_sizeMedium">\
                                <use xlink:href="img/icons.svg#icon-left"/>\
                            </svg>\
                        </a>\
                        <a href="#" class="ui-datePicker__stepper__right ui-btn ui-btn_secondary" data-test-selector="button-calendarYearMonthRight">\
                            <svg class="ui-icon ui-icon_sizeMedium">\
                                <use xlink:href="img/icons.svg#icon-right"/>\
                            </svg>\
                        </a>\
                    </div>\
                    <div class="ui-datePicker__backSection__btnSelect ui-btn ui-btn_primary" data-test-selector="link-calendarYearMonthSelect">Select</div>\
                </div>\
            </div>\
        </div>';

    /**
     * Plugin name
     *
     * @type {string}
     */
    var pluginName = 'datePicker';

    /**
     * Plugin constructor
     *
     * @param {HTMLElement|jQuery} element Bound element
     * @param {Object} options Instance configuration
     *
     * @constructor
     */
    function DatePicker(element, options) {
        this.element = $(element);
        this.options = $.extend(true, {}, defaults, options);
        this.options.css = $.extend({}, defaults.css, $.fn[pluginName].css, options ? options.css : {});
        this.options.triggers = $.extend({}, defaults.triggers, $.fn[pluginName].triggers, options ? options.triggers : {});

        this._container = null;
        if (this.options.container) {
            this._container = $(this.options.container);
        }

        this._minDate = null;
        if (this.options.minDate) {
            this._minDate = moment(this.options.minDate).startOf('day');
        }

        this._maxDate = null;
        if (this.options.maxDate) {
            var maxDate = moment(this.options.maxDate);
            if (!this._minDate || maxDate.subtract(1, 'day').isAfter(this._minDate)) {
                this._maxDate = moment(this.options.maxDate).endOf('day');
            }
        }

        this._date = null;
        if (this.options.date && this.isValid(this.options.date)) {
            this._date = moment(this.options.date);
        }

        if (this._date) {
            this.currentDate(this._date, true);
        } else {
            this.currentDate(moment(), true);
        }

        this._monthPicker = this.options.initFromMonthPicker === true;
        this._monthPickerDate = this.currentDate();
        this._yearsPage = undefined;

        this.saveState();

        this.picker = $('<div class="' + this.options.css.picker + '"></div>');
        this.picker.hide().css('z-index', this.options.zIndex);

        if (this._container) {
            this.picker.addClass(this.options.css.pickerInline);
            this.picker.appendTo(this._container);
        } else {
            this.picker.appendTo(this.options.placement);
        }

        this.breakpoints = breakpoints;
        this.breakpoint = this.breakpoints.current();

        this.init();
    }

    /**
     * Save datepicker state
     */
    DatePicker.prototype.saveState = function () {
        this._initial = {
            date: this.date(),
            current: this.currentDate(),
            minDate: this.minDate(),
            maxDate: this.maxDate()
        };
    };

    /**
     * Reset to initial state
     */
    DatePicker.prototype.restoreState = function () {
        this._minDate = this._initial.minDate;
        this._maxDate = this._initial.maxDate;
        this._currentDate = this._initial.current;
        this._date = this._initial.date;

        this.element.trigger('restoreState.rp.datePicker');
        this.render(true);
    };

    /**
     * Initialise basic functionality
     */
    DatePicker.prototype.init = function () {
        this.bindEvents();
        this.render();
        if (this.options.autoOpen) {
            this.show();
        }
    };

    /**
     * Destroy plugin instance. Unbind events, remove DOM
     */
    DatePicker.prototype.destroy = function () {
        this.picker.remove();
        this.element.off('.rp.datePicker');
        $('body').off('.rp.datePicker');
        $.data(this.element, pluginName, null);
    };

    /**
     * Get or set minimum date
     *
     * @param {Moment|String=} minDate Optionally, set minimum date.
     * @returns {Moment|null|void} If argument ommited, returns current minimum date
     */
    DatePicker.prototype.minDate = function (minDate) {
        if (minDate === undefined) {
            return this._minDate ? moment(this._minDate) : null;
        }

        minDate = moment(minDate);
        if (!minDate.isAfter(moment(this._maxDate), 'day')) {
            this._minDate = minDate.startOf('day');
            if (!this.isValid(this._date)) {
                this.reset();
            }
            this.render(true);
        }
    };

    /**
     * Get or set maximum date
     *
     * @param {Moment|String=} maxDate Optionally, set maximum date.
     * @returns {Moment|null|void} If argument ommited, returns current maximum date
     */
    DatePicker.prototype.maxDate = function (maxDate) {
        if (maxDate === undefined) {
            return this._maxDate ? moment(this._maxDate) : null;
        }

        maxDate = moment(maxDate);
        if (!maxDate.isBefore(moment(this._minDate), 'day')) {
            this._maxDate = maxDate.endOf('day');
            if (!this.isValid(this._date)) {
                this.reset();
            }
            this.render(true);
        }
    };

    /**
     * Checks, if given date is valid
     *
     * @param {Moment|String} date Date to check
     * @returns {boolean} TRUE if date is valid, FALSE otherwise
     */
    DatePicker.prototype.isValid = function (date) {
        var check = moment(date);

        if (this._minDate && this._maxDate) {
            return this._minDate <= check && this._maxDate >= check;
        } else if (this._maxDate) {
            return this._maxDate >= check;
        } else if (this._minDate) {
            return this._minDate <= check;
        }

        return true;
    };

    /**
     * Bind handlers to handle required events
     */
    DatePicker.prototype.bindEvents = function () {
        this.picker.on('click', '.' + this.options.triggers.today, { context: this }, this.today);
        this.picker.on('click', '.' + this.options.triggers.date + ':not(.disabled)', { context: this }, this.date);
        this.picker.on('click', '.' + this.options.triggers.month, { context: this }, this.month);
        this.picker.on('click', '.' + this.options.triggers.year, { context: this }, this.year);
        this.picker.on('click', '.' + this.options.triggers.nextMonth + ':not(.disabled)', { context: this }, this.nextMonth);
        this.picker.on('click', '.' + this.options.triggers.prevMonth + ':not(.disabled)', { context: this }, this.prevMonth);
        this.picker.on('click', '.' + this.options.triggers.nextYears, { context: this }, this.nextYears);
        this.picker.on('click', '.' + this.options.triggers.prevYears, { context: this }, this.prevYears);
        this.picker.on('click', '.' + this.options.triggers.pickMonth, { context: this }, this.pickMonth);
        this.picker.on('click', '.' + this.options.triggers.pickDate, { context: this }, this.pickDate);
        this.picker.on('click', '.' + this.options.triggers.selectMonth, { context: this }, this.selectMonth);
        this.picker.on('click', '.' + this.options.triggers.close, { context: this }, this.hide);

        this.element.on('click.rp.datePicker', { context: this }, this.toggle);

        $(window).on('resize.rp.datePicker', this._onWindowResize());
        $(window).on('scroll.rp.datePicker', _lodash2.default.throttle(this.position.bind(this), 50));
        $(window).on('rpBreakpointsSwitch', this._onBreakpoint());
        $('body').on('click', { context: this }, function (event) {
            var skip = event.originalEvent && event.originalEvent.keepShown === event.data.context || $(event.target).is(event.data.context.element) || $.contains(event.data.context.picker[0], event.target) || $.contains(event.data.context.element[0], event.target);
            if (skip) {
                return;
            }

            event.data.context.hide();
        });
    };

    /**
     * Open picker if it is hidden, or hide it, if it is opened
     * If called as event handler, event object passed as first argument.
     *
     * @param {Event=} event Optionally, Event object
     */
    DatePicker.prototype.toggle = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.data.context.toggle();
            return;
        }

        if (this.picker.is(':visible')) {
            this.hide();
        } else {
            this.show();
        }
    };

    /**
     * Open picker
     */
    DatePicker.prototype.show = function () {
        var event = $.Event('show.rp.datePicker');
        this.element.trigger(event);
        if (!event.isDefaultPrevented()) {
            if (this._container && !this._container.is(this.picker.parent())) {
                this._container.append(this.picker);
            }

            this.picker.show();
            this.position();
            this.element.trigger('shown.rp.datePicker');
        }
    };

    /**
     * Hide picker
     * If called as event handler, event object passed as first argument.
     *
     * @param {Event=} event Optionally, event object
     */
    DatePicker.prototype.hide = function (event) {
        if (event && event.preventDefault) {
            if ($(event.data.context.picker).is(':visible') && !event.data.context._container) {
                event.preventDefault();
                event.data.context.hide();
            }

            return;
        }

        event = $.Event('hide.rp.datePicker');
        this.element.trigger(event);
        if (!event.isDefaultPrevented() && this.picker.is(':visible')) {
            this.picker.hide();
            this.element.trigger('hidden.rp.datePicker');
        }
    };

    /**
     * Set selected and view date to today
     * If called as event handler, event object passed as first argument.
     *
     * @param event Optionally, event object
     */
    DatePicker.prototype.today = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.today();
            return;
        }

        var today = moment();

        this.currentDate(today);
        this.date(today, this.options.autoClose);
    };

    /**
     * Get or set selected date
     *
     * @param {Moment|String|null|Event=} date Optionally. If called as event, this is event object.
     * If called directly, this param should contain date to select
     * @param {Boolean=} close Optionally. Close auto picker after success change
     *
     * @return {Moment|void} If called without parameters, method will return currently selected date
     */
    DatePicker.prototype.date = function (date, close) {
        if (date === undefined) {
            return this._date ? moment(this._date) : null;
        }

        if (date.data && date.data.context) {
            date.preventDefault();
            date.originalEvent.keepShown = date.data.context;
            date.data.context.date($(this).data('date'), date.data.context.options.autoClose);
            return;
        }

        if (this.isValid(date)) {
            var oldDate = this.date(),
                newDate = moment(date),
                event = $.Event('change.rp.datePicker');

            this.element.trigger(event, [newDate, oldDate]);

            if (!event.isDefaultPrevented()) {
                this._date = moment(date);
                this._currentDate = moment(this._date);

                if (close) {
                    this.hide();
                }

                this.render();
            }
        }
    };

    /**
     * Deselect selected date
     */
    DatePicker.prototype.reset = function () {
        var oldDate = this.date();
        this._date = null;
        this.element.trigger('reset.rp.datePicker', [oldDate]);

        this.render();
    };

    /**
     * Set current (view) date
     *
     * @param {Moment|String=} date Date to view
     * @param {Boolean=} noRender Optionally, picker after changing view date. Default is false, that means that
     * picker will be re-rendered automatically
     */
    DatePicker.prototype.currentDate = function (date, noRender) {
        if (!date) {
            return moment(this._currentDate);
        } else {
            date = moment(date);

            if (this._minDate) {
                date = moment.max(date, this._minDate);
            }

            if (this._maxDate) {
                date = moment.min(date, this._maxDate);
            }

            this._yearsPage = undefined;
            this._currentDate = date;
            if (!noRender) {
                this.render();
            }
        }
    };

    /**
     * Get or set view month
     *
     * @param {Moment|String|Event=} month Optionally. If called as event, this is event object.
     * If called directly, this param should contain zero-based index of month to view
     *
     * @return {Number|void} If called without parameters, method will return current view month as zero-based number
     */
    DatePicker.prototype.month = function (month) {
        if (month === undefined) {
            return this._currentDate.month();
        }

        if (month.data && month.data.context) {
            month.preventDefault();
            month.data.context.month($(this).data('month'));
            month.originalEvent.keepShown = month.data.context;
            return;
        }

        var currentDate = moment(this._currentDate).month(month);
        this.currentDate(currentDate, true);
        if (this.options.monthPickerAutoClose) {
            this.pickDate();
        }

        this.render();
    };

    /**
     * Get or set view year
     *
     * @param {Moment|String|Event=} year Optionally. If called as event, this is event object.
     * If called directly, this param should contain view year
     *
     * @return {Number|void} If called without parameters, method will return current view year
     */
    DatePicker.prototype.year = function (year) {
        if (year === undefined) {
            return this._currentDate.year();
        }

        if (year.data && year.data.context) {
            year.preventDefault();
            year.data.context.year($(this).data('year'));
            year.originalEvent.keepShown = year.data.context;
            return;
        }

        var currentDate = moment(this._currentDate).year(year);
        this.currentDate(currentDate, true);
        if (this.options.monthPickerAutoClose) {
            this.pickDate();
        }

        this.render();
    };

    /**
     * Go to next years page
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.nextYears = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.nextYears();
            return;
        }

        if (this._maxDate && this._yearsPage >= this._getYearPage(this._maxDate.year())) {
            this._yearsPage = this._getYearPage(this._maxDate.year());
        } else {
            this._yearsPage++;
        }

        this.render();
    };

    /**
     * Go to previous years page
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.prevYears = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.prevYears();
            return;
        }

        if (this._minDate && this._yearsPage <= this._getYearPage(this._minDate.year())) {
            this._yearsPage = this._getYearPage(this._minDate.year());
        } else {
            this._yearsPage--;
        }

        this.render();
    };

    /**
     * Go to next month view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.nextMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.nextMonth();
            return;
        }

        this.currentDate(this.currentDate().add(1, 'month'));
    };

    /**
     * Go to previous month view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.prevMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.prevMonth();
            return;
        }

        this.currentDate(this.currentDate().subtract(1, 'month'));
    };

    /**
     * Open month picker view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.pickMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.pickMonth();
            return;
        }

        this._yearsPage = undefined;
        this._monthPicker = true;
        this._monthPickerDate = this.currentDate();
        this.render();
    };

    /**
     * Open date picker view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.pickDate = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.pickDate();
            return;
        }

        this._monthPicker = false;
        if (!this.options.monthPickerAutoClose && !this.options.monthAutoPick) {
            this.currentDate(this._monthPickerDate);
        }

        this.render();
    };

    /**
     * Select month and close month picker
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.selectMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.selectMonth();
            return;
        }

        this._monthPicker = false;
        this.render();
    };

    /**
     * Render date picker
     * @param {Boolean=} force Optionally, force render
     */
    DatePicker.prototype.render = function (force) {
        var self = this;
        var tpl = this.options.template ? this.options.template : $.fn[pluginName].template ? $.fn[pluginName].template : template;

        var compiled = _.template(tpl),
            renderHtml = function renderHtml() {
            self.picker.html(compiled({
                dates: self.buildDates(),
                months: self.buildMonths(),
                years: self.buildYears(),
                week: self.buildWeek(),
                viewDate: self.currentDate()
            }));

            self.picker.data('currentDate', self.currentDate());
            self.picker.data('yearsPage', self._yearsPage);

            self.position();
        },
            updateMonthView = function updateMonthView() {
            var datePicker, monthPicker;

            datePicker = self.picker.find('.' + self.options.css.datePicker);
            monthPicker = self.picker.find('.' + self.options.css.monthPicker);
            if (self._monthPicker) {
                monthPicker.show();
                datePicker.hide();
            } else {
                monthPicker.hide();
                datePicker.show();
            }
        },
            updateMonthStep = function updateMonthStep() {
            if (!self.isValid(self.currentDate().add(1, 'month').startOf('month'))) {
                self.picker.find('.' + self.options.triggers.nextMonth).addClass(self.options.css.stepDisabled);
            }

            if (!self.isValid(self.currentDate().subtract(1, 'month').endOf('month'))) {
                self.picker.find('.' + self.options.triggers.prevMonth).addClass(self.options.css.stepDisabled);
            }
        },
            updateYearStep = function updateYearStep() {
            var prevYears = self.picker.find('.' + self.options.triggers.prevYears),
                nextYears = self.picker.find('.' + self.options.triggers.nextYears);

            prevYears.removeClass(self.options.css.stepDisabled);
            nextYears.removeClass(self.options.css.stepDisabled);

            if (self._minDate && self._yearsPage <= self._getYearPage(self._minDate.year())) {
                self._yearsPage = self._getYearPage(self._minDate.year());
                prevYears.addClass(self.options.css.stepDisabled);
            }

            if (self._maxDate && self._yearsPage >= self._getYearPage(self._maxDate.year())) {
                self._yearsPage = self._getYearPage(self._maxDate.year());
                nextYears.addClass(self.options.css.stepDisabled);
            }
        };

        renderHtml();
        updateMonthView();
        updateMonthStep();
        updateYearStep();
    };

    /**
     * Build months matrix
     * @returns {Array} Matrix of months
     */
    DatePicker.prototype.buildMonths = function () {
        var months = moment.monthsShort(),
            selectedMonth = this.currentDate().format('MMM'),
            rows = [],
            row,
            month;

        for (var i = 0; i < 2; i++) {
            row = [];
            for (var j = 0; j < 6; j++) {
                var key = 6 * i + j;
                month = {
                    data: key,
                    label: months[key],
                    classes: []
                };
                var check = this.currentDate().month(key);

                if (this._minDate && this._minDate.isAfter(check, 'month')) {
                    month.classes.push(this.options.css.monthDisabled);
                } else if (this._maxDate && this._maxDate.isBefore(check, 'month')) {
                    month.classes.push(this.options.css.monthDisabled);
                } else if (months[key] == selectedMonth) {
                    month.classes.push(this.options.css.monthSelected);
                }

                row.push(month);
            }
            rows.push(row);
        }

        return rows;
    };

    /**
     * Build years matrix
     * @returns {Array} Matrix of years
     */
    DatePicker.prototype.buildYears = function () {
        var current = this.currentDate(),
            view = moment(),
            rows = [],
            offset,
            row;

        if (this._yearsPage === undefined) {
            this._yearsPage = this._getYearPage();
        }

        offset = this._yearsPage * 6 - 3;
        view.add(offset, 'year');
        for (var i = 0; i < 2; i++) {
            row = [];
            for (var j = 0; j < 3; j++) {
                var year = {
                    data: view.year(),
                    label: view.format('YYYY'),
                    classes: []
                };

                if (this._minDate && this._minDate.year() > view.year()) {
                    year.classes.push(this.options.css.yearDisabled);
                } else if (this._maxDate && this._maxDate.year() < view.year()) {
                    year.classes.push(this.options.css.yearDisabled);
                } else if (view.year() == current.year()) {
                    year.classes.push(this.options.css.yearSelected);
                }

                row.push(year);
                view.add(1, 'year');
            }

            rows.push(row);
        }

        return rows;
    };

    /**
     * Calculate years page
     *
     * @returns {Number} page of current viewed year
     */
    DatePicker.prototype._getYearPage = function (year) {
        year = year ? year : this.currentDate().year();

        var diff = year - moment().year() - 2;
        return Math.ceil(diff / 6);
    };

    /**
     * Build days matrix
     * @returns {Array} Matrix of years
     */
    DatePicker.prototype.buildDates = function () {
        var css = this.options.css,
            current = this.currentDate(),
            origin = this.currentDate(),
            selected = this.date(),
            days = current.daysInMonth(),
            offset = current.startOf('month').day() - this.options.weekStart,
            rows,
            dates,
            date;

        offset = offset < 0 ? 6 : offset;

        current.subtract(offset, 'days');
        rows = [];
        for (var i = 0, lines = Math.ceil((days + offset) / 7); i < lines; i++) {
            dates = [];
            for (var j = 0; j < 7; j++) {
                date = {
                    data: current.format('YYYY-MM-DD'),
                    label: current.format('D'),
                    moment: moment(current),
                    classes: []
                };

                if (!this.isValid(current)) {
                    date.classes.push(css.dateDisabled);
                } else if (current.isSame(selected, 'day')) {
                    date.classes.push(css.dateSelected);
                }

                if (i === 0 && j < offset) {
                    date.classes.push(css.datePast);
                } else if (current.month() != origin.month()) {
                    date.classes.push(css.dateFuture);
                }

                dates.push(date);
                current.add(1, 'days');
            }
            rows.push(dates);
        }

        return rows;
    };

    /**
     * Build week days array
     * @returns {Array} Array of week days abbreviations
     */
    DatePicker.prototype.buildWeek = function () {
        var weekDays = moment.weekdaysMin();
        if (this.options.weekStart) {
            weekDays = weekDays.concat(weekDays.splice(0, this.options.weekStart));
        }

        return weekDays;
    };

    /**
     * Place datePicker in configured position
     */
    DatePicker.prototype.position = function () {
        var position = this.options.position,
            track = this.options.track,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop,
            pointerPosition = this.options.pointerPosition,
            pointer = this.picker.find('.' + this.options.css.pointer);

        if (!position.of) {
            position.of = this.element;
        }

        if (!pointerPosition.of) {
            pointerPosition.of = position.of;
        }

        var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
            EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW;

        var wideScreen = [NARROW, EXTRA_NARROW].indexOf(this.breakpoint.code) === -1;

        if (wideScreen && !this._container) {
            this.picker.position(position);
            pointer.position(pointerPosition);
            pointer.css('top', 0);
            if (this.picker.offset().top < this.element.offset().top) {
                pointer.addClass(this.options.css.pointerInvert);
            } else {
                pointer.removeClass(this.options.css.pointerInvert);
            }
        } else {
            if (track) {
                this.picker.css('top', scrollTop).css('left', '');
            } else {
                this.picker.css('top', '').css('left', '');
            }
        }
    };

    /**
     * Change container of datepicker
     */
    DatePicker.prototype.container = function (selector) {
        if (!selector) {
            this._container = null;
            this.picker.removeClass(this.options.css.pickerInline);
            this.picker.appendTo(this.options.placement);
        } else {
            this._container = $(selector);
            this.picker.addClass(this.options.css.pickerInline);
            this.picker.appendTo(this._container);
        }

        this.position();
    };

    /**
     * Window resize event handler
     * Should perform repositioning of picker
     *
     * @returns {Function} Event handler
     * @private
     */
    DatePicker.prototype._onWindowResize = function () {
        var self = this,
            tm = null;

        return function () {
            clearTimeout(tm);

            tm = setTimeout(function () {
                self.position();
            }, 100);
        };
    };

    /**
     * Breakpoint change event
     * Should perform repositioning of picker
     *
     * @returns {Function} Event handler
     * @private
     */
    DatePicker.prototype._onBreakpoint = function () {
        var self = this;

        return function (event) {
            self.breakpoint = event.detail.breakpoint;
        };
    };

    /**
     * Register plugin function
     *
     * @param params
     * @returns {$.fn}
     */
    $.fn[pluginName] = function (params) {
        var args = Array.prototype.slice.call(arguments, 1);
        var getterResult;

        this.each(function () {
            var object = $.data(this, pluginName);
            if (!object) {
                $.data(this, pluginName, new DatePicker(this, params));
            } else if (params && params != '_' && object[params]) {
                getterResult = object[params].apply(object, args);
            } else {
                object.show();
            }
        });

        return getterResult !== undefined ? getterResult : this;
    };

    /**
     * Global CSS styles
     * @type {Object}
     */
    $.fn[pluginName].css = {};

    /**
     * Global triggers
     * @type {Object}
     */
    $.fn[pluginName].triggers = {};

    /**
     * Global template
     * @type {Object}
     */
    $.fn[pluginName].template = '';
})(_jquery2.default, _moment2.default, _lodash2.default, _rpMqBreakpoints2.default);

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(1594);
var isArguments = __webpack_require__(1593);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 1593 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1763 */,
/* 1764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(46);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(229);

var _ExecutionEnvironment = __webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(2308);
module.exports = self.fetch.bind(self);


/***/ }),
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1839 */,
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(177);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(232),
    isIterateeCall = __webpack_require__(1880);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(466),
    flatRest = __webpack_require__(795),
    getData = __webpack_require__(477),
    getFuncName = __webpack_require__(798),
    isArray = __webpack_require__(49),
    isLaziable = __webpack_require__(802);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 1860 */,
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(1840),
    getTag = __webpack_require__(178),
    mapToArray = __webpack_require__(804),
    setToPairs = __webpack_require__(1903);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(314),
    isArrayLike = __webpack_require__(156),
    isIndex = __webpack_require__(310),
    isObject = __webpack_require__(89);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(473),
    copyObject = __webpack_require__(234),
    createAssigner = __webpack_require__(1853),
    isArrayLike = __webpack_require__(156),
    isPrototype = __webpack_require__(311),
    keys = __webpack_require__(157);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(232),
    createWrap = __webpack_require__(308),
    getHolder = __webpack_require__(478),
    replaceHolders = __webpack_require__(313);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(1817),
    baseRest = __webpack_require__(232),
    toNumber = __webpack_require__(490);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1821),
    hasPath = __webpack_require__(801);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(783),
    getMatchData = __webpack_require__(799);

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(474),
    baseForOwn = __webpack_require__(778),
    baseIteratee = __webpack_require__(231);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(774),
    baseEach = __webpack_require__(305),
    baseIteratee = __webpack_require__(231),
    baseReduce = __webpack_require__(1838),
    isArray = __webpack_require__(49);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(1861),
    keys = __webpack_require__(157);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */
/***/ (function(module, exports) {

/**
 * Secure random string generator with custom alphabet.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {generator} random The random bytes generator.
 * @param {string} alphabet Symbols to be used in new random string.
 * @param {size} size The number of symbols in new random string.
 *
 * @return {string} Random string.
 *
 * @example
 * const format = require('nanoid/format')
 *
 * function random (size) {
 *   const result = []
 *   for (let i = 0; i < size; i++) {
 *     result.push(randomByte())
 *   }
 *   return result
 * }
 *
 * format(random, "abcdef", 5) //=> "fbaef"
 *
 * @name format
 * @function
 */
module.exports = function (random, alphabet, size) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  var step = Math.ceil(1.6 * mask * size / alphabet.length)

  var id = ''
  while (true) {
    var bytes = random(step)
    for (var i = 0; i < step; i++) {
      var byte = bytes[i] & mask
      if (alphabet[byte]) {
        id += alphabet[byte]
        if (id.length === size) return id
      }
    }
  }
}

/**
 * @callback generator
 * @param {number} bytes The number of bytes to generate.
 * @return {number[]} Random bytes.
 */


/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  center: _propTypes2.default.any,
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  radius: _propTypes2.default.number,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCenterChanged: "center_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRadiusChanged: "radius_changed",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(circle) {
    return circle.getBounds();
  },
  getCenter: function getCenter(circle) {
    return circle.getCenter();
  },
  getDraggable: function getDraggable(circle) {
    return circle.getDraggable();
  },
  getEditable: function getEditable(circle) {
    return circle.getEditable();
  },
  getMap: function getMap(circle) {
    return circle.getMap();
  },
  getRadius: function getRadius(circle) {
    return circle.getRadius();
  },
  getVisible: function getVisible(circle) {
    return circle.getVisible();
  }
};

var controlledPropUpdaterMap = {
  center: function center(circle, _center) {
    circle.setCenter(_center);
  },
  draggable: function draggable(circle, _draggable) {
    circle.setDraggable(_draggable);
  },
  editable: function editable(circle, _editable) {
    circle.setEditable(_editable);
  },
  options: function options(circle, _options) {
    circle.setOptions(_options);
  },
  radius: function radius(circle, _radius) {
    circle.setRadius(_radius);
  },
  visible: function visible(circle, _visible) {
    circle.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.CIRCLE];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Circle",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
    var circle = new google.maps.Circle((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.CIRCLE, circle);
  },
  componentWillUnmount: function componentWillUnmount() {
    var circle = getInstanceFromComponent(this);
    if (circle) {
      circle.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  directions: _propTypes2.default.any,
  options: _propTypes2.default.object,
  panel: _propTypes2.default.object,
  routeIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onDirectionsChanged: "directions_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDirections: function getDirections(directionsRenderer) {
    return directionsRenderer.getDirections();
  },
  getPanel: function getPanel(directionsRenderer) {
    return directionsRenderer.getPanel();
  },
  getRouteIndex: function getRouteIndex(directionsRenderer) {
    return directionsRenderer.getRouteIndex();
  }
};

var controlledPropUpdaterMap = {
  directions: function directions(directionsRenderer, _directions) {
    directionsRenderer.setDirections(_directions);
  },
  options: function options(directionsRenderer, _options) {
    directionsRenderer.setOptions(_options);
  },
  panel: function panel(directionsRenderer, _panel) {
    directionsRenderer.setPanel(_panel);
  },
  routeIndex: function routeIndex(directionsRenderer, _routeIndex) {
    directionsRenderer.setRouteIndex(_routeIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.DIRECTIONS_RENDERER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "DirectionsRenderer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
    var directionsRenderer = new google.maps.DirectionsRenderer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.DIRECTIONS_RENDERER, directionsRenderer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var directionsRenderer = getInstanceFromComponent(this);
    if (directionsRenderer) {
      directionsRenderer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
    // NOTICE!!!!!!
    //
    // Only expose those with getters & setters in the table as controlled props.
    //
    // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
    //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
    //
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    options: _propTypes2.default.object
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
    onClick: "click"
};

var publicMethodMap = {
    // Public APIs
    //
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    //
    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
    //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
    // END - Public APIs
};

var controlledPropUpdaterMap = {
    options: function options(fusionTablesLayer, _options) {
        fusionTablesLayer.setOptions(_options);
    }
};

function getInstanceFromComponent(component) {
    return component.state[_constants.FUSION_TABLES_LAYER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
    displayName: "FusionTablesLayer",

    propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

    contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

    getInitialState: function getInitialState() {
        var fusionTablesLayer = new google.maps.FusionTablesLayer((0, _extends3.default)({
            map: this.context[_constants.MAP]
        }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));

        return (0, _defineProperty3.default)({}, _constants.FUSION_TABLES_LAYER, fusionTablesLayer);
    },
    componentWillUnmount: function componentWillUnmount() {
        var fusionTablesLayer = getInstanceFromComponent(this);
        if (fusionTablesLayer) {
            fusionTablesLayer.setMap(null);
        }
    },
    render: function render() {
        return false;
    }
});

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(1214);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _invariant = __webpack_require__(46);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  center: _propTypes2.default.object,

  heading: _propTypes2.default.number,

  mapTypeId: _propTypes2.default.any,

  options: _propTypes2.default.object,

  streetView: _propTypes2.default.any,

  tilt: _propTypes2.default.number,

  zoom: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onBoundsChanged: "bounds_changed",

  onCenterChanged: "center_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onHeadingChanged: "heading_changed",

  onIdle: "idle",

  onMapTypeIdChanged: "maptypeid_changed",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onProjectionChanged: "projection_changed",

  onResize: "resize",

  onRightClick: "rightclick",

  onTilesLoaded: "tilesloaded",

  onTiltChanged: "tilt_changed",

  onZoomChanged: "zoom_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(map) {
    return map.getBounds();
  },
  getCenter: function getCenter(map) {
    return map.getCenter();
  },
  getDiv: function getDiv(map) {
    return map.getDiv();
  },
  getHeading: function getHeading(map) {
    return map.getHeading();
  },
  getMapTypeId: function getMapTypeId(map) {
    return map.getMapTypeId();
  },
  getProjection: function getProjection(map) {
    return map.getProjection();
  },
  getStreetView: function getStreetView(map) {
    return map.getStreetView();
  },
  getTilt: function getTilt(map) {
    return map.getTilt();
  },
  getZoom: function getZoom(map) {
    return map.getZoom();
  },

  // END - Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // Public APIs - Use this carefully
  // See discussion in https://github.com/tomchentw/react-google-maps/issues/62
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return !it.match(/^get/) && !it.match(/^set/) && !it.match(/Map$/); })
  fitBounds: function fitBounds(map, args) {
    return map.fitBounds.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panBy: function panBy(map, args) {
    return map.panBy.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panTo: function panTo(map, args) {
    return map.panTo.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panToBounds: function panToBounds(map, args) {
    return map.panToBounds.apply(map, (0, _toConsumableArray3.default)(args));
  }
};

var controlledPropUpdaterMap = {
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
};

function getInstanceFromComponent(component) {
  return component.context[_constants.MAP];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "GoogleMap",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    var map = getInstanceFromComponent(this);

    (0, _invariant2.default)(!!map, "Did you wrap <GoogleMap> component with withGoogleMap() HOC?");

    map.setOptions((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
    return null;
  },
  render: function render() {
    var children = this.props.children;


    return _react2.default.createElement(
      "div",
      null,
      children
    );
  }
});

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _contextTypes; /* global google */


var _invariant = __webpack_require__(46);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _reactDom = __webpack_require__(91);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  children: _propTypes2.default.element,
  options: _propTypes2.default.object,
  position: _propTypes2.default.any,
  zIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCloseClick: "closeclick",

  onContentChanged: "content_changed",

  onDomReady: "domready",

  onPositionChanged: "position_changed",

  onZIndexChanged: "zindex_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getPosition: function getPosition(infoWindow) {
    return infoWindow.getPosition();
  },
  getZIndex: function getZIndex(infoWindow) {
    return infoWindow.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  children: function children(infoWindow, _children, component) {
    (0, _reactDom.unstable_renderSubtreeIntoContainer)(component, _react.Children.only(_children), infoWindow.getContent());
  },
  options: function options(infoWindow, _options) {
    infoWindow.setOptions(_options);
  },
  position: function position(infoWindow, _position) {
    infoWindow.setPosition(_position);
  },
  zIndex: function zIndex(infoWindow, _zIndex) {
    infoWindow.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.INFO_WINDOW];
}

function openInfoWindow(context, infoWindow) {
  var map = context[_constants.MAP];
  var anchor = context[_constants.ANCHOR];
  if (anchor) {
    infoWindow.open(map, anchor);
  } else if (infoWindow.getPosition()) {
    infoWindow.open(map);
  } else {
    (0, _invariant2.default)(false, "You must provide either an anchor (typically a <Marker>) or a position for <InfoWindow>.");
  }
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "InfoWindow",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _propTypes2.default.object), (0, _defineProperty3.default)(_contextTypes, _constants.ANCHOR, _propTypes2.default.object), _contextTypes),

  getInitialState: function getInitialState() {
    var map = this.context[_constants.MAP];
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
    var infoWindow = new google.maps.InfoWindow((0, _extends3.default)({
      map: map
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
      // Override props of ReactElement type
      content: undefined,
      children: undefined
    }));

    openInfoWindow(this.context, infoWindow);
    return (0, _defineProperty3.default)({}, _constants.INFO_WINDOW, infoWindow);
  },
  componentDidMount: function componentDidMount() {
    var infoWindow = getInstanceFromComponent(this);
    var content = document.createElement("div");

    controlledPropUpdaterMap.children({
      getContent: function getContent() {
        return content;
      }
    }, this.props.children, this);
    infoWindow.setContent(content);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var anchorChanged = this.context[_constants.ANCHOR] !== nextContext[_constants.ANCHOR];
    if (anchorChanged) {
      var infoWindow = getInstanceFromComponent(this);
      openInfoWindow(nextContext, infoWindow);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var infoWindow = getInstanceFromComponent(this);
    if (infoWindow) {
      (0, _reactDom.unmountComponentAtNode)(infoWindow.getContent());
      infoWindow.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  defaultViewport: _propTypes2.default.any,
  options: _propTypes2.default.any,
  metadata: _propTypes2.default.any,
  status: _propTypes2.default.any,
  url: _propTypes2.default.string,
  zIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDefaultViewportChanged: "defaultviewport_changed",

  onStatusChanged: "status_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDefaultViewport: function getDefaultViewport(kmlLayer) {
    return kmlLayer.getDefaultViewport();
  },
  getMetadata: function getMetadata(kmlLayer) {
    return kmlLayer.getMetadata();
  },
  getOptions: function getOptions(kmlLayer) {
    return kmlLayer.getOptions();
  },
  getStatus: function getStatus(kmlLayer) {
    return kmlLayer.getStatus();
  },
  getUrl: function getUrl(kmlLayer) {
    return kmlLayer.getUrl();
  },
  getZIndex: function getZIndex(kmlLayer) {
    return kmlLayer.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  defaultViewport: function defaultViewport(kmlLayer, _defaultViewport) {
    kmlLayer.setDefaultViewport(_defaultViewport);
  },
  metadata: function metadata(kmlLayer, _metadata) {
    kmlLayer.setMetadata(_metadata);
  },
  options: function options(kmlLayer, _options) {
    kmlLayer.setOptions(_options);
  },
  status: function status(kmlLayer, _status) {
    kmlLayer.setStatus(_status);
  },
  url: function url(kmlLayer, _url) {
    kmlLayer.setUrl(_url);
  },
  zIndex: function zIndex(kmlLayer, _zIndex) {
    kmlLayer.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.KML_LAYER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "KmlLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
    var kmlLayer = new google.maps.KmlLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.KML_LAYER, kmlLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var kmlLayer = getInstanceFromComponent(this);
    if (kmlLayer) {
      kmlLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _contextTypes; /* global google */


var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  animation: _propTypes2.default.any,

  attribution: _propTypes2.default.any,

  clickable: _propTypes2.default.bool,

  cursor: _propTypes2.default.string,

  draggable: _propTypes2.default.bool,

  icon: _propTypes2.default.any,

  label: _propTypes2.default.any,

  noRedraw: _propTypes2.default.bool,

  opacity: _propTypes2.default.number,

  options: _propTypes2.default.object,

  place: _propTypes2.default.any,

  position: _propTypes2.default.any,

  shape: _propTypes2.default.any,

  title: _propTypes2.default.string,

  visible: _propTypes2.default.bool,

  zIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onAnimationChanged: "animation_changed",

  onClick: "click",

  onClickableChanged: "clickable_changed",

  onCursorChanged: "cursor_changed",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDraggableChanged: "draggable_changed",

  onDragStart: "dragstart",

  onFlatChanged: "flat_changed",

  onIconChanged: "icon_changed",

  onMouseDown: "mousedown",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onPositionChanged: "position_changed",

  onRightClick: "rightclick",

  onShapeChanged: "shape_changed",

  onTitleChanged: "title_changed",

  onVisibleChanged: "visible_changed",

  onZindexChanged: "zindex_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getAnimation: function getAnimation(marker) {
    return marker.getAnimation();
  },
  getAttribution: function getAttribution(marker) {
    return marker.getAttribution();
  },
  getClickable: function getClickable(marker) {
    return marker.getClickable();
  },
  getCursor: function getCursor(marker) {
    return marker.getCursor();
  },
  getDraggable: function getDraggable(marker) {
    return marker.getDraggable();
  },
  getIcon: function getIcon(marker) {
    return marker.getIcon();
  },
  getLabel: function getLabel(marker) {
    return marker.getLabel();
  },
  getOpacity: function getOpacity(marker) {
    return marker.getOpacity();
  },
  getPlace: function getPlace(marker) {
    return marker.getPlace();
  },
  getPosition: function getPosition(marker) {
    return marker.getPosition();
  },
  getShape: function getShape(marker) {
    return marker.getShape();
  },
  getTitle: function getTitle(marker) {
    return marker.getTitle();
  },
  getVisible: function getVisible(marker) {
    return marker.getVisible();
  },
  getZIndex: function getZIndex(marker) {
    return marker.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  animation: function animation(marker, _animation) {
    marker.setAnimation(_animation);
  },
  attribution: function attribution(marker, _attribution) {
    marker.setAttribution(_attribution);
  },
  clickable: function clickable(marker, _clickable) {
    marker.setClickable(_clickable);
  },
  cursor: function cursor(marker, _cursor) {
    marker.setCursor(_cursor);
  },
  draggable: function draggable(marker, _draggable) {
    marker.setDraggable(_draggable);
  },
  icon: function icon(marker, _icon) {
    marker.setIcon(_icon);
  },
  label: function label(marker, _label) {
    marker.setLabel(_label);
  },
  opacity: function opacity(marker, _opacity) {
    marker.setOpacity(_opacity);
  },
  options: function options(marker, _options) {
    marker.setOptions(_options);
  },
  place: function place(marker, _place) {
    marker.setPlace(_place);
  },
  position: function position(marker, _position) {
    marker.setPosition(_position);
  },
  shape: function shape(marker, _shape) {
    marker.setShape(_shape);
  },
  title: function title(marker, _title) {
    marker.setTitle(_title);
  },
  visible: function visible(marker, _visible) {
    marker.setVisible(_visible);
  },
  zIndex: function zIndex(marker, _zIndex) {
    marker.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.MARKER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Marker",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _propTypes2.default.object), (0, _defineProperty3.default)(_contextTypes, _constants.MARKER_CLUSTERER, _propTypes2.default.object), _contextTypes),

  childContextTypes: (0, _defineProperty3.default)({}, _constants.ANCHOR, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
    var marker = new google.maps.Marker((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
    var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!this.props.noRedraw);
    } else {
      marker.setMap(this.context[_constants.MAP]);
    }
    return (0, _defineProperty3.default)({}, _constants.MARKER, marker);
  },
  getChildContext: function getChildContext() {
    return (0, _defineProperty3.default)({}, _constants.ANCHOR, this.context[_constants.ANCHOR] || getInstanceFromComponent(this));
  },
  componentWillUnmount: function componentWillUnmount() {
    var marker = getInstanceFromComponent(this);
    if (marker) {
      var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
      if (markerClusterer) {
        markerClusterer.removeMarker(marker, !!this.props.noRedraw);
      }
      marker.setMap(null);
    }
  },
  render: function render() {
    var children = this.props.children;


    return _react2.default.createElement(
      "div",
      null,
      children
    );
  }
});

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _delay2 = __webpack_require__(1919);

var _delay3 = _interopRequireDefault(_delay2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

var _OverlayViewHelper = __webpack_require__(2071);

var helpers = _interopRequireWildcard(_OverlayViewHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  mapPaneName: _propTypes2.default.string,
  position: _propTypes2.default.object,
  bounds: _propTypes2.default.object
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getPanes: function getPanes(overlayView) {
    return overlayView.getPanes();
  },
  getProjection: function getProjection(overlayView) {
    return overlayView.getProjection();
  }
};

var controlledPropUpdaterMap = {};

function getInstanceFromComponent(component) {
  return component.state[_constants.OVERLAY_VIEW];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "OverlayView",

  statics: {
    FLOAT_PANE: "floatPane",
    MAP_PANE: "mapPane",
    MARKER_LAYER: "markerLayer",
    OVERLAY_LAYER: "overlayLayer",
    OVERLAY_MOUSE_TARGET: "overlayMouseTarget"
  },

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes, {
    children: _propTypes2.default.node.isRequired,
    getPixelPositionOffset: _propTypes2.default.func
  }),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
    var overlayView = new google.maps.OverlayView();
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = this.onAdd;
    overlayView.draw = this.draw;
    overlayView.onRemove = this.onRemove;
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(this.context[_constants.MAP]);
    return (0, _defineProperty3.default)({}, _constants.OVERLAY_VIEW, overlayView);
  },
  onAdd: function onAdd() {
    this._containerElement = helpers.createContainerElement();
  },
  draw: function draw() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
    var overlayView = getInstanceFromComponent(this);
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
    var mapPanes = overlayView.getPanes();
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
    var mapCanvasProjection = overlayView.getProjection();
    //
    var props = (0, _extends3.default)({}, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
      children: this.props.children,
      getPixelPositionOffset: this.props.getPixelPositionOffset
    });
    helpers.mountContainerElementToPane(mapPanes, this._containerElement, props);
    helpers.renderChildToContainerElement(mapCanvasProjection, this._containerElement, props);
  },
  onRemove: function onRemove() {
    helpers.unmountAndDestroyContainerElement(this._containerElement);
    this._containerElement = null;
  },
  componentDidUpdate: function componentDidUpdate() {
    (0, _delay3.default)(this.draw);
  },
  componentWillUnmount: function componentWillUnmount() {
    var overlayView = getInstanceFromComponent(this);
    if (overlayView) {
      overlayView.setMap(null);
      // You must implement three methods: onAdd(), draw(), and onRemove().
      overlayView.onAdd = null;
      overlayView.draw = null;
      overlayView.onRemove = null;
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  path: _propTypes2.default.any,
  paths: _propTypes2.default.any,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDraggable: function getDraggable(polygon) {
    return polygon.getDraggable();
  },
  getEditable: function getEditable(polygon) {
    return polygon.getEditable();
  },
  getPath: function getPath(polygon) {
    return polygon.getPath();
  },
  getPaths: function getPaths(polygon) {
    return polygon.getPaths();
  },
  getVisible: function getVisible(polygon) {
    return polygon.getVisible();
  }
};

var controlledPropUpdaterMap = {
  draggable: function draggable(polygon, _draggable) {
    polygon.setDraggable(_draggable);
  },
  editable: function editable(polygon, _editable) {
    polygon.setEditable(_editable);
  },
  options: function options(polygon, _options) {
    polygon.setOptions(_options);
  },
  path: function path(polygon, _path) {
    polygon.setPath(_path);
  },
  paths: function paths(polygon, _paths) {
    polygon.setPaths(_paths);
  },
  visible: function visible(polygon, _visible) {
    polygon.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.POLYGON];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Polygon",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
    var polygon = new google.maps.Polygon((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.POLYGON, polygon);
  },
  componentWillUnmount: function componentWillUnmount() {
    var polygon = getInstanceFromComponent(this);
    if (polygon) {
      polygon.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  path: _propTypes2.default.any,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDraggable: function getDraggable(polyline) {
    return polyline.getDraggable();
  },
  getEditable: function getEditable(polyline) {
    return polyline.getEditable();
  },
  getPath: function getPath(polyline) {
    return polyline.getPath();
  },
  getVisible: function getVisible(polyline) {
    return polyline.getVisible();
  }
};

var controlledPropUpdaterMap = {
  draggable: function draggable(polyline, _draggable) {
    polyline.setDraggable(_draggable);
  },
  editable: function editable(polyline, _editable) {
    polyline.setEditable(_editable);
  },
  options: function options(polyline, _options) {
    polyline.setOptions(_options);
  },
  path: function path(polyline, _path) {
    polyline.setPath(_path);
  },
  visible: function visible(polyline, _visible) {
    polyline.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.POLYLINE];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Polyline",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
    var polyline = new google.maps.Polyline((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.POLYLINE, polyline);
  },
  componentWillUnmount: function componentWillUnmount() {
    var polyline = getInstanceFromComponent(this);
    if (polyline) {
      polyline.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  bounds: _propTypes2.default.any,
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onBoundsChanged: "bounds_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(rectangle) {
    return rectangle.getBounds();
  },
  getDraggable: function getDraggable(rectangle) {
    return rectangle.getDraggable();
  },
  getEditable: function getEditable(rectangle) {
    return rectangle.getEditable();
  },
  getVisible: function getVisible(rectangle) {
    return rectangle.getVisible();
  }
};

var controlledPropUpdaterMap = {
  bounds: function bounds(rectangle, _bounds) {
    rectangle.setBounds(_bounds);
  },
  draggable: function draggable(rectangle, _draggable) {
    rectangle.setDraggable(_draggable);
  },
  editable: function editable(rectangle, _editable) {
    rectangle.setEditable(_editable);
  },
  options: function options(rectangle, _options) {
    rectangle.setOptions(_options);
  },
  visible: function visible(rectangle, _visible) {
    rectangle.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.RECTANGLE];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Rectangle",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
    var rectangle = new google.maps.Rectangle((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.RECTANGLE, rectangle);
  },
  componentWillUnmount: function componentWillUnmount() {
    var rectangle = getInstanceFromComponent(this);
    if (rectangle) {
      rectangle.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
  links: _propTypes2.default.array,
  motionTracking: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  pano: _propTypes2.default.string,
  panoProvider: _propTypes2.default.func,
  position: _propTypes2.default.object,
  pov: _propTypes2.default.object,
  visible: _propTypes2.default.bool,
  zoom: _propTypes2.default.number
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCloseClick: "closeclick",

  onPanoChanged: "pano_changed",

  onPositionChanged: "position_changed",

  onLinksChanged: "links_changed",

  onPovChanged: "pov_changed",

  onResize: "resize",

  onStatusChanged: "status_changed",

  onVisibleChanged: "visible_changed",

  onZoomChanged: "zoom_changed"

};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getLinks: function getLinks(streetViewPanorama) {
    return streetViewPanorama.getLinks();
  },
  getLocation: function getLocation(streetViewPanorama) {
    return streetViewPanorama.getLocation();
  },
  getMotionTracking: function getMotionTracking(streetViewPanorama) {
    return streetViewPanorama.getMotionTracking();
  },
  getPano: function getPano(streetViewPanorama) {
    return streetViewPanorama.getPano();
  },
  getPhotographerPov: function getPhotographerPov(streetViewPanorama) {
    return streetViewPanorama.getPhotographerPov();
  },
  getPosition: function getPosition(streetViewPanorama) {
    return streetViewPanorama.getPosition();
  },
  getPov: function getPov(streetViewPanorama) {
    return streetViewPanorama.getPov();
  },
  getStatus: function getStatus(streetViewPanorama) {
    return streetViewPanorama.getStatus();
  },
  getVisible: function getVisible(streetViewPanorama) {
    return streetViewPanorama.getVisible();
  },
  getZoom: function getZoom(streetViewPanorama) {
    return streetViewPanorama.getZoom();
  }
};

var controlledPropUpdaterMap = {
  links: function links(streetViewPanorama, _links) {
    streetViewPanorama.setLinks(_links);
  },
  motionTracking: function motionTracking(streetViewPanorama, _motionTracking) {
    streetViewPanorama.setMotionTracking(_motionTracking);
  },
  options: function options(streetViewPanorama, _options) {
    streetViewPanorama.setOptions(_options);
  },
  pano: function pano(streetViewPanorama, _pano) {
    streetViewPanorama.setPano(_pano);
  },
  panoProvider: function panoProvider(streetViewPanorama, _panoProvider) {
    streetViewPanorama.registerPanoProvider(_panoProvider);
  },
  position: function position(streetViewPanorama, _position) {
    streetViewPanorama.setPosition(_position);
  },
  pov: function pov(streetViewPanorama, _pov) {
    streetViewPanorama.setPov(_pov);
  },
  visible: function visible(streetViewPanorama, _visible) {
    streetViewPanorama.setVisible(_visible);
  },
  zoom: function zoom(streetViewPanorama, _zoom) {
    streetViewPanorama.setZoom(_zoom);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.STREET_VIEW_PANORAMA];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "StreetViewPanorama",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  childContextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialOptions: function getInitialOptions() {
    return (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props);
  },
  getChildContext: function getChildContext() {
    return (0, _defineProperty3.default)({}, _constants.MAP, this.state[_constants.STREET_VIEW_PANORAMA]);
  },
  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
    var streetViewPanorama = void 0;
    if (!this.props.containerElement && this.context[_constants.MAP]) {
      streetViewPanorama = this.context[_constants.MAP].getStreetView();
      streetViewPanorama.setOptions(this.getInitialOptions());
    }
    if (!this.props.containerElement && !this.context[_constants.MAP]) {
      throw new Error("You need to use the StreetViewPanorama in the context of `<GoogleMap>` or pass an `containerElement` for it to be rendered in.");
    }
    return (0, _defineProperty3.default)({}, _constants.STREET_VIEW_PANORAMA, streetViewPanorama);
  },
  handleComponentMount: function handleComponentMount(el) {
    this.el = el;
    if (this.el) {
      var streetViewPanorama = new google.maps.StreetViewPanorama(this.el, (0, _extends3.default)({
        map: this.context[_constants.MAP]
      }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
      if (this.context[_constants.MAP]) {
        this.context[_constants.MAP].setStreetView(streetViewPanorama);
      }
      this.setState((0, _defineProperty3.default)({}, _constants.STREET_VIEW_PANORAMA, streetViewPanorama));
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var streetViewPanorama = getInstanceFromComponent(this);
    if (streetViewPanorama) {
      streetViewPanorama.setVisible(false);
    }
  },
  render: function render() {
    if (this.props.containerElement) {
      return _react2.default.cloneElement(this.props.containerElement, { ref: this.handleComponentMount }, this.props.children);
    }
    return _react2.default.createElement(
      "div",
      null,
      this.props.children
    );
  }
});

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(62);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(34);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(64);

var _enhanceElement = __webpack_require__(72);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  options: _propTypes2.default.object
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  // END - Public APIs
};

var controlledPropUpdaterMap = {
  options: function options(trafficLayer, _options) {
    trafficLayer.setOptions(_options);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.TRAFFIC_LAYER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "TrafficLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
    var trafficLayer = new google.maps.TrafficLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.TRAFFIC_LAYER, trafficLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var trafficLayer = getInstanceFromComponent(this);
    if (trafficLayer) {
      trafficLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withGoogleMap = __webpack_require__(2072);

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default;
  }
});

var _GoogleMap = __webpack_require__(2060);

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default;
  }
});

var _Marker = __webpack_require__(2063);

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default;
  }
});

var _Rectangle = __webpack_require__(2067);

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default;
  }
});

var _Polyline = __webpack_require__(2066);

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default;
  }
});

var _Polygon = __webpack_require__(2065);

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default;
  }
});

var _Circle = __webpack_require__(2057);

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _KmlLayer = __webpack_require__(2062);

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default;
  }
});

var _FusionTablesLayer = __webpack_require__(2059);

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default;
  }
});

var _TrafficLayer = __webpack_require__(2069);

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default;
  }
});

var _DirectionsRenderer = __webpack_require__(2058);

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default;
  }
});

var _InfoWindow = __webpack_require__(2061);

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default;
  }
});

var _OverlayView = __webpack_require__(2064);

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default;
  }
});

var _StreetViewPanorama = __webpack_require__(2068);

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _assign2 = __webpack_require__(1914);

var _assign3 = _interopRequireDefault(_assign2);

var _isFunction2 = __webpack_require__(316);

var _isFunction3 = _interopRequireDefault(_isFunction2);

exports.createContainerElement = createContainerElement;
exports.mountContainerElementToPane = mountContainerElementToPane;
exports.renderChildToContainerElement = renderChildToContainerElement;
exports.unmountAndDestroyContainerElement = unmountAndDestroyContainerElement;

var _invariant = __webpack_require__(46);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(1);

var _reactDom = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createContainerElement() {
  var containerElement = document.createElement("div");
  containerElement.style.position = "absolute";
  return containerElement;
} /* global google */
function mountContainerElementToPane(mapPanes, containerElement, props) {
  var mapPaneName = props.mapPaneName;

  (0, _invariant2.default)(!!mapPaneName, "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s", mapPaneName);
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
  mapPanes[mapPaneName].appendChild(containerElement);
}

function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset;
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight);
  } else {
    return {};
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
}

function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst;
  } else {
    return factory(inst, type);
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px"
    };
  }
  return {
    left: "-9999px",
    top: "-9999px"
  };
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position);
  if (point) {
    var x = point.x,
        y = point.y;

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px"
    };
  }
  return {
    left: "-9999px",
    top: "-9999px"
  };
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(props.bounds, google.maps.LatLngBounds, createLatLngBounds);
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds);
  } else {
    var position = ensureOfType(props.position, google.maps.LatLng, createLatLng);
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position);
  }
}

function renderChildToContainerElement(mapCanvasProjection, containerElement, props) {
  var child = _react.Children.only(props.children);
  (0, _reactDom.render)(child, containerElement, function () {
    var offset = (0, _extends3.default)({
      x: 0,
      y: 0
    }, getOffsetOverride(containerElement, props));
    var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, props);
    (0, _assign3.default)(containerElement.style, layoutStyles);
  });
}

function unmountAndDestroyContainerElement(containerElement) {
  containerElement.parentNode.removeChild(containerElement);
  (0, _reactDom.unmountComponentAtNode)(containerElement);
}

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(197);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(4);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(52);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(35);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(41);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(54);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(53);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withGoogleMap;

var _warning = __webpack_require__(112);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(46);

var _invariant2 = _interopRequireDefault(_invariant);

var _reactDisplayName = __webpack_require__(1993);

var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
function withGoogleMap(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Container, _Component);

    function Container() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Container);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        map: null
      }, _this.handleComponentMount = _this.handleComponentMount.bind(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Container, [{
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)({}, _constants.MAP, this.state.map);
      }
    }, {
      key: "componentWillMount",
      value: function componentWillMount() {
        var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement;

        (0, _invariant2.default)(!!containerElement && !!mapElement, "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized.");
      }
    }, {
      key: "handleComponentMount",
      value: function handleComponentMount(node) {
        if (this.state.map || node === null) {
          return;
        }
        (0, _warning2.default)("undefined" !== typeof google, "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168");
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
        var map = new google.maps.Map(node);
        this.setState({ map: map });
      }
    }, {
      key: "render",
      value: function render() {
        var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, ["containerElement", "mapElement"]);
        var map = this.state.map;


        if (map) {
          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
            ref: this.handleComponentMount
          }), _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(WrappedComponent, restProps)
          ));
        } else {
          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
            ref: this.handleComponentMount
          }), _react2.default.createElement("div", null));
        }
      }
    }]);
    return Container;
  }(_react.Component), _class.displayName = "withGoogleMap(" + (0, _reactDisplayName2.default)(WrappedComponent) + ")", _class.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired
  }, _class.childContextTypes = (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object), _temp2;
}

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(2093);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(1592);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(2074);

var _HelmetConstants = __webpack_require__(876);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(29);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(876);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(1);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(1762));
var shallowEqual = _interopDefault(__webpack_require__(2289));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(886);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });





/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(887);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });





/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = idCellSizeCache;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultCellSizeCache__ = __webpack_require__(512);


/**
 * Alternate CellMeasurer `cellSizeCache` implementation.
 * Similar to `defaultCellSizeCache` except that sizes are tied to data id rather than index.
 * Requires an index-to-id map function (passed in externally) to operate.
 */
function idCellSizeCache(_ref) {
  var indexToIdMap = _ref.indexToIdMap;
  var _ref$uniformColumnWid = _ref.uniformColumnWidth;
  var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
  var _ref$uniformRowHeight = _ref.uniformRowHeight;
  var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;

  var cellSizeCache = new __WEBPACK_IMPORTED_MODULE_0__defaultCellSizeCache__["a" /* default */]({
    uniformColumnWidth: uniformColumnWidth,
    uniformRowHeight: uniformRowHeight
  });

  return {
    clearAllColumnWidths: function clearAllColumnWidths() {
      cellSizeCache.clearAllColumnWidths();
    },
    clearAllRowHeights: function clearAllRowHeights() {
      cellSizeCache.clearAllRowHeights();
    },
    clearColumnWidth: function clearColumnWidth(index) {
      cellSizeCache.clearColumnWidth(indexToIdMap(index));
    },
    clearRowHeight: function clearRowHeight(index) {
      cellSizeCache.clearRowHeight(indexToIdMap(index));
    },
    getColumnWidth: function getColumnWidth(index) {
      return cellSizeCache.getColumnWidth(indexToIdMap(index));
    },
    getRowHeight: function getRowHeight(index) {
      return cellSizeCache.getRowHeight(indexToIdMap(index));
    },
    setColumnWidth: function setColumnWidth(index, width) {
      cellSizeCache.setColumnWidth(indexToIdMap(index), width);
    },
    setRowHeight: function setRowHeight(index, height) {
      cellSizeCache.setRowHeight(indexToIdMap(index), height);
    }
  };
}

/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(888);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellSizeCache__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellSizeCache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__idCellSizeCache__ = __webpack_require__(2096);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__idCellSizeCache__["a"]; });









/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__);












// @TODO It would be nice to refactor Grid to use this code as well.

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _Component);

  function CollectionView(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call(this, props, context));

    _this.state = {
      calculateSizeAndPositionDataOnNextUpdate: false,
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };

    // Invokes callbacks only when their values have changed.
    _this._onSectionRenderedMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])(false);

    // Bind functions to instance so they don't lose context when passed around.
    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this.setState({
        calculateSizeAndPositionDataOnNextUpdate: true
      });
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props;
      var cellLayoutManager = _props.cellLayoutManager;
      var scrollLeft = _props.scrollLeft;
      var scrollToCell = _props.scrollToCell;
      var scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize();

      var totalHeight = _cellLayoutManager$ge.height;
      var totalWidth = _cellLayoutManager$ge.width;

      // Initialize onScroll callback.

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props;
      var height = _props2.height;
      var scrollToAlignment = _props2.scrollToAlignment;
      var scrollToCell = _props2.scrollToCell;
      var width = _props2.width;
      var _state = this.state;
      var scrollLeft = _state.scrollLeft;
      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
      var scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var cellLayoutManager = this.props.cellLayoutManager;


      cellLayoutManager.calculateSizeAndPositionData();

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()
      this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextProps.cellCount === 0 && (nextState.scrollLeft !== 0 || nextState.scrollTop !== 0)) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        this._setScrollPosition({
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        });
      }

      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || nextState.calculateSizeAndPositionDataOnNextUpdate) {
        nextProps.cellLayoutManager.calculateSizeAndPositionData();
      }

      if (nextState.calculateSizeAndPositionDataOnNextUpdate) {
        this.setState({
          calculateSizeAndPositionDataOnNextUpdate: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props;
      var autoHeight = _props3.autoHeight;
      var cellCount = _props3.cellCount;
      var cellLayoutManager = _props3.cellLayoutManager;
      var className = _props3.className;
      var height = _props3.height;
      var horizontalOverscanSize = _props3.horizontalOverscanSize;
      var id = _props3.id;
      var noContentRenderer = _props3.noContentRenderer;
      var style = _props3.style;
      var verticalOverscanSize = _props3.verticalOverscanSize;
      var width = _props3.width;
      var _state2 = this.state;
      var isScrolling = _state2.isScrolling;
      var scrollLeft = _state2.scrollLeft;
      var scrollTop = _state2.scrollTop;

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize();

      var totalHeight = _cellLayoutManager$ge2.height;
      var totalWidth = _cellLayoutManager$ge2.width;

      // Safely expand the rendered area by the specified overscan amount

      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          ref: function ref(_ref) {
            _this2._scrollingContainer = _ref;
          },
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0
        },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            }
          },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this3 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this3.props.isScrollingChange;


        isScrollingChange(false);

        _this3._disablePointerEventsTimeoutId = null;
        _this3.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnSectionRenderedHelper',
    value: function _invokeOnSectionRenderedHelper() {
      var _props4 = this.props;
      var cellLayoutManager = _props4.cellLayoutManager;
      var onSectionRendered = _props4.onSectionRendered;


      this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this4 = this;

      var scrollLeft = _ref2.scrollLeft;
      var scrollTop = _ref2.scrollTop;
      var totalHeight = _ref2.totalHeight;
      var totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft;
          var scrollTop = _ref3.scrollTop;
          var _props5 = _this4.props;
          var height = _props5.height;
          var onScroll = _props5.onScroll;
          var width = _props5.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft;
      var scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_updateScrollPositionForScrollToCell',
    value: function _updateScrollPositionForScrollToCell() {
      var _props6 = this.props;
      var cellLayoutManager = _props6.cellLayoutManager;
      var height = _props6.height;
      var scrollToAlignment = _props6.scrollToAlignment;
      var scrollToCell = _props6.scrollToCell;
      var width = _props6.width;
      var _state3 = this.state;
      var scrollLeft = _state3.scrollLeft;
      var scrollTop = _state3.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          this._setScrollPosition(scrollPosition);
        }
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _props7 = this.props;
      var cellLayoutManager = _props7.cellLayoutManager;
      var height = _props7.height;
      var isScrollingChange = _props7.isScrollingChange;
      var width = _props7.width;

      var scrollbarSize = this._scrollbarSize;

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize();

      var totalHeight = _cellLayoutManager$ge3.height;
      var totalWidth = _cellLayoutManager$ge3.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!this.state.isScrolling) {
          isScrollingChange(true);
        }

        this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  style: {},
  verticalOverscanSize: 0
};
/* harmony default export */ __webpack_exports__["a"] = (CollectionView);
 false ? CollectionView.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height;
    var width = _ref.width;
    var x = _ref.x;
    var y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}(); /** @rlow */


/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(2099);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height;
      var width = _ref.width;
      var x = _ref.x;
      var y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height;
      var width = _ref3.width;
      var x = _ref3.x;
      var y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum;
      var index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(889);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collection__["a"]; });





/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(2100);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount;
  var cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter;
  var sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(890);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a"]; });





/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager = function () {
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount;
    var cellSizeGetter = _ref.cellSizeGetter;
    var estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;

    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    this._cellSizeAndPositionData = {};

    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    this._lastMeasuredIndex = -1;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount;
      var estimatedCellSize = _ref2.estimatedCellSize;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          if (_size == null || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          }

          this._cellSizeAndPositionData[i] = {
            offset: _offset,
            size: _size
          };

          _offset += _size;
        }

        this._lastMeasuredIndex = index;
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completedly estimated initially.
     * As cells as measured the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();

      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align;
      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
      var containerSize = _ref3.containerSize;
      var currentOffset = _ref3.currentOffset;
      var targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize;
      var offset = _ref4.offset;

      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(_ref5) {
      var high = _ref5.high;
      var low = _ref5.low;
      var offset = _ref5.offset;

      var middle = void 0;
      var currentOffset = void 0;

      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(_ref6) {
      var index = _ref6.index;
      var offset = _ref6.offset;

      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch({
        high: Math.min(index, this._cellCount - 1),
        low: Math.floor(index / 2),
        offset: offset
      });
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch({
          high: lastMeasuredIndex,
          low: 0,
          offset: offset
        });
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch({
          index: lastMeasuredIndex,
          offset: offset
        });
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_MAX_SCROLL_SIZE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(2104);





/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */
var DEFAULT_MAX_SCROLL_SIZE = 1500000;

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */

var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize;
    var maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize;

    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scalled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize;
      var offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align;
      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
      var containerSize = _ref3.containerSize;
      var currentOffset = _ref3.currentOffset;
      var targetIndex = _ref3.targetIndex;
      var totalSize = _ref3.totalSize;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex,
        totalSize: totalSize
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize;
      var offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize;
      var offset = _ref5.offset;
      var totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize;
      var offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize;
      var offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 *
 * @param cellCount Number of rows or columns in the current axis
 * @param cellsSize Width or height of cells for the current axis
 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
 * @param nextCellsCount Newly updated number of rows or columns in the current axis
 * @param nextCellsSize Newly updated width or height of cells for the current axis
 * @param nextScrollToIndex Newly updated scroll-to-index
 * @param scrollToIndex Scroll-to-index
 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount;
  var cellSize = _ref.cellSize;
  var computeMetadataCallback = _ref.computeMetadataCallback;
  var computeMetadataCallbackProps = _ref.computeMetadataCallbackProps;
  var nextCellsCount = _ref.nextCellsCount;
  var nextCellSize = _ref.nextCellSize;
  var nextScrollToIndex = _ref.nextScrollToIndex;
  var scrollToIndex = _ref.scrollToIndex;
  var updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_FORWARD; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getOverscanIndices;
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 *
 * @param cellCount Number of rows or columns in the current axis
 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD
 * @param overscanCellsCount Maximum number of cells to over-render in either direction
 * @param startIndex Begin of range of visible cells
 * @param stopIndex End of range of visible cells
 */
function getOverscanIndices(_ref) {
  var cellCount = _ref.cellCount;
  var overscanCellsCount = _ref.overscanCellsCount;
  var scrollDirection = _ref.scrollDirection;
  var startIndex = _ref.startIndex;
  var stopIndex = _ref.stopIndex;

  var overscanStartIndex = void 0;
  var overscanStopIndex = void 0;

  switch (scrollDirection) {
    case SCROLL_DIRECTION_FORWARD:
      overscanStartIndex = startIndex;
      overscanStopIndex = stopIndex + overscanCellsCount;
      break;
    case SCROLL_DIRECTION_BACKWARD:
      overscanStartIndex = startIndex - overscanCellsCount;
      overscanStopIndex = stopIndex;
      break;
  }

  return {
    overscanStartIndex: Math.max(0, overscanStartIndex),
    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
  };
}

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 *
 * @param cellsSize Width or height of cells for the current axis
 * @param cellSizeAndPositionManager Manages size and position metadata of cells
 * @param previousCellsCount Previous number of rows or columns
 * @param previousCellsSize Previous width or height of cells
 * @param previousScrollToIndex Previous scroll-to-index
 * @param previousSize Previous width or height of the virtualized container
 * @param scrollOffset Current scrollLeft or scrollTop
 * @param scrollToIndex Scroll-to-index
 * @param size Width or height of the virtualized container
 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
 */
function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize;
  var cellSizeAndPositionManager = _ref.cellSizeAndPositionManager;
  var previousCellsCount = _ref.previousCellsCount;
  var previousCellSize = _ref.previousCellSize;
  var previousScrollToAlignment = _ref.previousScrollToAlignment;
  var previousScrollToIndex = _ref.previousScrollToIndex;
  var previousSize = _ref.previousSize;
  var scrollOffset = _ref.scrollOffset;
  var scrollToAlignment = _ref.scrollToAlignment;
  var scrollToIndex = _ref.scrollToIndex;
  var size = _ref.size;
  var updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(893);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a"]; });





/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(894);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });





/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(895);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });





/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(896);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a"]; });





/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(899);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRenderer__ = __webpack_require__(902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultRowRenderer__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultRowRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Column__ = __webpack_require__(897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Column__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SortDirection__ = __webpack_require__(513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__SortDirection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortIndicator__ = __webpack_require__(898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__SortIndicator__["a"]; });



















/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(904);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_onScroll__ = __webpack_require__(905);
/* unused harmony reexport IS_SCROLLING_TIMEOUT */







/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionFromTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollTop;
/**
 * Gets the height of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
function getHeight(element) {
  return element === window ? window.innerHeight : element.getBoundingClientRect().height;
}

/**
 * Gets the vertical position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top position will be a negative number and this element’s top will be increased (by that amount).
 */
function getPositionFromTop(element, container) {
  var offset = container === window ? 0 : getScrollTop(container);
  var containerElement = container === window ? document.documentElement : container;
  return element.getBoundingClientRect().top + offset - containerElement.getBoundingClientRect().top;
}

/**
 * Gets the vertical scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollTop(element) {
  if (element === window) {
    return 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop;
  } else {
    return element.scrollTop;
  }
}

/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(2094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowKeyStepper", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(2095);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoSizer", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(2097);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurer", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellMeasurerCellSizeCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniformSizeCellMeasurerCellSizeCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "idCellMeasurerCellSizeCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(2101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return __WEBPACK_IMPORTED_MODULE_3__Collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(2103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnSizer", function() { return __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table__ = __webpack_require__(2113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellDataGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortDirection", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortIndicator", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Grid__ = __webpack_require__(325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_6__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_6__Grid__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InfiniteLoader__ = __webpack_require__(2109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteLoader", function() { return __WEBPACK_IMPORTED_MODULE_7__InfiniteLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__List__ = __webpack_require__(2110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_8__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(2111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(2112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollSync", function() { return __WEBPACK_IMPORTED_MODULE_10__ScrollSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WindowScroller__ = __webpack_require__(2114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowScroller", function() { return __WEBPACK_IMPORTED_MODULE_11__WindowScroller__["a"]; });













/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align;
  var align = _ref$align === undefined ? 'auto' : _ref$align;
  var cellOffset = _ref.cellOffset;
  var cellSize = _ref.cellSize;
  var containerSize = _ref.containerSize;
  var currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 **/

function createDetectElementResize() {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = this;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        animationstring = 'animation',
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            animationstring = pfx + 'Animation';
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles() {
    if (!document.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) element.attachEvent('onresize', fn);else {
      if (!element.__resizeTriggers__) {
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles();
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) resetTriggers(element);
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) element.detachEvent('onresize', fn);else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

/***/ }),
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var requestIdleCallback =
  function (cb) {
  if (global.requestIdleCallback) return global.requestIdleCallback(cb)
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  }

var cancelIdleCallback =
  function (id) {
  if (global.cancelIdleCallback) return global.cancelIdleCallback(id)
    return clearTimeout(id);
  }

exports.requestIdleCallback = requestIdleCallback
exports.cancelIdleCallback = cancelIdleCallback

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = __webpack_require__(65);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpDiffusionConnector = __webpack_require__(337);

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

var _DiffusionServiceUtils = __webpack_require__(191);

var _PricesStateStore = __webpack_require__(190);

var _DIFFUSION = __webpack_require__(330);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _EVENTS = __webpack_require__(925);

var _EVENTS2 = _interopRequireDefault(_EVENTS);

var _PopOver2 = __webpack_require__(927);

var _PopOver3 = _interopRequireDefault(_PopOver2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var narrowBreakpoints = [_rpMqBreakpoints.breakpointCodes.EXTRA_NARROW, _rpMqBreakpoints.breakpointCodes.NARROW];

var BestOddsPopOver = function (_PopOver) {
    _inherits(BestOddsPopOver, _PopOver);

    function BestOddsPopOver() {
        _classCallCheck(this, BestOddsPopOver);

        return _possibleConstructorReturn(this, (BestOddsPopOver.__proto__ || Object.getPrototypeOf(BestOddsPopOver)).apply(this, arguments));
    }

    _createClass(BestOddsPopOver, [{
        key: 'open',
        value: function open(e) {
            var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
            if (currentBookmaker !== '#BESTODDS') {
                return;
            }
            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'open', this).call(this, e);
            (0, _jquery2.default)(window).on(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
            (0, _jquery2.default)(window).on(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
        }
    }, {
        key: 'close',
        value: function close(e) {
            (0, _jquery2.default)(window).off(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
            (0, _jquery2.default)(window).off(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'close', this).call(this, e);
        }
    }]);

    return BestOddsPopOver;
}(_PopOver3.default);

var defaultConfig = {
    bestOddsContainerSelector: '.js-bestOddsPriceContainer',
    diffusionConfigs: '.js-diffusionHorsesList',
    priceBtnOddsSelector: '.js-PC-bestOdds__priceBtn',
    activeBestOddsSelector: {
        popOver: '.js-PC-bestOdds',
        horseList: '.js-diffusionBestOdds',
        arrow: '.js-PC-bestOdds__arrow'
    },
    bestOddsArrowHiddenClass: 'PC-bestOdds__arrow_hidden',
    bestOddsArrowRight: 'PC-bestOdds__arrow_right',
    bestOddsArrowLeft: 'PC-bestOdds__arrow_left',
    noPointerClass: 'RC-runnerPrice_noPointer',
    bestOddsArrowHeight: 27,
    sideMarginInPx: 16,
    bestOddsArrowPositionInPx: {
        min: 7,
        max: 488
    },
    popOverConfig: {
        activeClass: 'PC-bestOdds_active',
        popOverSelector: '.js-PC-bestOdds',
        openAreaSelector: '.js-runnerPriceBestOdds',
        shadowAreaSelectors: '.PC-bestOddsOverlay',
        diffusionConfig: '.js-diffusionBestOdds',
        runnerName: '.js-bestOddsHorseName'
    }
};

var BestOdds = function () {
    function BestOdds(config) {
        _classCallCheck(this, BestOdds);

        this.config = _jquery2.default.extend(true, defaultConfig, config);
        this.init();
    }

    _createClass(BestOdds, [{
        key: 'init',
        value: function init() {
            this.diffusionSession = new _rpDiffusionConnector2.default({
                onDataFunction: this.onDataReceive.bind(this)
            });

            this.showDecimalPrices = false;
            this.initOverlay();
            this.bindEvents();
            this.$bestOdds = (0, _jquery2.default)(this.config.popOverConfig.popOverSelector);
            this.$bestOddsParent = this.$bestOdds.parent();
            this.initPopover();
        }
    }, {
        key: 'initOverlay',
        value: function initOverlay() {
            this.overlay = (0, _jquery2.default)('<div class="PC-bestOddsOverlay"></div>');
            (0, _jquery2.default)('body').append(this.overlay);
        }
    }, {
        key: 'initPopover',
        value: function initPopover() {
            var popoverOptions = this.getPopoverOptions();
            this.popOver = new BestOddsPopOver(popoverOptions);
        }
    }, {
        key: 'getPopoverOptions',
        value: function getPopoverOptions() {
            return {
                activeClass: this.config.popOverConfig.activeClass,
                popOverSelector: this.config.popOverConfig.popOverSelector,
                openAreaSelectors: [this.config.popOverConfig.openAreaSelector],
                closeAreaSelectors: [this.config.priceBtnOddsSelector, this.config.popOverConfig.shadowAreaSelectors],
                onOpen: this.onPopOverOpen.bind(this),
                onClose: this.onPopOverClose.bind(this),
                onResizeHandler: this.onResizeHandler.bind(this),
                onBreakpointChange: this.onBreakpointChange.bind(this)
            };
        }
    }, {
        key: 'onPopOverOpen',
        value: function onPopOverOpen(e) {
            this.overlay.show();
            this.prepareDiffusionData(e);
            this.pricesSubscribe();
            this.setOriginPrice(e.target);
            this.handleBestOddsPosition();
        }
    }, {
        key: 'onPopOverClose',
        value: function onPopOverClose() {
            this.diffusionSession.unsubscribeAll();
            this.clearPopUp();
            this.overlay.hide();
            this.$bestOdds.detach();
            this.$bestOddsParent.append(this.$bestOdds);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicsRunnersUpdate.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onDynamicsRunnersUpdate.bind(this));
        }
    }, {
        key: 'onUserSettingsChanged',
        value: function onUserSettingsChanged(event, userSettings) {
            this.showDecimalPrices = userSettings.decimalOdds;
        }
    }, {
        key: 'onDynamicsRunnersUpdate',
        value: function onDynamicsRunnersUpdate() {
            this.popOver.destroy();
            this.initPopover();
        }
    }, {
        key: 'onDataReceive',
        value: function onDataReceive(webClientMessage) {
            var topic = webClientMessage.getTopic();

            if (topic.includes('#INFO')) {
                this.handleRaceInfo(webClientMessage);
            } else {
                this.handleHorsePrice(webClientMessage);
            }
        }
    }, {
        key: 'prepareDiffusionData',
        value: function prepareDiffusionData(event) {
            var $diffusionHorseListElem = (0, _jquery2.default)(event.target).closest(this.config.diffusionConfigs);
            var diffusionHorseName = $diffusionHorseListElem.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate($diffusionHorseListElem);
            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime($diffusionHorseListElem);
            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName($diffusionHorseListElem);

            (0, _jquery2.default)(this.config.popOverConfig.runnerName).text(diffusionHorseName);
            var $diffusionBestOdds = (0, _jquery2.default)(this.config.popOverConfig.diffusionConfig);
            this.$bestOdds.detach();

            $diffusionBestOdds.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, diffusionHorseName).attr(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, courseName).attr(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, raceTime).attr(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, raceDate);

            var $priceContainer = (0, _jquery2.default)(event.target).closest(this.config.bestOddsContainerSelector);
            $priceContainer.append(this.$bestOdds);
        }
    }, {
        key: 'handleRaceInfo',
        value: function handleRaceInfo(WebClientMessage) {
            var raceInfo = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

            this.renderEwInfo(raceInfo);
            _PricesStateStore.pricesStateStore.updateRaceInfo(raceInfo);
            if (raceInfo.suspendState === 'H') {
                this.updatePricesForRaceInfo(raceInfo.bookmaker);
            }
        }
    }, {
        key: 'handleHorsePrice',
        value: function handleHorsePrice(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);

            this.renderPrice(renderConfig);
        }
    }, {
        key: 'renderPrice',
        value: function renderPrice(renderConfig) {
            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
             * support CSS selector search with data attributes
             */

            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig}"]`;
            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
            var bookieContainer = Array.prototype.filter.call(pricesContainer, function (el) {
                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
            });
            var priceButton = (0, _jquery2.default)(bookieContainer).find(this.config.priceBtnOddsSelector)[0];

            this.clearBestOddsPosition();

            if (priceButton) {
                var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);
                priceButton.innerHTML = renderPriceValue;
                if (renderPriceValue === '-') {
                    priceButton.classList.add(this.config.noPointerClass);
                } else {
                    priceButton.classList.remove(this.config.noPointerClass);
                }
                var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
                var dataDiffusionStatus = raceInfo && raceInfo.suspendState === 'H' ? 'H' : renderConfig.status;

                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, renderConfig.outcomersId);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, renderConfig.fractionalPrice);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, renderConfig.decimalPrice);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.STATUS, dataDiffusionStatus);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, renderConfig.eventId);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, renderConfig.meetingId);

                bookieContainer[0].classList.add('PC-bestOdds__bookieRow_active');
                this.sortPrices(bookieContainer);
            }
            this.handleBestOddsPosition();
        }
    }, {
        key: 'sortPrices',
        value: function sortPrices(bookieRow) {
            var bookieContainer = (0, _jquery2.default)(bookieRow).closest('.PC-bestOdds__bookiesList').find('.PC-bestOdds__bookieRow_active');

            if (bookieContainer.length === 0) {
                return;
            }
            var priceBtnOddsSelector = this.config.priceBtnOddsSelector;
            bookieContainer.toArray().map(function (item) {
                return {
                    bookie: item.getAttribute('data-diffusion-bookieName').toLowerCase(),
                    price: (0, _jquery2.default)(item).find(priceBtnOddsSelector).attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
                    element: item
                };
            }).sort(function (prev, next) {
                if (isNaN(prev.price) && isNaN(next.price) || prev.price === next.price) {
                    if (prev.bookie > next.bookie) {
                        return 1;
                    } else if (prev.bookie < next.bookie) {
                        return -1;
                    }
                    return 0;
                } else if (isNaN(prev.price)) {
                    return 1;
                } else if (isNaN(next.price)) {
                    return 0;
                }
                return next.price - prev.price;
            }).forEach(function (elem, index) {
                var bookieElement = elem.element;
                bookieElement.style.order = index;
            });
        }
    }, {
        key: 'pricesSubscribe',
        value: function pricesSubscribe() {
            var horsesList = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList).toArray();
            var topics = horsesList.map(function (horseElement) {
                var bookmaker = _DiffusionServiceUtils.diffusionServiceUtils.getTopicBookmaker(horseElement);
                var diffusionData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(horseElement);

                return _extends(diffusionData, { bookmaker: bookmaker });
            }).map(function (diffusionData) {
                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(diffusionData);
                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic(diffusionData);

                return [priceTopic, infoTopic];
            }).reduce(function (acum, value) {
                return acum.concat(value);
            }, []).filter(function (topic) {
                return topic;
            });

            this.diffusionSession.subscribe({ topics: topics });
        }
    }, {
        key: 'renderEwInfo',
        value: function renderEwInfo(renderConfig) {
            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
             * support CSS selector search with data attributes
             */

            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig.bookmaker}"]`;

            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
            var bookieContainer = (0, _jquery2.default)(Array.prototype.filter.call(pricesContainer, function (el) {
                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
            }));
            var ewElement = bookieContainer.find('.js-diffusionBestOdds_eachWay')[0];
            var bogElement = bookieContainer.find('.js-diffusionBestOdds_bog')[0];

            if (ewElement) {
                ewElement.innerHTML = renderConfig.isWinOnly ? '<b>win only</b>' : [renderConfig.winOdds, renderConfig.placeWinner].join(' ');
            }

            if (bogElement) {
                if (renderConfig.isBog === 'Y') {
                    bogElement.classList.add('PC-bestOdds__bookieRow__oddsIcon_active');
                } else {
                    bogElement.classList.remove('PC-bestOdds__bookieRow__oddsIcon_active');
                }
            }
        }
    }, {
        key: 'clearPopUp',
        value: function clearPopUp() {
            var _this2 = this;

            var diffusionRows = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList);

            Array.prototype.forEach.call(diffusionRows, function (element) {
                var priceBtn = (0, _jquery2.default)(element).find(_this2.config.priceBtnOddsSelector)[0];

                element.classList.remove('PC-bestOdds__bookieRow_active');

                _this2.renderEwInfo({
                    winOdds: '',
                    placeWinner: '',
                    isBog: 'N',
                    bookmaker: element.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER)
                });
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, '');
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, '');
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, '');
                priceBtn.innerHTML = '';
            });
        }
    }, {
        key: 'handleBestOddsPosition',
        value: function handleBestOddsPosition() {
            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0];
            var popOverArrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
            var windowHeight = window.innerHeight;
            var windowWidth = window.innerWidth;
            var bestOddsRect = popOver.getBoundingClientRect();
            var bestOddsArrowPositionMax = bestOddsRect.height - this.config.bestOddsArrowHeight;
            var $priceContainer = (0, _jquery2.default)(this.originPrice).closest(this.config.bestOddsContainerSelector);
            var priceContainerRect = $priceContainer.length ? $priceContainer[0].getBoundingClientRect() : null;
            var originPriceRect = this.originPrice.getBoundingClientRect();
            var targetContainerRect = priceContainerRect && priceContainerRect.width && priceContainerRect.height > originPriceRect.height ? priceContainerRect : originPriceRect;
            var isWideBreakpoint = narrowBreakpoints.indexOf(_rpMqBreakpoints2.default.current().code) === -1;

            var calculatedTop = -(bestOddsRect.height - targetContainerRect.height) / 2;
            var spaceToTop = targetContainerRect.top + calculatedTop;
            var spaceToBottom = windowHeight - (targetContainerRect.top + calculatedTop + bestOddsRect.height);
            var calculatedLeft = void 0;

            // Vertical Alignment

            if (spaceToTop < this.config.sideMarginInPx && spaceToBottom > this.config.sideMarginInPx) {
                calculatedTop = this.config.sideMarginInPx - targetContainerRect.top;
            } else if (spaceToBottom < this.config.sideMarginInPx && spaceToTop > this.config.sideMarginInPx) {
                calculatedTop = windowHeight - targetContainerRect.top - bestOddsRect.height - this.config.sideMarginInPx;
            }
            var arrowTop = -(calculatedTop - (targetContainerRect.height - this.config.bestOddsArrowHeight) / 2);

            // Arrow alignment
            if (arrowTop < this.config.bestOddsArrowPositionInPx.min || arrowTop > bestOddsArrowPositionMax) {
                popOverArrow.classList.add(this.config.bestOddsArrowHiddenClass);
            } else {
                popOverArrow.setAttribute('style', 'top:' + arrowTop + 'px');
            }
            // Horizontal alignment

            if (isWideBreakpoint) {
                calculatedLeft = targetContainerRect.width + 16;
            } else {
                calculatedLeft = (windowWidth - bestOddsRect.width) / 2 - targetContainerRect.left;
            }

            if (windowWidth < targetContainerRect.left + calculatedLeft + bestOddsRect.width + this.config.sideMarginInPx && isWideBreakpoint) {
                calculatedLeft = -(bestOddsRect.width + 16);
                popOverArrow.classList.add(this.config.bestOddsArrowRight);
            } else {
                popOverArrow.classList.add(this.config.bestOddsArrowLeft);
            }

            if (calculatedLeft) {
                popOver.setAttribute('style', 'top:' + calculatedTop + 'px; left:' + calculatedLeft + 'px');
            } else {
                popOver.setAttribute('style', 'top:' + calculatedTop + 'px');
            }
        }
    }, {
        key: 'clearBestOddsPosition',
        value: function clearBestOddsPosition() {
            var arrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
            arrow.setAttribute('style', '');
            arrow.classList.remove(this.config.bestOddsArrowHiddenClass);
            arrow.classList.remove(this.config.bestOddsArrowRight);
            arrow.classList.remove(this.config.bestOddsArrowLeft);

            (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0].setAttribute('style', '');
        }
    }, {
        key: 'onResizeHandler',
        value: function onResizeHandler() {
            this.clearBestOddsPosition();
            this.handleBestOddsPosition();
        }
    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
            this.popOver.close();
        }
    }, {
        key: 'updatePricesForRaceInfo',
        value: function updatePricesForRaceInfo(bookmaker) {
            var _this3 = this;

            var bookieElements = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver).find(this.config.popOverConfig.diffusionConfig).toArray();

            bookieElements.filter(function (el) {
                return el.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER) === bookmaker;
            }).map(function (el) {
                return (0, _jquery2.default)(el).find(_this3.config.priceBtnOddsSelector)[0];
            }).forEach(function (el) {
                var priceInfo = _this3.getRenderConfigFromElement(el);
                var getRaceInfo = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(el);
                var renderConfig = _extends(priceInfo, getRaceInfo, { bookmaker: bookmaker });
                // TODO: clear is some esear way (JIRA: PC-4557)
                _this3.renderPrice(renderConfig);
            });
        }
        // TODO: move to private function or to utils (JIRA: PC-4559)
        /* eslint-disable class-methods-use-this */

    }, {
        key: 'getRenderConfigFromElement',
        value: function getRenderConfigFromElement(element) {
            return {
                outcomersId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID),
                fractionalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL),
                decimalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
                historyPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.HISTORY),
                eventId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID),
                meetingId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID)
            };
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'setOriginPrice',
        value: function setOriginPrice(newPrice) {
            this.originPriceElement = newPrice;
        }
    }, {
        key: 'originPrice',
        get: function get() {
            return this.originPriceElement;
        }
    }]);

    return BestOdds;
}();

exports.default = BestOdds;

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(230);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpAnalytics = __webpack_require__(130);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _DiffusionServiceUtils = __webpack_require__(191);

var _ToteBookmakersNameMap = __webpack_require__(2268);

var _PricesStateStore = __webpack_require__(190);

var _DIFFUSION = __webpack_require__(330);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var nonIntegratedBookieList = {
    'SPORTING INDEX': {
        url: 'https://sports.sportingbet.com/en/sports/racing?wm=4582140#racing=lobby',
        width: 572,
        height: 523,
        name: 'SPORTING INDEX'
    },
    BOLEYSPORTS: {
        url: 'http://www.boylesports.com/addbet?idfiacampaign=32667&id=[$outcomeId]',
        width: 1000,
        height: 600,
        name: 'BOLEYSPORTS'
    },
    '888': {
        url: 'https://www.888sport.com/?sr=1644587',
        width: 1000,
        height: 600,
        name: '888'
    },
    VC: {
        url: 'http://www.betvictor.com/sports/en/coupon/remotes?outcomeids=[[$outcomeId]00]&btagid=90081080',
        width: 986,
        height: 600,
        name: 'VC'
    },
    TOTE: {
        url: 'https://tote.co.uk/[$meeting-name]/[$time]/[$runner-name]/win?utm_source=racingpost&utm_medium=partner-editoral&utm_campaign=oddsgrid&utm_content=odds-grid',
        width: 1050,
        height: 500,
        name: 'TOTE'
    }
};

var bookmakersMap = {
    BET365: 'bet365',
    LADB: 'Ladbrokes',
    WH_OXI: 'William Hill',
    CORAL: 'Coral',
    PPWR: 'Paddy Power',
    BETFAIR: 'Betfair',
    'SPORTING INDEX': 'Sporting',
    VC: 'BetVictor',
    SURREY: 'Sky bet',
    BOLEYSPORTS: 'Boylesport',
    '888': '888sport',
    TOTE: 'Tote',
    '#BESTODDS': 'Best Odds'
};

var LOCATION_DATA_ATTRIBUTE = 'data-price-location';
var RACE_ID_DATA_ATTRIBUTE = 'data-diffusion-race-id';
var DATA_RACE_DATE_TIME = 'data-card-race-date-time';

function isPriceButtonClicked($priceElement) {
    var invalidPricePattern = /^[\s,\-,NR]{1,}$/;
    return $priceElement.length && !$priceElement.text().match(invalidPricePattern);
}

function getBookmakerName($priceElement) {
    var bookieRow = $priceElement.closest('[' + _DIFFUSION2.default.DATA.INPUT.BOOKMAKER + ']')[0];
    if (bookieRow) {
        var bookmaker = bookieRow.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER);
        if (bookmaker) {
            return bookmaker;
        }
    }
    return _PricesStateStore.pricesStateStore.getCurrentBookmaker();
}

function isBookmakerIntegrated(bookmakerName) {
    return !!nonIntegratedBookieList[bookmakerName];
}

function setLocationfromURL() {
    var location = window.location.href;
    if (location.indexOf('horse-tracker') > -1) return 'Horse Tracker';

    if (location.indexOf('profile') > -1) {
        if (location.indexOf('horse') > -1) return 'Horse Profile';
        if (location.indexOf('jockey') > -1) return 'Jockey Profile';
        if (location.indexOf('owner') > -1) return 'Owner Profile';
        if (location.indexOf('trainer') > -1) return 'Trainer Profile';
    }

    if (location.indexOf('tipping') > -1) return 'Tipping Article';
    if (location.indexOf('news') > -1) return 'News Article';

    return 'Undefined location';
}

function trackBetButtonClickAnalytics(bookieName, location, selectionData) {
    var _config;

    var bookmaker = Object.prototype.hasOwnProperty.call(bookmakersMap, bookieName) ? bookmakersMap[bookieName] : bookieName;
    var trackLocation = void 0;

    if (location) {
        trackLocation = location;
    } else {
        trackLocation = setLocationfromURL();
    }

    var config = (_config = {}, _defineProperty(_config, segmentio.TRAIT_LOCATION, trackLocation), _defineProperty(_config, segmentio.TRAIT_BOOKMAKER, bookmaker), _defineProperty(_config, segmentio.TRAIT_PRICE, selectionData.priceType), _defineProperty(_config, segmentio.TRAIT_HORSE_NAME, selectionData.horseName), _config);

    segmentio.identify(undefined, config).then(function () {
        return segmentio.trackBetButtonClick(config);
    });
}

/* eslint-disable class-methods-use-this */

var BetHandler = function () {
    function BetHandler() {
        _classCallCheck(this, BetHandler);

        this.bindEvents();
    }

    _createClass(BetHandler, [{
        key: 'bindEvents',
        value: function bindEvents() {
            var $body = (0, _jquery2.default)('body');

            $body[0].addEventListener('click', this.makeSelectionHandler.bind(this), true);
            $body.on('RC.makeSelection', this.makeSelection.bind(this));
        }
    }, {
        key: 'makeSelectionHandler',
        value: function makeSelectionHandler(event) {
            var $priceElement = (0, _jquery2.default)(event.target).closest('.js-betHandler');
            if (!isPriceButtonClicked($priceElement)) {
                return;
            }
            event.preventDefault();

            var horseElement = $priceElement.closest('.js-diffusionHorsesList')[0] || $priceElement.closest('.js-diffusionBestOdds')[0];
            var raceId = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(RACE_ID_DATA_ATTRIBUTE, horseElement);

            if (!raceId) {
                // eslint-disable-next-line no-console
                console.error('Making selection required parameter missing');
                return;
            }

            var id = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID);
            var fractionalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);
            var decimalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL);
            var isSp = fractionalPrice === 'SP';
            var price = isSp ? null : fractionalPrice;
            var eventId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID);
            var meetingId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID);
            var bookmaker = getBookmakerName($priceElement);

            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName(horseElement);
            var horseName = horseElement.getAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime(horseElement);
            var dataRaceDateTime = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(DATA_RACE_DATE_TIME, horseElement);
            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate(horseElement);
            var location = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(LOCATION_DATA_ATTRIBUTE, horseElement);
            var userMD5 = _jsCookie2.default.get('RP_MD5_COOKIE');
            var topic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
                courseName: courseName,
                raceTime: raceTime,
                raceDate: raceDate,
                bookmaker: bookmaker
            });

            var getCourseName = courseName.toUpperCase();
            var getToteCourseName = getCourseName in _ToteBookmakersNameMap.toteCourseNameMapping ? _ToteBookmakersNameMap.toteCourseNameMapping[getCourseName] : courseName;
            var ToteTimeObj = new Date(dataRaceDateTime);
            var formatMinutes = ToteTimeObj.getMinutes() < 10 ? "0" + ToteTimeObj.getMinutes() : ToteTimeObj.getMinutes();
            var setToteRaceTime = ToteTimeObj.getHours() + ":" + formatMinutes;

            var selectionData = {
                selectionInfo: {
                    id: id,
                    price: price,
                    fractionalPrice: fractionalPrice,
                    decimalPrice: decimalPrice,
                    isSp: isSp,
                    eventId: eventId,
                    meetingId: meetingId,
                    data: {
                        horseName: horseName,
                        courseName: courseName.toLowerCase(),
                        raceDate: raceDate,
                        time: raceTime,
                        eachWayTopic: topic,
                        infoTopic: topic,
                        raceId: raceId
                    },
                    toteUrlParams: {
                        horseName: horseName.replace(/[\W_]/g, '-').toLowerCase(),
                        courseName: getToteCourseName.replace(/[\W_]/g, '-').toLowerCase(),
                        time: setToteRaceTime
                    }
                },
                bookieName: bookmaker,
                userMD5: userMD5,
                priceElement: $priceElement
            };
            this.makeSelection(event, selectionData);

            if ((0, _jquery2.default)(event.target).hasClass('added-to-betslip')) {
                var priceType = isSp ? 'SP' : 'Odds';

                trackBetButtonClickAnalytics(bookmaker, location, {
                    priceType: priceType,
                    horseName: horseName
                });
            }
        }
    }, {
        key: 'onNotIntegratedBookmakerSelected',
        value: function onNotIntegratedBookmakerSelected(data) {
            var bookieName = data.bookieName,
                _data$selectionInfo = data.selectionInfo,
                id = _data$selectionInfo.id,
                price = _data$selectionInfo.price,
                isSp = _data$selectionInfo.isSp,
                priceElement = data.priceElement;

            var notIntegratedBookmaker = nonIntegratedBookieList[bookieName];
            var outcomersId = notIntegratedBookmaker.name === 'BOLEYSPORTS' ? id / 10 : id;
            var dividend = '';
            var divider = '';
            if (!isSp) {
                var splitedPrice = price.split('/');
                dividend = splitedPrice[0];
                divider = splitedPrice[1];
            }

            var toteHorseName = data.selectionInfo.toteUrlParams.horseName;
            var toteCorseName = data.selectionInfo.toteUrlParams.courseName;
            var toteRaceTime = data.selectionInfo.toteUrlParams.time;
            var isOddsComparisonTable = window.location.href.split('/').indexOf('odds-comparison') > 0;

            // tote replacing are [$meeting-name]/[$time]/[$runner-name]/win'

            var url = notIntegratedBookmaker.url.replace('[$runner-name]', toteHorseName).replace('[$time]', toteRaceTime).replace('[$meeting-name]', toteCorseName).replace('[$outcomeId]', outcomersId).replace('[$dividend]', dividend).replace('[$divider]', divider).replace('[$price]', data.selectionInfo.price || '').replace('[$userMD5]', !data.userMD5 ? 'no_MD5_cookie' : data.userMD5).replace('[$eventId]', data.selectionInfo.eventId).replace('[$meetingId]', data.selectionInfo.meetingId).replace('[$utm_content]', isOddsComparisonTable ? 'oddscomparison' : 'racecardsodds');

            priceElement.attr('href', url).attr('data-popup-width', notIntegratedBookmaker.width).attr('data-popup-height', notIntegratedBookmaker.height).attr('data-popup-blank', true).addClass('js-popupLink');
        }
    }, {
        key: 'onIntegratedBookmakerSelected',
        value: function onIntegratedBookmakerSelected(data) {
            var bookieName = data.bookieName,
                _data$selectionInfo2 = data.selectionInfo,
                meetingId = _data$selectionInfo2.meetingId,
                _data$selectionInfo2$ = _data$selectionInfo2.data,
                courseName = _data$selectionInfo2$.courseName,
                raceDate = _data$selectionInfo2$.raceDate,
                time = _data$selectionInfo2$.time;

            var _pricesStateStore$get = _PricesStateStore.pricesStateStore.getRaceInfo({
                bookmaker: bookieName,
                courseName: courseName.toUpperCase(),
                raceDate: raceDate,
                raceTime: time
            }),
                suspendState = _pricesStateStore$get.suspendState,
                winOdds = _pricesStateStore$get.winOdds,
                placeWinner = _pricesStateStore$get.placeWinner,
                isBog = _pricesStateStore$get.isBog;

            _extends(data.selectionInfo, {
                suspendState: suspendState,
                eachWayFraction: winOdds,
                eachWayPlaces: placeWinner,
                isBog: isBog
            });
            var raceId = data.selectionInfo.data.raceId;
            var outcomersId = data.selectionInfo.id;

            if (window.betslipApi && window.betslipApi.isHorseSelected(raceId, outcomersId, meetingId)) {
                var removeSelectionEvent = new CustomEvent('BETSLIP.REMOVE_SELECTION', { detail: data });
                document.dispatchEvent(removeSelectionEvent);
                // for back compatibility (temporary)
                _jquery2.default.event.trigger('BETSLIP.REMOVE_SELECTION', _extends({}, data));
            } else {
                var makeSelectionEvent = new CustomEvent('BETSLIP.MAKE_SELECTION', { detail: data });
                document.dispatchEvent(makeSelectionEvent);
                // for back compatibility (temporary)
                _jquery2.default.event.trigger('BETSLIP.MAKE_SELECTION', _extends({}, data));
            }
        }
    }, {
        key: 'makeSelection',
        value: function makeSelection(event, data) {
            var bookieName = data.bookieName;

            if (isBookmakerIntegrated(bookieName)) {
                this.onNotIntegratedBookmakerSelected(data);
            } else if (data.bookieName !== '#BESTODDS') {
                this.onIntegratedBookmakerSelected(data);
            }
        }
    }]);

    return BetHandler;
}();
/* eslint-enable class-methods-use-this */

exports.default = BetHandler;

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pricesStateStore = exports.horsesListStore = exports.diffusionServiceUtils = exports.pricesProvider = exports.priceButton = exports.PRICE_HANDLER_EVENTS = exports.BestOdds = exports.PopOver = exports.BetHandler = undefined;

__webpack_require__(1764);

var _PopOver = __webpack_require__(927);

var _PopOver2 = _interopRequireDefault(_PopOver);

var _BestOdds = __webpack_require__(2261);

var _BestOdds2 = _interopRequireDefault(_BestOdds);

var _DiffusionServiceUtils = __webpack_require__(191);

var _BetHandler = __webpack_require__(2262);

var _BetHandler2 = _interopRequireDefault(_BetHandler);

var _PricesStateStore = __webpack_require__(190);

var _HorsesListStore = __webpack_require__(926);

var _priceButtonPresenter = __webpack_require__(2264);

var _PricesProvider = __webpack_require__(924);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BetHandler = _BetHandler2.default;
exports.PopOver = _PopOver2.default;
exports.BestOdds = _BestOdds2.default;
exports.PRICE_HANDLER_EVENTS = _PricesProvider.PRICE_HANDLER_EVENTS;
exports.priceButton = _priceButtonPresenter.priceButton;
exports.pricesProvider = _PricesProvider.pricesProvider;
exports.diffusionServiceUtils = _DiffusionServiceUtils.diffusionServiceUtils;
exports.horsesListStore = _HorsesListStore.horsesListStore;
exports.pricesStateStore = _PricesStateStore.pricesStateStore;

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.priceButton = exports.PRICE_BUTTON = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

var _DiffusionServiceUtils = __webpack_require__(191);

var _DIFFUSION = __webpack_require__(330);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _PricesStateStore = __webpack_require__(190);

var _PricesProvider = __webpack_require__(924);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRICE_BUTTON = exports.PRICE_BUTTON = {
    CLASSES: {
        SUBSCRIBED: 'js-PC-subscribed',
        NOT_SUBSCRIBED: '.js-diffusionHorsesList:not(.js-PC-subscribed)',
        NOT_CLICKABLE: 'noPointerClass',
        HIDDEN: 'ui-priceBtn_noPrice'
    },
    SELECTORS: {
        RACE_SETTINGS: '.js-diffusionTopicSettingsRace', // General container
        HORSE_ELEMENT: '.js-diffusionHorsesList', // Div with particular price
        PRICE_VALUE: '.js-diffusionPriceValue' // <a> with data from diffusion
    },
    POPUP: {
        HEIGHT: 'data-popup-height',
        WIDTH: 'data-popup-width',
        BLANK: 'data-popup-blank',
        LINK_CLASS: 'js-popupLink'
    },
    BOOKMAKERS: {
        WH_OXI: 'ui-priceBtn_williamHill',
        '#BESTODDS': 'ui-priceBtn_bestOdds',
        LADB: 'ui-priceBtn_ladbrokes',
        BET365: 'ui-priceBtn_bet365',
        CORAL: 'ui-priceBtn_coral',
        PPWR: 'ui-priceBtn_paddypower',
        BETFAIR: 'ui-priceBtn_betfair',
        VC: 'ui-priceBtn_betVictor',
        'SPORTING INDEX': 'ui-priceBtn_sportingBet',
        SURREY: 'ui-priceBtn_skybet',
        '888': 'ui-priceBtn_888sport',
        BOLEYSPORTS: 'ui-priceBtn_boylesport',
        TOTE: 'ui-priceBtn_tote'
    }
};

/* eslint-disable no-use-before-define */
var priceButton = exports.priceButton = {
    activate: activate,
    deactivate: deactivate
};

function activate() {
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
    addBetslipEventListeners();
}

function deactivate() {
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
}

function onPriceReceived(renderConfig) {
    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
    if (currentBookmaker === renderConfig.bookmaker) {
        renderPrice(renderConfig);
    }
}

function onPriceSettingsChanged(_ref) {
    var showDecimal = _ref.showDecimal;

    togglePricesViewType({ showDecimal: showDecimal });
}

function onPricesWillBeUpdated() {
    clearPrices();
}

function addBetslipEventListeners() {
    document.addEventListener('BETSLIP.SELECTION_MADE', function () {
        setAddedToBetslipClass();
    });

    document.addEventListener('BETSLIP.SELECTION_REMOVED', function () {
        setAddedToBetslipClass();
    });
}

function onRaceInfoReceived(_ref2) {
    var bookmaker = _ref2.bookmaker,
        courseName = _ref2.courseName,
        raceDate = _ref2.raceDate,
        raceTime = _ref2.raceTime,
        suspendState = _ref2.suspendState;

    if (suspendState === 'H') {
        markPricesOfFinishedRaces({ bookmaker: bookmaker, courseName: courseName, raceDate: raceDate, raceTime: raceTime });
    }
}

function markPricesOfFinishedRaces(_ref3) {
    var bookmaker = _ref3.bookmaker,
        courseName = _ref3.courseName,
        raceDate = _ref3.raceDate,
        raceTime = _ref3.raceTime;

    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();
    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

    if (bookmaker !== currentBookmaker) {
        return;
    }
    priceElements.filter(function (priceElement) {
        var elementData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(priceElement);

        return elementData.courseName === courseName && elementData.raceDate === raceDate && elementData.raceTime === raceTime;
    }).forEach(function (priceElement) {
        var element = priceElement;

        element.innerHTML = '-';
        element.classList.add(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
    });
}

function togglePricesViewType(_ref4) {
    var showDecimal = _ref4.showDecimal;

    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();

    priceElements.forEach(togglePriceViewType);

    function togglePriceViewType(priceElement) {
        var element = priceElement;
        var currentValue = priceElement.innerHTML;
        var isNoPrice = ['', '-', 'SP'].includes(currentValue);

        if (!isNoPrice) {
            element.innerHTML = showDecimal ? Math.floor(parseFloat(priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL)) * 100) / 100 : priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);

            if (_DIFFUSION2.default.DATA.INPUT.BOOKMAKER === 'TOTE') {
                element.innerHTML = parseFloat(element.innerHTML).toFixed(2);
            }
        }
    }
}

function renderPrice(renderConfig) {
    var priceElements = _DiffusionServiceUtils.diffusionServiceUtils.getPriceContainer(renderConfig);

    priceElements.forEach(function (buttonContainer) {
        var priceElement = (0, _jquery2.default)(buttonContainer).find(PRICE_BUTTON.SELECTORS.PRICE_VALUE)[0];
        var $priceElement = (0, _jquery2.default)(priceElement);
        var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);

        if (priceElement) {
            applyButtonStyling($priceElement, renderPriceValue, renderConfig.bookmaker);

            setDiffusionDataAttributes($priceElement, _extends(renderConfig, { nextPrice: renderPriceValue }));
            $priceElement.text(renderPriceValue);
        }
    });

    setAddedToBetslipClass();
}

function clearPrices() {
    (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray().forEach(function (priceElement) {
        var element = priceElement;

        element.innerHTML = '';
        setDiffusionDataAttributes(element, {});
        clearBookmakerStyling(element);
    });
}

function setAddedToBetslipClass() {
    var nextSelections = !!window.betslipApi && window.betslipApi.getSelectedBets();
    (0, _jquery2.default)('.added-to-betslip').removeClass('added-to-betslip');
    if (nextSelections.length) {
        nextSelections.forEach(function (selection) {
            var $priceElements = (0, _jquery2.default)('[data-diffusion-outcomers-id="' + selection.outcomersId + '"][data-diffusion-meeting-id="' + selection.meetingId + '"]');
            if ($priceElements.length) {
                $priceElements.addClass('added-to-betslip');
            }
        });
    }
}

function setDiffusionDataAttributes(element, priceConfig) {
    (0, _jquery2.default)(element).attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, priceConfig.outcomersId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, priceConfig.fractionalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, priceConfig.decimalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.HISTORY, priceConfig.historyPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.STATUS, priceConfig.status || '').attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, priceConfig.eventId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, priceConfig.meetingId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.NEXT_PRICE, priceConfig.nextPrice || '').attr(PRICE_BUTTON.POPUP.WIDTH, '').attr(PRICE_BUTTON.POPUP.HEIGHT, '').attr('href', '#');
}

function clearBookmakerStyling(element) {
    var $element = (0, _jquery2.default)(element);

    $element.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
    Object.keys(PRICE_BUTTON.BOOKMAKERS).forEach(function (feed) {
        $element.removeClass(PRICE_BUTTON.BOOKMAKERS[feed]);
    });
}

function applyButtonStyling($priceElement, renderPriceValue, bookmaker) {
    $priceElement.removeClass(PRICE_BUTTON.POPUP.LINK_CLASS);

    if (renderPriceValue) {
        if (renderPriceValue === '-') {
            $priceElement.addClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
        } else {
            $priceElement.removeClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
        }
        $priceElement.removeClass(PRICE_BUTTON.CLASSES.HIDDEN).addClass(PRICE_BUTTON.BOOKMAKERS[bookmaker]);
    } else {
        $priceElement.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
    }
}

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiffusionFeedHelper = function () {
    function DiffusionFeedHelper() {
        _classCallCheck(this, DiffusionFeedHelper);

        this.bookmakerFeedConfig = [{ bookmaker: 'PPWR', feed: 'PADDYPOWER' }, { bookmaker: 'BETFAIR', feed: 'BETFAIR' }, { bookmaker: 'WH_OXI', feed: 'WH_OXI' }, { bookmaker: 'LADB', feed: 'LADB' }, { bookmaker: 'BET365', feed: 'BET365' }, { bookmaker: 'CORAL', feed: 'CORAL' }, { bookmaker: 'BOLEYSPORTS', feed: 'BOLEYSPORTS' }, { bookmaker: 'RB', feed: 'RB' }, { bookmaker: 'SPORTING INDEX', feed: 'SPORTING INDEX' }, { bookmaker: 'SURREY', feed: 'SURREY' }, { bookmaker: '888', feed: '888' }, { bookmaker: 'VC', feed: 'VC' }, { bookmaker: 'TOTE', feed: 'TOTE' }];
    }

    _createClass(DiffusionFeedHelper, [{
        key: 'getFeedByBookmaker',
        value: function getFeedByBookmaker(bookmaker) {
            var found = this.bookmakerFeedConfig.find(function (item) {
                return item.bookmaker === bookmaker;
            });
            return found ? found.feed : bookmaker;
        }
    }, {
        key: 'getBookmakerByFeed',
        value: function getBookmakerByFeed(feed) {
            var found = this.bookmakerFeedConfig.find(function (item) {
                return item.feed === feed;
            });
            return found ? found.bookmaker : feed;
        }
    }]);

    return DiffusionFeedHelper;
}();

exports.default = new DiffusionFeedHelper();

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prepareTopics = exports.combineArrays = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestIdleCallback = __webpack_require__(2137);

var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// [a, b] + [c, d, e] = [ a, c, b, d, e ]
var combineArrays = exports.combineArrays = function combineArrays(first, second) {
    var result = [];
    while (first.length > 0 || second.length > 0) {
        if (first.length > 0) {
            result.push(first.shift());
        }
        if (second.length > 0) {
            result.push(second.shift());
        }
    }

    return result;
};

// in order to subscribe for prices in both columns in parallel.
var prepareTopics = exports.prepareTopics = function prepareTopics(topics) {
    var preparedTopics = [];
    if ((0, _jquery2.default)(document).width() < 768) {
        preparedTopics = Array.from(topics);
    } else {
        var center = topics.findIndex(function (topic) {
            return topic.indexOf && topic.indexOf('WIN/M') > -1;
        });
        preparedTopics = combineArrays(topics.slice(0, center), topics.slice(center));
    }

    return preparedTopics;
};

var Subscriber = function () {
    function Subscriber(session) {
        var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        _classCallCheck(this, Subscriber);

        this.taskList = [];
        this.isActive = false;
        this.session = session;
        this.currentTaskId = 0;
        this.chunkSize = chunkSize;
        this.runTask = this.runTask.bind(this);
    }

    _createClass(Subscriber, [{
        key: 'run',
        value: function run() {
            this.isActive = true;
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.isActive = false;
        }
    }, {
        key: 'addTask',
        value: function addTask(taskHandler, taskData) {
            this.taskList.push({
                handler: taskHandler,
                data: taskData
            });

            if (!this.currentTaskId) {
                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
            }
        }
    }, {
        key: 'runTask',
        value: function runTask(deadline) {
            while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.taskList.length && this.isActive) {
                var task = this.taskList.shift();
                task.handler(task.data);
            }

            if (this.taskList.length) {
                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
            } else {
                this.currentTaskId = 0;
            }
        }
    }, {
        key: 'schedule',
        value: function schedule(topics) {
            var _this = this;

            var chunks = [];
            var preparedTopics = prepareTopics(topics);

            for (var i = 0; i < topics.length; i += this.chunkSize) {
                chunks.push(preparedTopics.slice(i, i + this.chunkSize));
            }

            chunks.forEach(function (chunk) {
                _this.addTask(_this.session.subscribe, { topics: chunk });
            });
        }
    }, {
        key: 'subscribe',
        value: function subscribe(topics) {
            if (!this.session || !topics.map) {
                return;
            }

            if (topics.length <= this.chunkSize) {
                this.session.subscribe({ topics: topics });
            } else {
                this.schedule(topics);
            }
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.stop();
            this.taskList = [];
            _requestIdleCallback2.default.cancelIdleCallback(this.currentTaskId);
            this.currentTaskId = 0;
            this.session.unsubscribeAll();
            this.run();
        }
    }]);

    return Subscriber;
}();

exports.default = Subscriber;

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PubSub = function () {
    function PubSub() {
        _classCallCheck(this, PubSub);

        this.handlers = [];
    }

    _createClass(PubSub, [{
        key: "subscribe",
        value: function subscribe(event, handler) {
            this.handlers.push({ event: event, handler: handler });
        }
    }, {
        key: "unsubscribe",
        value: function unsubscribe(event, handler) {
            this.handlers = this.handlers.filter(function (savedHandler) {
                return !(savedHandler.event === event && savedHandler.handler === handler);
            });
        }
    }, {
        key: "publish",
        value: function publish(event, args) {
            this.handlers.filter(function (topic) {
                return topic.event === event;
            }).forEach(function (topic) {
                return topic.handler(args);
            });
        }
    }]);

    return PubSub;
}();

exports.default = PubSub;

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var toteCourseNameMapping = exports.toteCourseNameMapping = {
    "ASCOT": "ASCOT",
    "AYR": "AYR",
    "BANGOR-ON-DEE": "BANGOR",
    "CARLISLE": "CARLISLE",
    "CATTERICK": "CATTERICK",
    "CHELMSFORD": "CHELMSFORD CITY",
    "CHELMSFORD (A.W)": "CHELMSFORD CITY",
    "CHELTENHAM": "CHELTENHAM",
    "CHEPSTOW": "CHEPSTOW",
    "CLONMEL": "CLONMEL",
    "CORK": "CORK",
    "DONCASTER": "DONCASTER",
    "DOWN ROYAL": "DOWN ROYAL",
    "DOWNPATRICK": "DOWNPATRICK",
    "DUNDALK (A.W)": "DUNDALK",
    "EXETER": "EXETER",
    "FAIRYHOUSE": "FAIRYHOUSE",
    "FAKENHAM": "FAKENHAM",
    "FFOS LAS": "FFOS LAS",
    "FONTWELL": "FONTWELL",
    "GOWRAN PARK": "GOWRAN",
    "HAYDOCK": "HAYDOCK PARK",
    "HEREFORD": "HEREFORD",
    "HEXHAM": "HEXHAM",
    "HUNTINGDON": "HUNTINGDON",
    "KELSO": "KELSO",
    "KEMPTON": "KEMPTON PARK",
    "KEMPTON (A.W)": "KEMPTON PARK",
    "LEICESTER": "LEICESTER",
    "LEOPARDSTOWN": "LEOPARDSTOWN",
    "LIMERICK": "LIMERICK",
    "LINGFIELD": "LINGFIELD PARK",
    "LINGFIELD (A.W)": "LINGFIELD PARK",
    "LUDLOW": "LUDLOW",
    "MARKET RASEN": "MARKET RASEN",
    "MUSSELBURGH": "MUSSELBURGH",
    "NAAS": "NAAS",
    "NAVAN": "NAVAN",
    "NEWBURY": "NEWBURY",
    "NEWCASTLE": "NEWCASTLE",
    "NEWCASTLE (A.W)": "NEWCASTLE",
    "PLUMPTON": "PLUMPTON",
    "PUNCHESTOWN": "PUNCHESTOWN",
    "RIPON": "RIPON",
    "SEDGEFIELD": "SEDGEFIELD",
    "SOUTHWELL": "SOUTHWELL",
    "SOUTHWELL (A.W)": "SOUTHWELL",
    "STRATFORD": "STRATFORD",
    "TAUNTON": "TAUNTON",
    "THURLES": "THURLES",
    "TRAMORE": "TRAMORE",
    "UTTOXETER": "UTTOXETER",
    "WARWICK": "WARWICK",
    "WETHERBY": "WETHERBY",
    "WEXFORD": "WEXFORD",
    "WINCANTON": "WINCANTON",
    "WOLVERHAMPTON (A.W)": "WOLVERHAMPTON"
};

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disabledScrollClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(6);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = __webpack_require__(65);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SelectPopover = __webpack_require__(2275);

var _SelectPopover2 = _interopRequireDefault(_SelectPopover);

var _SelectButton = __webpack_require__(2272);

var _SelectButton2 = _interopRequireDefault(_SelectButton);

var _SelectOption = __webpack_require__(2274);

var _SelectOption2 = _interopRequireDefault(_SelectOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var disabledScrollClass = exports.disabledScrollClass = 'ui-disabledScroll';

var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
    NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;

/**
 * The Select component. The only exported component.
 */

var Select = function (_PureComponent) {
    _inherits(Select, _PureComponent);

    _createClass(Select, null, [{
        key: 'toggleElementClass',
        value: function toggleElementClass(element, className, enabled) {
            // IE 11 doesn't support second parameter in classList.toggle
            if (enabled) {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        }
    }, {
        key: 'toggleDisabledScrollClass',
        value: function toggleDisabledScrollClass(enabled) {
            Select.toggleElementClass(document.querySelector('html'), disabledScrollClass, enabled);
            Select.toggleElementClass(document.body, disabledScrollClass, enabled);
        }
    }, {
        key: 'getOptionProp',
        value: function getOptionProp(option, getter) {
            if ((0, _lodash.isString)(getter) || (0, _lodash.isArray)(getter)) {
                return (0, _lodash.get)(option, getter);
            }

            if ((0, _lodash.isFunction)(getter)) {
                return getter(option);
            }

            return null;
        }
    }]);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.renderNoOptions = function () {
            var _this$props = _this.props,
                noOptionsRenderer = _this$props.noOptionsRenderer,
                noOptionsMessage = _this$props.noOptionsMessage;


            if (noOptionsRenderer) return noOptionsRenderer();

            return _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__icon' },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    noOptionsMessage
                )
            );
        };

        _this.state = {
            popoverOpen: false,
            query: ''
        };
        _this.startPagePositionTop = null;

        _this.handlePageClick = _this.handlePageClick.bind(_this);
        _this.handleBreakpointChange = _this.handleBreakpointChange.bind(_this);

        _this.closePopover = _this.closePopover.bind(_this);
        _this.togglePopover = _this.togglePopover.bind(_this);

        _this.clearSelection = _this.clearSelection.bind(_this);

        _this.handleButtonClick = _this.handleButtonClick.bind(_this);
        _this.handleOptionClick = _this.handleOptionClick.bind(_this);

        _this.handleQueryChange = _this.handleQueryChange.bind(_this);

        _this.getOptionLabel = _this.getOptionLabel.bind(_this);
        _this.getOptionValue = _this.getOptionValue.bind(_this);
        _this.isOptionSelected = _this.isOptionSelected.bind(_this);
        _this.renderButtonLabel = _this.renderButtonLabel.bind(_this);
        _this.renderButtonOption = _this.renderButtonOption.bind(_this);
        _this.renderOption = _this.renderOption.bind(_this);
        return _this;
    }

    _createClass(Select, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('click', this.handlePageClick, false);
            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('click', this.handlePageClick, false);
            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);

            if (this.isPopoverOpen()) {
                this.closePopover();
            }
        }
    }, {
        key: 'getRenderingOptions',
        value: function getRenderingOptions() {
            var _this2 = this;

            var _props = this.props,
                options = _props.options,
                optionsSorter = _props.optionsSorter;
            var _state$query = this.state.query,
                query = _state$query === undefined ? '' : _state$query;

            return (optionsSorter === null ? _lodash.identity : _lodash.sortBy)(!query ? options : options.filter(function (option) {
                return _this2.props.optionsQueryComparator(_this2.getOptionLabel(option), query);
            }), optionsSorter || function (option) {
                return _this2.getOptionLabel(option).toLowerCase();
            });
        }
    }, {
        key: 'getOptionValue',
        value: function getOptionValue(option) {
            return Select.getOptionProp(option, this.props.valueGetter);
        }
    }, {
        key: 'getOptionLabel',
        value: function getOptionLabel(option) {
            return Select.getOptionProp(option, this.props.labelGetter);
        }
    }, {
        key: 'isOptionSelected',
        value: function isOptionSelected(option) {
            var currentValue = this.getOptionValue(option);
            if ((0, _lodash.isArray)(this.props.value)) {
                return this.props.value.indexOf(currentValue) >= 0;
            }
            return currentValue === this.props.value;
        }
    }, {
        key: 'isPopoverOpen',
        value: function isPopoverOpen() {
            return this.state.popoverOpen;
        }
    }, {
        key: 'togglePopover',
        value: function togglePopover() {
            var popoverOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.isPopoverOpen();

            this.setState({
                popoverOpen: popoverOpen
            });

            this.togglePageScroll(popoverOpen, _rpMqBreakpoints2.default.current().code);
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.togglePopover(false);
        }
    }, {
        key: 'clearSelection',
        value: function clearSelection(e, value) {
            e.stopPropagation();

            if (this.props.disabled) {
                return;
            }

            var result = this.props.multiSelect ? this.props.value.filter(function (item) {
                return item !== value;
            }) : null;

            this.props.onChange(result);
        }
    }, {
        key: 'togglePageScroll',
        value: function togglePageScroll(popoverOpen, breakpointCode) {
            if (popoverOpen && [EXTRA_NARROW, NARROW].indexOf(breakpointCode) > -1) {
                this.disablePageScroll();
            } else {
                this.enablePageScroll();
            }
        }
    }, {
        key: 'enablePageScroll',
        value: function enablePageScroll() {
            Select.toggleDisabledScrollClass(false);

            if (this.startPagePositionTop !== null) {
                var windowPageYOffset = this.rootRef.getBoundingClientRect().top - this.startPagePositionTop + window.pageYOffset;
                this.startPagePositionTop = null;
                window.setTimeout(function () {
                    window.scrollTo(window.pageXOffset, windowPageYOffset);
                }, 0);
            }
        }
    }, {
        key: 'disablePageScroll',
        value: function disablePageScroll() {
            this.startPagePositionTop = this.rootRef.getBoundingClientRect().top;

            Select.toggleDisabledScrollClass(true);
        }
    }, {
        key: 'handleBreakpointChange',
        value: function handleBreakpointChange(e) {
            if (this.isPopoverOpen()) {
                this.togglePageScroll(true, e.detail.breakpoint.code);
            }
        }
    }, {
        key: 'handleSingleOptionClick',
        value: function handleSingleOptionClick(value, option) {
            this.props.onChange(value, option);
            this.closePopover();
        }
    }, {
        key: 'handleMultiOptionClick',
        value: function handleMultiOptionClick(value, option) {
            this.props.onChange(value, option);
        }
    }, {
        key: 'handleOptionClick',
        value: function handleOptionClick(value, option) {
            var _props2 = this.props,
                onChange = _props2.onChange,
                multiSelect = _props2.multiSelect;

            onChange(value, option);
            if (!multiSelect) {
                this.closePopover();
            }
        }
    }, {
        key: 'handleQueryChange',
        value: function handleQueryChange(query) {
            this.setState({ query: query });
        }
    }, {
        key: 'handlePageClick',
        value: function handlePageClick(e) {
            if (this.isPopoverOpen() && !this.rootRef.contains(e.target)) {
                this.closePopover();
            }
        }
    }, {
        key: 'handleButtonClick',
        value: function handleButtonClick() {
            this.togglePopover();
        }
    }, {
        key: 'renderButtonOption',
        value: function renderButtonOption(value) {
            var _this3 = this;

            var option = this.props.options.find(function (item) {
                return _this3.getOptionValue(item) === value;
            });
            return _react2.default.createElement(
                'span',
                { className: 'sb-select__button__label_flag', key: value },
                _react2.default.createElement(
                    'span',
                    { className: 'sb-select__button__label' },
                    this.getOptionLabel(option)
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: 'sb-select__button__label_flagClose',
                        onClick: function onClick(e) {
                            return _this3.clearSelection(e, value);
                        }
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Small' })
                )
            );
        }
    }, {
        key: 'renderButtonLabel',
        value: function renderButtonLabel() {
            var _props3 = this.props,
                multiSelect = _props3.multiSelect,
                value = _props3.value,
                placeholder = _props3.placeholder;


            if ((0, _lodash.isNil)(value) || multiSelect && !value.length) {
                return placeholder;
            }

            return multiSelect ? value.map(this.renderButtonOption) : this.renderButtonOption(value);
        }
    }, {
        key: 'renderOption',
        value: function renderOption(option) {
            return _react2.default.createElement(_SelectOption2.default, {
                key: this.getOptionValue(option),
                option: option,
                labelGetter: this.getOptionLabel,
                valueGetter: this.getOptionValue,
                isSelected: this.isOptionSelected,
                immediateUpdate: this.props.multiSelect,
                onClick: this.handleOptionClick
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props4 = this.props,
                title = _props4.title,
                disabled = _props4.disabled,
                alphabet = _props4.alphabet,
                showSearch = _props4.showSearch,
                onPopoverDidOpen = _props4.onPopoverDidOpen,
                multiSelect = _props4.multiSelect,
                options = _props4.options,
                rowHeight = _props4.rowHeight;
            var query = this.state.query;

            return _react2.default.createElement(
                'div',
                {
                    className: 'sb-select ' + (multiSelect ? 'sb-select_multi' : ''),
                    ref: function ref(_ref) {
                        return _this4.rootRef = _ref;
                    }
                },
                _react2.default.createElement(_SelectButton2.default, {
                    label: this.renderButtonLabel(),
                    major: this.isPopoverOpen(),
                    disabled: disabled,
                    onClick: this.handleButtonClick
                }),
                this.isPopoverOpen() ? _react2.default.createElement(_SelectPopover2.default, {
                    title: title,
                    alphabet: alphabet,
                    showSearch: showSearch && options.length > 0,
                    query: query,
                    rowHeight: rowHeight,
                    options: this.getRenderingOptions(),
                    optionLabelGetter: this.getOptionLabel,
                    optionRenderer: this.renderOption,
                    noOptionsRenderer: this.renderNoOptions,
                    onQueryChange: this.handleQueryChange,
                    onClose: this.closePopover,
                    onDidMount: onPopoverDidOpen
                }) : null
            );
        }
    }]);

    return Select;
}(_react.PureComponent);

Select.propTypes = {
    /**
     * Title to be displayed in popover on mobile devices
     */
    title: _react.PropTypes.string.isRequired,
    /**
     * Placeholder to be displayed while no value selected
     */
    placeholder: _react.PropTypes.string,
    /**
     * Disables the component
     */
    disabled: _react.PropTypes.bool,
    /**
     * Select should be used as a controlled component.
     * This property sets it's value.
     */
    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.array]),
    /**
     * This property allows multiple options to be selected..
     */
    multiSelect: _react.PropTypes.bool,
    /**
     * Options to be rendered in open popover.
     * It should have structure [{ label: 'Option Label', value: 'optionValue' }] by default.
     * Options with custom structure are acceptable too (see 'labelGetter' and 'valueGetter' for details).
     */
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
    /**
     * Shows alphabet in popover.
     * It could be boolean if you want to control the visibility of the default (English) alphabet.
     * You can also provide a string with custom chars to be rendered instead of default alphabet.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
    /**
     * Controls the visibility of search input in popover.
     */
    showSearch: _react.PropTypes.bool,
    /**
     * Controls height of row element, defaults to 64px
     */
    rowHeight: _react.PropTypes.number,
    /**
     * You can set custom option label getter if you have custom option object structure.
     * By default it is 'label'.
     * It uses _.get for string and array label getter.
     * You also can pass a function which accepts option object as a parameter and returns string label.
     * For example, ({ name }) => name
     */
    labelGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
    /**
     * You can set custom option value getter if you have custom option object structure.
     * By default it is 'value'.
     * It uses _.get for string and array value getter.
     * You also can pass a function which accepts option object as a parameter and returns value.
     * For example, ({ id }) => id
     */
    valueGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
    /**
     * By default options are sorted by labels in alphabet order.
     * You can override default sorting with this property.
     * It uses _.sortBy API.
     * Pass null if you want to disable sorting.
     */
    optionsSorter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
    /**
     * Comapring option and filter query
     */
    optionsQueryComparator: _react.PropTypes.func,
    /**
     * Message to render if no options available (due to search query or any other reason).
     * It is ignored if noOptionsRenderer is set.
     */
    noOptionsMessage: _react.PropTypes.string,
    /**
     * Function that renders the placeholder if no options available (due to search query or any other reason)
     */
    noOptionsRenderer: _react.PropTypes.func,
    /**
     * Select should be used as a controlled component.
     * You should handle change event with this property to change component value.
     */
    onChange: _react.PropTypes.func.isRequired,
    /**
     * You can handle popover open with this property.
     * If your handler returns Promise, component will render the Spinne while promise unresolved.
     * It could be used to load options asynchronously.
     */
    onPopoverDidOpen: _react.PropTypes.func
};

Select.defaultProps = {
    value: null,
    placeholder: 'Select',
    labelGetter: 'label',
    valueGetter: 'value',
    noOptionsMessage: 'No results',
    noOptionsRenderer: null,
    optionsQueryComparator: function optionsQueryComparator(optionLabel, query) {
        return optionLabel.toLowerCase().indexOf(query.toLowerCase()) > -1;
    }
};

exports.default = Select;

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The alphabet.
 */
var SelectAlphabet = function SelectAlphabet(_ref) {
    var alphabet = _ref.alphabet,
        _onClick = _ref.onClick;
    return _react2.default.createElement(
        'ul',
        { className: 'sb-selectAlphabet' },
        ((0, _lodash.isString)(alphabet) ? alphabet.split('') : alphabet).map(function (character, index) {
            return _react2.default.createElement(
                'li',
                {
                    key: index,
                    onClick: function onClick() {
                        return _onClick(character);
                    },
                    className: 'sb-selectAlphabet__character'
                },
                character
            );
        })
    );
};

SelectAlphabet.propTypes = {
    /**
     * You can provide string with all alphabet characters or an array of characters to be displayed.
     * It is English alphabet by default.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.string]),
    /**
     * The 'click' event handler.
     * It will receive a character as an argument.
     */
    onClick: _react.PropTypes.func.isRequired
};

SelectAlphabet.defaultProps = {
    alphabet: 'abcdefghijklmnopqrstuvwxyz'
};

exports.default = SelectAlphabet;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(824);

var _throttle2 = _interopRequireDefault(_throttle);

var _isMatch = __webpack_require__(1932);

var _isMatch2 = _interopRequireDefault(_isMatch);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectAutoSizer = function (_PureComponent) {
    _inherits(SelectAutoSizer, _PureComponent);

    function SelectAutoSizer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SelectAutoSizer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectAutoSizer.__proto__ || Object.getPrototypeOf(SelectAutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            measured: false,
            height: null,
            width: null
        }, _this.checkSize = function () {
            // TODO: width and height should be calculated without padding
            var _this$parentRef = _this.parentRef,
                clientWidth = _this$parentRef.clientWidth,
                clientHeight = _this$parentRef.clientHeight;

            var _this$props$sizeProce = _this.props.sizeProcessor({
                height: clientHeight,
                width: clientWidth
            }),
                height = _this$props$sizeProce.height,
                width = _this$props$sizeProce.width;

            var state = {
                height: height,
                width: width,
                measured: true
            };
            if ((0, _isMatch2.default)(_this.state, state)) {
                return;
            }
            _this.setState(state, _this.props.onDidResize);
        }, _this.checkSizeThrottled = (0, _throttle2.default)(_this.checkSize, 100, { leading: false, trailing: true }), _this.handleResize = _this.checkSizeThrottled, _this.handleOrientationChange = function () {
            // Mobile devices (iOS 10.3.1) don't return valid parent element size
            // right after the screen orientation change. It also fires the resize event
            // with the same issue.
            // So we need to check size after some time past after event.
            // The only robust way to get new screen size I've found is to
            // check the size several times (during at least 500ms).
            // We could do this just once after 500ms past but it makes the UX worse.
            // I've also tried to check repeatedly until the first size change happened
            // but there were situations on iOS when it returns new height
            // with old width.
            var count = 0;
            var checkSizeRepeated = function checkSizeRepeated() {
                _this.checkSizeThrottled();
                count += 1;
                if (count < 5) {
                    setTimeout(checkSizeRepeated, 100);
                }
            };
            checkSizeRepeated();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectAutoSizer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.parentRef = this.rootRef.parentNode;
            this.checkSize();

            window.addEventListener('resize', this.handleResize);
            window.addEventListener('orientationchange', this.handleOrientationChange);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.checkSize();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('orientationchange', this.handleOrientationChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                measured = _state.measured,
                height = _state.height,
                width = _state.width;

            return _react2.default.createElement(
                'div',
                { ref: function ref(_ref2) {
                        return _this2.rootRef = _ref2;
                    } },
                measured ? this.props.contentRenderer({ height: height, width: width })
                // Hack for IE11 to get correct clientWidth
                : _react2.default.createElement(
                    'div',
                    null,
                    '\xA0'
                )
            );
        }
    }]);

    return SelectAutoSizer;
}(_react.PureComponent);

SelectAutoSizer.propTypes = {
    sizeProcessor: _react.PropTypes.func,
    contentRenderer: _react.PropTypes.func.isRequired,
    onDidResize: _react.PropTypes.func
};
SelectAutoSizer.defaultProps = {
    sizeProcessor: function sizeProcessor(obj) {
        return obj;
    },
    onDidResize: function onDidResize() {
        return null;
    }
};
exports.default = SelectAutoSizer;

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The button with selected value that toggles the popover.
 * It doesn't pass element to the ref callback if written as a stateless function.
 */
var SelectButton = function (_PureComponent) {
    _inherits(SelectButton, _PureComponent);

    function SelectButton() {
        _classCallCheck(this, SelectButton);

        return _possibleConstructorReturn(this, (SelectButton.__proto__ || Object.getPrototypeOf(SelectButton)).apply(this, arguments));
    }

    _createClass(SelectButton, [{
        key: 'render',
        // eslint-disable-line
        value: function render() {
            var _props = this.props,
                label = _props.label,
                major = _props.major,
                disabled = _props.disabled,
                onClick = _props.onClick;

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('ui-btn', 'sb-select__button', {
                        'ui-btn_primary': major,
                        'ui-btn_primary--disabled': major && disabled,
                        'ui-btn--disabled': !major && disabled
                    }),
                    onClick: disabled ? null : onClick
                },
                _react2.default.createElement(
                    'span',
                    { className: 'sb-select__button__label' },
                    label
                ),
                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'down', size: 'Medium' })
            );
        }
    }]);

    return SelectButton;
}(_react.PureComponent);

SelectButton.propTypes = {
    /**
     * This is the label to be displayed.
     * It could be a string or a node to render.
     */
    label: _react.PropTypes.node.isRequired,
    /**
     * Applies major button styling.
     */
    major: _react.PropTypes.bool.isRequired,
    /**
     * Disables the button.
     */
    disabled: _react.PropTypes.bool,
    /**
     * The 'click' event handler.
     */
    onClick: _react.PropTypes.func.isRequired
};

exports.default = SelectButton;

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The search input.
 */
var SelectInput = function SelectInput(_ref) {
  var title = _ref.title,
      value = _ref.value,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown;
  return _react2.default.createElement(
    "div",
    { className: "sb-select__inputContainer" },
    _react2.default.createElement(
      "span",
      { className: "sb-select__inputLabel" },
      title
    ),
    _react2.default.createElement("input", {
      className: "sb-select__input",
      type: "text",
      maxLength: "30",
      placeholder: "Search...",
      value: value,
      onChange: onChange,
      onKeyDown: onKeyDown
    })
  );
};

SelectInput.propTypes = {
  /**
   * Title to be displayed on mobile devices
   */
  title: _react.PropTypes.string.isRequired,
  /**
   * This is the controlled component, so it requires it's value.
   */
  value: _react.PropTypes.string.isRequired,
  /**
   * This is the controlled component, so it requires 'change' event handler.
   */
  onChange: _react.PropTypes.func.isRequired,
  /**
   * The 'keydown' event handler. It is used to handle 'Esc' and 'Enter' buttons.
   */
  onKeyDown: _react.PropTypes.func.isRequired
};

exports.default = SelectInput;

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _clamper = __webpack_require__(1235);

var _clamper2 = _interopRequireDefault(_clamper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The option from the list.
 */
var SelectOption = function (_PureComponent) {
    _inherits(SelectOption, _PureComponent);

    function SelectOption(props) {
        _classCallCheck(this, SelectOption);

        var _this = _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(SelectOption, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _clamper2.default)(this.labelRef, { clamp: 2 });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            var _props = this.props,
                option = _props.option,
                valueGetter = _props.valueGetter,
                onClick = _props.onClick,
                immediateUpdate = _props.immediateUpdate;

            onClick(valueGetter(option), option);

            if (immediateUpdate) {
                this.forceUpdate();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                option = _props2.option,
                labelGetter = _props2.labelGetter,
                isSelected = _props2.isSelected;

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: (0, _classnames2.default)('sb-selectList__option', 'ui-popoverList__link', { 'sb-selectList__option_selected': isSelected(option) })
                },
                _react2.default.createElement(
                    'span',
                    {
                        className: 'sb-selectList__label',
                        ref: function ref(_ref) {
                            return _this2.labelRef = _ref;
                        }
                    },
                    labelGetter(option)
                ),
                _react2.default.createElement(_rpReactSvgIcon2.default, {
                    iconName: 'tick',
                    size: 'Medium'
                })
            );
        }
    }]);

    return SelectOption;
}(_react.PureComponent);

SelectOption.propTypes = {
    /**
     * The option to render.
     * It has no mandatory structure.
     * You can pass any object with custom label and value getters.
     */
    option: _react.PropTypes.object.isRequired, // eslint-disable-line
    /**
     * The option label getter.
     * It is used to display the option.
     */
    labelGetter: _react.PropTypes.func.isRequired,
    /**
     * The option value getter.
     * It is used to pass the value to the onClick handler.
     */
    valueGetter: _react.PropTypes.func.isRequired,
    /**
     * Function to check is option selected.
     * It is used to highlight the selected option.
     */
    isSelected: _react.PropTypes.func.isRequired,
    /**
     * The 'click' event handler.
     * It gets option value and the option itself as arguments.
     */
    onClick: _react.PropTypes.func.isRequired,
    /**
     * Property for immediate option re render on selection
     */
    immediateUpdate: _react.PropTypes.bool
};

exports.default = SelectOption;

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POSITION_BOTTOM = exports.POSITION_TOP = exports.KEY_CODE_ESC = exports.KEY_CODE_ENTER = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(6);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = __webpack_require__(2116);

var _rpMqBreakpoints = __webpack_require__(65);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SelectInput = __webpack_require__(2273);

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _SelectAlphabet = __webpack_require__(2270);

var _SelectAlphabet2 = _interopRequireDefault(_SelectAlphabet);

var _SelectAutoSizer = __webpack_require__(2271);

var _SelectAutoSizer2 = _interopRequireDefault(_SelectAutoSizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_CODE_ENTER = exports.KEY_CODE_ENTER = 13;
var KEY_CODE_ESC = exports.KEY_CODE_ESC = 27;

var POSITION_TOP = exports.POSITION_TOP = 'top';
var POSITION_BOTTOM = exports.POSITION_BOTTOM = 'bottom';

/**
 * The popover with options, search input and alphabet.
 */

var SelectPopover = function (_PureComponent) {
    _inherits(SelectPopover, _PureComponent);

    _createClass(SelectPopover, null, [{
        key: 'renderSpinner',
        value: function renderSpinner() {
            return _react2.default.createElement(
                'div',
                { className: 'sb-selectSpinner' },
                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'spinner', size: '2XL' })
            );
        }
    }]);

    function SelectPopover(props) {
        _classCallCheck(this, SelectPopover);

        var _this = _possibleConstructorReturn(this, (SelectPopover.__proto__ || Object.getPrototypeOf(SelectPopover)).call(this, props));

        _this.handleBreakpointsSwitch = function (e) {
            return _this.setState({
                breakpointCode: e.detail.breakpoint.code
            });
        };

        _this.checkPosition = (0, _lodash.once)(function () {
            // Popover shouldn't jump from top to bottom while querying
            // So we call this function only once
            var _this$rootRef$parentN = _this.rootRef.parentNode.getBoundingClientRect(),
                parentTop = _this$rootRef$parentN.top,
                parentBottom = _this$rootRef$parentN.bottom;

            var _this$rootRef$getBoun = _this.rootRef.getBoundingClientRect(),
                height = _this$rootRef$getBoun.height;

            var windowHeight = window.innerHeight;

            // We show popover at bottom if there is enough space for it below the select button
            // or there is not enough space above the select button.
            // Otherwise it is shown at top.
            var position = windowHeight - parentBottom >= height || parentTop < height ? POSITION_BOTTOM : POSITION_TOP;

            if (position !== _this.state.position) {
                _this.setState({ position: position });
            }
        });

        _this.processListSize = function (_ref) {
            var width = _ref.width,
                height = _ref.height;
            var _this$props = _this.props,
                options = _this$props.options,
                rowHeight = _this$props.rowHeight,
                dropdownListHeight = _this$props.dropdownListHeight;
            var breakpointCode = _this.state.breakpointCode;
            var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
                NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;

            return {
                width: width,
                height: [EXTRA_NARROW, NARROW].includes(breakpointCode) ? height : Math.min(dropdownListHeight, options.length * rowHeight)
            };
        };

        _this.state = {
            didMountHandling: false,
            breakpointCode: _rpMqBreakpoints2.default.current().code,
            position: POSITION_BOTTOM
        };

        _this.renderOption = _this.renderOption.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
        _this.handleAlphabetClick = _this.handleAlphabetClick.bind(_this);
        return _this;
    }

    _createClass(SelectPopover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var onDidMount = this.props.onDidMount;

            if (onDidMount) {
                var handlerResult = onDidMount();
                if ((0, _lodash.isObject)(handlerResult) && (0, _lodash.isFunction)(handlerResult.then) && (0, _lodash.isFunction)(handlerResult.catch)) {
                    this.toggleDidMountHandling(true);
                    // TODO: handle errors
                    handlerResult.then(function () {
                        return _this2.toggleDidMountHandling(false);
                    }).catch(function () {
                        return _this2.toggleDidMountHandling(false);
                    });
                }
            }

            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            this.props.onQueryChange(e.target.value);

            /*
            * This does re-rendering of List
            * if options were changed but quantity is the same.
            *
            * For example your query is "x"
            * and you have two options "x1" and "x2".
            * After that you change query to "y"
            * and get "y1" and "y2".
            * In this case List shows previous results
            * and we should trigger update manually
            */
            if (this.listRef) {
                this.listRef.forceUpdateGrid();
            }
        }
    }, {
        key: 'handleInputKeyDown',
        value: function handleInputKeyDown(e) {
            if (e.keyCode === KEY_CODE_ENTER || e.keyCode === KEY_CODE_ESC) {
                this.props.onClose(e);
            }
        }
    }, {
        key: 'handleAlphabetClick',
        value: function handleAlphabetClick(char) {
            var _props = this.props,
                options = _props.options,
                optionLabelGetter = _props.optionLabelGetter;

            this.listRef.scrollToRow(options.findIndex(function (option) {
                return optionLabelGetter(option)[0].toLowerCase() >= char.toLowerCase();
            }));
        }
    }, {
        key: 'toggleDidMountHandling',
        value: function toggleDidMountHandling(didMountHandling) {
            this.setState({ didMountHandling: didMountHandling });
        }
    }, {
        key: 'renderAlphabet',
        value: function renderAlphabet() {
            var alphabet = this.props.alphabet;

            if (!alphabet) {
                return null;
            }

            return _react2.default.createElement(_SelectAlphabet2.default, {
                alphabet: (0, _lodash.isString)(alphabet) ? alphabet : undefined,
                onClick: this.handleAlphabetClick
            });
        }
    }, {
        key: 'renderQueryInput',
        value: function renderQueryInput() {
            var _props2 = this.props,
                query = _props2.query,
                title = _props2.title,
                showSearch = _props2.showSearch;

            if (!showSearch) {
                return null;
            }
            return _react2.default.createElement(_SelectInput2.default, {
                title: title,
                value: query,
                onChange: this.handleInputChange,
                onKeyDown: this.handleInputKeyDown
            });
        }
    }, {
        key: 'renderOption',
        value: function renderOption(_ref2) {
            var index = _ref2.index,
                key = _ref2.key,
                style = _ref2.style;

            return _react2.default.createElement(
                'div',
                {
                    key: key,
                    style: style
                },
                this.props.optionRenderer(this.props.options[index])
            );
        }
    }, {
        key: 'renderList',
        value: function renderList() {
            var _this3 = this;

            var _props3 = this.props,
                options = _props3.options,
                rowHeight = _props3.rowHeight,
                noOptionsRenderer = _props3.noOptionsRenderer;

            if (options.length === 0) {
                return noOptionsRenderer();
            }
            return _react2.default.createElement(
                'div',
                { className: 'sb-selectListWrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'sb-selectList' },
                    _react2.default.createElement(_SelectAutoSizer2.default, {
                        sizeProcessor: this.processListSize,
                        contentRenderer: function contentRenderer(_ref3) {
                            var width = _ref3.width,
                                height = _ref3.height;
                            return _react2.default.createElement(_reactVirtualized.List, {
                                ref: function ref(_ref4) {
                                    return _this3.listRef = _ref4;
                                },
                                height: height,
                                overscanRowCount: 15,
                                rowHeight: rowHeight,
                                rowCount: options.length,
                                rowRenderer: _this3.renderOption,
                                scrollToAlignment: 'start',
                                width: width
                            });
                        },
                        onDidResize: this.checkPosition
                    })
                ),
                this.renderAlphabet()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props4 = this.props,
                title = _props4.title,
                onClose = _props4.onClose;

            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(_ref5) {
                        return _this4.rootRef = _ref5;
                    },
                    className: 'ui-popover ui-popover_headless ui-popover_' + this.state.position
                },
                _react2.default.createElement('div', { className: 'ui-popoverPointer' }),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-popoverHeader' },
                    _react2.default.createElement(
                        'span',
                        { className: 'ui-popoverHeader__title' },
                        title
                    ),
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'ui-btn ui-btn_secondary ui-popoverHeader__btn',
                            onClick: onClose
                        },
                        _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Medium' })
                    )
                ),
                this.renderQueryInput(),
                this.state.didMountHandling ? SelectPopover.renderSpinner() : this.renderList()
            );
        }
    }]);

    return SelectPopover;
}(_react.PureComponent);

SelectPopover.propTypes = {
    /**
     * Title to be displayed on mobile devices
     */
    title: _react.PropTypes.string.isRequired,
    /**
     * Shows alphabet.
     * It could be boolean if you want to control the visibility of the default (English) alphabet.
     * You can also provide a string with custom chars to be rendered instead of default alphabet.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
    /**
     * Controls the visibility of search input.
     */
    showSearch: _react.PropTypes.bool,
    /**
     * Controls height of row element, defaults to 64px
     */
    rowHeight: _react.PropTypes.number,
    /**
     * Controls height of options list into dropdown (for medium and larger screens),
     */
    dropdownListHeight: _react.PropTypes.number,
    /**
     * The search query value.
     * This is the controlled component so it requires the search query value.
     */
    query: _react.PropTypes.string.isRequired,
    /**
     * Array of options to be rendered.
     */
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
    /**
     * Funtion that gets the option as an argument and returns it's label.
     * It is used to scroll to option by alphabet.
     */
    optionLabelGetter: _react.PropTypes.func.isRequired,
    /**
     * Function that gets the option as an argument and returns the React node for this option.
     */
    optionRenderer: _react.PropTypes.func.isRequired,
    /**
     * Function that renders the placeholder if no options available (due to search query or any other reason)
     */
    noOptionsRenderer: _react.PropTypes.func.isRequired,
    /**
     * This is the controlled component so it requires the search query change handler.
     */
    onQueryChange: _react.PropTypes.func.isRequired,
    /**
     * Close button 'click' handler.
     */
    onClose: _react.PropTypes.func.isRequired,
    /**
     * It could be considered as the 'open' event handler.
     * If it returns a Promise application shows the spinner until promise resolved or rejected.
     */
    onDidMount: _react.PropTypes.func
};

SelectPopover.defaultProps = {
    rowHeight: 64,
    dropdownListHeight: 354,
    query: '',
    options: []
};

exports.default = SelectPopover;

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(2269);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @link https://racingpost.atlassian.net/browse/PB2-610
 */
exports.default = _Select2.default;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = __webpack_require__(529);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(528);

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RpSimpleTable = function (_PureComponent) {
  _inherits(RpSimpleTable, _PureComponent);

  function RpSimpleTable() {
    _classCallCheck(this, RpSimpleTable);

    return _possibleConstructorReturn(this, (RpSimpleTable.__proto__ || Object.getPrototypeOf(RpSimpleTable)).apply(this, arguments));
  }

  _createClass(RpSimpleTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          columns = _props.columns,
          loading = _props.loading,
          noDataText = _props.noDataText,
          className = _props.className,
          uiType = _props.uiType,
          sortIdx = _props.sortIdx,
          onHeaderCellClick = _props.onHeaderCellClick;


      var sortable = data.length > 0;

      var tableClassName = (0, _classnames2.default)('ui-table', className, 'ui-table_type' + uiType, sortable && 'ui-table_sortable');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: tableClassName },
          _react2.default.createElement(_Header2.default, {
            columns: columns,
            sortable: data.length > 0,
            sortIdx: sortIdx,
            onHeaderCellClick: onHeaderCellClick
          }),
          _react2.default.createElement(_Body2.default, {
            data: data,
            columns: columns,
            loading: loading,
            noDataText: noDataText
          })
        )
      );
    }
  }]);

  return RpSimpleTable;
}(_react.PureComponent);

RpSimpleTable.defaultProps = {
  data: [],
  uiType: 1,
  noDataText: 'No data for this table'
};

RpSimpleTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    cell: _propTypes2.default.func,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    className: _propTypes2.default.string
  })).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  sortIdx: _propTypes2.default.number,
  className: _propTypes2.default.string,
  uiType: _propTypes2.default.number,
  noDataText: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onHeaderCellClick: _propTypes2.default.func.isRequired
};

exports.default = RpSimpleTable;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = __webpack_require__(529);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(528);

var _Body2 = _interopRequireDefault(_Body);

var _Footer = __webpack_require__(2279);

var _Footer2 = _interopRequireDefault(_Footer);

var _ShowMore = __webpack_require__(930);

var _ShowMore2 = _interopRequireDefault(_ShowMore);

var _addSortFns = __webpack_require__(933);

var _addSortFns2 = _interopRequireDefault(_addSortFns);

var _sortData = __webpack_require__(935);

var _sortData2 = _interopRequireDefault(_sortData);

var _addIds = __webpack_require__(931);

var _addIds2 = _interopRequireDefault(_addIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dataChange = function dataChange(data, columns, sortIdx, defaultSortIdx) {
  var changedData = (0, _addIds2.default)(data || []);
  return Number.isFinite(sortIdx) ? (0, _sortData2.default)(changedData, columns, sortIdx, defaultSortIdx) : changedData;
};

var RpTable = function (_PureComponent) {
  _inherits(RpTable, _PureComponent);

  function RpTable(props) {
    _classCallCheck(this, RpTable);

    var _this = _possibleConstructorReturn(this, (RpTable.__proto__ || Object.getPrototypeOf(RpTable)).call(this, props));

    _initialiseProps.call(_this);

    var defaultSortIdx = props.defaultSortIdx || props.initialSortIdx || 0;
    var sortIdx = props.initialSortIdx;
    var columns = (0, _addSortFns2.default)(props.columns, props.sortable, props.initialSortIdx);
    var data = dataChange(props.data, columns, sortIdx, defaultSortIdx);
    var itemsShown = props.resultsPerPage || data.length;

    _this.state = {
      columns: columns, defaultSortIdx: defaultSortIdx, data: data, sortIdx: sortIdx, itemsShown: itemsShown
    };
    return _this;
  }

  _createClass(RpTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props === nextProps) return;

      var newState = {};
      var _state = this.state,
          sortIdx = _state.sortIdx,
          defaultSortIdx = _state.defaultSortIdx,
          columns = _state.columns;

      var nextSortIdx = nextProps.initialSortIdx;

      if (this.props.columns !== nextProps.columns) {
        newState.columns = (0, _addSortFns2.default)(nextProps.columns, nextProps.sortable, sortIdx, defaultSortIdx);
      }

      if (this.props.data !== nextProps.data || this.props.columns !== nextProps.columns) {
        newState.data = dataChange(nextProps.data, newState.columns || columns, nextSortIdx, defaultSortIdx);
        newState.itemsShown = nextProps.resultsPerPage || newState.data.length;
      }

      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          columns = _state2.columns,
          data = _state2.data,
          sortIdx = _state2.sortIdx,
          itemsShown = _state2.itemsShown,
          defaultSortIdx = _state2.defaultSortIdx;
      var _props = this.props,
          loading = _props.loading,
          noDataText = _props.noDataText,
          footerData = _props.footerData,
          setRowClass = _props.setRowClass,
          className = _props.className,
          uiType = _props.uiType,
          filter = _props.filter,
          headerRow = _props.headerRow,
          specialRow = _props.specialRow;


      var sortable = this.props.sortable && data.length > 1;

      var filteredData = filter ? data.filter(filter) : data;
      var specialFiltered = specialRow && sortIdx !== defaultSortIdx ? filteredData.filter(function (_ref) {
        var isSpecial = _ref.isSpecial;
        return !isSpecial;
      }) : filteredData;
      var shownData = itemsShown < specialFiltered.length ? specialFiltered.slice(0, itemsShown) : specialFiltered;

      var tableClassName = (0, _classnames2.default)('ui-table', className, 'ui-table_type' + uiType, sortable && 'ui-table_sortable');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: tableClassName },
          _react2.default.createElement(_Header2.default, {
            columns: columns,
            sortable: sortable,
            sortIdx: sortIdx,
            onHeaderCellClick: this.sortTable,
            headerRow: headerRow
          }),
          _react2.default.createElement(_Body2.default, {
            data: shownData,
            columns: columns,
            loading: loading,
            noDataText: noDataText,
            setRowClass: setRowClass,
            specialRow: specialRow
          }),
          !loading && footerData && _react2.default.createElement(_Footer2.default, {
            footerData: footerData,
            columns: columns
          })
        ),
        !loading && itemsShown < data.length && _react2.default.createElement(_ShowMore2.default, { onClick: this.showMore })
      );
    }
  }]);

  return RpTable;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.showMore = function () {
    _this2.setState({
      itemsShown: _this2.state.itemsShown + _this2.props.resultsPerPage
    });
  };

  this.sortTable = function (index) {
    var _state3 = _this2.state,
        data = _state3.data,
        columns = _state3.columns,
        defaultSortIdx = _state3.defaultSortIdx;
    var onSortUpdate = _this2.props.onSortUpdate;


    _this2.setState({
      data: (0, _sortData2.default)(data, columns, index, defaultSortIdx),
      sortIdx: index
    });

    if (onSortUpdate) {
      onSortUpdate(index);
    }
  };
};

RpTable.defaultProps = {
  data: [],
  uiType: 1,
  noDataText: 'No data for this table'
};

RpTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    cell: _propTypes2.default.func,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    className: _propTypes2.default.string,
    sortFn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.oneOf(['numeric', 'numericReverse', 'alphabetic', 'byLastName'])])
  })).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  sortable: _propTypes2.default.bool,
  initialSortIdx: _propTypes2.default.number,
  defaultSortIdx: _propTypes2.default.number,
  footerData: _propTypes2.default.shape({}),
  className: _propTypes2.default.string,
  uiType: _propTypes2.default.number,
  noDataText: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  resultsPerPage: _propTypes2.default.number,
  filter: _propTypes2.default.func,
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func,
  headerRow: _propTypes2.default.func,
  onSortUpdate: _propTypes2.default.func
};

exports.default = RpTable;

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(530);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setFooterClass = function setFooterClass() {
  return 'ui-table__cell_footer';
};

var Footer = function (_PureComponent) {
  _inherits(Footer, _PureComponent);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          footerData = _props.footerData,
          columns = _props.columns;


      return _react2.default.createElement(
        'tfoot',
        { className: 'ui-table__footer' },
        _react2.default.createElement(_Row2.default, {
          rowData: footerData,
          columns: columns,
          setRowClass: setFooterClass
        })
      );
    }
  }]);

  return Footer;
}(_react.PureComponent);

Footer.propTypes = {
  footerData: _propTypes2.default.shape({}).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

exports.default = Footer;

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var alphabetic = function alphabetic(key) {
  return function (itemA, itemB) {
    var a = itemA[key];
    var b = itemB[key];

    if (a === b) return 0;

    if (!a) return 1;
    if (!b) return -1;

    return a > b ? 1 : -1;
  };
};

exports.default = alphabetic;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Sort by last name then by first name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */


var _lodash = __webpack_require__(6);

var separator = ' ';

var splitFullName = function splitFullName(fullName) {
  var nameArray = fullName.split(separator);
  return [nameArray.pop(), nameArray.join(separator)];
};

var byLastName = function byLastName(key) {
  return function (itemA, itemB) {
    var a = itemA[key];
    var b = itemB[key];

    if (a === b) return 0;

    if (!(0, _lodash.isString)(a)) return 1;
    if (!(0, _lodash.isString)(b)) return -1;

    var _splitFullName = splitFullName(a),
        _splitFullName2 = _slicedToArray(_splitFullName, 2),
        surnameA = _splitFullName2[0],
        nameA = _splitFullName2[1];

    var _splitFullName3 = splitFullName(b),
        _splitFullName4 = _slicedToArray(_splitFullName3, 2),
        surnameB = _splitFullName4[0],
        nameB = _splitFullName4[1];

    if (surnameA === surnameB) {
      return nameA > nameB ? 1 : -1;
    }

    return surnameA > surnameB ? 1 : -1;
  };
};

exports.default = byLastName;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFinite = Number.isFinite;
var numeric = exports.numeric = function numeric(key) {
  return function (itemA, itemB) {
    var a = parseFloat(itemA[key]);
    var b = parseFloat(itemB[key]);

    if (!isFinite(a)) return 1;
    if (!isFinite(b)) return -1;

    return b - a;
  };
};

var numericReverse = exports.numericReverse = function numericReverse(key) {
  return function (itemA, itemB) {
    var a = parseFloat(itemA[key]);
    var b = parseFloat(itemB[key]);

    if (!isFinite(a)) return 1;
    if (!isFinite(b)) return -1;

    return a - b;
  };
};

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESULTS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = exports.CARDS_PREFERRED_TAB = undefined;
exports.getPrefValue = getPrefValue;

var _jquery = __webpack_require__(18);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CARDS_PREFERRED_TAB = exports.CARDS_PREFERRED_TAB = 'cdt_tab_pref';
var CARDS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = 'cdt_list_pref';
var RESULTS_LIST_VIEW_TYPE = exports.RESULTS_LIST_VIEW_TYPE = 'rsp_list_pref';

function getValuesIfExist(value, possibleValues) {
    return value in possibleValues;
}

function getPrefValue(prefType, prefDefaultValue) {
    return localStorage.getItem(prefType) || prefDefaultValue;
}

function buildUrl(className, prefType, prefDefaultValue, possibleValues) {
    var prefValue = void 0;

    (0, _jquery2.default)(document).on('touchstart mousedown', '.' + className, function (e) {
        var $target = (0, _jquery2.default)(e.currentTarget);

        function updateHref(value) {
            $target.attr('href', function (index, href) {
                return '' + href.replace(/\/$/, '') + possibleValues[value];
            });
            $target.removeClass(className);
        }

        if (prefValue) {
            updateHref(prefValue);
        } else {
            prefValue = getPrefValue(prefType, prefDefaultValue);
            updateHref(prefValue);
        }
    });
}

function setPref(selector, storageKeyName, possibleValues) {
    var value = (0, _jquery2.default)(selector).attr('data-pref-type');
    if (!getValuesIfExist(value, possibleValues)) {
        return;
    }

    if (value) {
        try {
            localStorage.setItem(storageKeyName, value);
        } catch (e) {
            /* eslint-disable no-console */
            console.warn('You are in a private mode, so, we couldn\'t save your preference.');
        }
    }
}

function navigate() {
    var cardTabsPossibleValues = {
        free: '/',
        pro: '/pro',
        'at-a-glance': '/at-a-glance',
        'odds-comparison': '/odds-comparison',
        'raceday-live': '/raceday-live'
    };
    var cardListTypePossibleValues = {
        byCourse: '/',
        byTime: '/time-order'
    };

    var resultsListTypePossibleValues = {
        byCourse: '/',
        byTime: '/time-order'
    };

    // Racecards tab preferences
    // TODO: change to more related name
    setPref('.js-navigate-type', CARDS_PREFERRED_TAB, cardTabsPossibleValues);
    buildUrl('js-navigate-url', CARDS_PREFERRED_TAB, 'free', cardTabsPossibleValues);

    // Racecards list types preferences
    setPref('.js-rc-list-type', CARDS_LIST_VIEW_TYPE, cardListTypePossibleValues);
    buildUrl('js-rc-list-url', CARDS_LIST_VIEW_TYPE, 'byCourse', cardListTypePossibleValues);

    // Results list types preferences
    setPref('.js-rsp-list-type', RESULTS_LIST_VIEW_TYPE, resultsListTypePossibleValues);
    buildUrl('js-rsp-list-url', RESULTS_LIST_VIEW_TYPE, 'byCourse', resultsListTypePossibleValues);
}

exports.default = navigate;

/***/ }),
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(2291);
var alphabet = __webpack_require__(332);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(332);
var random = __webpack_require__(2294);
var format = __webpack_require__(1961);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(332);
var build = __webpack_require__(2290);
var isValid = __webpack_require__(2293);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(2296) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(332);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */
/***/ (function(module, exports) {

/***
   Copyright 2013 Teun Duynstee

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
module.exports = (function() {

    function identity(v){return v;}

    function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

    function makeCompareFunction(f, opt){
        opt = typeof(opt)==="number" ? {direction:opt} : opt||{};
        if(typeof(f)!="function"){
            var prop = f;
            // make unary function
            f = function(v1){return !!v1[prop] ? v1[prop] : "";}
        }
        if(f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase?ignoreCase:identity;
            var cmp = opt.cmp || function(v1,v2) {return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;}
            f = function(v1,v2) {return cmp(preprocess(uf(v1)), preprocess(uf(v2)));}
        }
        if(opt.direction === -1) return function(v1,v2){return -f(v1,v2)};
        return f;
    }

    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */
    function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the 
        exported function, or the firstBy property on it (for es6 module compatibility)
        */
        var x = (typeof(this) == "function" && !this.firstBy) ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
                        return x(a,b) || y(a,b);
                    }
                  : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
})();


/***/ }),
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ })
],[349]);


// WEBPACK FOOTER //
// app.min.js